(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireda16"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireda16"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("7wgKE", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $579884101b2e33e1$export$6503ec6e8aabbaf; }, function (v) { return $579884101b2e33e1$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $579884101b2e33e1$export$f7ad0328861e2f03; }, function (v) { return $579884101b2e33e1$export$f7ad0328861e2f03 = v; });
var $579884101b2e33e1$export$6503ec6e8aabbaf;
var $579884101b2e33e1$export$f7ad0328861e2f03;
"use strict";
var $579884101b2e33e1$var$mapping = new Map();
function $579884101b2e33e1$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$579884101b2e33e1$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $579884101b2e33e1$var$resolve(id) {
    var resolved = $579884101b2e33e1$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$579884101b2e33e1$export$6503ec6e8aabbaf = $579884101b2e33e1$var$register;
$579884101b2e33e1$export$f7ad0328861e2f03 = $579884101b2e33e1$var$resolve;

});

parcelRegister("kSeqf", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $f32409c1b79251cc$export$bdfd709ae4826697; }, function (v) { return $f32409c1b79251cc$export$bdfd709ae4826697 = v; });
var $f32409c1b79251cc$export$bdfd709ae4826697;
var $f32409c1b79251cc$export$c9e73fbda7da57b6;
var $f32409c1b79251cc$export$5a759dc7a1cfb72a;
"use strict";
var $f32409c1b79251cc$var$bundleURL = {};
function $f32409c1b79251cc$var$getBundleURLCached(id) {
    var value = $f32409c1b79251cc$var$bundleURL[id];
    if (!value) {
        value = $f32409c1b79251cc$var$getBundleURL();
        $f32409c1b79251cc$var$bundleURL[id] = value;
    }
    return value;
}
function $f32409c1b79251cc$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $f32409c1b79251cc$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $f32409c1b79251cc$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $f32409c1b79251cc$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$f32409c1b79251cc$export$bdfd709ae4826697 = $f32409c1b79251cc$var$getBundleURLCached;
$f32409c1b79251cc$export$c9e73fbda7da57b6 = $f32409c1b79251cc$var$getBaseURL;
$f32409c1b79251cc$export$5a759dc7a1cfb72a = $f32409c1b79251cc$var$getOrigin;

});

parcelRegister("5YOUh", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $45aa0b62b4686e01$export$7c398597f8905a1; });
function $45aa0b62b4686e01$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $45aa0b62b4686e01$export$7c398597f8905a1(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $45aa0b62b4686e01$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $45aa0b62b4686e01$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}

});

parcelRegister("j4B9x", function(module, exports) {

$parcel$export(module.exports, "__generator", function () { return $de2b35d45bf23e9b$export$67ebef60e6f28a6; });
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $de2b35d45bf23e9b$var$extendStatics = function extendStatics1(d, b) {
    $de2b35d45bf23e9b$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $de2b35d45bf23e9b$var$extendStatics(d, b);
};
function $de2b35d45bf23e9b$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $de2b35d45bf23e9b$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $de2b35d45bf23e9b$export$18ce0697a983be9b = function __assign1() {
    $de2b35d45bf23e9b$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $de2b35d45bf23e9b$export$18ce0697a983be9b.apply(this, arguments);
};
function $de2b35d45bf23e9b$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $de2b35d45bf23e9b$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $de2b35d45bf23e9b$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $de2b35d45bf23e9b$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $de2b35d45bf23e9b$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $de2b35d45bf23e9b$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $de2b35d45bf23e9b$export$45d3717a4c69092e = Object.create ? function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $de2b35d45bf23e9b$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $de2b35d45bf23e9b$export$45d3717a4c69092e(o, m, p);
}
function $de2b35d45bf23e9b$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $de2b35d45bf23e9b$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $de2b35d45bf23e9b$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($de2b35d45bf23e9b$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $de2b35d45bf23e9b$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $de2b35d45bf23e9b$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $de2b35d45bf23e9b$export$10c90e4f7922046c(v) {
    return this instanceof $de2b35d45bf23e9b$export$10c90e4f7922046c ? (this.v = v, this) : new $de2b35d45bf23e9b$export$10c90e4f7922046c(v);
}
function $de2b35d45bf23e9b$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $de2b35d45bf23e9b$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $de2b35d45bf23e9b$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $de2b35d45bf23e9b$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $de2b35d45bf23e9b$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $de2b35d45bf23e9b$export$19a8beecd37a4c45 === "function" ? $de2b35d45bf23e9b$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $de2b35d45bf23e9b$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $de2b35d45bf23e9b$var$__setModuleDefault = Object.create ? function __setModuleDefault(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $de2b35d45bf23e9b$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $de2b35d45bf23e9b$export$45d3717a4c69092e(result, mod, k);
    }
    $de2b35d45bf23e9b$var$__setModuleDefault(result, mod);
    return result;
}
function $de2b35d45bf23e9b$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $de2b35d45bf23e9b$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $de2b35d45bf23e9b$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $de2b35d45bf23e9b$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}

});

parcelRegister("GuWH3", function(module, exports) {

$parcel$export(module.exports, "raiseError", function () { return $07fbed860c71343c$export$d00b56ff2d620eb9; });
$parcel$export(module.exports, "$$Error", function () { return $07fbed860c71343c$export$507b31d55a607b45; });
function $07fbed860c71343c$export$d00b56ff2d620eb9(str) {
    throw new Error(str);
}
function $07fbed860c71343c$export$93807fddf246b6fd(str) {
    throw new EvalError(str);
}
function $07fbed860c71343c$export$a0f9c56f70c19509(str) {
    throw new RangeError(str);
}
function $07fbed860c71343c$export$1eb15f043789d5e9(str) {
    throw new ReferenceError(str);
}
function $07fbed860c71343c$export$e287b37aa627dc6(str) {
    throw new SyntaxError(str);
}
function $07fbed860c71343c$export$836409896c392e8b(str) {
    throw new TypeError(str);
}
function $07fbed860c71343c$export$6511d306f3a81413(str) {
    throw new URIError(str);
}
var $07fbed860c71343c$export$507b31d55a607b45 = "JsError";
 /* No side effect */ 
});

parcelRegister("eklj4", function(module, exports) {

$parcel$export(module.exports, "$$catch", function () { return $a6e376032d552f87$export$e62bb7a22f80ae34; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $1xvYg = parcelRequire("1xvYg");
var $a6e376032d552f87$export$696ef7156ff42767 = /* @__PURE__ */ $1xvYg.create("Promise.JsError");
function $a6e376032d552f87$export$e62bb7a22f80ae34(promise, callback) {
    return promise.catch(function(err) {
        return $iv6Yc._1(callback, $1xvYg.is_extension(err) ? err : {
            RE_EXN_ID: $a6e376032d552f87$export$696ef7156ff42767,
            _1: err
        });
    });
}
 /* No side effect */ 
});
parcelRegister("iv6Yc", function(module, exports) {

$parcel$export(module.exports, "app", function () { return $d7808759cc50027a$export$729c8b7179294ba; });
$parcel$export(module.exports, "_1", function () { return $d7808759cc50027a$export$6bb4ba3ef072a075; });
$parcel$export(module.exports, "__1", function () { return $d7808759cc50027a$export$cd395b1790869493; });
$parcel$export(module.exports, "_2", function () { return $d7808759cc50027a$export$ec609e2ed7190fc2; });
$parcel$export(module.exports, "__2", function () { return $d7808759cc50027a$export$9d7677205a3a0fa7; });
$parcel$export(module.exports, "_3", function () { return $d7808759cc50027a$export$24aa22226b6cf255; });
$parcel$export(module.exports, "__3", function () { return $d7808759cc50027a$export$67f030eafa9ce57; });
$parcel$export(module.exports, "_4", function () { return $d7808759cc50027a$export$86520c20d9656c74; });
$parcel$export(module.exports, "__4", function () { return $d7808759cc50027a$export$321742c2090790cd; });
$parcel$export(module.exports, "_5", function () { return $d7808759cc50027a$export$6991ae8ef79c0b2b; });
$parcel$export(module.exports, "__5", function () { return $d7808759cc50027a$export$6370d775c271b44a; });
$parcel$export(module.exports, "_6", function () { return $d7808759cc50027a$export$ab694918f6f09b83; });
$parcel$export(module.exports, "__6", function () { return $d7808759cc50027a$export$7b5cf4094c54cf84; });
$parcel$export(module.exports, "_7", function () { return $d7808759cc50027a$export$c74ac252bb0cfc27; });
$parcel$export(module.exports, "_8", function () { return $d7808759cc50027a$export$fb0020d138ee4a60; });

var $1PGgk = parcelRequire("1PGgk");
function $d7808759cc50027a$export$729c8b7179294ba(_f, _args) {
    while(true){
        var args = _args;
        var f = _f;
        var init_arity = f.length;
        var arity = init_arity === 0 ? 1 : init_arity;
        var len = args.length;
        var d = arity - len | 0;
        if (d === 0) return f.apply(null, args);
        if (d >= 0) return function(f, args) {
            return function(x) {
                return $d7808759cc50027a$export$729c8b7179294ba(f, args.concat([
                    x
                ]));
            };
        }(f, args);
        _args = $1PGgk.sub(args, arity, -d | 0);
        _f = f.apply(null, $1PGgk.sub(args, 0, arity));
        continue;
    }
}
function $d7808759cc50027a$export$6bb4ba3ef072a075(o, a0) {
    var arity = o.length;
    if (arity === 1) return o(a0);
    else switch(arity){
        case 1:
            return o(a0);
        case 2:
            return function(param) {
                return o(a0, param);
            };
        case 3:
            return function(param, param$1) {
                return o(a0, param, param$1);
            };
        case 4:
            return function(param, param$1, param$2) {
                return o(a0, param, param$1, param$2);
            };
        case 5:
            return function(param, param$1, param$2, param$3) {
                return o(a0, param, param$1, param$2, param$3);
            };
        case 6:
            return function(param, param$1, param$2, param$3, param$4) {
                return o(a0, param, param$1, param$2, param$3, param$4);
            };
        case 7:
            return function(param, param$1, param$2, param$3, param$4, param$5) {
                return o(a0, param, param$1, param$2, param$3, param$4, param$5);
            };
        default:
            return $d7808759cc50027a$export$729c8b7179294ba(o, [
                a0
            ]);
    }
}
function $d7808759cc50027a$export$cd395b1790869493(o) {
    var arity = o.length;
    if (arity === 1) return o;
    else return function(a0) {
        return $d7808759cc50027a$export$6bb4ba3ef072a075(o, a0);
    };
}
function $d7808759cc50027a$export$ec609e2ed7190fc2(o, a0, a1) {
    var arity = o.length;
    if (arity === 2) return o(a0, a1);
    else switch(arity){
        case 1:
            return $d7808759cc50027a$export$729c8b7179294ba(o(a0), [
                a1
            ]);
        case 2:
            return o(a0, a1);
        case 3:
            return function(param) {
                return o(a0, a1, param);
            };
        case 4:
            return function(param, param$1) {
                return o(a0, a1, param, param$1);
            };
        case 5:
            return function(param, param$1, param$2) {
                return o(a0, a1, param, param$1, param$2);
            };
        case 6:
            return function(param, param$1, param$2, param$3) {
                return o(a0, a1, param, param$1, param$2, param$3);
            };
        case 7:
            return function(param, param$1, param$2, param$3, param$4) {
                return o(a0, a1, param, param$1, param$2, param$3, param$4);
            };
        default:
            return $d7808759cc50027a$export$729c8b7179294ba(o, [
                a0,
                a1
            ]);
    }
}
function $d7808759cc50027a$export$9d7677205a3a0fa7(o) {
    var arity = o.length;
    if (arity === 2) return o;
    else return function(a0, a1) {
        return $d7808759cc50027a$export$ec609e2ed7190fc2(o, a0, a1);
    };
}
function $d7808759cc50027a$export$24aa22226b6cf255(o, a0, a1, a2) {
    var arity = o.length;
    if (arity === 3) return o(a0, a1, a2);
    else switch(arity){
        case 1:
            return $d7808759cc50027a$export$729c8b7179294ba(o(a0), [
                a1,
                a2
            ]);
        case 2:
            return $d7808759cc50027a$export$729c8b7179294ba(o(a0, a1), [
                a2
            ]);
        case 3:
            return o(a0, a1, a2);
        case 4:
            return function(param) {
                return o(a0, a1, a2, param);
            };
        case 5:
            return function(param, param$1) {
                return o(a0, a1, a2, param, param$1);
            };
        case 6:
            return function(param, param$1, param$2) {
                return o(a0, a1, a2, param, param$1, param$2);
            };
        case 7:
            return function(param, param$1, param$2, param$3) {
                return o(a0, a1, a2, param, param$1, param$2, param$3);
            };
        default:
            return $d7808759cc50027a$export$729c8b7179294ba(o, [
                a0,
                a1,
                a2
            ]);
    }
}
function $d7808759cc50027a$export$67f030eafa9ce57(o) {
    var arity = o.length;
    if (arity === 3) return o;
    else return function(a0, a1, a2) {
        return $d7808759cc50027a$export$24aa22226b6cf255(o, a0, a1, a2);
    };
}
function $d7808759cc50027a$export$86520c20d9656c74(o, a0, a1, a2, a3) {
    var arity = o.length;
    if (arity === 4) return o(a0, a1, a2, a3);
    else switch(arity){
        case 1:
            return $d7808759cc50027a$export$729c8b7179294ba(o(a0), [
                a1,
                a2,
                a3
            ]);
        case 2:
            return $d7808759cc50027a$export$729c8b7179294ba(o(a0, a1), [
                a2,
                a3
            ]);
        case 3:
            return $d7808759cc50027a$export$729c8b7179294ba(o(a0, a1, a2), [
                a3
            ]);
        case 4:
            return o(a0, a1, a2, a3);
        case 5:
            return function(param) {
                return o(a0, a1, a2, a3, param);
            };
        case 6:
            return function(param, param$1) {
                return o(a0, a1, a2, a3, param, param$1);
            };
        case 7:
            return function(param, param$1, param$2) {
                return o(a0, a1, a2, a3, param, param$1, param$2);
            };
        default:
            return $d7808759cc50027a$export$729c8b7179294ba(o, [
                a0,
                a1,
                a2,
                a3
            ]);
    }
}
function $d7808759cc50027a$export$321742c2090790cd(o) {
    var arity = o.length;
    if (arity === 4) return o;
    else return function(a0, a1, a2, a3) {
        return $d7808759cc50027a$export$86520c20d9656c74(o, a0, a1, a2, a3);
    };
}
function $d7808759cc50027a$export$6991ae8ef79c0b2b(o, a0, a1, a2, a3, a4) {
    var arity = o.length;
    if (arity === 5) return o(a0, a1, a2, a3, a4);
    else switch(arity){
        case 1:
            return $d7808759cc50027a$export$729c8b7179294ba(o(a0), [
                a1,
                a2,
                a3,
                a4
            ]);
        case 2:
            return $d7808759cc50027a$export$729c8b7179294ba(o(a0, a1), [
                a2,
                a3,
                a4
            ]);
        case 3:
            return $d7808759cc50027a$export$729c8b7179294ba(o(a0, a1, a2), [
                a3,
                a4
            ]);
        case 4:
            return $d7808759cc50027a$export$729c8b7179294ba(o(a0, a1, a2, a3), [
                a4
            ]);
        case 5:
            return o(a0, a1, a2, a3, a4);
        case 6:
            return function(param) {
                return o(a0, a1, a2, a3, a4, param);
            };
        case 7:
            return function(param, param$1) {
                return o(a0, a1, a2, a3, a4, param, param$1);
            };
        default:
            return $d7808759cc50027a$export$729c8b7179294ba(o, [
                a0,
                a1,
                a2,
                a3,
                a4
            ]);
    }
}
function $d7808759cc50027a$export$6370d775c271b44a(o) {
    var arity = o.length;
    if (arity === 5) return o;
    else return function(a0, a1, a2, a3, a4) {
        return $d7808759cc50027a$export$6991ae8ef79c0b2b(o, a0, a1, a2, a3, a4);
    };
}
function $d7808759cc50027a$export$ab694918f6f09b83(o, a0, a1, a2, a3, a4, a5) {
    var arity = o.length;
    if (arity === 6) return o(a0, a1, a2, a3, a4, a5);
    else switch(arity){
        case 1:
            return $d7808759cc50027a$export$729c8b7179294ba(o(a0), [
                a1,
                a2,
                a3,
                a4,
                a5
            ]);
        case 2:
            return $d7808759cc50027a$export$729c8b7179294ba(o(a0, a1), [
                a2,
                a3,
                a4,
                a5
            ]);
        case 3:
            return $d7808759cc50027a$export$729c8b7179294ba(o(a0, a1, a2), [
                a3,
                a4,
                a5
            ]);
        case 4:
            return $d7808759cc50027a$export$729c8b7179294ba(o(a0, a1, a2, a3), [
                a4,
                a5
            ]);
        case 5:
            return $d7808759cc50027a$export$729c8b7179294ba(o(a0, a1, a2, a3, a4), [
                a5
            ]);
        case 6:
            return o(a0, a1, a2, a3, a4, a5);
        case 7:
            return function(param) {
                return o(a0, a1, a2, a3, a4, a5, param);
            };
        default:
            return $d7808759cc50027a$export$729c8b7179294ba(o, [
                a0,
                a1,
                a2,
                a3,
                a4,
                a5
            ]);
    }
}
function $d7808759cc50027a$export$7b5cf4094c54cf84(o) {
    var arity = o.length;
    if (arity === 6) return o;
    else return function(a0, a1, a2, a3, a4, a5) {
        return $d7808759cc50027a$export$ab694918f6f09b83(o, a0, a1, a2, a3, a4, a5);
    };
}
function $d7808759cc50027a$export$c74ac252bb0cfc27(o, a0, a1, a2, a3, a4, a5, a6) {
    var arity = o.length;
    if (arity === 7) return o(a0, a1, a2, a3, a4, a5, a6);
    else switch(arity){
        case 1:
            return $d7808759cc50027a$export$729c8b7179294ba(o(a0), [
                a1,
                a2,
                a3,
                a4,
                a5,
                a6
            ]);
        case 2:
            return $d7808759cc50027a$export$729c8b7179294ba(o(a0, a1), [
                a2,
                a3,
                a4,
                a5,
                a6
            ]);
        case 3:
            return $d7808759cc50027a$export$729c8b7179294ba(o(a0, a1, a2), [
                a3,
                a4,
                a5,
                a6
            ]);
        case 4:
            return $d7808759cc50027a$export$729c8b7179294ba(o(a0, a1, a2, a3), [
                a4,
                a5,
                a6
            ]);
        case 5:
            return $d7808759cc50027a$export$729c8b7179294ba(o(a0, a1, a2, a3, a4), [
                a5,
                a6
            ]);
        case 6:
            return $d7808759cc50027a$export$729c8b7179294ba(o(a0, a1, a2, a3, a4, a5), [
                a6
            ]);
        case 7:
            return o(a0, a1, a2, a3, a4, a5, a6);
        default:
            return $d7808759cc50027a$export$729c8b7179294ba(o, [
                a0,
                a1,
                a2,
                a3,
                a4,
                a5,
                a6
            ]);
    }
}
function $d7808759cc50027a$export$23d6e11d6b3715bb(o) {
    var arity = o.length;
    if (arity === 7) return o;
    else return function(a0, a1, a2, a3, a4, a5, a6) {
        return $d7808759cc50027a$export$c74ac252bb0cfc27(o, a0, a1, a2, a3, a4, a5, a6);
    };
}
function $d7808759cc50027a$export$fb0020d138ee4a60(o, a0, a1, a2, a3, a4, a5, a6, a7) {
    var arity = o.length;
    if (arity === 8) return o(a0, a1, a2, a3, a4, a5, a6, a7);
    else switch(arity){
        case 1:
            return $d7808759cc50027a$export$729c8b7179294ba(o(a0), [
                a1,
                a2,
                a3,
                a4,
                a5,
                a6,
                a7
            ]);
        case 2:
            return $d7808759cc50027a$export$729c8b7179294ba(o(a0, a1), [
                a2,
                a3,
                a4,
                a5,
                a6,
                a7
            ]);
        case 3:
            return $d7808759cc50027a$export$729c8b7179294ba(o(a0, a1, a2), [
                a3,
                a4,
                a5,
                a6,
                a7
            ]);
        case 4:
            return $d7808759cc50027a$export$729c8b7179294ba(o(a0, a1, a2, a3), [
                a4,
                a5,
                a6,
                a7
            ]);
        case 5:
            return $d7808759cc50027a$export$729c8b7179294ba(o(a0, a1, a2, a3, a4), [
                a5,
                a6,
                a7
            ]);
        case 6:
            return $d7808759cc50027a$export$729c8b7179294ba(o(a0, a1, a2, a3, a4, a5), [
                a6,
                a7
            ]);
        case 7:
            return $d7808759cc50027a$export$729c8b7179294ba(o(a0, a1, a2, a3, a4, a5, a6), [
                a7
            ]);
        default:
            return $d7808759cc50027a$export$729c8b7179294ba(o, [
                a0,
                a1,
                a2,
                a3,
                a4,
                a5,
                a6,
                a7
            ]);
    }
}
function $d7808759cc50027a$export$23302abb4f52e562(o) {
    var arity = o.length;
    if (arity === 8) return o;
    else return function(a0, a1, a2, a3, a4, a5, a6, a7) {
        return $d7808759cc50027a$export$fb0020d138ee4a60(o, a0, a1, a2, a3, a4, a5, a6, a7);
    };
}
 /* No side effect */ 
});
parcelRegister("1PGgk", function(module, exports) {

$parcel$export(module.exports, "sub", function () { return $155b5649ad275916$export$f93b5905241a7cca; });
$parcel$export(module.exports, "concat", function () { return $155b5649ad275916$export$ee1b3e54f0441b22; });
$parcel$export(module.exports, "set", function () { return $155b5649ad275916$export$adaa4cf7ef1b65be; });
$parcel$export(module.exports, "get", function () { return $155b5649ad275916$export$3988ae62b71be9a3; });
$parcel$export(module.exports, "make", function () { return $155b5649ad275916$export$dd44f18ab656f3bb; });
$parcel$export(module.exports, "make_float", function () { return $155b5649ad275916$export$d79c6918e0a9d9af; });
$parcel$export(module.exports, "blit", function () { return $155b5649ad275916$export$1b8713e12f56ba52; });
function $155b5649ad275916$export$f93b5905241a7cca(x, offset, len) {
    var result = new Array(len);
    var j = 0;
    var i = offset;
    while(j < len){
        result[j] = x[i];
        j = j + 1 | 0;
        i = i + 1 | 0;
    }
    return result;
}
function $155b5649ad275916$var$len(_acc, _l) {
    while(true){
        var l = _l;
        var acc = _acc;
        if (!l) return acc;
        _l = l.tl;
        _acc = l.hd.length + acc | 0;
        continue;
    }
}
function $155b5649ad275916$var$fill(arr, _i, _l) {
    while(true){
        var l = _l;
        var i = _i;
        if (!l) return;
        var x = l.hd;
        var l$1 = x.length;
        var k = i;
        var j = 0;
        while(j < l$1){
            arr[k] = x[j];
            k = k + 1 | 0;
            j = j + 1 | 0;
        }
        _l = l.tl;
        _i = k;
        continue;
    }
}
function $155b5649ad275916$export$ee1b3e54f0441b22(l) {
    var v = $155b5649ad275916$var$len(0, l);
    var result = new Array(v);
    $155b5649ad275916$var$fill(result, 0, l);
    return result;
}
function $155b5649ad275916$export$adaa4cf7ef1b65be(xs, index, newval) {
    if (index < 0 || index >= xs.length) throw {
        RE_EXN_ID: "Invalid_argument",
        _1: "index out of bounds",
        Error: new Error()
    };
    xs[index] = newval;
}
function $155b5649ad275916$export$3988ae62b71be9a3(xs, index) {
    if (index < 0 || index >= xs.length) throw {
        RE_EXN_ID: "Invalid_argument",
        _1: "index out of bounds",
        Error: new Error()
    };
    return xs[index];
}
function $155b5649ad275916$export$dd44f18ab656f3bb(len, init) {
    var b = new Array(len);
    for(var i = 0; i < len; ++i)b[i] = init;
    return b;
}
function $155b5649ad275916$export$d79c6918e0a9d9af(len) {
    var b = new Array(len);
    for(var i = 0; i < len; ++i)b[i] = 0;
    return b;
}
function $155b5649ad275916$export$1b8713e12f56ba52(a1, i1, a2, i2, len) {
    if (i2 <= i1) {
        for(var j = 0; j < len; ++j)a2[j + i2 | 0] = a1[j + i1 | 0];
        return;
    }
    for(var j$1 = len - 1 | 0; j$1 >= 0; --j$1)a2[j$1 + i2 | 0] = a1[j$1 + i1 | 0];
}
function $155b5649ad275916$export$f4427c3005d2d1a9(prim) {
    return prim.slice(0);
}
 /* No side effect */ 
});


parcelRegister("1xvYg", function(module, exports) {

$parcel$export(module.exports, "create", function () { return $11f1ac4476932d3c$export$185802fd694ee1f5; });
$parcel$export(module.exports, "is_extension", function () { return $11f1ac4476932d3c$export$18fe2da6a9df47cb; });
var $11f1ac4476932d3c$export$d560c7e4a29451c2 = {
    contents: 0
};
function $11f1ac4476932d3c$export$185802fd694ee1f5(str) {
    $11f1ac4476932d3c$export$d560c7e4a29451c2.contents = $11f1ac4476932d3c$export$d560c7e4a29451c2.contents + 1 | 0;
    return str + ("/" + $11f1ac4476932d3c$export$d560c7e4a29451c2.contents);
}
function $11f1ac4476932d3c$export$18fe2da6a9df47cb(e) {
    if (e == null) return false;
    else return typeof e.RE_EXN_ID === "string";
}
function $11f1ac4476932d3c$export$65f6247af03a69e8(x) {
    return x.RE_EXN_ID;
}
 /* No side effect */ 
});


parcelRegister("i7mYY", function(module, exports) {

$parcel$export(module.exports, "get", function () { return $d30ab54a4b4aa90f$export$3988ae62b71be9a3; });
$parcel$export(module.exports, "getExn", function () { return $d30ab54a4b4aa90f$export$2d6fda808293d631; });
$parcel$export(module.exports, "shuffleInPlace", function () { return $d30ab54a4b4aa90f$export$c8bbd489f517fb10; });
$parcel$export(module.exports, "reverse", function () { return $d30ab54a4b4aa90f$export$66c1ae025e96b4bc; });
$parcel$export(module.exports, "makeBy", function () { return $d30ab54a4b4aa90f$export$849fbdcc2211fcde; });
$parcel$export(module.exports, "range", function () { return $d30ab54a4b4aa90f$export$d02631cccf789723; });
$parcel$export(module.exports, "zip", function () { return $d30ab54a4b4aa90f$export$8901015135f2fb22; });
$parcel$export(module.exports, "concat", function () { return $d30ab54a4b4aa90f$export$ee1b3e54f0441b22; });
$parcel$export(module.exports, "concatMany", function () { return $d30ab54a4b4aa90f$export$252d63de73a739bf; });
$parcel$export(module.exports, "slice", function () { return $d30ab54a4b4aa90f$export$58adb3bec8346d0f; });
$parcel$export(module.exports, "sliceToEnd", function () { return $d30ab54a4b4aa90f$export$636515b12ce971; });
$parcel$export(module.exports, "blitUnsafe", function () { return $d30ab54a4b4aa90f$export$4893c6afb9c50600; });
$parcel$export(module.exports, "forEach", function () { return $d30ab54a4b4aa90f$export$4b80e395e36b5a56; });
$parcel$export(module.exports, "map", function () { return $d30ab54a4b4aa90f$export$871de8747c9eaa88; });
$parcel$export(module.exports, "flatMap", function () { return $d30ab54a4b4aa90f$export$5b8affa63fc6df16; });
$parcel$export(module.exports, "getBy", function () { return $d30ab54a4b4aa90f$export$d42617c71165e4fc; });
$parcel$export(module.exports, "getIndexBy", function () { return $d30ab54a4b4aa90f$export$165a6dc283bb948c; });
$parcel$export(module.exports, "keep", function () { return $d30ab54a4b4aa90f$export$fae3166c418e0471; });
$parcel$export(module.exports, "keepWithIndex", function () { return $d30ab54a4b4aa90f$export$3f46207acfee6bc5; });
$parcel$export(module.exports, "keepMap", function () { return $d30ab54a4b4aa90f$export$8b311cdc49e179cd; });
$parcel$export(module.exports, "forEachWithIndex", function () { return $d30ab54a4b4aa90f$export$2590cec716f5563e; });
$parcel$export(module.exports, "mapWithIndex", function () { return $d30ab54a4b4aa90f$export$8f07ddce13659f50; });
$parcel$export(module.exports, "reduce", function () { return $d30ab54a4b4aa90f$export$533b26079ad0b4b; });
$parcel$export(module.exports, "reduceReverseU", function () { return $d30ab54a4b4aa90f$export$ef531491e938ae6d; });
$parcel$export(module.exports, "reduceReverse2U", function () { return $d30ab54a4b4aa90f$export$c37d484a2f360d20; });
$parcel$export(module.exports, "reduceWithIndex", function () { return $d30ab54a4b4aa90f$export$bbd3ef8720e22369; });
$parcel$export(module.exports, "every", function () { return $d30ab54a4b4aa90f$export$7ecc1a3b11b57dab; });
$parcel$export(module.exports, "some", function () { return $d30ab54a4b4aa90f$export$ad14ef4001db2bcd; });
$parcel$export(module.exports, "some2", function () { return $d30ab54a4b4aa90f$export$2b9a9c68d2ecbfcb; });
$parcel$export(module.exports, "joinWith", function () { return $d30ab54a4b4aa90f$export$ec1dc8fbeea3467e; });

var $81N94 = parcelRequire("81N94");

var $iv6Yc = parcelRequire("iv6Yc");

var $5alaa = parcelRequire("5alaa");

var $loT9g = parcelRequire("loT9g");
function $d30ab54a4b4aa90f$export$3988ae62b71be9a3(arr, i) {
    if (i >= 0 && i < arr.length) return $loT9g.some(arr[i]);
}
function $d30ab54a4b4aa90f$export$2d6fda808293d631(arr, i) {
    if (!(i >= 0 && i < arr.length)) throw {
        RE_EXN_ID: "Assert_failure",
        _1: [
            "belt_Array.ml",
            35,
            2
        ],
        Error: new Error()
    };
    return arr[i];
}
function $d30ab54a4b4aa90f$export$adaa4cf7ef1b65be(arr, i, v) {
    if (i >= 0 && i < arr.length) {
        arr[i] = v;
        return true;
    } else return false;
}
function $d30ab54a4b4aa90f$export$2759592af1430f00(arr, i, v) {
    if (!(i >= 0 && i < arr.length)) throw {
        RE_EXN_ID: "Assert_failure",
        _1: [
            "belt_Array.ml",
            45,
            2
        ],
        Error: new Error()
    };
    arr[i] = v;
}
function $d30ab54a4b4aa90f$var$swapUnsafe(xs, i, j) {
    var tmp = xs[i];
    xs[i] = xs[j];
    xs[j] = tmp;
}
function $d30ab54a4b4aa90f$export$c8bbd489f517fb10(xs) {
    var len = xs.length;
    for(var i = 0; i < len; ++i)$d30ab54a4b4aa90f$var$swapUnsafe(xs, i, $5alaa.random_int(i, len));
}
function $d30ab54a4b4aa90f$export$448332262467e042(xs) {
    var result = xs.slice(0);
    $d30ab54a4b4aa90f$export$c8bbd489f517fb10(result);
    return result;
}
function $d30ab54a4b4aa90f$export$4ac24d4081114593(xs) {
    var len = xs.length;
    var ofs = 0;
    for(var i = 0, i_finish = len / 2 | 0; i < i_finish; ++i)$d30ab54a4b4aa90f$var$swapUnsafe(xs, ofs + i | 0, ((ofs + len | 0) - i | 0) - 1 | 0);
}
function $d30ab54a4b4aa90f$export$66c1ae025e96b4bc(xs) {
    var len = xs.length;
    var result = new Array(len);
    for(var i = 0; i < len; ++i)result[i] = xs[(len - 1 | 0) - i | 0];
    return result;
}
function $d30ab54a4b4aa90f$export$dd44f18ab656f3bb(l, f) {
    if (l <= 0) return [];
    var res = new Array(l);
    for(var i = 0; i < l; ++i)res[i] = f;
    return res;
}
function $d30ab54a4b4aa90f$export$790d8bf8abeeba86(l, f) {
    if (l <= 0) return [];
    var res = new Array(l);
    for(var i = 0; i < l; ++i)res[i] = f(i);
    return res;
}
function $d30ab54a4b4aa90f$export$849fbdcc2211fcde(l, f) {
    return $d30ab54a4b4aa90f$export$790d8bf8abeeba86(l, $iv6Yc.__1(f));
}
function $d30ab54a4b4aa90f$export$50f4f1c72194705e(l, f) {
    var u = $d30ab54a4b4aa90f$export$790d8bf8abeeba86(l, f);
    $d30ab54a4b4aa90f$export$c8bbd489f517fb10(u);
    return u;
}
function $d30ab54a4b4aa90f$export$e8d9b7996a060f6(l, f) {
    return $d30ab54a4b4aa90f$export$50f4f1c72194705e(l, $iv6Yc.__1(f));
}
function $d30ab54a4b4aa90f$export$d02631cccf789723(start, finish) {
    var cut = finish - start | 0;
    if (cut < 0) return [];
    var arr = new Array(cut + 1 | 0);
    for(var i = 0; i <= cut; ++i)arr[i] = start + i | 0;
    return arr;
}
function $d30ab54a4b4aa90f$export$d458fdc59efa85a1(start, finish, step) {
    var cut = finish - start | 0;
    if (cut < 0 || step <= 0) return [];
    var nb = (cut / step | 0) + 1 | 0;
    var arr = new Array(nb);
    var cur = start;
    for(var i = 0; i < nb; ++i){
        arr[i] = cur;
        cur = cur + step | 0;
    }
    return arr;
}
function $d30ab54a4b4aa90f$export$8901015135f2fb22(xs, ys) {
    var lenx = xs.length;
    var leny = ys.length;
    var len = lenx < leny ? lenx : leny;
    var s = new Array(len);
    for(var i = 0; i < len; ++i)s[i] = [
        xs[i],
        ys[i]
    ];
    return s;
}
function $d30ab54a4b4aa90f$export$35c5113aa227aa5(xs, ys, f) {
    var lenx = xs.length;
    var leny = ys.length;
    var len = lenx < leny ? lenx : leny;
    var s = new Array(len);
    for(var i = 0; i < len; ++i)s[i] = f(xs[i], ys[i]);
    return s;
}
function $d30ab54a4b4aa90f$export$d9e678742f9ba92(xs, ys, f) {
    return $d30ab54a4b4aa90f$export$35c5113aa227aa5(xs, ys, $iv6Yc.__2(f));
}
function $d30ab54a4b4aa90f$export$ee1b3e54f0441b22(a1, a2) {
    var l1 = a1.length;
    var l2 = a2.length;
    var a1a2 = new Array(l1 + l2 | 0);
    for(var i = 0; i < l1; ++i)a1a2[i] = a1[i];
    for(var i$1 = 0; i$1 < l2; ++i$1)a1a2[l1 + i$1 | 0] = a2[i$1];
    return a1a2;
}
function $d30ab54a4b4aa90f$export$252d63de73a739bf(arrs) {
    var lenArrs = arrs.length;
    var totalLen = 0;
    for(var i = 0; i < lenArrs; ++i)totalLen = totalLen + arrs[i].length | 0;
    var result = new Array(totalLen);
    totalLen = 0;
    for(var j = 0; j < lenArrs; ++j){
        var cur = arrs[j];
        for(var k = 0, k_finish = cur.length; k < k_finish; ++k){
            result[totalLen] = cur[k];
            totalLen = totalLen + 1 | 0;
        }
    }
    return result;
}
function $d30ab54a4b4aa90f$export$58adb3bec8346d0f(a, offset, len) {
    if (len <= 0) return [];
    var lena = a.length;
    var ofs = offset < 0 ? $81N94.int_max(lena + offset | 0, 0) : offset;
    var hasLen = lena - ofs | 0;
    var copyLength = hasLen < len ? hasLen : len;
    if (copyLength <= 0) return [];
    var result = new Array(copyLength);
    for(var i = 0; i < copyLength; ++i)result[i] = a[ofs + i | 0];
    return result;
}
function $d30ab54a4b4aa90f$export$636515b12ce971(a, offset) {
    var lena = a.length;
    var ofs = offset < 0 ? $81N94.int_max(lena + offset | 0, 0) : offset;
    var len = lena > ofs ? lena - ofs | 0 : 0;
    var result = new Array(len);
    for(var i = 0; i < len; ++i)result[i] = a[ofs + i | 0];
    return result;
}
function $d30ab54a4b4aa90f$export$9563e054e6f787fb(a, offset, len, v) {
    if (len <= 0) return;
    var lena = a.length;
    var ofs = offset < 0 ? $81N94.int_max(lena + offset | 0, 0) : offset;
    var hasLen = lena - ofs | 0;
    var fillLength = hasLen < len ? hasLen : len;
    if (fillLength <= 0) return;
    for(var i = ofs, i_finish = ofs + fillLength | 0; i < i_finish; ++i)a[i] = v;
}
function $d30ab54a4b4aa90f$export$4893c6afb9c50600(a1, srcofs1, a2, srcofs2, blitLength) {
    if (srcofs2 <= srcofs1) {
        for(var j = 0; j < blitLength; ++j)a2[j + srcofs2 | 0] = a1[j + srcofs1 | 0];
        return;
    }
    for(var j$1 = blitLength - 1 | 0; j$1 >= 0; --j$1)a2[j$1 + srcofs2 | 0] = a1[j$1 + srcofs1 | 0];
}
function $d30ab54a4b4aa90f$export$1b8713e12f56ba52(a1, ofs1, a2, ofs2, len) {
    var lena1 = a1.length;
    var lena2 = a2.length;
    var srcofs1 = ofs1 < 0 ? $81N94.int_max(lena1 + ofs1 | 0, 0) : ofs1;
    var srcofs2 = ofs2 < 0 ? $81N94.int_max(lena2 + ofs2 | 0, 0) : ofs2;
    var blitLength = $81N94.int_min(len, $81N94.int_min(lena1 - srcofs1 | 0, lena2 - srcofs2 | 0));
    if (srcofs2 <= srcofs1) {
        for(var j = 0; j < blitLength; ++j)a2[j + srcofs2 | 0] = a1[j + srcofs1 | 0];
        return;
    }
    for(var j$1 = blitLength - 1 | 0; j$1 >= 0; --j$1)a2[j$1 + srcofs2 | 0] = a1[j$1 + srcofs1 | 0];
}
function $d30ab54a4b4aa90f$export$e4198045b3bb8c9c(a, f) {
    for(var i = 0, i_finish = a.length; i < i_finish; ++i)f(a[i]);
}
function $d30ab54a4b4aa90f$export$4b80e395e36b5a56(a, f) {
    $d30ab54a4b4aa90f$export$e4198045b3bb8c9c(a, $iv6Yc.__1(f));
}
function $d30ab54a4b4aa90f$export$cc22bf2a9ce99b1(a, f) {
    var l = a.length;
    var r = new Array(l);
    for(var i = 0; i < l; ++i)r[i] = f(a[i]);
    return r;
}
function $d30ab54a4b4aa90f$export$871de8747c9eaa88(a, f) {
    return $d30ab54a4b4aa90f$export$cc22bf2a9ce99b1(a, $iv6Yc.__1(f));
}
function $d30ab54a4b4aa90f$export$88eb46a8b99993cf(a, f) {
    return $d30ab54a4b4aa90f$export$252d63de73a739bf($d30ab54a4b4aa90f$export$cc22bf2a9ce99b1(a, f));
}
function $d30ab54a4b4aa90f$export$5b8affa63fc6df16(a, f) {
    return $d30ab54a4b4aa90f$export$252d63de73a739bf($d30ab54a4b4aa90f$export$cc22bf2a9ce99b1(a, $iv6Yc.__1(f)));
}
function $d30ab54a4b4aa90f$export$bc39419d633f09a1(a, p) {
    var l = a.length;
    var i = 0;
    var r;
    while(r === undefined && i < l){
        var v = a[i];
        if (p(v)) r = $loT9g.some(v);
        i = i + 1 | 0;
    }
    return r;
}
function $d30ab54a4b4aa90f$export$d42617c71165e4fc(a, p) {
    return $d30ab54a4b4aa90f$export$bc39419d633f09a1(a, $iv6Yc.__1(p));
}
function $d30ab54a4b4aa90f$export$c3c636d892d6cca6(a, p) {
    var l = a.length;
    var i = 0;
    var r;
    while(r === undefined && i < l){
        var v = a[i];
        if (p(v)) r = i;
        i = i + 1 | 0;
    }
    return r;
}
function $d30ab54a4b4aa90f$export$165a6dc283bb948c(a, p) {
    return $d30ab54a4b4aa90f$export$c3c636d892d6cca6(a, $iv6Yc.__1(p));
}
function $d30ab54a4b4aa90f$export$2e45af2d40d3fd2b(a, f) {
    var l = a.length;
    var r = new Array(l);
    var j = 0;
    for(var i = 0; i < l; ++i){
        var v = a[i];
        if (f(v)) {
            r[j] = v;
            j = j + 1 | 0;
        }
    }
    r.length = j;
    return r;
}
function $d30ab54a4b4aa90f$export$fae3166c418e0471(a, f) {
    return $d30ab54a4b4aa90f$export$2e45af2d40d3fd2b(a, $iv6Yc.__1(f));
}
function $d30ab54a4b4aa90f$export$c322a8aa3e32d301(a, f) {
    var l = a.length;
    var r = new Array(l);
    var j = 0;
    for(var i = 0; i < l; ++i){
        var v = a[i];
        if (f(v, i)) {
            r[j] = v;
            j = j + 1 | 0;
        }
    }
    r.length = j;
    return r;
}
function $d30ab54a4b4aa90f$export$3f46207acfee6bc5(a, f) {
    return $d30ab54a4b4aa90f$export$c322a8aa3e32d301(a, $iv6Yc.__2(f));
}
function $d30ab54a4b4aa90f$export$fb6daf1607d5d777(a, f) {
    var l = a.length;
    var r = new Array(l);
    var j = 0;
    for(var i = 0; i < l; ++i){
        var v = a[i];
        var v$1 = f(v);
        if (v$1 !== undefined) {
            r[j] = $loT9g.valFromOption(v$1);
            j = j + 1 | 0;
        }
    }
    r.length = j;
    return r;
}
function $d30ab54a4b4aa90f$export$8b311cdc49e179cd(a, f) {
    return $d30ab54a4b4aa90f$export$fb6daf1607d5d777(a, $iv6Yc.__1(f));
}
function $d30ab54a4b4aa90f$export$fd682543f1c8c317(a, f) {
    for(var i = 0, i_finish = a.length; i < i_finish; ++i)f(i, a[i]);
}
function $d30ab54a4b4aa90f$export$2590cec716f5563e(a, f) {
    $d30ab54a4b4aa90f$export$fd682543f1c8c317(a, $iv6Yc.__2(f));
}
function $d30ab54a4b4aa90f$export$4cb8e22ecd37a3cf(a, f) {
    var l = a.length;
    var r = new Array(l);
    for(var i = 0; i < l; ++i)r[i] = f(i, a[i]);
    return r;
}
function $d30ab54a4b4aa90f$export$8f07ddce13659f50(a, f) {
    return $d30ab54a4b4aa90f$export$4cb8e22ecd37a3cf(a, $iv6Yc.__2(f));
}
function $d30ab54a4b4aa90f$export$ae643c57dec5ffec(a, x, f) {
    var r = x;
    for(var i = 0, i_finish = a.length; i < i_finish; ++i)r = f(r, a[i]);
    return r;
}
function $d30ab54a4b4aa90f$export$533b26079ad0b4b(a, x, f) {
    return $d30ab54a4b4aa90f$export$ae643c57dec5ffec(a, x, $iv6Yc.__2(f));
}
function $d30ab54a4b4aa90f$export$ef531491e938ae6d(a, x, f) {
    var r = x;
    for(var i = a.length - 1 | 0; i >= 0; --i)r = f(r, a[i]);
    return r;
}
function $d30ab54a4b4aa90f$export$e11ac067bdfe867d(a, x, f) {
    return $d30ab54a4b4aa90f$export$ef531491e938ae6d(a, x, $iv6Yc.__2(f));
}
function $d30ab54a4b4aa90f$export$c37d484a2f360d20(a, b, x, f) {
    var r = x;
    var len = $81N94.int_min(a.length, b.length);
    for(var i = len - 1 | 0; i >= 0; --i)r = f(r, a[i], b[i]);
    return r;
}
function $d30ab54a4b4aa90f$export$29d0b882e6ca8ad4(a, b, x, f) {
    return $d30ab54a4b4aa90f$export$c37d484a2f360d20(a, b, x, $iv6Yc.__3(f));
}
function $d30ab54a4b4aa90f$export$671b20c9914d5d4(a, x, f) {
    var r = x;
    for(var i = 0, i_finish = a.length; i < i_finish; ++i)r = f(r, a[i], i);
    return r;
}
function $d30ab54a4b4aa90f$export$bbd3ef8720e22369(a, x, f) {
    return $d30ab54a4b4aa90f$export$671b20c9914d5d4(a, x, $iv6Yc.__3(f));
}
function $d30ab54a4b4aa90f$export$f294ebd954c6e224(arr, b) {
    var len = arr.length;
    var _i = 0;
    while(true){
        var i = _i;
        if (i === len) return true;
        if (!b(arr[i])) return false;
        _i = i + 1 | 0;
        continue;
    }
}
function $d30ab54a4b4aa90f$export$7ecc1a3b11b57dab(arr, f) {
    return $d30ab54a4b4aa90f$export$f294ebd954c6e224(arr, $iv6Yc.__1(f));
}
function $d30ab54a4b4aa90f$export$6d4e2e7ededf6e6e(arr, b) {
    var len = arr.length;
    var _i = 0;
    while(true){
        var i = _i;
        if (i === len) return false;
        if (b(arr[i])) return true;
        _i = i + 1 | 0;
        continue;
    }
}
function $d30ab54a4b4aa90f$export$ad14ef4001db2bcd(arr, f) {
    return $d30ab54a4b4aa90f$export$6d4e2e7ededf6e6e(arr, $iv6Yc.__1(f));
}
function $d30ab54a4b4aa90f$var$everyAux2(arr1, arr2, _i, b, len) {
    while(true){
        var i = _i;
        if (i === len) return true;
        if (!b(arr1[i], arr2[i])) return false;
        _i = i + 1 | 0;
        continue;
    }
}
function $d30ab54a4b4aa90f$export$32d47f85bf8fcd80(a, b, p) {
    return $d30ab54a4b4aa90f$var$everyAux2(a, b, 0, p, $81N94.int_min(a.length, b.length));
}
function $d30ab54a4b4aa90f$export$bb2198ede04be76f(a, b, p) {
    return $d30ab54a4b4aa90f$export$32d47f85bf8fcd80(a, b, $iv6Yc.__2(p));
}
function $d30ab54a4b4aa90f$export$febfdec44bdabfd5(a, b, p) {
    var _i = 0;
    var len = $81N94.int_min(a.length, b.length);
    while(true){
        var i = _i;
        if (i === len) return false;
        if (p(a[i], b[i])) return true;
        _i = i + 1 | 0;
        continue;
    }
}
function $d30ab54a4b4aa90f$export$2b9a9c68d2ecbfcb(a, b, p) {
    return $d30ab54a4b4aa90f$export$febfdec44bdabfd5(a, b, $iv6Yc.__2(p));
}
function $d30ab54a4b4aa90f$export$f28cee400b9bf71f(a, b, p) {
    var lena = a.length;
    var lenb = b.length;
    if (lena === lenb) return $d30ab54a4b4aa90f$var$everyAux2(a, b, 0, p, lena);
    else return false;
}
function $d30ab54a4b4aa90f$export$9663ddc1cf085b32(a, b, p) {
    return $d30ab54a4b4aa90f$export$f28cee400b9bf71f(a, b, $iv6Yc.__2(p));
}
function $d30ab54a4b4aa90f$export$c0aec0f0618831d3(a, b, p) {
    var lena = a.length;
    var lenb = b.length;
    if (lena > lenb) return 1;
    else if (lena < lenb) return -1;
    else {
        var _i = 0;
        while(true){
            var i = _i;
            if (i === lena) return 0;
            var c = p(a[i], b[i]);
            if (c !== 0) return c;
            _i = i + 1 | 0;
            continue;
        }
    }
}
function $d30ab54a4b4aa90f$export$6154dcdb7d23e37b(a, b, p) {
    return $d30ab54a4b4aa90f$export$c0aec0f0618831d3(a, b, $iv6Yc.__2(p));
}
function $d30ab54a4b4aa90f$export$5a6fbee869ed7abd(a, f) {
    var l = a.length;
    var i = 0;
    var j = 0;
    var a1 = new Array(l);
    var a2 = new Array(l);
    for(var ii = 0; ii < l; ++ii){
        var v = a[ii];
        if (f(v)) {
            a1[i] = v;
            i = i + 1 | 0;
        } else {
            a2[j] = v;
            j = j + 1 | 0;
        }
    }
    a1.length = i;
    a2.length = j;
    return [
        a1,
        a2
    ];
}
function $d30ab54a4b4aa90f$export$b29f828819edca8d(a, f) {
    return $d30ab54a4b4aa90f$export$5a6fbee869ed7abd(a, $iv6Yc.__1(f));
}
function $d30ab54a4b4aa90f$export$23c8d3f8757cab88(a) {
    var l = a.length;
    var a1 = new Array(l);
    var a2 = new Array(l);
    for(var i = 0; i < l; ++i){
        var match = a[i];
        a1[i] = match[0];
        a2[i] = match[1];
    }
    return [
        a1,
        a2
    ];
}
function $d30ab54a4b4aa90f$export$307cd3158c4754(a, sep, toString) {
    var l = a.length;
    if (l === 0) return "";
    var lastIndex = l - 1 | 0;
    var _i = 0;
    var _res = "";
    while(true){
        var res = _res;
        var i = _i;
        if (i === lastIndex) return res + toString(a[i]);
        _res = res + (toString(a[i]) + sep);
        _i = i + 1 | 0;
        continue;
    }
}
function $d30ab54a4b4aa90f$export$ec1dc8fbeea3467e(a, sep, toString) {
    return $d30ab54a4b4aa90f$export$307cd3158c4754(a, sep, $iv6Yc.__1(toString));
}
function $d30ab54a4b4aa90f$export$8e9de877e669511(n, f) {
    var v = new Array(n);
    for(var i = 0; i < n; ++i)v[i] = f(i);
    return v;
}
function $d30ab54a4b4aa90f$export$2cd8252107eb640b(n, f) {
    return $d30ab54a4b4aa90f$export$8e9de877e669511(n, $iv6Yc.__1(f));
}
 /* No side effect */ 
});
parcelRegister("81N94", function(module, exports) {

$parcel$export(module.exports, "int_compare", function () { return $5d8489fbba0fc2eb$export$354522a5acffad9c; });
$parcel$export(module.exports, "bool_compare", function () { return $5d8489fbba0fc2eb$export$c240aa38e4535f72; });
$parcel$export(module.exports, "float_compare", function () { return $5d8489fbba0fc2eb$export$856f195a8d3a917f; });
$parcel$export(module.exports, "string_compare", function () { return $5d8489fbba0fc2eb$export$d02a1e3d7b207b97; });
$parcel$export(module.exports, "int_min", function () { return $5d8489fbba0fc2eb$export$db1557085c62b9b9; });
$parcel$export(module.exports, "int_max", function () { return $5d8489fbba0fc2eb$export$355a5a6d39351009; });
$parcel$export(module.exports, "float_max", function () { return $5d8489fbba0fc2eb$export$42304c34585496aa; });
$parcel$export(module.exports, "i64_eq", function () { return $5d8489fbba0fc2eb$export$f55f62f23aa7e7c0; });
$parcel$export(module.exports, "i64_ge", function () { return $5d8489fbba0fc2eb$export$ac07213c4002d153; });
$parcel$export(module.exports, "i64_neq", function () { return $5d8489fbba0fc2eb$export$a47f15e99e00908d; });
$parcel$export(module.exports, "i64_lt", function () { return $5d8489fbba0fc2eb$export$175b4467bd3db13; });
$parcel$export(module.exports, "i64_gt", function () { return $5d8489fbba0fc2eb$export$1b8becaf35b9a53b; });
function $5d8489fbba0fc2eb$export$354522a5acffad9c(x, y) {
    if (x < y) return -1;
    else if (x === y) return 0;
    else return 1;
}
function $5d8489fbba0fc2eb$export$c240aa38e4535f72(x, y) {
    if (x) {
        if (y) return 0;
        else return 1;
    } else if (y) return -1;
    else return 0;
}
function $5d8489fbba0fc2eb$export$856f195a8d3a917f(x, y) {
    if (x === y) return 0;
    else if (x < y) return -1;
    else if (x > y || x === x) return 1;
    else if (y === y) return -1;
    else return 0;
}
function $5d8489fbba0fc2eb$export$d02a1e3d7b207b97(s1, s2) {
    if (s1 === s2) return 0;
    else if (s1 < s2) return -1;
    else return 1;
}
function $5d8489fbba0fc2eb$export$530c458936ea02e3(x, y) {
    if (x) return y;
    else return x;
}
function $5d8489fbba0fc2eb$export$db1557085c62b9b9(x, y) {
    if (x < y) return x;
    else return y;
}
function $5d8489fbba0fc2eb$export$d8d137fb490364a5(x, y) {
    if (x < y) return x;
    else return y;
}
function $5d8489fbba0fc2eb$export$dfaa2934841e6863(x, y) {
    if (x < y) return x;
    else return y;
}
function $5d8489fbba0fc2eb$export$51b90cb522e2ba01(x, y) {
    if (x) return x;
    else return y;
}
function $5d8489fbba0fc2eb$export$355a5a6d39351009(x, y) {
    if (x > y) return x;
    else return y;
}
function $5d8489fbba0fc2eb$export$42304c34585496aa(x, y) {
    if (x > y) return x;
    else return y;
}
function $5d8489fbba0fc2eb$export$91b095ed6d71abba(x, y) {
    if (x > y) return x;
    else return y;
}
function $5d8489fbba0fc2eb$export$f55f62f23aa7e7c0(x, y) {
    if (x[1] === y[1]) return x[0] === y[0];
    else return false;
}
function $5d8489fbba0fc2eb$export$ac07213c4002d153(param, param$1) {
    var other_hi = param$1[0];
    var hi = param[0];
    if (hi > other_hi) return true;
    else if (hi < other_hi) return false;
    else return param[1] >= param$1[1];
}
function $5d8489fbba0fc2eb$export$a47f15e99e00908d(x, y) {
    return !$5d8489fbba0fc2eb$export$f55f62f23aa7e7c0(x, y);
}
function $5d8489fbba0fc2eb$export$175b4467bd3db13(x, y) {
    return !$5d8489fbba0fc2eb$export$ac07213c4002d153(x, y);
}
function $5d8489fbba0fc2eb$export$1b8becaf35b9a53b(x, y) {
    if (x[0] > y[0]) return true;
    else if (x[0] < y[0]) return false;
    else return x[1] > y[1];
}
function $5d8489fbba0fc2eb$export$dca4e68e7d76d59b(x, y) {
    return !$5d8489fbba0fc2eb$export$1b8becaf35b9a53b(x, y);
}
function $5d8489fbba0fc2eb$export$500c8725a7d28fae(x, y) {
    if ($5d8489fbba0fc2eb$export$ac07213c4002d153(x, y)) return y;
    else return x;
}
function $5d8489fbba0fc2eb$export$2f5070955f9fbf0e(x, y) {
    if ($5d8489fbba0fc2eb$export$1b8becaf35b9a53b(x, y)) return x;
    else return y;
}
 /* No side effect */ 
});

parcelRegister("5alaa", function(module, exports) {

$parcel$export(module.exports, "floor_int", function () { return $3c2e4d6ea9997d35$export$9c44a373dcac123d; });
$parcel$export(module.exports, "random_int", function () { return $3c2e4d6ea9997d35$export$ffc8773aa9b24c08; });
$parcel$export(module.exports, "ceil", function () { return $3c2e4d6ea9997d35$export$803ce6b71a0a94b2; });
$parcel$export(module.exports, "floor", function () { return $3c2e4d6ea9997d35$export$a3fe094919f356fd; });

var $dQgXi = parcelRequire("dQgXi");
function $3c2e4d6ea9997d35$export$8c9e53b937a7ea1a(prim) {
    return Math.ceil(prim);
}
function $3c2e4d6ea9997d35$export$5a67a7133f8be3ef(f) {
    if (f > $dQgXi.max) return $dQgXi.max;
    else if (f < $dQgXi.min) return $dQgXi.min;
    else return Math.ceil(f);
}
function $3c2e4d6ea9997d35$export$ff8f5b2ad008fc0e(prim) {
    return Math.floor(prim);
}
function $3c2e4d6ea9997d35$export$9c44a373dcac123d(f) {
    if (f > $dQgXi.max) return $dQgXi.max;
    else if (f < $dQgXi.min) return $dQgXi.min;
    else return Math.floor(f);
}
function $3c2e4d6ea9997d35$export$ffc8773aa9b24c08(min, max) {
    return $3c2e4d6ea9997d35$export$9c44a373dcac123d(Math.random() * (max - min | 0)) + min | 0;
}
var $3c2e4d6ea9997d35$export$803ce6b71a0a94b2 = $3c2e4d6ea9997d35$export$5a67a7133f8be3ef;
var $3c2e4d6ea9997d35$export$a3fe094919f356fd = $3c2e4d6ea9997d35$export$9c44a373dcac123d;
 /* No side effect */ 
});
parcelRegister("dQgXi", function(module, exports) {

$parcel$export(module.exports, "max", function () { return $a13d48b421e31b62$export$8960430cfd85939f; });
$parcel$export(module.exports, "min", function () { return $a13d48b421e31b62$export$96ec731ed4dcb222; });
function $a13d48b421e31b62$export$411ce8e5a71e3069(x, y) {
    return x === y;
}
var $a13d48b421e31b62$export$8960430cfd85939f = 2147483647;
var $a13d48b421e31b62$export$96ec731ed4dcb222 = -2147483648;
 /* No side effect */ 
});


parcelRegister("loT9g", function(module, exports) {

$parcel$export(module.exports, "some", function () { return $f9469e32778ad918$export$ad14ef4001db2bcd; });
$parcel$export(module.exports, "nullable_to_opt", function () { return $f9469e32778ad918$export$73807854efd48d62; });
$parcel$export(module.exports, "undefined_to_opt", function () { return $f9469e32778ad918$export$daa96954a277296c; });
$parcel$export(module.exports, "null_to_opt", function () { return $f9469e32778ad918$export$3370544e9afcd152; });
$parcel$export(module.exports, "valFromOption", function () { return $f9469e32778ad918$export$2d819ee58e195d2e; });
function $f9469e32778ad918$export$4a8d4869baca50f2(x) {
    return x.BS_PRIVATE_NESTED_SOME_NONE !== undefined;
}
function $f9469e32778ad918$export$ad14ef4001db2bcd(x) {
    if (x === undefined) return {
        BS_PRIVATE_NESTED_SOME_NONE: 0
    };
    else if (x !== null && x.BS_PRIVATE_NESTED_SOME_NONE !== undefined) return {
        BS_PRIVATE_NESTED_SOME_NONE: x.BS_PRIVATE_NESTED_SOME_NONE + 1 | 0
    };
    else return x;
}
function $f9469e32778ad918$export$73807854efd48d62(x) {
    if (x == null) return;
    else return $f9469e32778ad918$export$ad14ef4001db2bcd(x);
}
function $f9469e32778ad918$export$daa96954a277296c(x) {
    if (x === undefined) return;
    else return $f9469e32778ad918$export$ad14ef4001db2bcd(x);
}
function $f9469e32778ad918$export$3370544e9afcd152(x) {
    if (x === null) return;
    else return $f9469e32778ad918$export$ad14ef4001db2bcd(x);
}
function $f9469e32778ad918$export$2d819ee58e195d2e(x) {
    if (!(x !== null && x.BS_PRIVATE_NESTED_SOME_NONE !== undefined)) return x;
    var depth = x.BS_PRIVATE_NESTED_SOME_NONE;
    if (depth === 0) return;
    else return {
        BS_PRIVATE_NESTED_SOME_NONE: depth - 1 | 0
    };
}
function $f9469e32778ad918$export$953ca920446a35(x) {
    if (x === undefined) return;
    else return $f9469e32778ad918$export$2d819ee58e195d2e(x);
}
function $f9469e32778ad918$export$4a9d7f619f776b55(x) {
    if (x !== undefined) return x.VAL;
    else return x;
}
 /* No side effect */ 
});


parcelRegister("2whNH", function(module, exports) {

$parcel$export(module.exports, "keep", function () { return $1d5c60bfdfc55398$export$fae3166c418e0471; });
$parcel$export(module.exports, "forEach", function () { return $1d5c60bfdfc55398$export$4b80e395e36b5a56; });
$parcel$export(module.exports, "mapWithDefault", function () { return $1d5c60bfdfc55398$export$ae51aac33fd70d30; });
$parcel$export(module.exports, "map", function () { return $1d5c60bfdfc55398$export$871de8747c9eaa88; });
$parcel$export(module.exports, "flatMap", function () { return $1d5c60bfdfc55398$export$5b8affa63fc6df16; });
$parcel$export(module.exports, "getWithDefault", function () { return $1d5c60bfdfc55398$export$73b8ef55a37133c7; });
$parcel$export(module.exports, "orElse", function () { return $1d5c60bfdfc55398$export$41d1a04d78e7b141; });
$parcel$export(module.exports, "isSome", function () { return $1d5c60bfdfc55398$export$5d7e502287836e58; });
$parcel$export(module.exports, "isNone", function () { return $1d5c60bfdfc55398$export$e56af863d5645d5f; });

var $iv6Yc = parcelRequire("iv6Yc");

var $loT9g = parcelRequire("loT9g");
function $1d5c60bfdfc55398$export$2e45af2d40d3fd2b(opt, p) {
    if (opt !== undefined && p($loT9g.valFromOption(opt))) return opt;
}
function $1d5c60bfdfc55398$export$fae3166c418e0471(opt, p) {
    return $1d5c60bfdfc55398$export$2e45af2d40d3fd2b(opt, $iv6Yc.__1(p));
}
function $1d5c60bfdfc55398$export$e4198045b3bb8c9c(opt, f) {
    if (opt !== undefined) return f($loT9g.valFromOption(opt));
}
function $1d5c60bfdfc55398$export$4b80e395e36b5a56(opt, f) {
    $1d5c60bfdfc55398$export$e4198045b3bb8c9c(opt, $iv6Yc.__1(f));
}
function $1d5c60bfdfc55398$export$2d6fda808293d631(x) {
    if (x !== undefined) return $loT9g.valFromOption(x);
    throw {
        RE_EXN_ID: "Not_found",
        Error: new Error()
    };
}
function $1d5c60bfdfc55398$export$28a83b3631ef8d34(opt, $$default, f) {
    if (opt !== undefined) return f($loT9g.valFromOption(opt));
    else return $$default;
}
function $1d5c60bfdfc55398$export$ae51aac33fd70d30(opt, $$default, f) {
    return $1d5c60bfdfc55398$export$28a83b3631ef8d34(opt, $$default, $iv6Yc.__1(f));
}
function $1d5c60bfdfc55398$export$cc22bf2a9ce99b1(opt, f) {
    if (opt !== undefined) return $loT9g.some(f($loT9g.valFromOption(opt)));
}
function $1d5c60bfdfc55398$export$871de8747c9eaa88(opt, f) {
    return $1d5c60bfdfc55398$export$cc22bf2a9ce99b1(opt, $iv6Yc.__1(f));
}
function $1d5c60bfdfc55398$export$88eb46a8b99993cf(opt, f) {
    if (opt !== undefined) return f($loT9g.valFromOption(opt));
}
function $1d5c60bfdfc55398$export$5b8affa63fc6df16(opt, f) {
    return $1d5c60bfdfc55398$export$88eb46a8b99993cf(opt, $iv6Yc.__1(f));
}
function $1d5c60bfdfc55398$export$73b8ef55a37133c7(opt, $$default) {
    if (opt !== undefined) return $loT9g.valFromOption(opt);
    else return $$default;
}
function $1d5c60bfdfc55398$export$41d1a04d78e7b141(opt, other) {
    if (opt !== undefined) return opt;
    else return other;
}
function $1d5c60bfdfc55398$export$5d7e502287836e58(param) {
    return param !== undefined;
}
function $1d5c60bfdfc55398$export$e56af863d5645d5f(x) {
    return x === undefined;
}
function $1d5c60bfdfc55398$export$f28cee400b9bf71f(a, b, f) {
    if (a !== undefined) {
        if (b !== undefined) return f($loT9g.valFromOption(a), $loT9g.valFromOption(b));
        else return false;
    } else return b === undefined;
}
function $1d5c60bfdfc55398$export$9663ddc1cf085b32(a, b, f) {
    return $1d5c60bfdfc55398$export$f28cee400b9bf71f(a, b, $iv6Yc.__2(f));
}
function $1d5c60bfdfc55398$export$c0aec0f0618831d3(a, b, f) {
    if (a !== undefined) {
        if (b !== undefined) return f($loT9g.valFromOption(a), $loT9g.valFromOption(b));
        else return 1;
    } else if (b !== undefined) return -1;
    else return 0;
}
function $1d5c60bfdfc55398$export$6154dcdb7d23e37b(a, b, f) {
    return $1d5c60bfdfc55398$export$c0aec0f0618831d3(a, b, $iv6Yc.__2(f));
}
 /* No side effect */ 
});

parcelRegister("kiuDo", function(module, exports) {

$parcel$export(module.exports, "int_of_string", function () { return $ec6d4076064b4af9$export$54f1a2c7334cd47a; });
$parcel$export(module.exports, "format_float", function () { return $ec6d4076064b4af9$export$a1cc16e22de035c2; });
$parcel$export(module.exports, "float_of_string", function () { return $ec6d4076064b4af9$export$e64a7892310c43e6; });

var $81N94 = parcelRequire("81N94");

var $dD1bi = parcelRequire("dD1bi");
function $ec6d4076064b4af9$var$parse_digit(c) {
    if (c >= 65) {
        if (c >= 97) {
            if (c >= 123) return -1;
            else return c - 87 | 0;
        } else if (c >= 91) return -1;
        else return c - 55 | 0;
    } else if (c > 57 || c < 48) return -1;
    else return c - /* '0' */ 48 | 0;
}
function $ec6d4076064b4af9$var$int_of_string_base(param) {
    switch(param){
        case /* Oct */ 0:
            return 8;
        case /* Hex */ 1:
            return 16;
        case /* Dec */ 2:
            return 10;
        case /* Bin */ 3:
            return 2;
    }
}
function $ec6d4076064b4af9$var$parse_sign_and_base(s) {
    var sign = 1;
    var base = /* Dec */ 2;
    var i = 0;
    var match = s.codePointAt(i);
    switch(match){
        case 43:
            i = i + 1 | 0;
            break;
        case 44:
            break;
        case 45:
            sign = -1;
            i = i + 1 | 0;
            break;
        default:
    }
    if (s.codePointAt(i) === /* '0' */ 48) {
        var match$1 = s.codePointAt(i + 1 | 0);
        if (match$1 >= 89) {
            if (match$1 >= 111) {
                if (match$1 < 121) switch(match$1){
                    case 111:
                        base = /* Oct */ 0;
                        i = i + 2 | 0;
                        break;
                    case 117:
                        i = i + 2 | 0;
                        break;
                    case 112:
                    case 113:
                    case 114:
                    case 115:
                    case 116:
                    case 118:
                    case 119:
                        break;
                    case 120:
                        base = /* Hex */ 1;
                        i = i + 2 | 0;
                        break;
                }
            } else if (match$1 === 98) {
                base = /* Bin */ 3;
                i = i + 2 | 0;
            }
        } else if (match$1 !== 66) {
            if (match$1 >= 79) switch(match$1){
                case 79:
                    base = /* Oct */ 0;
                    i = i + 2 | 0;
                    break;
                case 85:
                    i = i + 2 | 0;
                    break;
                case 80:
                case 81:
                case 82:
                case 83:
                case 84:
                case 86:
                case 87:
                    break;
                case 88:
                    base = /* Hex */ 1;
                    i = i + 2 | 0;
                    break;
            }
        } else {
            base = /* Bin */ 3;
            i = i + 2 | 0;
        }
    }
    return [
        i,
        sign,
        base
    ];
}
function $ec6d4076064b4af9$export$54f1a2c7334cd47a(s) {
    var match = $ec6d4076064b4af9$var$parse_sign_and_base(s);
    var i = match[0];
    var base = $ec6d4076064b4af9$var$int_of_string_base(match[2]);
    var threshold = 4294967295;
    var len = s.length;
    var c = i < len ? s.codePointAt(i) : /* '\000' */ 0;
    var d = $ec6d4076064b4af9$var$parse_digit(c);
    if (d < 0 || d >= base) throw {
        RE_EXN_ID: "Failure",
        _1: "int_of_string",
        Error: new Error()
    };
    var aux = function aux(_acc, _k) {
        while(true){
            var k = _k;
            var acc = _acc;
            if (k === len) return acc;
            var a = s.codePointAt(k);
            if (a === /* '_' */ 95) {
                _k = k + 1 | 0;
                continue;
            }
            var v = $ec6d4076064b4af9$var$parse_digit(a);
            if (v < 0 || v >= base) throw {
                RE_EXN_ID: "Failure",
                _1: "int_of_string",
                Error: new Error()
            };
            var acc$1 = base * acc + v;
            if (acc$1 > threshold) throw {
                RE_EXN_ID: "Failure",
                _1: "int_of_string",
                Error: new Error()
            };
            _k = k + 1 | 0;
            _acc = acc$1;
            continue;
        }
    };
    var res = match[1] * aux(d, i + 1 | 0);
    var or_res = res | 0;
    if (base === 10 && res !== or_res) throw {
        RE_EXN_ID: "Failure",
        _1: "int_of_string",
        Error: new Error()
    };
    return or_res;
}
function $ec6d4076064b4af9$export$7a154557857cbfac(s) {
    var match = $ec6d4076064b4af9$var$parse_sign_and_base(s);
    var hbase = match[2];
    var i = match[0];
    var base = $dD1bi.of_int32($ec6d4076064b4af9$var$int_of_string_base(hbase));
    var sign = $dD1bi.of_int32(match[1]);
    var threshold;
    switch(hbase){
        case /* Oct */ 0:
            threshold = [
                536870911,
                4294967295
            ];
            break;
        case /* Hex */ 1:
            threshold = [
                268435455,
                4294967295
            ];
            break;
        case /* Dec */ 2:
            threshold = [
                429496729,
                2576980377
            ];
            break;
        case /* Bin */ 3:
            threshold = $dD1bi.max_int;
            break;
    }
    var len = s.length;
    var c = i < len ? s.codePointAt(i) : /* '\000' */ 0;
    var d = $dD1bi.of_int32($ec6d4076064b4af9$var$parse_digit(c));
    if ($81N94.i64_lt(d, $dD1bi.zero) || $81N94.i64_ge(d, base)) throw {
        RE_EXN_ID: "Failure",
        _1: "int64_of_string",
        Error: new Error()
    };
    var aux = function aux(_acc, _k) {
        while(true){
            var k = _k;
            var acc = _acc;
            if (k === len) return acc;
            var a = s.codePointAt(k);
            if (a === /* '_' */ 95) {
                _k = k + 1 | 0;
                continue;
            }
            var v = $dD1bi.of_int32($ec6d4076064b4af9$var$parse_digit(a));
            if ($81N94.i64_lt(v, $dD1bi.zero) || $81N94.i64_ge(v, base) || $81N94.i64_gt(acc, threshold)) throw {
                RE_EXN_ID: "Failure",
                _1: "int64_of_string",
                Error: new Error()
            };
            var acc$1 = $dD1bi.add($dD1bi.mul(base, acc), v);
            _k = k + 1 | 0;
            _acc = acc$1;
            continue;
        }
    };
    var res = $dD1bi.mul(sign, aux(d, i + 1 | 0));
    var or_res = $dD1bi.or_(res, $dD1bi.zero);
    if ($81N94.i64_eq(base, [
        0,
        10
    ]) && $81N94.i64_neq(res, or_res)) throw {
        RE_EXN_ID: "Failure",
        _1: "int64_of_string",
        Error: new Error()
    };
    return or_res;
}
function $ec6d4076064b4af9$var$int_of_base(param) {
    switch(param){
        case /* Oct */ 0:
            return 8;
        case /* Hex */ 1:
            return 16;
        case /* Dec */ 2:
            return 10;
    }
}
function $ec6d4076064b4af9$var$lowercase(c) {
    if (c >= /* 'A' */ 65 && c <= /* 'Z' */ 90 || c >= /* '\192' */ 192 && c <= /* '\214' */ 214 || c >= /* '\216' */ 216 && c <= /* '\222' */ 222) return c + 32 | 0;
    else return c;
}
function $ec6d4076064b4af9$var$parse_format(fmt) {
    var len = fmt.length;
    if (len > 31) throw {
        RE_EXN_ID: "Invalid_argument",
        _1: "format_int: format too long",
        Error: new Error()
    };
    var f = {
        justify: "+",
        signstyle: "-",
        filter: " ",
        alternate: false,
        base: /* Dec */ 2,
        signedconv: false,
        width: 0,
        uppercase: false,
        sign: 1,
        prec: -1,
        conv: "f"
    };
    var _i = 0;
    while(true){
        var i = _i;
        if (i >= len) return f;
        var c = fmt.codePointAt(i);
        var exit = 0;
        if (c >= 69) {
            if (c >= 88) {
                if (c >= 121) exit = 1;
                else switch(c){
                    case 88:
                        f.base = /* Hex */ 1;
                        f.uppercase = true;
                        _i = i + 1 | 0;
                        continue;
                    case 101:
                    case 102:
                    case 103:
                        exit = 5;
                        break;
                    case 100:
                    case 105:
                        exit = 4;
                        break;
                    case 111:
                        f.base = /* Oct */ 0;
                        _i = i + 1 | 0;
                        continue;
                    case 117:
                        f.base = /* Dec */ 2;
                        _i = i + 1 | 0;
                        continue;
                    case 89:
                    case 90:
                    case 91:
                    case 92:
                    case 93:
                    case 94:
                    case 95:
                    case 96:
                    case 97:
                    case 98:
                    case 99:
                    case 104:
                    case 106:
                    case 107:
                    case 108:
                    case 109:
                    case 110:
                    case 112:
                    case 113:
                    case 114:
                    case 115:
                    case 116:
                    case 118:
                    case 119:
                        exit = 1;
                        break;
                    case 120:
                        f.base = /* Hex */ 1;
                        _i = i + 1 | 0;
                        continue;
                }
            } else if (c >= 72) exit = 1;
            else {
                f.signedconv = true;
                f.uppercase = true;
                f.conv = String.fromCharCode($ec6d4076064b4af9$var$lowercase(c));
                _i = i + 1 | 0;
                continue;
            }
        } else switch(c){
            case 35:
                f.alternate = true;
                _i = i + 1 | 0;
                continue;
            case 32:
            case 43:
                exit = 2;
                break;
            case 45:
                f.justify = "-";
                _i = i + 1 | 0;
                continue;
            case 46:
                f.prec = 0;
                var j = i + 1 | 0;
                while((function(j) {
                    return function() {
                        var w = fmt.codePointAt(j) - /* '0' */ 48 | 0;
                        return w >= 0 && w <= 9;
                    };
                })(j)()){
                    f.prec = (Math.imul(f.prec, 10) + fmt.codePointAt(j) | 0) - /* '0' */ 48 | 0;
                    j = j + 1 | 0;
                }
                _i = j;
                continue;
            case 33:
            case 34:
            case 36:
            case 37:
            case 38:
            case 39:
            case 40:
            case 41:
            case 42:
            case 44:
            case 47:
                exit = 1;
                break;
            case 48:
                f.filter = "0";
                _i = i + 1 | 0;
                continue;
            case 49:
            case 50:
            case 51:
            case 52:
            case 53:
            case 54:
            case 55:
            case 56:
            case 57:
                exit = 3;
                break;
            default:
                exit = 1;
        }
        switch(exit){
            case 1:
                _i = i + 1 | 0;
                continue;
            case 2:
                f.signstyle = String.fromCharCode(c);
                _i = i + 1 | 0;
                continue;
            case 3:
                f.width = 0;
                var j$1 = i;
                while((function(j$1) {
                    return function() {
                        var w = fmt.codePointAt(j$1) - /* '0' */ 48 | 0;
                        return w >= 0 && w <= 9;
                    };
                })(j$1)()){
                    f.width = (Math.imul(f.width, 10) + fmt.codePointAt(j$1) | 0) - /* '0' */ 48 | 0;
                    j$1 = j$1 + 1 | 0;
                }
                _i = j$1;
                continue;
            case 4:
                f.signedconv = true;
                f.base = /* Dec */ 2;
                _i = i + 1 | 0;
                continue;
            case 5:
                f.signedconv = true;
                f.conv = String.fromCharCode(c);
                _i = i + 1 | 0;
                continue;
        }
    }
}
function $ec6d4076064b4af9$var$finish_formatting(config, rawbuffer) {
    var justify = config.justify;
    var signstyle = config.signstyle;
    var filter = config.filter;
    var alternate = config.alternate;
    var base = config.base;
    var signedconv = config.signedconv;
    var width = config.width;
    var uppercase = config.uppercase;
    var sign = config.sign;
    var len = rawbuffer.length;
    if (signedconv && (sign < 0 || signstyle !== "-")) len = len + 1 | 0;
    if (alternate) {
        if (base === /* Oct */ 0) len = len + 1 | 0;
        else if (base === /* Hex */ 1) len = len + 2 | 0;
    }
    var buffer = "";
    if (justify === "+" && filter === " ") for(var _for = len; _for < width; ++_for)buffer = buffer + filter;
    if (signedconv) {
        if (sign < 0) buffer = buffer + "-";
        else if (signstyle !== "-") buffer = buffer + signstyle;
    }
    if (alternate && base === /* Oct */ 0) buffer = buffer + "0";
    if (alternate && base === /* Hex */ 1) buffer = buffer + "0x";
    if (justify === "+" && filter === "0") for(var _for$1 = len; _for$1 < width; ++_for$1)buffer = buffer + filter;
    buffer = uppercase ? buffer + rawbuffer.toUpperCase() : buffer + rawbuffer;
    if (justify === "-") for(var _for$2 = len; _for$2 < width; ++_for$2)buffer = buffer + " ";
    return buffer;
}
function $ec6d4076064b4af9$export$7c65dd8409f37a29(fmt, i) {
    if (fmt === "%d") return String(i);
    var f = $ec6d4076064b4af9$var$parse_format(fmt);
    var i$1 = i < 0 ? f.signedconv ? (f.sign = -1, -i >>> 0) : i >>> 0 : i;
    var s = i$1.toString($ec6d4076064b4af9$var$int_of_base(f.base));
    if (f.prec >= 0) {
        f.filter = " ";
        var n = f.prec - s.length | 0;
        if (n > 0) s = "0".repeat(n) + s;
    }
    return $ec6d4076064b4af9$var$finish_formatting(f, s);
}
function $ec6d4076064b4af9$var$dec_of_pos_int64(x) {
    if (!$81N94.i64_lt(x, $dD1bi.zero)) return $dD1bi.to_string(x);
    var wbase = [
        0,
        10
    ];
    var y = $dD1bi.discard_sign(x);
    var match = $dD1bi.div_mod(y, wbase);
    var match$1 = $dD1bi.div_mod($dD1bi.add([
        0,
        8
    ], match[1]), wbase);
    var quotient = $dD1bi.add($dD1bi.add([
        214748364,
        3435973836
    ], match[0]), match$1[0]);
    return $dD1bi.to_string(quotient) + "0123456789"[$dD1bi.to_int32(match$1[1])];
}
function $ec6d4076064b4af9$var$oct_of_int64(x) {
    var s = "";
    var wbase = [
        0,
        8
    ];
    var cvtbl = "01234567";
    if ($81N94.i64_lt(x, $dD1bi.zero)) {
        var y = $dD1bi.discard_sign(x);
        var match = $dD1bi.div_mod(y, wbase);
        var quotient = $dD1bi.add([
            268435456,
            0
        ], match[0]);
        var modulus = match[1];
        s = cvtbl[$dD1bi.to_int32(modulus)] + s;
        while($81N94.i64_neq(quotient, $dD1bi.zero)){
            var match$1 = $dD1bi.div_mod(quotient, wbase);
            quotient = match$1[0];
            modulus = match$1[1];
            s = cvtbl[$dD1bi.to_int32(modulus)] + s;
        }
    } else {
        var match$2 = $dD1bi.div_mod(x, wbase);
        var quotient$1 = match$2[0];
        var modulus$1 = match$2[1];
        s = cvtbl[$dD1bi.to_int32(modulus$1)] + s;
        while($81N94.i64_neq(quotient$1, $dD1bi.zero)){
            var match$3 = $dD1bi.div_mod(quotient$1, wbase);
            quotient$1 = match$3[0];
            modulus$1 = match$3[1];
            s = cvtbl[$dD1bi.to_int32(modulus$1)] + s;
        }
    }
    return s;
}
function $ec6d4076064b4af9$export$890b36441b21018a(fmt, x) {
    if (fmt === "%d") return $dD1bi.to_string(x);
    var f = $ec6d4076064b4af9$var$parse_format(fmt);
    var x$1 = f.signedconv && $81N94.i64_lt(x, $dD1bi.zero) ? (f.sign = -1, $dD1bi.neg(x)) : x;
    var match = f.base;
    var s;
    switch(match){
        case /* Oct */ 0:
            s = $ec6d4076064b4af9$var$oct_of_int64(x$1);
            break;
        case /* Hex */ 1:
            s = $dD1bi.to_hex(x$1);
            break;
        case /* Dec */ 2:
            s = $ec6d4076064b4af9$var$dec_of_pos_int64(x$1);
            break;
    }
    var fill_s;
    if (f.prec >= 0) {
        f.filter = " ";
        var n = f.prec - s.length | 0;
        fill_s = n > 0 ? "0".repeat(n) + s : s;
    } else fill_s = s;
    return $ec6d4076064b4af9$var$finish_formatting(f, fill_s);
}
function $ec6d4076064b4af9$export$a1cc16e22de035c2(fmt, x) {
    var f = $ec6d4076064b4af9$var$parse_format(fmt);
    var prec = f.prec < 0 ? 6 : f.prec;
    var x$1 = x < 0 ? (f.sign = -1, -x) : x;
    var s = "";
    if (isNaN(x$1)) {
        s = "nan";
        f.filter = " ";
    } else if (isFinite(x$1)) {
        var match = f.conv;
        switch(match){
            case "e":
                s = x$1.toExponential(prec);
                var i = s.length;
                if (s.codePointAt(i - 3 | 0) === /* 'e' */ 101) s = s.slice(0, i - 1 | 0) + ("0" + s.slice(i - 1 | 0));
                break;
            case "f":
                s = x$1.toFixed(prec);
                break;
            case "g":
                var prec$1 = prec !== 0 ? prec : 1;
                s = x$1.toExponential(prec$1 - 1 | 0);
                var j = s.indexOf("e");
                var exp = Number(s.slice(j + 1 | 0)) | 0;
                if (exp < -4 || x$1 >= 1e21 || x$1.toFixed().length > prec$1) {
                    var i$1 = j - 1 | 0;
                    while(s.codePointAt(i$1) === /* '0' */ 48)i$1 = i$1 - 1 | 0;
                    if (s.codePointAt(i$1) === /* '.' */ 46) i$1 = i$1 - 1 | 0;
                    s = s.slice(0, i$1 + 1 | 0) + s.slice(j);
                    var i$2 = s.length;
                    if (s.codePointAt(i$2 - 3 | 0) === /* 'e' */ 101) s = s.slice(0, i$2 - 1 | 0) + ("0" + s.slice(i$2 - 1 | 0));
                } else {
                    var p = prec$1;
                    if (exp < 0) {
                        p = p - (exp + 1 | 0) | 0;
                        s = x$1.toFixed(p);
                    } else while(function() {
                        s = x$1.toFixed(p);
                        return s.length > (prec$1 + 1 | 0);
                    }())p = p - 1 | 0;
                    if (p !== 0) {
                        var k = s.length - 1 | 0;
                        while(s.codePointAt(k) === /* '0' */ 48)k = k - 1 | 0;
                        if (s.codePointAt(k) === /* '.' */ 46) k = k - 1 | 0;
                        s = s.slice(0, k + 1 | 0);
                    }
                }
                break;
            default:
        }
    } else {
        s = "inf";
        f.filter = " ";
    }
    return $ec6d4076064b4af9$var$finish_formatting(f, s);
}
var $ec6d4076064b4af9$export$6b16f782609bad1d = function hexstring_of_float(x, prec, style) {
    if (!isFinite(x)) {
        if (isNaN(x)) return "nan";
        return x > 0 ? "infinity" : "-infinity";
    }
    var sign = x == 0 && 1 / x == -Infinity ? 1 : x >= 0 ? 0 : 1;
    if (sign) x = -x;
    var exp = 0;
    if (x == 0) ;
    else if (x < 1) while(x < 1 && exp > -1022){
        x *= 2;
        exp--;
    }
    else while(x >= 2){
        x /= 2;
        exp++;
    }
    var exp_sign = exp < 0 ? "" : "+";
    var sign_str = "";
    if (sign) sign_str = "-";
    else switch(style){
        case 43 /* '+' */ :
            sign_str = "+";
            break;
        case 32 /* ' ' */ :
            sign_str = " ";
            break;
        default:
            break;
    }
    if (prec >= 0 && prec < 13) {
        /* If a precision is given, and is small, round mantissa accordingly */ var cst = Math.pow(2, prec * 4);
        x = Math.round(x * cst) / cst;
    }
    var x_str = x.toString(16);
    if (prec >= 0) {
        var idx = x_str.indexOf(".");
        if (idx < 0) x_str += "." + "0".repeat(prec);
        else {
            var size = idx + 1 + prec;
            if (x_str.length < size) x_str += "0".repeat(size - x_str.length);
            else x_str = x_str.substr(0, size);
        }
    }
    return sign_str + "0x" + x_str + "p" + exp_sign + exp.toString(10);
};
var $ec6d4076064b4af9$var$float_of_string = function float_of_string(s, exn) {
    var res = +s;
    if (s.length > 0 && res === res) return res;
    s = s.replace(/_/g, "");
    res = +s;
    if (s.length > 0 && res === res || /^[+-]?nan$/i.test(s)) return res;
    var m = /^ *([+-]?)0x([0-9a-f]+)\.?([0-9a-f]*)p([+-]?[0-9]+)/i.exec(s);
    //            1        2             3           4
    if (m) {
        var m3 = m[3].replace(/0+$/, "");
        var mantissa = parseInt(m[1] + m[2] + m3, 16);
        var exponent = (m[4] | 0) - 4 * m3.length;
        res = mantissa * Math.pow(2, exponent);
        return res;
    }
    if (/^\+?inf(inity)?$/i.test(s)) return Infinity;
    if (/^-inf(inity)?$/i.test(s)) return -Infinity;
    throw exn;
};
function $ec6d4076064b4af9$export$e64a7892310c43e6(s) {
    return $ec6d4076064b4af9$var$float_of_string(s, {
        RE_EXN_ID: "Failure",
        _1: "float_of_string"
    });
}
 /* No side effect */ 
});
parcelRegister("dD1bi", function(module, exports) {

$parcel$export(module.exports, "max_int", function () { return $9ebfd56c1029ee4d$export$44174b80ac4a558e; });
$parcel$export(module.exports, "zero", function () { return $9ebfd56c1029ee4d$export$7f9972325ebfd559; });
$parcel$export(module.exports, "neg", function () { return $9ebfd56c1029ee4d$export$d9493ff0dfa0fdd5; });
$parcel$export(module.exports, "add", function () { return $9ebfd56c1029ee4d$export$e16d8520af44a096; });
$parcel$export(module.exports, "mul", function () { return $9ebfd56c1029ee4d$export$6e3a27864ab166fe; });
$parcel$export(module.exports, "or_", function () { return $9ebfd56c1029ee4d$export$77e609ef32e106a4; });
$parcel$export(module.exports, "to_float", function () { return $9ebfd56c1029ee4d$export$179d0ee7d36d1d50; });
$parcel$export(module.exports, "of_float", function () { return $9ebfd56c1029ee4d$export$f4a8b0237c8df9a6; });
$parcel$export(module.exports, "to_string", function () { return $9ebfd56c1029ee4d$export$46c173f28beef960; });
$parcel$export(module.exports, "div_mod", function () { return $9ebfd56c1029ee4d$export$6bd85662b525b3b9; });
$parcel$export(module.exports, "of_int32", function () { return $9ebfd56c1029ee4d$export$c0dea48708041221; });
$parcel$export(module.exports, "to_int32", function () { return $9ebfd56c1029ee4d$export$a6caf603acdaf417; });
$parcel$export(module.exports, "to_hex", function () { return $9ebfd56c1029ee4d$export$b34392537f2698a2; });
$parcel$export(module.exports, "discard_sign", function () { return $9ebfd56c1029ee4d$export$451161f7dbaf7ee5; });
$parcel$export(module.exports, "float_of_bits", function () { return $9ebfd56c1029ee4d$export$15bac053cf5e8d01; });
$parcel$export(module.exports, "bits_of_float", function () { return $9ebfd56c1029ee4d$export$f759bca77b24f29e; });

var $81N94 = parcelRequire("81N94");
function $9ebfd56c1029ee4d$export$ad7cae49b56e2eb8(lo, hi) {
    return [
        hi,
        lo >>> 0
    ];
}
var $9ebfd56c1029ee4d$export$8c5d7acc34381e45 = [
    -2147483648,
    0
];
var $9ebfd56c1029ee4d$export$44174b80ac4a558e = [
    2147483647,
    4294967295
];
var $9ebfd56c1029ee4d$export$80bf7733f1207381 = [
    0,
    1
];
var $9ebfd56c1029ee4d$export$7f9972325ebfd559 = [
    0,
    0
];
var $9ebfd56c1029ee4d$export$8258efd2c6861b6b = [
    -1,
    4294967295
];
function $9ebfd56c1029ee4d$var$neg_signed(x) {
    return (x & -2147483648) !== 0;
}
function $9ebfd56c1029ee4d$var$non_neg_signed(x) {
    return (x & -2147483648) === 0;
}
function $9ebfd56c1029ee4d$export$61d85e1612867711(param) {
    var x_lo = param[1];
    var x_hi = param[0];
    var lo = x_lo + 1 | 0;
    return [
        x_hi + (lo === 0 ? 1 : 0) | 0,
        lo >>> 0
    ];
}
function $9ebfd56c1029ee4d$export$d9493ff0dfa0fdd5(param) {
    var other_lo = (param[1] ^ -1) + 1 | 0;
    return [
        (param[0] ^ -1) + (other_lo === 0 ? 1 : 0) | 0,
        other_lo >>> 0
    ];
}
function $9ebfd56c1029ee4d$var$add_aux(param, y_lo, y_hi) {
    var x_lo = param[1];
    var lo = x_lo + y_lo | 0;
    var overflow = $9ebfd56c1029ee4d$var$neg_signed(x_lo) && ($9ebfd56c1029ee4d$var$neg_signed(y_lo) || $9ebfd56c1029ee4d$var$non_neg_signed(lo)) || $9ebfd56c1029ee4d$var$neg_signed(y_lo) && $9ebfd56c1029ee4d$var$non_neg_signed(lo) ? 1 : 0;
    return [
        param[0] + y_hi + overflow | 0,
        lo >>> 0
    ];
}
function $9ebfd56c1029ee4d$export$e16d8520af44a096(self, param) {
    return $9ebfd56c1029ee4d$var$add_aux(self, param[1], param[0]);
}
function $9ebfd56c1029ee4d$export$411ce8e5a71e3069(x, y) {
    if (x[1] === y[1]) return x[0] === y[0];
    else return false;
}
function $9ebfd56c1029ee4d$export$59e6990050957897(x, y) {
    if (y !== null) return $81N94.i64_eq(x, y);
    else return false;
}
function $9ebfd56c1029ee4d$export$f1ff0552b435f9a8(x, y) {
    if (y !== undefined) return $81N94.i64_eq(x, y);
    else return false;
}
function $9ebfd56c1029ee4d$export$82648b0ea8b9e17f(x, y) {
    if (y == null) return false;
    else return $81N94.i64_eq(x, y);
}
function $9ebfd56c1029ee4d$var$sub_aux(x, lo, hi) {
    var y_lo = (lo ^ -1) + 1 >>> 0;
    var y_hi = (hi ^ -1) + (y_lo === 0 ? 1 : 0) | 0;
    return $9ebfd56c1029ee4d$var$add_aux(x, y_lo, y_hi);
}
function $9ebfd56c1029ee4d$export$f93b5905241a7cca(self, param) {
    return $9ebfd56c1029ee4d$var$sub_aux(self, param[1], param[0]);
}
function $9ebfd56c1029ee4d$export$b824a15733c7c982(x, numBits) {
    if (numBits === 0) return x;
    var lo = x[1];
    if (numBits >= 32) return [
        lo << (numBits - 32 | 0),
        0
    ];
    else return [
        lo >>> (32 - numBits | 0) | x[0] << numBits,
        lo << numBits >>> 0
    ];
}
function $9ebfd56c1029ee4d$export$9f754e9462ba943d(x, numBits) {
    if (numBits === 0) return x;
    var hi = x[0];
    var offset = numBits - 32 | 0;
    if (offset === 0) return [
        0,
        hi >>> 0
    ];
    else if (offset > 0) return [
        0,
        hi >>> offset
    ];
    else return [
        hi >>> numBits,
        (hi << (-offset | 0) | x[1] >>> numBits) >>> 0
    ];
}
function $9ebfd56c1029ee4d$export$fd2f69ca989c391d(x, numBits) {
    if (numBits === 0) return x;
    var hi = x[0];
    if (numBits < 32) return [
        hi >> numBits,
        (hi << (32 - numBits | 0) | x[1] >>> numBits) >>> 0
    ];
    else return [
        hi >= 0 ? 0 : -1,
        hi >> (numBits - 32 | 0) >>> 0
    ];
}
function $9ebfd56c1029ee4d$export$d141fa6c6d93da6f(param) {
    if (param[0] !== 0) return false;
    else return param[1] === 0;
}
function $9ebfd56c1029ee4d$export$6e3a27864ab166fe(_this, _other) {
    while(true){
        var other = _other;
        var $$this = _this;
        var lo;
        var this_hi = $$this[0];
        var exit = 0;
        var exit$1 = 0;
        var exit$2 = 0;
        if (this_hi !== 0) exit$2 = 4;
        else {
            if ($$this[1] === 0) return $9ebfd56c1029ee4d$export$7f9972325ebfd559;
            exit$2 = 4;
        }
        if (exit$2 === 4) {
            if (other[0] !== 0) exit$1 = 3;
            else {
                if (other[1] === 0) return $9ebfd56c1029ee4d$export$7f9972325ebfd559;
                exit$1 = 3;
            }
        }
        if (exit$1 === 3) {
            if (this_hi !== -2147483648 || $$this[1] !== 0) exit = 2;
            else lo = other[1];
        }
        if (exit === 2) {
            var other_hi = other[0];
            var lo$1 = $$this[1];
            var exit$3 = 0;
            if (other_hi !== -2147483648 || other[1] !== 0) exit$3 = 3;
            else lo = lo$1;
            if (exit$3 === 3) {
                var other_lo = other[1];
                if (this_hi < 0) {
                    if (other_hi >= 0) return $9ebfd56c1029ee4d$export$d9493ff0dfa0fdd5($9ebfd56c1029ee4d$export$6e3a27864ab166fe($9ebfd56c1029ee4d$export$d9493ff0dfa0fdd5($$this), other));
                    _other = $9ebfd56c1029ee4d$export$d9493ff0dfa0fdd5(other);
                    _this = $9ebfd56c1029ee4d$export$d9493ff0dfa0fdd5($$this);
                    continue;
                }
                if (other_hi < 0) return $9ebfd56c1029ee4d$export$d9493ff0dfa0fdd5($9ebfd56c1029ee4d$export$6e3a27864ab166fe($$this, $9ebfd56c1029ee4d$export$d9493ff0dfa0fdd5(other)));
                var a48 = this_hi >>> 16;
                var a32 = this_hi & 65535;
                var a16 = lo$1 >>> 16;
                var a00 = lo$1 & 65535;
                var b48 = other_hi >>> 16;
                var b32 = other_hi & 65535;
                var b16 = other_lo >>> 16;
                var b00 = other_lo & 65535;
                var c48 = 0;
                var c32 = 0;
                var c16 = 0;
                var c00 = a00 * b00;
                c16 = (c00 >>> 16) + a16 * b00;
                c32 = c16 >>> 16;
                c16 = (c16 & 65535) + a00 * b16;
                c32 = c32 + (c16 >>> 16) + a32 * b00;
                c48 = c32 >>> 16;
                c32 = (c32 & 65535) + a16 * b16;
                c48 = c48 + (c32 >>> 16);
                c32 = (c32 & 65535) + a00 * b32;
                c48 = c48 + (c32 >>> 16);
                c32 = c32 & 65535;
                c48 = c48 + (a48 * b00 + a32 * b16 + a16 * b32 + a00 * b48) & 65535;
                return [
                    c32 | c48 << 16,
                    (c00 & 65535 | (c16 & 65535) << 16) >>> 0
                ];
            }
        }
        if ((lo & 1) === 0) return $9ebfd56c1029ee4d$export$7f9972325ebfd559;
        else return $9ebfd56c1029ee4d$export$8c5d7acc34381e45;
    }
}
function $9ebfd56c1029ee4d$export$6444ef5cd411280c(param, param$1) {
    return [
        param[0] ^ param$1[0],
        (param[1] ^ param$1[1]) >>> 0
    ];
}
function $9ebfd56c1029ee4d$export$77e609ef32e106a4(param, param$1) {
    return [
        param[0] | param$1[0],
        (param[1] | param$1[1]) >>> 0
    ];
}
function $9ebfd56c1029ee4d$export$2be5551b2b7d0f3c(param, param$1) {
    return [
        param[0] & param$1[0],
        (param[1] & param$1[1]) >>> 0
    ];
}
function $9ebfd56c1029ee4d$export$179d0ee7d36d1d50(param) {
    return param[0] * 0x100000000 + param[1];
}
function $9ebfd56c1029ee4d$export$f4a8b0237c8df9a6(x) {
    if (isNaN(x) || !isFinite(x)) return $9ebfd56c1029ee4d$export$7f9972325ebfd559;
    if (x <= -9223372036854776000) return $9ebfd56c1029ee4d$export$8c5d7acc34381e45;
    if (x + 1 >= 9.22337203685477581e+18) return $9ebfd56c1029ee4d$export$44174b80ac4a558e;
    if (x < 0) return $9ebfd56c1029ee4d$export$d9493ff0dfa0fdd5($9ebfd56c1029ee4d$export$f4a8b0237c8df9a6(-x));
    var hi = x / 4294967296 | 0;
    var lo = x % 4294967296 | 0;
    return [
        hi,
        lo >>> 0
    ];
}
function $9ebfd56c1029ee4d$var$isSafeInteger(param) {
    var hi = param[0];
    var top11Bits = hi >> 21;
    if (top11Bits === 0) return true;
    else if (top11Bits === -1) return !(param[1] === 0 && hi === -2097152);
    else return false;
}
function $9ebfd56c1029ee4d$export$46c173f28beef960(self) {
    if ($9ebfd56c1029ee4d$var$isSafeInteger(self)) return String($9ebfd56c1029ee4d$export$179d0ee7d36d1d50(self));
    if (self[0] < 0) {
        if ($81N94.i64_eq(self, $9ebfd56c1029ee4d$export$8c5d7acc34381e45)) return "-9223372036854775808";
        else return "-" + $9ebfd56c1029ee4d$export$46c173f28beef960($9ebfd56c1029ee4d$export$d9493ff0dfa0fdd5(self));
    }
    var approx_div1 = $9ebfd56c1029ee4d$export$f4a8b0237c8df9a6(Math.floor($9ebfd56c1029ee4d$export$179d0ee7d36d1d50(self) / 10));
    var lo = approx_div1[1];
    var hi = approx_div1[0];
    var match = $9ebfd56c1029ee4d$var$sub_aux($9ebfd56c1029ee4d$var$sub_aux(self, lo << 3, lo >>> 29 | hi << 3), lo << 1, lo >>> 31 | hi << 1);
    var rem_lo = match[1];
    var rem_hi = match[0];
    if (rem_lo === 0 && rem_hi === 0) return $9ebfd56c1029ee4d$export$46c173f28beef960(approx_div1) + "0";
    if (rem_hi < 0) {
        var rem_lo$1 = (rem_lo ^ -1) + 1 >>> 0;
        var delta = Math.ceil(rem_lo$1 / 10);
        var remainder = 10 * delta - rem_lo$1;
        return $9ebfd56c1029ee4d$export$46c173f28beef960($9ebfd56c1029ee4d$var$sub_aux(approx_div1, delta | 0, 0)) + String(remainder | 0);
    }
    var delta$1 = Math.floor(rem_lo / 10);
    var remainder$1 = rem_lo - 10 * delta$1;
    return $9ebfd56c1029ee4d$export$46c173f28beef960($9ebfd56c1029ee4d$var$add_aux(approx_div1, delta$1 | 0, 0)) + String(remainder$1 | 0);
}
function $9ebfd56c1029ee4d$export$159d9494db57879b(_self, _other) {
    while(true){
        var other = _other;
        var self = _self;
        var self_hi = self[0];
        var exit = 0;
        var exit$1 = 0;
        if (other[0] !== 0 || other[1] !== 0) exit$1 = 2;
        else throw {
            RE_EXN_ID: "Division_by_zero",
            Error: new Error()
        };
        if (exit$1 === 2) {
            if (self_hi !== -2147483648) {
                if (self_hi !== 0) exit = 1;
                else {
                    if (self[1] === 0) return $9ebfd56c1029ee4d$export$7f9972325ebfd559;
                    exit = 1;
                }
            } else if (self[1] !== 0) exit = 1;
            else {
                if ($81N94.i64_eq(other, $9ebfd56c1029ee4d$export$80bf7733f1207381) || $81N94.i64_eq(other, $9ebfd56c1029ee4d$export$8258efd2c6861b6b)) return self;
                if ($81N94.i64_eq(other, $9ebfd56c1029ee4d$export$8c5d7acc34381e45)) return $9ebfd56c1029ee4d$export$80bf7733f1207381;
                var half_this = $9ebfd56c1029ee4d$export$fd2f69ca989c391d(self, 1);
                var approx = $9ebfd56c1029ee4d$export$b824a15733c7c982($9ebfd56c1029ee4d$export$159d9494db57879b(half_this, other), 1);
                var exit$2 = 0;
                if (approx[0] !== 0) exit$2 = 3;
                else {
                    if (approx[1] === 0) {
                        if (other[0] < 0) return $9ebfd56c1029ee4d$export$80bf7733f1207381;
                        else return $9ebfd56c1029ee4d$export$d9493ff0dfa0fdd5($9ebfd56c1029ee4d$export$80bf7733f1207381);
                    }
                    exit$2 = 3;
                }
                if (exit$2 === 3) {
                    var rem = $9ebfd56c1029ee4d$export$f93b5905241a7cca(self, $9ebfd56c1029ee4d$export$6e3a27864ab166fe(other, approx));
                    return $9ebfd56c1029ee4d$export$e16d8520af44a096(approx, $9ebfd56c1029ee4d$export$159d9494db57879b(rem, other));
                }
            }
        }
        if (exit === 1) {
            var other_hi = other[0];
            var exit$3 = 0;
            if (other_hi !== -2147483648) exit$3 = 2;
            else {
                if (other[1] === 0) return $9ebfd56c1029ee4d$export$7f9972325ebfd559;
                exit$3 = 2;
            }
            if (exit$3 === 2) {
                if (self_hi < 0) {
                    if (other_hi >= 0) return $9ebfd56c1029ee4d$export$d9493ff0dfa0fdd5($9ebfd56c1029ee4d$export$159d9494db57879b($9ebfd56c1029ee4d$export$d9493ff0dfa0fdd5(self), other));
                    _other = $9ebfd56c1029ee4d$export$d9493ff0dfa0fdd5(other);
                    _self = $9ebfd56c1029ee4d$export$d9493ff0dfa0fdd5(self);
                    continue;
                }
                if (other_hi < 0) return $9ebfd56c1029ee4d$export$d9493ff0dfa0fdd5($9ebfd56c1029ee4d$export$159d9494db57879b(self, $9ebfd56c1029ee4d$export$d9493ff0dfa0fdd5(other)));
                var res = $9ebfd56c1029ee4d$export$7f9972325ebfd559;
                var rem$1 = self;
                while($81N94.i64_ge(rem$1, other)){
                    var b = Math.floor($9ebfd56c1029ee4d$export$179d0ee7d36d1d50(rem$1) / $9ebfd56c1029ee4d$export$179d0ee7d36d1d50(other));
                    var approx$1 = 1 > b ? 1 : b;
                    var log2 = Math.ceil(Math.log(approx$1) / Math.LN2);
                    var delta = log2 <= 48 ? 1 : Math.pow(2, log2 - 48);
                    var approxRes = $9ebfd56c1029ee4d$export$f4a8b0237c8df9a6(approx$1);
                    var approxRem = $9ebfd56c1029ee4d$export$6e3a27864ab166fe(approxRes, other);
                    while(approxRem[0] < 0 || $81N94.i64_gt(approxRem, rem$1)){
                        approx$1 = approx$1 - delta;
                        approxRes = $9ebfd56c1029ee4d$export$f4a8b0237c8df9a6(approx$1);
                        approxRem = $9ebfd56c1029ee4d$export$6e3a27864ab166fe(approxRes, other);
                    }
                    if ($9ebfd56c1029ee4d$export$d141fa6c6d93da6f(approxRes)) approxRes = $9ebfd56c1029ee4d$export$80bf7733f1207381;
                    res = $9ebfd56c1029ee4d$export$e16d8520af44a096(res, approxRes);
                    rem$1 = $9ebfd56c1029ee4d$export$f93b5905241a7cca(rem$1, approxRem);
                }
                return res;
            }
        }
    }
}
function $9ebfd56c1029ee4d$export$3f70e015da55297(self, other) {
    return $9ebfd56c1029ee4d$export$f93b5905241a7cca(self, $9ebfd56c1029ee4d$export$6e3a27864ab166fe($9ebfd56c1029ee4d$export$159d9494db57879b(self, other), other));
}
function $9ebfd56c1029ee4d$export$6bd85662b525b3b9(self, other) {
    var quotient = $9ebfd56c1029ee4d$export$159d9494db57879b(self, other);
    return [
        quotient,
        $9ebfd56c1029ee4d$export$f93b5905241a7cca(self, $9ebfd56c1029ee4d$export$6e3a27864ab166fe(quotient, other))
    ];
}
function $9ebfd56c1029ee4d$export$398604a469f7de9a(self, other) {
    var y = other[0];
    var x = self[0];
    var v = x < y ? -1 : x === y ? 0 : 1;
    if (v !== 0) return v;
    var y$1 = other[1];
    var x$1 = self[1];
    if (x$1 < y$1) return -1;
    else if (x$1 === y$1) return 0;
    else return 1;
}
function $9ebfd56c1029ee4d$export$c0dea48708041221(lo) {
    return [
        lo < 0 ? -1 : 0,
        lo >>> 0
    ];
}
function $9ebfd56c1029ee4d$export$a6caf603acdaf417(x) {
    return x[1] | 0;
}
function $9ebfd56c1029ee4d$export$b34392537f2698a2(x) {
    var x_lo = x[1];
    var x_hi = x[0];
    var aux = function aux(v) {
        return (v >>> 0).toString(16);
    };
    if (x_hi === 0 && x_lo === 0) return "0";
    if (x_lo === 0) return aux(x_hi) + "00000000";
    if (x_hi === 0) return aux(x_lo);
    var lo = aux(x_lo);
    var pad = 8 - lo.length | 0;
    if (pad <= 0) return aux(x_hi) + lo;
    else return aux(x_hi) + ("0".repeat(pad) + lo);
}
function $9ebfd56c1029ee4d$export$451161f7dbaf7ee5(x) {
    return [
        2147483647 & x[0],
        x[1]
    ];
}
function $9ebfd56c1029ee4d$export$15bac053cf5e8d01(x) {
    return function(lo, hi) {
        return new Float64Array(new Int32Array([
            lo,
            hi
        ]).buffer)[0];
    }(x[1], x[0]);
}
function $9ebfd56c1029ee4d$export$f759bca77b24f29e(x) {
    var match = function(x) {
        return new Int32Array(new Float64Array([
            x
        ]).buffer);
    }(x);
    return [
        match[1],
        match[0] >>> 0
    ];
}
 /* No side effect */ 
});


parcelRegister("hxhfd", function(module, exports) {

$parcel$export(module.exports, "rollbarAccessToken", function () { return $034b66cada616cfa$export$d60a81027a7fc168; });
$parcel$export(module.exports, "nodeEnv", function () { return $034b66cada616cfa$export$37fa9d2aa1bf6dd1; });
$parcel$export(module.exports, "gitCommitSha", function () { return $034b66cada616cfa$export$747e59cf66009941; });
$parcel$export(module.exports, "apiHostnameProduction", function () { return $034b66cada616cfa$export$c72a56dea64b03fb; });
$parcel$export(module.exports, "getApiEnv", function () { return $034b66cada616cfa$export$25f63cee9d874dd7; });
$parcel$export(module.exports, "getApiHostname", function () { return $034b66cada616cfa$export$bd4ab0797d61c2b; });
$parcel$export(module.exports, "isTest", function () { return $034b66cada616cfa$export$410cbc2864fa25b5; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $2whNH = parcelRequire("2whNH");

var $bygWp = parcelRequire("bygWp");
var $034b66cada616cfa$export$d60a81027a7fc168 = "533bb4b491e442a7be988a4644319547";
var $034b66cada616cfa$export$37fa9d2aa1bf6dd1 = "production";
var $034b66cada616cfa$export$a2d882c07f06d405 = undefined;
var $034b66cada616cfa$export$a2390155e08931f4 = "60a309d3e063b4401dca948ebcb3bc3aab58b8cf";
var $034b66cada616cfa$export$747e59cf66009941 = $2whNH.getWithDefault($2whNH.orElse($034b66cada616cfa$export$a2d882c07f06d405, $034b66cada616cfa$export$a2390155e08931f4), "");
var $034b66cada616cfa$export$c72a56dea64b03fb = "https://api.maker.co";
var $034b66cada616cfa$export$ecb130f066f23e18 = "https://api-git-master-makerco.vercel.app";
var $034b66cada616cfa$export$c14bca7cd1b899b8 = "http://localhost:3001";
function $034b66cada616cfa$export$29a9c8be395a5cb3(env) {
    if (typeof env !== "number") return env._0;
    switch(env){
        case /* Staging */ 0:
            return "staging";
        case /* Production */ 1:
            return "production";
        case /* Local */ 2:
            return "local";
    }
}
function $034b66cada616cfa$export$25f63cee9d874dd7(devMode) {
    var partial_arg = /^(smartnav|api)\-([^\-]+)\-makerco\.vercel\.app$/;
    var isHostnameSafe = function isHostnameSafe(param) {
        return partial_arg.test(param);
    };
    var devMode$1 = devMode.toLowerCase();
    switch(devMode$1){
        case "dev":
        case "local":
            return /* Local */ 2;
        case "head":
        case "master":
        case "preview":
        case "staging":
            return /* Staging */ 0;
        default:
            if ($iv6Yc._1(isHostnameSafe, devMode$1)) return /* Hostname */ {
                _0: devMode$1
            };
            else return /* Production */ 1;
    }
}
function $034b66cada616cfa$export$bd4ab0797d61c2b(devMode) {
    if (typeof devMode !== "number") return "https://" + devMode._0;
    switch(devMode){
        case /* Staging */ 0:
            return $034b66cada616cfa$export$ecb130f066f23e18;
        case /* Production */ 1:
            return $034b66cada616cfa$export$c72a56dea64b03fb;
        case /* Local */ 2:
            return $034b66cada616cfa$export$c14bca7cd1b899b8;
    }
}
function $034b66cada616cfa$export$410cbc2864fa25b5(param) {
    if ($034b66cada616cfa$export$37fa9d2aa1bf6dd1 !== "production" || $bygWp.getCurrentHostname(undefined).endsWith(".vercel.app")) return true;
    else return $bygWp.getCurrentHostname(undefined).endsWith(".pages.dev");
}
 /* rollbarAccessToken Not a pure module */ 
});
parcelRegister("bygWp", function(module, exports) {

$parcel$export(module.exports, "getEstimatedVideoMimeFromUrl", function () { return $869002d3db994acc$export$b7f4c428112a07ab; });
$parcel$export(module.exports, "addProtocolIfMissing", function () { return $869002d3db994acc$export$54a0c441cd72babc; });
$parcel$export(module.exports, "resolveRelativePath", function () { return $869002d3db994acc$export$d3e288fe2560b9f7; });
$parcel$export(module.exports, "maybeMakeUrl", function () { return $869002d3db994acc$export$f37acb312a335172; });
$parcel$export(module.exports, "getCanonical", function () { return $869002d3db994acc$export$2c10ae20b5734e88; });
$parcel$export(module.exports, "getCurrentHostname", function () { return $869002d3db994acc$export$c41f2426343a61c1; });
$parcel$export(module.exports, "getCurrentUrl", function () { return $869002d3db994acc$export$dc90482e4ef07afd; });
$parcel$export(module.exports, "getPathname", function () { return $869002d3db994acc$export$b829272b1dcc6798; });
$parcel$export(module.exports, "getParam", function () { return $869002d3db994acc$export$ecf541e09a511845; });
$parcel$export(module.exports, "changeParam", function () { return $869002d3db994acc$export$83a2651f56a4b1d8; });
$parcel$export(module.exports, "deleteParamWithRegex", function () { return $869002d3db994acc$export$aea854206f351518; });
$parcel$export(module.exports, "addHostnameMaybe", function () { return $869002d3db994acc$export$6abdb4c09c2e81a1; });
$parcel$export(module.exports, "maybeMakeRelativeUrl", function () { return $869002d3db994acc$export$c7b1edcbf49dfe63; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $oO3sB = parcelRequire("oO3sB");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");
function $869002d3db994acc$export$b7f4c428112a07ab(src) {
    var parts = $i7mYY.get($i7mYY.keepMap($2whNH.getWithDefault($loT9g.null_to_opt($2whNH.getWithDefault($i7mYY.get(src.split("?"), 0), "").toLowerCase().match(/(.mp4|.m3u8|.mov)$/)), []), function(a) {
        return a;
    }), 0);
    if (parts === undefined) return;
    switch(parts){
        case ".m3u8":
            return "application/x-mpegURL";
        case ".mov":
            return "video/quicktime";
        case ".mp4":
            return "video/mp4";
        default:
            return;
    }
}
function $869002d3db994acc$export$fde0ca51e692f9(src) {
    return $2whNH.isSome($869002d3db994acc$export$b7f4c428112a07ab(src));
}
function $869002d3db994acc$export$54a0c441cd72babc(str) {
    var isMissingProtocol = !/^([^\/])+:\/\//.test(str) && !/^\/([^\/]+)/.test(str) && str.trim() !== "";
    if (isMissingProtocol) return str.replace(/^(?:(.*:)?\/\/)?(.*)/i, "https://$2");
    else return str;
}
function $869002d3db994acc$export$d3e288fe2560b9f7(relativePath) {
    var isRelativePath = relativePath.startsWith("/");
    if (isRelativePath) return window.location.origin + relativePath;
    else return relativePath;
}
function $869002d3db994acc$export$f37acb312a335172(url) {
    try {
        return $loT9g.some(new URL(url));
    } catch (e) {
        return;
    }
}
function $869002d3db994acc$export$2c10ae20b5734e88(param) {
    var link = $2whNH.flatMap($2whNH.map($loT9g.nullable_to_opt(document.querySelector("link[rel='canonical']")), function(el) {
        return $loT9g.nullable_to_opt(el.getAttribute("href"));
    }), function(href) {
        if (href === "") return;
        else return href;
    });
    var link$1;
    if (link !== undefined) link$1 = link;
    else {
        var $$location = window.location;
        link$1 = $$location.origin + $$location.pathname;
    }
    var link$2 = $2whNH.isSome($loT9g.null_to_opt(link$1.match(/^http/))) ? link$1 : "https://" + link$1;
    var url = $869002d3db994acc$export$f37acb312a335172(link$2);
    if (url === undefined) return "";
    var url$1 = $loT9g.valFromOption(url);
    $i7mYY.forEach($i7mYY.keep(Array.from(url$1.searchParams.keys()), function(param) {
        return $oO3sB.includes("QN", param);
    }), function(key) {
        url$1.searchParams.delete(key);
    });
    return url$1.toString();
}
function $869002d3db994acc$export$c41f2426343a61c1(param) {
    return window.location.hostname;
}
function $869002d3db994acc$export$dc90482e4ef07afd(param) {
    return window.location.href;
}
function $869002d3db994acc$export$e61aef4ae55da883(input) {
    var url = $869002d3db994acc$export$f37acb312a335172(input);
    if (url !== undefined) return $loT9g.valFromOption(url).hostname;
}
function $869002d3db994acc$export$b829272b1dcc6798(input) {
    var url = $869002d3db994acc$export$f37acb312a335172(input);
    if (url !== undefined) return $loT9g.valFromOption(url).pathname;
}
function $869002d3db994acc$export$ecf541e09a511845(input, key) {
    var url = $869002d3db994acc$export$f37acb312a335172(input);
    if (url !== undefined) return $loT9g.nullable_to_opt($loT9g.valFromOption(url).searchParams.get(key));
}
function $869002d3db994acc$export$83a2651f56a4b1d8(input, key, value) {
    var url = $869002d3db994acc$export$f37acb312a335172(input);
    if (url === undefined) return input;
    var url$1 = $loT9g.valFromOption(url);
    if (value !== undefined) url$1.searchParams.set(key, value);
    else url$1.searchParams.delete(key);
    return url$1.toString();
}
function $869002d3db994acc$export$aea854206f351518(input, keyRe) {
    var url = $869002d3db994acc$export$f37acb312a335172(input);
    if (url === undefined) return input;
    var url$1 = $loT9g.valFromOption(url);
    $i7mYY.forEach($i7mYY.keep(Array.from(url$1.searchParams.keys()), function(param) {
        return keyRe.test(param);
    }), function(key) {
        url$1.searchParams.delete(key);
    });
    return url$1.toString();
}
function $869002d3db994acc$export$6abdb4c09c2e81a1(url, hostname) {
    var match = $869002d3db994acc$export$e61aef4ae55da883(url);
    if (match !== undefined) return url;
    else return hostname + url;
}
function $869002d3db994acc$export$c7b1edcbf49dfe63(url) {
    var urlObj = $869002d3db994acc$export$f37acb312a335172(url);
    return $2whNH.mapWithDefault(urlObj, url, function(obj) {
        if (obj.hostname === window.location.hostname) return obj.pathname + obj.search + obj.hash;
        else return obj.href;
    });
}
 /* No side effect */ 
});
parcelRegister("oO3sB", function(module, exports) {

$parcel$export(module.exports, "includes", function () { return $04a911d9514e6a54$export$ee2e0f811dca1807; });
$parcel$export(module.exports, "match_", function () { return $04a911d9514e6a54$export$cdda381943c99125; });
$parcel$export(module.exports, "split", function () { return $04a911d9514e6a54$export$65980d18b75784e2; });
$parcel$export(module.exports, "splitByRe", function () { return $04a911d9514e6a54$export$d3429aad18808f65; });
$parcel$export(module.exports, "substr", function () { return $04a911d9514e6a54$export$2f35ab04d2335697; });

var $iv6Yc = parcelRequire("iv6Yc");

var $loT9g = parcelRequire("loT9g");

var $e1M2F = parcelRequire("e1M2F");
function $04a911d9514e6a54$export$bbcf894add1d392c(arg1, obj) {
    return obj.charAt(arg1);
}
function $04a911d9514e6a54$export$c0c1d67d36c309b0(arg1, obj) {
    return obj.charCodeAt(arg1);
}
function $04a911d9514e6a54$export$42977f40461e1360(arg1, obj) {
    return obj.codePointAt(arg1);
}
function $04a911d9514e6a54$export$ee1b3e54f0441b22(arg1, obj) {
    return obj.concat(arg1);
}
function $04a911d9514e6a54$export$252d63de73a739bf(arg1, obj) {
    return $e1M2F.spliceObjApply(obj, "concat", [
        arg1
    ]);
}
function $04a911d9514e6a54$export$10fdab3683b55b22(arg1, obj) {
    return obj.endsWith(arg1);
}
function $04a911d9514e6a54$export$d6b198f3d68b24db(arg1, arg2, obj) {
    return obj.endsWith(arg1, arg2);
}
function $04a911d9514e6a54$export$ee2e0f811dca1807(arg1, obj) {
    return obj.includes(arg1);
}
function $04a911d9514e6a54$export$92bc748dfba5c3(arg1, arg2, obj) {
    return obj.includes(arg1, arg2);
}
function $04a911d9514e6a54$export$305f7d4e9d4624f2(arg1, obj) {
    return obj.indexOf(arg1);
}
function $04a911d9514e6a54$export$3840751aad9a3d1c(arg1, arg2, obj) {
    return obj.indexOf(arg1, arg2);
}
function $04a911d9514e6a54$export$557cfb7ed375eeb7(arg1, obj) {
    return obj.lastIndexOf(arg1);
}
function $04a911d9514e6a54$export$4a78c614e5d162c5(arg1, arg2, obj) {
    return obj.lastIndexOf(arg1, arg2);
}
function $04a911d9514e6a54$export$35652c12e6caefdf(arg1, obj) {
    return obj.localeCompare(arg1);
}
function $04a911d9514e6a54$export$cdda381943c99125(arg1, obj) {
    return $loT9g.null_to_opt(obj.match(arg1));
}
function $04a911d9514e6a54$export$cec6843133747b7a(arg1, obj) {
    return obj.normalize(arg1);
}
function $04a911d9514e6a54$export$76d90c956114f2c2(arg1, obj) {
    return obj.repeat(arg1);
}
function $04a911d9514e6a54$export$77ad94ebf1c2b9ed(arg1, arg2, obj) {
    return obj.replace(arg1, arg2);
}
function $04a911d9514e6a54$export$bb211dc63ac1cd60(arg1, arg2, obj) {
    return obj.replace(arg1, arg2);
}
function $04a911d9514e6a54$export$7869610114f2a6db(arg1, arg2, obj) {
    return obj.replace(arg1, $iv6Yc.__3(arg2));
}
function $04a911d9514e6a54$export$72af1fe9efa233b9(arg1, arg2, obj) {
    return obj.replace(arg1, $iv6Yc.__4(arg2));
}
function $04a911d9514e6a54$export$6cde2f74b467cfda(arg1, arg2, obj) {
    return obj.replace(arg1, $iv6Yc.__5(arg2));
}
function $04a911d9514e6a54$export$c24f5eff759a8aa8(arg1, arg2, obj) {
    return obj.replace(arg1, $iv6Yc.__6(arg2));
}
function $04a911d9514e6a54$export$d76128d007d19019(arg1, obj) {
    return obj.search(arg1);
}
function $04a911d9514e6a54$export$58adb3bec8346d0f(from, to_, obj) {
    return obj.slice(from, to_);
}
function $04a911d9514e6a54$export$636515b12ce971(from, obj) {
    return obj.slice(from);
}
function $04a911d9514e6a54$export$65980d18b75784e2(arg1, obj) {
    return obj.split(arg1);
}
function $04a911d9514e6a54$export$a8fe09dfdc2aaa22(arg1, limit, obj) {
    return obj.split(arg1, limit);
}
function $04a911d9514e6a54$export$d3429aad18808f65(arg1, obj) {
    return obj.split(arg1);
}
function $04a911d9514e6a54$export$c1daf8ec930c1b4e(arg1, limit, obj) {
    return obj.split(arg1, limit);
}
function $04a911d9514e6a54$export$68326237475e9a7d(arg1, obj) {
    return obj.startsWith(arg1);
}
function $04a911d9514e6a54$export$dfe4dcb5aa627eb2(arg1, arg2, obj) {
    return obj.startsWith(arg1, arg2);
}
function $04a911d9514e6a54$export$2f35ab04d2335697(from, obj) {
    return obj.substr(from);
}
function $04a911d9514e6a54$export$d7de59369970b89d(from, length, obj) {
    return obj.substr(from, length);
}
function $04a911d9514e6a54$export$662d3818631fba36(from, to_, obj) {
    return obj.substring(from, to_);
}
function $04a911d9514e6a54$export$7137b6142d2c0135(from, obj) {
    return obj.substring(from);
}
function $04a911d9514e6a54$export$2e2992790a6f69a8(arg1, obj) {
    return obj.anchor(arg1);
}
function $04a911d9514e6a54$export$9c30223ca0a664fb(arg1, obj) {
    return obj.link(arg1);
}
 /* No side effect */ 
});
parcelRegister("e1M2F", function(module, exports) {

$parcel$export(module.exports, "spliceObjApply", function () { return $a3666ccefeabf94f$export$38bd5c25b9c03fdc; });
var $a3666ccefeabf94f$export$b883dd1aeef19298 = function spliceApply(fn, args) {
    var i, argLen;
    argLen = args.length;
    var applied = [];
    for(i = 0; i < argLen - 1; ++i)applied.push(args[i]);
    var lastOne = args[argLen - 1];
    for(i = 0; i < lastOne.length; ++i)applied.push(lastOne[i]);
    return fn.apply(null, applied);
};
var $a3666ccefeabf94f$export$4fb8f84441cf41b = function spliceNewApply(ctor, args) {
    var i, argLen;
    argLen = args.length;
    var applied = [
        null
    ] // Function.prototype.bind.apply(fn, args) requires the first element in `args` to be `null`
    ;
    for(i = 0; i < argLen - 1; ++i)applied.push(args[i]);
    var lastOne = args[argLen - 1];
    for(i = 0; i < lastOne.length; ++i)applied.push(lastOne[i]);
    var C = Function.prototype.bind.apply(ctor, applied);
    return new C();
};
var $a3666ccefeabf94f$export$38bd5c25b9c03fdc = function spliceObjApply(obj, name, args) {
    var i, argLen;
    argLen = args.length;
    var applied = [];
    for(i = 0; i < argLen - 1; ++i)applied.push(args[i]);
    var lastOne = args[argLen - 1];
    for(i = 0; i < lastOne.length; ++i)applied.push(lastOne[i]);
    return obj[name].apply(obj, applied);
};
 /* No side effect */ 
});




parcelRegister("2gwg0", function(module, exports) {

$parcel$export(module.exports, "isShopify", function () { return $1a6618ff3241895e$export$55e72648ecf74d00; });
$parcel$export(module.exports, "getShop", function () { return $1a6618ff3241895e$export$94a798e7920ff647; });
$parcel$export(module.exports, "getCountry", function () { return $1a6618ff3241895e$export$a27f7d52d5670305; });
$parcel$export(module.exports, "getLanguage", function () { return $1a6618ff3241895e$export$64783e31db14f0ba; });
$parcel$export(module.exports, "makeUrl", function () { return $1a6618ff3241895e$export$e98ca45c96b2aafe; });
$parcel$export(module.exports, "makeCoverUrl", function () { return $1a6618ff3241895e$export$5b34c872bd037cc3; });
$parcel$export(module.exports, "isShopifyImg", function () { return $1a6618ff3241895e$export$d61d1a5886754ed1; });
$parcel$export(module.exports, "getCheckoutLink", function () { return $1a6618ff3241895e$export$2a04187f21f7a890; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $bygWp = parcelRequire("bygWp");
function $1a6618ff3241895e$export$55e72648ecf74d00(param) {
    return $2whNH.isSome(window.Shopify);
}
function $1a6618ff3241895e$export$94a798e7920ff647(param) {
    return $2whNH.flatMap(window.Shopify, function(shopify) {
        return shopify.shop;
    });
}
function $1a6618ff3241895e$export$a27f7d52d5670305(param) {
    return $2whNH.flatMap(window.Shopify, function(shopify) {
        return shopify.country;
    });
}
function $1a6618ff3241895e$export$64783e31db14f0ba(param) {
    return $2whNH.flatMap(window.Shopify, function(shopify) {
        return shopify.locale;
    });
}
function $1a6618ff3241895e$export$a8eb35c07a9de52(__x) {
    return __x.replace(/(_\d+x(\d+|)).(\w{3,4}\?)/, ".$3");
}
function $1a6618ff3241895e$export$e98ca45c96b2aafe(url, w, h, dprOpt, unit) {
    var dpr = dprOpt !== undefined ? dprOpt : 1;
    var url$1 = $1a6618ff3241895e$export$a8eb35c07a9de52(url);
    var width = $2whNH.mapWithDefault(w, "", function(w) {
        return "&width=" + String(Math.imul(w, dpr));
    });
    var height = $2whNH.mapWithDefault(h, "", function(h) {
        return "&height=" + String(Math.imul(h, dpr));
    });
    return url$1 + width + height;
}
function $1a6618ff3241895e$export$5b34c872bd037cc3(url, w, h, naturalWidth, naturalHeight, dprOpt, unit) {
    var dpr = dprOpt !== undefined ? dprOpt : 1;
    var url$1 = $1a6618ff3241895e$export$a8eb35c07a9de52(url);
    var param;
    if (w !== undefined && h !== undefined) {
        if (naturalWidth !== undefined) {
            if (naturalHeight !== undefined) {
                var dw = w / naturalWidth;
                var dh = h / naturalHeight;
                param = dh < dw ? "&width=" + String(Math.imul(w, dpr)) + "" : "&height=" + String(Math.imul(h, dpr)) + "";
            } else param = "";
        } else param = naturalHeight !== undefined ? "" : h < w ? "&width=" + String(Math.imul(w, dpr)) + "" : "&height=" + String(Math.imul(h, dpr)) + "";
    } else param = "";
    return url$1 + param;
}
function $1a6618ff3241895e$export$d61d1a5886754ed1(src) {
    return src.includes("cdn.shopify.com");
}
function $1a6618ff3241895e$export$2a04187f21f7a890(cart, clientId, transitiveStore, checkoutLink) {
    var getVariantId = function getVariantId(variantId, url) {
        var isNumeric = variantId.length === $2whNH.getWithDefault($2whNH.getWithDefault($i7mYY.get($2whNH.getWithDefault($loT9g.null_to_opt(variantId.match(/([0-9]+)/)), []), 0), undefined), "").length;
        var variantIdFromLink = $i7mYY.get($2whNH.getWithDefault($loT9g.null_to_opt($2whNH.getWithDefault(url, "").match(/variant=([0-9]+)/)), []), 1);
        if (isNumeric) return variantId;
        if (variantIdFromLink === undefined) return variantId;
        var variantIdFromLink$1 = $loT9g.valFromOption(variantIdFromLink);
        if (variantIdFromLink$1 !== undefined) return variantIdFromLink$1;
        else return variantId;
    };
    var baseUrl = $2whNH.map($2whNH.flatMap(checkoutLink, $bygWp.maybeMakeUrl), function(prim) {
        return prim.origin;
    });
    return $2whNH.map($2whNH.flatMap(baseUrl, $bygWp.maybeMakeUrl), function(baseUrl) {
        var queryParams = [];
        var token = $2whNH.flatMap(transitiveStore, function(store) {
            return store.shopifyStorefrontAccessToken;
        });
        var queryParams$1 = token !== undefined ? $i7mYY.concat(queryParams, [
            "access_token=" + token + ""
        ]) : queryParams;
        var queryParams$2 = clientId !== undefined ? $i7mYY.concat(queryParams$1, [
            "ref=mkr|" + clientId[0] + "|" + clientId[1] + ""
        ]) : queryParams$1;
        var queryParams$3 = $i7mYY.joinWith(queryParams$2, "&", function(a) {
            return a;
        });
        var queryParams$4 = queryParams$3 === "" ? "" : "?" + queryParams$3;
        return baseUrl.origin + "/cart/" + $i7mYY.joinWith($2whNH.mapWithDefault(cart, [], function(cart) {
            return cart.items;
        }), ",", function(param) {
            return getVariantId(param.variantId, param.url) + ":" + String(param.quantity);
        }) + queryParams$4;
    });
}
 /* No side effect */ 
});

parcelRegister("aYvyX", function(module, exports) {

$parcel$export(module.exports, "isEnabled", function () { return $7fd7fdae034a86a6$export$3b029eb57ac4d562; });
$parcel$export(module.exports, "$$Option", function () { return $7fd7fdae034a86a6$export$98c61fe1bf2ebc47; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $7bjme = parcelRequire("7bjme");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $hxhfd = parcelRequire("hxhfd");

var $7KlbQ = parcelRequire("7KlbQ");

var $2gwg0 = parcelRequire("2gwg0");

var $gfHt9 = parcelRequire("gfHt9");
function $7fd7fdae034a86a6$export$3b029eb57ac4d562(param) {
    var isPrivacyEnabled = $2whNH.getWithDefault(navigator.globalPrivacyControl, false);
    var isPreview = $7bjme.equal($loT9g.nullable_to_opt(new URL(window.location.href).searchParams.get("QNPreviewMode")), "HEAD");
    var match = $hxhfd.isTest(undefined);
    if (match || isPrivacyEnabled || isPreview) return false;
    else return true;
}
function $7fd7fdae034a86a6$var$make(configId, categoryTitle, product, variant, time, link, isInline, isLauncher, isNavMenu, navVersionOpt, currentStory, storyTitle, partnerId, breakpoint, accountId, isMiniPDPVisible, $$event, mediaId, mediaParentId, mediaSrc, mediaTitle, relatedMediaCategoryId, relatedMediaProductIds, url, param) {
    var navVersion = navVersionOpt !== undefined ? navVersionOpt : "v1";
    return {
        sheetId: configId,
        toProductCategory: categoryTitle,
        toProductColor: $2whNH.flatMap(variant, function(variant) {
            return $7KlbQ.Variant.getOptionValue(variant, "Color");
        }),
        toProductGroupId: undefined,
        toProductId: $2whNH.map(product, function(product) {
            return product.id;
        }),
        toProductMaterial: $2whNH.flatMap(variant, function(variant) {
            return $7KlbQ.Variant.getOptionValue(variant, "Material");
        }),
        toProductPattern: $2whNH.flatMap(variant, function(variant) {
            return $7KlbQ.Variant.getOptionValue(variant, "Pattern");
        }),
        toProductPrice: $2whNH.flatMap(variant, function(variant) {
            var price = variant.price;
            if (typeof price === "number") return;
            else if (price.TAG === /* Regular */ 0) return price._0;
            else return price._0.price;
        }),
        toProductSize: $2whNH.flatMap(variant, function(variant) {
            return $7KlbQ.Variant.getOptionValue(variant, "Size");
        }),
        toProductTitle: $2whNH.map(product, function(product) {
            return product.name;
        }),
        timeOnQuickNav: time,
        parentUrl: link,
        affiliation: $2gwg0.getShop(undefined),
        current_story: currentStory,
        story_title: storyTitle,
        partner_id: partnerId,
        account_id: accountId,
        breakpoint: breakpoint,
        isInline: isInline,
        isLauncher: isLauncher,
        isNavMenu: isNavMenu,
        navVersion: navVersion,
        isMiniPDPVisible: isMiniPDPVisible,
        non_interaction: $2whNH.map($$event, $gfHt9.isNonInteractive),
        mediaId: mediaId,
        mediaParentId: mediaParentId,
        mediaSrc: mediaSrc,
        mediaTitle: mediaTitle,
        relatedMediaCategoryId: relatedMediaCategoryId,
        relatedMediaProductIds: relatedMediaProductIds,
        url: url
    };
}
var $7fd7fdae034a86a6$export$98c61fe1bf2ebc47 = {
    make: $7fd7fdae034a86a6$var$make
};
 /* Env-Showside Not a pure module */ 
});
parcelRegister("7bjme", function(module, exports) {

$parcel$export(module.exports, "obj_dup", function () { return $53a893834dd90926$export$d8fa716a4e6e8723; });
$parcel$export(module.exports, "equal", function () { return $53a893834dd90926$export$411ce8e5a71e3069; });
$parcel$export(module.exports, "notequal", function () { return $53a893834dd90926$export$e3d9078e809a082f; });
$parcel$export(module.exports, "greaterequal", function () { return $53a893834dd90926$export$4fa9ef49e56dee0c; });
$parcel$export(module.exports, "greaterthan", function () { return $53a893834dd90926$export$2c5a6007921c641b; });
$parcel$export(module.exports, "lessthan", function () { return $53a893834dd90926$export$54a65104ebc207fc; });

var $gfRPo = parcelRequire("gfRPo");

var $81N94 = parcelRequire("81N94");
var $53a893834dd90926$var$for_in = function for_in(o, foo) {
    for(var x in o)foo(x);
};
var $53a893834dd90926$export$d8fa716a4e6e8723 = function obj_dup(x) {
    if (Array.isArray(x)) {
        var len = x.length;
        var v = new Array(len);
        for(var i = 0; i < len; ++i)v[i] = x[i];
        if (x.TAG !== undefined) v.TAG = x.TAG // TODO this can be removed eventually
        ;
        return v;
    }
    return Object.assign({}, x);
};
var $53a893834dd90926$export$41a7c804a30c74cd = function update_dummy(x, y) {
    var k;
    if (Array.isArray(y)) {
        for(k = 0; k < y.length; ++k)x[k] = y[k];
        if (y.TAG !== undefined) x.TAG = y.TAG;
    } else for(var k in y)x[k] = y[k];
};
function $53a893834dd90926$export$398604a469f7de9a(a, b) {
    if (a === b) return 0;
    var a_type = typeof a === "undefined" ? "undefined" : (0, $gfRPo._)(a);
    var b_type = typeof b === "undefined" ? "undefined" : (0, $gfRPo._)(b);
    switch(a_type){
        case "boolean":
            if (b_type === "boolean") return $81N94.bool_compare(a, b);
            break;
        case "function":
            if (b_type === "function") throw {
                RE_EXN_ID: "Invalid_argument",
                _1: "compare: functional value",
                Error: new Error()
            };
            break;
        case "number":
            if (b_type === "number") return $81N94.float_compare(a, b);
            break;
        case "string":
            if (b_type === "string") return $81N94.string_compare(a, b);
            else return 1;
        case "undefined":
            return -1;
        default:
    }
    switch(b_type){
        case "string":
            return -1;
        case "undefined":
            return 1;
        default:
            if (a_type === "boolean") return 1;
            if (b_type === "boolean") return -1;
            if (a_type === "function") return 1;
            if (b_type === "function") return -1;
            if (a_type === "number") {
                if (b === null || b.BS_PRIVATE_NESTED_SOME_NONE !== undefined) return 1;
                else return -1;
            }
            if (b_type === "number") {
                if (a === null || a.BS_PRIVATE_NESTED_SOME_NONE !== undefined) return -1;
                else return 1;
            }
            if (a === null) {
                if (b.BS_PRIVATE_NESTED_SOME_NONE !== undefined) return 1;
                else return -1;
            }
            if (b === null) {
                if (a.BS_PRIVATE_NESTED_SOME_NONE !== undefined) return -1;
                else return 1;
            }
            if (a.BS_PRIVATE_NESTED_SOME_NONE !== undefined) {
                if (b.BS_PRIVATE_NESTED_SOME_NONE !== undefined) return $53a893834dd90926$var$aux_obj_compare(a, b);
                else return -1;
            }
            var tag_a = a.TAG | 0;
            var tag_b = b.TAG | 0;
            if (tag_a === 248) return $81N94.int_compare(a[1], b[1]);
            if (tag_a === 251) throw {
                RE_EXN_ID: "Invalid_argument",
                _1: "equal: abstract value",
                Error: new Error()
            };
            if (tag_a !== tag_b) {
                if (tag_a < tag_b) return -1;
                else return 1;
            }
            var len_a = a.length | 0;
            var len_b = b.length | 0;
            if (len_a === len_b) {
                if (Array.isArray(a)) {
                    var _i = 0;
                    while(true){
                        var i = _i;
                        if (i === len_a) return 0;
                        var res = $53a893834dd90926$export$398604a469f7de9a(a[i], b[i]);
                        if (res !== 0) return res;
                        _i = i + 1 | 0;
                        continue;
                    }
                } else if (a instanceof Date && b instanceof Date) return a - b;
                else return $53a893834dd90926$var$aux_obj_compare(a, b);
            } else if (len_a < len_b) {
                var _i$1 = 0;
                while(true){
                    var i$1 = _i$1;
                    if (i$1 === len_a) return -1;
                    var res$1 = $53a893834dd90926$export$398604a469f7de9a(a[i$1], b[i$1]);
                    if (res$1 !== 0) return res$1;
                    _i$1 = i$1 + 1 | 0;
                    continue;
                }
            } else {
                var _i$2 = 0;
                while(true){
                    var i$2 = _i$2;
                    if (i$2 === len_b) return 1;
                    var res$2 = $53a893834dd90926$export$398604a469f7de9a(a[i$2], b[i$2]);
                    if (res$2 !== 0) return res$2;
                    _i$2 = i$2 + 1 | 0;
                    continue;
                }
            }
    }
}
function $53a893834dd90926$var$aux_obj_compare(a, b) {
    var min_key_lhs = {
        contents: undefined
    };
    var min_key_rhs = {
        contents: undefined
    };
    var do_key = function do_key(param, key) {
        var min_key = param[2];
        var _$b = param[1];
        if (!(!Object.prototype.hasOwnProperty.call(_$b, key) || $53a893834dd90926$export$398604a469f7de9a(param[0][key], _$b[key]) > 0)) return;
        var mk = min_key.contents;
        if (mk !== undefined && key >= mk) return;
        else {
            min_key.contents = key;
            return;
        }
    };
    var partial_arg = [
        a,
        b,
        min_key_rhs
    ];
    var do_key_a = function do_key_a(param) {
        return do_key(partial_arg, param);
    };
    var partial_arg$1 = [
        b,
        a,
        min_key_lhs
    ];
    var do_key_b = function do_key_b(param) {
        return do_key(partial_arg$1, param);
    };
    $53a893834dd90926$var$for_in(a, do_key_a);
    $53a893834dd90926$var$for_in(b, do_key_b);
    var match = min_key_lhs.contents;
    var match$1 = min_key_rhs.contents;
    if (match !== undefined) {
        if (match$1 !== undefined) return $81N94.string_compare(match, match$1);
        else return -1;
    } else if (match$1 !== undefined) return 1;
    else return 0;
}
function $53a893834dd90926$export$411ce8e5a71e3069(a, b) {
    if (a === b) return true;
    var a_type = typeof a === "undefined" ? "undefined" : (0, $gfRPo._)(a);
    if (a_type === "string" || a_type === "number" || a_type === "boolean" || a_type === "undefined" || a === null) return false;
    var b_type = typeof b === "undefined" ? "undefined" : (0, $gfRPo._)(b);
    if (a_type === "function" || b_type === "function") throw {
        RE_EXN_ID: "Invalid_argument",
        _1: "equal: functional value",
        Error: new Error()
    };
    if (b_type === "number" || b_type === "undefined" || b === null) return false;
    var tag_a = a.TAG | 0;
    var tag_b = b.TAG | 0;
    if (tag_a === 248) return a[1] === b[1];
    if (tag_a === 251) throw {
        RE_EXN_ID: "Invalid_argument",
        _1: "equal: abstract value",
        Error: new Error()
    };
    if (tag_a !== tag_b) return false;
    var len_a = a.length | 0;
    var len_b = b.length | 0;
    if (len_a === len_b) {
        if (Array.isArray(a)) {
            var _i = 0;
            while(true){
                var i = _i;
                if (i === len_a) return true;
                if (!$53a893834dd90926$export$411ce8e5a71e3069(a[i], b[i])) return false;
                _i = i + 1 | 0;
                continue;
            }
        } else if (a instanceof Date && b instanceof Date) return !(a > b || a < b);
        else {
            var result = {
                contents: true
            };
            var do_key_a = function do_key_a(key) {
                if (!Object.prototype.hasOwnProperty.call(b, key)) {
                    result.contents = false;
                    return;
                }
            };
            var do_key_b = function do_key_b(key) {
                if (!Object.prototype.hasOwnProperty.call(a, key) || !$53a893834dd90926$export$411ce8e5a71e3069(b[key], a[key])) {
                    result.contents = false;
                    return;
                }
            };
            $53a893834dd90926$var$for_in(a, do_key_a);
            if (result.contents) $53a893834dd90926$var$for_in(b, do_key_b);
            return result.contents;
        }
    } else return false;
}
function $53a893834dd90926$export$59e6990050957897(x, y) {
    if (y !== null) return $53a893834dd90926$export$411ce8e5a71e3069(x, y);
    else return x === y;
}
function $53a893834dd90926$export$f1ff0552b435f9a8(x, y) {
    if (y !== undefined) return $53a893834dd90926$export$411ce8e5a71e3069(x, y);
    else return x === y;
}
function $53a893834dd90926$export$82648b0ea8b9e17f(x, y) {
    if (y == null) return x === y;
    else return $53a893834dd90926$export$411ce8e5a71e3069(x, y);
}
function $53a893834dd90926$export$e3d9078e809a082f(a, b) {
    if (typeof a === "number" && typeof b === "number") return a !== b;
    else return !$53a893834dd90926$export$411ce8e5a71e3069(a, b);
}
function $53a893834dd90926$export$4fa9ef49e56dee0c(a, b) {
    if (typeof a === "number" && typeof b === "number") return a >= b;
    else return $53a893834dd90926$export$398604a469f7de9a(a, b) >= 0;
}
function $53a893834dd90926$export$2c5a6007921c641b(a, b) {
    if (typeof a === "number" && typeof b === "number") return a > b;
    else return $53a893834dd90926$export$398604a469f7de9a(a, b) > 0;
}
function $53a893834dd90926$export$8825358824a4a274(a, b) {
    if (typeof a === "number" && typeof b === "number") return a <= b;
    else return $53a893834dd90926$export$398604a469f7de9a(a, b) <= 0;
}
function $53a893834dd90926$export$54a65104ebc207fc(a, b) {
    if (typeof a === "number" && typeof b === "number") return a < b;
    else return $53a893834dd90926$export$398604a469f7de9a(a, b) < 0;
}
function $53a893834dd90926$export$96ec731ed4dcb222(x, y) {
    if ($53a893834dd90926$export$398604a469f7de9a(x, y) <= 0) return x;
    else return y;
}
function $53a893834dd90926$export$8960430cfd85939f(x, y) {
    if ($53a893834dd90926$export$398604a469f7de9a(x, y) >= 0) return x;
    else return y;
}
 /* No side effect */ 
});
parcelRegister("gfRPo", function(module, exports) {

$parcel$export(module.exports, "_type_of", function () { return $bd57cd2c3be44143$export$5f0017c582d45a2d; });
$parcel$export(module.exports, "_", function () { return $bd57cd2c3be44143$export$5f0017c582d45a2d; });
function $bd57cd2c3be44143$export$5f0017c582d45a2d(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}

});


parcelRegister("7KlbQ", function(module, exports) {

$parcel$export(module.exports, "Media", function () { return $5a3d443209c54fe4$export$7fc53215244aec38; });
$parcel$export(module.exports, "Metadata", function () { return $5a3d443209c54fe4$export$e7adebdc1ebd2fed; });
$parcel$export(module.exports, "Variant", function () { return $5a3d443209c54fe4$export$585dc7a4228aacca; });
$parcel$export(module.exports, "getProductById", function () { return $5a3d443209c54fe4$export$5db19e0f3922ef0f; });
$parcel$export(module.exports, "getVideoSource", function () { return $5a3d443209c54fe4$export$62783612bf83e9a5; });
$parcel$export(module.exports, "getVariantById", function () { return $5a3d443209c54fe4$export$d48e1aa14fa1dc00; });
$parcel$export(module.exports, "getAllVariants", function () { return $5a3d443209c54fe4$export$f9abbd7546031f08; });
$parcel$export(module.exports, "getAllVariantsWithPriority", function () { return $5a3d443209c54fe4$export$c9267a596b900af2; });
$parcel$export(module.exports, "getVariantBySelector", function () { return $5a3d443209c54fe4$export$25c71e859aead278; });
$parcel$export(module.exports, "getValidProductImages", function () { return $5a3d443209c54fe4$export$a52834f13bd29c6; });
$parcel$export(module.exports, "getDisplaySwatchImage", function () { return $5a3d443209c54fe4$export$73d101e96c830bb1; });
$parcel$export(module.exports, "zipTaggedProducts", function () { return $5a3d443209c54fe4$export$6e855fd31183132a; });
$parcel$export(module.exports, "getVariantsByOptionName", function () { return $5a3d443209c54fe4$export$185e7fd2150576e3; });
$parcel$export(module.exports, "keepVariants", function () { return $5a3d443209c54fe4$export$f91ec76af9e09c08; });
$parcel$export(module.exports, "getVariantsByOptionValue", function () { return $5a3d443209c54fe4$export$99742a092e6c0f87; });
$parcel$export(module.exports, "getVariantsByOptionNames", function () { return $5a3d443209c54fe4$export$86e6d9925aa28586; });
$parcel$export(module.exports, "getOptionsByName", function () { return $5a3d443209c54fe4$export$eecbff93d5cdbc8; });
$parcel$export(module.exports, "getAllVariantMedia", function () { return $5a3d443209c54fe4$export$33c2a29c22a32a68; });
$parcel$export(module.exports, "getDisplayProductCardMedia", function () { return $5a3d443209c54fe4$export$8ba76842a51b6a6a; });
$parcel$export(module.exports, "getDisplayName", function () { return $5a3d443209c54fe4$export$be63e0664592e141; });
$parcel$export(module.exports, "getInitialDisplayVariant", function () { return $5a3d443209c54fe4$export$b256f5e2beb12ea8; });
$parcel$export(module.exports, "expandVariantsByOptionNames", function () { return $5a3d443209c54fe4$export$7100e8c4f210baa1; });
$parcel$export(module.exports, "isOutOfStock", function () { return $5a3d443209c54fe4$export$61eb0e7a3d17fad5; });
$parcel$export(module.exports, "isInStock", function () { return $5a3d443209c54fe4$export$962dd12abd78c2e6; });
$parcel$export(module.exports, "toLegacyDTO", function () { return $5a3d443209c54fe4$export$29e26ac2c5f9bfdc; });
$parcel$export(module.exports, "tryParseFromDTO", function () { return $5a3d443209c54fe4$export$3cfe0de6793961ae; });
$parcel$export(module.exports, "getKey", function () { return $5a3d443209c54fe4$export$a47fb462a08de82f; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $d3YYW = parcelRequire("d3YYW");

var $7bjme = parcelRequire("7bjme");

var $69lAE = parcelRequire("69lAE");

var $8ncuc = parcelRequire("8ncuc");

var $i7mYY = parcelRequire("i7mYY");

var $2Ng4w = parcelRequire("2Ng4w");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $3tOK1 = parcelRequire("3tOK1");

var $hG39s = parcelRequire("hG39s");

var $gwEzd = parcelRequire("gwEzd");

var $bygWp = parcelRequire("bygWp");

var $8dLtV = parcelRequire("8dLtV");

var $eFryz = parcelRequire("eFryz");

var $8L1B1 = parcelRequire("8L1B1");

var $7Uv7n = parcelRequire("7Uv7n");

var $6jWwC = parcelRequire("6jWwC");
var $5a3d443209c54fe4$var$Media = {};
var $5a3d443209c54fe4$var$Variant = {};
var $5a3d443209c54fe4$export$4624c240901a6889 = {
    Media: $5a3d443209c54fe4$var$Media,
    Variant: $5a3d443209c54fe4$var$Variant
};
function $5a3d443209c54fe4$export$8d539b6bc182bbf5(__x) {
    return $2whNH.getWithDefault(__x, "");
}
function $5a3d443209c54fe4$export$b42e70ddca33ff5b(str) {
    if (str === "") return;
    else return str;
}
function $5a3d443209c54fe4$export$4b82e3b4bea91870(str) {
    if ($7bjme.notequal(str, "")) return str !== undefined;
    else return false;
}
function $5a3d443209c54fe4$var$newProductById(products, id) {
    return $i7mYY.getBy(products, function(product) {
        return $iv6Yc._1($hG39s.ProductId.toString, product.id) === id;
    });
}
var $5a3d443209c54fe4$export$ef82a0f75c4e1f89 = {
    newProductById: $5a3d443209c54fe4$var$newProductById
};
function $5a3d443209c54fe4$var$getImageUrl(media) {
    switch(media.TAG | 0){
        case /* Image */ 0:
            return media._0.url;
        case /* Video */ 1:
        case /* IframeEmbed */ 2:
            return;
    }
}
function $5a3d443209c54fe4$var$getImageSize(media) {
    switch(media.TAG | 0){
        case /* Image */ 0:
            var match = media._0;
            return [
                match.width,
                match.height
            ];
        case /* Video */ 1:
        case /* IframeEmbed */ 2:
            return [
                undefined,
                undefined
            ];
    }
}
function $5a3d443209c54fe4$var$getImageUrlWithPosterFallback(media) {
    switch(media.TAG | 0){
        case /* Image */ 0:
            return media._0.url;
        case /* Video */ 1:
            return media._0.posterUrl;
        case /* IframeEmbed */ 2:
            return;
    }
}
function $5a3d443209c54fe4$var$getImageSizeWithPosterFallback(media) {
    switch(media.TAG | 0){
        case /* Image */ 0:
            var match = media._0;
            return [
                match.width,
                match.height
            ];
        case /* Video */ 1:
            return $2whNH.map($i7mYY.get(media._0.sources, 0), function(source) {
                return [
                    source.width,
                    source.height
                ];
            });
        case /* IframeEmbed */ 2:
            return;
    }
}
function $5a3d443209c54fe4$var$getVideoSource(video) {
    var src = $i7mYY.getBy(video.sources, function(source) {
        return source.mimeType === "application/x-mpegURL";
    });
    var src$1 = src !== undefined ? src : $i7mYY.getBy(video.sources, function(source) {
        return source.mimeType === "video/mp4";
    });
    if (src$1 !== undefined) return src$1;
    else return $i7mYY.get(video.sources, 0);
}
var $5a3d443209c54fe4$var$resolveVideoUrls = $3tOK1.mem(function(media) {
    return $i7mYY.reduceWithIndex($i7mYY.map(media, function(mediaItem) {
        if (mediaItem.TAG === /* TypeImage */ 0) return $2whNH.getWithDefault($2whNH.map($2whNH.flatMap(mediaItem._0.url, function(url) {
            return $2whNH.map($bygWp.getEstimatedVideoMimeFromUrl(url), function(mimeType) {
                return [
                    url,
                    mimeType
                ];
            });
        }), function(param) {
            return {
                TAG: /* TypeVideo */ 1,
                _0: {
                    poster: undefined,
                    sources: [
                        {
                            mimeType: param[1],
                            size: [
                                0,
                                0
                            ],
                            url: param[0]
                        }
                    ]
                }
            };
        }), mediaItem);
        else return mediaItem;
    }), [], function(acc, curr, i) {
        var next;
        if (curr.TAG === /* TypeImage */ 0) next = curr;
        else {
            var data = curr._0;
            var poster = data.poster;
            var poster$1 = poster !== undefined ? poster : $2whNH.map($i7mYY.get($i7mYY.keepMap(acc, function(media) {
                if (media.TAG === /* TypeImage */ 0) return media._0;
            }), 0), function(source) {
                return source.url;
            });
            next = {
                TAG: /* TypeVideo */ 1,
                _0: {
                    poster: poster$1,
                    sources: data.sources
                }
            };
        }
        return $i7mYY.concat(acc, [
            next
        ]);
    });
});
function $5a3d443209c54fe4$var$getVideoUrl(media) {
    switch(media.TAG | 0){
        case /* Video */ 1:
            return $2whNH.map($5a3d443209c54fe4$var$getVideoSource(media._0), function(videoSource) {
                return videoSource.url;
            });
        case /* Image */ 0:
        case /* IframeEmbed */ 2:
            return;
    }
}
function $5a3d443209c54fe4$var$getImage(media) {
    switch(media.TAG | 0){
        case /* Image */ 0:
            return media._0;
        case /* Video */ 1:
            var match = media._0;
            var posterUrl = match.posterUrl;
            return $2whNH.flatMap($i7mYY.get(match.sources, 0), function(source) {
                return $2whNH.map(posterUrl, function(url) {
                    return {
                        url: url,
                        width: source.width,
                        height: source.height
                    };
                });
            });
        case /* IframeEmbed */ 2:
            return;
    }
}
function $5a3d443209c54fe4$var$fromDTO(dto) {
    if (dto.TAG === /* TypeImage */ 0) {
        var data = dto._0;
        var match = $2whNH.getWithDefault(data.size, [
            0,
            0
        ]);
        return {
            TAG: /* Image */ 0,
            _0: {
                url: data.url,
                width: match[0],
                height: match[1]
            }
        };
    }
    var data$1 = dto._0;
    return {
        TAG: /* Video */ 1,
        _0: {
            posterUrl: data$1.poster,
            sources: data$1.sources.map(function(source) {
                var match = source.size;
                return {
                    url: source.url,
                    width: match[0],
                    height: match[1],
                    mimeType: source.mimeType
                };
            })
        }
    };
}
var $5a3d443209c54fe4$var$resolveIframeEmbedUrls = $3tOK1.mem(function(media) {
    return $i7mYY.map(media, function(mediaItem) {
        switch(mediaItem.TAG | 0){
            case /* Image */ 0:
                var url = mediaItem._0.url;
                if ($i7mYY.some(Object.keys($8dLtV.knownEmbeds), function(known) {
                    return url.startsWith(known);
                })) return {
                    TAG: /* IframeEmbed */ 2,
                    _0: {
                        url: url
                    }
                };
                else return mediaItem;
            case /* Video */ 1:
            case /* IframeEmbed */ 2:
                return mediaItem;
        }
    });
});
function $5a3d443209c54fe4$var$fromDTOArray(dto) {
    return $iv6Yc._1($5a3d443209c54fe4$var$resolveIframeEmbedUrls, $i7mYY.map($iv6Yc._1($5a3d443209c54fe4$var$resolveVideoUrls, dto), $5a3d443209c54fe4$var$fromDTO));
}
var $5a3d443209c54fe4$export$7fc53215244aec38 = {
    getImageUrl: $5a3d443209c54fe4$var$getImageUrl,
    getImageSize: $5a3d443209c54fe4$var$getImageSize,
    getImageUrlWithPosterFallback: $5a3d443209c54fe4$var$getImageUrlWithPosterFallback,
    getImageSizeWithPosterFallback: $5a3d443209c54fe4$var$getImageSizeWithPosterFallback,
    getVideoSource: $5a3d443209c54fe4$var$getVideoSource,
    resolveVideoUrls: $5a3d443209c54fe4$var$resolveVideoUrls,
    getVideoUrl: $5a3d443209c54fe4$var$getVideoUrl,
    getImage: $5a3d443209c54fe4$var$getImage,
    fromDTO: $5a3d443209c54fe4$var$fromDTO,
    resolveIframeEmbedUrls: $5a3d443209c54fe4$var$resolveIframeEmbedUrls,
    fromDTOArray: $5a3d443209c54fe4$var$fromDTOArray
};
function $5a3d443209c54fe4$var$isEmpty(text) {
    if (text.trim() === "") return true;
    else return /^[^\w]$/.test(text);
}
function $5a3d443209c54fe4$var$isEmptyList(list) {
    if ($i7mYY.every(list, $5a3d443209c54fe4$var$isEmpty)) return true;
    else return list.length === 0;
}
function $5a3d443209c54fe4$var$toString(metadata) {
    var exit = 0;
    if (typeof metadata === "number") return;
    switch(metadata.TAG | 0){
        case /* DecimalField */ 2:
        case /* IntegerField */ 3:
            return metadata._0.toString();
        case /* Boolean */ 8:
            return $2Ng4w.string_of_bool(metadata._0);
        case /* Json */ 9:
            return JSON.stringify(metadata._0);
        case /* Money */ 10:
            var money = metadata._0;
            return $2whNH.mapWithDefault($gwEzd.parse(money.currencyCode + money.amount), "", $gwEzd.format);
        case /* Dimension */ 4:
        case /* Volume */ 11:
        case /* Weight */ 12:
            exit = 2;
            break;
        case /* MultiLineTextField */ 0:
        case /* SingleLineTextField */ 1:
        case /* Date */ 5:
        case /* DateTime */ 6:
        case /* Color */ 7:
        case /* Url */ 13:
        case /* Rating */ 14:
            exit = 1;
            break;
        case /* FileReference */ 15:
            var fileType = metadata._0;
            var tmp;
            tmp = fileType.TAG === /* TypeImage */ 0 ? fileType._0.url : $2whNH.getWithDefault(fileType._0.poster, "");
            return tmp;
        case /* Audio */ 16:
            return metadata._0.contentUrl;
        default:
            return;
    }
    switch(exit){
        case 1:
            var string = metadata._0;
            if (!$5a3d443209c54fe4$var$isEmpty(string)) return string;
            else return;
        case 2:
            var physicalQuantity = metadata._0;
            return physicalQuantity.value.toString() + " " + physicalQuantity.unitName;
    }
}
function $5a3d443209c54fe4$var$getFieldWithPreprocess(metadata, field) {
    var preprocess = function preprocess(value) {
        var brightonParsed = $6jWwC.parseMetadata(field, value);
        if (brightonParsed !== undefined) return brightonParsed;
        else return value;
    };
    return $2whNH.map($d3YYW.get(metadata, field), preprocess);
}
function $5a3d443209c54fe4$var$getMetadata(product, variant) {
    var variantMetadata = variant.metadata;
    var productMetadata = product.metadata;
    return $d3YYW.fromArray($i7mYY.concat($d3YYW.entries(productMetadata), $d3YYW.entries(variantMetadata)));
}
function $5a3d443209c54fe4$var$getMetadataValue(product, variant, field) {
    return $5a3d443209c54fe4$var$getFieldWithPreprocess($5a3d443209c54fe4$var$getMetadata(product, variant), field);
}
function $5a3d443209c54fe4$var$getMetadataAsText(product, variant, field) {
    return $2whNH.flatMap($5a3d443209c54fe4$var$getMetadataValue(product, variant, field), $5a3d443209c54fe4$var$toString);
}
var $5a3d443209c54fe4$export$e7adebdc1ebd2fed = {
    isEmpty: $5a3d443209c54fe4$var$isEmpty,
    isEmptyList: $5a3d443209c54fe4$var$isEmptyList,
    toString: $5a3d443209c54fe4$var$toString,
    getFieldWithPreprocess: $5a3d443209c54fe4$var$getFieldWithPreprocess,
    getMetadata: $5a3d443209c54fe4$var$getMetadata,
    getMetadataValue: $5a3d443209c54fe4$var$getMetadataValue,
    getMetadataAsText: $5a3d443209c54fe4$var$getMetadataAsText
};
function $5a3d443209c54fe4$var$getAllOptionValues(variant) {
    return $i7mYY.map($d3YYW.values(variant.options), function(option) {
        return option.value;
    });
}
function $5a3d443209c54fe4$var$getOptionValue(variant, optionName) {
    return $2whNH.map($d3YYW.get(variant.options, optionName), function(option) {
        return option.value;
    });
}
function $5a3d443209c54fe4$var$getQuantity(variant) {
    var quantity = variant.availability;
    if (quantity) return quantity._0;
    else return 0;
}
function $5a3d443209c54fe4$var$findAtPosition(array, position) {
    return $loT9g.undefined_to_opt(array.find(function(param, index) {
        return index === position;
    }));
}
function $5a3d443209c54fe4$var$getVariantPrices(variant) {
    var price = variant.price;
    if (typeof price === "number") return [
        "",
        undefined
    ];
    if (price.TAG === /* Regular */ 0) return [
        price._0,
        undefined
    ];
    var match = price._0;
    return [
        match.regularPrice,
        match.price
    ];
}
function $5a3d443209c54fe4$var$getRealProductPurchasePrice(variant) {
    var match = $5a3d443209c54fe4$var$getVariantPrices(variant);
    var price = $2whNH.map($gwEzd.parse(match[0]), function(price) {
        return price.value;
    });
    var salePrice = $2whNH.map($2whNH.flatMap(match[1], $gwEzd.parse), function(price) {
        return price.value;
    });
    if (price !== undefined) {
        if (salePrice !== undefined && price >= salePrice) return salePrice;
        else return price;
    } else if (salePrice !== undefined) return salePrice;
    else return 0.0;
}
function $5a3d443209c54fe4$var$getDiscountedPercentage(variant) {
    var match = $5a3d443209c54fe4$var$getVariantPrices(variant);
    var price = $2whNH.map($gwEzd.parse(match[0]), function(price) {
        return price.value;
    });
    var salePrice = $2whNH.map($2whNH.flatMap(match[1], $gwEzd.parse), function(price) {
        return price.value;
    });
    if (price === undefined) return 0.0;
    if (salePrice === undefined) return 0.0;
    var lowestPrice = price < salePrice ? price : salePrice;
    var highestPrice = price > salePrice ? price : salePrice;
    var savings = highestPrice - lowestPrice;
    return savings / price * 100;
}
function $5a3d443209c54fe4$var$tryParseMedia(dto, mediaList) {
    var mediaIndex = $2whNH.getWithDefault(dto.mediaIndex, 0);
    var media = $5a3d443209c54fe4$var$findAtPosition($5a3d443209c54fe4$var$fromDTOArray(mediaList), mediaIndex);
    if (media !== undefined) return media;
    else return {
        TAG: /* Image */ 0,
        _0: {
            url: "",
            width: 0,
            height: 0
        }
    };
}
function $5a3d443209c54fe4$var$tryParseOtherMedia(dto, mediaList) {
    return $5a3d443209c54fe4$var$fromDTOArray($i7mYY.keepMap($i7mYY.map($2whNH.getWithDefault(dto.mediaIndexesSourcedFromVariant, []), function(param) {
        return $i7mYY.get(mediaList, param);
    }), function(a) {
        return a;
    }));
}
function $5a3d443209c54fe4$var$tryParsePrice(dto, currency) {
    var withCurrency = function withCurrency(s) {
        return "" + s + "" + $2whNH.mapWithDefault(currency, "", function(currency) {
            return " " + currency + "";
        }) + "";
    };
    var price = dto.price;
    var compareAtPrice = dto.compareAtPrice;
    if (compareAtPrice !== undefined) {
        if (price !== undefined) return {
            TAG: /* Promotional */ 1,
            _0: {
                price: withCurrency(price),
                regularPrice: withCurrency(compareAtPrice)
            }
        };
        else return /* NoPrice */ 0;
    } else if (price !== undefined) return {
        TAG: /* Regular */ 0,
        _0: withCurrency(price)
    };
    else return /* NoPrice */ 0;
}
function $5a3d443209c54fe4$var$getVariantOptions(dto, options) {
    return $d3YYW.fromArray($i7mYY.keepMap($i7mYY.keepMap($i7mYY.mapWithIndex([
        dto.option1,
        dto.option2,
        dto.option3
    ], function(index, value) {
        return $2whNH.map(value, function(value) {
            return [
                index,
                value
            ];
        });
    }), function(a) {
        return a;
    }), function(param) {
        var findByOptionValue = param[1];
        var findByOptionIndex = param[0];
        var matchingOption = $i7mYY.get($i7mYY.keepWithIndex(options, function(option, index) {
            return $i7mYY.some(option.values, function(value) {
                if (value === findByOptionValue) return index === findByOptionIndex;
                else return false;
            });
        }), 0);
        if (matchingOption === undefined) return;
        var name = matchingOption.name;
        return [
            name,
            {
                id: matchingOption.id,
                name: name,
                value: findByOptionValue
            }
        ];
    }));
}
function $5a3d443209c54fe4$var$tryParseFromDTO(dto, currency, mediaList, options) {
    var quantity = dto.inventory.quantity;
    var quantity$1 = $2whNH.getWithDefault(quantity, 0);
    var availability = quantity$1 > 0 ? /* InStock */ {
        _0: quantity$1
    } : /* OutOfStock */ 0;
    return {
        name: dto.name,
        description: dto.description,
        id: dto.id,
        price: $5a3d443209c54fe4$var$tryParsePrice(dto, currency),
        availability: availability,
        inventory: quantity$1,
        media: $5a3d443209c54fe4$var$tryParseMedia(dto, mediaList),
        otherMedia: $5a3d443209c54fe4$var$tryParseOtherMedia(dto, mediaList),
        link: dto.link,
        promotionalText: dto.promoText,
        mpn: dto.mpn,
        sku: dto.sku,
        brand: dto.brand,
        customLabels: dto.customLabels.map($5a3d443209c54fe4$export$8d539b6bc182bbf5),
        options: $5a3d443209c54fe4$var$getVariantOptions(dto, options),
        metadata: dto.metadata
    };
}
function $5a3d443209c54fe4$var$matchesFilter(variant, options, filters) {
    var variantFacets = $i7mYY.concat($i7mYY.map($d3YYW.entries(options), function(param) {
        return param[0].toLowerCase() + "=" + param[1].value;
    }), $i7mYY.concatMany($i7mYY.map($d3YYW.entries(variant.metadata), function(param) {
        var key = param[0];
        return $i7mYY.map($i7mYY.map($2whNH.mapWithDefault($5a3d443209c54fe4$var$toString(param[1]), [], function(__x) {
            return __x.split(",");
        }), function(prim) {
            return prim.trim();
        }), function(value) {
            return "metadata::" + key + "=" + value;
        });
    })));
    var filterFacets = $2whNH.keep($2whNH.map(filters, function(f) {
        return $i7mYY.keepMap(f.entries, function(f) {
            var match = f.facet.split("=");
            if (match.length !== 2) return;
            var facet = match[0];
            if (facet === "color" || facet === "size" || facet === "material" || facet === "pattern" || facet === "style" || facet.startsWith("metadata::")) return f.facet;
        });
    }), function(f) {
        return f.length !== 0;
    });
    if (filterFacets !== undefined) return variantFacets.some(function(facet) {
        return filterFacets.includes(facet);
    });
    else return true;
}
var $5a3d443209c54fe4$export$585dc7a4228aacca = {
    getAllOptionValues: $5a3d443209c54fe4$var$getAllOptionValues,
    getOptionValue: $5a3d443209c54fe4$var$getOptionValue,
    getQuantity: $5a3d443209c54fe4$var$getQuantity,
    findAtPosition: $5a3d443209c54fe4$var$findAtPosition,
    getVariantPrices: $5a3d443209c54fe4$var$getVariantPrices,
    getRealProductPurchasePrice: $5a3d443209c54fe4$var$getRealProductPurchasePrice,
    getDiscountedPercentage: $5a3d443209c54fe4$var$getDiscountedPercentage,
    tryParseMedia: $5a3d443209c54fe4$var$tryParseMedia,
    tryParseOtherMedia: $5a3d443209c54fe4$var$tryParseOtherMedia,
    tryParsePrice: $5a3d443209c54fe4$var$tryParsePrice,
    getVariantOptions: $5a3d443209c54fe4$var$getVariantOptions,
    tryParseFromDTO: $5a3d443209c54fe4$var$tryParseFromDTO,
    matchesFilter: $5a3d443209c54fe4$var$matchesFilter
};
function $5a3d443209c54fe4$export$ca122b95797c31ac(variants) {
    var orderedSets = [
        [
            "XXS",
            "XXS-XS",
            "2XS-XS",
            "XXS/XS",
            "2XS/XS",
            "XS",
            "XS-S",
            "XS/S",
            "S",
            "S-M",
            "S/M",
            "M",
            "M-L",
            "M/L",
            "L",
            "L-XL",
            "L/XL",
            "XL",
            "XL-XXL",
            "XL-2XL",
            "XL/XXL",
            "XL/2XL",
            "XXL",
            "2XL",
            "XXL-XXXL",
            "2XL-3XL",
            "XXL/XXXL",
            "2XL/3XL",
            "XXXL",
            "3XL",
            "XXXL-XXXXL",
            "3XL-4XL",
            "XXXL/XXXXL",
            "3XL/4XL",
            "XXXXL",
            "4XL",
            "XXXXL-XXXXXL",
            "4XL-5XL",
            "XXXXL/XXXXXL",
            "4XL/5XL",
            "XXXXXL",
            "5XL",
            "6XL",
            "7XL",
            "Free Size",
            "One Size"
        ],
        [
            "xxs",
            "xs",
            "s",
            "m",
            "l",
            "xl",
            "xxl",
            "2xl",
            "xxxl",
            "3xl",
            "xxxxl",
            "4xl",
            "xxxxxl",
            "5xl",
            "6xl",
            "7xl"
        ],
        [
            "xxs",
            "xs",
            "s",
            "m",
            "l",
            "xl",
            "xxl",
            "xxxl",
            "xxxxl",
            "xxxxxl"
        ],
        [
            "small",
            "medium",
            "large",
            "extra large",
            "extra extra large"
        ],
        [
            "Small",
            "Medium",
            "Large",
            "X-Large",
            "2X-Large",
            "3X-Large",
            "4X-Large"
        ],
        [
            "P",
            "1",
            "2",
            "3",
            "4",
            "5",
            "6",
            "7",
            "8",
            "9",
            "10",
            "11",
            "12",
            "13",
            "14"
        ],
        [
            "Single",
            "Queen",
            "King"
        ],
        [
            "XXS / .",
            "XS / .",
            "S / .",
            "M / .",
            "L / .",
            "XL / .",
            "XXL / ."
        ]
    ];
    return $69lAE.sortInPlaceWith(function(a, b) {
        var set = $i7mYY.getBy(orderedSets, function(set) {
            var foundA = $i7mYY.some(set, function(value) {
                return value === a;
            });
            var foundB = $i7mYY.some(set, function(value) {
                return value === b;
            });
            if (foundA) return foundB;
            else return false;
        });
        if (set === undefined) return $7Uv7n.compare(a, b);
        var indexA = $2whNH.getWithDefault($i7mYY.getIndexBy(set, function(value) {
            return value === a;
        }), 0);
        var indexB = $2whNH.getWithDefault($i7mYY.getIndexBy(set, function(value) {
            return value === b;
        }), 0);
        return indexA - indexB | 0;
    }, variants);
}
function $5a3d443209c54fe4$export$5db19e0f3922ef0f(products, id) {
    return $loT9g.undefined_to_opt(products.find(function(product) {
        return product.id === id;
    }));
}
function $5a3d443209c54fe4$export$62783612bf83e9a5(video) {
    var src = $i7mYY.getBy(video.sources, function(source) {
        return source.mimeType === "application/x-mpegURL";
    });
    var src$1 = src !== undefined ? src : $i7mYY.getBy(video.sources, function(source) {
        return source.mimeType === "video/mp4";
    });
    if (src$1 !== undefined) return src$1;
    else return $i7mYY.get(video.sources, 0);
}
function $5a3d443209c54fe4$export$d48e1aa14fa1dc00(product, variantId) {
    return $loT9g.undefined_to_opt([
        product.firstVariant
    ].concat(product.otherVariants).find(function(v) {
        return v.id === variantId;
    }));
}
function $5a3d443209c54fe4$export$f9abbd7546031f08(prod) {
    return [
        prod.firstVariant
    ].concat(prod.otherVariants);
}
function $5a3d443209c54fe4$export$cdc07e1899485156(array, match) {
    var nextIndex = $2whNH.getWithDefault($i7mYY.getIndexBy(array, $iv6Yc.__1(match)), 0);
    return $i7mYY.concat($i7mYY.sliceToEnd(array, nextIndex), $i7mYY.slice(array, 0, nextIndex));
}
function $5a3d443209c54fe4$export$c9267a596b900af2(prioritizedVariantId, prod) {
    return $5a3d443209c54fe4$export$cdc07e1899485156($5a3d443209c54fe4$export$f9abbd7546031f08(prod), function(variant) {
        return $7bjme.equal(prioritizedVariantId, variant.id);
    });
}
function $5a3d443209c54fe4$export$25c71e859aead278(product, selector) {
    var variants = $i7mYY.keep($5a3d443209c54fe4$export$f9abbd7546031f08(product), function(variants) {
        return variants.availability !== /* OutOfStock */ 0;
    });
    var tmp;
    switch(selector){
        case /* FirstVariant */ 0:
            tmp = $i7mYY.get(variants, 0);
            break;
        case /* HighestPriceVariant */ 1:
            tmp = $i7mYY.get(variants.sort(function(a, b) {
                var priceA = $5a3d443209c54fe4$var$getRealProductPurchasePrice(a);
                var priceB = $5a3d443209c54fe4$var$getRealProductPurchasePrice(b);
                if (priceA === priceB) return 0;
                else if (priceA > priceB) return -1;
                else return 1;
            }), 0);
            break;
        case /* LowestPriceVariant */ 2:
            tmp = $i7mYY.get(variants.sort(function(a, b) {
                var priceA = $5a3d443209c54fe4$var$getRealProductPurchasePrice(a);
                var priceB = $5a3d443209c54fe4$var$getRealProductPurchasePrice(b);
                if (priceA === priceB) return 0;
                else if (priceA > priceB) return 1;
                else return -1;
            }), 0);
            break;
        case /* HighestDiscountVariant */ 3:
            tmp = $i7mYY.get(variants.sort(function(a, b) {
                var discountA = $5a3d443209c54fe4$var$getDiscountedPercentage(a);
                var discountB = $5a3d443209c54fe4$var$getDiscountedPercentage(b);
                if (discountA === discountB) return 0;
                else if (discountA > discountB) return -1;
                else return 1;
            }), 0);
            break;
    }
    return $2whNH.getWithDefault(tmp, product.firstVariant);
}
function $5a3d443209c54fe4$export$a52834f13bd29c6(product) {
    var isImageBigEnough = function isImageBigEnough(image) {
        var height = image.height;
        var width = image.width;
        if (width === 0 && height === 0) return true;
        else if (width > 40) return height > 40;
        else return false;
    };
    return $i7mYY.keepMap(product.allMedia, function(item) {
        switch(item.TAG | 0){
            case /* Image */ 0:
                var image = item._0;
                if (isImageBigEnough(image)) return image.url;
                else return;
            case /* Video */ 1:
                return item._0.posterUrl;
            case /* IframeEmbed */ 2:
                return;
        }
    });
}
function $5a3d443209c54fe4$export$73d101e96c830bb1(product, variant) {
    var brightonCustomSwatch = $6jWwC.getDisplaySwatchImage($5a3d443209c54fe4$var$getMetadata(product, variant), variant.sku);
    if (brightonCustomSwatch !== undefined) return brightonCustomSwatch;
    else return $2whNH.getWithDefault($5a3d443209c54fe4$var$getImageUrlWithPosterFallback(variant.media), "");
}
function $5a3d443209c54fe4$export$6e855fd31183132a(products, taggedBy) {
    return $i7mYY.keepMap($i7mYY.map(taggedBy, function(tag) {
        var pairWithProduct = $i7mYY.getBy(products, function(product) {
            return product.id === tag.productId;
        });
        if (pairWithProduct !== undefined) return [
            tag,
            pairWithProduct
        ];
    }), function(p) {
        return p;
    });
}
function $5a3d443209c54fe4$export$185e7fd2150576e3(product, optionName) {
    var allVariants = [
        product.firstVariant
    ].concat(product.otherVariants);
    return $i7mYY.keep(allVariants, function(variant) {
        return $i7mYY.some($i7mYY.map($d3YYW.entries(variant.options), function(param) {
            return param[1].value;
        }), function(vo) {
            return optionName === vo;
        });
    });
}
function $5a3d443209c54fe4$export$883d4a9b619ff37e(inStockOpt, variants, optionValues) {
    var inStock = inStockOpt !== undefined ? inStockOpt : true;
    return $i7mYY.keep(variants, function(v) {
        if (v.availability !== /* OutOfStock */ 0 || !inStock) return $i7mYY.some($5a3d443209c54fe4$var$getAllOptionValues(v), function(value) {
            return optionValues.includes(value);
        });
        else return false;
    });
}
function $5a3d443209c54fe4$export$f91ec76af9e09c08(product, matchesFilter) {
    var updatedVariants = $i7mYY.keep($i7mYY.concat([
        product.firstVariant
    ], product.otherVariants), matchesFilter);
    return {
        id: product.id,
        productType: product.productType,
        categoryId: product.categoryId,
        name: product.name,
        description: product.description,
        currency: product.currency,
        link: product.link,
        reviewSummary: product.reviewSummary,
        promotionalText: product.promotionalText,
        allMedia: product.allMedia,
        firstVariant: $2whNH.getWithDefault($i7mYY.get(updatedVariants, 0), product.firstVariant),
        otherVariants: $i7mYY.slice(updatedVariants, 1, product.otherVariants.length),
        tags: product.tags,
        metadata: product.metadata,
        options: product.options,
        storeId: product.storeId
    };
}
function $5a3d443209c54fe4$export$99742a092e6c0f87(inStockOpt, product, optionValue) {
    var inStock = inStockOpt !== undefined ? inStockOpt : true;
    return $5a3d443209c54fe4$export$883d4a9b619ff37e(inStock, $5a3d443209c54fe4$export$f9abbd7546031f08(product), [
        optionValue
    ]);
}
function $5a3d443209c54fe4$export$86e6d9925aa28586(strictOpt, product, options) {
    var strict = strictOpt !== undefined ? strictOpt : false;
    var findBy = function findBy(fn) {
        return $i7mYY.keep($5a3d443209c54fe4$export$f9abbd7546031f08(product), function(variant) {
            return $iv6Yc._1(fn, $d3YYW.values(variant.options));
        });
    };
    var match = function match(param) {
        var vo = param.value;
        var vn = param.name;
        return $i7mYY.some(options, function(param) {
            if (param.value === vo) return param.name === vn;
            else return false;
        });
    };
    if (strict) return findBy(function(__x) {
        return $i7mYY.every(__x, match);
    });
    else return $i7mYY.concat(findBy(function(__x) {
        return $i7mYY.every(__x, match);
    }), findBy(function(__x) {
        return $i7mYY.some(__x, match);
    }));
}
function $5a3d443209c54fe4$export$eecbff93d5cdbc8(product, optionName) {
    return $2whNH.getWithDefault($d3YYW.get(product.options, optionName), []);
}
function $5a3d443209c54fe4$export$33c2a29c22a32a68(hideMediaFromOtherVariants, product, variant) {
    var match = variant.otherMedia;
    if (hideMediaFromOtherVariants && match.length !== 0) return match;
    return $5a3d443209c54fe4$export$cdc07e1899485156(product.allMedia, function(media) {
        return $7bjme.equal(media, variant.media);
    });
}
function $5a3d443209c54fe4$export$8ba76842a51b6a6a(hideMediaFromOtherVariants, product, variant) {
    var isEqual = function isEqual(mediaA, mediaB) {
        if ($7bjme.equal($5a3d443209c54fe4$var$getImageUrlWithPosterFallback(mediaA), $5a3d443209c54fe4$var$getImageUrlWithPosterFallback(mediaB))) return $7bjme.equal($5a3d443209c54fe4$var$getVideoUrl(mediaA), $5a3d443209c54fe4$var$getVideoUrl(mediaB));
        else return false;
    };
    var allVariantMedia = variant !== undefined ? $5a3d443209c54fe4$export$33c2a29c22a32a68(hideMediaFromOtherVariants, product, variant) : [];
    var mediaIndex;
    if (variant !== undefined) {
        var partial_arg = variant.media;
        mediaIndex = $2whNH.getWithDefault($i7mYY.getIndexBy(allVariantMedia, function(param) {
            return isEqual(partial_arg, param);
        }), 0);
    } else mediaIndex = 0;
    var firstMedia = $2whNH.getWithDefault($i7mYY.get(allVariantMedia, mediaIndex), {
        TAG: /* Image */ 0,
        _0: {
            url: "",
            width: 0,
            height: 0
        }
    });
    var otherMedia = $i7mYY.keep(allVariantMedia, function(media) {
        return !isEqual(media, firstMedia);
    });
    return [
        firstMedia,
        otherMedia
    ];
}
function $5a3d443209c54fe4$export$be63e0664592e141(store, variant, product) {
    if (variant !== undefined && !(typeof store === "number" || store.TAG !== /* Maker */ 0)) return $2whNH.getWithDefault(variant.name, product.name);
    else return product.name;
}
function $5a3d443209c54fe4$export$b256f5e2beb12ea8(hideOutOfStock, activeVariantId, displayVariantBy, product) {
    var defaultVariant = $5a3d443209c54fe4$export$25c71e859aead278(product, displayVariantBy);
    var selectedVariant = activeVariantId !== undefined ? $2whNH.keep($5a3d443209c54fe4$export$d48e1aa14fa1dc00(product, activeVariantId), function(variant) {
        if (variant.availability !== /* OutOfStock */ 0) return true;
        else return !hideOutOfStock;
    }) : undefined;
    return $2whNH.getWithDefault(selectedVariant, defaultVariant);
}
function $5a3d443209c54fe4$export$e9b93a43bd1606b(__x) {
    return $eFryz.getUnique(__x, function(product) {
        return product.id;
    });
}
function $5a3d443209c54fe4$export$7100e8c4f210baa1(hideOutOfStock, appliedFilters, productsWithTag, optionNames) {
    return $i7mYY.concatMany($i7mYY.map(productsWithTag, function(productWithTag) {
        var product = productWithTag[1];
        var existingTag = productWithTag[0];
        var existingTagId = $2whNH.map(existingTag, function(tag) {
            return tag.id;
        });
        var existingVariantId = $2whNH.flatMap(existingTag, function(tag) {
            return tag.variantId;
        });
        if (existingVariantId !== undefined) return [
            productWithTag
        ];
        var options = $i7mYY.keepMap(optionNames, function(optionName) {
            return $d3YYW.get(product.options, optionName);
        });
        if (options.length !== 0) {
            if (appliedFilters !== undefined) return [
                productWithTag
            ];
            else return $i7mYY.concatMany($i7mYY.map(options, function(options) {
                return $i7mYY.keepMap(options, function(param) {
                    var value = param.value;
                    return $2whNH.map($2whNH.map($2whNH.map($i7mYY.getBy($i7mYY.keep($5a3d443209c54fe4$export$f9abbd7546031f08(product), function(variant) {
                        if (variant.availability !== /* OutOfStock */ 0) return true;
                        else return !hideOutOfStock;
                    }), function(variant) {
                        return $i7mYY.some($d3YYW.values(variant.options), function(option) {
                            return option.value === value;
                        });
                    }), function(variant) {
                        return variant.id;
                    }), function(variantId) {
                        return {
                            id: $2whNH.getWithDefault(existingTagId, product.id + variantId),
                            productId: product.id,
                            variantId: variantId
                        };
                    }), function(tag) {
                        return [
                            tag,
                            product
                        ];
                    });
                });
            }));
        } else return [
            productWithTag
        ];
    }));
}
function $5a3d443209c54fe4$export$61eb0e7a3d17fad5(product) {
    return $5a3d443209c54fe4$export$f9abbd7546031f08(product).every(function(v) {
        return v.availability === /* OutOfStock */ 0;
    });
}
function $5a3d443209c54fe4$export$962dd12abd78c2e6(product) {
    return $i7mYY.some($5a3d443209c54fe4$export$f9abbd7546031f08(product), function(v) {
        var match = v.availability;
        if (match) return true;
        else return false;
    });
}
function $5a3d443209c54fe4$export$20fb11211262408f(product, hideOutOfStock) {
    return $2whNH.keep(product, function(product) {
        if ($5a3d443209c54fe4$export$962dd12abd78c2e6(product)) return true;
        else return !hideOutOfStock;
    });
}
function $5a3d443209c54fe4$export$29e26ac2c5f9bfdc(product, variant) {
    var store = $8L1B1.getStoreTypeByStoreId(product.storeId);
    var match = $5a3d443209c54fe4$export$8ba76842a51b6a6a(true, product, variant);
    var additionalMedia = match[1];
    var firstMedia = match[0];
    var price = variant.price;
    var tmp;
    tmp = typeof price === "number" ? "" : price.TAG === /* Regular */ 0 ? price._0 : price._0.regularPrice;
    var match$1 = variant.price;
    var tmp$1;
    tmp$1 = typeof match$1 === "number" || match$1.TAG === /* Regular */ 0 ? "" : match$1._0.price;
    var match$2 = variant.link;
    var match$3 = product.link;
    return {
        title: $5a3d443209c54fe4$export$be63e0664592e141(store, variant, product),
        size: $2whNH.getWithDefault($5a3d443209c54fe4$var$getOptionValue(variant, "Size"), ""),
        color: $2whNH.getWithDefault($5a3d443209c54fe4$var$getOptionValue(variant, "Color"), ""),
        pattern: $2whNH.getWithDefault($5a3d443209c54fe4$var$getOptionValue(variant, "Pattern"), ""),
        material: $2whNH.getWithDefault($5a3d443209c54fe4$var$getOptionValue(variant, "Material"), ""),
        price: tmp,
        style: $2whNH.getWithDefault($5a3d443209c54fe4$var$getOptionValue(variant, "Style"), ""),
        salePrice: tmp$1,
        description: $2whNH.getWithDefault($2whNH.orElse(variant.description, product.description), ""),
        groupId: product.id,
        id: "" + product.id + "_" + variant.id + "",
        imageLink: $2whNH.getWithDefault($5a3d443209c54fe4$var$getImageUrlWithPosterFallback(firstMedia), ""),
        imageSize: $5a3d443209c54fe4$var$getImageSizeWithPosterFallback(firstMedia),
        additionalImageLinks: $i7mYY.map($i7mYY.map(additionalMedia, $5a3d443209c54fe4$var$getImageUrlWithPosterFallback), $5a3d443209c54fe4$export$8d539b6bc182bbf5),
        additionalImageSizes: $i7mYY.map(additionalMedia, $5a3d443209c54fe4$var$getImageSizeWithPosterFallback),
        customLabel0: $2whNH.flatMap($i7mYY.get(variant.customLabels, 0), $5a3d443209c54fe4$export$b42e70ddca33ff5b),
        customLabel1: $2whNH.flatMap($i7mYY.get(variant.customLabels, 1), $5a3d443209c54fe4$export$b42e70ddca33ff5b),
        customLabel2: $2whNH.flatMap($i7mYY.get(variant.customLabels, 2), $5a3d443209c54fe4$export$b42e70ddca33ff5b),
        customLabel3: $2whNH.flatMap($i7mYY.get(variant.customLabels, 3), $5a3d443209c54fe4$export$b42e70ddca33ff5b),
        customLabel4: $2whNH.flatMap($i7mYY.get(variant.customLabels, 4), $5a3d443209c54fe4$export$b42e70ddca33ff5b),
        customLabel5: $2whNH.flatMap($i7mYY.get(variant.customLabels, 5), $5a3d443209c54fe4$export$b42e70ddca33ff5b),
        customLabel6: $2whNH.flatMap($i7mYY.get(variant.customLabels, 6), $5a3d443209c54fe4$export$b42e70ddca33ff5b),
        customLabel7: $2whNH.flatMap($i7mYY.get(variant.customLabels, 7), $5a3d443209c54fe4$export$b42e70ddca33ff5b),
        customLabel8: $2whNH.flatMap($i7mYY.get(variant.customLabels, 8), $5a3d443209c54fe4$export$b42e70ddca33ff5b),
        customLabel9: $2whNH.flatMap($i7mYY.get(variant.customLabels, 9), $5a3d443209c54fe4$export$b42e70ddca33ff5b),
        productType: product.productType,
        availability: variant.availability === /* OutOfStock */ 0 ? "out_of_stock" : "in_stock",
        availableQuantity: variant.inventory,
        link: match$2 !== undefined ? match$2 : match$3 !== undefined ? match$3 : undefined,
        brand: variant.brand,
        mpn: variant.mpn,
        sku: variant.sku,
        tags: product.tags.length !== 0 ? product.tags : undefined,
        metadata: $loT9g.some($5a3d443209c54fe4$var$getMetadata(product, variant)),
        currency: product.currency,
        reviewSummary: $2whNH.map(product.reviewSummary, function(summary) {
            return {
                count: summary.count,
                average: summary.average
            };
        })
    };
}
function $5a3d443209c54fe4$export$49fe41a914eb071d(options, variants) {
    return $d3YYW.fromArray($i7mYY.map(options, function(option) {
        return [
            option.name,
            $i7mYY.map($5a3d443209c54fe4$export$ca122b95797c31ac(option.values), function(value) {
                return {
                    id: option.id,
                    name: option.name,
                    value: value
                };
            })
        ];
    }));
}
function $5a3d443209c54fe4$export$3cfe0de6793961ae(appliedFilters, hideOutOfStockOpt, categoryId, storeId, dto) {
    var hideOutOfStock = hideOutOfStockOpt !== undefined ? hideOutOfStockOpt : true;
    var currency = $2whNH.map(dto.currency, function(prim) {
        return prim.toUpperCase();
    });
    var filteredVariants = $i7mYY.keep(dto.variants, function(v) {
        if (!hideOutOfStock) return true;
        var n = v.inventory.quantity;
        if (n !== undefined) return n > 0;
        else return false;
    });
    var match = $8ncuc.fromArray(filteredVariants);
    if (!match) return;
    var firstVariant = $5a3d443209c54fe4$var$tryParseFromDTO(match.hd, currency, dto.media, dto.options);
    var arg = dto.media;
    var arg$1 = dto.options;
    var otherVariants = $i7mYY.map($8ncuc.toArray(match.tl), function(param) {
        return $5a3d443209c54fe4$var$tryParseFromDTO(param, currency, arg, arg$1);
    });
    var allVariants = [
        firstVariant
    ].concat(otherVariants);
    var options = $5a3d443209c54fe4$export$49fe41a914eb071d(dto.options, allVariants);
    return {
        id: $iv6Yc._1($hG39s.ProductId.toString, dto.id),
        productType: $2whNH.getWithDefault(dto.productType, ""),
        categoryId: $2whNH.getWithDefault(categoryId, ""),
        name: $2whNH.getWithDefault(dto.name, ""),
        description: dto.description,
        currency: $2whNH.getWithDefault(currency, ""),
        link: dto.link,
        reviewSummary: $2whNH.map(dto.reviewSummary, function(summary) {
            return {
                count: summary.count,
                average: summary.average
            };
        }),
        promotionalText: dto.promoText,
        allMedia: $5a3d443209c54fe4$var$fromDTOArray(dto.media),
        firstVariant: firstVariant,
        otherVariants: otherVariants,
        tags: dto.tags,
        metadata: dto.metadata,
        options: options,
        storeId: storeId
    };
}
function $5a3d443209c54fe4$export$a47fb462a08de82f(variant, product) {
    return $i7mYY.keepMap([
        product.id,
        product.currency,
        product.name,
        Object.keys(product.options).join("-"),
        product.firstVariant.id,
        $2whNH.map(variant, function(variant) {
            return variant.id;
        }),
        $2whNH.map($2whNH.map(variant, $5a3d443209c54fe4$var$getRealProductPurchasePrice), function(prim) {
            return prim.toString();
        })
    ], function(a) {
        return a;
    }).join(":");
}
 /* resolveVideoUrls Not a pure module */ 
});
parcelRegister("d3YYW", function(module, exports) {

$parcel$export(module.exports, "get", function () { return $982adbe8cdff673c$export$3988ae62b71be9a3; });
$parcel$export(module.exports, "entries", function () { return $982adbe8cdff673c$export$3e9f948b41964866; });
$parcel$export(module.exports, "values", function () { return $982adbe8cdff673c$export$68c286be0e7e55b7; });
$parcel$export(module.exports, "fromArray", function () { return $982adbe8cdff673c$export$571d59b505e6bb4e; });
$parcel$export(module.exports, "map", function () { return $982adbe8cdff673c$export$871de8747c9eaa88; });

var $loT9g = parcelRequire("loT9g");
function $982adbe8cdff673c$export$3988ae62b71be9a3(dict, k) {
    if (k in dict) return $loT9g.some(dict[k]);
}
var $982adbe8cdff673c$export$d86d26fcf9b6eff8 = function unsafeDeleteKey(dict, key) {
    delete dict[key];
};
function $982adbe8cdff673c$export$3e9f948b41964866(dict) {
    var keys = Object.keys(dict);
    var l = keys.length;
    var values = new Array(l);
    for(var i = 0; i < l; ++i){
        var key = keys[i];
        values[i] = [
            key,
            dict[key]
        ];
    }
    return values;
}
function $982adbe8cdff673c$export$68c286be0e7e55b7(dict) {
    var keys = Object.keys(dict);
    var l = keys.length;
    var values$1 = new Array(l);
    for(var i = 0; i < l; ++i)values$1[i] = dict[keys[i]];
    return values$1;
}
function $982adbe8cdff673c$export$88e0dae599377b39(entries) {
    var dict = {};
    var _param = entries;
    while(true){
        var param = _param;
        if (!param) return dict;
        var match = param.hd;
        dict[match[0]] = match[1];
        _param = param.tl;
        continue;
    }
}
function $982adbe8cdff673c$export$571d59b505e6bb4e(entries) {
    var dict = {};
    var l = entries.length;
    for(var i = 0; i < l; ++i){
        var match = entries[i];
        dict[match[0]] = match[1];
    }
    return dict;
}
function $982adbe8cdff673c$export$871de8747c9eaa88(f, source) {
    var target = {};
    var keys = Object.keys(source);
    var l = keys.length;
    for(var i = 0; i < l; ++i){
        var key = keys[i];
        target[key] = f(source[key]);
    }
    return target;
}
 /* No side effect */ 
});

parcelRegister("69lAE", function(module, exports) {

$parcel$export(module.exports, "sortInPlaceWith", function () { return $47a454af396e700b$export$156a0843b24294c7; });
$parcel$export(module.exports, "concat", function () { return $47a454af396e700b$export$ee1b3e54f0441b22; });
$parcel$export(module.exports, "joinWith", function () { return $47a454af396e700b$export$ec1dc8fbeea3467e; });
$parcel$export(module.exports, "map", function () { return $47a454af396e700b$export$871de8747c9eaa88; });
$parcel$export(module.exports, "reducei", function () { return $47a454af396e700b$export$1460fbe8fbaef9f6; });

var $iv6Yc = parcelRequire("iv6Yc");

var $loT9g = parcelRequire("loT9g");

var $e1M2F = parcelRequire("e1M2F");
function $47a454af396e700b$export$10074e8e319eaaf(to_, obj) {
    return obj.copyWithin(to_);
}
function $47a454af396e700b$export$a9411e2b2f73668a(to_, from, obj) {
    return obj.copyWithin(to_, from);
}
function $47a454af396e700b$export$50c2501df62a61c3(to_, start, end_, obj) {
    return obj.copyWithin(to_, start, end_);
}
function $47a454af396e700b$export$3e23afb5fa975f92(arg1, obj) {
    return obj.fill(arg1);
}
function $47a454af396e700b$export$7c8a9f335867b105(arg1, from, obj) {
    return obj.fill(arg1, from);
}
function $47a454af396e700b$export$118900df563279e9(arg1, start, end_, obj) {
    return obj.fill(arg1, start, end_);
}
function $47a454af396e700b$export$4cbf152802aa238(arg1, obj) {
    return obj.push(arg1);
}
function $47a454af396e700b$export$9b635950ada85578(arg1, obj) {
    return $e1M2F.spliceObjApply(obj, "push", [
        arg1
    ]);
}
function $47a454af396e700b$export$156a0843b24294c7(arg1, obj) {
    return obj.sort($iv6Yc.__2(arg1));
}
function $47a454af396e700b$export$2e896601dcb17d26(pos, remove, add, obj) {
    return $e1M2F.spliceObjApply(obj, "splice", [
        pos,
        remove,
        add
    ]);
}
function $47a454af396e700b$export$38d7b11c94e4a8d6(pos, obj) {
    return obj.splice(pos);
}
function $47a454af396e700b$export$557eb37c4229d889(pos, count, obj) {
    return obj.splice(pos, count);
}
function $47a454af396e700b$export$37cdb546b806ae87(arg1, obj) {
    return obj.unshift(arg1);
}
function $47a454af396e700b$export$8fc1d85e1f2cc952(arg1, obj) {
    return $e1M2F.spliceObjApply(obj, "unshift", [
        arg1
    ]);
}
function $47a454af396e700b$export$ee1b3e54f0441b22(arg1, obj) {
    return obj.concat(arg1);
}
function $47a454af396e700b$export$252d63de73a739bf(arg1, obj) {
    return $e1M2F.spliceObjApply(obj, "concat", [
        arg1
    ]);
}
function $47a454af396e700b$export$ee2e0f811dca1807(arg1, obj) {
    return obj.includes(arg1);
}
function $47a454af396e700b$export$305f7d4e9d4624f2(arg1, obj) {
    return obj.indexOf(arg1);
}
function $47a454af396e700b$export$3840751aad9a3d1c(arg1, from, obj) {
    return obj.indexOf(arg1, from);
}
function $47a454af396e700b$export$ec1dc8fbeea3467e(arg1, obj) {
    return obj.join(arg1);
}
function $47a454af396e700b$export$557cfb7ed375eeb7(arg1, obj) {
    return obj.lastIndexOf(arg1);
}
function $47a454af396e700b$export$4a78c614e5d162c5(arg1, from, obj) {
    return obj.lastIndexOf(arg1, from);
}
function $47a454af396e700b$export$58adb3bec8346d0f(start, end_, obj) {
    return obj.slice(start, end_);
}
function $47a454af396e700b$export$a6d937cf5d2f468f(arg1, obj) {
    return obj.slice(arg1);
}
function $47a454af396e700b$export$7ecc1a3b11b57dab(arg1, obj) {
    return obj.every($iv6Yc.__1(arg1));
}
function $47a454af396e700b$export$17d08d18d8b01471(arg1, obj) {
    return obj.every($iv6Yc.__2(arg1));
}
function $47a454af396e700b$export$3dea766d36a8935f(arg1, obj) {
    return obj.filter($iv6Yc.__1(arg1));
}
function $47a454af396e700b$export$c31b87d65f96e3d5(arg1, obj) {
    return obj.filter($iv6Yc.__2(arg1));
}
function $47a454af396e700b$export$71aa6c912b956294(arg1, obj) {
    return $loT9g.undefined_to_opt(obj.find($iv6Yc.__1(arg1)));
}
function $47a454af396e700b$export$14909f539c3e1215(arg1, obj) {
    return $loT9g.undefined_to_opt(obj.find($iv6Yc.__2(arg1)));
}
function $47a454af396e700b$export$de3a4d4a0d731119(arg1, obj) {
    return obj.findIndex($iv6Yc.__1(arg1));
}
function $47a454af396e700b$export$777fa43736d5bf3f(arg1, obj) {
    return obj.findIndex($iv6Yc.__2(arg1));
}
function $47a454af396e700b$export$4b80e395e36b5a56(arg1, obj) {
    obj.forEach($iv6Yc.__1(arg1));
}
function $47a454af396e700b$export$3ab1c29810397d(arg1, obj) {
    obj.forEach($iv6Yc.__2(arg1));
}
function $47a454af396e700b$export$871de8747c9eaa88(arg1, obj) {
    return obj.map($iv6Yc.__1(arg1));
}
function $47a454af396e700b$export$8ef92191dafa99ba(arg1, obj) {
    return obj.map($iv6Yc.__2(arg1));
}
function $47a454af396e700b$export$533b26079ad0b4b(arg1, arg2, obj) {
    return obj.reduce($iv6Yc.__2(arg1), arg2);
}
function $47a454af396e700b$export$1460fbe8fbaef9f6(arg1, arg2, obj) {
    return obj.reduce($iv6Yc.__3(arg1), arg2);
}
function $47a454af396e700b$export$7fef8bcdbb34f435(arg1, arg2, obj) {
    return obj.reduceRight($iv6Yc.__2(arg1), arg2);
}
function $47a454af396e700b$export$4f1bdf2a9013c4b6(arg1, arg2, obj) {
    return obj.reduceRight($iv6Yc.__3(arg1), arg2);
}
function $47a454af396e700b$export$ad14ef4001db2bcd(arg1, obj) {
    return obj.some($iv6Yc.__1(arg1));
}
function $47a454af396e700b$export$de945d66ae7365ca(arg1, obj) {
    return obj.some($iv6Yc.__2(arg1));
}
 /* No side effect */ 
});

parcelRegister("8ncuc", function(module, exports) {

$parcel$export(module.exports, "get", function () { return $618a28301baf2026$export$3988ae62b71be9a3; });
$parcel$export(module.exports, "mapWithIndex", function () { return $618a28301baf2026$export$8f07ddce13659f50; });
$parcel$export(module.exports, "length", function () { return $618a28301baf2026$export$f24224f1c91d8156; });
$parcel$export(module.exports, "fromArray", function () { return $618a28301baf2026$export$571d59b505e6bb4e; });
$parcel$export(module.exports, "toArray", function () { return $618a28301baf2026$export$45b10814cc054894; });
$parcel$export(module.exports, "reverse", function () { return $618a28301baf2026$export$66c1ae025e96b4bc; });
$parcel$export(module.exports, "reduce", function () { return $618a28301baf2026$export$533b26079ad0b4b; });

var $iv6Yc = parcelRequire("iv6Yc");

var $i7mYY = parcelRequire("i7mYY");

var $loT9g = parcelRequire("loT9g");

var $58Tj9 = parcelRequire("58Tj9");
function $618a28301baf2026$export$5fd5031fecdacec3(x) {
    if (x) return $loT9g.some(x.hd);
}
function $618a28301baf2026$export$ceea6ccfccd07fd7(x) {
    if (x) return x.hd;
    throw {
        RE_EXN_ID: "Not_found",
        Error: new Error()
    };
}
function $618a28301baf2026$export$c01875f616615628(x) {
    if (x) return x.tl;
}
function $618a28301baf2026$export$a54e29821c34e5ee(x) {
    if (x) return x.tl;
    throw {
        RE_EXN_ID: "Not_found",
        Error: new Error()
    };
}
function $618a28301baf2026$export$e16d8520af44a096(xs, x) {
    return {
        hd: x,
        tl: xs
    };
}
function $618a28301baf2026$export$3988ae62b71be9a3(x, n) {
    if (n < 0) return;
    else {
        var _x = x;
        var _n = n;
        while(true){
            var n$1 = _n;
            var x$1 = _x;
            if (!x$1) return;
            if (n$1 === 0) return $loT9g.some(x$1.hd);
            _n = n$1 - 1 | 0;
            _x = x$1.tl;
            continue;
        }
    }
}
function $618a28301baf2026$export$2d6fda808293d631(x, n) {
    if (n < 0) throw {
        RE_EXN_ID: "Not_found",
        Error: new Error()
    };
    var _x = x;
    var _n = n;
    while(true){
        var n$1 = _n;
        var x$1 = _x;
        if (x$1) {
            if (n$1 === 0) return x$1.hd;
            _n = n$1 - 1 | 0;
            _x = x$1.tl;
            continue;
        }
        throw {
            RE_EXN_ID: "Not_found",
            Error: new Error()
        };
    }
}
function $618a28301baf2026$var$partitionAux(p, _cell, _precX, _precY) {
    while(true){
        var precY = _precY;
        var precX = _precX;
        var cell = _cell;
        if (!cell) return;
        var t = cell.tl;
        var h = cell.hd;
        var next = {
            hd: h,
            tl: /* [] */ 0
        };
        if (p(h)) {
            precX.tl = next;
            _precX = next;
            _cell = t;
            continue;
        }
        precY.tl = next;
        _precY = next;
        _cell = t;
        continue;
    }
}
function $618a28301baf2026$var$splitAux(_cell, _precX, _precY) {
    while(true){
        var precY = _precY;
        var precX = _precX;
        var cell = _cell;
        if (!cell) return;
        var match = cell.hd;
        var nextA = {
            hd: match[0],
            tl: /* [] */ 0
        };
        var nextB = {
            hd: match[1],
            tl: /* [] */ 0
        };
        precX.tl = nextA;
        precY.tl = nextB;
        _precY = nextB;
        _precX = nextA;
        _cell = cell.tl;
        continue;
    }
}
function $618a28301baf2026$var$copyAuxCont(_cellX, _prec) {
    while(true){
        var prec = _prec;
        var cellX = _cellX;
        if (!cellX) return prec;
        var next = {
            hd: cellX.hd,
            tl: /* [] */ 0
        };
        prec.tl = next;
        _prec = next;
        _cellX = cellX.tl;
        continue;
    }
}
function $618a28301baf2026$var$copyAuxWitFilter(f, _cellX, _prec) {
    while(true){
        var prec = _prec;
        var cellX = _cellX;
        if (!cellX) return;
        var t = cellX.tl;
        var h = cellX.hd;
        if (f(h)) {
            var next = {
                hd: h,
                tl: /* [] */ 0
            };
            prec.tl = next;
            _prec = next;
            _cellX = t;
            continue;
        }
        _cellX = t;
        continue;
    }
}
function $618a28301baf2026$var$copyAuxWithFilterIndex(f, _cellX, _prec, _i) {
    while(true){
        var i = _i;
        var prec = _prec;
        var cellX = _cellX;
        if (!cellX) return;
        var t = cellX.tl;
        var h = cellX.hd;
        if (f(h, i)) {
            var next = {
                hd: h,
                tl: /* [] */ 0
            };
            prec.tl = next;
            _i = i + 1 | 0;
            _prec = next;
            _cellX = t;
            continue;
        }
        _i = i + 1 | 0;
        _cellX = t;
        continue;
    }
}
function $618a28301baf2026$var$copyAuxWitFilterMap(f, _cellX, _prec) {
    while(true){
        var prec = _prec;
        var cellX = _cellX;
        if (!cellX) return;
        var t = cellX.tl;
        var h = f(cellX.hd);
        if (h !== undefined) {
            var next = {
                hd: $loT9g.valFromOption(h),
                tl: /* [] */ 0
            };
            prec.tl = next;
            _prec = next;
            _cellX = t;
            continue;
        }
        _cellX = t;
        continue;
    }
}
function $618a28301baf2026$var$removeAssocAuxWithMap(_cellX, x, _prec, f) {
    while(true){
        var prec = _prec;
        var cellX = _cellX;
        if (!cellX) return false;
        var t = cellX.tl;
        var h = cellX.hd;
        if (f(h[0], x)) {
            prec.tl = t;
            return true;
        }
        var next = {
            hd: h,
            tl: /* [] */ 0
        };
        prec.tl = next;
        _prec = next;
        _cellX = t;
        continue;
    }
}
function $618a28301baf2026$var$setAssocAuxWithMap(_cellX, x, k, _prec, eq) {
    while(true){
        var prec = _prec;
        var cellX = _cellX;
        if (!cellX) return false;
        var t = cellX.tl;
        var h = cellX.hd;
        if (eq(h[0], x)) {
            prec.tl = {
                hd: [
                    x,
                    k
                ],
                tl: t
            };
            return true;
        }
        var next = {
            hd: h,
            tl: /* [] */ 0
        };
        prec.tl = next;
        _prec = next;
        _cellX = t;
        continue;
    }
}
function $618a28301baf2026$var$copyAuxWithMap(_cellX, _prec, f) {
    while(true){
        var prec = _prec;
        var cellX = _cellX;
        if (!cellX) return;
        var next = {
            hd: f(cellX.hd),
            tl: /* [] */ 0
        };
        prec.tl = next;
        _prec = next;
        _cellX = cellX.tl;
        continue;
    }
}
function $618a28301baf2026$var$zipAux(_cellX, _cellY, _prec) {
    while(true){
        var prec = _prec;
        var cellY = _cellY;
        var cellX = _cellX;
        if (!cellX) return;
        if (!cellY) return;
        var next = {
            hd: [
                cellX.hd,
                cellY.hd
            ],
            tl: /* [] */ 0
        };
        prec.tl = next;
        _prec = next;
        _cellY = cellY.tl;
        _cellX = cellX.tl;
        continue;
    }
}
function $618a28301baf2026$var$copyAuxWithMap2(f, _cellX, _cellY, _prec) {
    while(true){
        var prec = _prec;
        var cellY = _cellY;
        var cellX = _cellX;
        if (!cellX) return;
        if (!cellY) return;
        var next = {
            hd: f(cellX.hd, cellY.hd),
            tl: /* [] */ 0
        };
        prec.tl = next;
        _prec = next;
        _cellY = cellY.tl;
        _cellX = cellX.tl;
        continue;
    }
}
function $618a28301baf2026$var$copyAuxWithMapI(f, _i, _cellX, _prec) {
    while(true){
        var prec = _prec;
        var cellX = _cellX;
        var i = _i;
        if (!cellX) return;
        var next = {
            hd: f(i, cellX.hd),
            tl: /* [] */ 0
        };
        prec.tl = next;
        _prec = next;
        _cellX = cellX.tl;
        _i = i + 1 | 0;
        continue;
    }
}
function $618a28301baf2026$var$takeAux(_n, _cell, _prec) {
    while(true){
        var prec = _prec;
        var cell = _cell;
        var n = _n;
        if (n === 0) return true;
        if (!cell) return false;
        var cell$1 = {
            hd: cell.hd,
            tl: /* [] */ 0
        };
        prec.tl = cell$1;
        _prec = cell$1;
        _cell = cell.tl;
        _n = n - 1 | 0;
        continue;
    }
}
function $618a28301baf2026$var$splitAtAux(_n, _cell, _prec) {
    while(true){
        var prec = _prec;
        var cell = _cell;
        var n = _n;
        if (n === 0) return cell;
        if (!cell) return;
        var cell$1 = {
            hd: cell.hd,
            tl: /* [] */ 0
        };
        prec.tl = cell$1;
        _prec = cell$1;
        _cell = cell.tl;
        _n = n - 1 | 0;
        continue;
    }
}
function $618a28301baf2026$export$b7df5d561049483a(lst, n) {
    if (n < 0) return;
    if (n === 0) return /* [] */ 0;
    if (!lst) return;
    var cell = {
        hd: lst.hd,
        tl: /* [] */ 0
    };
    var has = $618a28301baf2026$var$takeAux(n - 1 | 0, lst.tl, cell);
    if (has) return cell;
}
function $618a28301baf2026$export$663103110d94aac9(lst, n) {
    if (n < 0) return;
    else {
        var _l = lst;
        var _n = n;
        while(true){
            var n$1 = _n;
            var l = _l;
            if (n$1 === 0) return l;
            if (!l) return;
            _n = n$1 - 1 | 0;
            _l = l.tl;
            continue;
        }
    }
}
function $618a28301baf2026$export$b0d75975ac0be0e1(lst, n) {
    if (n < 0) return;
    if (n === 0) return [
        /* [] */ 0,
        lst
    ];
    if (!lst) return;
    var cell = {
        hd: lst.hd,
        tl: /* [] */ 0
    };
    var rest = $618a28301baf2026$var$splitAtAux(n - 1 | 0, lst.tl, cell);
    if (rest !== undefined) return [
        cell,
        rest
    ];
}
function $618a28301baf2026$export$ee1b3e54f0441b22(xs, ys) {
    if (!xs) return ys;
    var cell = {
        hd: xs.hd,
        tl: /* [] */ 0
    };
    $618a28301baf2026$var$copyAuxCont(xs.tl, cell).tl = ys;
    return cell;
}
function $618a28301baf2026$export$cc22bf2a9ce99b1(xs, f) {
    if (!xs) return /* [] */ 0;
    var cell = {
        hd: f(xs.hd),
        tl: /* [] */ 0
    };
    $618a28301baf2026$var$copyAuxWithMap(xs.tl, cell, f);
    return cell;
}
function $618a28301baf2026$export$871de8747c9eaa88(xs, f) {
    return $618a28301baf2026$export$cc22bf2a9ce99b1(xs, $iv6Yc.__1(f));
}
function $618a28301baf2026$export$35c5113aa227aa5(l1, l2, f) {
    if (!l1) return /* [] */ 0;
    if (!l2) return /* [] */ 0;
    var cell = {
        hd: f(l1.hd, l2.hd),
        tl: /* [] */ 0
    };
    $618a28301baf2026$var$copyAuxWithMap2(f, l1.tl, l2.tl, cell);
    return cell;
}
function $618a28301baf2026$export$d9e678742f9ba92(l1, l2, f) {
    return $618a28301baf2026$export$35c5113aa227aa5(l1, l2, $iv6Yc.__2(f));
}
function $618a28301baf2026$export$4cb8e22ecd37a3cf(xs, f) {
    if (!xs) return /* [] */ 0;
    var cell = {
        hd: f(0, xs.hd),
        tl: /* [] */ 0
    };
    $618a28301baf2026$var$copyAuxWithMapI(f, 1, xs.tl, cell);
    return cell;
}
function $618a28301baf2026$export$8f07ddce13659f50(xs, f) {
    return $618a28301baf2026$export$4cb8e22ecd37a3cf(xs, $iv6Yc.__2(f));
}
function $618a28301baf2026$export$790d8bf8abeeba86(n, f) {
    if (n <= 0) return /* [] */ 0;
    var headX = {
        hd: f(0),
        tl: /* [] */ 0
    };
    var cur = headX;
    var i = 1;
    while(i < n){
        var v = {
            hd: f(i),
            tl: /* [] */ 0
        };
        cur.tl = v;
        cur = v;
        i = i + 1 | 0;
    }
    return headX;
}
function $618a28301baf2026$export$849fbdcc2211fcde(n, f) {
    return $618a28301baf2026$export$790d8bf8abeeba86(n, $iv6Yc.__1(f));
}
function $618a28301baf2026$export$dd44f18ab656f3bb(n, v) {
    if (n <= 0) return /* [] */ 0;
    var headX = {
        hd: v,
        tl: /* [] */ 0
    };
    var cur = headX;
    var i = 1;
    while(i < n){
        var v$1 = {
            hd: v,
            tl: /* [] */ 0
        };
        cur.tl = v$1;
        cur = v$1;
        i = i + 1 | 0;
    }
    return headX;
}
function $618a28301baf2026$export$f24224f1c91d8156(xs) {
    var _x = xs;
    var _acc = 0;
    while(true){
        var acc = _acc;
        var x = _x;
        if (!x) return acc;
        _acc = acc + 1 | 0;
        _x = x.tl;
        continue;
    }
}
function $618a28301baf2026$var$fillAux(arr, _i, _x) {
    while(true){
        var x = _x;
        var i = _i;
        if (!x) return;
        arr[i] = x.hd;
        _x = x.tl;
        _i = i + 1 | 0;
        continue;
    }
}
function $618a28301baf2026$export$571d59b505e6bb4e(a) {
    var _i = a.length - 1 | 0;
    var _res = /* [] */ 0;
    while(true){
        var res = _res;
        var i = _i;
        if (i < 0) return res;
        _res = {
            hd: a[i],
            tl: res
        };
        _i = i - 1 | 0;
        continue;
    }
}
function $618a28301baf2026$export$45b10814cc054894(x) {
    var len = $618a28301baf2026$export$f24224f1c91d8156(x);
    var arr = new Array(len);
    $618a28301baf2026$var$fillAux(arr, 0, x);
    return arr;
}
function $618a28301baf2026$export$448332262467e042(xs) {
    var v = $618a28301baf2026$export$45b10814cc054894(xs);
    $i7mYY.shuffleInPlace(v);
    return $618a28301baf2026$export$571d59b505e6bb4e(v);
}
function $618a28301baf2026$export$be71da2caf12f8(_l1, _l2) {
    while(true){
        var l2 = _l2;
        var l1 = _l1;
        if (!l1) return l2;
        _l2 = {
            hd: l1.hd,
            tl: l2
        };
        _l1 = l1.tl;
        continue;
    }
}
function $618a28301baf2026$export$66c1ae025e96b4bc(l) {
    return $618a28301baf2026$export$be71da2caf12f8(l, /* [] */ 0);
}
function $618a28301baf2026$var$flattenAux(_prec, _xs) {
    while(true){
        var xs = _xs;
        var prec = _prec;
        if (xs) {
            _xs = xs.tl;
            _prec = $618a28301baf2026$var$copyAuxCont(xs.hd, prec);
            continue;
        }
        prec.tl = /* [] */ 0;
        return;
    }
}
function $618a28301baf2026$export$bffa455ba8c619a6(_xs) {
    while(true){
        var xs = _xs;
        if (!xs) return /* [] */ 0;
        var match = xs.hd;
        if (match) {
            var cell = {
                hd: match.hd,
                tl: /* [] */ 0
            };
            $618a28301baf2026$var$flattenAux($618a28301baf2026$var$copyAuxCont(match.tl, cell), xs.tl);
            return cell;
        }
        _xs = xs.tl;
        continue;
    }
}
function $618a28301baf2026$export$252d63de73a739bf(xs) {
    var len = xs.length;
    if (len === 1) return xs[0];
    if (len === 0) return /* [] */ 0;
    var len$1 = xs.length;
    var v = xs[len$1 - 1 | 0];
    for(var i = len$1 - 2 | 0; i >= 0; --i)v = $618a28301baf2026$export$ee1b3e54f0441b22(xs[i], v);
    return v;
}
function $618a28301baf2026$export$bcd62aac6e97f7fa(l, f) {
    var _accu = /* [] */ 0;
    var _xs = l;
    while(true){
        var xs = _xs;
        var accu = _accu;
        if (!xs) return accu;
        _xs = xs.tl;
        _accu = {
            hd: f(xs.hd),
            tl: accu
        };
        continue;
    }
}
function $618a28301baf2026$export$c69fed31bf090369(l, f) {
    return $618a28301baf2026$export$bcd62aac6e97f7fa(l, $iv6Yc.__1(f));
}
function $618a28301baf2026$export$e4198045b3bb8c9c(_xs, f) {
    while(true){
        var xs = _xs;
        if (!xs) return;
        f(xs.hd);
        _xs = xs.tl;
        continue;
    }
}
function $618a28301baf2026$export$4b80e395e36b5a56(xs, f) {
    $618a28301baf2026$export$e4198045b3bb8c9c(xs, $iv6Yc.__1(f));
}
function $618a28301baf2026$export$fd682543f1c8c317(l, f) {
    var _xs = l;
    var _i = 0;
    while(true){
        var i = _i;
        var xs = _xs;
        if (!xs) return;
        f(i, xs.hd);
        _i = i + 1 | 0;
        _xs = xs.tl;
        continue;
    }
}
function $618a28301baf2026$export$2590cec716f5563e(l, f) {
    $618a28301baf2026$export$fd682543f1c8c317(l, $iv6Yc.__2(f));
}
function $618a28301baf2026$export$ae643c57dec5ffec(_l, _accu, f) {
    while(true){
        var accu = _accu;
        var l = _l;
        if (!l) return accu;
        _accu = f(accu, l.hd);
        _l = l.tl;
        continue;
    }
}
function $618a28301baf2026$export$533b26079ad0b4b(l, accu, f) {
    return $618a28301baf2026$export$ae643c57dec5ffec(l, accu, $iv6Yc.__2(f));
}
function $618a28301baf2026$var$reduceReverseUnsafeU(l, accu, f) {
    if (l) return f($618a28301baf2026$var$reduceReverseUnsafeU(l.tl, accu, f), l.hd);
    else return accu;
}
function $618a28301baf2026$export$ef531491e938ae6d(l, acc, f) {
    var len = $618a28301baf2026$export$f24224f1c91d8156(l);
    if (len < 1000) return $618a28301baf2026$var$reduceReverseUnsafeU(l, acc, f);
    else return $i7mYY.reduceReverseU($618a28301baf2026$export$45b10814cc054894(l), acc, f);
}
function $618a28301baf2026$export$e11ac067bdfe867d(l, accu, f) {
    return $618a28301baf2026$export$ef531491e938ae6d(l, accu, $iv6Yc.__2(f));
}
function $618a28301baf2026$export$671b20c9914d5d4(l, acc, f) {
    var _l = l;
    var _acc = acc;
    var _i = 0;
    while(true){
        var i = _i;
        var acc$1 = _acc;
        var l$1 = _l;
        if (!l$1) return acc$1;
        _i = i + 1 | 0;
        _acc = f(acc$1, l$1.hd, i);
        _l = l$1.tl;
        continue;
    }
}
function $618a28301baf2026$export$bbd3ef8720e22369(l, acc, f) {
    return $618a28301baf2026$export$671b20c9914d5d4(l, acc, $iv6Yc.__3(f));
}
function $618a28301baf2026$export$1aed73332dd48c3(l1, l2, f) {
    var _l1 = l1;
    var _l2 = l2;
    var _accu = /* [] */ 0;
    while(true){
        var accu = _accu;
        var l2$1 = _l2;
        var l1$1 = _l1;
        if (!l1$1) return accu;
        if (!l2$1) return accu;
        _accu = {
            hd: f(l1$1.hd, l2$1.hd),
            tl: accu
        };
        _l2 = l2$1.tl;
        _l1 = l1$1.tl;
        continue;
    }
}
function $618a28301baf2026$export$56386c46e9127d6d(l1, l2, f) {
    return $618a28301baf2026$export$1aed73332dd48c3(l1, l2, $iv6Yc.__2(f));
}
function $618a28301baf2026$export$749f3ae5014c3ba3(_l1, _l2, f) {
    while(true){
        var l2 = _l2;
        var l1 = _l1;
        if (!l1) return;
        if (!l2) return;
        f(l1.hd, l2.hd);
        _l2 = l2.tl;
        _l1 = l1.tl;
        continue;
    }
}
function $618a28301baf2026$export$df99ccf98ba8fcd3(l1, l2, f) {
    $618a28301baf2026$export$749f3ae5014c3ba3(l1, l2, $iv6Yc.__2(f));
}
function $618a28301baf2026$export$e99d6518da14805d(_l1, _l2, _accu, f) {
    while(true){
        var accu = _accu;
        var l2 = _l2;
        var l1 = _l1;
        if (!l1) return accu;
        if (!l2) return accu;
        _accu = f(accu, l1.hd, l2.hd);
        _l2 = l2.tl;
        _l1 = l1.tl;
        continue;
    }
}
function $618a28301baf2026$export$45ce22197e959b90(l1, l2, acc, f) {
    return $618a28301baf2026$export$e99d6518da14805d(l1, l2, acc, $iv6Yc.__3(f));
}
function $618a28301baf2026$var$reduceReverse2UnsafeU(l1, l2, accu, f) {
    if (l1 && l2) return f($618a28301baf2026$var$reduceReverse2UnsafeU(l1.tl, l2.tl, accu, f), l1.hd, l2.hd);
    else return accu;
}
function $618a28301baf2026$export$c37d484a2f360d20(l1, l2, acc, f) {
    var len = $618a28301baf2026$export$f24224f1c91d8156(l1);
    if (len < 1000) return $618a28301baf2026$var$reduceReverse2UnsafeU(l1, l2, acc, f);
    else return $i7mYY.reduceReverse2U($618a28301baf2026$export$45b10814cc054894(l1), $618a28301baf2026$export$45b10814cc054894(l2), acc, f);
}
function $618a28301baf2026$export$29d0b882e6ca8ad4(l1, l2, acc, f) {
    return $618a28301baf2026$export$c37d484a2f360d20(l1, l2, acc, $iv6Yc.__3(f));
}
function $618a28301baf2026$export$f294ebd954c6e224(_xs, p) {
    while(true){
        var xs = _xs;
        if (!xs) return true;
        if (!p(xs.hd)) return false;
        _xs = xs.tl;
        continue;
    }
}
function $618a28301baf2026$export$7ecc1a3b11b57dab(xs, p) {
    return $618a28301baf2026$export$f294ebd954c6e224(xs, $iv6Yc.__1(p));
}
function $618a28301baf2026$export$6d4e2e7ededf6e6e(_xs, p) {
    while(true){
        var xs = _xs;
        if (!xs) return false;
        if (p(xs.hd)) return true;
        _xs = xs.tl;
        continue;
    }
}
function $618a28301baf2026$export$ad14ef4001db2bcd(xs, p) {
    return $618a28301baf2026$export$6d4e2e7ededf6e6e(xs, $iv6Yc.__1(p));
}
function $618a28301baf2026$export$32d47f85bf8fcd80(_l1, _l2, p) {
    while(true){
        var l2 = _l2;
        var l1 = _l1;
        if (!l1) return true;
        if (!l2) return true;
        if (!p(l1.hd, l2.hd)) return false;
        _l2 = l2.tl;
        _l1 = l1.tl;
        continue;
    }
}
function $618a28301baf2026$export$bb2198ede04be76f(l1, l2, p) {
    return $618a28301baf2026$export$32d47f85bf8fcd80(l1, l2, $iv6Yc.__2(p));
}
function $618a28301baf2026$export$98a8fd8b7df34937(_l1, _l2) {
    while(true){
        var l2 = _l2;
        var l1 = _l1;
        if (!l1) {
            if (l2) return -1;
            else return 0;
        }
        if (!l2) return 1;
        _l2 = l2.tl;
        _l1 = l1.tl;
        continue;
    }
}
function $618a28301baf2026$export$c0aec0f0618831d3(_l1, _l2, p) {
    while(true){
        var l2 = _l2;
        var l1 = _l1;
        if (!l1) {
            if (l2) return -1;
            else return 0;
        }
        if (!l2) return 1;
        var c = p(l1.hd, l2.hd);
        if (c !== 0) return c;
        _l2 = l2.tl;
        _l1 = l1.tl;
        continue;
    }
}
function $618a28301baf2026$export$6154dcdb7d23e37b(l1, l2, f) {
    return $618a28301baf2026$export$c0aec0f0618831d3(l1, l2, $iv6Yc.__2(f));
}
function $618a28301baf2026$export$f28cee400b9bf71f(_l1, _l2, p) {
    while(true){
        var l2 = _l2;
        var l1 = _l1;
        if (!l1) {
            if (l2) return false;
            else return true;
        }
        if (!l2) return false;
        if (!p(l1.hd, l2.hd)) return false;
        _l2 = l2.tl;
        _l1 = l1.tl;
        continue;
    }
}
function $618a28301baf2026$export$9663ddc1cf085b32(l1, l2, f) {
    return $618a28301baf2026$export$f28cee400b9bf71f(l1, l2, $iv6Yc.__2(f));
}
function $618a28301baf2026$export$febfdec44bdabfd5(_l1, _l2, p) {
    while(true){
        var l2 = _l2;
        var l1 = _l1;
        if (!l1) return false;
        if (!l2) return false;
        if (p(l1.hd, l2.hd)) return true;
        _l2 = l2.tl;
        _l1 = l1.tl;
        continue;
    }
}
function $618a28301baf2026$export$2b9a9c68d2ecbfcb(l1, l2, p) {
    return $618a28301baf2026$export$febfdec44bdabfd5(l1, l2, $iv6Yc.__2(p));
}
function $618a28301baf2026$export$8754c2358255764(_xs, x, eq) {
    while(true){
        var xs = _xs;
        if (!xs) return false;
        if (eq(xs.hd, x)) return true;
        _xs = xs.tl;
        continue;
    }
}
function $618a28301baf2026$export$a4f4bb6b1453fff5(xs, x, eq) {
    return $618a28301baf2026$export$8754c2358255764(xs, x, $iv6Yc.__2(eq));
}
function $618a28301baf2026$export$9f10509a9cbf6343(_xs, x, eq) {
    while(true){
        var xs = _xs;
        if (!xs) return;
        var match = xs.hd;
        if (eq(match[0], x)) return $loT9g.some(match[1]);
        _xs = xs.tl;
        continue;
    }
}
function $618a28301baf2026$export$d7de0eeef62c07d9(xs, x, eq) {
    return $618a28301baf2026$export$9f10509a9cbf6343(xs, x, $iv6Yc.__2(eq));
}
function $618a28301baf2026$export$aed88f778c485831(_xs, x, eq) {
    while(true){
        var xs = _xs;
        if (!xs) return false;
        if (eq(xs.hd[0], x)) return true;
        _xs = xs.tl;
        continue;
    }
}
function $618a28301baf2026$export$ec1dbb0d1232b51b(xs, x, eq) {
    return $618a28301baf2026$export$aed88f778c485831(xs, x, $iv6Yc.__2(eq));
}
function $618a28301baf2026$export$f15cecf84141c51d(xs, x, eq) {
    if (!xs) return /* [] */ 0;
    var l = xs.tl;
    var pair = xs.hd;
    if (eq(pair[0], x)) return l;
    var cell = {
        hd: pair,
        tl: /* [] */ 0
    };
    var removed = $618a28301baf2026$var$removeAssocAuxWithMap(l, x, cell, eq);
    if (removed) return cell;
    else return xs;
}
function $618a28301baf2026$export$bcc5750484d95a79(xs, x, eq) {
    return $618a28301baf2026$export$f15cecf84141c51d(xs, x, $iv6Yc.__2(eq));
}
function $618a28301baf2026$export$6052dceb8d8eaf34(xs, x, k, eq) {
    if (!xs) return {
        hd: [
            x,
            k
        ],
        tl: /* [] */ 0
    };
    var l = xs.tl;
    var pair = xs.hd;
    if (eq(pair[0], x)) return {
        hd: [
            x,
            k
        ],
        tl: l
    };
    var cell = {
        hd: pair,
        tl: /* [] */ 0
    };
    var replaced = $618a28301baf2026$var$setAssocAuxWithMap(l, x, k, cell, eq);
    if (replaced) return cell;
    else return {
        hd: [
            x,
            k
        ],
        tl: xs
    };
}
function $618a28301baf2026$export$ecd570b0c2c99011(xs, x, k, eq) {
    return $618a28301baf2026$export$6052dceb8d8eaf34(xs, x, k, $iv6Yc.__2(eq));
}
function $618a28301baf2026$export$147aeb9de40837c4(xs, cmp) {
    var arr = $618a28301baf2026$export$45b10814cc054894(xs);
    $58Tj9.stableSortInPlaceByU(arr, cmp);
    return $618a28301baf2026$export$571d59b505e6bb4e(arr);
}
function $618a28301baf2026$export$97db5808d8f88186(xs, cmp) {
    return $618a28301baf2026$export$147aeb9de40837c4(xs, $iv6Yc.__2(cmp));
}
function $618a28301baf2026$export$bc39419d633f09a1(_xs, p) {
    while(true){
        var xs = _xs;
        if (!xs) return;
        var x = xs.hd;
        if (p(x)) return $loT9g.some(x);
        _xs = xs.tl;
        continue;
    }
}
function $618a28301baf2026$export$d42617c71165e4fc(xs, p) {
    return $618a28301baf2026$export$bc39419d633f09a1(xs, $iv6Yc.__1(p));
}
function $618a28301baf2026$export$2e45af2d40d3fd2b(_xs, p) {
    while(true){
        var xs = _xs;
        if (!xs) return /* [] */ 0;
        var t = xs.tl;
        var h = xs.hd;
        if (p(h)) {
            var cell = {
                hd: h,
                tl: /* [] */ 0
            };
            $618a28301baf2026$var$copyAuxWitFilter(p, t, cell);
            return cell;
        }
        _xs = t;
        continue;
    }
}
function $618a28301baf2026$export$fae3166c418e0471(xs, p) {
    return $618a28301baf2026$export$2e45af2d40d3fd2b(xs, $iv6Yc.__1(p));
}
function $618a28301baf2026$export$c322a8aa3e32d301(xs, p) {
    var _xs = xs;
    var _i = 0;
    while(true){
        var i = _i;
        var xs$1 = _xs;
        if (!xs$1) return /* [] */ 0;
        var t = xs$1.tl;
        var h = xs$1.hd;
        if (p(h, i)) {
            var cell = {
                hd: h,
                tl: /* [] */ 0
            };
            $618a28301baf2026$var$copyAuxWithFilterIndex(p, t, cell, i + 1 | 0);
            return cell;
        }
        _i = i + 1 | 0;
        _xs = t;
        continue;
    }
}
function $618a28301baf2026$export$3f46207acfee6bc5(xs, p) {
    return $618a28301baf2026$export$c322a8aa3e32d301(xs, $iv6Yc.__2(p));
}
function $618a28301baf2026$export$fb6daf1607d5d777(_xs, p) {
    while(true){
        var xs = _xs;
        if (!xs) return /* [] */ 0;
        var t = xs.tl;
        var h = p(xs.hd);
        if (h !== undefined) {
            var cell = {
                hd: $loT9g.valFromOption(h),
                tl: /* [] */ 0
            };
            $618a28301baf2026$var$copyAuxWitFilterMap(p, t, cell);
            return cell;
        }
        _xs = t;
        continue;
    }
}
function $618a28301baf2026$export$8b311cdc49e179cd(xs, p) {
    return $618a28301baf2026$export$fb6daf1607d5d777(xs, $iv6Yc.__1(p));
}
function $618a28301baf2026$export$5a6fbee869ed7abd(l, p) {
    if (!l) return [
        /* [] */ 0,
        /* [] */ 0
    ];
    var h = l.hd;
    var nextX = {
        hd: h,
        tl: /* [] */ 0
    };
    var nextY = {
        hd: h,
        tl: /* [] */ 0
    };
    var b = p(h);
    $618a28301baf2026$var$partitionAux(p, l.tl, nextX, nextY);
    if (b) return [
        nextX,
        nextY.tl
    ];
    else return [
        nextX.tl,
        nextY
    ];
}
function $618a28301baf2026$export$b29f828819edca8d(l, p) {
    return $618a28301baf2026$export$5a6fbee869ed7abd(l, $iv6Yc.__1(p));
}
function $618a28301baf2026$export$23c8d3f8757cab88(xs) {
    if (!xs) return [
        /* [] */ 0,
        /* [] */ 0
    ];
    var match = xs.hd;
    var cellX = {
        hd: match[0],
        tl: /* [] */ 0
    };
    var cellY = {
        hd: match[1],
        tl: /* [] */ 0
    };
    $618a28301baf2026$var$splitAux(xs.tl, cellX, cellY);
    return [
        cellX,
        cellY
    ];
}
function $618a28301baf2026$export$8901015135f2fb22(l1, l2) {
    if (!l1) return /* [] */ 0;
    if (!l2) return /* [] */ 0;
    var cell = {
        hd: [
            l1.hd,
            l2.hd
        ],
        tl: /* [] */ 0
    };
    $618a28301baf2026$var$zipAux(l1.tl, l2.tl, cell);
    return cell;
}
var $618a28301baf2026$export$346677f925de839c = $618a28301baf2026$export$f24224f1c91d8156;
var $618a28301baf2026$export$3dea766d36a8935f = $618a28301baf2026$export$fae3166c418e0471;
var $618a28301baf2026$export$36e42aef19fc7171 = $618a28301baf2026$export$3f46207acfee6bc5;
 /* No side effect */ 
});
parcelRegister("58Tj9", function(module, exports) {

$parcel$export(module.exports, "strictlySortedLengthU", function () { return $3be89a1fe3e1ec7c$export$676638e94f0291c6; });
$parcel$export(module.exports, "stableSortInPlaceByU", function () { return $3be89a1fe3e1ec7c$export$2a81044477c2c00d; });
$parcel$export(module.exports, "stableSortBy", function () { return $3be89a1fe3e1ec7c$export$4a7b200faa4203c7; });

var $iv6Yc = parcelRequire("iv6Yc");

var $i7mYY = parcelRequire("i7mYY");
function $3be89a1fe3e1ec7c$var$sortedLengthAuxMore(xs, _prec, _acc, len, lt) {
    while(true){
        var acc = _acc;
        var prec = _prec;
        if (acc >= len) return acc;
        var v = xs[acc];
        if (!lt(v, prec)) return acc;
        _acc = acc + 1 | 0;
        _prec = v;
        continue;
    }
}
function $3be89a1fe3e1ec7c$export$676638e94f0291c6(xs, lt) {
    var len = xs.length;
    if (len === 0 || len === 1) return len;
    var x0 = xs[0];
    var x1 = xs[1];
    if (lt(x0, x1)) {
        var _prec = x1;
        var _acc = 2;
        while(true){
            var acc = _acc;
            var prec = _prec;
            if (acc >= len) return acc;
            var v = xs[acc];
            if (!lt(prec, v)) return acc;
            _acc = acc + 1 | 0;
            _prec = v;
            continue;
        }
    } else if (lt(x1, x0)) return -$3be89a1fe3e1ec7c$var$sortedLengthAuxMore(xs, x1, 2, len, lt) | 0;
    else return 1;
}
function $3be89a1fe3e1ec7c$export$bb0e766956b8a888(xs, lt) {
    return $3be89a1fe3e1ec7c$export$676638e94f0291c6(xs, $iv6Yc.__2(lt));
}
function $3be89a1fe3e1ec7c$export$f4769c9c596d6470(a, cmp) {
    var len = a.length;
    if (len === 0) return true;
    else {
        var _i = 0;
        var last_bound = len - 1 | 0;
        while(true){
            var i = _i;
            if (i === last_bound) return true;
            if (cmp(a[i], a[i + 1 | 0]) > 0) return false;
            _i = i + 1 | 0;
            continue;
        }
    }
}
function $3be89a1fe3e1ec7c$export$efa610630f9e181(a, cmp) {
    return $3be89a1fe3e1ec7c$export$f4769c9c596d6470(a, $iv6Yc.__2(cmp));
}
function $3be89a1fe3e1ec7c$var$merge(src, src1ofs, src1len, src2, src2ofs, src2len, dst, dstofs, cmp) {
    var src1r = src1ofs + src1len | 0;
    var src2r = src2ofs + src2len | 0;
    var _i1 = src1ofs;
    var _s1 = src[src1ofs];
    var _i2 = src2ofs;
    var _s2 = src2[src2ofs];
    var _d = dstofs;
    while(true){
        var d = _d;
        var s2 = _s2;
        var i2 = _i2;
        var s1 = _s1;
        var i1 = _i1;
        if (cmp(s1, s2) <= 0) {
            dst[d] = s1;
            var i1$1 = i1 + 1 | 0;
            if (i1$1 >= src1r) return $i7mYY.blitUnsafe(src2, i2, dst, d + 1 | 0, src2r - i2 | 0);
            _d = d + 1 | 0;
            _s1 = src[i1$1];
            _i1 = i1$1;
            continue;
        }
        dst[d] = s2;
        var i2$1 = i2 + 1 | 0;
        if (i2$1 >= src2r) return $i7mYY.blitUnsafe(src, i1, dst, d + 1 | 0, src1r - i1 | 0);
        _d = d + 1 | 0;
        _s2 = src2[i2$1];
        _i2 = i2$1;
        continue;
    }
}
function $3be89a1fe3e1ec7c$export$135b0c9cef4594bd(src, src1ofs, src1len, src2, src2ofs, src2len, dst, dstofs, cmp) {
    var src1r = src1ofs + src1len | 0;
    var src2r = src2ofs + src2len | 0;
    var _i1 = src1ofs;
    var _s1 = src[src1ofs];
    var _i2 = src2ofs;
    var _s2 = src2[src2ofs];
    var _d = dstofs;
    while(true){
        var d = _d;
        var s2 = _s2;
        var i2 = _i2;
        var s1 = _s1;
        var i1 = _i1;
        var c = cmp(s1, s2);
        if (c < 0) {
            dst[d] = s1;
            var i1$1 = i1 + 1 | 0;
            var d$1 = d + 1 | 0;
            if (i1$1 < src1r) {
                _d = d$1;
                _s1 = src[i1$1];
                _i1 = i1$1;
                continue;
            }
            $i7mYY.blitUnsafe(src2, i2, dst, d$1, src2r - i2 | 0);
            return (d$1 + src2r | 0) - i2 | 0;
        }
        if (c === 0) {
            dst[d] = s1;
            var i1$2 = i1 + 1 | 0;
            var i2$1 = i2 + 1 | 0;
            var d$2 = d + 1 | 0;
            if (!(i1$2 < src1r && i2$1 < src2r)) {
                if (i1$2 === src1r) {
                    $i7mYY.blitUnsafe(src2, i2$1, dst, d$2, src2r - i2$1 | 0);
                    return (d$2 + src2r | 0) - i2$1 | 0;
                } else {
                    $i7mYY.blitUnsafe(src, i1$2, dst, d$2, src1r - i1$2 | 0);
                    return (d$2 + src1r | 0) - i1$2 | 0;
                }
            }
            _d = d$2;
            _s2 = src2[i2$1];
            _i2 = i2$1;
            _s1 = src[i1$2];
            _i1 = i1$2;
            continue;
        }
        dst[d] = s2;
        var i2$2 = i2 + 1 | 0;
        var d$3 = d + 1 | 0;
        if (i2$2 < src2r) {
            _d = d$3;
            _s2 = src2[i2$2];
            _i2 = i2$2;
            continue;
        }
        $i7mYY.blitUnsafe(src, i1, dst, d$3, src1r - i1 | 0);
        return (d$3 + src1r | 0) - i1 | 0;
    }
}
function $3be89a1fe3e1ec7c$export$971dd5b0dfd021b6(src, src1ofs, src1len, src2, src2ofs, src2len, dst, dstofs, cmp) {
    return $3be89a1fe3e1ec7c$export$135b0c9cef4594bd(src, src1ofs, src1len, src2, src2ofs, src2len, dst, dstofs, $iv6Yc.__2(cmp));
}
function $3be89a1fe3e1ec7c$export$ee0dfe9b7c7205d0(src, src1ofs, src1len, src2, src2ofs, src2len, dst, dstofs, cmp) {
    var src1r = src1ofs + src1len | 0;
    var src2r = src2ofs + src2len | 0;
    var _i1 = src1ofs;
    var _s1 = src[src1ofs];
    var _i2 = src2ofs;
    var _s2 = src2[src2ofs];
    var _d = dstofs;
    while(true){
        var d = _d;
        var s2 = _s2;
        var i2 = _i2;
        var s1 = _s1;
        var i1 = _i1;
        var c = cmp(s1, s2);
        if (c < 0) {
            var i1$1 = i1 + 1 | 0;
            if (i1$1 >= src1r) return d;
            _s1 = src[i1$1];
            _i1 = i1$1;
            continue;
        }
        if (c === 0) {
            dst[d] = s1;
            var i1$2 = i1 + 1 | 0;
            var i2$1 = i2 + 1 | 0;
            var d$1 = d + 1 | 0;
            if (!(i1$2 < src1r && i2$1 < src2r)) return d$1;
            _d = d$1;
            _s2 = src2[i2$1];
            _i2 = i2$1;
            _s1 = src[i1$2];
            _i1 = i1$2;
            continue;
        }
        var i2$2 = i2 + 1 | 0;
        if (i2$2 >= src2r) return d;
        _s2 = src2[i2$2];
        _i2 = i2$2;
        continue;
    }
}
function $3be89a1fe3e1ec7c$export$1f4807a235930d45(src, src1ofs, src1len, src2, src2ofs, src2len, dst, dstofs, cmp) {
    return $3be89a1fe3e1ec7c$export$ee0dfe9b7c7205d0(src, src1ofs, src1len, src2, src2ofs, src2len, dst, dstofs, $iv6Yc.__2(cmp));
}
function $3be89a1fe3e1ec7c$export$f1f7eb63d928521d(src, src1ofs, src1len, src2, src2ofs, src2len, dst, dstofs, cmp) {
    var src1r = src1ofs + src1len | 0;
    var src2r = src2ofs + src2len | 0;
    var _i1 = src1ofs;
    var _s1 = src[src1ofs];
    var _i2 = src2ofs;
    var _s2 = src2[src2ofs];
    var _d = dstofs;
    while(true){
        var d = _d;
        var s2 = _s2;
        var i2 = _i2;
        var s1 = _s1;
        var i1 = _i1;
        var c = cmp(s1, s2);
        if (c < 0) {
            dst[d] = s1;
            var d$1 = d + 1 | 0;
            var i1$1 = i1 + 1 | 0;
            if (i1$1 >= src1r) return d$1;
            _d = d$1;
            _s1 = src[i1$1];
            _i1 = i1$1;
            continue;
        }
        if (c === 0) {
            var i1$2 = i1 + 1 | 0;
            var i2$1 = i2 + 1 | 0;
            if (!(i1$2 < src1r && i2$1 < src2r)) {
                if (i1$2 === src1r) return d;
                else {
                    $i7mYY.blitUnsafe(src, i1$2, dst, d, src1r - i1$2 | 0);
                    return (d + src1r | 0) - i1$2 | 0;
                }
            }
            _s2 = src2[i2$1];
            _i2 = i2$1;
            _s1 = src[i1$2];
            _i1 = i1$2;
            continue;
        }
        var i2$2 = i2 + 1 | 0;
        if (i2$2 < src2r) {
            _s2 = src2[i2$2];
            _i2 = i2$2;
            continue;
        }
        $i7mYY.blitUnsafe(src, i1, dst, d, src1r - i1 | 0);
        return (d + src1r | 0) - i1 | 0;
    }
}
function $3be89a1fe3e1ec7c$export$a37e3c603d7117e5(src, src1ofs, src1len, src2, src2ofs, src2len, dst, dstofs, cmp) {
    return $3be89a1fe3e1ec7c$export$f1f7eb63d928521d(src, src1ofs, src1len, src2, src2ofs, src2len, dst, dstofs, $iv6Yc.__2(cmp));
}
function $3be89a1fe3e1ec7c$var$insertionSort(src, srcofs, dst, dstofs, len, cmp) {
    for(var i = 0; i < len; ++i){
        var e = src[srcofs + i | 0];
        var j = (dstofs + i | 0) - 1 | 0;
        while(j >= dstofs && cmp(dst[j], e) > 0){
            dst[j + 1 | 0] = dst[j];
            j = j - 1 | 0;
        }
        dst[j + 1 | 0] = e;
    }
}
function $3be89a1fe3e1ec7c$var$sortTo(src, srcofs, dst, dstofs, len, cmp) {
    if (len <= 5) return $3be89a1fe3e1ec7c$var$insertionSort(src, srcofs, dst, dstofs, len, cmp);
    var l1 = len / 2 | 0;
    var l2 = len - l1 | 0;
    $3be89a1fe3e1ec7c$var$sortTo(src, srcofs + l1 | 0, dst, dstofs + l1 | 0, l2, cmp);
    $3be89a1fe3e1ec7c$var$sortTo(src, srcofs, src, srcofs + l2 | 0, l1, cmp);
    $3be89a1fe3e1ec7c$var$merge(src, srcofs + l2 | 0, l1, dst, dstofs + l1 | 0, l2, dst, dstofs, cmp);
}
function $3be89a1fe3e1ec7c$export$2a81044477c2c00d(a, cmp) {
    var l = a.length;
    if (l <= 5) return $3be89a1fe3e1ec7c$var$insertionSort(a, 0, a, 0, l, cmp);
    var l1 = l / 2 | 0;
    var l2 = l - l1 | 0;
    var t = new Array(l2);
    $3be89a1fe3e1ec7c$var$sortTo(a, l1, t, 0, l2, cmp);
    $3be89a1fe3e1ec7c$var$sortTo(a, 0, a, l2, l1, cmp);
    $3be89a1fe3e1ec7c$var$merge(a, l2, l1, t, 0, l2, a, 0, cmp);
}
function $3be89a1fe3e1ec7c$export$40cca47fcdb32a75(a, cmp) {
    $3be89a1fe3e1ec7c$export$2a81044477c2c00d(a, $iv6Yc.__2(cmp));
}
function $3be89a1fe3e1ec7c$export$5fea39d1086f7acb(a, cmp) {
    var b = a.slice(0);
    $3be89a1fe3e1ec7c$export$2a81044477c2c00d(b, cmp);
    return b;
}
function $3be89a1fe3e1ec7c$export$4a7b200faa4203c7(a, cmp) {
    return $3be89a1fe3e1ec7c$export$5fea39d1086f7acb(a, $iv6Yc.__2(cmp));
}
function $3be89a1fe3e1ec7c$export$427641b688ae4f8c(sorted, key, cmp) {
    var len = sorted.length;
    if (len === 0) return -1;
    var lo = sorted[0];
    var c = cmp(key, lo);
    if (c < 0) return -1;
    var hi = sorted[len - 1 | 0];
    var c2 = cmp(key, hi);
    if (c2 > 0) return -(len + 1 | 0) | 0;
    else {
        var _lo = 0;
        var _hi = len - 1 | 0;
        while(true){
            var hi$1 = _hi;
            var lo$1 = _lo;
            var mid = (lo$1 + hi$1 | 0) / 2 | 0;
            var midVal = sorted[mid];
            var c$1 = cmp(key, midVal);
            if (c$1 === 0) return mid;
            if (c$1 < 0) {
                if (hi$1 === mid) {
                    if (cmp(sorted[lo$1], key) === 0) return lo$1;
                    else return -(hi$1 + 1 | 0) | 0;
                }
                _hi = mid;
                continue;
            }
            if (lo$1 === mid) {
                if (cmp(sorted[hi$1], key) === 0) return hi$1;
                else return -(hi$1 + 1 | 0) | 0;
            }
            _lo = mid;
            continue;
        }
    }
}
function $3be89a1fe3e1ec7c$export$cfdf5c5dfceb78b(sorted, key, cmp) {
    return $3be89a1fe3e1ec7c$export$427641b688ae4f8c(sorted, key, $iv6Yc.__2(cmp));
}
var $3be89a1fe3e1ec7c$export$fdd676b64b72b00;
var $3be89a1fe3e1ec7c$export$96ac42349eda6d06;
 /* No side effect */ 
});


parcelRegister("2Ng4w", function(module, exports) {

$parcel$export(module.exports, "failwith", function () { return $208c9febbffc0b64$export$dfacdc1bc3225b90; });
$parcel$export(module.exports, "abs", function () { return $208c9febbffc0b64$export$2335f513bbd82c6d; });
$parcel$export(module.exports, "string_of_bool", function () { return $208c9febbffc0b64$export$d72f3e5a2687b7c4; });
$parcel$export(module.exports, "bool_of_string", function () { return $208c9febbffc0b64$export$7c5ed232a36d4124; });

var $iv6Yc = parcelRequire("iv6Yc");

var $6VA9O = parcelRequire("6VA9O");

var $kiuDo = parcelRequire("kiuDo");

var $axd0Z = parcelRequire("axd0Z");

var $1xvYg = parcelRequire("1xvYg");

var $bBMv4 = parcelRequire("bBMv4");
function $208c9febbffc0b64$export$dfacdc1bc3225b90(s) {
    throw {
        RE_EXN_ID: "Failure",
        _1: s,
        Error: new Error()
    };
}
function $208c9febbffc0b64$export$e28c21756d6cd4fd(s) {
    throw {
        RE_EXN_ID: "Invalid_argument",
        _1: s,
        Error: new Error()
    };
}
var $208c9febbffc0b64$export$6b467f3d80cc56bd = /* @__PURE__ */ $1xvYg.create("Pervasives.Exit");
function $208c9febbffc0b64$export$2335f513bbd82c6d(x) {
    if (x >= 0) return x;
    else return -x | 0;
}
function $208c9febbffc0b64$export$b8bfb75c96708e0b(x) {
    return x ^ -1;
}
var $208c9febbffc0b64$export$8c5d7acc34381e45 = -2147483648;
function $208c9febbffc0b64$export$522de874f1f7af40(x) {
    if (isFinite(x)) {
        if (Math.abs(x) >= 2.22507385850720138e-308) return /* FP_normal */ 0;
        else if (x !== 0) return /* FP_subnormal */ 1;
        else return /* FP_zero */ 2;
    } else if (isNaN(x)) return /* FP_nan */ 4;
    else return /* FP_infinite */ 3;
}
function $208c9febbffc0b64$export$869f5b0f7c1164e(n) {
    if (n < 0 || n > 255) throw {
        RE_EXN_ID: "Invalid_argument",
        _1: "char_of_int",
        Error: new Error()
    };
    return n;
}
function $208c9febbffc0b64$export$d72f3e5a2687b7c4(b) {
    if (b) return "true";
    else return "false";
}
function $208c9febbffc0b64$export$7c5ed232a36d4124(param) {
    switch(param){
        case "false":
            return false;
        case "true":
            return true;
        default:
            throw {
                RE_EXN_ID: "Invalid_argument",
                _1: "bool_of_string",
                Error: new Error()
            };
    }
}
function $208c9febbffc0b64$export$5412d0c7f1b0c2c9(param) {
    switch(param){
        case "false":
            return false;
        case "true":
            return true;
        default:
            return;
    }
}
function $208c9febbffc0b64$export$f0d530eee4c0f3d2(s) {
    try {
        return $kiuDo.int_of_string(s);
    } catch (raw_exn) {
        var exn = $bBMv4.internalToOCamlException(raw_exn);
        if (exn.RE_EXN_ID === "Failure") return;
        throw exn;
    }
}
function $208c9febbffc0b64$export$209d0e37ffa1400a(s) {
    var l = s.length;
    var _i = 0;
    while(true){
        var i = _i;
        if (i >= l) return s + ".";
        var match = $axd0Z.get(s, i);
        if (match >= 48) {
            if (match >= 58) return s;
            _i = i + 1 | 0;
            continue;
        }
        if (match !== 45) return s;
        _i = i + 1 | 0;
        continue;
    }
}
function $208c9febbffc0b64$export$bb64ca0876cf9550(f) {
    return $208c9febbffc0b64$export$209d0e37ffa1400a($kiuDo.format_float("%.12g", f));
}
function $208c9febbffc0b64$export$9f0301bf5008d9e8(s) {
    try {
        return $kiuDo.float_of_string(s);
    } catch (raw_exn) {
        var exn = $bBMv4.internalToOCamlException(raw_exn);
        if (exn.RE_EXN_ID === "Failure") return;
        throw exn;
    }
}
function $208c9febbffc0b64$export$70df91f55959aaf8(l1, l2) {
    if (l1) return {
        hd: l1.hd,
        tl: $208c9febbffc0b64$export$70df91f55959aaf8(l1.tl, l2)
    };
    else return l2;
}
function $208c9febbffc0b64$export$17f66b3ecf98e55f(param) {
    console.log("");
}
function $208c9febbffc0b64$export$6d7cae81c2ba3604(param) {
    console.error("");
}
function $208c9febbffc0b64$export$80570877a21ed78d(i) {
    console.log(String(i));
}
function $208c9febbffc0b64$export$1a2402adf83b7def(i) {
    console.log($208c9febbffc0b64$export$209d0e37ffa1400a($kiuDo.format_float("%.12g", i)));
}
function $208c9febbffc0b64$export$3ac97a7df6b534cb(prim) {
    console.log(prim);
}
var $208c9febbffc0b64$var$exit_function = {
    contents: function contents(prim) {}
};
function $208c9febbffc0b64$export$412e79380d04e5db(f) {
    var g = $208c9febbffc0b64$var$exit_function.contents;
    $208c9febbffc0b64$var$exit_function.contents = function(param) {
        $iv6Yc._1(f, undefined);
        $iv6Yc._1(g, undefined);
    };
}
function $208c9febbffc0b64$export$5c525e238923a57d(retcode) {
    $iv6Yc._1($208c9febbffc0b64$var$exit_function.contents, undefined);
    return $6VA9O.sys_exit(retcode);
}
var $208c9febbffc0b64$export$44174b80ac4a558e = 2147483647;
var $208c9febbffc0b64$export$a0978488bc4efbee = Infinity;
var $208c9febbffc0b64$export$7eaa4fcb52076062 = -Infinity;
var $208c9febbffc0b64$export$95eda9d7526c1155 = 1.79769313486231571e+308;
var $208c9febbffc0b64$export$e7c578afecb80c3a = 2.22507385850720138e-308;
var $208c9febbffc0b64$export$c7acb1007673d49d = 2.22044604925031308e-16;
 /* No side effect */ 
});
parcelRegister("6VA9O", function(module, exports) {

$parcel$export(module.exports, "sys_exit", function () { return $50b41d0573d00898$export$20f1234ab13f2efe; });

var $41cgx = parcelRequire("41cgx");
function $50b41d0573d00898$export$fdc1b5f462a25209(s) {
    if (typeof $41cgx === "undefined" || $41cgx.env === undefined) throw {
        RE_EXN_ID: "Not_found",
        Error: new Error()
    };
    var x = $41cgx.env[s];
    if (x !== undefined) return x;
    throw {
        RE_EXN_ID: "Not_found",
        Error: new Error()
    };
}
var $50b41d0573d00898$export$6ec267727e2e4048 = function os_type(_) {
    if (typeof $41cgx !== "undefined" && $41cgx.platform === "win32") return "Win32";
    else return "Unix";
};
function $50b41d0573d00898$export$ac900bd2a3bcc17e(param) {
    if (typeof $41cgx === "undefined" || $41cgx.uptime === undefined) return -1;
    else return $41cgx.uptime();
}
var $50b41d0573d00898$export$3ab03f4c8408420e = function sys_getcwd(param) {
    if (typeof $41cgx === "undefined" || $41cgx.cwd === undefined) return "/";
    return $41cgx.cwd();
};
function $50b41d0573d00898$export$27a88e70d8ffb16f(param) {
    if (typeof $41cgx === "undefined") return [
        "",
        [
            ""
        ]
    ];
    var argv = $41cgx.argv;
    if (argv == null) return [
        "",
        [
            ""
        ]
    ];
    else return [
        argv[0],
        argv
    ];
}
function $50b41d0573d00898$export$20f1234ab13f2efe(exit_code) {
    if (typeof $41cgx !== "undefined") return $41cgx.exit(exit_code);
}
function $50b41d0573d00898$export$c4789b0820c4ab62(_s) {
    throw {
        RE_EXN_ID: "Failure",
        _1: "sys_is_directory not implemented",
        Error: new Error()
    };
}
function $50b41d0573d00898$export$751d143c39c5bd0(_s) {
    throw {
        RE_EXN_ID: "Failure",
        _1: "sys_file_exists not implemented",
        Error: new Error()
    };
}
 /* No side effect */ 
});
parcelRegister("41cgx", function(module, exports) {
// shim for using process in browser
var $2ed0c51f0a1c31d6$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $2ed0c51f0a1c31d6$var$cachedSetTimeout;
var $2ed0c51f0a1c31d6$var$cachedClearTimeout;
function $2ed0c51f0a1c31d6$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $2ed0c51f0a1c31d6$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $2ed0c51f0a1c31d6$var$cachedSetTimeout = setTimeout;
        else $2ed0c51f0a1c31d6$var$cachedSetTimeout = $2ed0c51f0a1c31d6$var$defaultSetTimout;
    } catch (e) {
        $2ed0c51f0a1c31d6$var$cachedSetTimeout = $2ed0c51f0a1c31d6$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $2ed0c51f0a1c31d6$var$cachedClearTimeout = clearTimeout;
        else $2ed0c51f0a1c31d6$var$cachedClearTimeout = $2ed0c51f0a1c31d6$var$defaultClearTimeout;
    } catch (e) {
        $2ed0c51f0a1c31d6$var$cachedClearTimeout = $2ed0c51f0a1c31d6$var$defaultClearTimeout;
    }
})();
function $2ed0c51f0a1c31d6$var$runTimeout(fun) {
    if ($2ed0c51f0a1c31d6$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($2ed0c51f0a1c31d6$var$cachedSetTimeout === $2ed0c51f0a1c31d6$var$defaultSetTimout || !$2ed0c51f0a1c31d6$var$cachedSetTimeout) && setTimeout) {
        $2ed0c51f0a1c31d6$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $2ed0c51f0a1c31d6$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $2ed0c51f0a1c31d6$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $2ed0c51f0a1c31d6$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $2ed0c51f0a1c31d6$var$runClearTimeout(marker) {
    if ($2ed0c51f0a1c31d6$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($2ed0c51f0a1c31d6$var$cachedClearTimeout === $2ed0c51f0a1c31d6$var$defaultClearTimeout || !$2ed0c51f0a1c31d6$var$cachedClearTimeout) && clearTimeout) {
        $2ed0c51f0a1c31d6$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $2ed0c51f0a1c31d6$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $2ed0c51f0a1c31d6$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $2ed0c51f0a1c31d6$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $2ed0c51f0a1c31d6$var$queue = [];
var $2ed0c51f0a1c31d6$var$draining = false;
var $2ed0c51f0a1c31d6$var$currentQueue;
var $2ed0c51f0a1c31d6$var$queueIndex = -1;
function $2ed0c51f0a1c31d6$var$cleanUpNextTick() {
    if (!$2ed0c51f0a1c31d6$var$draining || !$2ed0c51f0a1c31d6$var$currentQueue) return;
    $2ed0c51f0a1c31d6$var$draining = false;
    if ($2ed0c51f0a1c31d6$var$currentQueue.length) $2ed0c51f0a1c31d6$var$queue = $2ed0c51f0a1c31d6$var$currentQueue.concat($2ed0c51f0a1c31d6$var$queue);
    else $2ed0c51f0a1c31d6$var$queueIndex = -1;
    if ($2ed0c51f0a1c31d6$var$queue.length) $2ed0c51f0a1c31d6$var$drainQueue();
}
function $2ed0c51f0a1c31d6$var$drainQueue() {
    if ($2ed0c51f0a1c31d6$var$draining) return;
    var timeout = $2ed0c51f0a1c31d6$var$runTimeout($2ed0c51f0a1c31d6$var$cleanUpNextTick);
    $2ed0c51f0a1c31d6$var$draining = true;
    var len = $2ed0c51f0a1c31d6$var$queue.length;
    while(len){
        $2ed0c51f0a1c31d6$var$currentQueue = $2ed0c51f0a1c31d6$var$queue;
        $2ed0c51f0a1c31d6$var$queue = [];
        while(++$2ed0c51f0a1c31d6$var$queueIndex < len)if ($2ed0c51f0a1c31d6$var$currentQueue) $2ed0c51f0a1c31d6$var$currentQueue[$2ed0c51f0a1c31d6$var$queueIndex].run();
        $2ed0c51f0a1c31d6$var$queueIndex = -1;
        len = $2ed0c51f0a1c31d6$var$queue.length;
    }
    $2ed0c51f0a1c31d6$var$currentQueue = null;
    $2ed0c51f0a1c31d6$var$draining = false;
    $2ed0c51f0a1c31d6$var$runClearTimeout(timeout);
}
$2ed0c51f0a1c31d6$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $2ed0c51f0a1c31d6$var$queue.push(new $2ed0c51f0a1c31d6$var$Item(fun, args));
    if ($2ed0c51f0a1c31d6$var$queue.length === 1 && !$2ed0c51f0a1c31d6$var$draining) $2ed0c51f0a1c31d6$var$runTimeout($2ed0c51f0a1c31d6$var$drainQueue);
};
// v8 likes predictible objects
function $2ed0c51f0a1c31d6$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$2ed0c51f0a1c31d6$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$2ed0c51f0a1c31d6$var$process.title = "browser";
$2ed0c51f0a1c31d6$var$process.browser = true;
$2ed0c51f0a1c31d6$var$process.env = {};
$2ed0c51f0a1c31d6$var$process.argv = [];
$2ed0c51f0a1c31d6$var$process.version = ""; // empty string to avoid regexp issues
$2ed0c51f0a1c31d6$var$process.versions = {};
function $2ed0c51f0a1c31d6$var$noop() {}
$2ed0c51f0a1c31d6$var$process.on = $2ed0c51f0a1c31d6$var$noop;
$2ed0c51f0a1c31d6$var$process.addListener = $2ed0c51f0a1c31d6$var$noop;
$2ed0c51f0a1c31d6$var$process.once = $2ed0c51f0a1c31d6$var$noop;
$2ed0c51f0a1c31d6$var$process.off = $2ed0c51f0a1c31d6$var$noop;
$2ed0c51f0a1c31d6$var$process.removeListener = $2ed0c51f0a1c31d6$var$noop;
$2ed0c51f0a1c31d6$var$process.removeAllListeners = $2ed0c51f0a1c31d6$var$noop;
$2ed0c51f0a1c31d6$var$process.emit = $2ed0c51f0a1c31d6$var$noop;
$2ed0c51f0a1c31d6$var$process.prependListener = $2ed0c51f0a1c31d6$var$noop;
$2ed0c51f0a1c31d6$var$process.prependOnceListener = $2ed0c51f0a1c31d6$var$noop;
$2ed0c51f0a1c31d6$var$process.listeners = function(name) {
    return [];
};
$2ed0c51f0a1c31d6$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$2ed0c51f0a1c31d6$var$process.cwd = function() {
    return "/";
};
$2ed0c51f0a1c31d6$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$2ed0c51f0a1c31d6$var$process.umask = function() {
    return 0;
};

});


parcelRegister("axd0Z", function(module, exports) {

$parcel$export(module.exports, "get", function () { return $7ab714f402cde22c$export$3988ae62b71be9a3; });
$parcel$export(module.exports, "make", function () { return $7ab714f402cde22c$export$dd44f18ab656f3bb; });
function $7ab714f402cde22c$export$3988ae62b71be9a3(s, i) {
    if (i >= s.length || i < 0) throw {
        RE_EXN_ID: "Invalid_argument",
        _1: "index out of bounds",
        Error: new Error()
    };
    return s.codePointAt(i);
}
function $7ab714f402cde22c$export$dd44f18ab656f3bb(n, ch) {
    return String.fromCharCode(ch).repeat(n);
}
 /* No side effect */ 
});

parcelRegister("bBMv4", function(module, exports) {

$parcel$export(module.exports, "internalToOCamlException", function () { return $8738c58b359047fe$export$83ef66a157212b9e; });
$parcel$export(module.exports, "as_js_exn", function () { return $8738c58b359047fe$export$410c7f658f342601; });

var $loT9g = parcelRequire("loT9g");

var $1xvYg = parcelRequire("1xvYg");
var $8738c58b359047fe$export$507b31d55a607b45 = "JsError";
function $8738c58b359047fe$export$83ef66a157212b9e(e) {
    if ($1xvYg.is_extension(e)) return e;
    else return {
        RE_EXN_ID: "JsError",
        _1: e
    };
}
function $8738c58b359047fe$export$410c7f658f342601(exn) {
    if (exn.RE_EXN_ID === $8738c58b359047fe$export$507b31d55a607b45) return $loT9g.some(exn._1);
}
 /* No side effect */ 
});


parcelRegister("3tOK1", function(module, exports) {

$parcel$export(module.exports, "mem", function () { return $288b70ace7a88a02$export$e8308fa57e490f0c; });
$parcel$export(module.exports, "memWithCacheKey", function () { return $288b70ace7a88a02$export$dcece0757e6970e9; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $l3Pg7 = parcelRequire("l3Pg7");

var $4R6bD = parcelRequire("4R6bD");
function $288b70ace7a88a02$export$78e3044358792147(a, b) {
    try {
        return $l3Pg7.default(a, b);
    } catch (exn) {
        return $l3Pg7(a, b);
    }
}
var $288b70ace7a88a02$export$e41fe70247822d20 = function newManyKeysMap(manyKeysMap) {
    if (manyKeysMap && manyKeysMap.default) return new manyKeysMap.default();
    return new manyKeysMap();
};
var $288b70ace7a88a02$export$3d984a453e22e1bb = function cacheKey() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    return args;
};
function $288b70ace7a88a02$export$e8308fa57e490f0c(input) {
    return $288b70ace7a88a02$export$78e3044358792147(input, {
        cacheKey: $288b70ace7a88a02$export$3d984a453e22e1bb,
        cache: $288b70ace7a88a02$export$e41fe70247822d20($4R6bD)
    });
}
function $288b70ace7a88a02$export$dcece0757e6970e9(input, cacheKey) {
    return $288b70ace7a88a02$export$78e3044358792147(input, {
        cacheKey: cacheKey,
        cache: $288b70ace7a88a02$export$e41fe70247822d20($4R6bD)
    });
}
 /* mem Not a pure module */ 
});
parcelRegister("l3Pg7", function(module, exports) {

var $kekIc = parcelRequire("kekIc");

var $kRmIq = parcelRequire("kRmIq");
"use strict";

var $j7mch = parcelRequire("j7mch");

var $jEo9X = parcelRequire("jEo9X");

var $bYBGZ = parcelRequire("bYBGZ");
var $f551a3c40831b806$var$cacheStore = new WeakMap();
var $f551a3c40831b806$var$defaultCacheKey = function() {
    for(var _len = arguments.length, arguments_ = new Array(_len), _key = 0; _key < _len; _key++){
        arguments_[_key] = arguments[_key];
    }
    if (arguments_.length === 0) return "__defaultKey";
    if (arguments_.length === 1) {
        var _arguments_ = (0, $kekIc._)(arguments_, 1), firstArgument = _arguments_[0];
        var isObject = typeof firstArgument === "object" && firstArgument !== null;
        var isPrimitive = !isObject;
        if (isPrimitive) return firstArgument;
    }
    return JSON.stringify(arguments_);
};
var $f551a3c40831b806$var$mem = function(fn) {
    var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _ref_cacheKey = _ref.cacheKey, cacheKey = _ref_cacheKey === void 0 ? $f551a3c40831b806$var$defaultCacheKey : _ref_cacheKey, _ref_cache = _ref.cache, cache = _ref_cache === void 0 ? new Map() : _ref_cache, _ref_cachePromiseRejection = _ref.cachePromiseRejection, cachePromiseRejection = _ref_cachePromiseRejection === void 0 ? true : _ref_cachePromiseRejection, maxAge = _ref.maxAge;
    if (typeof maxAge === "number") $bYBGZ(cache);
    var memoized = function memoized() {
        for(var _len = arguments.length, arguments_ = new Array(_len), _key = 0; _key < _len; _key++){
            arguments_[_key] = arguments[_key];
        }
        var key = cacheKey.apply(void 0, (0, $kRmIq._)(arguments_));
        if (cache.has(key)) return cache.get(key).data;
        var cacheItem = fn.apply(this, arguments_);
        cache.set(key, {
            data: cacheItem,
            maxAge: maxAge ? Date.now() + maxAge : Infinity
        });
        if ($jEo9X(cacheItem) && cachePromiseRejection === false) cacheItem.catch(function() {
            return cache.delete(key);
        });
        return cacheItem;
    };
    try {
        // The below call will throw in some host environments
        // See https://github.com/sindresorhus/mimic-fn/issues/10
        $j7mch(memoized, fn);
    } catch (_) {}
    $f551a3c40831b806$var$cacheStore.set(memoized, cache);
    return memoized;
};
module.exports = $f551a3c40831b806$var$mem;
module.exports.clear = function(fn) {
    var cache = $f551a3c40831b806$var$cacheStore.get(fn);
    if (cache && typeof cache.clear === "function") cache.clear();
};

});
parcelRegister("kekIc", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $eba52e6496b32771$export$fdf2a89c76341bbf; });

var $iyetx = parcelRequire("iyetx");

var $hyNcg = parcelRequire("hyNcg");

var $535Oz = parcelRequire("535Oz");

var $hFE5s = parcelRequire("hFE5s");
function $eba52e6496b32771$export$fdf2a89c76341bbf(arr, i) {
    return (0, $iyetx._array_with_holes)(arr) || (0, $hyNcg._iterable_to_array_limit)(arr, i) || (0, $hFE5s._unsupported_iterable_to_array)(arr, i) || (0, $535Oz._non_iterable_rest)();
}

});
parcelRegister("iyetx", function(module, exports) {

$parcel$export(module.exports, "_array_with_holes", function () { return $d816a182595497a3$export$e6256bf45c68d561; });
function $d816a182595497a3$export$e6256bf45c68d561(arr) {
    if (Array.isArray(arr)) return arr;
}

});

parcelRegister("hyNcg", function(module, exports) {

$parcel$export(module.exports, "_iterable_to_array_limit", function () { return $cc8bc616e6ef2cc0$export$2fd15edff6687200; });
function $cc8bc616e6ef2cc0$export$2fd15edff6687200(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}

});

parcelRegister("535Oz", function(module, exports) {

$parcel$export(module.exports, "_non_iterable_rest", function () { return $3ad1be4100d542df$export$60dbc22abd7da546; });
function $3ad1be4100d542df$export$60dbc22abd7da546() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});

parcelRegister("hFE5s", function(module, exports) {

$parcel$export(module.exports, "_unsupported_iterable_to_array", function () { return $cdd55c7450520114$export$a5be06335b3a083c; });

var $5QELw = parcelRequire("5QELw");
function $cdd55c7450520114$export$a5be06335b3a083c(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $5QELw._array_like_to_array)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $5QELw._array_like_to_array)(o, minLen);
}

});
parcelRegister("5QELw", function(module, exports) {

$parcel$export(module.exports, "_array_like_to_array", function () { return $44216e45ec0ec066$export$79e617b1955a2616; });
function $44216e45ec0ec066$export$79e617b1955a2616(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});



parcelRegister("kRmIq", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $f2fa60bb79d42ae6$export$1b5e630bc3aea29f; });

var $eDADq = parcelRequire("eDADq");

var $h6YrN = parcelRequire("h6YrN");

var $ki5z8 = parcelRequire("ki5z8");

var $hFE5s = parcelRequire("hFE5s");
function $f2fa60bb79d42ae6$export$1b5e630bc3aea29f(arr) {
    return (0, $eDADq._array_without_holes)(arr) || (0, $h6YrN._iterable_to_array)(arr) || (0, $hFE5s._unsupported_iterable_to_array)(arr) || (0, $ki5z8._non_iterable_spread)();
}

});
parcelRegister("eDADq", function(module, exports) {

$parcel$export(module.exports, "_array_without_holes", function () { return $aa81201c4814362b$export$7e0947b5ad3404e2; });

var $5QELw = parcelRequire("5QELw");
function $aa81201c4814362b$export$7e0947b5ad3404e2(arr) {
    if (Array.isArray(arr)) return (0, $5QELw._array_like_to_array)(arr);
}

});

parcelRegister("h6YrN", function(module, exports) {

$parcel$export(module.exports, "_iterable_to_array", function () { return $c751e2c35ca33d70$export$1eb58a6e75231000; });
function $c751e2c35ca33d70$export$1eb58a6e75231000(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

});

parcelRegister("ki5z8", function(module, exports) {

$parcel$export(module.exports, "_non_iterable_spread", function () { return $ec59ce54b437d8a4$export$e6f3c4780d19eb2b; });
function $ec59ce54b437d8a4$export$e6f3c4780d19eb2b() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("j7mch", function(module, exports) {
"use strict";
var $deafe3a6c18bc39c$var$mimicFn = function(to, from) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Reflect.ownKeys(from)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var prop = _step.value;
            Object.defineProperty(to, prop, Object.getOwnPropertyDescriptor(from, prop));
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return to;
};
module.exports = $deafe3a6c18bc39c$var$mimicFn;
// TODO: Remove this for the next major release
module.exports.default = $deafe3a6c18bc39c$var$mimicFn;

});

parcelRegister("jEo9X", function(module, exports) {
"use strict";
var $e4e47e5cd6b0770d$var$isPromise = function(input) {
    return input instanceof Promise || input !== null && typeof input === "object" && typeof input.then === "function" && typeof input.catch === "function";
};
module.exports = $e4e47e5cd6b0770d$var$isPromise;
// TODO: Remove this for the next major release
module.exports.default = $e4e47e5cd6b0770d$var$isPromise;

});

parcelRegister("bYBGZ", function(module, exports) {

var $j4B9x = parcelRequire("j4B9x");
"use strict";
var $8b82893f87912ee0$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : new P(function(resolve) {
                resolve(result.value);
            }).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $8b82893f87912ee0$var$__importDefault = undefined && undefined.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $8b82893f87912ee0$var$p_defer_1 = $8b82893f87912ee0$var$__importDefault((parcelRequire("8uH3H")));
function $8b82893f87912ee0$var$mapAgeCleaner(map) {
    var _this = this;
    var property = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "maxAge";
    var processingKey;
    var processingTimer;
    var processingDeferred;
    var cleanup = function() {
        return $8b82893f87912ee0$var$__awaiter(_this, void 0, void 0, function() {
            var _this, setupTimer, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, entry, err, _a;
            return (0, $j4B9x.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _this = this;
                        if (processingKey !== undefined) // If we are already processing an item, we can safely exit
                        return [
                            2
                        ];
                        setupTimer = function(item) {
                            return $8b82893f87912ee0$var$__awaiter(_this, void 0, void 0, function() {
                                var delay;
                                return (0, $j4B9x.__generator)(this, function(_state) {
                                    processingDeferred = $8b82893f87912ee0$var$p_defer_1.default();
                                    delay = item[1][property] - Date.now();
                                    if (delay <= 0) {
                                        // Remove the item immediately if the delay is equal to or below 0
                                        map.delete(item[0]);
                                        processingDeferred.resolve();
                                        return [
                                            2
                                        ];
                                    }
                                    // Keep track of the current processed key
                                    processingKey = item[0];
                                    processingTimer = setTimeout(function() {
                                        // Remove the item when the timeout fires
                                        map.delete(item[0]);
                                        if (processingDeferred) processingDeferred.resolve();
                                    }, delay);
                                    // tslint:disable-next-line:strict-type-predicates
                                    if (typeof processingTimer.unref === "function") // Don't hold up the process from exiting
                                    processingTimer.unref();
                                    return [
                                        2,
                                        processingDeferred.promise
                                    ];
                                });
                            });
                        };
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            10,
                            ,
                            11
                        ]);
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        _state.label = 2;
                    case 2:
                        _state.trys.push([
                            2,
                            7,
                            8,
                            9
                        ]);
                        _iterator = map[Symbol.iterator]();
                        _state.label = 3;
                    case 3:
                        if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                            3,
                            6
                        ];
                        entry = _step.value;
                        return [
                            4,
                            setupTimer(entry)
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        _iteratorNormalCompletion = true;
                        return [
                            3,
                            3
                        ];
                    case 6:
                        return [
                            3,
                            9
                        ];
                    case 7:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            9
                        ];
                    case 8:
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                        return [
                            7
                        ];
                    case 9:
                        return [
                            3,
                            11
                        ];
                    case 10:
                        _a = _state.sent();
                        return [
                            3,
                            11
                        ];
                    case 11:
                        processingKey = undefined;
                        return [
                            2
                        ];
                }
            });
        });
    };
    var reset = function() {
        processingKey = undefined;
        if (processingTimer !== undefined) {
            clearTimeout(processingTimer);
            processingTimer = undefined;
        }
        if (processingDeferred !== undefined) {
            processingDeferred.reject(undefined);
            processingDeferred = undefined;
        }
    };
    var originalSet = map.set.bind(map);
    map.set = function(key, value) {
        if (map.has(key)) // If the key already exist, remove it so we can add it back at the end of the map.
        map.delete(key);
        // Call the original `map.set`
        var result = originalSet(key, value);
        // If we are already processing a key and the key added is the current processed key, stop processing it
        if (processingKey && processingKey === key) reset();
        // Always run the cleanup method in case it wasn't started yet
        cleanup(); // tslint:disable-line:no-floating-promises
        return result;
    };
    cleanup(); // tslint:disable-line:no-floating-promises
    return map;
}
module.exports.default = $8b82893f87912ee0$var$mapAgeCleaner;
// Add support for CJS
module.exports = $8b82893f87912ee0$var$mapAgeCleaner;
module.exports.default = $8b82893f87912ee0$var$mapAgeCleaner;

});
parcelRegister("8uH3H", function(module, exports) {
"use strict";
module.exports = function() {
    var ret = {};
    ret.promise = new Promise(function(resolve, reject) {
        ret.resolve = resolve;
        ret.reject = reject;
    });
    return ret;
};

});



parcelRegister("4R6bD", function(module, exports) {

var $6Tsgf = parcelRequire("6Tsgf");

var $hmsbi = parcelRequire("hmsbi");

var $irtnp = parcelRequire("irtnp");

var $gzWEu = parcelRequire("gzWEu");

var $hPrj9 = parcelRequire("hPrj9");

var $tbJ7L = parcelRequire("tbJ7L");

var $kekIc = parcelRequire("kekIc");

var $kRmIq = parcelRequire("kRmIq");

var $gfRPo = parcelRequire("gfRPo");

var $O1H3y = parcelRequire("O1H3y");

var $3GntQ = parcelRequire("3GntQ");
"use strict";
var $3890e9322a9eba62$var$nullKey = Symbol("null"); // `objectHashes` key for null
var $3890e9322a9eba62$var$keyCounter = 0;
module.exports = /*#__PURE__*/ function(Map1) {
    (0, $hPrj9._)(ManyKeysMap, Map1);
    var _super = (0, $3GntQ._)(ManyKeysMap);
    function ManyKeysMap() {
        (0, $6Tsgf._)(this, ManyKeysMap);
        var _this;
        _this = _super.call(this);
        _this._objectHashes = new WeakMap();
        _this._symbolHashes = new Map(); // https://github.com/tc39/ecma262/issues/1194
        _this._publicKeys = new Map();
        // eslint-disable-next-line prefer-rest-params
        var _arguments = (0, $kekIc._)(arguments, 1), pairs = _arguments[0]; // Map compat
        if (pairs === null || pairs === undefined) return (0, $tbJ7L._)(_this);
        if (typeof pairs[Symbol.iterator] !== "function") throw new TypeError((typeof pairs === "undefined" ? "undefined" : (0, $gfRPo._)(pairs)) + " is not iterable (cannot read property Symbol(Symbol.iterator))");
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = pairs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = (0, $kekIc._)(_step.value, 2), keys = _step_value[0], value = _step_value[1];
                _this.set(keys, value);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return _this;
    }
    (0, $hmsbi._)(ManyKeysMap, [
        {
            key: "_getPublicKeys",
            value: function _getPublicKeys(keys) {
                var create = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                if (!Array.isArray(keys)) throw new TypeError("The keys parameter must be an array");
                var privateKey = this._getPrivateKey(keys, create);
                var publicKey;
                if (privateKey && this._publicKeys.has(privateKey)) publicKey = this._publicKeys.get(privateKey);
                else if (create) {
                    publicKey = (0, $kRmIq._)(keys); // Regenerate keys array to avoid external interaction
                    this._publicKeys.set(privateKey, publicKey);
                }
                return {
                    privateKey: privateKey,
                    publicKey: publicKey
                };
            }
        },
        {
            key: "_getPrivateKey",
            value: function _getPrivateKey(keys) {
                var create = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                var privateKeys = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var key = _step.value;
                        if (key === null) key = $3890e9322a9eba62$var$nullKey;
                        var hashes = typeof key === "object" || typeof key === "function" ? "_objectHashes" : (typeof key === "undefined" ? "undefined" : (0, $gfRPo._)(key)) === "symbol" ? "_symbolHashes" : false;
                        if (!hashes) privateKeys.push(key);
                        else if (this[hashes].has(key)) privateKeys.push(this[hashes].get(key));
                        else if (create) {
                            var privateKey = "@@mkm-ref-".concat($3890e9322a9eba62$var$keyCounter++, "@@");
                            this[hashes].set(key, privateKey);
                            privateKeys.push(privateKey);
                        } else return false;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return JSON.stringify(privateKeys);
            }
        },
        {
            key: "set",
            value: function set(keys, value) {
                var publicKey = this._getPublicKeys(keys, true).publicKey;
                return (0, $irtnp._)((0, $gzWEu._)(ManyKeysMap.prototype), "set", this).call(this, publicKey, value);
            }
        },
        {
            key: "get",
            value: function get(keys) {
                var publicKey = this._getPublicKeys(keys).publicKey;
                return (0, $irtnp._)((0, $gzWEu._)(ManyKeysMap.prototype), "get", this).call(this, publicKey);
            }
        },
        {
            key: "has",
            value: function has(keys) {
                var publicKey = this._getPublicKeys(keys).publicKey;
                return (0, $irtnp._)((0, $gzWEu._)(ManyKeysMap.prototype), "has", this).call(this, publicKey);
            }
        },
        {
            key: "delete",
            value: function _delete(keys) {
                var _this__getPublicKeys = this._getPublicKeys(keys), publicKey = _this__getPublicKeys.publicKey, privateKey = _this__getPublicKeys.privateKey;
                return Boolean(publicKey && (0, $irtnp._)((0, $gzWEu._)(ManyKeysMap.prototype), "delete", this).call(this, publicKey) && this._publicKeys.delete(privateKey));
            }
        },
        {
            key: "clear",
            value: function clear() {
                (0, $irtnp._)((0, $gzWEu._)(ManyKeysMap.prototype), "clear", this).call(this);
                this._symbolHashes.clear();
                this._publicKeys.clear();
            }
        },
        {
            key: Symbol.toStringTag,
            get: function get() {
                return "ManyKeysMap";
            }
        },
        {
            key: "size",
            get: function get() {
                return (0, $irtnp._)((0, $gzWEu._)(ManyKeysMap.prototype), "size", this);
            }
        }
    ]);
    return ManyKeysMap;
}((0, $O1H3y._)(Map));

});
parcelRegister("6Tsgf", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $504dcd2f00672bfc$export$2996f80ef42b8419; });
function $504dcd2f00672bfc$export$2996f80ef42b8419(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("hmsbi", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $ca3a59f3936b0329$export$d60067ff2358eee8; });
function $ca3a59f3936b0329$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $ca3a59f3936b0329$export$d60067ff2358eee8(Constructor, protoProps, staticProps) {
    if (protoProps) $ca3a59f3936b0329$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $ca3a59f3936b0329$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}

});

parcelRegister("irtnp", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $d6d18930e4a859b9$export$afb3516d9d608401; });

var $48oey = parcelRequire("48oey");
function $d6d18930e4a859b9$export$afb3516d9d608401(target, property, receiver) {
    if (typeof Reflect !== "undefined" && Reflect.get) $d6d18930e4a859b9$export$afb3516d9d608401 = Reflect.get;
    else $d6d18930e4a859b9$export$afb3516d9d608401 = function get(target, property, receiver) {
        var base = (0, $48oey._super_prop_base)(target, property);
        if (!base) return;
        var desc = Object.getOwnPropertyDescriptor(base, property);
        if (desc.get) return desc.get.call(receiver || target);
        return desc.value;
    };
    return $d6d18930e4a859b9$export$afb3516d9d608401(target, property, receiver || target);
}

});
parcelRegister("48oey", function(module, exports) {

$parcel$export(module.exports, "_super_prop_base", function () { return $302ab5177ba6056d$export$e4187255aefbc259; });

var $gzWEu = parcelRequire("gzWEu");
function $302ab5177ba6056d$export$e4187255aefbc259(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = (0, $gzWEu._get_prototype_of)(object);
        if (object === null) break;
    }
    return object;
}

});
parcelRegister("gzWEu", function(module, exports) {

$parcel$export(module.exports, "_get_prototype_of", function () { return $c11d69512f42d4ae$export$f09211a7d3c496a1; });
$parcel$export(module.exports, "_", function () { return $c11d69512f42d4ae$export$f09211a7d3c496a1; });
function $c11d69512f42d4ae$export$f09211a7d3c496a1(o) {
    $c11d69512f42d4ae$export$f09211a7d3c496a1 = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $c11d69512f42d4ae$export$f09211a7d3c496a1(o);
}

});



parcelRegister("hPrj9", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $cfac61dfebae21f0$export$7e4530ad35d3bb8; });

var $2sCUo = parcelRequire("2sCUo");
function $cfac61dfebae21f0$export$7e4530ad35d3bb8(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) (0, $2sCUo._set_prototype_of)(subClass, superClass);
}

});
parcelRegister("2sCUo", function(module, exports) {

$parcel$export(module.exports, "_set_prototype_of", function () { return $1cac60b5dae8e100$export$c2c98ac76e997b63; });
function $1cac60b5dae8e100$export$c2c98ac76e997b63(o, p) {
    $1cac60b5dae8e100$export$c2c98ac76e997b63 = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $1cac60b5dae8e100$export$c2c98ac76e997b63(o, p);
}

});


parcelRegister("tbJ7L", function(module, exports) {

$parcel$export(module.exports, "_possible_constructor_return", function () { return $057bce3f93742330$export$ef97c660ca164e52; });
$parcel$export(module.exports, "_", function () { return $057bce3f93742330$export$ef97c660ca164e52; });

var $hCOng = parcelRequire("hCOng");

var $gfRPo = parcelRequire("gfRPo");
function $057bce3f93742330$export$ef97c660ca164e52(self, call) {
    if (call && ((0, $gfRPo._type_of)(call) === "object" || typeof call === "function")) return call;
    return (0, $hCOng._assert_this_initialized)(self);
}

});
parcelRegister("hCOng", function(module, exports) {

$parcel$export(module.exports, "_assert_this_initialized", function () { return $cd4d0f88497bda56$export$f3b8ed2e4a5d10b8; });
$parcel$export(module.exports, "_", function () { return $cd4d0f88497bda56$export$f3b8ed2e4a5d10b8; });
function $cd4d0f88497bda56$export$f3b8ed2e4a5d10b8(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}

});


parcelRegister("O1H3y", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $0965fbe94c3e77d7$export$2466d533fda16e33; });

var $6Tn0u = parcelRequire("6Tn0u");

var $gzWEu = parcelRequire("gzWEu");

var $crlnd = parcelRequire("crlnd");

var $2sCUo = parcelRequire("2sCUo");
function $0965fbe94c3e77d7$export$2466d533fda16e33(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $0965fbe94c3e77d7$export$2466d533fda16e33 = function(Class) {
        if (Class === null || !(0, $crlnd._is_native_function)(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return (0, $6Tn0u._construct)(Class, arguments, (0, $gzWEu._get_prototype_of)(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return (0, $2sCUo._set_prototype_of)(Wrapper, Class);
    };
    return $0965fbe94c3e77d7$export$2466d533fda16e33(Class);
}

});
parcelRegister("6Tn0u", function(module, exports) {

$parcel$export(module.exports, "_construct", function () { return $5049b9d2ea9fb91a$export$2d841144c5f8c4ab; });

var $cOwn2 = parcelRequire("cOwn2");

var $2sCUo = parcelRequire("2sCUo");
function $5049b9d2ea9fb91a$export$2d841144c5f8c4ab(Parent, args, Class) {
    if ((0, $cOwn2._is_native_reflect_construct)()) $5049b9d2ea9fb91a$export$2d841144c5f8c4ab = Reflect.construct;
    else $5049b9d2ea9fb91a$export$2d841144c5f8c4ab = function construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) (0, $2sCUo._set_prototype_of)(instance, Class.prototype);
        return instance;
    };
    return $5049b9d2ea9fb91a$export$2d841144c5f8c4ab.apply(null, arguments);
}

});
parcelRegister("cOwn2", function(module, exports) {

$parcel$export(module.exports, "_is_native_reflect_construct", function () { return $954343a85cb74102$export$685354647fba1516; });
function $954343a85cb74102$export$685354647fba1516() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}

});


parcelRegister("crlnd", function(module, exports) {

$parcel$export(module.exports, "_is_native_function", function () { return $90e895fc65b83cb4$export$514eda94019f4334; });
function $90e895fc65b83cb4$export$514eda94019f4334(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

});


parcelRegister("3GntQ", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $2ae78212236cc0ab$export$8dd05c13f5255580; });

var $gzWEu = parcelRequire("gzWEu");

var $cOwn2 = parcelRequire("cOwn2");

var $tbJ7L = parcelRequire("tbJ7L");
function $2ae78212236cc0ab$export$8dd05c13f5255580(Derived) {
    var hasNativeReflectConstruct = (0, $cOwn2._is_native_reflect_construct)();
    return function _createSuperInternal() {
        var Super = (0, $gzWEu._get_prototype_of)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $gzWEu._get_prototype_of)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $tbJ7L._possible_constructor_return)(this, result);
    };
}

});



parcelRegister("hG39s", function(module, exports) {

$parcel$export(module.exports, "ProductId", function () { return $cde8cdc3766715c5$export$385544420f8b7777; });
$parcel$export(module.exports, "CategoryId", function () { return $cde8cdc3766715c5$export$22b261e08140d6b2; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $ki9MN = parcelRequire("ki9MN");
var $cde8cdc3766715c5$export$385544420f8b7777 = $ki9MN.Make({});
var $cde8cdc3766715c5$export$800880795edf46d = $ki9MN.Make({});
var $cde8cdc3766715c5$export$22b261e08140d6b2 = $ki9MN.Make({});
 /* ProductId Not a pure module */ 
});
parcelRegister("ki9MN", function(module, exports) {

$parcel$export(module.exports, "Make", function () { return $ec5d14672b55392d$export$ec284e6c61e81f96; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $79vie = parcelRequire("79vie");

var $AAkl8 = parcelRequire("AAkl8");

var $doJJK = parcelRequire("doJJK");
function $ec5d14672b55392d$export$ec284e6c61e81f96($star) {
    var toString = function toString(id) {
        return id;
    };
    var fromString = function fromString(id) {
        return id;
    };
    var include = $doJJK.Make({
        toJson: $AAkl8.string,
        fromJson: $79vie.string
    });
    return {
        toString: toString,
        fromString: fromString,
        toJson: $AAkl8.string,
        fromJson: $79vie.string,
        t_encode: include.t_encode,
        t_decode: include.t_decode,
        codec: include.codec
    };
}
 /* Json__Decode Not a pure module */ 
});
parcelRegister("79vie", function(module, exports) {

$parcel$export(module.exports, "string", function () { return $5351a5cabcc2510e$export$22b082955e083ec3; });
$parcel$export(module.exports, "bool", function () { return $5351a5cabcc2510e$export$87b259aa03e3d267; });
$parcel$export(module.exports, "$$int", function () { return $5351a5cabcc2510e$export$b537f535eb826cd3; });
$parcel$export(module.exports, "$$float", function () { return $5351a5cabcc2510e$export$7af93c3912c36b2a; });
$parcel$export(module.exports, "array", function () { return $5351a5cabcc2510e$export$2f23118c22fb2630; });
$parcel$export(module.exports, "list", function () { return $5351a5cabcc2510e$export$8837f4fc672e936d; });
$parcel$export(module.exports, "dict", function () { return $5351a5cabcc2510e$export$b7eef48498bbd53e; });
$parcel$export(module.exports, "keyValuePairs", function () { return $5351a5cabcc2510e$export$a6b37472941cc417; });
$parcel$export(module.exports, "tuple2", function () { return $5351a5cabcc2510e$export$92cb60c38e93b2cb; });
$parcel$export(module.exports, "tuple3", function () { return $5351a5cabcc2510e$export$7664ff7197245275; });
$parcel$export(module.exports, "tuple4", function () { return $5351a5cabcc2510e$export$b14eba571629e996; });
$parcel$export(module.exports, "tuple5", function () { return $5351a5cabcc2510e$export$51158e295b814981; });
$parcel$export(module.exports, "tuple6", function () { return $5351a5cabcc2510e$export$f52b7ee4eabdb261; });
$parcel$export(module.exports, "tuple7", function () { return $5351a5cabcc2510e$export$16acf2602fbdbf83; });
$parcel$export(module.exports, "tuple8", function () { return $5351a5cabcc2510e$export$258c90b8fff5318e; });
$parcel$export(module.exports, "field", function () { return $5351a5cabcc2510e$export$e0f35d825088c098; });
$parcel$export(module.exports, "at", function () { return $5351a5cabcc2510e$export$493d36ec626b6698; });
$parcel$export(module.exports, "index", function () { return $5351a5cabcc2510e$export$b610b8812bbcded9; });
$parcel$export(module.exports, "option", function () { return $5351a5cabcc2510e$export$a75d1723e6bda2ec; });
$parcel$export(module.exports, "oneOf", function () { return $5351a5cabcc2510e$export$a9a18ae5ba42aeab; });
$parcel$export(module.exports, "decodeString", function () { return $5351a5cabcc2510e$export$a0fb664af7d0cc44; });
$parcel$export(module.exports, "decodeValue", function () { return $5351a5cabcc2510e$export$1bc3347b5a3e0603; });
$parcel$export(module.exports, "errorToString", function () { return $5351a5cabcc2510e$export$46c1952d522542d7; });
$parcel$export(module.exports, "map", function () { return $5351a5cabcc2510e$export$871de8747c9eaa88; });
$parcel$export(module.exports, "map2", function () { return $5351a5cabcc2510e$export$5be556bf484c4f10; });
$parcel$export(module.exports, "andMap", function () { return $5351a5cabcc2510e$export$1ae5bb9217ed77cc; });
$parcel$export(module.exports, "$$null", function () { return $5351a5cabcc2510e$export$75050adc5191c049; });
$parcel$export(module.exports, "nullable", function () { return $5351a5cabcc2510e$export$133fc36489ac9add; });
$parcel$export(module.exports, "value", function () { return $5351a5cabcc2510e$export$2ab9a8f9f1186f14; });
$parcel$export(module.exports, "andThen", function () { return $5351a5cabcc2510e$export$9768a9ae43d7f016; });
$parcel$export(module.exports, "succeed", function () { return $5351a5cabcc2510e$export$9094b7742a87955e; });
$parcel$export(module.exports, "fail", function () { return $5351a5cabcc2510e$export$2b62a06a9fee979c; });
$parcel$export(module.exports, "map3", function () { return $5351a5cabcc2510e$export$f7389512af34c855; });
$parcel$export(module.exports, "map4", function () { return $5351a5cabcc2510e$export$dddc425886bb4024; });
$parcel$export(module.exports, "map5", function () { return $5351a5cabcc2510e$export$89e0958a4f22698b; });
$parcel$export(module.exports, "map6", function () { return $5351a5cabcc2510e$export$93c2dc1c6eacd42c; });
$parcel$export(module.exports, "map7", function () { return $5351a5cabcc2510e$export$a23802bf7d2b7306; });
$parcel$export(module.exports, "map8", function () { return $5351a5cabcc2510e$export$308685edec35689e; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $d3YYW = parcelRequire("d3YYW");

var $1ArWc = parcelRequire("1ArWc");

var $8ncuc = parcelRequire("8ncuc");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $gTtop = parcelRequire("gTtop");

var $loT9g = parcelRequire("loT9g");

var $AAkl8 = parcelRequire("AAkl8");
function $5351a5cabcc2510e$var$optToRes(option, err) {
    if (option !== undefined) return {
        TAG: /* Ok */ 0,
        _0: $loT9g.valFromOption(option)
    };
    else return {
        TAG: /* Error */ 1,
        _0: err
    };
}
function $5351a5cabcc2510e$var$resMapError(res, f) {
    if (res.TAG === /* Ok */ 0) return {
        TAG: /* Ok */ 0,
        _0: res._0
    };
    else return {
        TAG: /* Error */ 1,
        _0: $iv6Yc._1(f, res._0)
    };
}
function $5351a5cabcc2510e$var$resAndMap(resF, resV) {
    return $gTtop.flatMap(resF, function(f) {
        return $gTtop.map(resV, $iv6Yc.__1(f));
    });
}
function $5351a5cabcc2510e$export$22b082955e083ec3(j) {
    return $5351a5cabcc2510e$var$optToRes($1ArWc.decodeString(j), {
        TAG: /* Failure */ 0,
        _0: "Expecting a STRING",
        _1: j
    });
}
function $5351a5cabcc2510e$export$87b259aa03e3d267(j) {
    return $5351a5cabcc2510e$var$optToRes($1ArWc.decodeBoolean(j), {
        TAG: /* Failure */ 0,
        _0: "Expecting a BOOL",
        _1: j
    });
}
function $5351a5cabcc2510e$export$b537f535eb826cd3(j) {
    return $5351a5cabcc2510e$var$optToRes($2whNH.map($1ArWc.decodeNumber(j), function(prim) {
        return prim | 0;
    }), {
        TAG: /* Failure */ 0,
        _0: "Expecting an INT",
        _1: j
    });
}
function $5351a5cabcc2510e$export$7af93c3912c36b2a(j) {
    return $5351a5cabcc2510e$var$optToRes($1ArWc.decodeNumber(j), {
        TAG: /* Failure */ 0,
        _0: "Expecting a FLOAT",
        _1: j
    });
}
function $5351a5cabcc2510e$export$2f23118c22fb2630(aDecoder) {
    return function(j) {
        return $gTtop.flatMap($5351a5cabcc2510e$var$optToRes($1ArWc.decodeArray(j), {
            TAG: /* Failure */ 0,
            _0: "Expecting an ARRAY",
            _1: j
        }), function(arr) {
            return arr.reduce(function(acc, cur, index) {
                if (acc.TAG !== /* Ok */ 0) return acc;
                var error = $iv6Yc._1(aDecoder, cur);
                if (error.TAG === /* Ok */ 0) return {
                    TAG: /* Ok */ 0,
                    _0: acc._0.concat([
                        error._0
                    ])
                };
                else return {
                    TAG: /* Error */ 1,
                    _0: {
                        TAG: /* Index */ 1,
                        _0: index,
                        _1: error._0
                    }
                };
            }, {
                TAG: /* Ok */ 0,
                _0: []
            });
        });
    };
}
function $5351a5cabcc2510e$export$8837f4fc672e936d(aDecoder) {
    return function(j) {
        return $gTtop.flatMap($5351a5cabcc2510e$var$optToRes($1ArWc.decodeArray(j), {
            TAG: /* Failure */ 0,
            _0: "Expecting an ARRAY",
            _1: j
        }), function(arr) {
            return $i7mYY.reverse(arr).reduce(function(acc, cur, index) {
                if (acc.TAG !== /* Ok */ 0) return acc;
                var error = $iv6Yc._1(aDecoder, cur);
                if (error.TAG === /* Ok */ 0) return {
                    TAG: /* Ok */ 0,
                    _0: {
                        hd: error._0,
                        tl: acc._0
                    }
                };
                else return {
                    TAG: /* Error */ 1,
                    _0: {
                        TAG: /* Index */ 1,
                        _0: index,
                        _1: error._0
                    }
                };
            }, {
                TAG: /* Ok */ 0,
                _0: /* [] */ 0
            });
        });
    };
}
function $5351a5cabcc2510e$export$b7eef48498bbd53e(aDecoder) {
    return function(j) {
        return $gTtop.map($gTtop.flatMap($5351a5cabcc2510e$var$optToRes($1ArWc.decodeObject(j), {
            TAG: /* Failure */ 0,
            _0: "Expecting an OBJECT",
            _1: j
        }), function(obj) {
            return $d3YYW.entries(obj).reduce(function(acc, param) {
                var key = param[0];
                if (acc.TAG !== /* Ok */ 0) return acc;
                var error = $iv6Yc._1(aDecoder, param[1]);
                if (error.TAG === /* Ok */ 0) return {
                    TAG: /* Ok */ 0,
                    _0: acc._0.concat([
                        [
                            key,
                            error._0
                        ]
                    ])
                };
                else return {
                    TAG: /* Error */ 1,
                    _0: {
                        TAG: /* Field */ 2,
                        _0: key,
                        _1: error._0
                    }
                };
            }, {
                TAG: /* Ok */ 0,
                _0: []
            });
        }), $d3YYW.fromArray);
    };
}
function $5351a5cabcc2510e$export$a6b37472941cc417(aDecoder) {
    return function(j) {
        return $gTtop.flatMap($5351a5cabcc2510e$var$optToRes($1ArWc.decodeObject(j), {
            TAG: /* Failure */ 0,
            _0: "Expecting an OBJECT",
            _1: j
        }), function(obj) {
            return $d3YYW.entries(obj).reduce(function(acc, param) {
                var key = param[0];
                if (acc.TAG !== /* Ok */ 0) return acc;
                var error = $iv6Yc._1(aDecoder, param[1]);
                if (error.TAG === /* Ok */ 0) return {
                    TAG: /* Ok */ 0,
                    _0: acc._0.concat([
                        [
                            key,
                            error._0
                        ]
                    ])
                };
                else return {
                    TAG: /* Error */ 1,
                    _0: {
                        TAG: /* Field */ 2,
                        _0: key,
                        _1: error._0
                    }
                };
            }, {
                TAG: /* Ok */ 0,
                _0: []
            });
        });
    };
}
function $5351a5cabcc2510e$export$92cb60c38e93b2cb(aDecoder, bDecoder) {
    return function(j) {
        return $gTtop.flatMap($5351a5cabcc2510e$var$optToRes($1ArWc.decodeArray(j), {
            TAG: /* Failure */ 0,
            _0: "Expecting an ARRAY",
            _1: j
        }), function(arr) {
            if (arr.length !== 2) return {
                TAG: /* Error */ 1,
                _0: {
                    TAG: /* Failure */ 0,
                    _0: "Expecting an ARRAY with 2 elements",
                    _1: j
                }
            };
            var a = arr[0];
            var b = arr[1];
            return $5351a5cabcc2510e$var$resAndMap($5351a5cabcc2510e$var$resAndMap({
                TAG: /* Ok */ 0,
                _0: function _0(a, b) {
                    return [
                        a,
                        b
                    ];
                }
            }, $iv6Yc._1(aDecoder, a)), $iv6Yc._1(bDecoder, b));
        });
    };
}
function $5351a5cabcc2510e$export$7664ff7197245275(aDecoder, bDecoder, cDecoder) {
    return function(j) {
        return $gTtop.flatMap($5351a5cabcc2510e$var$optToRes($1ArWc.decodeArray(j), {
            TAG: /* Failure */ 0,
            _0: "Expecting an ARRAY",
            _1: j
        }), function(arr) {
            if (arr.length !== 3) return {
                TAG: /* Error */ 1,
                _0: {
                    TAG: /* Failure */ 0,
                    _0: "Expecting an ARRAY with 3 elements",
                    _1: j
                }
            };
            var a = arr[0];
            var b = arr[1];
            var c = arr[2];
            return $5351a5cabcc2510e$var$resAndMap($5351a5cabcc2510e$var$resAndMap($5351a5cabcc2510e$var$resAndMap({
                TAG: /* Ok */ 0,
                _0: function _0(a, b, c) {
                    return [
                        a,
                        b,
                        c
                    ];
                }
            }, $iv6Yc._1(aDecoder, a)), $iv6Yc._1(bDecoder, b)), $iv6Yc._1(cDecoder, c));
        });
    };
}
function $5351a5cabcc2510e$export$b14eba571629e996(aDecoder, bDecoder, cDecoder, dDecoder) {
    return function(j) {
        return $gTtop.flatMap($5351a5cabcc2510e$var$optToRes($1ArWc.decodeArray(j), {
            TAG: /* Failure */ 0,
            _0: "Expecting an ARRAY",
            _1: j
        }), function(arr) {
            if (arr.length !== 4) return {
                TAG: /* Error */ 1,
                _0: {
                    TAG: /* Failure */ 0,
                    _0: "Expecting an ARRAY with 4 elements",
                    _1: j
                }
            };
            var a = arr[0];
            var b = arr[1];
            var c = arr[2];
            var d = arr[3];
            return $5351a5cabcc2510e$var$resAndMap($5351a5cabcc2510e$var$resAndMap($5351a5cabcc2510e$var$resAndMap($5351a5cabcc2510e$var$resAndMap({
                TAG: /* Ok */ 0,
                _0: function _0(a, b, c, d) {
                    return [
                        a,
                        b,
                        c,
                        d
                    ];
                }
            }, $iv6Yc._1(aDecoder, a)), $iv6Yc._1(bDecoder, b)), $iv6Yc._1(cDecoder, c)), $iv6Yc._1(dDecoder, d));
        });
    };
}
function $5351a5cabcc2510e$export$51158e295b814981(aDecoder, bDecoder, cDecoder, dDecoder, eDecoder) {
    return function(j) {
        return $gTtop.flatMap($5351a5cabcc2510e$var$optToRes($1ArWc.decodeArray(j), {
            TAG: /* Failure */ 0,
            _0: "Expecting an ARRAY",
            _1: j
        }), function(arr) {
            if (arr.length !== 5) return {
                TAG: /* Error */ 1,
                _0: {
                    TAG: /* Failure */ 0,
                    _0: "Expecting an ARRAY with 5 elements",
                    _1: j
                }
            };
            var a = arr[0];
            var b = arr[1];
            var c = arr[2];
            var d = arr[3];
            var e = arr[4];
            return $5351a5cabcc2510e$var$resAndMap($5351a5cabcc2510e$var$resAndMap($5351a5cabcc2510e$var$resAndMap($5351a5cabcc2510e$var$resAndMap($5351a5cabcc2510e$var$resAndMap({
                TAG: /* Ok */ 0,
                _0: function _0(a, b, c, d, e) {
                    return [
                        a,
                        b,
                        c,
                        d,
                        e
                    ];
                }
            }, $iv6Yc._1(aDecoder, a)), $iv6Yc._1(bDecoder, b)), $iv6Yc._1(cDecoder, c)), $iv6Yc._1(dDecoder, d)), $iv6Yc._1(eDecoder, e));
        });
    };
}
function $5351a5cabcc2510e$export$f52b7ee4eabdb261(aDecoder, bDecoder, cDecoder, dDecoder, eDecoder, fDecoder) {
    return function(j) {
        return $gTtop.flatMap($5351a5cabcc2510e$var$optToRes($1ArWc.decodeArray(j), {
            TAG: /* Failure */ 0,
            _0: "Expecting an ARRAY",
            _1: j
        }), function(arr) {
            if (arr.length !== 6) return {
                TAG: /* Error */ 1,
                _0: {
                    TAG: /* Failure */ 0,
                    _0: "Expecting an ARRAY with 6 elements",
                    _1: j
                }
            };
            var a = arr[0];
            var b = arr[1];
            var c = arr[2];
            var d = arr[3];
            var e = arr[4];
            var f = arr[5];
            return $5351a5cabcc2510e$var$resAndMap($5351a5cabcc2510e$var$resAndMap($5351a5cabcc2510e$var$resAndMap($5351a5cabcc2510e$var$resAndMap($5351a5cabcc2510e$var$resAndMap($5351a5cabcc2510e$var$resAndMap({
                TAG: /* Ok */ 0,
                _0: function _0(a, b, c, d, e, f) {
                    return [
                        a,
                        b,
                        c,
                        d,
                        e,
                        f
                    ];
                }
            }, $iv6Yc._1(aDecoder, a)), $iv6Yc._1(bDecoder, b)), $iv6Yc._1(cDecoder, c)), $iv6Yc._1(dDecoder, d)), $iv6Yc._1(eDecoder, e)), $iv6Yc._1(fDecoder, f));
        });
    };
}
function $5351a5cabcc2510e$export$16acf2602fbdbf83(aDecoder, bDecoder, cDecoder, dDecoder, eDecoder, fDecoder, gDecoder) {
    return function(j) {
        return $gTtop.flatMap($5351a5cabcc2510e$var$optToRes($1ArWc.decodeArray(j), {
            TAG: /* Failure */ 0,
            _0: "Expecting an ARRAY",
            _1: j
        }), function(arr) {
            if (arr.length !== 7) return {
                TAG: /* Error */ 1,
                _0: {
                    TAG: /* Failure */ 0,
                    _0: "Expecting an ARRAY with 7 elements",
                    _1: j
                }
            };
            var a = arr[0];
            var b = arr[1];
            var c = arr[2];
            var d = arr[3];
            var e = arr[4];
            var f = arr[5];
            var g = arr[6];
            return $5351a5cabcc2510e$var$resAndMap($5351a5cabcc2510e$var$resAndMap($5351a5cabcc2510e$var$resAndMap($5351a5cabcc2510e$var$resAndMap($5351a5cabcc2510e$var$resAndMap($5351a5cabcc2510e$var$resAndMap($5351a5cabcc2510e$var$resAndMap({
                TAG: /* Ok */ 0,
                _0: function _0(a, b, c, d, e, f, g) {
                    return [
                        a,
                        b,
                        c,
                        d,
                        e,
                        f,
                        g
                    ];
                }
            }, $iv6Yc._1(aDecoder, a)), $iv6Yc._1(bDecoder, b)), $iv6Yc._1(cDecoder, c)), $iv6Yc._1(dDecoder, d)), $iv6Yc._1(eDecoder, e)), $iv6Yc._1(fDecoder, f)), $iv6Yc._1(gDecoder, g));
        });
    };
}
function $5351a5cabcc2510e$export$258c90b8fff5318e(aDecoder, bDecoder, cDecoder, dDecoder, eDecoder, fDecoder, gDecoder, hDecoder) {
    return function(j) {
        return $gTtop.flatMap($5351a5cabcc2510e$var$optToRes($1ArWc.decodeArray(j), {
            TAG: /* Failure */ 0,
            _0: "Expecting an ARRAY",
            _1: j
        }), function(arr) {
            if (arr.length !== 8) return {
                TAG: /* Error */ 1,
                _0: {
                    TAG: /* Failure */ 0,
                    _0: "Expecting an ARRAY with 8 elements",
                    _1: j
                }
            };
            var a = arr[0];
            var b = arr[1];
            var c = arr[2];
            var d = arr[3];
            var e = arr[4];
            var f = arr[5];
            var g = arr[6];
            var h = arr[7];
            return $5351a5cabcc2510e$var$resAndMap($5351a5cabcc2510e$var$resAndMap($5351a5cabcc2510e$var$resAndMap($5351a5cabcc2510e$var$resAndMap($5351a5cabcc2510e$var$resAndMap($5351a5cabcc2510e$var$resAndMap($5351a5cabcc2510e$var$resAndMap($5351a5cabcc2510e$var$resAndMap({
                TAG: /* Ok */ 0,
                _0: function _0(a, b, c, d, e, f, g, h) {
                    return [
                        a,
                        b,
                        c,
                        d,
                        e,
                        f,
                        g,
                        h
                    ];
                }
            }, $iv6Yc._1(aDecoder, a)), $iv6Yc._1(bDecoder, b)), $iv6Yc._1(cDecoder, c)), $iv6Yc._1(dDecoder, d)), $iv6Yc._1(eDecoder, e)), $iv6Yc._1(fDecoder, f)), $iv6Yc._1(gDecoder, g)), $iv6Yc._1(hDecoder, h));
        });
    };
}
function $5351a5cabcc2510e$var$fieldHelp(j, key) {
    return $gTtop.flatMap($5351a5cabcc2510e$var$optToRes($1ArWc.decodeObject(j), {
        TAG: /* Failure */ 0,
        _0: "Expecting an OBJECT with a field named '" + key + "'",
        _1: j
    }), function(sObj) {
        return $5351a5cabcc2510e$var$optToRes($d3YYW.get(sObj, key), {
            TAG: /* Failure */ 0,
            _0: "Expecting an OBJECT with a field named '" + key + "'",
            _1: j
        });
    });
}
function $5351a5cabcc2510e$export$e0f35d825088c098(key, aDecoder) {
    return function(j) {
        return $gTtop.flatMap($5351a5cabcc2510e$var$fieldHelp(j, key), function(jv) {
            return $5351a5cabcc2510e$var$resMapError($iv6Yc._1(aDecoder, jv), function(e) {
                return {
                    TAG: /* Field */ 2,
                    _0: key,
                    _1: e
                };
            });
        });
    };
}
function $5351a5cabcc2510e$var$atHelp(firstKey, keys, decoder) {
    return $5351a5cabcc2510e$export$e0f35d825088c098(firstKey, keys ? $5351a5cabcc2510e$var$atHelp(keys.hd, keys.tl, decoder) : decoder);
}
function $5351a5cabcc2510e$export$493d36ec626b6698(firstKey, keys, decoder) {
    return $5351a5cabcc2510e$var$atHelp(firstKey, $8ncuc.fromArray(keys), decoder);
}
function $5351a5cabcc2510e$export$b610b8812bbcded9(index$1, aDecoder) {
    return function(j) {
        return $gTtop.flatMap($gTtop.flatMap($5351a5cabcc2510e$var$optToRes($1ArWc.decodeArray(j), {
            TAG: /* Failure */ 0,
            _0: "Expecting an ARRAY",
            _1: j
        }), function(arr) {
            if (arr.length === 0) return {
                TAG: /* Error */ 1,
                _0: {
                    TAG: /* Failure */ 0,
                    _0: "Expecting a NON-EMPTY array. Need index " + String(index$1) + " but only saw an empty array",
                    _1: j
                }
            };
            else return $5351a5cabcc2510e$var$optToRes($i7mYY.get(arr, index$1), index$1 >= arr.length ? {
                TAG: /* Failure */ 0,
                _0: "Expecting a LONGER array. Need index " + String(index$1) + " but only saw " + String(arr.length) + " entries",
                _1: j
            } : {
                TAG: /* Failure */ 0,
                _0: "Expecting a POSITIVE index but saw " + String(index$1) + "",
                _1: j
            });
        }), function(jv) {
            return $5351a5cabcc2510e$var$resMapError($iv6Yc._1(aDecoder, jv), function(e) {
                return {
                    TAG: /* Index */ 1,
                    _0: index$1,
                    _1: e
                };
            });
        });
    };
}
function $5351a5cabcc2510e$export$a75d1723e6bda2ec(aDecoder) {
    return function(j) {
        return {
            TAG: /* Ok */ 0,
            _0: $gTtop.getWithDefault($gTtop.map($iv6Yc._1(aDecoder, j), function(a) {
                return $loT9g.some(a);
            }), undefined)
        };
    };
}
function $5351a5cabcc2510e$export$a9a18ae5ba42aeab(firstDecoder, decoders) {
    return function(j) {
        var a = $iv6Yc._1(firstDecoder, j);
        if (a.TAG === /* Ok */ 0) return {
            TAG: /* Ok */ 0,
            _0: a._0
        };
        else return $5351a5cabcc2510e$var$resMapError(decoders.reduce(function(acc, cur) {
            if (acc.TAG === /* Ok */ 0) return acc;
            var match = acc._0;
            var ne = $iv6Yc._1(cur, j);
            if (ne.TAG === /* Ok */ 0) return {
                TAG: /* Ok */ 0,
                _0: ne._0
            };
            else return {
                TAG: /* Error */ 1,
                _0: [
                    match[0],
                    {
                        hd: ne._0,
                        tl: match[1]
                    }
                ]
            };
        }, {
            TAG: /* Error */ 1,
            _0: [
                a._0,
                /* [] */ 0
            ]
        }), function(param) {
            return {
                TAG: /* OneOf */ 3,
                _0: param[0],
                _1: $8ncuc.toArray(param[1])
            };
        });
    };
}
function $5351a5cabcc2510e$var$fromString(s) {
    try {
        return $loT9g.some(JSON.parse(s));
    } catch (exn) {
        return;
    }
}
function $5351a5cabcc2510e$export$a0fb664af7d0cc44(s, decoder) {
    return $gTtop.flatMap($5351a5cabcc2510e$var$optToRes($5351a5cabcc2510e$var$fromString(s), {
        TAG: /* Failure */ 0,
        _0: "Invalid JSON",
        _1: s
    }), decoder);
}
function $5351a5cabcc2510e$export$1bc3347b5a3e0603(j, decoder) {
    return $iv6Yc._1(decoder, j);
}
function $5351a5cabcc2510e$var$joinList(l, s) {
    if (l) return $8ncuc.reduce(l.tl, l.hd, function(acc, cur) {
        return acc + s + cur;
    });
    else return "";
}
function $5351a5cabcc2510e$var$indent(str) {
    return $5351a5cabcc2510e$var$joinList($8ncuc.fromArray(str.split("\n")), "\n    ");
}
function $5351a5cabcc2510e$var$errorToStringHelp(_error, _context) {
    while(true){
        var context = _context;
        var error = _error;
        switch(error.TAG | 0){
            case /* Failure */ 0:
                var reveresed = $8ncuc.reverse(context);
                var intro = reveresed ? "Problem with the value at json" + $5351a5cabcc2510e$var$joinList(reveresed, "") + ":\n\n    " : "Problem with the given value:\n\n";
                return "" + intro + "" + $5351a5cabcc2510e$var$indent($AAkl8.encode(error._1, 4)) + "\n\n" + error._0 + "";
            case /* Index */ 1:
                var fieldName = "[" + String(error._0) + "]";
                _context = {
                    hd: fieldName,
                    tl: context
                };
                _error = error._1;
                continue;
            case /* Field */ 2:
                var fieldName$1 = '["' + error._0 + '"]';
                _context = {
                    hd: fieldName$1,
                    tl: context
                };
                _error = error._1;
                continue;
            case /* OneOf */ 3:
                var errs = error._1;
                var firstErr = error._0;
                if (errs.length !== 0) {
                    var reveresed$1 = $8ncuc.reverse(context);
                    var starter = reveresed$1 ? "oneOf at json" + $5351a5cabcc2510e$var$joinList(reveresed$1, "") + "" : "oneOf";
                    var intro$1 = "" + starter + " failed in the following " + String($8ncuc.length(context)) + " ways:";
                    return $5351a5cabcc2510e$var$joinList({
                        hd: intro$1,
                        tl: $8ncuc.mapWithIndex($8ncuc.fromArray($i7mYY.concat([
                            firstErr
                        ], errs)), function(i, err) {
                            return "\n\n(" + String(i + 1 | 0) + ") " + $5351a5cabcc2510e$var$indent($5351a5cabcc2510e$var$errorToStringHelp(err, /* [] */ 0));
                        })
                    }, "\n\n");
                }
                _error = firstErr;
                continue;
        }
    }
}
function $5351a5cabcc2510e$export$46c1952d522542d7(e) {
    return $5351a5cabcc2510e$var$errorToStringHelp(e, /* [] */ 0);
}
function $5351a5cabcc2510e$export$871de8747c9eaa88(decoder, f) {
    return function(j) {
        return $gTtop.map($iv6Yc._1(decoder, j), f);
    };
}
function $5351a5cabcc2510e$export$5be556bf484c4f10(decoderA, decoderB, f) {
    return function(j) {
        return $gTtop.flatMap($iv6Yc._1(decoderA, j), function(a) {
            return $gTtop.map($iv6Yc._1(decoderB, j), function(b) {
                return $iv6Yc._2(f, a, b);
            });
        });
    };
}
function $5351a5cabcc2510e$export$1ae5bb9217ed77cc(decoderF, decoderA) {
    return $5351a5cabcc2510e$export$5be556bf484c4f10(decoderF, decoderA, function(f, a) {
        return $iv6Yc._1(f, a);
    });
}
function $5351a5cabcc2510e$export$75050adc5191c049(v) {
    return function(j) {
        return $gTtop.map($5351a5cabcc2510e$var$optToRes($1ArWc.decodeNull(j), {
            TAG: /* Failure */ 0,
            _0: "invalid null",
            _1: j
        }), function(param) {
            return v;
        });
    };
}
function $5351a5cabcc2510e$export$133fc36489ac9add(decoder) {
    var f = function f(a) {
        return $loT9g.some(a);
    };
    return $5351a5cabcc2510e$export$a9a18ae5ba42aeab(function(j) {
        return $gTtop.map($iv6Yc._1(decoder, j), f);
    }, [
        $5351a5cabcc2510e$export$75050adc5191c049(undefined)
    ]);
}
function $5351a5cabcc2510e$export$2ab9a8f9f1186f14(j) {
    return {
        TAG: /* Ok */ 0,
        _0: j
    };
}
function $5351a5cabcc2510e$export$9768a9ae43d7f016(decoder, f) {
    return function(j) {
        return $gTtop.flatMap($iv6Yc._1(decoder, j), function(a) {
            var b = $iv6Yc._1(f, a);
            return $iv6Yc._1(b, j);
        });
    };
}
function $5351a5cabcc2510e$export$9094b7742a87955e(a) {
    return function(param) {
        return {
            TAG: /* Ok */ 0,
            _0: a
        };
    };
}
function $5351a5cabcc2510e$export$2b62a06a9fee979c(err) {
    return function(j) {
        return {
            TAG: /* Error */ 1,
            _0: {
                TAG: /* Failure */ 0,
                _0: err,
                _1: j
            }
        };
    };
}
function $5351a5cabcc2510e$export$f7389512af34c855(decoderA, decoderB, decoderC, f) {
    return $5351a5cabcc2510e$export$1ae5bb9217ed77cc($5351a5cabcc2510e$export$1ae5bb9217ed77cc($5351a5cabcc2510e$export$1ae5bb9217ed77cc(function(param) {
        return {
            TAG: /* Ok */ 0,
            _0: f
        };
    }, decoderA), decoderB), decoderC);
}
function $5351a5cabcc2510e$export$dddc425886bb4024(decoderA, decoderB, decoderC, decoderD, f) {
    return $5351a5cabcc2510e$export$1ae5bb9217ed77cc($5351a5cabcc2510e$export$1ae5bb9217ed77cc($5351a5cabcc2510e$export$1ae5bb9217ed77cc($5351a5cabcc2510e$export$1ae5bb9217ed77cc(function(param) {
        return {
            TAG: /* Ok */ 0,
            _0: f
        };
    }, decoderA), decoderB), decoderC), decoderD);
}
function $5351a5cabcc2510e$export$89e0958a4f22698b(decoderA, decoderB, decoderC, decoderD, decoderE, f) {
    return $5351a5cabcc2510e$export$1ae5bb9217ed77cc($5351a5cabcc2510e$export$1ae5bb9217ed77cc($5351a5cabcc2510e$export$1ae5bb9217ed77cc($5351a5cabcc2510e$export$1ae5bb9217ed77cc($5351a5cabcc2510e$export$1ae5bb9217ed77cc(function(param) {
        return {
            TAG: /* Ok */ 0,
            _0: f
        };
    }, decoderA), decoderB), decoderC), decoderD), decoderE);
}
function $5351a5cabcc2510e$export$93c2dc1c6eacd42c(decoderA, decoderB, decoderC, decoderD, decoderE, decoderF, f) {
    return $5351a5cabcc2510e$export$1ae5bb9217ed77cc($5351a5cabcc2510e$export$1ae5bb9217ed77cc($5351a5cabcc2510e$export$1ae5bb9217ed77cc($5351a5cabcc2510e$export$1ae5bb9217ed77cc($5351a5cabcc2510e$export$1ae5bb9217ed77cc($5351a5cabcc2510e$export$1ae5bb9217ed77cc(function(param) {
        return {
            TAG: /* Ok */ 0,
            _0: f
        };
    }, decoderA), decoderB), decoderC), decoderD), decoderE), decoderF);
}
function $5351a5cabcc2510e$export$a23802bf7d2b7306(decoderA, decoderB, decoderC, decoderD, decoderE, decoderF, decoderG, f) {
    return $5351a5cabcc2510e$export$1ae5bb9217ed77cc($5351a5cabcc2510e$export$1ae5bb9217ed77cc($5351a5cabcc2510e$export$1ae5bb9217ed77cc($5351a5cabcc2510e$export$1ae5bb9217ed77cc($5351a5cabcc2510e$export$1ae5bb9217ed77cc($5351a5cabcc2510e$export$1ae5bb9217ed77cc($5351a5cabcc2510e$export$1ae5bb9217ed77cc(function(param) {
        return {
            TAG: /* Ok */ 0,
            _0: f
        };
    }, decoderA), decoderB), decoderC), decoderD), decoderE), decoderF), decoderG);
}
function $5351a5cabcc2510e$export$308685edec35689e(decoderA, decoderB, decoderC, decoderD, decoderE, decoderF, decoderG, decoderH, f) {
    return $5351a5cabcc2510e$export$1ae5bb9217ed77cc($5351a5cabcc2510e$export$1ae5bb9217ed77cc($5351a5cabcc2510e$export$1ae5bb9217ed77cc($5351a5cabcc2510e$export$1ae5bb9217ed77cc($5351a5cabcc2510e$export$1ae5bb9217ed77cc($5351a5cabcc2510e$export$1ae5bb9217ed77cc($5351a5cabcc2510e$export$1ae5bb9217ed77cc($5351a5cabcc2510e$export$1ae5bb9217ed77cc(function(param) {
        return {
            TAG: /* Ok */ 0,
            _0: f
        };
    }, decoderA), decoderB), decoderC), decoderD), decoderE), decoderF), decoderG), decoderH);
}
 /* Json__Encode Not a pure module */ 
});
parcelRegister("1ArWc", function(module, exports) {

$parcel$export(module.exports, "classify", function () { return $127ed31820607685$export$b04d9b8d414ba5e8; });
$parcel$export(module.exports, "decodeString", function () { return $127ed31820607685$export$a0fb664af7d0cc44; });
$parcel$export(module.exports, "decodeNumber", function () { return $127ed31820607685$export$874d75d651b25595; });
$parcel$export(module.exports, "decodeObject", function () { return $127ed31820607685$export$57868717af36a6c; });
$parcel$export(module.exports, "decodeArray", function () { return $127ed31820607685$export$81879b02e9646afe; });
$parcel$export(module.exports, "decodeBoolean", function () { return $127ed31820607685$export$7e6b1898d6f2947e; });
$parcel$export(module.exports, "decodeNull", function () { return $127ed31820607685$export$d6ce7784e89e4f30; });

var $gfRPo = parcelRequire("gfRPo");

var $loT9g = parcelRequire("loT9g");
function $127ed31820607685$export$b04d9b8d414ba5e8(x) {
    var ty = typeof x === "undefined" ? "undefined" : (0, $gfRPo._)(x);
    if (ty === "string") return {
        TAG: /* JSONString */ 0,
        _0: x
    };
    else if (ty === "number") return {
        TAG: /* JSONNumber */ 1,
        _0: x
    };
    else if (ty === "boolean") {
        if (x === true) return /* JSONTrue */ 1;
        else return /* JSONFalse */ 0;
    } else if (x === null) return /* JSONNull */ 2;
    else if (Array.isArray(x)) return {
        TAG: /* JSONArray */ 3,
        _0: x
    };
    else return {
        TAG: /* JSONObject */ 2,
        _0: x
    };
}
function $127ed31820607685$export$e0969da9b8fb378d(x, v) {
    switch(v){
        case /* String */ 0:
            return typeof x === "string";
        case /* Number */ 1:
            return typeof x === "number";
        case /* Object */ 2:
            if (x !== null && typeof x === "object") return !Array.isArray(x);
            else return false;
        case /* Array */ 3:
            return Array.isArray(x);
        case /* Boolean */ 4:
            return typeof x === "boolean";
        case /* Null */ 5:
            return x === null;
    }
}
function $127ed31820607685$export$a0fb664af7d0cc44(json) {
    if (typeof json === "string") return json;
}
function $127ed31820607685$export$874d75d651b25595(json) {
    if (typeof json === "number") return json;
}
function $127ed31820607685$export$57868717af36a6c(json) {
    if (typeof json === "object" && !Array.isArray(json) && json !== null) return $loT9g.some(json);
}
function $127ed31820607685$export$81879b02e9646afe(json) {
    if (Array.isArray(json)) return json;
}
function $127ed31820607685$export$7e6b1898d6f2947e(json) {
    if (typeof json === "boolean") return json;
}
function $127ed31820607685$export$d6ce7784e89e4f30(json) {
    if (json === null) return null;
}
var $127ed31820607685$var$patch = function patch(json) {
    var x = [
        json
    ];
    var q = [
        {
            kind: 0,
            i: 0,
            parent: x
        }
    ];
    while(q.length !== 0){
        // begin pop the stack
        var cur = q[q.length - 1];
        if (cur.kind === 0) {
            cur.val = cur.parent[cur.i]; // patch the undefined value for array
            if (++cur.i === cur.parent.length) q.pop();
        } else q.pop();
        // finish
        var task = cur.val;
        if (typeof task === "object") {
            if (Array.isArray(task) && task.length !== 0) q.push({
                kind: 0,
                i: 0,
                parent: task,
                val: undefined
            });
            else for(var k in task){
                if (k === "RE_PRIVATE_NONE") {
                    if (cur.kind === 0) cur.parent[cur.i - 1] = undefined;
                    else cur.parent[cur.i] = undefined;
                    continue;
                }
                q.push({
                    kind: 1,
                    i: k,
                    parent: task,
                    val: task[k]
                });
            }
        }
    }
    return x[0];
};
function $127ed31820607685$export$d4424ececc0daddd(x) {
    return function(obj) {
        var output = JSON.stringify(obj, function(_, value) {
            if (value === undefined) return {
                RE_PRIVATE_NONE: true
            };
            return value;
        });
        if (output === undefined) // JSON.stringify will raise TypeError when it detects cylic objects
        throw new TypeError("output is undefined");
        return output;
    }(x);
}
function $127ed31820607685$export$9bd0effa93766bf1(s) {
    return $127ed31820607685$var$patch(JSON.parse(s));
}
 /* No side effect */ 
});

parcelRegister("gTtop", function(module, exports) {

$parcel$export(module.exports, "getExn", function () { return $c4c8952c771923ee$export$2d6fda808293d631; });
$parcel$export(module.exports, "map", function () { return $c4c8952c771923ee$export$871de8747c9eaa88; });
$parcel$export(module.exports, "flatMap", function () { return $c4c8952c771923ee$export$5b8affa63fc6df16; });
$parcel$export(module.exports, "getWithDefault", function () { return $c4c8952c771923ee$export$73b8ef55a37133c7; });

var $iv6Yc = parcelRequire("iv6Yc");
function $c4c8952c771923ee$export$2d6fda808293d631(x) {
    if (x.TAG === /* Ok */ 0) return x._0;
    throw {
        RE_EXN_ID: "Not_found",
        Error: new Error()
    };
}
function $c4c8952c771923ee$export$28a83b3631ef8d34(opt, $$default, f) {
    if (opt.TAG === /* Ok */ 0) return f(opt._0);
    else return $$default;
}
function $c4c8952c771923ee$export$ae51aac33fd70d30(opt, $$default, f) {
    return $c4c8952c771923ee$export$28a83b3631ef8d34(opt, $$default, $iv6Yc.__1(f));
}
function $c4c8952c771923ee$export$cc22bf2a9ce99b1(opt, f) {
    if (opt.TAG === /* Ok */ 0) return {
        TAG: /* Ok */ 0,
        _0: f(opt._0)
    };
    else return {
        TAG: /* Error */ 1,
        _0: opt._0
    };
}
function $c4c8952c771923ee$export$871de8747c9eaa88(opt, f) {
    return $c4c8952c771923ee$export$cc22bf2a9ce99b1(opt, $iv6Yc.__1(f));
}
function $c4c8952c771923ee$export$88eb46a8b99993cf(opt, f) {
    if (opt.TAG === /* Ok */ 0) return f(opt._0);
    else return {
        TAG: /* Error */ 1,
        _0: opt._0
    };
}
function $c4c8952c771923ee$export$5b8affa63fc6df16(opt, f) {
    return $c4c8952c771923ee$export$88eb46a8b99993cf(opt, $iv6Yc.__1(f));
}
function $c4c8952c771923ee$export$73b8ef55a37133c7(opt, $$default) {
    if (opt.TAG === /* Ok */ 0) return opt._0;
    else return $$default;
}
function $c4c8952c771923ee$export$71a04ee6075aae31(param) {
    if (param.TAG === /* Ok */ 0) return true;
    else return false;
}
function $c4c8952c771923ee$export$e6127cc7fe7395c3(param) {
    if (param.TAG === /* Ok */ 0) return false;
    else return true;
}
function $c4c8952c771923ee$export$f28cee400b9bf71f(a, b, f) {
    if (a.TAG === /* Ok */ 0) {
        if (b.TAG === /* Ok */ 0) return f(a._0, b._0);
        else return false;
    } else if (b.TAG === /* Ok */ 0) return false;
    else return true;
}
function $c4c8952c771923ee$export$9663ddc1cf085b32(a, b, f) {
    return $c4c8952c771923ee$export$f28cee400b9bf71f(a, b, $iv6Yc.__2(f));
}
function $c4c8952c771923ee$export$c0aec0f0618831d3(a, b, f) {
    if (a.TAG === /* Ok */ 0) {
        if (b.TAG === /* Ok */ 0) return f(a._0, b._0);
        else return 1;
    } else if (b.TAG === /* Ok */ 0) return -1;
    else return 0;
}
function $c4c8952c771923ee$export$6154dcdb7d23e37b(a, b, f) {
    return $c4c8952c771923ee$export$c0aec0f0618831d3(a, b, $iv6Yc.__2(f));
}
 /* No side effect */ 
});

parcelRegister("AAkl8", function(module, exports) {

$parcel$export(module.exports, "encode", function () { return $06df8ab499e05972$export$c564cdbbe6da493; });
$parcel$export(module.exports, "string", function () { return $06df8ab499e05972$export$22b082955e083ec3; });
$parcel$export(module.exports, "$$int", function () { return $06df8ab499e05972$export$b537f535eb826cd3; });
$parcel$export(module.exports, "$$float", function () { return $06df8ab499e05972$export$7af93c3912c36b2a; });
$parcel$export(module.exports, "bool", function () { return $06df8ab499e05972$export$87b259aa03e3d267; });
$parcel$export(module.exports, "$$null", function () { return $06df8ab499e05972$export$75050adc5191c049; });
$parcel$export(module.exports, "array", function () { return $06df8ab499e05972$export$2f23118c22fb2630; });
$parcel$export(module.exports, "list", function () { return $06df8ab499e05972$export$8837f4fc672e936d; });
$parcel$export(module.exports, "object", function () { return $06df8ab499e05972$export$be5493f9613cbbe; });
$parcel$export(module.exports, "dict", function () { return $06df8ab499e05972$export$b7eef48498bbd53e; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $d3YYW = parcelRequire("d3YYW");

var $8ncuc = parcelRequire("8ncuc");
function $06df8ab499e05972$export$c564cdbbe6da493(v, indentLevel) {
    return JSON.stringify(v, null, indentLevel);
}
function $06df8ab499e05972$export$22b082955e083ec3(prim) {
    return prim;
}
function $06df8ab499e05972$export$b537f535eb826cd3(i) {
    return i;
}
function $06df8ab499e05972$export$7af93c3912c36b2a(prim) {
    return prim;
}
function $06df8ab499e05972$export$87b259aa03e3d267(prim) {
    return prim;
}
var $06df8ab499e05972$export$75050adc5191c049 = null;
function $06df8ab499e05972$export$2f23118c22fb2630(arr, encodeI) {
    return arr.map($iv6Yc.__1(encodeI));
}
function $06df8ab499e05972$export$8837f4fc672e936d(l, encodeI) {
    return $8ncuc.toArray(l).map($iv6Yc.__1(encodeI));
}
var $06df8ab499e05972$export$be5493f9613cbbe = $d3YYW.fromArray;
function $06df8ab499e05972$export$b7eef48498bbd53e(obj) {
    return obj;
}
 /* null Not a pure module */ 
});


parcelRegister("doJJK", function(module, exports) {

$parcel$export(module.exports, "Make", function () { return $9c10fea84862ada0$export$ec284e6c61e81f96; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $79vie = parcelRequire("79vie");
function $9c10fea84862ada0$var$toDeccoError(e) {
    var errorStr = $79vie.errorToString(e);
    return {
        path: "unknown from rescript-json",
        message: errorStr,
        value: null
    };
}
function $9c10fea84862ada0$export$ec284e6c61e81f96(Serializable) {
    var t_encode = Serializable.toJson;
    var t_decode = function t_decode(json) {
        var ok = $79vie.decodeValue(json, Serializable.fromJson);
        if (ok.TAG === /* Ok */ 0) return {
            TAG: /* Ok */ 0,
            _0: ok._0
        };
        else return {
            TAG: /* Error */ 1,
            _0: $9c10fea84862ada0$var$toDeccoError(ok._0)
        };
    };
    var codec = [
        t_encode,
        t_decode
    ];
    return {
        t_encode: t_encode,
        t_decode: t_decode,
        codec: codec
    };
}
function $9c10fea84862ada0$export$9e9dc98d17ddfffc(RecursiveSerializable) {
    var t_encode = RecursiveSerializable.toJson;
    var t_decode = function t_decode(json) {
        var ok = $79vie.decodeValue(json, $iv6Yc._1(RecursiveSerializable.fromJson, undefined));
        if (ok.TAG === /* Ok */ 0) return {
            TAG: /* Ok */ 0,
            _0: ok._0
        };
        else return {
            TAG: /* Error */ 1,
            _0: $9c10fea84862ada0$var$toDeccoError(ok._0)
        };
    };
    var codec = [
        t_encode,
        t_decode
    ];
    return {
        t_encode: t_encode,
        t_decode: t_decode,
        codec: codec
    };
}
 /* Json__Decode Not a pure module */ 
});



parcelRegister("gwEzd", function(module, exports) {

$parcel$export(module.exports, "parse", function () { return $c07f1a400119ffd3$export$98e6a39c04603d36; });
$parcel$export(module.exports, "format", function () { return $c07f1a400119ffd3$export$d9468344d3651243; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $loT9g = parcelRequire("loT9g");

var $gjrxO = parcelRequire("gjrxO");
function $c07f1a400119ffd3$export$58fbacee5f6146c9(a) {
    try {
        return $gjrxO.default(a);
    } catch (exn) {
        return $gjrxO(a);
    }
}
function $c07f1a400119ffd3$export$98e6a39c04603d36(str) {
    var res = $c07f1a400119ffd3$export$58fbacee5f6146c9(str);
    var res$1 = res == null ? undefined : $loT9g.some(res);
    if (res == null) return res$1;
    else if (res.currency === "" && res.symbol === "$") return {
        value: res.value,
        currency: "USD",
        symbol: res.symbol
    };
    else if (res.currency === "" && res.symbol === "\u20B9") return {
        value: res.value,
        currency: "INR",
        symbol: res.symbol
    };
    else if (res.currency === "") return;
    else return res$1;
}
function $c07f1a400119ffd3$export$d9468344d3651243(parseResult) {
    var match = parseResult.currency;
    var tmp = match === "DKK" ? "de-DK" : "en-US";
    return parseResult.value.toLocaleString(tmp, {
        style: "currency",
        currency: parseResult.currency,
        minimumFractionDigits: parseResult.value === Math.round(parseResult.value) ? 0 : 2
    });
}
 /* parsecurrency Not a pure module */ 
});
parcelRegister("gjrxO", function(module, exports) {
var $be03c969955178b3$var$currencyMatcher = /^(?:([A-Z]{3}) ?)?(?:([^\d ]+?) ?)?(((?:\d{1,3}([,. ’'\u00A0]))*?\d{1,})(([,.])\d{1,2})?)(?: ?([^\d ]+?))??(?: ?([A-Z]{3}))?$/;
var $be03c969955178b3$var$gr = /^\d{1,3}([,. ’'\u00A0]\d{3})*$/; // validate groups
var $be03c969955178b3$var$ind = /^\d{1,2}(,\d{2})*(,\d{3})?$/; // exception for Indian number format
module.exports = function parseCurrency(priceStr) {
    if (!priceStr || !priceStr.match) return null;
    priceStr = priceStr.trim();
    var match = priceStr.match($be03c969955178b3$var$currencyMatcher);
    if (!match) return null;
    var groupSeparator = match[5] || "";
    var decimalSeparator = match[7] || "";
    if (groupSeparator === decimalSeparator && decimalSeparator) return null;
    var integer = match[4];
    if (groupSeparator && !integer.match($be03c969955178b3$var$gr) && !integer.match($be03c969955178b3$var$ind)) return null;
    var value = match[3];
    if (!value) return null;
    if (groupSeparator) value = value.replace(RegExp("\\" + groupSeparator, "g"), "");
    if (decimalSeparator) value = value.replace(decimalSeparator, ".");
    var numericVal = +value;
    if (typeof numericVal !== "number" || isNaN(numericVal)) return null;
    return {
        raw: priceStr,
        value: numericVal,
        integer: integer || "",
        decimals: match[6] || "",
        currency: match[1] || match[9] || "",
        symbol: match[2] || match[8] || "",
        decimalSeparator: decimalSeparator,
        groupSeparator: groupSeparator
    };
};

});


parcelRegister("8dLtV", function(module, exports) {

$parcel$export(module.exports, "knownEmbeds", function () { return $5fc45e81fb5ef04f$export$995786f782b48a21; });
$parcel$export(module.exports, "make", function () { return $5fc45e81fb5ef04f$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $g85JO = parcelRequire("g85JO");

var $d3YYW = parcelRequire("d3YYW");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");
var $5fc45e81fb5ef04f$export$995786f782b48a21 = $d3YYW.fromArray([
    [
        "https://www.youtube.com/embed/",
        {
            autoplayParam: "autoplay=1",
            loopParam: "loop=1"
        }
    ],
    [
        "https://player.vimeo.com/video/",
        {
            autoplayParam: "autoplay=1",
            loopParam: "loop=1"
        }
    ],
    [
        "https://play.gumlet.io/embed/",
        {
            autoplayParam: "autoplay=true",
            loopParam: "loop=true"
        }
    ],
    [
        "https://vimeo.gumlet.io/embed/",
        {
            autoplayParam: "autoplay=true",
            loopParam: "loop=true"
        }
    ]
]);
function $5fc45e81fb5ef04f$var$IframeEmbed(Props) {
    var url = Props.url;
    var widthFullOpt = Props.widthFull;
    var heightFullOpt = Props.heightFull;
    var interactiveOpt = Props.interactive;
    var autoplayOpt = Props.autoplay;
    var loopOpt = Props.loop;
    var widthFull = widthFullOpt !== undefined ? widthFullOpt : true;
    var heightFull = heightFullOpt !== undefined ? heightFullOpt : true;
    var interactive = interactiveOpt !== undefined ? interactiveOpt : false;
    var autoplay = autoplayOpt !== undefined ? autoplayOpt : true;
    var loop = loopOpt !== undefined ? loopOpt : true;
    var config = $2whNH.flatMap($i7mYY.getBy(Object.keys($5fc45e81fb5ef04f$export$995786f782b48a21), function(param) {
        return url.startsWith(param);
    }), function(param) {
        return $d3YYW.get($5fc45e81fb5ef04f$export$995786f782b48a21, param);
    });
    var autoplayParam = autoplay ? $2whNH.map(config, function(c) {
        return c.autoplayParam;
    }) : undefined;
    var loopParam = loop ? $2whNH.map(config, function(c) {
        return c.loopParam;
    }) : undefined;
    var params = $i7mYY.keepMap([
        autoplayParam,
        loopParam
    ], function(a) {
        return a;
    }).join("&");
    var url$1 = $i7mYY.keepMap([
        url,
        params
    ], function(a) {
        return a;
    }).join("?");
    return /*#__PURE__*/ $g85JO.createElement("iframe", {
        style: {
            border: "none",
            height: heightFull ? "100%" : "auto",
            overflow: "hidden",
            width: widthFull ? "100%" : "auto",
            pointerEvents: interactive ? "auto" : "none"
        },
        src: url$1
    });
}
$5fc45e81fb5ef04f$var$IframeEmbed.displayName = "IframeEmbed";
var $5fc45e81fb5ef04f$export$dd44f18ab656f3bb = $5fc45e81fb5ef04f$var$IframeEmbed;
 /* knownEmbeds Not a pure module */ 
});
parcelRegister("g85JO", function(module, exports) {
"use strict";

module.exports = (parcelRequire("6mHgG"));

});
parcelRegister("6mHgG", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $4a265c46e3f8f73b$export$dca3b0875bd9a954; }, function (v) { return $4a265c46e3f8f73b$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $4a265c46e3f8f73b$export$16fa2f45be04daa8; }, function (v) { return $4a265c46e3f8f73b$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $4a265c46e3f8f73b$export$ffb0004e005737fa; }, function (v) { return $4a265c46e3f8f73b$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $4a265c46e3f8f73b$export$e2c29f18771995cb; }, function (v) { return $4a265c46e3f8f73b$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $4a265c46e3f8f73b$export$221d75b3f55bb0bd; }, function (v) { return $4a265c46e3f8f73b$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $4a265c46e3f8f73b$export$5f8d39834fd61797; }, function (v) { return $4a265c46e3f8f73b$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $4a265c46e3f8f73b$export$74bf444e3cd11ea5; }, function (v) { return $4a265c46e3f8f73b$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $4a265c46e3f8f73b$export$ae55be85d98224ed; }, function (v) { return $4a265c46e3f8f73b$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $4a265c46e3f8f73b$export$e530037191fcd5d7; }, function (v) { return $4a265c46e3f8f73b$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $4a265c46e3f8f73b$export$fd42f52fd3ae1109; }, function (v) { return $4a265c46e3f8f73b$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $4a265c46e3f8f73b$export$c8a8987d4410bf2d; }, function (v) { return $4a265c46e3f8f73b$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $4a265c46e3f8f73b$export$d38cd72104c1f0e9; }, function (v) { return $4a265c46e3f8f73b$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $4a265c46e3f8f73b$export$7d1e3a5e95ceca43; }, function (v) { return $4a265c46e3f8f73b$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $4a265c46e3f8f73b$export$257a8862b851cb5b; }, function (v) { return $4a265c46e3f8f73b$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $4a265c46e3f8f73b$export$a8257692ac88316c; }, function (v) { return $4a265c46e3f8f73b$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $4a265c46e3f8f73b$export$488013bae63b21da; }, function (v) { return $4a265c46e3f8f73b$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $4a265c46e3f8f73b$export$7c73462e0d25e514; }, function (v) { return $4a265c46e3f8f73b$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "useCallback", function () { return $4a265c46e3f8f73b$export$35808ee640e87ca7; }, function (v) { return $4a265c46e3f8f73b$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $4a265c46e3f8f73b$export$fae74005e78b1a27; }, function (v) { return $4a265c46e3f8f73b$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $4a265c46e3f8f73b$export$dc8fbce3eb94dc1e; }, function (v) { return $4a265c46e3f8f73b$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useEffect", function () { return $4a265c46e3f8f73b$export$6d9c69b0de29b591; }, function (v) { return $4a265c46e3f8f73b$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $4a265c46e3f8f73b$export$d5a552a76deda3c2; }, function (v) { return $4a265c46e3f8f73b$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $4a265c46e3f8f73b$export$e5c5a5f917a5871c; }, function (v) { return $4a265c46e3f8f73b$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $4a265c46e3f8f73b$export$1538c33de8887b59; }, function (v) { return $4a265c46e3f8f73b$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $4a265c46e3f8f73b$export$13e3392192263954; }, function (v) { return $4a265c46e3f8f73b$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $4a265c46e3f8f73b$export$b8f5890fc79d6aca; }, function (v) { return $4a265c46e3f8f73b$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $4a265c46e3f8f73b$export$60241385465d0a34; }, function (v) { return $4a265c46e3f8f73b$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "version", function () { return $4a265c46e3f8f73b$export$83d89fbfd8236492; }, function (v) { return $4a265c46e3f8f73b$export$83d89fbfd8236492 = v; });
/** @license React v16.14.0
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $gfRPo = parcelRequire("gfRPo");
var $4a265c46e3f8f73b$export$dca3b0875bd9a954;
var $4a265c46e3f8f73b$export$16fa2f45be04daa8;
var $4a265c46e3f8f73b$export$ffb0004e005737fa;
var $4a265c46e3f8f73b$export$e2c29f18771995cb;
var $4a265c46e3f8f73b$export$221d75b3f55bb0bd;
var $4a265c46e3f8f73b$export$5f8d39834fd61797;
var $4a265c46e3f8f73b$export$74bf444e3cd11ea5;
var $4a265c46e3f8f73b$export$ae55be85d98224ed;
var $4a265c46e3f8f73b$export$e530037191fcd5d7;
var $4a265c46e3f8f73b$export$fd42f52fd3ae1109;
var $4a265c46e3f8f73b$export$c8a8987d4410bf2d;
var $4a265c46e3f8f73b$export$d38cd72104c1f0e9;
var $4a265c46e3f8f73b$export$7d1e3a5e95ceca43;
var $4a265c46e3f8f73b$export$257a8862b851cb5b;
var $4a265c46e3f8f73b$export$a8257692ac88316c;
var $4a265c46e3f8f73b$export$488013bae63b21da;
var $4a265c46e3f8f73b$export$7c73462e0d25e514;
var $4a265c46e3f8f73b$export$35808ee640e87ca7;
var $4a265c46e3f8f73b$export$fae74005e78b1a27;
var $4a265c46e3f8f73b$export$dc8fbce3eb94dc1e;
var $4a265c46e3f8f73b$export$6d9c69b0de29b591;
var $4a265c46e3f8f73b$export$d5a552a76deda3c2;
var $4a265c46e3f8f73b$export$e5c5a5f917a5871c;
var $4a265c46e3f8f73b$export$1538c33de8887b59;
var $4a265c46e3f8f73b$export$13e3392192263954;
var $4a265c46e3f8f73b$export$b8f5890fc79d6aca;
var $4a265c46e3f8f73b$export$60241385465d0a34;
var $4a265c46e3f8f73b$export$83d89fbfd8236492;
"use strict";

var $22Kv0 = parcelRequire("22Kv0");
var $4a265c46e3f8f73b$var$n = "function" === typeof Symbol && Symbol.for, $4a265c46e3f8f73b$var$p = $4a265c46e3f8f73b$var$n ? Symbol.for("react.element") : 60103, $4a265c46e3f8f73b$var$q = $4a265c46e3f8f73b$var$n ? Symbol.for("react.portal") : 60106, $4a265c46e3f8f73b$var$r = $4a265c46e3f8f73b$var$n ? Symbol.for("react.fragment") : 60107, $4a265c46e3f8f73b$var$t = $4a265c46e3f8f73b$var$n ? Symbol.for("react.strict_mode") : 60108, $4a265c46e3f8f73b$var$u = $4a265c46e3f8f73b$var$n ? Symbol.for("react.profiler") : 60114, $4a265c46e3f8f73b$var$v = $4a265c46e3f8f73b$var$n ? Symbol.for("react.provider") : 60109, $4a265c46e3f8f73b$var$w = $4a265c46e3f8f73b$var$n ? Symbol.for("react.context") : 60110, $4a265c46e3f8f73b$var$x = $4a265c46e3f8f73b$var$n ? Symbol.for("react.forward_ref") : 60112, $4a265c46e3f8f73b$var$y = $4a265c46e3f8f73b$var$n ? Symbol.for("react.suspense") : 60113, $4a265c46e3f8f73b$var$z = $4a265c46e3f8f73b$var$n ? Symbol.for("react.memo") : 60115, $4a265c46e3f8f73b$var$A = $4a265c46e3f8f73b$var$n ? Symbol.for("react.lazy") : 60116, $4a265c46e3f8f73b$var$B = "function" === typeof Symbol && Symbol.iterator;
function $4a265c46e3f8f73b$var$C(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $4a265c46e3f8f73b$var$D = {
    isMounted: function isMounted() {
        return !1;
    },
    enqueueForceUpdate: function enqueueForceUpdate() {},
    enqueueReplaceState: function enqueueReplaceState() {},
    enqueueSetState: function enqueueSetState() {}
}, $4a265c46e3f8f73b$var$E = {};
function $4a265c46e3f8f73b$var$F(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $4a265c46e3f8f73b$var$E;
    this.updater = c || $4a265c46e3f8f73b$var$D;
}
$4a265c46e3f8f73b$var$F.prototype.isReactComponent = {};
$4a265c46e3f8f73b$var$F.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error($4a265c46e3f8f73b$var$C(85));
    this.updater.enqueueSetState(this, a, b, "setState");
};
$4a265c46e3f8f73b$var$F.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $4a265c46e3f8f73b$var$G() {}
$4a265c46e3f8f73b$var$G.prototype = $4a265c46e3f8f73b$var$F.prototype;
function $4a265c46e3f8f73b$var$H(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $4a265c46e3f8f73b$var$E;
    this.updater = c || $4a265c46e3f8f73b$var$D;
}
var $4a265c46e3f8f73b$var$I = $4a265c46e3f8f73b$var$H.prototype = new $4a265c46e3f8f73b$var$G;
$4a265c46e3f8f73b$var$I.constructor = $4a265c46e3f8f73b$var$H;
$22Kv0($4a265c46e3f8f73b$var$I, $4a265c46e3f8f73b$var$F.prototype);
$4a265c46e3f8f73b$var$I.isPureReactComponent = !0;
var $4a265c46e3f8f73b$var$J = {
    current: null
}, $4a265c46e3f8f73b$var$K = Object.prototype.hasOwnProperty, $4a265c46e3f8f73b$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $4a265c46e3f8f73b$var$M(a, b, c) {
    var e, d = {}, g = null, k = null;
    if (null != b) for(e in void 0 !== b.ref && (k = b.ref), void 0 !== b.key && (g = "" + b.key), b)$4a265c46e3f8f73b$var$K.call(b, e) && !$4a265c46e3f8f73b$var$L.hasOwnProperty(e) && (d[e] = b[e]);
    var f = arguments.length - 2;
    if (1 === f) d.children = c;
    else if (1 < f) {
        for(var h = Array(f), m = 0; m < f; m++)h[m] = arguments[m + 2];
        d.children = h;
    }
    if (a && a.defaultProps) for(e in f = a.defaultProps, f)void 0 === d[e] && (d[e] = f[e]);
    return {
        $$typeof: $4a265c46e3f8f73b$var$p,
        type: a,
        key: g,
        ref: k,
        props: d,
        _owner: $4a265c46e3f8f73b$var$J.current
    };
}
function $4a265c46e3f8f73b$var$N(a, b) {
    return {
        $$typeof: $4a265c46e3f8f73b$var$p,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $4a265c46e3f8f73b$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $4a265c46e3f8f73b$var$p;
}
function $4a265c46e3f8f73b$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + ("" + a).replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $4a265c46e3f8f73b$var$P = /\/+/g, $4a265c46e3f8f73b$var$Q = [];
function $4a265c46e3f8f73b$var$R(a, b, c, e) {
    if ($4a265c46e3f8f73b$var$Q.length) {
        var d = $4a265c46e3f8f73b$var$Q.pop();
        d.result = a;
        d.keyPrefix = b;
        d.func = c;
        d.context = e;
        d.count = 0;
        return d;
    }
    return {
        result: a,
        keyPrefix: b,
        func: c,
        context: e,
        count: 0
    };
}
function $4a265c46e3f8f73b$var$S(a) {
    a.result = null;
    a.keyPrefix = null;
    a.func = null;
    a.context = null;
    a.count = 0;
    10 > $4a265c46e3f8f73b$var$Q.length && $4a265c46e3f8f73b$var$Q.push(a);
}
function $4a265c46e3f8f73b$var$T(a, b, c, e) {
    var d = typeof a === "undefined" ? "undefined" : (0, $gfRPo._)(a);
    if ("undefined" === d || "boolean" === d) a = null;
    var g = !1;
    if (null === a) g = !0;
    else switch(d){
        case "string":
        case "number":
            g = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $4a265c46e3f8f73b$var$p:
                case $4a265c46e3f8f73b$var$q:
                    g = !0;
            }
    }
    if (g) return c(e, a, "" === b ? "." + $4a265c46e3f8f73b$var$U(a, 0) : b), 1;
    g = 0;
    b = "" === b ? "." : b + ":";
    if (Array.isArray(a)) for(var k = 0; k < a.length; k++){
        d = a[k];
        var f = b + $4a265c46e3f8f73b$var$U(d, k);
        g += $4a265c46e3f8f73b$var$T(d, f, c, e);
    }
    else if (null === a || "object" !== typeof a ? f = null : (f = $4a265c46e3f8f73b$var$B && a[$4a265c46e3f8f73b$var$B] || a["@@iterator"], f = "function" === typeof f ? f : null), "function" === typeof f) for(a = f.call(a), k = 0; !(d = a.next()).done;)d = d.value, f = b + $4a265c46e3f8f73b$var$U(d, k++), g += $4a265c46e3f8f73b$var$T(d, f, c, e);
    else if ("object" === d) throw c = "" + a, Error($4a265c46e3f8f73b$var$C(31, "[object Object]" === c ? "object with keys {" + Object.keys(a).join(", ") + "}" : c, ""));
    return g;
}
function $4a265c46e3f8f73b$var$V(a, b, c) {
    return null == a ? 0 : $4a265c46e3f8f73b$var$T(a, "", b, c);
}
function $4a265c46e3f8f73b$var$U(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $4a265c46e3f8f73b$var$escape(a.key) : b.toString(36);
}
function $4a265c46e3f8f73b$var$W(a, b) {
    a.func.call(a.context, b, a.count++);
}
function $4a265c46e3f8f73b$var$aa(a, b, c) {
    var e = a.result, d = a.keyPrefix;
    a = a.func.call(a.context, b, a.count++);
    Array.isArray(a) ? $4a265c46e3f8f73b$var$X(a, e, c, function(a) {
        return a;
    }) : null != a && ($4a265c46e3f8f73b$var$O(a) && (a = $4a265c46e3f8f73b$var$N(a, d + (!a.key || b && b.key === a.key ? "" : ("" + a.key).replace($4a265c46e3f8f73b$var$P, "$&/") + "/") + c)), e.push(a));
}
function $4a265c46e3f8f73b$var$X(a, b, c, e, d) {
    var g = "";
    null != c && (g = ("" + c).replace($4a265c46e3f8f73b$var$P, "$&/") + "/");
    b = $4a265c46e3f8f73b$var$R(b, g, e, d);
    $4a265c46e3f8f73b$var$V(a, $4a265c46e3f8f73b$var$aa, b);
    $4a265c46e3f8f73b$var$S(b);
}
var $4a265c46e3f8f73b$var$Y = {
    current: null
};
function $4a265c46e3f8f73b$var$Z() {
    var a = $4a265c46e3f8f73b$var$Y.current;
    if (null === a) throw Error($4a265c46e3f8f73b$var$C(321));
    return a;
}
var $4a265c46e3f8f73b$var$ba = {
    ReactCurrentDispatcher: $4a265c46e3f8f73b$var$Y,
    ReactCurrentBatchConfig: {
        suspense: null
    },
    ReactCurrentOwner: $4a265c46e3f8f73b$var$J,
    IsSomeRendererActing: {
        current: !1
    },
    assign: $22Kv0
};
$4a265c46e3f8f73b$export$dca3b0875bd9a954 = {
    map: function map(a, b, c) {
        if (null == a) return a;
        var e = [];
        $4a265c46e3f8f73b$var$X(a, e, null, b, c);
        return e;
    },
    forEach: function forEach(a, b, c) {
        if (null == a) return a;
        b = $4a265c46e3f8f73b$var$R(null, null, b, c);
        $4a265c46e3f8f73b$var$V(a, $4a265c46e3f8f73b$var$W, b);
        $4a265c46e3f8f73b$var$S(b);
    },
    count: function count(a) {
        return $4a265c46e3f8f73b$var$V(a, function() {
            return null;
        }, null);
    },
    toArray: function toArray(a) {
        var b = [];
        $4a265c46e3f8f73b$var$X(a, b, null, function(a) {
            return a;
        });
        return b;
    },
    only: function only(a) {
        if (!$4a265c46e3f8f73b$var$O(a)) throw Error($4a265c46e3f8f73b$var$C(143));
        return a;
    }
};
$4a265c46e3f8f73b$export$16fa2f45be04daa8 = $4a265c46e3f8f73b$var$F;
$4a265c46e3f8f73b$export$ffb0004e005737fa = $4a265c46e3f8f73b$var$r;
$4a265c46e3f8f73b$export$e2c29f18771995cb = $4a265c46e3f8f73b$var$u;
$4a265c46e3f8f73b$export$221d75b3f55bb0bd = $4a265c46e3f8f73b$var$H;
$4a265c46e3f8f73b$export$5f8d39834fd61797 = $4a265c46e3f8f73b$var$t;
$4a265c46e3f8f73b$export$74bf444e3cd11ea5 = $4a265c46e3f8f73b$var$y;
$4a265c46e3f8f73b$export$ae55be85d98224ed = $4a265c46e3f8f73b$var$ba;
$4a265c46e3f8f73b$export$e530037191fcd5d7 = function(a, b, c) {
    if (null === a || void 0 === a) throw Error($4a265c46e3f8f73b$var$C(267, a));
    var e = $22Kv0({}, a.props), d = a.key, g = a.ref, k = a._owner;
    if (null != b) {
        void 0 !== b.ref && (g = b.ref, k = $4a265c46e3f8f73b$var$J.current);
        void 0 !== b.key && (d = "" + b.key);
        if (a.type && a.type.defaultProps) var f = a.type.defaultProps;
        for(h in b)$4a265c46e3f8f73b$var$K.call(b, h) && !$4a265c46e3f8f73b$var$L.hasOwnProperty(h) && (e[h] = void 0 === b[h] && void 0 !== f ? f[h] : b[h]);
    }
    var h = arguments.length - 2;
    if (1 === h) e.children = c;
    else if (1 < h) {
        f = Array(h);
        for(var m = 0; m < h; m++)f[m] = arguments[m + 2];
        e.children = f;
    }
    return {
        $$typeof: $4a265c46e3f8f73b$var$p,
        type: a.type,
        key: d,
        ref: g,
        props: e,
        _owner: k
    };
};
$4a265c46e3f8f73b$export$fd42f52fd3ae1109 = function(a, b) {
    void 0 === b && (b = null);
    a = {
        $$typeof: $4a265c46e3f8f73b$var$w,
        _calculateChangedBits: b,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    a.Provider = {
        $$typeof: $4a265c46e3f8f73b$var$v,
        _context: a
    };
    return a.Consumer = a;
};
$4a265c46e3f8f73b$export$c8a8987d4410bf2d = $4a265c46e3f8f73b$var$M;
$4a265c46e3f8f73b$export$d38cd72104c1f0e9 = function(a) {
    var b = $4a265c46e3f8f73b$var$M.bind(null, a);
    b.type = a;
    return b;
};
$4a265c46e3f8f73b$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$4a265c46e3f8f73b$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $4a265c46e3f8f73b$var$x,
        render: a
    };
};
$4a265c46e3f8f73b$export$a8257692ac88316c = $4a265c46e3f8f73b$var$O;
$4a265c46e3f8f73b$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $4a265c46e3f8f73b$var$A,
        _ctor: a,
        _status: -1,
        _result: null
    };
};
$4a265c46e3f8f73b$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $4a265c46e3f8f73b$var$z,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$4a265c46e3f8f73b$export$35808ee640e87ca7 = function(a, b) {
    return $4a265c46e3f8f73b$var$Z().useCallback(a, b);
};
$4a265c46e3f8f73b$export$fae74005e78b1a27 = function(a, b) {
    return $4a265c46e3f8f73b$var$Z().useContext(a, b);
};
$4a265c46e3f8f73b$export$dc8fbce3eb94dc1e = function() {};
$4a265c46e3f8f73b$export$6d9c69b0de29b591 = function(a, b) {
    return $4a265c46e3f8f73b$var$Z().useEffect(a, b);
};
$4a265c46e3f8f73b$export$d5a552a76deda3c2 = function(a, b, c) {
    return $4a265c46e3f8f73b$var$Z().useImperativeHandle(a, b, c);
};
$4a265c46e3f8f73b$export$e5c5a5f917a5871c = function(a, b) {
    return $4a265c46e3f8f73b$var$Z().useLayoutEffect(a, b);
};
$4a265c46e3f8f73b$export$1538c33de8887b59 = function(a, b) {
    return $4a265c46e3f8f73b$var$Z().useMemo(a, b);
};
$4a265c46e3f8f73b$export$13e3392192263954 = function(a, b, c) {
    return $4a265c46e3f8f73b$var$Z().useReducer(a, b, c);
};
$4a265c46e3f8f73b$export$b8f5890fc79d6aca = function(a) {
    return $4a265c46e3f8f73b$var$Z().useRef(a);
};
$4a265c46e3f8f73b$export$60241385465d0a34 = function(a) {
    return $4a265c46e3f8f73b$var$Z().useState(a);
};
$4a265c46e3f8f73b$export$83d89fbfd8236492 = "16.14.0";

});
parcelRegister("22Kv0", function(module, exports) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ "use strict";
/* eslint-disable no-unused-vars */ var $17cfd6695af3e4f0$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $17cfd6695af3e4f0$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $17cfd6695af3e4f0$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $17cfd6695af3e4f0$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(val);
}
function $17cfd6695af3e4f0$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String("abc"); // eslint-disable-line no-new-wrappers
        test1[5] = "de";
        if (Object.getOwnPropertyNames(test1)[0] === "5") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2["_" + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join("") !== "0123456789") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        "abcdefghijklmnopqrst".split("").forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = $17cfd6695af3e4f0$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $17cfd6695af3e4f0$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($17cfd6695af3e4f0$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($17cfd6695af3e4f0$var$getOwnPropertySymbols) {
            symbols = $17cfd6695af3e4f0$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($17cfd6695af3e4f0$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

});




parcelRegister("eFryz", function(module, exports) {

$parcel$export(module.exports, "getUnique", function () { return $aada452be983ec31$export$7cbdfefc5f05c1c5; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $d3YYW = parcelRequire("d3YYW");

var $i7mYY = parcelRequire("i7mYY");
function $aada452be983ec31$export$7cbdfefc5f05c1c5(array, getKey) {
    var chosen = {};
    var idsInOrder = [];
    $i7mYY.forEach(array, function(p) {
        var curChosen = $d3YYW.get(chosen, $iv6Yc._1(getKey, p));
        if (curChosen !== undefined) return;
        else {
            idsInOrder.push($iv6Yc._1(getKey, p));
            chosen[$iv6Yc._1(getKey, p)] = p;
            return;
        }
    });
    return $i7mYY.keepMap(idsInOrder, function(id) {
        return $d3YYW.get(chosen, id);
    });
}
 /* No side effect */ 
});

parcelRegister("8L1B1", function(module, exports) {

$parcel$export(module.exports, "getStoreTypeByStoreId", function () { return $6603f37ba6649b1d$export$dc5ed4dccf692eb0; });
$parcel$export(module.exports, "use", function () { return $6603f37ba6649b1d$export$1f96ae73734a86cc; });
$parcel$export(module.exports, "make", function () { return $6603f37ba6649b1d$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $g85JO = parcelRequire("g85JO");
function $6603f37ba6649b1d$export$dc5ed4dccf692eb0(storeId) {
    if (storeId !== undefined) {
        if (storeId.startsWith("maker-legacy-graphql")) return {
            TAG: /* Maker */ 0,
            _0: storeId
        };
        else return {
            TAG: /* Shopify */ 1,
            _0: storeId
        };
    } else return /* Unknown */ 0;
}
var $6603f37ba6649b1d$export$a078c61943f9dbbe = /*#__PURE__*/ $g85JO.createContext(/* Unknown */ 0);
var $6603f37ba6649b1d$export$ca328f169d304df4 = $6603f37ba6649b1d$export$a078c61943f9dbbe.Provider;
function $6603f37ba6649b1d$var$StoreProvider(Props) {
    var config = Props.config;
    var children = Props.children;
    var value = $6603f37ba6649b1d$export$dc5ed4dccf692eb0(config.transitiveStoreId);
    return /*#__PURE__*/ $g85JO.createElement($6603f37ba6649b1d$export$ca328f169d304df4, {
        value: value,
        children: children
    });
}
$6603f37ba6649b1d$var$StoreProvider.displayName = "StoreProvider";
function $6603f37ba6649b1d$export$1f96ae73734a86cc(param) {
    return $g85JO.useContext($6603f37ba6649b1d$export$a078c61943f9dbbe);
}
var $6603f37ba6649b1d$export$f36c9b20522c59e3 = /* Unknown */ 0;
var $6603f37ba6649b1d$export$dd44f18ab656f3bb = $6603f37ba6649b1d$var$StoreProvider;
 /* context Not a pure module */ 
});

parcelRegister("7Uv7n", function(module, exports) {

$parcel$export(module.exports, "compare", function () { return $5c25e6beae512e2f$export$398604a469f7de9a; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $9bVHE = parcelRequire("9bVHE");
function $5c25e6beae512e2f$export$398604a469f7de9a(a, b) {
    try {
        return $9bVHE.default(a, b);
    } catch (exn) {
        return $9bVHE(a, b);
    }
}
 /* string-natural-compare Not a pure module */ 
});
parcelRegister("9bVHE", function(module, exports) {

var $gfRPo = parcelRequire("gfRPo");
"use strict";
var $6b11e6c804cb311b$var$defaultAlphabetIndexMap = [];
function $6b11e6c804cb311b$var$isNumberCode(code) {
    return code >= 48 /* '0' */  && code <= 57 /* '9' */ ;
}
function $6b11e6c804cb311b$var$naturalCompare(a, b, opts) {
    if (typeof a !== "string") throw new TypeError("The first argument must be a string. Received type '".concat(typeof a === "undefined" ? "undefined" : (0, $gfRPo._)(a), "'"));
    if (typeof b !== "string") throw new TypeError("The second argument must be a string. Received type '".concat(typeof b === "undefined" ? "undefined" : (0, $gfRPo._)(b), "'"));
    var lengthA = a.length;
    var lengthB = b.length;
    var indexA = 0;
    var indexB = 0;
    var alphabetIndexMap = $6b11e6c804cb311b$var$defaultAlphabetIndexMap;
    var firstDifferenceInLeadingZeros = 0;
    if (opts) {
        if (opts.caseInsensitive) {
            a = a.toLowerCase();
            b = b.toLowerCase();
        }
        if (opts.alphabet) alphabetIndexMap = $6b11e6c804cb311b$var$buildAlphabetIndexMap(opts.alphabet);
    }
    while(indexA < lengthA && indexB < lengthB){
        var charCodeA = a.charCodeAt(indexA);
        var charCodeB = b.charCodeAt(indexB);
        if ($6b11e6c804cb311b$var$isNumberCode(charCodeA)) {
            if (!$6b11e6c804cb311b$var$isNumberCode(charCodeB)) return charCodeA - charCodeB;
            var numStartA = indexA;
            var numStartB = indexB;
            while(charCodeA === 48 /* '0' */  && ++numStartA < lengthA)charCodeA = a.charCodeAt(numStartA);
            while(charCodeB === 48 /* '0' */  && ++numStartB < lengthB)charCodeB = b.charCodeAt(numStartB);
            if (numStartA !== numStartB && firstDifferenceInLeadingZeros === 0) firstDifferenceInLeadingZeros = numStartA - numStartB;
            var numEndA = numStartA;
            var numEndB = numStartB;
            while(numEndA < lengthA && $6b11e6c804cb311b$var$isNumberCode(a.charCodeAt(numEndA)))++numEndA;
            while(numEndB < lengthB && $6b11e6c804cb311b$var$isNumberCode(b.charCodeAt(numEndB)))++numEndB;
            var difference = numEndA - numStartA - numEndB + numStartB; // numA length - numB length
            if (difference !== 0) return difference;
            while(numStartA < numEndA){
                difference = a.charCodeAt(numStartA++) - b.charCodeAt(numStartB++);
                if (difference !== 0) return difference;
            }
            indexA = numEndA;
            indexB = numEndB;
            continue;
        }
        if (charCodeA !== charCodeB) {
            if (charCodeA < alphabetIndexMap.length && charCodeB < alphabetIndexMap.length && alphabetIndexMap[charCodeA] !== -1 && alphabetIndexMap[charCodeB] !== -1) return alphabetIndexMap[charCodeA] - alphabetIndexMap[charCodeB];
            return charCodeA - charCodeB;
        }
        ++indexA;
        ++indexB;
    }
    if (indexA < lengthA) return 1;
    if (indexB < lengthB) return -1;
    return firstDifferenceInLeadingZeros;
}
var $6b11e6c804cb311b$var$alphabetIndexMapCache = {};
function $6b11e6c804cb311b$var$buildAlphabetIndexMap(alphabet) {
    var existingMap = $6b11e6c804cb311b$var$alphabetIndexMapCache[alphabet];
    if (existingMap !== undefined) return existingMap;
    var indexMap = [];
    var maxCharCode = alphabet.split("").reduce(function(maxCode, char) {
        return Math.max(maxCode, char.charCodeAt(0));
    }, 0);
    for(var i = 0; i <= maxCharCode; i++)indexMap.push(-1);
    for(var i1 = 0; i1 < alphabet.length; i1++)indexMap[alphabet.charCodeAt(i1)] = i1;
    $6b11e6c804cb311b$var$alphabetIndexMapCache[alphabet] = indexMap;
    return indexMap;
}
module.exports = $6b11e6c804cb311b$var$naturalCompare;

});


parcelRegister("6jWwC", function(module, exports) {

$parcel$export(module.exports, "useWishlistLink", function () { return $49a1ea4862491ee4$export$b082cf2181975f; });
$parcel$export(module.exports, "getDisplaySwatchImage", function () { return $49a1ea4862491ee4$export$73d101e96c830bb1; });
$parcel$export(module.exports, "parseMetadata", function () { return $49a1ea4862491ee4$export$978f9418fe0cb26c; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $d3YYW = parcelRequire("d3YYW");

var $1ArWc = parcelRequire("1ArWc");

var $7bjme = parcelRequire("7bjme");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $jmDU9 = parcelRequire("jmDU9");

var $8E2YL = parcelRequire("8E2YL");
function $49a1ea4862491ee4$export$84137bb44359aed5(str) {
    try {
        return $loT9g.some(JSON.parse(str));
    } catch (e) {
        return;
    }
}
function $49a1ea4862491ee4$export$46f821548a13b2a9(param) {
    return $7bjme.equal($8E2YL.use(undefined).config.accountId, "PgWbiuD1w");
}
function $49a1ea4862491ee4$export$b082cf2181975f(param) {
    var isBrighton = $49a1ea4862491ee4$export$46f821548a13b2a9(undefined);
    var match = $jmDU9.use(undefined);
    if (isBrighton && match.supported) return "https://www.brighton.com/pages/wishlist";
}
function $49a1ea4862491ee4$var$fromJson(json) {
    return $2whNH.flatMap($2whNH.flatMap($2whNH.flatMap($2whNH.flatMap(json, $1ArWc.decodeString), $49a1ea4862491ee4$export$84137bb44359aed5), $1ArWc.decodeObject), function(object) {
        var skuToOriginalSourceMapping = $2whNH.map($2whNH.flatMap($d3YYW.get(object, "SKUToOriginalSourceMapping"), $1ArWc.decodeObject), function(dict) {
            return $d3YYW.fromArray($i7mYY.keepMap($i7mYY.map($d3YYW.entries(dict), function(param) {
                var value = $1ArWc.decodeString(param[1]);
                if (value !== undefined) return [
                    param[0],
                    value
                ];
            }), function(a) {
                return a;
            }));
        });
        if (skuToOriginalSourceMapping !== undefined) return {
            skuToOriginalSourceMapping: $loT9g.valFromOption(skuToOriginalSourceMapping)
        };
    });
}
var $49a1ea4862491ee4$export$1d9134eb89f361c9 = {
    fromJson: $49a1ea4862491ee4$var$fromJson
};
function $49a1ea4862491ee4$var$fromJson$1(json) {
    return $2whNH.map($2whNH.flatMap($2whNH.flatMap($2whNH.flatMap(json, $1ArWc.decodeString), $49a1ea4862491ee4$export$84137bb44359aed5), $1ArWc.decodeArray), function(array) {
        return $i7mYY.keepMap(array, $1ArWc.decodeString);
    });
}
var $49a1ea4862491ee4$export$87e48b5834a91c9 = {
    fromJson: $49a1ea4862491ee4$var$fromJson$1
};
function $49a1ea4862491ee4$export$73d101e96c830bb1(metadata, sku) {
    var mapping = $49a1ea4862491ee4$var$fromJson($2whNH.flatMap($d3YYW.get(metadata, "cql::salsify_image_sources"), function(metadata) {
        if (typeof metadata === "number" || metadata.TAG !== /* Json */ 9) return;
        else return $loT9g.some(metadata._0);
    }));
    var swatches = $49a1ea4862491ee4$var$fromJson$1($2whNH.flatMap($d3YYW.get(metadata, "cql::swatches_json"), function(metadata) {
        if (typeof metadata === "number" || metadata.TAG !== /* Json */ 9) return;
        else return $loT9g.some(metadata._0);
    }));
    if (mapping === undefined) return;
    if (swatches === undefined) return;
    if (sku === undefined) return;
    var imageSrc = $d3YYW.get(mapping.skuToOriginalSourceMapping, sku);
    var isUrl = $2whNH.mapWithDefault(imageSrc, false, function(src) {
        return src.startsWith("http");
    });
    var color = $2whNH.flatMap(imageSrc, function(src) {
        return $2whNH.flatMap($2whNH.flatMap($loT9g.null_to_opt(src.match(/__([a-z-]+)_0\.([a-z]+)$/)), function(__x) {
            return $i7mYY.get(__x, 1);
        }), function(a) {
            return a;
        });
    });
    if (color !== undefined && isUrl) return $loT9g.undefined_to_opt(swatches.find(function(swatch) {
        return swatch.includes("/" + color + ".");
    }));
}
function $49a1ea4862491ee4$export$978f9418fe0cb26c(field, value) {
    var rowSplitter = ",,,,,,,,,,";
    var columnSplitter = "::::::::::";
    var isWeirdData = function isWeirdData(value) {
        if (value.includes(rowSplitter)) return value.includes(columnSplitter);
        else return false;
    };
    if (typeof value === "number") return;
    if (value.TAG !== /* SingleLineTextField */ 1) return;
    var value$1 = value._0;
    if (field !== "cql::detail_specs") return;
    if (!isWeirdData(value$1)) return;
    var tableContent = $i7mYY.map($i7mYY.keep($i7mYY.map(value$1.split(rowSplitter), function(row) {
        return row.split(columnSplitter);
    }), function(row) {
        return $7bjme.notequal($i7mYY.get(row, 1), "");
    }), function(row) {
        var columns = $i7mYY.mapWithIndex(row, function(i, column) {
            return '<td style="font-weight: ' + (i === 0 ? "bold" : "normal") + '">' + column + "</td>";
        }).join("");
        return "<tr>" + columns + "</tr>";
    }).join("");
    return {
        TAG: /* MultiLineTextField */ 0,
        _0: '<table><tbody style="width: 100%">' + tableContent + "</tbody></table>"
    };
}
 /* SwymitWishlist-Showside Not a pure module */ 
});
parcelRegister("jmDU9", function(module, exports) {

$parcel$export(module.exports, "Provider", function () { return $e18f069eb1b09ad5$export$2881499e37b75b9a; });
$parcel$export(module.exports, "use", function () { return $e18f069eb1b09ad5$export$1f96ae73734a86cc; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $75ZqT = parcelRequire("75ZqT");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $1xvYg = parcelRequire("1xvYg");

var $bBMv4 = parcelRequire("bBMv4");

var $ehnwQ = parcelRequire("ehnwQ");

var $4QdUt = parcelRequire("4QdUt");
var $e18f069eb1b09ad5$export$76b03647d83bac48 = /* @__PURE__ */ $1xvYg.create("SwymitWishlist-Showside.SwymitError");
var $e18f069eb1b09ad5$export$c5d5162b9d1a0cae = /* @__PURE__ */ $1xvYg.create("SwymitWishlist-Showside.Unsupported");
function $e18f069eb1b09ad5$export$a4eaf5b22b2a2e7a(param) {
    return window._swat !== undefined;
}
function $e18f069eb1b09ad5$export$5a6e5bbdedfe948e(param) {
    return $2whNH.flatMap(window._swat, function(swat) {
        return swat.fetchWishlistCount;
    }) !== undefined;
}
function $e18f069eb1b09ad5$export$d3da1ecaf1206c58(promise) {
    return $ehnwQ.$$catch(promise, function(originalExn) {
        var message;
        if (originalExn.RE_EXN_ID === $e18f069eb1b09ad5$export$76b03647d83bac48) {
            var message$1 = originalExn._1;
            message = message$1.trim() !== "" ? "[swymit] " + message$1 : "[swymit] Unknown error occurred while interacting with Swymit API";
        } else message = "[swymit] Unknown error occurred while interacting with Swymit API";
        var err = originalExn.RE_EXN_ID === $e18f069eb1b09ad5$export$76b03647d83bac48 ? originalExn._2 : originalExn;
        var jsExn = $75ZqT.$$Error.fromRescript(err);
        var rootCause = $75ZqT.$$Error.getRootCause(jsExn);
        var match = rootCause.message;
        var match$1 = rootCause.name;
        var rootCauseMessage = match !== undefined ? match$1 !== undefined ? "RC: " + match$1 + " " + match + "" : "RC: " + match + "" : match$1 !== undefined ? "RC: " + match$1 + "" : undefined;
        var message$2 = $i7mYY.keepMap([
            message,
            rootCauseMessage
        ], function(a) {
            return a;
        }).join(", ");
        $4QdUt.jsError2($75ZqT.$$Error.fromStringWithCause(message$2, rootCause), message$2);
        return Promise.reject(err);
    });
}
function $e18f069eb1b09ad5$export$331d7bff90e3f738(callback) {
    $g85JO.useEffect(function() {
        var callbacks = window.SwymCallbacks;
        window.SwymCallbacks = callbacks !== undefined ? $i7mYY.concat(callbacks, [
            callback
        ]) : [
            callback
        ];
        return function(param) {
            var callbacks = window.SwymCallbacks;
            window.SwymCallbacks = callbacks !== undefined ? $i7mYY.keep(callbacks, function(cb) {
                return cb !== callback;
            }) : [];
        };
    }, []);
}
function $e18f069eb1b09ad5$export$238555f81762a634(link) {
    return $e18f069eb1b09ad5$export$d3da1ecaf1206c58(new Promise(function(resolve, reject) {
        if (link !== undefined) return $2whNH.forEach(window._swat, function(swat) {
            try {
                swat.addToWishlistUsingDu({
                    du: link,
                    source: "collections-grid"
                }, function(count) {
                    resolve(undefined);
                });
                return;
            } catch (raw_e) {
                var e = $bBMv4.internalToOCamlException(raw_e);
                return reject({
                    RE_EXN_ID: $e18f069eb1b09ad5$export$76b03647d83bac48,
                    _1: "Add to wishlist failed",
                    _2: e
                });
            }
        });
        else return reject({
            RE_EXN_ID: $e18f069eb1b09ad5$export$76b03647d83bac48,
            _1: "No link provided",
            _2: {
                RE_EXN_ID: $e18f069eb1b09ad5$export$c5d5162b9d1a0cae
            }
        });
    }));
}
function $e18f069eb1b09ad5$export$205c97362c017443(link) {
    return $e18f069eb1b09ad5$export$d3da1ecaf1206c58(new Promise(function(resolve, reject) {
        if (link !== undefined) return $2whNH.forEach(window._swat, function(swat) {
            try {
                swat.removeFromWishlistUsingDu({
                    du: link,
                    source: "collections-grid"
                }, function(count) {
                    resolve(undefined);
                });
                return;
            } catch (raw_e) {
                var e = $bBMv4.internalToOCamlException(raw_e);
                return reject({
                    RE_EXN_ID: $e18f069eb1b09ad5$export$76b03647d83bac48,
                    _1: "Remove from wishlist failed",
                    _2: e
                });
            }
        });
        else return reject({
            RE_EXN_ID: $e18f069eb1b09ad5$export$76b03647d83bac48,
            _1: "No link provided",
            _2: {
                RE_EXN_ID: $e18f069eb1b09ad5$export$c5d5162b9d1a0cae
            }
        });
    }));
}
function $e18f069eb1b09ad5$export$e73c0ee0823d1bbe(param) {
    return $e18f069eb1b09ad5$export$d3da1ecaf1206c58(new Promise(function(resolve, reject) {
        $2whNH.forEach($2whNH.flatMap(window._swat, function(prim) {
            return prim.fetchWishlistCount;
        }), function(callback) {
            try {
                return $iv6Yc._2(callback, function(param) {
                    resolve(param.data.count);
                }, function(error) {
                    reject({
                        RE_EXN_ID: $e18f069eb1b09ad5$export$76b03647d83bac48,
                        _1: "Failed to get wishlist count",
                        _2: error
                    });
                });
            } catch (raw_e) {
                var e = $bBMv4.internalToOCamlException(raw_e);
                return reject({
                    RE_EXN_ID: $e18f069eb1b09ad5$export$76b03647d83bac48,
                    _1: "Failed to get wishlist count",
                    _2: e
                });
            }
        });
    }));
}
function $e18f069eb1b09ad5$export$cfd4146dd627a4ce(variantId) {
    return $e18f069eb1b09ad5$export$d3da1ecaf1206c58(new Promise(function(resolve, reject) {
        $2whNH.forEach(window._swat, function(swat) {
            try {
                swat.isInWishlist({
                    epi: variantId
                }, function(isInWishlist) {
                    resolve(isInWishlist);
                });
                return;
            } catch (raw_e) {
                var e = $bBMv4.internalToOCamlException(raw_e);
                return reject({
                    RE_EXN_ID: $e18f069eb1b09ad5$export$76b03647d83bac48,
                    _1: "Failed to check if product is in wishlist",
                    _2: e
                });
            }
        });
    }));
}
var $e18f069eb1b09ad5$var$context = /*#__PURE__*/ $g85JO.createContext({
    add: function add(param) {
        return Promise.reject({
            RE_EXN_ID: $e18f069eb1b09ad5$export$c5d5162b9d1a0cae
        });
    },
    remove: function remove(param) {
        return Promise.reject({
            RE_EXN_ID: $e18f069eb1b09ad5$export$c5d5162b9d1a0cae
        });
    },
    isAdded: function isAdded(param) {
        return Promise.reject({
            RE_EXN_ID: $e18f069eb1b09ad5$export$c5d5162b9d1a0cae
        });
    },
    count: 0,
    loaded: false,
    supported: false
});
var $e18f069eb1b09ad5$var$provider = $e18f069eb1b09ad5$var$context.Provider;
function $e18f069eb1b09ad5$var$SwymitWishlist$Provider(Props) {
    var children = Props.children;
    var match = $g85JO.useState(function() {
        return $e18f069eb1b09ad5$export$5a6e5bbdedfe948e(undefined);
    });
    var setLoaded = match[1];
    var loaded = match[0];
    var match$1 = $g85JO.useState(function() {
        return 0;
    });
    var setCount = match$1[1];
    var supported = window._swat !== undefined;
    $e18f069eb1b09ad5$export$331d7bff90e3f738(function(swat) {
        $iv6Yc._1(setLoaded, function(param) {
            return $e18f069eb1b09ad5$export$5a6e5bbdedfe948e(undefined);
        });
    });
    var updateCount = function updateCount(param) {
        if (loaded) {
            $e18f069eb1b09ad5$export$e73c0ee0823d1bbe(undefined).then(function(count) {
                $iv6Yc._1(setCount, function(param) {
                    return count;
                });
            });
            return;
        }
    };
    $g85JO.useEffect(function() {
        updateCount(undefined);
        var evtLayer = $2whNH.flatMap(window._swat, function(prim) {
            return prim.evtLayer;
        });
        if (evtLayer === undefined) return;
        var evtLayer$1 = $loT9g.valFromOption(evtLayer);
        evtLayer$1.addEventListener("sw:addedtowishlist", updateCount);
        evtLayer$1.addEventListener("sw:removedfromwishlist", updateCount);
        return function(param) {
            evtLayer$1.removeEventListener("sw:addedtowishlist", updateCount);
            evtLayer$1.removeEventListener("sw:removedfromwishlist", updateCount);
        };
    }, [
        loaded
    ]);
    var handleAdd = function handleAdd(link) {
        return $e18f069eb1b09ad5$export$238555f81762a634(link).then(function(param) {
            updateCount(undefined);
        });
    };
    var handleRemove = function handleRemove(link) {
        return $e18f069eb1b09ad5$export$205c97362c017443(link).then(function(param) {
            updateCount(undefined);
        });
    };
    var isAdded = $e18f069eb1b09ad5$export$cfd4146dd627a4ce;
    var ctx_count = match$1[0];
    var ctx = {
        add: handleAdd,
        remove: handleRemove,
        isAdded: isAdded,
        count: ctx_count,
        loaded: loaded,
        supported: supported
    };
    return /*#__PURE__*/ $g85JO.createElement($e18f069eb1b09ad5$var$provider, {
        value: ctx,
        children: children
    });
}
$e18f069eb1b09ad5$var$SwymitWishlist$Provider.displayName = "SwymitWishlist.Provider";
var $e18f069eb1b09ad5$export$2881499e37b75b9a = {
    context: $e18f069eb1b09ad5$var$context,
    provider: $e18f069eb1b09ad5$var$provider,
    make: $e18f069eb1b09ad5$var$SwymitWishlist$Provider
};
function $e18f069eb1b09ad5$export$1f96ae73734a86cc(param) {
    return $g85JO.useContext($e18f069eb1b09ad5$var$context);
}
 /* context Not a pure module */ 
});
parcelRegister("75ZqT", function(module, exports) {

$parcel$export(module.exports, "$$Error", function () { return $52a8a74a8d9b8da3$export$507b31d55a607b45; });
$parcel$export(module.exports, "critical1", function () { return $52a8a74a8d9b8da3$export$c72c201879be19f7; });
$parcel$export(module.exports, "critical2", function () { return $52a8a74a8d9b8da3$export$d81adedbc8266a46; });
$parcel$export(module.exports, "critical3", function () { return $52a8a74a8d9b8da3$export$abbc13d208d7fd9d; });
$parcel$export(module.exports, "error1", function () { return $52a8a74a8d9b8da3$export$16b612f002658c42; });
$parcel$export(module.exports, "error2", function () { return $52a8a74a8d9b8da3$export$d509cefd34be14b1; });
$parcel$export(module.exports, "error3", function () { return $52a8a74a8d9b8da3$export$7da009fca5b7be62; });
$parcel$export(module.exports, "info1", function () { return $52a8a74a8d9b8da3$export$b2447b3a74273ee1; });
$parcel$export(module.exports, "info2", function () { return $52a8a74a8d9b8da3$export$be46b8986d197da1; });
$parcel$export(module.exports, "warning1", function () { return $52a8a74a8d9b8da3$export$e6c9b5ac8658dcc8; });
$parcel$export(module.exports, "warning2", function () { return $52a8a74a8d9b8da3$export$739cf6bc6f40dab2; });
// Generated by ReScript, PLEASE EDIT WITH CARE
var $52a8a74a8d9b8da3$var$findAMeaningfulMessageInArgs = function(args) {
    for(var k in args){
        if (typeof args[k] == "object" && args[k] instanceof Error) return args[k].message;
        if (typeof args[k] == "string") return args[k];
    }
};
// RE_EXN_ID irritatingly has the variant index /1 on it
// this can only confuse error grouping and seems to make
// rollbar not treat it as a valid error.name
var $52a8a74a8d9b8da3$var$clean_REX_ID = function(id) {
    var split = id.split("/");
    if (split.length == 2) return split[0];
    return id;
};
var $52a8a74a8d9b8da3$var$fromString = function fromString(str) {
    return new Error(str);
};
var $52a8a74a8d9b8da3$var$fromStringWithCause = function fromStringWithCause(str, cause) {
    var error = new Error(str, {
        cause: cause
    });
    error.stack = cause.stack;
    return error;
};
var $52a8a74a8d9b8da3$var$getRootCause = function getRootCause(err) {
    while(typeof err.cause == "object" && err.cause instanceof Error)err = err.cause;
    return err;
};
var $52a8a74a8d9b8da3$var$fromRescript = function fromRescript(err) {
    // It already is a js exn, not rescript exception, perhaps a type issue
    // could lead to this so we just want to keep it
    if (err instanceof Error) return err;
    // Looks in every way like a real rescript exception
    if (err !== null && typeof err === "object" && typeof err.RE_EXN_ID == "string") {
        var args = [
            err._0,
            err._1,
            err._2,
            err._3,
            err._4,
            err._5,
            err._6
        ].filter(function(arg) {
            return typeof arg !== "undefined";
        });
        var newError = new Error();
        newError.name = $52a8a74a8d9b8da3$var$clean_REX_ID(err.RE_EXN_ID);
        newError.message = $52a8a74a8d9b8da3$var$findAMeaningfulMessageInArgs(args);
        newError.RE_EXN_ID = err.RE_EXN_ID;
        for(var i = 0; i < args.length; i++)if (typeof args[i] !== "undefined") newError["RE_EXN_ARG_" + i] = args[i];
        if (err.Error instanceof Error) newError.stack = err.Error.stack;
        return newError;
    }
    // Not clear how this could be possible but keeping because no harm
    // Probably never was possible and just exists for no reason
    if (err !== null && typeof err === "object" && err._1 instanceof Error) return err._1;
    return new Error("Rescript (uninterpretable) " + JSON.stringify(err));
};
function $52a8a74a8d9b8da3$var$fromRescriptWithNewMessage(err, newMessage) {
    return $52a8a74a8d9b8da3$var$fromStringWithCause(newMessage, $52a8a74a8d9b8da3$var$fromRescript(err));
}
var $52a8a74a8d9b8da3$export$507b31d55a607b45 = {
    fromString: $52a8a74a8d9b8da3$var$fromString,
    fromStringWithCause: $52a8a74a8d9b8da3$var$fromStringWithCause,
    getRootCause: $52a8a74a8d9b8da3$var$getRootCause,
    fromRescript: $52a8a74a8d9b8da3$var$fromRescript,
    fromRescriptWithNewMessage: $52a8a74a8d9b8da3$var$fromRescriptWithNewMessage
};
function $52a8a74a8d9b8da3$export$c72c201879be19f7(client, e) {
    return new Promise(function(resolve, reject) {
        client.critical(e, function(err, res) {
            if (err == null) return resolve(undefined);
            else return reject(err);
        });
    });
}
function $52a8a74a8d9b8da3$export$d81adedbc8266a46(client, e, a) {
    return new Promise(function(resolve, reject) {
        client.critical(e, a, function(err, res) {
            if (err == null) return resolve(undefined);
            else return reject(err);
        });
    });
}
function $52a8a74a8d9b8da3$export$abbc13d208d7fd9d(client, e, a, b) {
    return new Promise(function(resolve, reject) {
        client.critical(e, a, b, function(err, res) {
            if (err == null) return resolve(undefined);
            else return reject(err);
        });
    });
}
function $52a8a74a8d9b8da3$export$16b612f002658c42(client, e) {
    return new Promise(function(resolve, reject) {
        client.error(e, function(err, res) {
            if (err == null) return resolve(undefined);
            else return reject(err);
        });
    });
}
function $52a8a74a8d9b8da3$export$d509cefd34be14b1(client, e, a) {
    return new Promise(function(resolve, reject) {
        client.error(e, a, function(err, res) {
            if (err == null) return resolve(undefined);
            else return reject(err);
        });
    });
}
function $52a8a74a8d9b8da3$export$7da009fca5b7be62(client, e, a, b) {
    return new Promise(function(resolve, reject) {
        client.error(e, a, b, function(err, res) {
            if (err == null) return resolve(undefined);
            else return reject(err);
        });
    });
}
function $52a8a74a8d9b8da3$export$b2447b3a74273ee1(client, msg) {
    return new Promise(function(resolve, reject) {
        client.info(msg, function(err, res) {
            if (err == null) return resolve(undefined);
            else return reject(err);
        });
    });
}
function $52a8a74a8d9b8da3$export$be46b8986d197da1(client, msg, extraInfo) {
    return new Promise(function(resolve, reject) {
        client.info(msg, extraInfo, function(err, res) {
            if (err == null) return resolve(undefined);
            else return reject(err);
        });
    });
}
function $52a8a74a8d9b8da3$export$e6c9b5ac8658dcc8(client, msg) {
    return new Promise(function(resolve, reject) {
        client.warning(msg, function(err, res) {
            if (err == null) return resolve(undefined);
            else return reject(err);
        });
    });
}
function $52a8a74a8d9b8da3$export$739cf6bc6f40dab2(client, msg, extraInfo) {
    return new Promise(function(resolve, reject) {
        client.warning(msg, extraInfo, function(err, res) {
            if (err == null) return resolve(undefined);
            else return reject(err);
        });
    });
}
 /*  Not a pure module */ 
});

parcelRegister("ehnwQ", function(module, exports) {

$parcel$export(module.exports, "$$catch", function () { return $a654e78b37424f32$export$e62bb7a22f80ae34; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $eklj4 = parcelRequire("eklj4");

var $4RPwt = parcelRequire("4RPwt");
function $a654e78b37424f32$export$e62bb7a22f80ae34(promise, fn) {
    return $eklj4.$$catch(promise, function(e) {
        return $iv6Yc._1(fn, $4RPwt.Exn.unwrapJsError(e));
    });
}
 /* No side effect */ 
});
parcelRegister("4RPwt", function(module, exports) {

$parcel$export(module.exports, "Exn", function () { return $38b414089bbb92f4$export$3448ba6aefb0114; });
// Generated by ReScript, PLEASE EDIT WITH CARE
var $38b414089bbb92f4$export$8d5400d15923e166 = {};
var $38b414089bbb92f4$var$unwrapJsError = function unwrapJsError(exn) {
    if (typeof exn != "object") return exn;
    if (!exn.hasOwnProperty("RE_EXN_ID") || !exn.hasOwnProperty("_1")) return exn;
    if (typeof exn["RE_EXN_ID"] == "string" && exn["RE_EXN_ID"].includes("JsError") && typeof exn["_1"] == "object" && exn["_1"] instanceof Error) return exn["_1"];
    else return exn;
};
var $38b414089bbb92f4$export$3448ba6aefb0114 = {
    unwrapJsError: $38b414089bbb92f4$var$unwrapJsError
};
 /* No side effect */ 
});


parcelRegister("4QdUt", function(module, exports) {

$parcel$export(module.exports, "LogicalError", function () { return $3866cef03bb4f5d9$export$21682c112315ff06; });
$parcel$export(module.exports, "LogicalErrorUnreported", function () { return $3866cef03bb4f5d9$export$63c8c81b4abafe13; });
$parcel$export(module.exports, "makeError", function () { return $3866cef03bb4f5d9$export$5a4bb2b1c89bdce7; });
$parcel$export(module.exports, "jsError1", function () { return $3866cef03bb4f5d9$export$f871d1f00b8c5f6a; });
$parcel$export(module.exports, "jsError2", function () { return $3866cef03bb4f5d9$export$9d57cf5a2e014ce6; });
$parcel$export(module.exports, "error1", function () { return $3866cef03bb4f5d9$export$16b612f002658c42; });
$parcel$export(module.exports, "error2", function () { return $3866cef03bb4f5d9$export$d509cefd34be14b1; });
$parcel$export(module.exports, "error3", function () { return $3866cef03bb4f5d9$export$7da009fca5b7be62; });
$parcel$export(module.exports, "info2", function () { return $3866cef03bb4f5d9$export$be46b8986d197da1; });
$parcel$export(module.exports, "warning2", function () { return $3866cef03bb4f5d9$export$739cf6bc6f40dab2; });
$parcel$export(module.exports, "critical2", function () { return $3866cef03bb4f5d9$export$d81adedbc8266a46; });
$parcel$export(module.exports, "critical3", function () { return $3866cef03bb4f5d9$export$abbc13d208d7fd9d; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $5YOUh = parcelRequire("5YOUh");

var $j4B9x = parcelRequire("j4B9x");

var $iv6Yc = parcelRequire("iv6Yc");

var $75ZqT = parcelRequire("75ZqT");

var $hxhfd = parcelRequire("hxhfd");

var $1xvYg = parcelRequire("1xvYg");

var $bBMv4 = parcelRequire("bBMv4");

var $3866cef03bb4f5d9$export$a1d4d71ddf15b4b4 = function importRollbarClient() {
    return (parcelRequire("8XXN2")).then(function(rollbar) {
        return function(options) {
            return new rollbar(options);
        };
    });
};
function $3866cef03bb4f5d9$export$57570b1603cf6adb(param) {
    var host = window.location.host;
    var isIgnoredHost = host.endsWith(".vercel.app") || host.endsWith(".pages.dev") || host.endsWith("showside.maker.co") || host.endsWith("showside-staging.maker.co") || host.endsWith("nav.maker.co") || host.endsWith(".myshopify.com") || host.endsWith(".shopifypreview.com") || host.endsWith(".glitch.me") || host.endsWith("localhost:3000") || host.endsWith("localhost:3002");
    if (isIgnoredHost && $hxhfd.nodeEnv === "production") return "production-ignored";
    else return $hxhfd.nodeEnv;
}
function $3866cef03bb4f5d9$export$8bedcca5bbd73999(param) {
    return $3866cef03bb4f5d9$var$_getInstance.apply(this, arguments);
}
function $3866cef03bb4f5d9$var$_getInstance() {
    $3866cef03bb4f5d9$var$_getInstance = (0, $5YOUh._)(function(param) {
        var makeClient;
        return (0, $j4B9x.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        $iv6Yc._1($3866cef03bb4f5d9$export$a1d4d71ddf15b4b4, undefined)
                    ];
                case 1:
                    makeClient = _state.sent();
                    return [
                        2,
                        makeClient({
                            accessToken: $hxhfd.rollbarAccessToken,
                            captureUncaught: false,
                            captureUnhandledRejections: false,
                            environment: $3866cef03bb4f5d9$export$57570b1603cf6adb(undefined),
                            checkIgnore: undefined,
                            payload: {
                                client: {
                                    javascript: {
                                        source_map_enabled: true,
                                        code_version: $hxhfd.gitCommitSha,
                                        guess_uncaught_frames: true
                                    }
                                }
                            },
                            codeVersion: $hxhfd.gitCommitSha
                        })
                    ];
            }
        });
    });
    return $3866cef03bb4f5d9$var$_getInstance.apply(this, arguments);
}
var $3866cef03bb4f5d9$export$21682c112315ff06 = /* @__PURE__ */ $1xvYg.create("RollbarInstance-Showside.LogicalError");
var $3866cef03bb4f5d9$export$63c8c81b4abafe13 = /* @__PURE__ */ $1xvYg.create("RollbarInstance-Showside.LogicalErrorUnreported");
function $3866cef03bb4f5d9$export$5a4bb2b1c89bdce7(reportOpt, message) {
    var report = reportOpt !== undefined ? reportOpt : true;
    try {
        throw report ? {
            RE_EXN_ID: $3866cef03bb4f5d9$export$21682c112315ff06,
            _1: message
        } : {
            RE_EXN_ID: $3866cef03bb4f5d9$export$63c8c81b4abafe13,
            _1: message
        };
    } catch (raw_err) {
        return $bBMv4.internalToOCamlException(raw_err);
    }
}
var $3866cef03bb4f5d9$export$15f4d6fb99115d67 = function(error) {
    if (typeof window !== "undefined" && window.location.host !== "") {
        if (typeof error === "string") return "[" + window.location.host + "] " + error;
        else if (typeof error === "object" && error instanceof Error) {
            error.message = "[" + window.location.host + "] " + error.message;
            return error;
        } else return error;
    } else return error;
};
function $3866cef03bb4f5d9$export$f871d1f00b8c5f6a(error) {
    return $3866cef03bb4f5d9$export$8bedcca5bbd73999(undefined).then(function(__x) {
        return $75ZqT.error1(__x, $3866cef03bb4f5d9$export$15f4d6fb99115d67(error));
    });
}
function $3866cef03bb4f5d9$export$9d57cf5a2e014ce6(error, extraInfo) {
    return $3866cef03bb4f5d9$export$8bedcca5bbd73999(undefined).then(function(__x) {
        return $75ZqT.error2(__x, $3866cef03bb4f5d9$export$15f4d6fb99115d67(error), $3866cef03bb4f5d9$export$15f4d6fb99115d67(extraInfo));
    });
}
function $3866cef03bb4f5d9$export$61ff420436c0eab3(error, extraInfo1, extraInfo2) {
    return $3866cef03bb4f5d9$export$8bedcca5bbd73999(undefined).then(function(__x) {
        return $75ZqT.error3(__x, $3866cef03bb4f5d9$export$15f4d6fb99115d67(error), $3866cef03bb4f5d9$export$15f4d6fb99115d67(extraInfo1), $3866cef03bb4f5d9$export$15f4d6fb99115d67(extraInfo2));
    });
}
function $3866cef03bb4f5d9$export$16b612f002658c42(error) {
    return $3866cef03bb4f5d9$export$f871d1f00b8c5f6a($75ZqT.$$Error.fromRescript(error));
}
function $3866cef03bb4f5d9$export$d509cefd34be14b1(error, extraInfo) {
    return $3866cef03bb4f5d9$export$9d57cf5a2e014ce6($75ZqT.$$Error.fromRescript(error), extraInfo);
}
function $3866cef03bb4f5d9$export$7da009fca5b7be62(error, extraInfo1, extraInfo2) {
    return $3866cef03bb4f5d9$export$61ff420436c0eab3($75ZqT.$$Error.fromRescript(error), extraInfo1, extraInfo2);
}
function $3866cef03bb4f5d9$export$b2447b3a74273ee1(msg) {
    return $3866cef03bb4f5d9$export$8bedcca5bbd73999(undefined).then(function(__x) {
        return $75ZqT.info1(__x, msg);
    });
}
function $3866cef03bb4f5d9$export$be46b8986d197da1(msg, extraInfo) {
    return $3866cef03bb4f5d9$export$8bedcca5bbd73999(undefined).then(function(__x) {
        return $75ZqT.info2(__x, msg, extraInfo);
    });
}
function $3866cef03bb4f5d9$export$e6c9b5ac8658dcc8(msg) {
    return $3866cef03bb4f5d9$export$8bedcca5bbd73999(undefined).then(function(__x) {
        return $75ZqT.warning1(__x, msg);
    });
}
function $3866cef03bb4f5d9$export$739cf6bc6f40dab2(msg, extraInfo) {
    return $3866cef03bb4f5d9$export$8bedcca5bbd73999(undefined).then(function(__x) {
        return $75ZqT.warning2(__x, msg, extraInfo);
    });
}
function $3866cef03bb4f5d9$export$c72c201879be19f7(error) {
    return $3866cef03bb4f5d9$export$8bedcca5bbd73999(undefined).then(function(__x) {
        return $75ZqT.critical1(__x, $3866cef03bb4f5d9$export$15f4d6fb99115d67(error));
    });
}
function $3866cef03bb4f5d9$export$d81adedbc8266a46(error, extraInfo) {
    return $3866cef03bb4f5d9$export$8bedcca5bbd73999(undefined).then(function(__x) {
        return $75ZqT.critical2(__x, $3866cef03bb4f5d9$export$15f4d6fb99115d67(error), $3866cef03bb4f5d9$export$15f4d6fb99115d67(extraInfo));
    });
}
function $3866cef03bb4f5d9$export$abbc13d208d7fd9d(error, extraInfo1, extraInfo2) {
    return $3866cef03bb4f5d9$export$8bedcca5bbd73999(undefined).then(function(__x) {
        return $75ZqT.critical3(__x, $3866cef03bb4f5d9$export$15f4d6fb99115d67(error), $3866cef03bb4f5d9$export$15f4d6fb99115d67(extraInfo1), $3866cef03bb4f5d9$export$15f4d6fb99115d67(extraInfo2));
    });
}
 /* Rollbar Not a pure module */ 
});
parcelRegister("8XXN2", function(module, exports) {


module.exports = (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("hOJSK")).then(function() {
    return parcelRequire("dmQ15");
});

});
parcelRegister("isbc1", function(module, exports) {
"use strict";

var $7J4BA = parcelRequire("7J4BA");
module.exports = $7J4BA(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName("script");
        if ([].concat(existingScripts).some(function isCurrentBundle(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement("link");
        preloadLink.href = bundle;
        preloadLink.rel = "preload";
        preloadLink.as = "script";
        document.head.appendChild(preloadLink);
        var script = document.createElement("script");
        script.async = true;
        script.type = "text/javascript";
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName("head")[0].appendChild(script);
    });
});

});
parcelRegister("7J4BA", function(module, exports) {
"use strict";
var $5a004edf52e5b33a$var$cachedBundles = {};
var $5a004edf52e5b33a$var$cachedPreloads = {};
var $5a004edf52e5b33a$var$cachedPrefetches = {};
function $5a004edf52e5b33a$var$getCache(type) {
    switch(type){
        case "preload":
            return $5a004edf52e5b33a$var$cachedPreloads;
        case "prefetch":
            return $5a004edf52e5b33a$var$cachedPrefetches;
        default:
            return $5a004edf52e5b33a$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $5a004edf52e5b33a$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});





parcelRegister("8E2YL", function(module, exports) {

$parcel$export(module.exports, "use", function () { return $64b45ec2ab217d72$export$1f96ae73734a86cc; });
$parcel$export(module.exports, "make", function () { return $64b45ec2ab217d72$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $5YOUh = parcelRequire("5YOUh");

var $j4B9x = parcelRequire("j4B9x");

var $2gEz2 = parcelRequire("2gEz2");

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $d3YYW = parcelRequire("d3YYW");

var $1ArWc = parcelRequire("1ArWc");

var $7bjme = parcelRequire("7bjme");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $gTtop = parcelRequire("gTtop");

var $loT9g = parcelRequire("loT9g");

var $79vie = parcelRequire("79vie");

var $16qP0 = parcelRequire("16qP0");

var $9bmXk = parcelRequire("9bmXk");

var $kJhYp = parcelRequire("kJhYp");

var $h6rW7 = parcelRequire("h6rW7");

var $h7kEx = parcelRequire("h7kEx");

var $9MZLD = parcelRequire("9MZLD");

var $ivJr2 = parcelRequire("ivJr2");

var $kMqPq = parcelRequire("kMqPq");

var $cq0ZS = parcelRequire("cq0ZS");

var $efwy1 = parcelRequire("efwy1");

var $hBcYV = parcelRequire("hBcYV");

var $aSJcu = parcelRequire("aSJcu");

var $dcR0L = parcelRequire("dcR0L");

var $6Cykr = parcelRequire("6Cykr");

var $kNO66 = parcelRequire("kNO66");
var $64b45ec2ab217d72$export$a078c61943f9dbbe = /*#__PURE__*/ $g85JO.createContext(undefined);
var $64b45ec2ab217d72$export$ca328f169d304df4 = $64b45ec2ab217d72$export$a078c61943f9dbbe.Provider;

var $64b45ec2ab217d72$export$d045906b3aa8a91a = function importConfigurationDecoder() {
    return (parcelRequire("7pMKc")).then(function(m) {
        return m.default;
    });
};
function $64b45ec2ab217d72$export$2b0ac18f7cd43e19(url) {
    $iv6Yc._1($64b45ec2ab217d72$export$d045906b3aa8a91a, undefined);
    var match = $2gEz2.useSWR(undefined, undefined, undefined, false, $9bmXk.fromOption(url), function(url) {
        return $h7kEx.$$fetch(undefined, undefined, undefined, undefined, $h7kEx.Server.ignoreNotFoundError, function() {
            var _ref = (0, $5YOUh._)(function(json) {
                var decoder;
                return (0, $j4B9x.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                $iv6Yc._1($64b45ec2ab217d72$export$d045906b3aa8a91a, undefined)
                            ];
                        case 1:
                            decoder = _state.sent();
                            return [
                                2,
                                $iv6Yc._1(decoder, json)
                            ];
                    }
                });
            });
            return function(json) {
                return _ref.apply(this, arguments);
            };
        }(), url);
    });
    return [
        match.error,
        match.data
    ];
}
function $64b45ec2ab217d72$export$f85b47f087288d0b(settings, options) {
    var dict = $2whNH.getWithDefault($1ArWc.decodeObject($6Cykr.toJson(settings)), {});
    var withAppliedOptions = $i7mYY.reduce($d3YYW.entries(options), dict, function(acc, param) {
        acc[param[0]] = param[1];
        return acc;
    });
    try {
        return $gTtop.getExn($79vie.decodeValue(withAppliedOptions, $kNO66.fromJson));
    } catch (exn) {
        return settings;
    }
}
function $64b45ec2ab217d72$export$ea6966039545a416(namespace, config) {
    var options;
    try {
        options = $2whNH.flatMap($2whNH.map($2whNH.map($loT9g.nullable_to_opt(new URL(window.location.href).searchParams.get($h6rW7.toNamespacedKey("QNOptions", namespace))), $kJhYp.decodePostMessageData), function(prim) {
            return JSON.parse(prim);
        }), $1ArWc.decodeObject);
    } catch (exn) {
        options = undefined;
    }
    if (options === undefined) return config;
    try {
        return {
            id: config.id,
            categories: config.categories,
            settings: $64b45ec2ab217d72$export$f85b47f087288d0b(config.settings, $loT9g.valFromOption(options)),
            transitiveStoreId: config.transitiveStoreId,
            transitiveAccount: config.transitiveAccount,
            transitiveStore: config.transitiveStore,
            accountId: config.accountId,
            lastModifiedAt: config.lastModifiedAt
        };
    } catch (exn$1) {
        return config;
    }
}
function $64b45ec2ab217d72$var$ConfigurationProvider(Props) {
    var embedType = Props.embedType;
    var configId = Props.configId;
    var children = Props.children;
    var config = Props.config;
    var breakpointOverride = Props.breakpointOverride;
    var enableTrimmingTreeByReferrer = Props.enableTrimmingTreeByReferrer;
    var match = $aSJcu.use(undefined);
    var match$1 = $g85JO.useState(function() {
        return breakpointOverride;
    });
    var setBreakpointOverride = match$1[1];
    var breakpoint = $2whNH.getWithDefault(match$1[0], match.breakpoint);
    var match$2 = $16qP0.use(undefined);
    var smartnavApiHost = match$2.smartnavApiHost;
    var match$3 = $hBcYV.useRouter(undefined);
    var previewMode = match$3.previewMode;
    var $$location = window.location;
    var trimTreeByReferrer = $g85JO.useMemo(function() {
        if (enableTrimmingTreeByReferrer) return encodeURIComponent($$location.origin + $$location.pathname);
    }, []);
    var live = previewMode !== undefined ? typeof previewMode === "number" ? previewMode !== 0 : false : true;
    var backup = previewMode !== undefined && typeof previewMode !== "number" ? previewMode._0.toString() : undefined;
    var url = $2whNH.map(configId, function(configId) {
        return $kMqPq.makeApiUrl(smartnavApiHost, live, backup, configId, $9MZLD.toString(breakpoint), trimTreeByReferrer, embedType === /* ProductDetailsPage */ 5, undefined);
    });
    var match$4 = $64b45ec2ab217d72$export$2b0ac18f7cd43e19(url);
    var data = match$4[1];
    var getLastModifiedNodeTimestamp = function getLastModifiedNodeTimestamp(config, $$default) {
        var largestTimestamp = {
            contents: $$default
        };
        var maybeUpdateLargestTimestamp = function maybeUpdateLargestTimestamp1(category) {
            var current = category.lastModifiedAt;
            var comparison = $2whNH.getWithDefault(current, 0.0) > $2whNH.getWithDefault(largestTimestamp.contents, 0.0);
            if (comparison) largestTimestamp.contents = current;
            $i7mYY.forEach($cq0ZS.getChildren(category), maybeUpdateLargestTimestamp);
        };
        $i7mYY.forEach($2whNH.mapWithDefault(data, [], function(config) {
            return config.categories;
        }), maybeUpdateLargestTimestamp);
        return largestTimestamp.contents;
    };
    var getLastModifiedAt = function getLastModifiedAt(config) {
        var $$default = config.lastModifiedAt;
        if (previewMode === 0) return $2whNH.getWithDefault(getLastModifiedNodeTimestamp(config, $$default), $$default);
        else return $$default;
    };
    var config$1 = config !== undefined ? config : data;
    var config$2 = $2whNH.map(config$1, function(config) {
        var newrecord = $7bjme.obj_dup(config.settings);
        return {
            id: config.id,
            categories: config.categories,
            settings: (newrecord.gaTrackingId = $2whNH.mapWithDefault(config.settings.gaTrackingId, $2whNH.flatMap(config.transitiveAccount, function(a) {
                return a.gaMeasurementId;
            }), function(id) {
                return id;
            }), newrecord.hideOutOfStock = embedType >= 5 ? false : config.settings.hideOutOfStock, newrecord),
            transitiveStoreId: config.transitiveStoreId,
            transitiveAccount: config.transitiveAccount,
            transitiveStore: config.transitiveStore,
            accountId: config.accountId,
            lastModifiedAt: getLastModifiedAt(config)
        };
    });
    var match$5 = $efwy1.use(undefined);
    var namespace = match$5.namespace;
    var config$3 = $2whNH.map(config$2, function(param) {
        return $64b45ec2ab217d72$export$ea6966039545a416(namespace, param);
    });
    var render = function render(param) {
        if (config$3 !== undefined) return /*#__PURE__*/ $g85JO.createElement($64b45ec2ab217d72$export$ca328f169d304df4, {
            value: {
                config: config$3,
                setBreakpointOverride: setBreakpointOverride
            },
            children: children
        });
        else return null;
    };
    var memoized = $g85JO.useMemo(function() {
        return render(undefined);
    }, [
        $2whNH.mapWithDefault(config$3, 0.0, function(dto) {
            return dto.lastModifiedAt;
        }),
        breakpoint
    ]);
    if (configId !== undefined) return memoized;
    else return render(undefined);
}
$64b45ec2ab217d72$var$ConfigurationProvider.displayName = "ConfigurationProvider";
function $64b45ec2ab217d72$export$1f96ae73734a86cc(param) {
    return $ivJr2.useWithDefault("ConfigurationProvider.use", "ConfigurationProvider", $64b45ec2ab217d72$export$a078c61943f9dbbe, {
        config: $dcR0L.empty,
        setBreakpointOverride: function setBreakpointOverride(param) {}
    });
}
var $64b45ec2ab217d72$export$f36c9b20522c59e3;
var $64b45ec2ab217d72$export$dd44f18ab656f3bb = $64b45ec2ab217d72$var$ConfigurationProvider;
 /* context Not a pure module */ 
});
parcelRegister("2gEz2", function(module, exports) {

$parcel$export(module.exports, "NetworkError", function () { return $1a6c8a902165eaaa$export$bae979e68e4dc802; });
$parcel$export(module.exports, "useSWR", function () { return $1a6c8a902165eaaa$export$41b6679633ce3eb7; });
$parcel$export(module.exports, "useSWRInfinite", function () { return $1a6c8a902165eaaa$export$9982c8e7e2cadcbd; });
$parcel$export(module.exports, "revalidate", function () { return $1a6c8a902165eaaa$export$b409ca198cd12e26; });
$parcel$export(module.exports, "Cache", function () { return $1a6c8a902165eaaa$export$94affb487e701bf2; });
// Generated by ReScript, PLEASE EDIT WITH CARE
parcelRequire("hFMPu");
var $208Th = parcelRequire("208Th");
var $hFMPu = parcelRequire("hFMPu");
var $8A5Rh = parcelRequire("8A5Rh");
var $1yHTa = parcelRequire("1yHTa");

var $iv6Yc = parcelRequire("iv6Yc");

var $gOCfv = parcelRequire("gOCfv");

var $g85JO = parcelRequire("g85JO");

var $eklj4 = parcelRequire("eklj4");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $1xvYg = parcelRequire("1xvYg");

var $bBMv4 = parcelRequire("bBMv4");
var $1a6c8a902165eaaa$export$bae979e68e4dc802 = /* @__PURE__ */ $1xvYg.create("SWR.NetworkError");
var $1a6c8a902165eaaa$export$ea52035eac03daf0 = /* @__PURE__ */ $1xvYg.create("SWR.ServerError");
var $1a6c8a902165eaaa$export$ef3eed12d06c0285 = /* @__PURE__ */ $1xvYg.create("SWR.DecodeError");
var $1a6c8a902165eaaa$export$f9c837a54db411d = /* @__PURE__ */ $1xvYg.create("SWR.ParseError");
function $1a6c8a902165eaaa$export$41b6679633ce3eb7(shouldRetryOnErrorOpt, refreshIntervalOpt, refreshWhenHiddenOpt, revalidateOnFocusOpt, key, fetcher) {
    var shouldRetryOnError = shouldRetryOnErrorOpt !== undefined ? shouldRetryOnErrorOpt : true;
    var refreshInterval = refreshIntervalOpt !== undefined ? refreshIntervalOpt : 0;
    var refreshWhenHidden = refreshWhenHiddenOpt !== undefined ? refreshWhenHiddenOpt : false;
    var revalidateOnFocus = revalidateOnFocusOpt !== undefined ? revalidateOnFocusOpt : true;
    return (0, $hFMPu.default)(key, fetcher, {
        refreshInterval: refreshInterval,
        refreshWhenHidden: refreshWhenHidden,
        shouldRetryOnError: shouldRetryOnError,
        revalidateOnFocus: revalidateOnFocus
    });
}
function $1a6c8a902165eaaa$export$3eeb2fec93664997(shouldRetryOnErrorOpt, refreshIntervalOpt, refreshWhenHiddenOpt, initialData, revalidateOnMount, revalidateOnFocusOpt, revalidateFirstPageOpt, key, fetcher) {
    var shouldRetryOnError = shouldRetryOnErrorOpt !== undefined ? shouldRetryOnErrorOpt : true;
    var refreshInterval = refreshIntervalOpt !== undefined ? refreshIntervalOpt : 0;
    var refreshWhenHidden = refreshWhenHiddenOpt !== undefined ? refreshWhenHiddenOpt : false;
    var revalidateOnFocus = revalidateOnFocusOpt !== undefined ? revalidateOnFocusOpt : true;
    var revalidateFirstPage = revalidateFirstPageOpt !== undefined ? revalidateFirstPageOpt : true;
    return (0, $hFMPu.default)(key, fetcher, {
        refreshInterval: refreshInterval,
        refreshWhenHidden: refreshWhenHidden,
        shouldRetryOnError: shouldRetryOnError,
        initialData: initialData,
        revalidateOnMount: revalidateOnMount,
        revalidateOnFocus: revalidateOnFocus,
        revalidateFirstPage: revalidateFirstPage
    });
}
function $1a6c8a902165eaaa$export$9982c8e7e2cadcbd(refreshInterval, refreshWhenHidden, initialSize, persistSize, revalidateAll, revalidateOnFocus, revalidateFirstPage, getKey, fetcher) {
    return $1yHTa.useSWRInfinite(getKey, fetcher, {
        refreshInterval: refreshInterval,
        refreshWhenHidden: refreshWhenHidden,
        initialSize: initialSize,
        persistSize: persistSize,
        revalidateAll: revalidateAll,
        revalidateOnFocus: revalidateOnFocus,
        revalidateFirstPage: revalidateFirstPage
    });
}
function $1a6c8a902165eaaa$export$57e795267c26e600(key, fn, revalidate) {
    return $8A5Rh.mutate(key, fn, revalidate);
}
function $1a6c8a902165eaaa$export$b409ca198cd12e26(key) {
    return $8A5Rh.mutate(key);
}
var $1a6c8a902165eaaa$export$4c7bbecdacc3ca2c = {};
function $1a6c8a902165eaaa$var$SWR$Config(Props) {
    var refreshWhenHiddenOpt = Props.refreshWhenHidden;
    var refreshIntervalOpt = Props.refreshInterval;
    var shouldRetryOnErrorOpt = Props.shouldRetryOnError;
    var revalidateOnFocusOpt = Props.revalidateOnFocus;
    var children = Props.children;
    var refreshWhenHidden = refreshWhenHiddenOpt !== undefined ? refreshWhenHiddenOpt : false;
    var refreshInterval = refreshIntervalOpt !== undefined ? refreshIntervalOpt : 0;
    var shouldRetryOnError = shouldRetryOnErrorOpt !== undefined ? shouldRetryOnErrorOpt : true;
    var revalidateOnFocus = revalidateOnFocusOpt !== undefined ? revalidateOnFocusOpt : true;
    var value = {
        refreshInterval: refreshInterval,
        refreshWhenHidden: refreshWhenHidden,
        shouldRetryOnError: shouldRetryOnError,
        revalidateOnFocus: revalidateOnFocus
    };
    return $g85JO.createElement($8A5Rh.SWRConfig, {
        value: value,
        children: children
    });
}
var $1a6c8a902165eaaa$export$29cd7b75162a9425 = {
    make: $1a6c8a902165eaaa$var$SWR$Config
};
function $1a6c8a902165eaaa$export$47fdd40111eda34c(logErrorOpt, headers, asyncDecoder, decoder, url) {
    var logError = logErrorOpt !== undefined ? logErrorOpt : true;
    var headers$1 = $2whNH.getWithDefault(headers, {});
    return $eklj4.$$catch(fetch(url, $gOCfv.RequestInit.make(/* Get */ 0, $loT9g.some(headers$1), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined)(undefined)), function(err) {
        return Promise.reject({
            RE_EXN_ID: $1a6c8a902165eaaa$export$bae979e68e4dc802,
            _1: $2whNH.getWithDefault($2whNH.flatMap($bBMv4.as_js_exn(err), function(prim) {
                return prim.message;
            }), "Network error")
        });
    }).then(function(res) {
        var status = res.status;
        if (status !== 200) return $eklj4.$$catch($gOCfv.$$Response.text(res), function(param) {
            return Promise.resolve("");
        }).then(function(text) {
            return Promise.reject({
                RE_EXN_ID: $1a6c8a902165eaaa$export$ea52035eac03daf0,
                _1: "Error fetching, non-200 response. " + String(status) + " " + text + ""
            });
        });
        else return Promise.resolve(res);
    }).then(function(res) {
        return $eklj4.$$catch($gOCfv.$$Response.json(res), function(param) {
            return Promise.reject({
                RE_EXN_ID: $1a6c8a902165eaaa$export$f9c837a54db411d,
                _1: "Could not parse as JSON"
            });
        });
    }).then(function(json) {
        if (asyncDecoder !== undefined) return $iv6Yc._1(asyncDecoder, json);
        else return Promise.resolve($iv6Yc._1(decoder, json));
    }).then(function(decoded) {
        if (decoded.TAG === /* Ok */ 0) return Promise.resolve(decoded._0);
        var err = decoded._0;
        if (logError) console.error(err);
        return Promise.reject({
            RE_EXN_ID: $1a6c8a902165eaaa$export$ef3eed12d06c0285,
            _1: "Could not decode JSON " + err + ""
        });
    });
}
var $1a6c8a902165eaaa$var$cache = $208Th.cache.cache;
var $1a6c8a902165eaaa$export$94affb487e701bf2 = {
    cache: $1a6c8a902165eaaa$var$cache
};
 /* cache Not a pure module */ 
});
parcelRegister("hFMPu", function(module, exports) {
$parcel$export(module.exports, "mutate", function () { return (parcelRequire("8A5Rh")).mutate; });
$parcel$export(module.exports, "SWRConfig", function () { return (parcelRequire("8A5Rh")).SWRConfig; });

$parcel$export(module.exports, "default", function () { return $cddc2488b980abf5$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "useSWRInfinite", function () { return (parcelRequire("1yHTa")).useSWRInfinite; });
$parcel$export(module.exports, "cache", function () { return (parcelRequire("208Th")).cache; });
// `useSWR` and related APIs

var $8A5Rh = parcelRequire("8A5Rh");

var $1yHTa = parcelRequire("1yHTa");

var $208Th = parcelRequire("208Th");
var $cddc2488b980abf5$export$2e2bcd8739ae039 = (0, $8A5Rh.default);

});
parcelRegister("8A5Rh", function(module, exports) {

$parcel$export(module.exports, "mutate", function () { return $63f63ae17ca2d8d7$export$57e795267c26e600; });
$parcel$export(module.exports, "SWRConfig", function () { return $63f63ae17ca2d8d7$export$4c7bbecdacc3ca2c; });
$parcel$export(module.exports, "default", function () { return $63f63ae17ca2d8d7$export$2e2bcd8739ae039; });

var $g85JO = parcelRequire("g85JO");

var $208Th = parcelRequire("208Th");

var $1Xfro = parcelRequire("1Xfro");

var $jQEyq = parcelRequire("jQEyq");
var $63f63ae17ca2d8d7$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $63f63ae17ca2d8d7$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
// global state managers
var $63f63ae17ca2d8d7$var$CONCURRENT_PROMISES = {};
var $63f63ae17ca2d8d7$var$CONCURRENT_PROMISES_TS = {};
var $63f63ae17ca2d8d7$var$FOCUS_REVALIDATORS = {};
var $63f63ae17ca2d8d7$var$RECONNECT_REVALIDATORS = {};
var $63f63ae17ca2d8d7$var$CACHE_REVALIDATORS = {};
var $63f63ae17ca2d8d7$var$MUTATION_TS = {};
var $63f63ae17ca2d8d7$var$MUTATION_END_TS = {};
// generate strictly increasing timestamps
var $63f63ae17ca2d8d7$var$now = function() {
    var ts = 0;
    return function() {
        return ++ts;
    };
}();
// setup DOM events listeners for `focus` and `reconnect` actions
if (!(0, $1Xfro.IS_SERVER)) {
    var $63f63ae17ca2d8d7$var$revalidate_1 = function revalidate_1(revalidators) {
        if (!(0, $208Th.default).isDocumentVisible() || !(0, $208Th.default).isOnline()) return;
        for(var key in revalidators)if (revalidators[key][0]) revalidators[key][0]();
    };
    if (typeof (0, $208Th.default).registerOnFocus === "function") (0, $208Th.default).registerOnFocus(function() {
        return $63f63ae17ca2d8d7$var$revalidate_1($63f63ae17ca2d8d7$var$FOCUS_REVALIDATORS);
    });
    if (typeof (0, $208Th.default).registerOnReconnect === "function") (0, $208Th.default).registerOnReconnect(function() {
        return $63f63ae17ca2d8d7$var$revalidate_1($63f63ae17ca2d8d7$var$RECONNECT_REVALIDATORS);
    });
}
var $63f63ae17ca2d8d7$export$e614dc9140f7ae71 = function trigger(_key, shouldRevalidate) {
    if (shouldRevalidate === void 0) shouldRevalidate = true;
    // we are ignoring the second argument which correspond to the arguments
    // the fetcher will receive when key is an array
    var _a = (0, $208Th.cache).serializeKey(_key), key = _a[0], keyErr = _a[2], keyValidating = _a[3];
    if (!key) return Promise.resolve();
    var updaters = $63f63ae17ca2d8d7$var$CACHE_REVALIDATORS[key];
    if (key && updaters) {
        var currentData = (0, $208Th.cache).get(key);
        var currentError = (0, $208Th.cache).get(keyErr);
        var currentIsValidating = (0, $208Th.cache).get(keyValidating);
        var promises = [];
        for(var i = 0; i < updaters.length; ++i)promises.push(updaters[i](shouldRevalidate, currentData, currentError, currentIsValidating, i > 0));
        // return new updated value
        return Promise.all(promises).then(function() {
            return (0, $208Th.cache).get(key);
        });
    }
    return Promise.resolve((0, $208Th.cache).get(key));
};
var $63f63ae17ca2d8d7$var$broadcastState = function broadcastState(key, data, error, isValidating) {
    var updaters = $63f63ae17ca2d8d7$var$CACHE_REVALIDATORS[key];
    if (key && updaters) for(var i = 0; i < updaters.length; ++i)updaters[i](false, data, error, isValidating);
};
var $63f63ae17ca2d8d7$export$57e795267c26e600 = function mutate(_key, _data, shouldRevalidate) {
    if (shouldRevalidate === void 0) shouldRevalidate = true;
    return $63f63ae17ca2d8d7$var$__awaiter(void 0, void 0, void 0, function() {
        var _a, key, keyErr, beforeMutationTs, beforeConcurrentPromisesTs, data, error, isAsyncMutation, err_1, shouldAbort, updaters, promises, i;
        return $63f63ae17ca2d8d7$var$__generator(this, function(_b) {
            switch(_b.label){
                case 0:
                    _a = (0, $208Th.cache).serializeKey(_key), key = _a[0], keyErr = _a[2];
                    if (!key) return [
                        2 /*return*/ 
                    ];
                    // if there is no new data to update, let's just revalidate the key
                    if (typeof _data === "undefined") return [
                        2 /*return*/ ,
                        $63f63ae17ca2d8d7$export$e614dc9140f7ae71(_key, shouldRevalidate)
                    ];
                    // update global timestamps
                    $63f63ae17ca2d8d7$var$MUTATION_TS[key] = $63f63ae17ca2d8d7$var$now() - 1;
                    $63f63ae17ca2d8d7$var$MUTATION_END_TS[key] = 0;
                    beforeMutationTs = $63f63ae17ca2d8d7$var$MUTATION_TS[key];
                    beforeConcurrentPromisesTs = $63f63ae17ca2d8d7$var$CONCURRENT_PROMISES_TS[key];
                    isAsyncMutation = false;
                    if (_data && typeof _data === "function") // `_data` is a function, call it passing current cache value
                    try {
                        _data = _data((0, $208Th.cache).get(key));
                    } catch (err) {
                        // if `_data` function throws an error synchronously, it shouldn't be cached
                        _data = undefined;
                        error = err;
                    }
                    if (!(_data && typeof _data.then === "function")) return [
                        3 /*break*/ ,
                        5
                    ];
                    // `_data` is a promise
                    isAsyncMutation = true;
                    _b.label = 1;
                case 1:
                    _b.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4 /*yield*/ ,
                        _data
                    ];
                case 2:
                    data = _b.sent();
                    return [
                        3 /*break*/ ,
                        4
                    ];
                case 3:
                    err_1 = _b.sent();
                    error = err_1;
                    return [
                        3 /*break*/ ,
                        4
                    ];
                case 4:
                    return [
                        3 /*break*/ ,
                        6
                    ];
                case 5:
                    data = _data;
                    _b.label = 6;
                case 6:
                    shouldAbort = function shouldAbort() {
                        // check if other mutations have occurred since we've started this mutation
                        if (beforeMutationTs !== $63f63ae17ca2d8d7$var$MUTATION_TS[key] || beforeConcurrentPromisesTs !== $63f63ae17ca2d8d7$var$CONCURRENT_PROMISES_TS[key]) {
                            if (error) throw error;
                            return true;
                        }
                    };
                    // if there's a race we don't update cache or broadcast change, just return the data
                    if (shouldAbort()) return [
                        2 /*return*/ ,
                        data
                    ];
                    if (typeof data !== "undefined") // update cached data
                    (0, $208Th.cache).set(key, data);
                    // always update or reset the error
                    (0, $208Th.cache).set(keyErr, error);
                    // reset the timestamp to mark the mutation has ended
                    $63f63ae17ca2d8d7$var$MUTATION_END_TS[key] = $63f63ae17ca2d8d7$var$now() - 1;
                    if (!isAsyncMutation) {
                        // we skip broadcasting if there's another mutation happened synchronously
                        if (shouldAbort()) return [
                            2 /*return*/ ,
                            data
                        ];
                    }
                    updaters = $63f63ae17ca2d8d7$var$CACHE_REVALIDATORS[key];
                    if (updaters) {
                        promises = [];
                        for(i = 0; i < updaters.length; ++i)promises.push(updaters[i](!!shouldRevalidate, data, error, undefined, i > 0));
                        // return new updated value
                        return [
                            2 /*return*/ ,
                            Promise.all(promises).then(function() {
                                if (error) throw error;
                                return (0, $208Th.cache).get(key);
                            })
                        ];
                    }
                    // throw error or return data to be used by caller of mutate
                    if (error) throw error;
                    return [
                        2 /*return*/ ,
                        data
                    ];
            }
        });
    });
};
function $63f63ae17ca2d8d7$var$useSWR() {
    var _this = this;
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var _key = args[0];
    var config = Object.assign({}, (0, $208Th.default), (0, $g85JO.useContext)((0, $jQEyq.default)), args.length > 2 ? args[2] : args.length === 2 && typeof args[1] === "object" ? args[1] : {});
    // in typescript args.length > 2 is not same as args.lenth === 3
    // we do a safe type assertion here
    // args.length === 3
    var fn = args.length > 2 ? args[1] : args.length === 2 && typeof args[1] === "function" ? args[1] : /**
                  pass fn as null will disable revalidate
                  https://paco.sh/blog/shared-hook-state-with-swr
                */ args[1] === null ? args[1] : config.fetcher;
    // we assume `key` as the identifier of the request
    // `key` can change but `fn` shouldn't
    // (because `revalidate` only depends on `key`)
    // `keyErr` is the cache key for error objects
    var _a = (0, $208Th.cache).serializeKey(_key), key = _a[0], fnArgs = _a[1], keyErr = _a[2], keyValidating = _a[3];
    var configRef = (0, $g85JO.useRef)(config);
    (0, $1Xfro.useIsomorphicLayoutEffect)(function() {
        configRef.current = config;
    });
    var willRevalidateOnMount = function willRevalidateOnMount() {
        return config.revalidateOnMount || !config.initialData && config.revalidateOnMount === undefined;
    };
    var resolveData = function resolveData() {
        var cachedData = (0, $208Th.cache).get(key);
        return typeof cachedData === "undefined" ? config.initialData : cachedData;
    };
    var resolveIsValidating = function resolveIsValidating() {
        return !!(0, $208Th.cache).get(keyValidating) || key && willRevalidateOnMount();
    };
    var initialData = resolveData();
    var initialError = (0, $208Th.cache).get(keyErr);
    var initialIsValidating = resolveIsValidating();
    // if a state is accessed (data, error or isValidating),
    // we add the state to dependencies so if the state is
    // updated in the future, we can trigger a rerender
    var stateDependencies = (0, $g85JO.useRef)({
        data: false,
        error: false,
        isValidating: false
    });
    var stateRef = (0, $g85JO.useRef)({
        data: initialData,
        error: initialError,
        isValidating: initialIsValidating
    });
    // display the data label in the React DevTools next to SWR hooks
    (0, $g85JO.useDebugValue)(stateRef.current.data);
    var rerender = (0, $g85JO.useState)({})[1];
    var dispatch = (0, $g85JO.useCallback)(function(payload) {
        var shouldUpdateState = false;
        for(var k in payload){
            // @ts-ignore
            if (stateRef.current[k] === payload[k]) continue;
            // @ts-ignore
            stateRef.current[k] = payload[k];
            // @ts-ignore
            if (stateDependencies.current[k]) shouldUpdateState = true;
        }
        if (shouldUpdateState) {
            // if component is unmounted, should skip rerender
            // if component is not mounted, should skip rerender
            if (unmountedRef.current || !initialMountedRef.current) return;
            rerender({});
        }
    }, // config.suspense isn't allowed to change during the lifecycle
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    // error ref inside revalidate (is last request errored?)
    var unmountedRef = (0, $g85JO.useRef)(false);
    var keyRef = (0, $g85JO.useRef)(key);
    // check if component is mounted in suspense mode
    var initialMountedRef = (0, $g85JO.useRef)(false);
    // do unmount check for callbacks
    var eventsCallback = (0, $g85JO.useCallback)(function(event) {
        var _a;
        var params = [];
        for(var _i = 1; _i < arguments.length; _i++)params[_i - 1] = arguments[_i];
        if (unmountedRef.current) return;
        if (!initialMountedRef.current) return;
        if (key !== keyRef.current) return;
        // @ts-ignore
        (_a = configRef.current)[event].apply(_a, params);
    }, [
        key
    ]);
    var boundMutate = (0, $g85JO.useCallback)(function(data, shouldRevalidate) {
        return $63f63ae17ca2d8d7$export$57e795267c26e600(keyRef.current, data, shouldRevalidate);
    }, []);
    var addRevalidator = function addRevalidator(revalidators, callback) {
        if (!revalidators[key]) revalidators[key] = [
            callback
        ];
        else revalidators[key].push(callback);
        return function() {
            var keyedRevalidators = revalidators[key];
            var index = keyedRevalidators.indexOf(callback);
            if (index >= 0) {
                // O(1): faster than splice
                keyedRevalidators[index] = keyedRevalidators[keyedRevalidators.length - 1];
                keyedRevalidators.pop();
            }
        };
    };
    // start a revalidation
    var revalidate = (0, $g85JO.useCallback)(function(revalidateOpts) {
        if (revalidateOpts === void 0) revalidateOpts = {};
        return $63f63ae17ca2d8d7$var$__awaiter(_this, void 0, void 0, function() {
            var _a, retryCount, _b, dedupe, loading, shouldDeduping, newData, startAt, newState, err_2;
            return $63f63ae17ca2d8d7$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        if (!key || !fn) return [
                            2 /*return*/ ,
                            false
                        ];
                        if (unmountedRef.current) return [
                            2 /*return*/ ,
                            false
                        ];
                        if (configRef.current.isPaused()) return [
                            2 /*return*/ ,
                            false
                        ];
                        _a = revalidateOpts.retryCount, retryCount = _a === void 0 ? 0 : _a, _b = revalidateOpts.dedupe, dedupe = _b === void 0 ? false : _b;
                        loading = true;
                        shouldDeduping = typeof $63f63ae17ca2d8d7$var$CONCURRENT_PROMISES[key] !== "undefined" && dedupe;
                        _c.label = 1;
                    case 1:
                        _c.trys.push([
                            1,
                            6,
                            ,
                            7
                        ]);
                        dispatch({
                            isValidating: true
                        });
                        (0, $208Th.cache).set(keyValidating, true);
                        if (!shouldDeduping) // also update other hooks
                        $63f63ae17ca2d8d7$var$broadcastState(key, stateRef.current.data, stateRef.current.error, true);
                        newData = void 0;
                        startAt = void 0;
                        if (!shouldDeduping) return [
                            3 /*break*/ ,
                            3
                        ];
                        // there's already an ongoing request,
                        // this one needs to be deduplicated.
                        startAt = $63f63ae17ca2d8d7$var$CONCURRENT_PROMISES_TS[key];
                        return [
                            4 /*yield*/ ,
                            $63f63ae17ca2d8d7$var$CONCURRENT_PROMISES[key]
                        ];
                    case 2:
                        newData = _c.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 3:
                        // if no cache being rendered currently (it shows a blank page),
                        // we trigger the loading slow event.
                        if (config.loadingTimeout && !(0, $208Th.cache).get(key)) setTimeout(function() {
                            if (loading) eventsCallback("onLoadingSlow", key, config);
                        }, config.loadingTimeout);
                        if (fnArgs !== null) $63f63ae17ca2d8d7$var$CONCURRENT_PROMISES[key] = fn.apply(void 0, fnArgs);
                        else $63f63ae17ca2d8d7$var$CONCURRENT_PROMISES[key] = fn(key);
                        $63f63ae17ca2d8d7$var$CONCURRENT_PROMISES_TS[key] = startAt = $63f63ae17ca2d8d7$var$now();
                        return [
                            4 /*yield*/ ,
                            $63f63ae17ca2d8d7$var$CONCURRENT_PROMISES[key]
                        ];
                    case 4:
                        newData = _c.sent();
                        setTimeout(function() {
                            delete $63f63ae17ca2d8d7$var$CONCURRENT_PROMISES[key];
                            delete $63f63ae17ca2d8d7$var$CONCURRENT_PROMISES_TS[key];
                        }, config.dedupingInterval);
                        // trigger the success event,
                        // only do this for the original request.
                        eventsCallback("onSuccess", newData, key, config);
                        _c.label = 5;
                    case 5:
                        // if there're other ongoing request(s), started after the current one,
                        // we need to ignore the current one to avoid possible race conditions:
                        //   req1------------------>res1        (current one)
                        //        req2---------------->res2
                        // the request that fired later will always be kept.
                        if ($63f63ae17ca2d8d7$var$CONCURRENT_PROMISES_TS[key] > startAt) return [
                            2 /*return*/ ,
                            false
                        ];
                        // if there're other mutations(s), overlapped with the current revalidation:
                        // case 1:
                        //   req------------------>res
                        //       mutate------>end
                        // case 2:
                        //         req------------>res
                        //   mutate------>end
                        // case 3:
                        //   req------------------>res
                        //       mutate-------...---------->
                        // we have to ignore the revalidation result (res) because it's no longer fresh.
                        // meanwhile, a new revalidation should be triggered when the mutation ends.
                        if ($63f63ae17ca2d8d7$var$MUTATION_TS[key] && // case 1
                        (startAt <= $63f63ae17ca2d8d7$var$MUTATION_TS[key] || // case 2
                        startAt <= $63f63ae17ca2d8d7$var$MUTATION_END_TS[key] || // case 3
                        $63f63ae17ca2d8d7$var$MUTATION_END_TS[key] === 0)) {
                            dispatch({
                                isValidating: false
                            });
                            return [
                                2 /*return*/ ,
                                false
                            ];
                        }
                        (0, $208Th.cache).set(keyErr, undefined);
                        (0, $208Th.cache).set(keyValidating, false);
                        newState = {
                            isValidating: false
                        };
                        if (typeof stateRef.current.error !== "undefined") // we don't have an error
                        newState.error = undefined;
                        if (!config.compare(stateRef.current.data, newData)) // deep compare to avoid extra re-render
                        // data changed
                        newState.data = newData;
                        if (!config.compare((0, $208Th.cache).get(key), newData)) (0, $208Th.cache).set(key, newData);
                        // merge the new state
                        dispatch(newState);
                        if (!shouldDeduping) // also update other hooks
                        $63f63ae17ca2d8d7$var$broadcastState(key, newData, newState.error, false);
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 6:
                        err_2 = _c.sent();
                        delete $63f63ae17ca2d8d7$var$CONCURRENT_PROMISES[key];
                        delete $63f63ae17ca2d8d7$var$CONCURRENT_PROMISES_TS[key];
                        if (configRef.current.isPaused()) {
                            dispatch({
                                isValidating: false
                            });
                            return [
                                2 /*return*/ ,
                                false
                            ];
                        }
                        (0, $208Th.cache).set(keyErr, err_2);
                        // get a new error
                        // don't use deep equal for errors
                        if (stateRef.current.error !== err_2) {
                            // we keep the stale data
                            dispatch({
                                isValidating: false,
                                error: err_2
                            });
                            if (!shouldDeduping) // also broadcast to update other hooks
                            $63f63ae17ca2d8d7$var$broadcastState(key, undefined, err_2, false);
                        }
                        // events and retry
                        eventsCallback("onError", err_2, key, config);
                        if (config.shouldRetryOnError) // when retrying, we always enable deduping
                        eventsCallback("onErrorRetry", err_2, key, config, revalidate, {
                            retryCount: retryCount + 1,
                            dedupe: true
                        });
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 7:
                        loading = false;
                        return [
                            2 /*return*/ ,
                            true
                        ];
                }
            });
        });
    }, // dispatch is immutable, and `eventsCallback`, `fnArgs`, `keyErr`, and `keyValidating` are based on `key`,
    // so we can them from the deps array.
    //
    // FIXME:
    // `fn` and `config` might be changed during the lifecycle,
    // but they might be changed every render like this.
    // useSWR('key', () => fetch('/api/'), { suspense: true })
    // So we omit the values from the deps array
    // even though it might cause unexpected behaviors.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        key
    ]);
    // mounted (client side rendering)
    (0, $1Xfro.useIsomorphicLayoutEffect)(function() {
        if (!key) return undefined;
        // after `key` updates, we need to mark it as mounted
        unmountedRef.current = false;
        var isUpdating = initialMountedRef.current;
        initialMountedRef.current = true;
        // after the component is mounted (hydrated),
        // we need to update the data from the cache
        // and trigger a revalidation
        var currentHookData = stateRef.current.data;
        var latestKeyedData = resolveData();
        // update the state if the key changed (not the inital render) or cache updated
        keyRef.current = key;
        if (!config.compare(currentHookData, latestKeyedData)) dispatch({
            data: latestKeyedData
        });
        // revalidate with deduping
        var softRevalidate = function softRevalidate() {
            return revalidate({
                dedupe: true
            });
        };
        // trigger a revalidation
        if (isUpdating || willRevalidateOnMount()) {
            if (typeof latestKeyedData !== "undefined" && !(0, $1Xfro.IS_SERVER)) // delay revalidate if there's cache
            // to not block the rendering
            // @ts-ignore it's safe to use requestAnimationFrame in browser
            (0, $1Xfro.rAF)(softRevalidate);
            else softRevalidate();
        }
        var pending = false;
        var onFocus = function onFocus() {
            if (pending || !configRef.current.revalidateOnFocus) return;
            pending = true;
            softRevalidate();
            setTimeout(function() {
                return pending = false;
            }, configRef.current.focusThrottleInterval);
        };
        var onReconnect = function onReconnect() {
            if (configRef.current.revalidateOnReconnect) softRevalidate();
        };
        // register global cache update listener
        var onUpdate = function onUpdate(shouldRevalidate, updatedData, updatedError, updatedIsValidating, dedupe) {
            if (shouldRevalidate === void 0) shouldRevalidate = true;
            if (dedupe === void 0) dedupe = true;
            // update hook state
            var newState = {};
            var needUpdate = false;
            if (typeof updatedData !== "undefined" && !config.compare(stateRef.current.data, updatedData)) {
                newState.data = updatedData;
                needUpdate = true;
            }
            // always update error
            // because it can be `undefined`
            if (stateRef.current.error !== updatedError) {
                newState.error = updatedError;
                needUpdate = true;
            }
            if (typeof updatedIsValidating !== "undefined" && stateRef.current.isValidating !== updatedIsValidating) {
                newState.isValidating = updatedIsValidating;
                needUpdate = true;
            }
            if (needUpdate) dispatch(newState);
            if (shouldRevalidate) {
                if (dedupe) return softRevalidate();
                else return revalidate();
            }
            return false;
        };
        var unsubFocus = addRevalidator($63f63ae17ca2d8d7$var$FOCUS_REVALIDATORS, onFocus);
        var unsubReconnect = addRevalidator($63f63ae17ca2d8d7$var$RECONNECT_REVALIDATORS, onReconnect);
        var unsubUpdate = addRevalidator($63f63ae17ca2d8d7$var$CACHE_REVALIDATORS, onUpdate);
        return function() {
            // cleanup
            dispatch = function dispatch() {
                return null;
            };
            // mark it as unmounted
            unmountedRef.current = true;
            unsubFocus();
            unsubReconnect();
            unsubUpdate();
        };
    }, [
        key,
        revalidate
    ]);
    (0, $1Xfro.useIsomorphicLayoutEffect)(function() {
        var timer = null;
        var tick = function tick1() {
            return $63f63ae17ca2d8d7$var$__awaiter(_this, void 0, void 0, function() {
                return $63f63ae17ca2d8d7$var$__generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (!(!stateRef.current.error && (configRef.current.refreshWhenHidden || configRef.current.isDocumentVisible()) && (configRef.current.refreshWhenOffline || configRef.current.isOnline()))) return [
                                3 /*break*/ ,
                                2
                            ];
                            // only revalidate when the page is visible
                            // if API request errored, we stop polling in this round
                            // and let the error retry function handle it
                            return [
                                4 /*yield*/ ,
                                revalidate({
                                    dedupe: true
                                })
                            ];
                        case 1:
                            // only revalidate when the page is visible
                            // if API request errored, we stop polling in this round
                            // and let the error retry function handle it
                            _a.sent();
                            _a.label = 2;
                        case 2:
                            // Read the latest refreshInterval
                            if (configRef.current.refreshInterval && timer) timer = setTimeout(tick, configRef.current.refreshInterval);
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        if (configRef.current.refreshInterval) timer = setTimeout(tick, configRef.current.refreshInterval);
        return function() {
            if (timer) {
                clearTimeout(timer);
                timer = null;
            }
        };
    }, [
        config.refreshInterval,
        config.refreshWhenHidden,
        config.refreshWhenOffline,
        revalidate
    ]);
    // suspense
    var latestData;
    var latestError;
    if (config.suspense) {
        // in suspense mode, we can't return empty state
        // (it should be suspended)
        // try to get data and error from cache
        latestData = (0, $208Th.cache).get(key);
        latestError = (0, $208Th.cache).get(keyErr);
        if (typeof latestData === "undefined") latestData = initialData;
        if (typeof latestError === "undefined") latestError = initialError;
        if (typeof latestData === "undefined" && typeof latestError === "undefined") {
            // need to start the request if it hasn't
            if (!$63f63ae17ca2d8d7$var$CONCURRENT_PROMISES[key]) // trigger revalidate immediately
            // to get the promise
            // in this revalidate, should not rerender
            revalidate();
            if ($63f63ae17ca2d8d7$var$CONCURRENT_PROMISES[key] && typeof $63f63ae17ca2d8d7$var$CONCURRENT_PROMISES[key].then === "function") // if it is a promise
            throw $63f63ae17ca2d8d7$var$CONCURRENT_PROMISES[key];
            // it's a value, return it directly (override)
            latestData = $63f63ae17ca2d8d7$var$CONCURRENT_PROMISES[key];
        }
        if (typeof latestData === "undefined" && latestError) // in suspense mode, throw error if there's no content
        throw latestError;
    }
    // define returned state
    // can be memorized since the state is a ref
    var memoizedState = (0, $g85JO.useMemo)(function() {
        // revalidate will be deprecated in the 1.x release
        // because mutate() covers the same use case of revalidate().
        // This remains only for backward compatibility
        var state = {
            revalidate: revalidate,
            mutate: boundMutate
        };
        Object.defineProperties(state, {
            error: {
                // `key` might be changed in the upcoming hook re-render,
                // but the previous state will stay
                // so we need to match the latest key and data (fallback to `initialData`)
                get: function get() {
                    stateDependencies.current.error = true;
                    if (config.suspense) return latestError;
                    return keyRef.current === key ? stateRef.current.error : initialError;
                },
                enumerable: true
            },
            data: {
                get: function get() {
                    stateDependencies.current.data = true;
                    if (config.suspense) return latestData;
                    return keyRef.current === key ? stateRef.current.data : initialData;
                },
                enumerable: true
            },
            isValidating: {
                get: function get() {
                    stateDependencies.current.isValidating = true;
                    return key ? stateRef.current.isValidating : false;
                },
                enumerable: true
            }
        });
        return state;
    // `config.suspense` isn't allowed to change during the lifecycle.
    // `boundMutate` is immutable, and the immutability of `revalidate` depends on `key`
    // so we can omit them from the deps array,
    // but we put it to enable react-hooks/exhaustive-deps rule.
    // `initialData` and `initialError` are not initial values
    // because they are changed during the lifecycle
    // so we should add them in the deps array.
    }, [
        revalidate,
        initialData,
        initialError,
        boundMutate,
        key,
        config.suspense,
        latestError,
        latestData
    ]);
    return memoizedState;
}
Object.defineProperty((0, $jQEyq.default).Provider, "default", {
    value: (0, $208Th.default)
});
var $63f63ae17ca2d8d7$export$4c7bbecdacc3ca2c = (0, $jQEyq.default).Provider;
var $63f63ae17ca2d8d7$export$2e2bcd8739ae039 = $63f63ae17ca2d8d7$var$useSWR;

});
parcelRegister("208Th", function(module, exports) {

$parcel$export(module.exports, "cache", function () { return $17527a53f7e8607c$export$69a3209f1a06c04d; });
$parcel$export(module.exports, "default", function () { return $17527a53f7e8607c$export$2e2bcd8739ae039; });

var $04OyG = parcelRequire("04OyG");

var $e2Lqf = parcelRequire("e2Lqf");

var $89rke = parcelRequire("89rke");
var $17527a53f7e8607c$var$__assign = undefined && undefined.__assign || function() {
    $17527a53f7e8607c$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $17527a53f7e8607c$var$__assign.apply(this, arguments);
};
// cache
var $17527a53f7e8607c$export$69a3209f1a06c04d = new (0, $e2Lqf.default)();
// error retry
function $17527a53f7e8607c$var$onErrorRetry(_, __, config, revalidate, opts) {
    if (!config.isDocumentVisible()) // if it's hidden, stop
    // it will auto revalidate when focus
    return;
    if (typeof config.errorRetryCount === "number" && opts.retryCount > config.errorRetryCount) return;
    // exponential backoff
    var count = Math.min(opts.retryCount, 8);
    var timeout = ~~((Math.random() + 0.5) * (1 << count)) * config.errorRetryInterval;
    setTimeout(revalidate, timeout, opts);
}
// client side: need to adjust the config
// based on the browser status
// slow connection (<= 70Kbps)
var $17527a53f7e8607c$var$slowConnection = typeof window !== "undefined" && // @ts-ignore
navigator["connection"] && // @ts-ignore
[
    "slow-2g",
    "2g"
].indexOf(navigator["connection"].effectiveType) !== -1;
// config
var $17527a53f7e8607c$var$defaultConfig = $17527a53f7e8607c$var$__assign({
    // events
    onLoadingSlow: function onLoadingSlow() {},
    onSuccess: function onSuccess() {},
    onError: function onError() {},
    onErrorRetry: $17527a53f7e8607c$var$onErrorRetry,
    errorRetryInterval: ($17527a53f7e8607c$var$slowConnection ? 10 : 5) * 1000,
    focusThrottleInterval: 5000,
    dedupingInterval: 2000,
    loadingTimeout: ($17527a53f7e8607c$var$slowConnection ? 5 : 3) * 1000,
    refreshInterval: 0,
    revalidateOnFocus: true,
    revalidateOnReconnect: true,
    refreshWhenHidden: false,
    refreshWhenOffline: false,
    shouldRetryOnError: true,
    suspense: false,
    compare: (0, $04OyG.dequal),
    isPaused: function isPaused() {
        return false;
    }
}, (0, $89rke.default));
var $17527a53f7e8607c$export$2e2bcd8739ae039 = $17527a53f7e8607c$var$defaultConfig;

});
parcelRegister("04OyG", function(module, exports) {

$parcel$export(module.exports, "dequal", function () { return $00e797ad72c31a35$export$de8294bb3be0322f; }, function (v) { return $00e797ad72c31a35$export$de8294bb3be0322f = v; });
var $00e797ad72c31a35$export$de8294bb3be0322f;
var $00e797ad72c31a35$var$has = Object.prototype.hasOwnProperty;
function $00e797ad72c31a35$var$dequal(foo, bar) {
    var ctor, len;
    if (foo === bar) return true;
    if (foo && bar && (ctor = foo.constructor) === bar.constructor) {
        if (ctor === Date) return foo.getTime() === bar.getTime();
        if (ctor === RegExp) return foo.toString() === bar.toString();
        if (ctor === Array) {
            if ((len = foo.length) === bar.length) {
                while(len-- && $00e797ad72c31a35$var$dequal(foo[len], bar[len]));
            }
            return len === -1;
        }
        if (!ctor || typeof foo === "object") {
            len = 0;
            for(ctor in foo){
                if ($00e797ad72c31a35$var$has.call(foo, ctor) && ++len && !$00e797ad72c31a35$var$has.call(bar, ctor)) return false;
                if (!(ctor in bar) || !$00e797ad72c31a35$var$dequal(foo[ctor], bar[ctor])) return false;
            }
            return Object.keys(bar).length === len;
        }
    }
    return foo !== foo && bar !== bar;
}
$00e797ad72c31a35$export$de8294bb3be0322f = $00e797ad72c31a35$var$dequal;

});

parcelRegister("e2Lqf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a39609ae85cf9ef2$export$2e2bcd8739ae039; });

var $8mUMP = parcelRequire("8mUMP");
var $a39609ae85cf9ef2$var$Cache = /** @class */ function() {
    function Cache(initialData) {
        if (initialData === void 0) initialData = {};
        this.cache = new Map(Object.entries(initialData));
        this.subs = [];
    }
    Cache.prototype.get = function(key) {
        var _key = this.serializeKey(key)[0];
        return this.cache.get(_key);
    };
    Cache.prototype.set = function(key, value) {
        var _key = this.serializeKey(key)[0];
        this.cache.set(_key, value);
        this.notify();
    };
    Cache.prototype.keys = function() {
        return Array.from(this.cache.keys());
    };
    Cache.prototype.has = function(key) {
        var _key = this.serializeKey(key)[0];
        return this.cache.has(_key);
    };
    Cache.prototype.clear = function() {
        this.cache.clear();
        this.notify();
    };
    Cache.prototype.delete = function(key) {
        var _key = this.serializeKey(key)[0];
        this.cache.delete(_key);
        this.notify();
    };
    // TODO: introduce namespace for the cache
    Cache.prototype.serializeKey = function(key) {
        var args = null;
        if (typeof key === "function") try {
            key = key();
        } catch (err) {
            // dependencies not ready
            key = "";
        }
        if (Array.isArray(key)) {
            // args array
            args = key;
            key = (0, $8mUMP.default)(key);
        } else // convert null to ''
        key = String(key || "");
        var errorKey = key ? "err@" + key : "";
        var isValidatingKey = key ? "validating@" + key : "";
        return [
            key,
            args,
            errorKey,
            isValidatingKey
        ];
    };
    Cache.prototype.subscribe = function(listener) {
        var _this = this;
        if (typeof listener !== "function") throw new Error("Expected the listener to be a function.");
        var isSubscribed = true;
        this.subs.push(listener);
        return function() {
            if (!isSubscribed) return;
            isSubscribed = false;
            var index = _this.subs.indexOf(listener);
            if (index > -1) {
                _this.subs[index] = _this.subs[_this.subs.length - 1];
                _this.subs.length--;
            }
        };
    };
    // Notify Cache subscribers about a change in the cache
    Cache.prototype.notify = function() {
        for(var _i = 0, _a = this.subs; _i < _a.length; _i++){
            var listener = _a[_i];
            listener();
        }
    };
    return Cache;
}();
var $a39609ae85cf9ef2$export$2e2bcd8739ae039 = $a39609ae85cf9ef2$var$Cache;

});
parcelRegister("8mUMP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $617c6d6ae37f1786$export$2e2bcd8739ae039; });
// use WeakMap to store the object->key mapping
// so the objects can be garbage collected.
// WeakMap uses a hashtable under the hood, so the lookup
// complexity is almost O(1).
var $617c6d6ae37f1786$var$table = new WeakMap();
// counter of the key
var $617c6d6ae37f1786$var$counter = 0;
function $617c6d6ae37f1786$export$2e2bcd8739ae039(args) {
    if (!args.length) return "";
    var key = "arg";
    for(var i = 0; i < args.length; ++i){
        if (args[i] === null) {
            key += "@null";
            continue;
        }
        var _hash = void 0;
        if (typeof args[i] !== "object" && typeof args[i] !== "function") {
            // need to consider the case that args[i] is a string:
            // args[i]        _hash
            // "undefined" -> '"undefined"'
            // undefined   -> 'undefined'
            // 123         -> '123'
            // "null"      -> '"null"'
            if (typeof args[i] === "string") _hash = '"' + args[i] + '"';
            else _hash = String(args[i]);
        } else if (!$617c6d6ae37f1786$var$table.has(args[i])) {
            _hash = $617c6d6ae37f1786$var$counter;
            $617c6d6ae37f1786$var$table.set(args[i], $617c6d6ae37f1786$var$counter++);
        } else _hash = $617c6d6ae37f1786$var$table.get(args[i]);
        key += "@" + _hash;
    }
    return key;
}

});


parcelRegister("89rke", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $01881200fcc95421$export$2e2bcd8739ae039; });
/**
 * Due to bug https://bugs.chromium.org/p/chromium/issues/detail?id=678075,
 * it's not reliable to detect if the browser is currently online or offline
 * based on `navigator.onLine`.
 * As a work around, we always assume it's online on first load, and change
 * the status upon `online` or `offline` events.
 */ var $01881200fcc95421$var$online = true;
var $01881200fcc95421$var$isOnline = function isOnline() {
    return $01881200fcc95421$var$online;
};
var $01881200fcc95421$var$isDocumentVisible = function isDocumentVisible() {
    if (typeof document !== "undefined" && document.visibilityState !== undefined) return document.visibilityState !== "hidden";
    // always assume it's visible
    return true;
};
var $01881200fcc95421$var$fetcher = function fetcher(url) {
    return fetch(url).then(function(res) {
        return res.json();
    });
};
var $01881200fcc95421$var$registerOnFocus = function registerOnFocus(cb) {
    if (typeof window !== "undefined" && window.addEventListener !== undefined && typeof document !== "undefined" && document.addEventListener !== undefined) {
        // focus revalidate
        document.addEventListener("visibilitychange", function() {
            return cb();
        }, false);
        window.addEventListener("focus", function() {
            return cb();
        }, false);
    }
};
var $01881200fcc95421$var$registerOnReconnect = function registerOnReconnect(cb) {
    if (typeof window !== "undefined" && window.addEventListener !== undefined) {
        // reconnect revalidate
        window.addEventListener("online", function() {
            $01881200fcc95421$var$online = true;
            cb();
        }, false);
        // nothing to revalidate, just update the status
        window.addEventListener("offline", function() {
            return $01881200fcc95421$var$online = false;
        }, false);
    }
};
var $01881200fcc95421$export$2e2bcd8739ae039 = {
    isOnline: $01881200fcc95421$var$isOnline,
    isDocumentVisible: $01881200fcc95421$var$isDocumentVisible,
    fetcher: $01881200fcc95421$var$fetcher,
    registerOnFocus: $01881200fcc95421$var$registerOnFocus,
    registerOnReconnect: $01881200fcc95421$var$registerOnReconnect
};

});


parcelRegister("1Xfro", function(module, exports) {

$parcel$export(module.exports, "IS_SERVER", function () { return $16c747591e6e79d3$export$d2f4d8e74279c212; });
$parcel$export(module.exports, "rAF", function () { return $16c747591e6e79d3$export$eba6076d3d7d0c06; });
$parcel$export(module.exports, "useIsomorphicLayoutEffect", function () { return $16c747591e6e79d3$export$700979bc83e7db82; });

var $g85JO = parcelRequire("g85JO");
var $16c747591e6e79d3$export$d2f4d8e74279c212 = typeof window === "undefined" || // @ts-ignore
!!(typeof Deno !== "undefined" && Deno && Deno.version && Deno.version.deno);
var $16c747591e6e79d3$export$eba6076d3d7d0c06 = $16c747591e6e79d3$export$d2f4d8e74279c212 ? null : window["requestAnimationFrame"] ? function rAF(f) {
    return window["requestAnimationFrame"](f);
} : function(f) {
    return setTimeout(f, 1);
};
var $16c747591e6e79d3$export$700979bc83e7db82 = $16c747591e6e79d3$export$d2f4d8e74279c212 ? (0, $g85JO.useEffect) : (0, $g85JO.useLayoutEffect);

});

parcelRegister("jQEyq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e73254e08c6b50ce$export$2e2bcd8739ae039; });

var $g85JO = parcelRequire("g85JO");
var $e73254e08c6b50ce$var$SWRConfigContext = (0, $g85JO.createContext)({});
$e73254e08c6b50ce$var$SWRConfigContext.displayName = "SWRConfigContext";
var $e73254e08c6b50ce$export$2e2bcd8739ae039 = $e73254e08c6b50ce$var$SWRConfigContext;

});


parcelRegister("1yHTa", function(module, exports) {

$parcel$export(module.exports, "useSWRInfinite", function () { return $122b02cd3e73892a$export$9982c8e7e2cadcbd; });

var $g85JO = parcelRequire("g85JO");

var $208Th = parcelRequire("208Th");

var $1Xfro = parcelRequire("1Xfro");

var $jQEyq = parcelRequire("jQEyq");

var $8A5Rh = parcelRequire("8A5Rh");
var $122b02cd3e73892a$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $122b02cd3e73892a$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $122b02cd3e73892a$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $122b02cd3e73892a$export$9982c8e7e2cadcbd() {
    var _this = this;
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var getKey = args[0];
    var config = Object.assign({}, (0, $208Th.default), (0, $g85JO.useContext)((0, $jQEyq.default)), args.length > 2 ? args[2] : args.length === 2 && typeof args[1] === "object" ? args[1] : {});
    // in typescript args.length > 2 is not same as args.lenth === 3
    // we do a safe type assertion here
    // args.length === 3
    var fn = args.length > 2 ? args[1] : args.length === 2 && typeof args[1] === "function" ? args[1] : config.fetcher;
    var _a = config.initialSize, initialSize = _a === void 0 ? 1 : _a, _b = config.revalidateAll, revalidateAll = _b === void 0 ? false : _b, _c = config.persistSize, persistSize = _c === void 0 ? false : _c, extraConfig = $122b02cd3e73892a$var$__rest(config, [
        "initialSize",
        "revalidateAll",
        "persistSize"
    ]);
    // get the serialized key of the first page
    var firstPageKey = null;
    try {
        firstPageKey = (0, $208Th.cache).serializeKey(getKey(0, null))[0];
    } catch (err) {
    // not ready
    }
    var rerender = (0, $g85JO.useState)({})[1];
    // we use cache to pass extra info (context) to fetcher so it can be globally shared
    // here we get the key of the fetcher context cache
    var contextCacheKey = null;
    if (firstPageKey) contextCacheKey = "ctx@" + firstPageKey;
    // page size is also cached to share the page data between hooks having the same key
    var pageSizeCacheKey = null;
    if (firstPageKey) pageSizeCacheKey = "len@" + firstPageKey;
    var didMountRef = (0, $g85JO.useRef)(false);
    var resolvePageSize = (0, $g85JO.useCallback)(function() {
        var cachedPageSize = (0, $208Th.cache).get(pageSizeCacheKey);
        return typeof cachedPageSize !== "undefined" ? cachedPageSize : initialSize;
    }, [
        pageSizeCacheKey,
        initialSize
    ]);
    // keep the last page size to restore it with the persistSize option
    var lastPageSizeRef = (0, $g85JO.useRef)(resolvePageSize());
    // every time the key changes, we reset the page size if it's not persisted
    (0, $1Xfro.useIsomorphicLayoutEffect)(function() {
        if (!didMountRef.current) {
            didMountRef.current = true;
            return;
        }
        // If the key has been changed, we keep the current page size if persistSize is enabled
        (0, $208Th.cache).set(pageSizeCacheKey, persistSize ? lastPageSizeRef.current : initialSize);
    // initialSize isn't allowed to change during the lifecycle
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        firstPageKey
    ]);
    // keep the data inside a ref
    var dataRef = (0, $g85JO.useRef)();
    // actual swr of all pages
    var swr = (0, $8A5Rh.default)(firstPageKey ? [
        "inf",
        firstPageKey
    ] : null, function() {
        return $122b02cd3e73892a$var$__awaiter(_this, void 0, void 0, function() {
            var _a, originalData, force, data, pageSize, previousPageData, i, _b, pageKey, pageArgs, pageData, shouldFetchPage;
            return $122b02cd3e73892a$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        _a = (0, $208Th.cache).get(contextCacheKey) || {}, originalData = _a.data, force = _a.force;
                        data = [];
                        pageSize = resolvePageSize();
                        previousPageData = null;
                        i = 0;
                        _c.label = 1;
                    case 1:
                        if (!(i < pageSize)) return [
                            3 /*break*/ ,
                            8
                        ];
                        _b = (0, $208Th.cache).serializeKey(getKey(i, previousPageData)), pageKey = _b[0], pageArgs = _b[1];
                        if (!pageKey) // pageKey is falsy, stop fetching next pages
                        return [
                            3 /*break*/ ,
                            8
                        ];
                        pageData = (0, $208Th.cache).get(pageKey);
                        shouldFetchPage = revalidateAll || force || typeof pageData === "undefined" || typeof force === "undefined" && i === 0 && typeof dataRef.current !== "undefined" || originalData && !config.compare(originalData[i], pageData);
                        if (!shouldFetchPage) return [
                            3 /*break*/ ,
                            6
                        ];
                        if (!(pageArgs !== null)) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            4 /*yield*/ ,
                            fn.apply(void 0, pageArgs)
                        ];
                    case 2:
                        pageData = _c.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 3:
                        return [
                            4 /*yield*/ ,
                            fn(pageKey)
                        ];
                    case 4:
                        pageData = _c.sent();
                        _c.label = 5;
                    case 5:
                        (0, $208Th.cache).set(pageKey, pageData);
                        _c.label = 6;
                    case 6:
                        data.push(pageData);
                        previousPageData = pageData;
                        _c.label = 7;
                    case 7:
                        ++i;
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 8:
                        // once we executed the data fetching based on the context, clear the context
                        (0, $208Th.cache).delete(contextCacheKey);
                        // return the data
                        return [
                            2 /*return*/ ,
                            data
                        ];
                }
            });
        });
    }, extraConfig);
    // update dataRef
    (0, $1Xfro.useIsomorphicLayoutEffect)(function() {
        dataRef.current = swr.data;
    }, [
        swr.data
    ]);
    var mutate = (0, $g85JO.useCallback)(function(data, shouldRevalidate) {
        if (shouldRevalidate === void 0) shouldRevalidate = true;
        if (shouldRevalidate && typeof data !== "undefined") {
            // we only revalidate the pages that are changed
            var originalData = dataRef.current;
            (0, $208Th.cache).set(contextCacheKey, {
                data: originalData,
                force: false
            });
        } else if (shouldRevalidate) // calling `mutate()`, we revalidate all pages
        (0, $208Th.cache).set(contextCacheKey, {
            force: true
        });
        return swr.mutate(data, shouldRevalidate);
    }, // swr.mutate is always the same reference
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        contextCacheKey
    ]);
    // extend the SWR API
    var setSize = (0, $g85JO.useCallback)(function(arg) {
        var size;
        if (typeof arg === "function") size = arg(resolvePageSize());
        else if (typeof arg === "number") size = arg;
        if (typeof size === "number") {
            (0, $208Th.cache).set(pageSizeCacheKey, size);
            lastPageSizeRef.current = size;
        }
        rerender({});
        return mutate(function(v) {
            return v;
        });
    }, // immutability of rerender is guaranteed by React, but react-hooks/exhaustive-deps doesn't recognize it
    // from `rerender = useState({})[1], so we put rerender here
    [
        pageSizeCacheKey,
        resolvePageSize,
        mutate,
        rerender
    ]);
    // Use getter functions to avoid unnecessary re-renders caused by triggering all the getters of the returned swr object
    var swrInfinite = {
        size: resolvePageSize(),
        setSize: setSize,
        mutate: mutate
    };
    Object.defineProperties(swrInfinite, {
        error: {
            get: function get() {
                return swr.error;
            },
            enumerable: true
        },
        data: {
            get: function get() {
                return swr.data;
            },
            enumerable: true
        },
        // revalidate will be deprecated in the 1.x release
        // because mutate() covers the same use case of revalidate().
        // This remains only for backward compatibility
        revalidate: {
            get: function get() {
                return swr.revalidate;
            },
            enumerable: true
        },
        isValidating: {
            get: function get() {
                return swr.isValidating;
            },
            enumerable: true
        }
    });
    return swrInfinite;
}

});


parcelRegister("gOCfv", function(module, exports) {

$parcel$export(module.exports, "RequestInit", function () { return $c3defc4fec8ac51e$export$ffbc82ea5de81ac6; });
$parcel$export(module.exports, "$$Request", function () { return $c3defc4fec8ac51e$export$53d047610dcbd7d1; });
$parcel$export(module.exports, "$$Response", function () { return $c3defc4fec8ac51e$export$ccdc019228fc9db2; });

var $iv6Yc = parcelRequire("iv6Yc");

var $loT9g = parcelRequire("loT9g");
function $c3defc4fec8ac51e$var$encodeRequestMethod(method_) {
    if (typeof method_ !== "number") return method_._0;
    switch(method_){
        case /* Get */ 0:
            return "GET";
        case /* Head */ 1:
            return "HEAD";
        case /* Post */ 2:
            return "POST";
        case /* Put */ 3:
            return "PUT";
        case /* Delete */ 4:
            return "DELETE";
        case /* Connect */ 5:
            return "CONNECT";
        case /* Options */ 6:
            return "OPTIONS";
        case /* Trace */ 7:
            return "TRACE";
        case /* Patch */ 8:
            return "PATCH";
    }
}
function $c3defc4fec8ac51e$var$encodeReferrerPolicy(param) {
    switch(param){
        case /* None */ 0:
            return "";
        case /* NoReferrer */ 1:
            return "no-referrer";
        case /* NoReferrerWhenDowngrade */ 2:
            return "no-referrer-when-downgrade";
        case /* SameOrigin */ 3:
            return "same-origin";
        case /* Origin */ 4:
            return "origin";
        case /* StrictOrigin */ 5:
            return "strict-origin";
        case /* OriginWhenCrossOrigin */ 6:
            return "origin-when-cross-origin";
        case /* StrictOriginWhenCrossOrigin */ 7:
            return "strict-origin-when-cross-origin";
        case /* UnsafeUrl */ 8:
            return "unsafe-url";
    }
}
function $c3defc4fec8ac51e$var$encodeRequestMode(param) {
    switch(param){
        case /* Navigate */ 0:
            return "navigate";
        case /* SameOrigin */ 1:
            return "same-origin";
        case /* NoCORS */ 2:
            return "no-cors";
        case /* CORS */ 3:
            return "cors";
    }
}
function $c3defc4fec8ac51e$var$encodeRequestCredentials(param) {
    switch(param){
        case /* Omit */ 0:
            return "omit";
        case /* SameOrigin */ 1:
            return "same-origin";
        case /* Include */ 2:
            return "include";
    }
}
function $c3defc4fec8ac51e$var$encodeRequestCache(param) {
    switch(param){
        case /* Default */ 0:
            return "default";
        case /* NoStore */ 1:
            return "no-store";
        case /* Reload */ 2:
            return "reload";
        case /* NoCache */ 3:
            return "no-cache";
        case /* ForceCache */ 4:
            return "force-cache";
        case /* OnlyIfCached */ 5:
            return "only-if-cached";
    }
}
function $c3defc4fec8ac51e$var$encodeRequestRedirect(param) {
    switch(param){
        case /* Follow */ 0:
            return "follow";
        case /* Error */ 1:
            return "error";
        case /* Manual */ 2:
            return "manual";
    }
}
var $c3defc4fec8ac51e$export$6dc17dc4269800be = {};
function $c3defc4fec8ac51e$var$append(arg1, arg2, obj) {
    obj.append(arg1, arg2);
}
function $c3defc4fec8ac51e$var$$$delete(arg1, obj) {
    obj.delete(arg1);
}
function $c3defc4fec8ac51e$var$get(arg1, obj) {
    return $loT9g.null_to_opt(obj.get(arg1));
}
function $c3defc4fec8ac51e$var$has(arg1, obj) {
    return obj.has(arg1);
}
function $c3defc4fec8ac51e$var$set(arg1, arg2, obj) {
    obj.set(arg1, arg2);
}
var $c3defc4fec8ac51e$export$953df90d5d5fed48 = {
    append: $c3defc4fec8ac51e$var$append,
    $$delete: $c3defc4fec8ac51e$var$$$delete,
    get: $c3defc4fec8ac51e$var$get,
    has: $c3defc4fec8ac51e$var$has,
    set: $c3defc4fec8ac51e$var$set
};
var $c3defc4fec8ac51e$export$f7d5d70d55931f4b = {};
function $c3defc4fec8ac51e$var$map(f, v) {
    if (v !== undefined) return $loT9g.some($iv6Yc._1(f, $loT9g.valFromOption(v)));
}
function $c3defc4fec8ac51e$var$make(method_, headers, body, referrer, referrerPolicyOpt, mode, credentials, cache, redirect, integrityOpt, keepalive, signal) {
    var _$referrerPolicy = referrerPolicyOpt !== undefined ? referrerPolicyOpt : /* None */ 0;
    var integrity = integrityOpt !== undefined ? integrityOpt : "";
    var partial_arg = integrity;
    var partial_arg$1 = $c3defc4fec8ac51e$var$map($c3defc4fec8ac51e$var$encodeRequestRedirect, redirect);
    var partial_arg$2 = $c3defc4fec8ac51e$var$map($c3defc4fec8ac51e$var$encodeRequestCache, cache);
    var partial_arg$3 = $c3defc4fec8ac51e$var$map($c3defc4fec8ac51e$var$encodeRequestCredentials, credentials);
    var partial_arg$4 = $c3defc4fec8ac51e$var$map($c3defc4fec8ac51e$var$encodeRequestMode, mode);
    var partial_arg$5 = $c3defc4fec8ac51e$var$encodeReferrerPolicy(_$referrerPolicy);
    var partial_arg$6 = $c3defc4fec8ac51e$var$map($c3defc4fec8ac51e$var$encodeRequestMethod, method_);
    return function(param) {
        var tmp = {};
        if (partial_arg$6 !== undefined) tmp.method = partial_arg$6;
        if (headers !== undefined) tmp.headers = $loT9g.valFromOption(headers);
        if (body !== undefined) tmp.body = $loT9g.valFromOption(body);
        if (referrer !== undefined) tmp.referrer = referrer;
        if (partial_arg$5 !== undefined) tmp.referrerPolicy = partial_arg$5;
        if (partial_arg$4 !== undefined) tmp.mode = partial_arg$4;
        if (partial_arg$3 !== undefined) tmp.credentials = partial_arg$3;
        if (partial_arg$2 !== undefined) tmp.cache = partial_arg$2;
        if (partial_arg$1 !== undefined) tmp.redirect = partial_arg$1;
        if (partial_arg !== undefined) tmp.integrity = partial_arg;
        if (keepalive !== undefined) tmp.keepalive = keepalive;
        if (signal !== undefined) tmp.signal = $loT9g.valFromOption(signal);
        return tmp;
    };
}
function $c3defc4fec8ac51e$var$method_(self) {
    var method_$1 = self.method;
    switch(method_$1){
        case "CONNECT":
            return /* Connect */ 5;
        case "DELETE":
            return /* Delete */ 4;
        case "GET":
            return /* Get */ 0;
        case "HEAD":
            return /* Head */ 1;
        case "OPTIONS":
            return /* Options */ 6;
        case "PATCH":
            return /* Patch */ 8;
        case "POST":
            return /* Post */ 2;
        case "PUT":
            return /* Put */ 3;
        case "TRACE":
            return /* Trace */ 7;
        default:
            return /* Other */ {
                _0: method_$1
            };
    }
}
function $c3defc4fec8ac51e$var$type_(self) {
    var e = self.type;
    switch(e){
        case "":
            return /* None */ 0;
        case "audio":
            return /* Audio */ 1;
        case "font":
            return /* Font */ 2;
        case "image":
            return /* Image */ 3;
        case "script":
            return /* Script */ 4;
        case "style":
            return /* Style */ 5;
        case "track":
            return /* Track */ 6;
        case "video":
            return /* Video */ 7;
        default:
            throw {
                RE_EXN_ID: "Failure",
                _1: "Unknown requestType: " + e,
                Error: new Error()
            };
    }
}
function $c3defc4fec8ac51e$var$destination(self) {
    var e = self.destination;
    switch(e){
        case "":
            return /* None */ 0;
        case "document":
            return /* Document */ 1;
        case "embed":
            return /* Embed */ 2;
        case "font":
            return /* Font */ 3;
        case "image":
            return /* Image */ 4;
        case "manifest":
            return /* Manifest */ 5;
        case "media":
            return /* Media */ 6;
        case "object":
            return /* Object */ 7;
        case "report":
            return /* Report */ 8;
        case "script":
            return /* Script */ 9;
        case "serviceworker":
            return /* ServiceWorker */ 10;
        case "sharedworder":
            return /* SharedWorker */ 11;
        case "style":
            return /* Style */ 12;
        case "worker":
            return /* Worker */ 13;
        case "xslt":
            return /* Xslt */ 14;
        default:
            throw {
                RE_EXN_ID: "Failure",
                _1: "Unknown requestDestination: " + e,
                Error: new Error()
            };
    }
}
function $c3defc4fec8ac51e$var$referrerPolicy(self) {
    var e = self.referrerPolicy;
    switch(e){
        case "":
            return /* None */ 0;
        case "no-referrer":
            return /* NoReferrer */ 1;
        case "no-referrer-when-downgrade":
            return /* NoReferrerWhenDowngrade */ 2;
        case "origin":
            return /* Origin */ 4;
        case "origin-when-cross-origin":
            return /* OriginWhenCrossOrigin */ 6;
        case "same-origin":
            return /* SameOrigin */ 3;
        case "strict-origin":
            return /* StrictOrigin */ 5;
        case "strict-origin-when-cross-origin":
            return /* StrictOriginWhenCrossOrigin */ 7;
        case "unsafe-url":
            return /* UnsafeUrl */ 8;
        default:
            throw {
                RE_EXN_ID: "Failure",
                _1: "Unknown referrerPolicy: " + e,
                Error: new Error()
            };
    }
}
function $c3defc4fec8ac51e$var$mode(self) {
    var e = self.mode;
    switch(e){
        case "cors":
            return /* CORS */ 3;
        case "navigate":
            return /* Navigate */ 0;
        case "no-cors":
            return /* NoCORS */ 2;
        case "same-origin":
            return /* SameOrigin */ 1;
        default:
            throw {
                RE_EXN_ID: "Failure",
                _1: "Unknown requestMode: " + e,
                Error: new Error()
            };
    }
}
function $c3defc4fec8ac51e$var$credentials(self) {
    var e = self.credentials;
    switch(e){
        case "include":
            return /* Include */ 2;
        case "omit":
            return /* Omit */ 0;
        case "same-origin":
            return /* SameOrigin */ 1;
        default:
            throw {
                RE_EXN_ID: "Failure",
                _1: "Unknown requestCredentials: " + e,
                Error: new Error()
            };
    }
}
function $c3defc4fec8ac51e$var$cache(self) {
    var e = self.cache;
    switch(e){
        case "default":
            return /* Default */ 0;
        case "force-cache":
            return /* ForceCache */ 4;
        case "no-cache":
            return /* NoCache */ 3;
        case "no-store":
            return /* NoStore */ 1;
        case "only-if-cached":
            return /* OnlyIfCached */ 5;
        case "reload":
            return /* Reload */ 2;
        default:
            throw {
                RE_EXN_ID: "Failure",
                _1: "Unknown requestCache: " + e,
                Error: new Error()
            };
    }
}
function $c3defc4fec8ac51e$var$redirect(self) {
    var e = self.redirect;
    switch(e){
        case "error":
            return /* Error */ 1;
        case "follow":
            return /* Follow */ 0;
        case "manual":
            return /* Manual */ 2;
        default:
            throw {
                RE_EXN_ID: "Failure",
                _1: "Unknown requestRedirect: " + e,
                Error: new Error()
            };
    }
}
function $c3defc4fec8ac51e$var$classify(t) {
    if (typeof t === "string") return {
        NAME: "String",
        VAL: t
    };
    else return {
        NAME: "File",
        VAL: t
    };
}
var $c3defc4fec8ac51e$var$EntryValue = {
    classify: $c3defc4fec8ac51e$var$classify
};
function $c3defc4fec8ac51e$var$append$1(arg1, arg2, obj) {
    obj.append(arg1, arg2);
}
function $c3defc4fec8ac51e$var$$$delete$1(arg1, obj) {
    obj.delete(arg1);
}
function $c3defc4fec8ac51e$var$get$1(arg1, obj) {
    return obj.get(arg1);
}
function $c3defc4fec8ac51e$var$getAll(arg1, obj) {
    return obj.getAll(arg1);
}
function $c3defc4fec8ac51e$var$set$1(arg1, arg2, obj) {
    obj.set(arg1, arg2);
}
function $c3defc4fec8ac51e$var$has$1(arg1, obj) {
    return obj.has(arg1);
}
function $c3defc4fec8ac51e$var$appendObject(arg1, arg2, filename, obj) {
    obj.append(arg1, arg2, filename !== undefined ? $loT9g.valFromOption(filename) : undefined);
}
function $c3defc4fec8ac51e$var$appendBlob(arg1, arg2, filename, obj) {
    obj.append(arg1, arg2, filename !== undefined ? $loT9g.valFromOption(filename) : undefined);
}
function $c3defc4fec8ac51e$var$appendFile(arg1, arg2, filename, obj) {
    obj.append(arg1, arg2, filename !== undefined ? $loT9g.valFromOption(filename) : undefined);
}
function $c3defc4fec8ac51e$var$setObject(arg1, arg2, filename, obj) {
    obj.set(arg1, arg2, filename !== undefined ? $loT9g.valFromOption(filename) : undefined);
}
function $c3defc4fec8ac51e$var$setBlob(arg1, arg2, filename, obj) {
    obj.set(arg1, arg2, filename !== undefined ? $loT9g.valFromOption(filename) : undefined);
}
function $c3defc4fec8ac51e$var$setFile(arg1, arg2, filename, obj) {
    obj.set(arg1, arg2, filename !== undefined ? $loT9g.valFromOption(filename) : undefined);
}
var $c3defc4fec8ac51e$export$18c5480443206253 = {
    EntryValue: $c3defc4fec8ac51e$var$EntryValue,
    Iterator: undefined,
    append: $c3defc4fec8ac51e$var$append$1,
    $$delete: $c3defc4fec8ac51e$var$$$delete$1,
    get: $c3defc4fec8ac51e$var$get$1,
    getAll: $c3defc4fec8ac51e$var$getAll,
    set: $c3defc4fec8ac51e$var$set$1,
    has: $c3defc4fec8ac51e$var$has$1,
    appendObject: $c3defc4fec8ac51e$var$appendObject,
    appendBlob: $c3defc4fec8ac51e$var$appendBlob,
    appendFile: $c3defc4fec8ac51e$var$appendFile,
    setObject: $c3defc4fec8ac51e$var$setObject,
    setBlob: $c3defc4fec8ac51e$var$setBlob,
    setFile: $c3defc4fec8ac51e$var$setFile
};
var $c3defc4fec8ac51e$export$271af40fe955dbf7 = {
    abort: function abort(prim) {
        prim.abort();
    }
};
function $c3defc4fec8ac51e$var$Body_arrayBuffer(prim) {
    return prim.arrayBuffer();
}
function $c3defc4fec8ac51e$var$Body_blob(prim) {
    return prim.blob();
}
function $c3defc4fec8ac51e$var$Body_formData(prim) {
    return prim.formData();
}
function $c3defc4fec8ac51e$var$Body_json(prim) {
    return prim.json();
}
function $c3defc4fec8ac51e$var$Body_text(prim) {
    return prim.text();
}
var $c3defc4fec8ac51e$export$4b2c32e08f77ff18 = {
    arrayBuffer: $c3defc4fec8ac51e$var$Body_arrayBuffer,
    blob: $c3defc4fec8ac51e$var$Body_blob,
    formData: $c3defc4fec8ac51e$var$Body_formData,
    json: $c3defc4fec8ac51e$var$Body_json,
    text: $c3defc4fec8ac51e$var$Body_text
};
var $c3defc4fec8ac51e$export$ffbc82ea5de81ac6 = {
    make: $c3defc4fec8ac51e$var$make
};
function $c3defc4fec8ac51e$var$Request_arrayBuffer(prim) {
    return prim.arrayBuffer();
}
function $c3defc4fec8ac51e$var$Request_blob(prim) {
    return prim.blob();
}
function $c3defc4fec8ac51e$var$Request_formData(prim) {
    return prim.formData();
}
function $c3defc4fec8ac51e$var$Request_json(prim) {
    return prim.json();
}
function $c3defc4fec8ac51e$var$Request_text(prim) {
    return prim.text();
}
var $c3defc4fec8ac51e$export$53d047610dcbd7d1 = {
    method_: $c3defc4fec8ac51e$var$method_,
    type_: $c3defc4fec8ac51e$var$type_,
    destination: $c3defc4fec8ac51e$var$destination,
    referrerPolicy: $c3defc4fec8ac51e$var$referrerPolicy,
    mode: $c3defc4fec8ac51e$var$mode,
    credentials: $c3defc4fec8ac51e$var$credentials,
    cache: $c3defc4fec8ac51e$var$cache,
    redirect: $c3defc4fec8ac51e$var$redirect,
    arrayBuffer: $c3defc4fec8ac51e$var$Request_arrayBuffer,
    blob: $c3defc4fec8ac51e$var$Request_blob,
    formData: $c3defc4fec8ac51e$var$Request_formData,
    json: $c3defc4fec8ac51e$var$Request_json,
    text: $c3defc4fec8ac51e$var$Request_text
};
function $c3defc4fec8ac51e$var$Response_clone(prim) {
    return prim.clone();
}
function $c3defc4fec8ac51e$var$Response_arrayBuffer(prim) {
    return prim.arrayBuffer();
}
function $c3defc4fec8ac51e$var$Response_blob(prim) {
    return prim.blob();
}
function $c3defc4fec8ac51e$var$Response_formData(prim) {
    return prim.formData();
}
function $c3defc4fec8ac51e$var$Response_json(prim) {
    return prim.json();
}
function $c3defc4fec8ac51e$var$Response_text(prim) {
    return prim.text();
}
var $c3defc4fec8ac51e$export$ccdc019228fc9db2 = {
    clone: $c3defc4fec8ac51e$var$Response_clone,
    arrayBuffer: $c3defc4fec8ac51e$var$Response_arrayBuffer,
    blob: $c3defc4fec8ac51e$var$Response_blob,
    formData: $c3defc4fec8ac51e$var$Response_formData,
    json: $c3defc4fec8ac51e$var$Response_json,
    text: $c3defc4fec8ac51e$var$Response_text
};
 /* No side effect */ 
});


parcelRegister("16qP0", function(module, exports) {

$parcel$export(module.exports, "use", function () { return $0cdb28399fc98f06$export$1f96ae73734a86cc; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $g85JO = parcelRequire("g85JO");

var $hxhfd = parcelRequire("hxhfd");

var $hBcYV = parcelRequire("hBcYV");
var $0cdb28399fc98f06$export$2cd8252107eb640b = {
    smartnavApiHost: $hxhfd.apiHostnameProduction
};
var $0cdb28399fc98f06$export$a078c61943f9dbbe = /*#__PURE__*/ $g85JO.createContext($0cdb28399fc98f06$export$2cd8252107eb640b);
var $0cdb28399fc98f06$export$ca328f169d304df4 = $0cdb28399fc98f06$export$a078c61943f9dbbe.Provider;
function $0cdb28399fc98f06$var$UseEnv(Props) {
    var value = Props.value;
    var children = Props.children;
    return /*#__PURE__*/ $g85JO.createElement($0cdb28399fc98f06$export$ca328f169d304df4, {
        value: value,
        children: children
    });
}
$0cdb28399fc98f06$var$UseEnv.displayName = "UseEnv";
function $0cdb28399fc98f06$export$1f96ae73734a86cc(param) {
    var match = $hBcYV.useRouter(undefined);
    var devMode = match.devMode;
    return $g85JO.useContext(devMode !== undefined ? /*#__PURE__*/ $g85JO.createContext({
        smartnavApiHost: $hxhfd.getApiHostname(devMode)
    }) : $0cdb28399fc98f06$export$a078c61943f9dbbe);
}
var $0cdb28399fc98f06$export$dd44f18ab656f3bb = $0cdb28399fc98f06$var$UseEnv;
 /* context Not a pure module */ 
});
parcelRegister("hBcYV", function(module, exports) {

$parcel$export(module.exports, "getListPageCategoryId", function () { return $ccfff63d2d5023ce$export$a7ae50691d4c079c; });
$parcel$export(module.exports, "toString", function () { return $ccfff63d2d5023ce$export$f84e8e69fd4488a5; });
$parcel$export(module.exports, "useRouter", function () { return $ccfff63d2d5023ce$export$9a302a45f65d0572; });
$parcel$export(module.exports, "useActiveCategory", function () { return $ccfff63d2d5023ce$export$6c760c46f61cf29a; });
$parcel$export(module.exports, "isPreview", function () { return $ccfff63d2d5023ce$export$bda24362f94bfb51; });
$parcel$export(module.exports, "make", function () { return $ccfff63d2d5023ce$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $7bjme = parcelRequire("7bjme");

var $69lAE = parcelRequire("69lAE");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $79vie = parcelRequire("79vie");

var $fEMeF = parcelRequire("fEMeF");

var $jVmMx = parcelRequire("jVmMx");

var $kJhYp = parcelRequire("kJhYp");

var $hylFb = parcelRequire("hylFb");

var $cq0ZS = parcelRequire("cq0ZS");

var $efwy1 = parcelRequire("efwy1");

var $9hB74 = parcelRequire("9hB74");

var $04dLg = parcelRequire("04dLg");
var $ccfff63d2d5023ce$export$8959acddd05dbdf0 = $79vie.map2($79vie.field("categoryId", $79vie.string), $79vie.field("sourceNodeId", $79vie.nullable($79vie.string)), function(categoryId, sourceNodeId) {
    return {
        categoryId: categoryId,
        sourceNodeId: sourceNodeId
    };
});
function $ccfff63d2d5023ce$export$dc9746201ba00425(storeCategoryType) {
    return $iv6Yc._1($jVmMx.Encode.object, [
        [
            "categoryId",
            $iv6Yc._1($jVmMx.Encode.string, storeCategoryType.categoryId)
        ],
        [
            "sourceNodeId",
            $jVmMx.Encode.nullable(storeCategoryType.sourceNodeId, $jVmMx.Encode.string)
        ]
    ]);
}
function $ccfff63d2d5023ce$export$39a82c2d7daeef99(homeType) {
    if (typeof homeType !== "number") return $jVmMx.Encode.deccoVariantWithPayload(homeType._0, "StoreCategory", $ccfff63d2d5023ce$export$dc9746201ba00425);
    switch(homeType){
        case /* Index */ 0:
            return $jVmMx.Encode.simpleVariant([
                [
                    "Index",
                    /* Index */ 0
                ]
            ], /* Index */ 0);
        case /* Favorites */ 1:
            return $jVmMx.Encode.simpleVariant([
                [
                    "Favorites",
                    /* Favorites */ 1
                ]
            ], /* Favorites */ 1);
        case /* History */ 2:
            return $jVmMx.Encode.simpleVariant([
                [
                    "History",
                    /* History */ 2
                ]
            ], /* History */ 2);
        case /* StoreCart */ 3:
            return $jVmMx.Encode.simpleVariant([
                [
                    "StoreCart",
                    /* StoreCart */ 3
                ]
            ], /* StoreCart */ 3);
    }
}
var $ccfff63d2d5023ce$var$index = $jVmMx.Decode.simpleVariant([
    [
        "Index",
        /* Index */ 0
    ]
]);
var $ccfff63d2d5023ce$var$favorites = $jVmMx.Decode.simpleVariant([
    [
        "Favorites",
        /* Favorites */ 1
    ]
]);
var $ccfff63d2d5023ce$var$history = $jVmMx.Decode.simpleVariant([
    [
        "History",
        /* History */ 2
    ]
]);
var $ccfff63d2d5023ce$var$storeCart = $jVmMx.Decode.simpleVariant([
    [
        "StoreCart",
        /* StoreCart */ 3
    ]
]);
var $ccfff63d2d5023ce$var$storeCategory = $jVmMx.Decode.deccoVariantWithPayload("StoreCategory", $ccfff63d2d5023ce$export$8959acddd05dbdf0, function(v) {
    return /* StoreCategory */ {
        _0: v
    };
});
var $ccfff63d2d5023ce$export$b1c11dd88551da9a = $iv6Yc._2($jVmMx.Decode.oneOf, $ccfff63d2d5023ce$var$index, [
    $ccfff63d2d5023ce$var$favorites,
    $ccfff63d2d5023ce$var$history,
    $ccfff63d2d5023ce$var$storeCart,
    $ccfff63d2d5023ce$var$storeCategory
]);
function $ccfff63d2d5023ce$export$2fa9a34fd04640d2(param) {
    return $iv6Yc._1($jVmMx.Encode.object, [
        [
            "homeType",
            $ccfff63d2d5023ce$export$39a82c2d7daeef99(param.homeType)
        ],
        [
            "filters",
            $jVmMx.Encode.nullable(param.filters, $fEMeF.t_encode)
        ],
        [
            "sort",
            $jVmMx.Encode.nullable(param.sort, $04dLg.ProductSortOrder.toJson)
        ]
    ]);
}
var $ccfff63d2d5023ce$export$f6abe3d4c037d964 = $79vie.map3($79vie.field("homeType", $ccfff63d2d5023ce$export$b1c11dd88551da9a), $79vie.field("filters", $79vie.option($fEMeF.fromJson)), $79vie.field("sort", $79vie.option($04dLg.ProductSortOrder.fromJson)), function(homeType, filters, sort) {
    return {
        homeType: homeType,
        filters: filters,
        sort: sort
    };
});
function $ccfff63d2d5023ce$export$6499df23410b158d(listPageType) {
    if (typeof listPageType === "number") switch(listPageType){
        case /* Favorites */ 0:
            return $jVmMx.Encode.simpleVariant([
                [
                    "Favorites",
                    /* Favorites */ 0
                ]
            ], /* Favorites */ 0);
        case /* History */ 1:
            return $jVmMx.Encode.simpleVariant([
                [
                    "History",
                    /* History */ 1
                ]
            ], /* History */ 1);
        case /* StoreCart */ 2:
            return $jVmMx.Encode.simpleVariant([
                [
                    "StoreCart",
                    /* StoreCart */ 2
                ]
            ], /* StoreCart */ 2);
    }
    else switch(listPageType.TAG | 0){
        case /* Category */ 0:
            return $jVmMx.Encode.deccoVariantWithPayload(listPageType._0, "Category", $jVmMx.Encode.string);
        case /* Product */ 1:
            return $jVmMx.Encode.deccoVariantWithPayload(listPageType._0, "Product", $jVmMx.Encode.string);
        case /* StoreCategory */ 2:
            return $jVmMx.Encode.deccoVariantWithPayload(listPageType._0, "StoreCategory", $ccfff63d2d5023ce$export$dc9746201ba00425);
    }
}
var $ccfff63d2d5023ce$var$category = $jVmMx.Decode.deccoVariantWithPayload("Category", $jVmMx.Decode.string, function(v) {
    return {
        TAG: /* Category */ 0,
        _0: v
    };
});
var $ccfff63d2d5023ce$var$product = $jVmMx.Decode.deccoVariantWithPayload("Product", $jVmMx.Decode.string, function(v) {
    return {
        TAG: /* Product */ 1,
        _0: v
    };
});
var $ccfff63d2d5023ce$var$favorites$1 = $jVmMx.Decode.simpleVariant([
    [
        "Favorites",
        /* Favorites */ 0
    ]
]);
var $ccfff63d2d5023ce$var$history$1 = $jVmMx.Decode.simpleVariant([
    [
        "History",
        /* History */ 1
    ]
]);
var $ccfff63d2d5023ce$var$storeCart$1 = $jVmMx.Decode.simpleVariant([
    [
        "StoreCart",
        /* StoreCart */ 2
    ]
]);
var $ccfff63d2d5023ce$var$storeCategory$1 = $jVmMx.Decode.deccoVariantWithPayload("StoreCategory", $ccfff63d2d5023ce$export$8959acddd05dbdf0, function(v) {
    return {
        TAG: /* StoreCategory */ 2,
        _0: v
    };
});
var $ccfff63d2d5023ce$export$77c42703ca5af014 = $iv6Yc._2($jVmMx.Decode.oneOf, $ccfff63d2d5023ce$var$category, [
    $ccfff63d2d5023ce$var$product,
    $ccfff63d2d5023ce$var$favorites$1,
    $ccfff63d2d5023ce$var$history$1,
    $ccfff63d2d5023ce$var$storeCart$1,
    $ccfff63d2d5023ce$var$storeCategory$1
]);
function $ccfff63d2d5023ce$export$e07909246d7a7182(param) {
    return $iv6Yc._1($jVmMx.Encode.object, [
        [
            "listPageType",
            $ccfff63d2d5023ce$export$6499df23410b158d(param.listPageType)
        ],
        [
            "viewPLP",
            $iv6Yc._1($jVmMx.Encode.bool, param.viewPLP)
        ],
        [
            "filters",
            $jVmMx.Encode.nullable(param.filters, $fEMeF.t_encode)
        ],
        [
            "sort",
            $jVmMx.Encode.nullable(param.sort, $04dLg.ProductSortOrder.toJson)
        ]
    ]);
}
var $ccfff63d2d5023ce$export$400d2f7d94b7449e = $79vie.map4($79vie.field("listPageType", $ccfff63d2d5023ce$export$77c42703ca5af014), $79vie.field("viewPLP", $79vie.bool), $79vie.field("filters", $79vie.option($fEMeF.fromJson)), $79vie.field("sort", $79vie.option($04dLg.ProductSortOrder.fromJson)), function(listPageType, viewPLP, filters, sort) {
    return {
        listPageType: listPageType,
        viewPLP: viewPLP,
        filters: filters,
        sort: sort
    };
});
function $ccfff63d2d5023ce$export$aaccbef6c4ed376a(param) {
    return $iv6Yc._1($jVmMx.Encode.object, [
        [
            "categoryId",
            $jVmMx.Encode.nullable(param.categoryId, $jVmMx.Encode.string)
        ],
        [
            "productCategoryId",
            $jVmMx.Encode.nullable(param.productCategoryId, $jVmMx.Encode.string)
        ],
        [
            "productId",
            $iv6Yc._1($jVmMx.Encode.string, param.productId)
        ],
        [
            "variantId",
            $jVmMx.Encode.nullable(param.variantId, $jVmMx.Encode.string)
        ],
        [
            "zoomedPhotoIndex",
            $jVmMx.Encode.nullable(param.zoomedPhotoIndex, $jVmMx.Encode.$$int)
        ]
    ]);
}
var $ccfff63d2d5023ce$export$463dcecd5ba8ab56 = $79vie.map5($79vie.field("categoryId", $79vie.option($79vie.string)), $79vie.field("productCategoryId", $79vie.option($79vie.string)), $79vie.field("productId", $79vie.string), $79vie.field("variantId", $79vie.option($79vie.string)), $79vie.field("zoomedPhotoIndex", $79vie.option($79vie.$$int)), function(categoryId, productCategoryId, productId, variantId, zoomedPhotoIndex) {
    return {
        categoryId: categoryId,
        productCategoryId: productCategoryId,
        productId: productId,
        variantId: variantId,
        zoomedPhotoIndex: zoomedPhotoIndex
    };
});
function $ccfff63d2d5023ce$export$7f097db678b13234(param) {
    return $iv6Yc._1($jVmMx.Encode.object, [
        [
            "mediaId",
            $iv6Yc._1($jVmMx.Encode.string, param.mediaId)
        ],
        [
            "mediaParentId",
            $jVmMx.Encode.nullable(param.mediaParentId, $jVmMx.Encode.string)
        ],
        [
            "albumId",
            $jVmMx.Encode.nullable(param.albumId, $jVmMx.Encode.string)
        ],
        [
            "productId",
            $jVmMx.Encode.nullable(param.productId, $jVmMx.Encode.string)
        ],
        [
            "variantId",
            $jVmMx.Encode.nullable(param.variantId, $jVmMx.Encode.string)
        ],
        [
            "panelClosed",
            $jVmMx.Encode.nullable(param.panelClosed, $jVmMx.Encode.bool)
        ],
        [
            "zoomedPhotoIndex",
            $jVmMx.Encode.nullable(param.zoomedPhotoIndex, $jVmMx.Encode.$$int)
        ],
        [
            "time",
            $jVmMx.Encode.nullable(param.time, $jVmMx.Encode.$$float)
        ]
    ]);
}
var $ccfff63d2d5023ce$export$7248f310197d616e = $79vie.andMap($79vie.andMap($79vie.andMap($79vie.andMap($79vie.andMap($79vie.andMap($79vie.andMap($79vie.andMap($79vie.andMap($79vie.andMap($79vie.succeed(function(mediaId, mediaParentId, albumId, productId, relatedMediaProductIds, relatedMediaCategoryId, variantId, panelClosed, zoomedPhotoIndex, time) {
    return {
        mediaId: mediaId,
        mediaParentId: mediaParentId,
        albumId: albumId,
        productId: productId,
        relatedMediaProductIds: relatedMediaProductIds,
        relatedMediaCategoryId: relatedMediaCategoryId,
        variantId: variantId,
        panelClosed: panelClosed,
        zoomedPhotoIndex: zoomedPhotoIndex,
        time: time
    };
}), $79vie.field("mediaId", $79vie.string)), $79vie.field("mediaParentId", $79vie.option($79vie.string))), $79vie.field("albumId", $79vie.option($79vie.string))), $79vie.field("productId", $79vie.option($79vie.string))), $79vie.field("relatedMediaProductIds", $79vie.option($79vie.array($79vie.string)))), $79vie.field("relatedMediaCategoryId", $79vie.option($79vie.string))), $79vie.field("variantId", $79vie.option($79vie.string))), $79vie.field("panelClosed", $79vie.option($79vie.bool))), $79vie.field("zoomedPhotoIndex", $79vie.option($79vie.$$int))), $79vie.field("time", $79vie.option($79vie.$$float)));
function $ccfff63d2d5023ce$export$44dcc29d7de32e6b(route) {
    if (typeof route === "number") return $iv6Yc._2($jVmMx.Encode.array, [
        "NotRendered"
    ], $jVmMx.Encode.string);
    switch(route.TAG | 0){
        case /* Home */ 0:
            return $jVmMx.Encode.deccoVariantWithPayload(route._0, "Home", $ccfff63d2d5023ce$export$2fa9a34fd04640d2);
        case /* ListPage */ 1:
            return $jVmMx.Encode.deccoVariantWithPayload(route._0, "ListPage", $ccfff63d2d5023ce$export$e07909246d7a7182);
        case /* PDP */ 2:
            return $jVmMx.Encode.deccoVariantWithPayload(route._0, "PDP", $ccfff63d2d5023ce$export$aaccbef6c4ed376a);
        case /* QuickView */ 3:
            return $jVmMx.Encode.deccoVariantWithPayload(route._0, "QuickView", $ccfff63d2d5023ce$export$7f097db678b13234);
    }
}
var $ccfff63d2d5023ce$export$c6557303c12e4d5 = $iv6Yc._2($jVmMx.Decode.oneOf, $jVmMx.Decode.exactStringVariant("NotRendered", /* NotRendered */ 0), [
    $jVmMx.Decode.deccoVariantWithPayload("Home", $ccfff63d2d5023ce$export$f6abe3d4c037d964, function(v) {
        return {
            TAG: /* Home */ 0,
            _0: v
        };
    }),
    $jVmMx.Decode.deccoVariantWithPayload("ListPage", $ccfff63d2d5023ce$export$400d2f7d94b7449e, function(v) {
        return {
            TAG: /* ListPage */ 1,
            _0: v
        };
    }),
    $jVmMx.Decode.deccoVariantWithPayload("PDP", $ccfff63d2d5023ce$export$463dcecd5ba8ab56, function(v) {
        return {
            TAG: /* PDP */ 2,
            _0: v
        };
    }),
    $jVmMx.Decode.deccoVariantWithPayload("QuickView", $ccfff63d2d5023ce$export$7248f310197d616e, function(v) {
        return {
            TAG: /* QuickView */ 3,
            _0: v
        };
    })
]);
function $ccfff63d2d5023ce$export$a7ae50691d4c079c(route) {
    if (typeof route === "number") return;
    if (route.TAG !== /* ListPage */ 1) return;
    var listPageType = route._0.listPageType;
    if (typeof listPageType === "number" || listPageType.TAG !== /* Category */ 0) return;
    else return listPageType._0;
}
function $ccfff63d2d5023ce$export$a08dede735aa5b41($$location) {
    var match = $$location.quickNav;
    var match$1 = $$location.quickView;
    if (match !== undefined) {
        var match$2 = match.tabId;
        var match$3 = match.categoryId;
        var match$4 = match.productId;
        var match$5 = match.productCategoryId;
        var match$6 = match$1.mediaId;
        var match$7 = match.relatedProductsId;
        var match$8 = match.view;
        var view;
        if (match$6 !== undefined) return {
            TAG: /* QuickView */ 3,
            _0: {
                mediaId: match$6,
                mediaParentId: match$1.mediaParentId,
                albumId: match$1.albumId,
                productId: match$1.productId,
                relatedMediaProductIds: match$1.relatedMediaProductIds,
                relatedMediaCategoryId: match$1.relatedMediaCategoryId,
                variantId: match$1.variantId,
                panelClosed: match$1.panelClosed,
                zoomedPhotoIndex: match$1.photoZoom,
                time: match$1.time
            }
        };
        if (match$2 === undefined) return /* NotRendered */ 0;
        if (match$4 !== undefined) return {
            TAG: /* PDP */ 2,
            _0: {
                categoryId: match.categoryId,
                productCategoryId: match.productCategoryId,
                productId: match$4,
                variantId: match.variantId,
                zoomedPhotoIndex: match.photoZoom
            }
        };
        if (match$3 !== undefined) {
            if (match$5 !== undefined) return /* NotRendered */ 0;
            if (match$3 !== "") {
                var tmp;
                if (match$8 !== undefined) {
                    if (typeof match$8 === "number") switch(match$8){
                        case /* PLP */ 0:
                            tmp = {
                                TAG: /* Category */ 0,
                                _0: match$3
                            };
                            break;
                        case /* Favorites */ 1:
                            tmp = /* Favorites */ 0;
                            break;
                        case /* History */ 2:
                            tmp = /* History */ 1;
                            break;
                        case /* StoreCart */ 3:
                            tmp = /* StoreCart */ 2;
                            break;
                    }
                    else tmp = {
                        TAG: /* StoreCategory */ 2,
                        _0: match$8._0
                    };
                } else tmp = {
                    TAG: /* Category */ 0,
                    _0: match$3
                };
                return {
                    TAG: /* ListPage */ 1,
                    _0: {
                        listPageType: tmp,
                        viewPLP: $2whNH.mapWithDefault(match$8, false, function(view) {
                            return view === /* PLP */ 0;
                        }),
                        filters: match.filters,
                        sort: match.sort
                    }
                };
            }
            if (match$3 !== "") return /* NotRendered */ 0;
            view = match$8;
        } else {
            if (match$5 !== undefined) return /* NotRendered */ 0;
            if (match$7 !== undefined) {
                if (match$7 !== "") {
                    var tmp$1;
                    if (match$8 !== undefined) {
                        if (typeof match$8 === "number") switch(match$8){
                            case /* PLP */ 0:
                                tmp$1 = {
                                    TAG: /* Product */ 1,
                                    _0: match$7
                                };
                                break;
                            case /* Favorites */ 1:
                                tmp$1 = /* Favorites */ 0;
                                break;
                            case /* History */ 2:
                                tmp$1 = /* History */ 1;
                                break;
                            case /* StoreCart */ 3:
                                tmp$1 = /* StoreCart */ 2;
                                break;
                        }
                        else tmp$1 = {
                            TAG: /* StoreCategory */ 2,
                            _0: match$8._0
                        };
                    } else tmp$1 = {
                        TAG: /* Product */ 1,
                        _0: match$7
                    };
                    return {
                        TAG: /* ListPage */ 1,
                        _0: {
                            listPageType: tmp$1,
                            viewPLP: $2whNH.mapWithDefault(match$8, false, function(view) {
                                return view === /* PLP */ 0;
                            }),
                            filters: match.filters,
                            sort: match.sort
                        }
                    };
                }
                view = match$8;
            } else view = match$8;
        }
        var tmp$2;
        if (view !== undefined) {
            if (typeof view === "number") switch(view){
                case /* PLP */ 0:
                    tmp$2 = /* Index */ 0;
                    break;
                case /* Favorites */ 1:
                    tmp$2 = /* Favorites */ 1;
                    break;
                case /* History */ 2:
                    tmp$2 = /* History */ 2;
                    break;
                case /* StoreCart */ 3:
                    tmp$2 = /* StoreCart */ 3;
                    break;
            }
            else tmp$2 = /* StoreCategory */ {
                _0: view._0
            };
        } else tmp$2 = /* Index */ 0;
        return {
            TAG: /* Home */ 0,
            _0: {
                homeType: tmp$2,
                filters: match.filters,
                sort: match.sort
            }
        };
    }
    var mediaId = match$1.mediaId;
    if (mediaId !== undefined) return {
        TAG: /* QuickView */ 3,
        _0: {
            mediaId: mediaId,
            mediaParentId: match$1.mediaParentId,
            albumId: match$1.albumId,
            productId: match$1.productId,
            relatedMediaProductIds: match$1.relatedMediaProductIds,
            relatedMediaCategoryId: match$1.relatedMediaCategoryId,
            variantId: match$1.variantId,
            panelClosed: match$1.panelClosed,
            zoomedPhotoIndex: match$1.photoZoom,
            time: match$1.time
        }
    };
    else return /* NotRendered */ 0;
}
function $ccfff63d2d5023ce$export$d8edd63f2323d5ab(clearIntent, previewMode, param) {
    return true;
}
function $ccfff63d2d5023ce$export$f84e8e69fd4488a5(route) {
    if (typeof route === "number") return "NotRendered";
    switch(route.TAG | 0){
        case /* Home */ 0:
            var match = route._0;
            return $i7mYY.joinWith([
                "Home",
                $2whNH.mapWithDefault(match.filters, "", $fEMeF.toString),
                $2whNH.mapWithDefault(match.sort, "", $04dLg.ProductSortOrder.toString)
            ], "|", function(a) {
                return a;
            });
        case /* ListPage */ 1:
            var match$1 = route._0;
            var listPageType = match$1.listPageType;
            var tmp;
            if (typeof listPageType === "number") switch(listPageType){
                case /* Favorites */ 0:
                    tmp = "Favorites";
                    break;
                case /* History */ 1:
                    tmp = "History";
                    break;
                case /* StoreCart */ 2:
                    tmp = "StoreCart";
                    break;
            }
            else switch(listPageType.TAG | 0){
                case /* Category */ 0:
                    tmp = "Category-" + listPageType._0;
                    break;
                case /* Product */ 1:
                    tmp = "Product-" + listPageType._0;
                    break;
                case /* StoreCategory */ 2:
                    var match$2 = listPageType._0;
                    tmp = $i7mYY.keepMap([
                        "StoreCategory",
                        match$2.categoryId,
                        match$2.sourceNodeId
                    ], function(a) {
                        return a;
                    }).join("-");
                    break;
            }
            return $i7mYY.joinWith([
                "ListPage",
                tmp,
                match$1.viewPLP ? "true" : "false",
                $2whNH.mapWithDefault(match$1.filters, "", $fEMeF.toString),
                $2whNH.mapWithDefault(match$1.sort, "", $04dLg.ProductSortOrder.toString)
            ], "|", function(a) {
                return a;
            });
        case /* PDP */ 2:
            var match$3 = route._0;
            return $i7mYY.joinWith([
                "PDP",
                $2whNH.getWithDefault(match$3.categoryId, ""),
                $2whNH.getWithDefault(match$3.productCategoryId, ""),
                match$3.productId,
                $2whNH.getWithDefault(match$3.variantId, ""),
                $2whNH.mapWithDefault(match$3.zoomedPhotoIndex, "", function(prim) {
                    return String(prim);
                })
            ], "|", function(a) {
                return a;
            });
        case /* QuickView */ 3:
            var match$4 = route._0;
            return $i7mYY.joinWith([
                "QuickView",
                match$4.mediaId,
                $2whNH.getWithDefault(match$4.albumId, ""),
                $2whNH.getWithDefault(match$4.mediaParentId, ""),
                $2whNH.getWithDefault(match$4.productId, ""),
                $2whNH.getWithDefault(match$4.variantId, ""),
                $2whNH.mapWithDefault(match$4.panelClosed, "", function(a) {
                    if (a) return "true";
                    else return "false";
                }),
                $2whNH.mapWithDefault(match$4.zoomedPhotoIndex, "", function(prim) {
                    return String(prim);
                }),
                $2whNH.mapWithDefault(match$4.time, "", function(prim) {
                    return String(prim);
                }),
                $2whNH.getWithDefault(match$4.relatedMediaCategoryId, ""),
                $2whNH.mapWithDefault(match$4.relatedMediaProductIds, "", function(param) {
                    return $69lAE.joinWith(",", param);
                })
            ], "|", function(a) {
                return a;
            });
    }
}
var $ccfff63d2d5023ce$export$9713d8a57e03815e = {
    contents: {
        inline: undefined,
        drawer: undefined,
        launcher: undefined,
        section: undefined,
        menu: undefined,
        pdp: undefined
    }
};
var $ccfff63d2d5023ce$export$a078c61943f9dbbe = /*#__PURE__*/ $g85JO.createContext({
    route: /* NotRendered */ 0,
    quickViewUnderlyingRoute: undefined,
    back: function back(param) {},
    goTo: function goTo(clearIntent, replaceState, route) {},
    reset: function reset(param) {},
    isForcingPLP: false,
    isQuickView: false,
    listPageType: undefined,
    anyProductId: undefined,
    anyVariantId: undefined,
    relatedProductId: undefined,
    productCategoryId: undefined,
    productSort: undefined,
    productFilters: undefined,
    previewMode: undefined,
    devMode: undefined,
    setIsHistoryEnabled: function setIsHistoryEnabled(param) {},
    raw: $kJhYp.empty
});
var $ccfff63d2d5023ce$export$ca328f169d304df4 = $ccfff63d2d5023ce$export$a078c61943f9dbbe.Provider;
function $ccfff63d2d5023ce$var$RouterProvider(Props) {
    var configId = Props.configId;
    var defaultInitialRoute = Props.defaultInitialRoute;
    var embedType = Props.embedType;
    var children = Props.children;
    var match = $efwy1.use(undefined);
    var namespace = match.namespace;
    var $$location = $kJhYp.use(undefined);
    var quickNav = $$location.quickNav;
    var quickView = $$location.quickView;
    var match$1 = $g85JO.useState(function() {
        return $ccfff63d2d5023ce$export$d8edd63f2323d5ab;
    });
    var setIsHistoryEnabled = match$1[1];
    var isHistoryEnabled = match$1[0];
    var setIsHistoryEnabled$1 = function setIsHistoryEnabled$1(fn) {
        $iv6Yc._1(setIsHistoryEnabled, function(previousValue) {
            return fn;
        });
    };
    var qnRelatedProductId = $2whNH.flatMap(quickNav, function(qn) {
        return qn.relatedProductsId;
    });
    var qnView = $2whNH.flatMap(quickNav, function(qn) {
        return $2whNH.map(qn.view, function(view) {
            return view;
        });
    });
    if (defaultInitialRoute !== undefined) switch(embedType){
        case /* Bottombar */ 0:
            var init = $ccfff63d2d5023ce$export$9713d8a57e03815e.contents;
            $ccfff63d2d5023ce$export$9713d8a57e03815e.contents = {
                inline: init.inline,
                drawer: defaultInitialRoute,
                launcher: init.launcher,
                section: init.section,
                menu: init.menu,
                pdp: init.pdp
            };
            break;
        case /* Inline */ 1:
            var init$1 = $ccfff63d2d5023ce$export$9713d8a57e03815e.contents;
            $ccfff63d2d5023ce$export$9713d8a57e03815e.contents = {
                inline: defaultInitialRoute,
                drawer: init$1.drawer,
                launcher: init$1.launcher,
                section: init$1.section,
                menu: init$1.menu,
                pdp: init$1.pdp
            };
            break;
        case /* Launcher */ 2:
            var init$2 = $ccfff63d2d5023ce$export$9713d8a57e03815e.contents;
            $ccfff63d2d5023ce$export$9713d8a57e03815e.contents = {
                inline: init$2.inline,
                drawer: init$2.drawer,
                launcher: defaultInitialRoute,
                section: init$2.section,
                menu: init$2.menu,
                pdp: init$2.pdp
            };
            break;
        case /* Section */ 3:
            var init$3 = $ccfff63d2d5023ce$export$9713d8a57e03815e.contents;
            $ccfff63d2d5023ce$export$9713d8a57e03815e.contents = {
                inline: init$3.inline,
                drawer: init$3.drawer,
                launcher: init$3.launcher,
                section: defaultInitialRoute,
                menu: init$3.menu,
                pdp: init$3.pdp
            };
            break;
        case /* Menu */ 4:
            var init$4 = $ccfff63d2d5023ce$export$9713d8a57e03815e.contents;
            $ccfff63d2d5023ce$export$9713d8a57e03815e.contents = {
                inline: init$4.inline,
                drawer: init$4.drawer,
                launcher: init$4.launcher,
                section: init$4.section,
                menu: defaultInitialRoute,
                pdp: init$4.pdp
            };
            break;
        case /* ProductDetailsPage */ 5:
            var init$5 = $ccfff63d2d5023ce$export$9713d8a57e03815e.contents;
            $ccfff63d2d5023ce$export$9713d8a57e03815e.contents = {
                inline: init$5.inline,
                drawer: init$5.drawer,
                launcher: init$5.launcher,
                section: init$5.section,
                menu: init$5.menu,
                pdp: defaultInitialRoute
            };
            break;
    }
    var value = $g85JO.useMemo(function() {
        var defaultRoute;
        switch(embedType){
            case /* Bottombar */ 0:
                defaultRoute = $ccfff63d2d5023ce$export$9713d8a57e03815e.contents.drawer;
                break;
            case /* Inline */ 1:
                defaultRoute = $ccfff63d2d5023ce$export$9713d8a57e03815e.contents.inline;
                break;
            case /* Launcher */ 2:
                defaultRoute = $ccfff63d2d5023ce$export$9713d8a57e03815e.contents.launcher;
                break;
            case /* Section */ 3:
                defaultRoute = $ccfff63d2d5023ce$export$9713d8a57e03815e.contents.section;
                break;
            case /* Menu */ 4:
                defaultRoute = $ccfff63d2d5023ce$export$9713d8a57e03815e.contents.menu;
                break;
            case /* ProductDetailsPage */ 5:
                defaultRoute = $ccfff63d2d5023ce$export$9713d8a57e03815e.contents.pdp;
                break;
        }
        var route = $ccfff63d2d5023ce$export$a08dede735aa5b41({
            quickView: quickView,
            quickNav: quickNav
        });
        var route$1 = $ccfff63d2d5023ce$export$a08dede735aa5b41({
            quickView: $9hB74.empty,
            quickNav: quickNav
        });
        var quickViewUnderlyingRoute = typeof route$1 === "number" ? defaultRoute !== undefined ? defaultRoute : /* NotRendered */ 0 : route$1;
        var route$2 = defaultRoute !== undefined && route === /* NotRendered */ 0 ? defaultRoute : route;
        var previewMode = $2whNH.flatMap(quickNav, function(qn) {
            return qn.previewMode;
        });
        var devMode = $2whNH.flatMap(quickNav, function(qn) {
            return qn.devMode;
        });
        var match;
        if (typeof route$2 === "number") match = [
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined
        ];
        else switch(route$2.TAG | 0){
            case /* Home */ 0:
                var match$1 = route$2._0;
                var homeType = match$1.homeType;
                var tmp;
                if (typeof homeType === "number") switch(homeType){
                    case /* Index */ 0:
                        tmp = undefined;
                        break;
                    case /* Favorites */ 1:
                        tmp = /* Favorites */ 0;
                        break;
                    case /* History */ 2:
                        tmp = /* History */ 1;
                        break;
                    case /* StoreCart */ 3:
                        tmp = /* StoreCart */ 2;
                        break;
                }
                else tmp = {
                    TAG: /* StoreCategory */ 2,
                    _0: homeType._0
                };
                match = [
                    tmp,
                    undefined,
                    undefined,
                    undefined,
                    match$1.sort,
                    match$1.filters
                ];
                break;
            case /* ListPage */ 1:
                var match$2 = route$2._0;
                match = [
                    match$2.listPageType,
                    undefined,
                    undefined,
                    undefined,
                    match$2.sort,
                    match$2.filters
                ];
                break;
            case /* PDP */ 2:
                var match$3 = route$2._0;
                var tmp$1;
                var exit = 0;
                if (qnView !== undefined) {
                    if (typeof qnView === "number") switch(qnView){
                        case /* PLP */ 0:
                            exit = 1;
                            break;
                        case /* Favorites */ 1:
                            tmp$1 = /* Favorites */ 0;
                            break;
                        case /* History */ 2:
                            tmp$1 = /* History */ 1;
                            break;
                        case /* StoreCart */ 3:
                            tmp$1 = /* StoreCart */ 2;
                            break;
                    }
                    else tmp$1 = {
                        TAG: /* StoreCategory */ 2,
                        _0: qnView._0
                    };
                } else exit = 1;
                if (exit === 1) tmp$1 = $2whNH.map(match$3.categoryId, function(id) {
                    return {
                        TAG: /* Category */ 0,
                        _0: id
                    };
                });
                match = [
                    tmp$1,
                    match$3.productId,
                    match$3.variantId,
                    match$3.productCategoryId,
                    $2whNH.flatMap(quickNav, function(qn) {
                        return qn.sort;
                    }),
                    $2whNH.flatMap(quickNav, function(qn) {
                        return qn.filters;
                    })
                ];
                break;
            case /* QuickView */ 3:
                var match$4 = route$2._0;
                var mediaId = match$4.mediaId;
                var exit$1 = 0;
                if (quickViewUnderlyingRoute !== undefined && !(typeof quickViewUnderlyingRoute === "number" || quickViewUnderlyingRoute.TAG !== /* PDP */ 2)) {
                    var match$5 = quickViewUnderlyingRoute._0;
                    match = [
                        {
                            TAG: /* Category */ 0,
                            _0: mediaId
                        },
                        match$5.productId,
                        match$5.variantId,
                        undefined,
                        undefined,
                        undefined
                    ];
                } else exit$1 = 1;
                if (exit$1 === 1) match = [
                    {
                        TAG: /* Category */ 0,
                        _0: mediaId
                    },
                    match$4.productId,
                    match$4.variantId,
                    undefined,
                    undefined,
                    undefined
                ];
                break;
        }
        var productFilters = match[5];
        var productSort = match[4];
        var listPageType = match[0];
        var isQuickView;
        isQuickView = typeof route$2 === "number" || route$2.TAG !== /* QuickView */ 3 ? false : true;
        var reset = function reset(param) {
            $kJhYp.goTo(namespace, $iv6Yc._3(isHistoryEnabled, true, previewMode, route$2), $9hB74.empty, {
                configId: previewMode !== undefined || devMode !== undefined ? configId : $hylFb.empty.configId,
                tabId: $hylFb.empty.tabId,
                categoryId: $hylFb.empty.categoryId,
                productCategoryId: $hylFb.empty.productCategoryId,
                productId: $hylFb.empty.productId,
                relatedProductsId: $hylFb.empty.relatedProductsId,
                variantId: $hylFb.empty.variantId,
                photoZoom: $hylFb.empty.photoZoom,
                previewMode: previewMode,
                devMode: devMode,
                filters: $hylFb.empty.filters,
                sort: $hylFb.empty.sort,
                view: $hylFb.empty.view
            }, undefined, undefined, undefined);
        };
        var goTo = function goTo(clearIntentOpt, replaceStateOpt, route) {
            var clearIntent = clearIntentOpt !== undefined ? clearIntentOpt : true;
            var replaceState = replaceStateOpt !== undefined ? replaceStateOpt : false;
            if (typeof route === "number") return reset(undefined);
            switch(route.TAG | 0){
                case /* Home */ 0:
                    var match = route._0;
                    var homeType = match.homeType;
                    var tmp;
                    if (typeof homeType === "number") switch(homeType){
                        case /* Index */ 0:
                            tmp = undefined;
                            break;
                        case /* Favorites */ 1:
                            tmp = /* Favorites */ 1;
                            break;
                        case /* History */ 2:
                            tmp = /* History */ 2;
                            break;
                        case /* StoreCart */ 3:
                            tmp = /* StoreCart */ 3;
                            break;
                    }
                    else tmp = /* StoreCategory */ {
                        _0: homeType._0
                    };
                    return $kJhYp.goTo(namespace, $iv6Yc._3(isHistoryEnabled, clearIntent, previewMode, route), undefined, {
                        configId: configId,
                        tabId: "navigation",
                        categoryId: undefined,
                        productCategoryId: $hylFb.empty.productCategoryId,
                        productId: undefined,
                        relatedProductsId: $hylFb.empty.relatedProductsId,
                        variantId: undefined,
                        photoZoom: $hylFb.empty.photoZoom,
                        previewMode: previewMode,
                        devMode: devMode,
                        filters: match.filters,
                        sort: match.sort,
                        view: tmp
                    }, replaceState, undefined, undefined);
                case /* ListPage */ 1:
                    var match$1 = route._0;
                    var viewPLP = match$1.viewPLP;
                    var listPageType = match$1.listPageType;
                    var init = $2whNH.getWithDefault(quickNav, $hylFb.empty);
                    var tmp$1;
                    var exit = 0;
                    if (typeof listPageType === "number") exit = 1;
                    else switch(listPageType.TAG | 0){
                        case /* Category */ 0:
                            tmp$1 = listPageType._0;
                            break;
                        case /* Product */ 1:
                            tmp$1 = undefined;
                            break;
                        default:
                            exit = 1;
                    }
                    if (exit === 1) tmp$1 = $2whNH.flatMap(quickNav, function(qn) {
                        return qn.categoryId;
                    });
                    var tmp$2;
                    tmp$2 = typeof listPageType === "number" || listPageType.TAG !== /* Product */ 1 ? undefined : listPageType._0;
                    var tmp$3;
                    if (typeof listPageType === "number") switch(listPageType){
                        case /* Favorites */ 0:
                            tmp$3 = /* Favorites */ 1;
                            break;
                        case /* History */ 1:
                            tmp$3 = /* History */ 2;
                            break;
                        case /* StoreCart */ 2:
                            tmp$3 = /* StoreCart */ 3;
                            break;
                    }
                    else switch(listPageType.TAG | 0){
                        case /* Category */ 0:
                        case /* Product */ 1:
                            tmp$3 = viewPLP ? /* PLP */ 0 : undefined;
                            break;
                        case /* StoreCategory */ 2:
                            tmp$3 = /* StoreCategory */ {
                                _0: listPageType._0
                            };
                            break;
                    }
                    return $kJhYp.goTo(namespace, $iv6Yc._3(isHistoryEnabled, clearIntent, previewMode, route), undefined, {
                        configId: configId,
                        tabId: "navigation",
                        categoryId: tmp$1,
                        productCategoryId: undefined,
                        productId: undefined,
                        relatedProductsId: tmp$2,
                        variantId: undefined,
                        photoZoom: init.photoZoom,
                        previewMode: previewMode,
                        devMode: devMode,
                        filters: match$1.filters,
                        sort: match$1.sort,
                        view: tmp$3
                    }, replaceState, undefined, undefined);
                case /* PDP */ 2:
                    var match$2 = route._0;
                    var init$1 = $2whNH.getWithDefault(quickNav, $hylFb.empty);
                    return $kJhYp.goTo(namespace, $iv6Yc._3(isHistoryEnabled, clearIntent, previewMode, route), undefined, {
                        configId: configId,
                        tabId: "navigation",
                        categoryId: match$2.categoryId,
                        productCategoryId: match$2.productCategoryId,
                        productId: match$2.productId,
                        relatedProductsId: init$1.relatedProductsId,
                        variantId: match$2.variantId,
                        photoZoom: match$2.zoomedPhotoIndex,
                        previewMode: previewMode,
                        devMode: devMode,
                        filters: init$1.filters,
                        sort: init$1.sort,
                        view: qnView
                    }, replaceState, undefined, undefined);
                case /* QuickView */ 3:
                    var match$3 = route._0;
                    var init$2 = $2whNH.getWithDefault(quickNav, $hylFb.empty);
                    var quickNavLocation_tabId = init$2.tabId;
                    var quickNavLocation_categoryId = init$2.categoryId;
                    var quickNavLocation_productCategoryId = init$2.productCategoryId;
                    var quickNavLocation_productId = init$2.productId;
                    var quickNavLocation_relatedProductsId = init$2.relatedProductsId;
                    var quickNavLocation_variantId = init$2.variantId;
                    var quickNavLocation_photoZoom = init$2.photoZoom;
                    var quickNavLocation_filters = init$2.filters;
                    var quickNavLocation_sort = init$2.sort;
                    var quickNavLocation_view = init$2.view;
                    var quickNavLocation = {
                        configId: configId,
                        tabId: quickNavLocation_tabId,
                        categoryId: quickNavLocation_categoryId,
                        productCategoryId: quickNavLocation_productCategoryId,
                        productId: quickNavLocation_productId,
                        relatedProductsId: quickNavLocation_relatedProductsId,
                        variantId: quickNavLocation_variantId,
                        photoZoom: quickNavLocation_photoZoom,
                        previewMode: previewMode,
                        devMode: devMode,
                        filters: quickNavLocation_filters,
                        sort: quickNavLocation_sort,
                        view: quickNavLocation_view
                    };
                    var quickNavLocation$1;
                    if (quickViewUnderlyingRoute !== undefined && typeof quickViewUnderlyingRoute !== "number") switch(quickViewUnderlyingRoute.TAG | 0){
                        case /* ListPage */ 1:
                            var listPageType$1 = quickViewUnderlyingRoute._0.listPageType;
                            if (typeof listPageType$1 === "number") switch(listPageType$1){
                                case /* Favorites */ 0:
                                    quickNavLocation$1 = {
                                        configId: configId,
                                        tabId: quickNavLocation_tabId,
                                        categoryId: quickNavLocation_categoryId,
                                        productCategoryId: quickNavLocation_productCategoryId,
                                        productId: quickNavLocation_productId,
                                        relatedProductsId: quickNavLocation_relatedProductsId,
                                        variantId: quickNavLocation_variantId,
                                        photoZoom: quickNavLocation_photoZoom,
                                        previewMode: previewMode,
                                        devMode: devMode,
                                        filters: quickNavLocation_filters,
                                        sort: quickNavLocation_sort,
                                        view: /* Favorites */ 1
                                    };
                                    break;
                                case /* History */ 1:
                                    quickNavLocation$1 = {
                                        configId: configId,
                                        tabId: quickNavLocation_tabId,
                                        categoryId: quickNavLocation_categoryId,
                                        productCategoryId: quickNavLocation_productCategoryId,
                                        productId: quickNavLocation_productId,
                                        relatedProductsId: quickNavLocation_relatedProductsId,
                                        variantId: quickNavLocation_variantId,
                                        photoZoom: quickNavLocation_photoZoom,
                                        previewMode: previewMode,
                                        devMode: devMode,
                                        filters: quickNavLocation_filters,
                                        sort: quickNavLocation_sort,
                                        view: /* History */ 2
                                    };
                                    break;
                                case /* StoreCart */ 2:
                                    quickNavLocation$1 = {
                                        configId: configId,
                                        tabId: quickNavLocation_tabId,
                                        categoryId: quickNavLocation_categoryId,
                                        productCategoryId: quickNavLocation_productCategoryId,
                                        productId: quickNavLocation_productId,
                                        relatedProductsId: quickNavLocation_relatedProductsId,
                                        variantId: quickNavLocation_variantId,
                                        photoZoom: quickNavLocation_photoZoom,
                                        previewMode: previewMode,
                                        devMode: devMode,
                                        filters: quickNavLocation_filters,
                                        sort: quickNavLocation_sort,
                                        view: /* StoreCart */ 3
                                    };
                                    break;
                            }
                            else switch(listPageType$1.TAG | 0){
                                case /* Category */ 0:
                                    quickNavLocation$1 = {
                                        configId: configId,
                                        tabId: quickNavLocation_tabId,
                                        categoryId: listPageType$1._0,
                                        productCategoryId: quickNavLocation_productCategoryId,
                                        productId: quickNavLocation_productId,
                                        relatedProductsId: quickNavLocation_relatedProductsId,
                                        variantId: quickNavLocation_variantId,
                                        photoZoom: quickNavLocation_photoZoom,
                                        previewMode: previewMode,
                                        devMode: devMode,
                                        filters: quickNavLocation_filters,
                                        sort: quickNavLocation_sort,
                                        view: quickNavLocation_view
                                    };
                                    break;
                                case /* Product */ 1:
                                    quickNavLocation$1 = {
                                        configId: configId,
                                        tabId: quickNavLocation_tabId,
                                        categoryId: quickNavLocation_categoryId,
                                        productCategoryId: quickNavLocation_productCategoryId,
                                        productId: quickNavLocation_productId,
                                        relatedProductsId: listPageType$1._0,
                                        variantId: quickNavLocation_variantId,
                                        photoZoom: quickNavLocation_photoZoom,
                                        previewMode: previewMode,
                                        devMode: devMode,
                                        filters: quickNavLocation_filters,
                                        sort: quickNavLocation_sort,
                                        view: quickNavLocation_view
                                    };
                                    break;
                                case /* StoreCategory */ 2:
                                    quickNavLocation$1 = {
                                        configId: configId,
                                        tabId: quickNavLocation_tabId,
                                        categoryId: quickNavLocation_categoryId,
                                        productCategoryId: quickNavLocation_productCategoryId,
                                        productId: quickNavLocation_productId,
                                        relatedProductsId: quickNavLocation_relatedProductsId,
                                        variantId: quickNavLocation_variantId,
                                        photoZoom: quickNavLocation_photoZoom,
                                        previewMode: previewMode,
                                        devMode: devMode,
                                        filters: quickNavLocation_filters,
                                        sort: quickNavLocation_sort,
                                        view: /* StoreCategory */ {
                                            _0: listPageType$1._0
                                        }
                                    };
                                    break;
                            }
                            break;
                        case /* PDP */ 2:
                            var match$4 = quickViewUnderlyingRoute._0;
                            quickNavLocation$1 = {
                                configId: configId,
                                tabId: quickNavLocation_tabId,
                                categoryId: quickNavLocation_categoryId,
                                productCategoryId: match$4.productCategoryId,
                                productId: match$4.productId,
                                relatedProductsId: quickNavLocation_relatedProductsId,
                                variantId: match$4.variantId,
                                photoZoom: quickNavLocation_photoZoom,
                                previewMode: previewMode,
                                devMode: devMode,
                                filters: quickNavLocation_filters,
                                sort: quickNavLocation_sort,
                                view: quickNavLocation_view
                            };
                            break;
                        default:
                            quickNavLocation$1 = quickNavLocation;
                    }
                    else quickNavLocation$1 = quickNavLocation;
                    return $kJhYp.goTo(namespace, $iv6Yc._3(isHistoryEnabled, clearIntent, previewMode, route), $9hB74.make(match$3.mediaId, match$3.mediaParentId, match$3.albumId, match$3.panelClosed, undefined, match$3.productId, match$3.relatedMediaProductIds, match$3.relatedMediaCategoryId, match$3.variantId, match$3.zoomedPhotoIndex, undefined, undefined), quickNavLocation$1, replaceState, undefined, undefined);
            }
        };
        var back = function back(param) {
            if (typeof route$2 === "number") return;
            switch(route$2.TAG | 0){
                case /* Home */ 0:
                    var homeType = route$2._0.homeType;
                    if (homeType === 0) return reset(undefined);
                    else return goTo(undefined, undefined, {
                        TAG: /* Home */ 0,
                        _0: {
                            homeType: /* Index */ 0,
                            filters: undefined,
                            sort: undefined
                        }
                    });
                case /* ListPage */ 1:
                    var payload = route$2._0;
                    var match = payload.listPageType;
                    if (typeof match !== "number") switch(match.TAG | 0){
                        case /* Category */ 0:
                        case /* Product */ 1:
                            return goTo(undefined, undefined, {
                                TAG: /* Home */ 0,
                                _0: {
                                    homeType: /* Index */ 0,
                                    filters: undefined,
                                    sort: undefined
                                }
                            });
                        default:
                    }
                    var categoryId = $2whNH.flatMap(quickNav, function(qn) {
                        return qn.categoryId;
                    });
                    if (categoryId !== undefined) return goTo(undefined, undefined, {
                        TAG: /* ListPage */ 1,
                        _0: {
                            listPageType: {
                                TAG: /* Category */ 0,
                                _0: categoryId
                            },
                            viewPLP: payload.viewPLP,
                            filters: payload.filters,
                            sort: payload.sort
                        }
                    });
                    else return goTo(undefined, undefined, {
                        TAG: /* Home */ 0,
                        _0: {
                            homeType: /* Index */ 0,
                            filters: undefined,
                            sort: undefined
                        }
                    });
                case /* PDP */ 2:
                    var data = route$2._0;
                    if (data.zoomedPhotoIndex !== undefined) return goTo(undefined, undefined, {
                        TAG: /* PDP */ 2,
                        _0: {
                            categoryId: data.categoryId,
                            productCategoryId: data.productCategoryId,
                            productId: data.productId,
                            variantId: data.variantId,
                            zoomedPhotoIndex: undefined
                        }
                    });
                    var tmp;
                    if (listPageType !== undefined) tmp = listPageType;
                    else if (quickNav !== undefined) {
                        var match$1 = quickNav.relatedProductsId;
                        var match$2 = quickNav.categoryId;
                        tmp = match$1 !== undefined ? {
                            TAG: /* Product */ 1,
                            _0: match$1
                        } : match$2 !== undefined ? {
                            TAG: /* Category */ 0,
                            _0: match$2
                        } : {
                            TAG: /* Category */ 0,
                            _0: ""
                        };
                    } else tmp = {
                        TAG: /* Category */ 0,
                        _0: ""
                    };
                    return goTo(undefined, undefined, {
                        TAG: /* ListPage */ 1,
                        _0: {
                            listPageType: tmp,
                            viewPLP: $7bjme.equal(qnView, /* PLP */ 0),
                            filters: productFilters,
                            sort: productSort
                        }
                    });
                case /* QuickView */ 3:
                    var payload$1 = route$2._0;
                    if (payload$1.zoomedPhotoIndex !== undefined) return goTo(undefined, undefined, {
                        TAG: /* QuickView */ 3,
                        _0: {
                            mediaId: payload$1.mediaId,
                            mediaParentId: payload$1.mediaParentId,
                            albumId: payload$1.albumId,
                            productId: payload$1.productId,
                            relatedMediaProductIds: payload$1.relatedMediaProductIds,
                            relatedMediaCategoryId: payload$1.relatedMediaCategoryId,
                            variantId: payload$1.variantId,
                            panelClosed: payload$1.panelClosed,
                            zoomedPhotoIndex: undefined,
                            time: payload$1.time
                        }
                    });
                    else if (payload$1.productId !== undefined) return goTo(undefined, undefined, {
                        TAG: /* QuickView */ 3,
                        _0: {
                            mediaId: payload$1.mediaId,
                            mediaParentId: payload$1.mediaParentId,
                            albumId: payload$1.albumId,
                            productId: undefined,
                            relatedMediaProductIds: payload$1.relatedMediaProductIds,
                            relatedMediaCategoryId: payload$1.relatedMediaCategoryId,
                            variantId: payload$1.variantId,
                            panelClosed: payload$1.panelClosed,
                            zoomedPhotoIndex: payload$1.zoomedPhotoIndex,
                            time: payload$1.time
                        }
                    });
                    else if (quickViewUnderlyingRoute !== undefined) return goTo(undefined, undefined, quickViewUnderlyingRoute);
                    else return;
            }
        };
        return {
            route: route$2,
            quickViewUnderlyingRoute: quickViewUnderlyingRoute,
            back: back,
            goTo: goTo,
            reset: reset,
            isForcingPLP: $7bjme.equal(qnView, /* PLP */ 0),
            isQuickView: isQuickView,
            listPageType: listPageType,
            anyProductId: match[1],
            anyVariantId: match[2],
            relatedProductId: qnRelatedProductId,
            productCategoryId: match[3],
            productSort: productSort,
            productFilters: productFilters,
            previewMode: previewMode,
            devMode: devMode,
            setIsHistoryEnabled: setIsHistoryEnabled$1,
            raw: $$location
        };
    }, [
        $2whNH.mapWithDefault(quickNav, "", $hylFb.toString),
        $9hB74.toString(quickView),
        configId,
        embedType,
        namespace,
        isHistoryEnabled
    ]);
    return /*#__PURE__*/ $g85JO.createElement($ccfff63d2d5023ce$export$ca328f169d304df4, {
        value: value,
        children: children
    });
}
$ccfff63d2d5023ce$var$RouterProvider.displayName = "RouterProvider";
function $ccfff63d2d5023ce$export$35ee3b2bf8634c20(param) {
    $ccfff63d2d5023ce$export$9713d8a57e03815e.contents = {
        inline: undefined,
        drawer: undefined,
        launcher: undefined,
        section: undefined,
        menu: undefined,
        pdp: undefined
    };
}
function $ccfff63d2d5023ce$export$9a302a45f65d0572(param) {
    return $g85JO.useContext($ccfff63d2d5023ce$export$a078c61943f9dbbe);
}
function $ccfff63d2d5023ce$export$6c760c46f61cf29a(includeQuickViewOpt, includePDPOpt, categories) {
    var includeQuickView = includeQuickViewOpt !== undefined ? includeQuickViewOpt : false;
    var includePDP = includePDPOpt !== undefined ? includePDPOpt : true;
    var match = $g85JO.useContext($ccfff63d2d5023ce$export$a078c61943f9dbbe);
    var listPageType = match.listPageType;
    var quickViewUnderlyingRoute = match.quickViewUnderlyingRoute;
    var route = match.route;
    var exit = 0;
    var listPageType$1;
    var homeType;
    var categoryId;
    var productCategoryId;
    var exit$1 = 0;
    var exit$2 = 0;
    var exit$3 = 0;
    var exit$4 = 0;
    var exit$5 = 0;
    var exit$6 = 0;
    if (typeof route === "number" || route.TAG !== /* QuickView */ 3) exit$6 = 9;
    else {
        if (includeQuickView) return $cq0ZS.getCategoryById(categories, route._0.mediaId);
        exit$6 = 9;
    }
    if (exit$6 === 9) {
        if (quickViewUnderlyingRoute !== undefined) {
            if (typeof quickViewUnderlyingRoute === "number") {
                if (listPageType === undefined) return;
                if (typeof listPageType === "number") return;
                switch(listPageType.TAG | 0){
                    case /* Category */ 0:
                        return $cq0ZS.getCategoryById(categories, listPageType._0);
                    case /* StoreCategory */ 2:
                        var categoryId$1 = listPageType._0.sourceNodeId;
                        if (categoryId$1 !== undefined) return $cq0ZS.getCategoryById(categories, categoryId$1);
                        else return;
                    default:
                        return;
                }
            } else if (quickViewUnderlyingRoute.TAG === /* ListPage */ 1) {
                listPageType$1 = quickViewUnderlyingRoute._0.listPageType;
                exit = 1;
            } else exit$5 = 8;
        } else exit$5 = 8;
    }
    if (exit$5 === 8) {
        if (typeof route === "number" || route.TAG !== /* ListPage */ 1) exit$4 = 7;
        else {
            listPageType$1 = route._0.listPageType;
            exit = 1;
        }
    }
    if (exit$4 === 7) {
        if (quickViewUnderlyingRoute !== undefined) {
            if (typeof quickViewUnderlyingRoute !== "number") switch(quickViewUnderlyingRoute.TAG | 0){
                case /* Home */ 0:
                    homeType = quickViewUnderlyingRoute._0.homeType;
                    exit = 2;
                    break;
                case /* PDP */ 2:
                case /* QuickView */ 3:
                    exit$3 = 6;
                    break;
            }
        } else exit$3 = 6;
    }
    if (exit$3 === 6) {
        if (typeof route === "number" || route.TAG !== /* Home */ 0) exit$2 = 5;
        else {
            homeType = route._0.homeType;
            exit = 2;
        }
    }
    if (exit$2 === 5) {
        if (quickViewUnderlyingRoute !== undefined) {
            if (typeof quickViewUnderlyingRoute !== "number") {
                if (quickViewUnderlyingRoute.TAG === /* PDP */ 2) {
                    var match$1 = quickViewUnderlyingRoute._0;
                    categoryId = match$1.categoryId;
                    productCategoryId = match$1.productCategoryId;
                    exit = 3;
                } else exit$1 = 4;
            }
        } else exit$1 = 4;
    }
    if (exit$1 === 4) {
        if (typeof route === "number") return;
        if (route.TAG !== /* PDP */ 2) return;
        var match$2 = route._0;
        categoryId = match$2.categoryId;
        productCategoryId = match$2.productCategoryId;
        exit = 3;
    }
    switch(exit){
        case 1:
            if (typeof listPageType$1 === "number") return;
            switch(listPageType$1.TAG | 0){
                case /* Category */ 0:
                    return $cq0ZS.getCategoryById(categories, listPageType$1._0);
                case /* StoreCategory */ 2:
                    var categoryId$2 = listPageType$1._0.sourceNodeId;
                    if (categoryId$2 !== undefined) return $cq0ZS.getCategoryById(categories, categoryId$2);
                    else return;
                default:
                    return;
            }
        case 2:
            if (typeof homeType === "number") return;
            var categoryId$3 = homeType._0.sourceNodeId;
            if (categoryId$3 !== undefined) return $cq0ZS.getCategoryById(categories, categoryId$3);
            else return;
        case 3:
            var categoryId$4 = includePDP ? productCategoryId : categoryId;
            return $2whNH.flatMap(categoryId$4, function(id) {
                return $cq0ZS.getCategoryById(categories, id);
            });
    }
}
function $ccfff63d2d5023ce$export$bda24362f94bfb51(routerData) {
    return $7bjme.equal(routerData.previewMode, /* PreviewHead */ 0);
}
var $ccfff63d2d5023ce$export$dd44f18ab656f3bb = $ccfff63d2d5023ce$var$RouterProvider;
 /* storeCategoryType_decode Not a pure module */ 
});
parcelRegister("fEMeF", function(module, exports) {

$parcel$export(module.exports, "mergeOption", function () { return $b66002032a1093e6$export$418e47b9ac6296e9; });
$parcel$export(module.exports, "length", function () { return $b66002032a1093e6$export$f24224f1c91d8156; });
$parcel$export(module.exports, "toMinPriceFacet", function () { return $b66002032a1093e6$export$340794d062b2c9a1; });
$parcel$export(module.exports, "toMaxPriceFacet", function () { return $b66002032a1093e6$export$383a0fd0cb2e9597; });
$parcel$export(module.exports, "add", function () { return $b66002032a1093e6$export$e16d8520af44a096; });
$parcel$export(module.exports, "remove", function () { return $b66002032a1093e6$export$cd7f480d6b8286c3; });
$parcel$export(module.exports, "t_encode", function () { return $b66002032a1093e6$export$cc42ff7b6c615091; });
$parcel$export(module.exports, "make", function () { return $b66002032a1093e6$export$dd44f18ab656f3bb; });
$parcel$export(module.exports, "fromJson", function () { return $b66002032a1093e6$export$7ae2d2a8b28a8cb8; });
$parcel$export(module.exports, "toStringOfIndex", function () { return $b66002032a1093e6$export$e3ea025983b032e1; });
$parcel$export(module.exports, "toString", function () { return $b66002032a1093e6$export$f84e8e69fd4488a5; });
$parcel$export(module.exports, "safeDecode", function () { return $b66002032a1093e6$export$7a47376c130cfeac; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $i7mYY = parcelRequire("i7mYY");

var $d1G6W = parcelRequire("d1G6W");

var $2whNH = parcelRequire("2whNH");

var $bYadz = parcelRequire("bYadz");
function $b66002032a1093e6$export$4950aa0f605343fb(facets1, facets2) {
    return {
        entries: $i7mYY.concat(facets1.entries, facets2.entries),
        minPrice: $2whNH.orElse(facets1.minPrice, facets2.minPrice),
        maxPrice: $2whNH.orElse(facets1.maxPrice, facets2.maxPrice)
    };
}
function $b66002032a1093e6$export$418e47b9ac6296e9(facets1, facets2) {
    if (facets1 !== undefined) {
        if (facets2 !== undefined) return $b66002032a1093e6$export$4950aa0f605343fb(facets1, facets2);
        else return facets1;
    } else if (facets2 !== undefined) return facets2;
    else return;
}
function $b66002032a1093e6$export$f24224f1c91d8156(facets) {
    return (facets.entries.length + ($2whNH.isSome(facets.maxPrice) ? 1 : 0) | 0) + ($2whNH.isSome(facets.minPrice) ? 1 : 0) | 0;
}
function $b66002032a1093e6$export$340794d062b2c9a1(minPrice) {
    return "minprice=" + minPrice.toString();
}
function $b66002032a1093e6$export$383a0fd0cb2e9597(maxPrice) {
    return "maxprice=" + maxPrice.toString();
}
function $b66002032a1093e6$export$43e07561023c405c(facet) {
    var match = facet.split("=");
    if (match.length !== 2) return;
    var match$1 = match[0];
    if (match$1 === "minprice") return $d1G6W.fromString(match[1]);
}
function $b66002032a1093e6$export$eb96f256a5dd3e1f(facet) {
    var match = facet.split("=");
    if (match.length !== 2) return;
    var match$1 = match[0];
    if (match$1 === "maxprice") return $d1G6W.fromString(match[1]);
}
function $b66002032a1093e6$export$e16d8520af44a096(facets, entry) {
    var minPrice = $b66002032a1093e6$export$43e07561023c405c(entry.facet);
    var maxPrice = $b66002032a1093e6$export$eb96f256a5dd3e1f(entry.facet);
    var updatedFacets_entries = facets.entries;
    var updatedFacets_minPrice = $2whNH.orElse(minPrice, facets.minPrice);
    var updatedFacets_maxPrice = $2whNH.orElse(maxPrice, facets.maxPrice);
    var updatedFacets = {
        entries: updatedFacets_entries,
        minPrice: updatedFacets_minPrice,
        maxPrice: updatedFacets_maxPrice
    };
    return $b66002032a1093e6$export$4950aa0f605343fb(updatedFacets, $bYadz.make(undefined, undefined, [
        entry
    ]));
}
function $b66002032a1093e6$export$cd7f480d6b8286c3(facets, facet) {
    var entries = $i7mYY.keep(facets.entries, function(param) {
        return param.facet !== facet;
    });
    var minPrice = $2whNH.keep(facets.minPrice, function(minPrice) {
        return "minprice=" + minPrice.toString() !== facet;
    });
    var maxPrice = $2whNH.keep(facets.maxPrice, function(maxPrice) {
        return "maxprice=" + maxPrice.toString() !== facet;
    });
    return $bYadz.make(minPrice, maxPrice, entries);
}
var $b66002032a1093e6$export$f36491c978b47831 = $bYadz.entry_encode;
var $b66002032a1093e6$export$4537221bf74c4819 = $bYadz.entry_decode;
var $b66002032a1093e6$export$6f3f41cc52acf41c = $bYadz.entry_fromJson;
var $b66002032a1093e6$export$50fd5e4354593993 = $bYadz.entry_toJson;
var $b66002032a1093e6$export$cc42ff7b6c615091 = $bYadz.t_encode;
var $b66002032a1093e6$export$bb5e712207166a02 = $bYadz.t_decode;
var $b66002032a1093e6$export$dd44f18ab656f3bb = $bYadz.make;
var $b66002032a1093e6$export$7ae2d2a8b28a8cb8 = $bYadz.fromJson;
var $b66002032a1093e6$export$d5b7a8bf56ee1fe2 = $bYadz.toJson;
var $b66002032a1093e6$export$e5172b961a11c52e = $bYadz.abstract_encode;
var $b66002032a1093e6$export$bdddd0cc5d922103 = $bYadz.abstract_decode;
var $b66002032a1093e6$export$e3ea025983b032e1 = $bYadz.toStringOfIndex;
var $b66002032a1093e6$export$1c37c01eba8ed446 = $bYadz.codec;
var $b66002032a1093e6$export$3004f64547af360e = $bYadz.fromString;
var $b66002032a1093e6$export$f84e8e69fd4488a5 = $bYadz.toString;
var $b66002032a1093e6$export$7a47376c130cfeac = $bYadz.safeDecode;
 /* Facets-ApiTypes Not a pure module */ 
});
parcelRegister("d1G6W", function(module, exports) {

$parcel$export(module.exports, "fromString", function () { return $97bc08b311d24138$export$3004f64547af360e; });
function $97bc08b311d24138$export$3004f64547af360e(i) {
    var i$1 = parseFloat(i);
    if (isNaN(i$1)) return;
    else return i$1;
}
 /* No side effect */ 
});

parcelRegister("bYadz", function(module, exports) {

$parcel$export(module.exports, "entry_encode", function () { return $8b6d395814534b36$export$f36491c978b47831; });
$parcel$export(module.exports, "entry_decode", function () { return $8b6d395814534b36$export$4537221bf74c4819; });
$parcel$export(module.exports, "entry_fromJson", function () { return $8b6d395814534b36$export$6f3f41cc52acf41c; });
$parcel$export(module.exports, "entry_toJson", function () { return $8b6d395814534b36$export$50fd5e4354593993; });
$parcel$export(module.exports, "t_encode", function () { return $8b6d395814534b36$export$cc42ff7b6c615091; });
$parcel$export(module.exports, "t_decode", function () { return $8b6d395814534b36$export$bb5e712207166a02; });
$parcel$export(module.exports, "make", function () { return $8b6d395814534b36$export$dd44f18ab656f3bb; });
$parcel$export(module.exports, "fromJson", function () { return $8b6d395814534b36$export$7ae2d2a8b28a8cb8; });
$parcel$export(module.exports, "toJson", function () { return $8b6d395814534b36$export$d5b7a8bf56ee1fe2; });
$parcel$export(module.exports, "abstract_encode", function () { return $8b6d395814534b36$export$e5172b961a11c52e; });
$parcel$export(module.exports, "abstract_decode", function () { return $8b6d395814534b36$export$bdddd0cc5d922103; });
$parcel$export(module.exports, "toStringOfIndex", function () { return $8b6d395814534b36$export$e3ea025983b032e1; });
$parcel$export(module.exports, "codec", function () { return $8b6d395814534b36$export$1c37c01eba8ed446; });
$parcel$export(module.exports, "safeDecode", function () { return $8b6d395814534b36$export$7a47376c130cfeac; });
$parcel$export(module.exports, "fromString", function () { return $8b6d395814534b36$export$3004f64547af360e; });
$parcel$export(module.exports, "toString", function () { return $8b6d395814534b36$export$f84e8e69fd4488a5; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $3zjNo = parcelRequire("3zjNo");

var $d3YYW = parcelRequire("d3YYW");

var $1ArWc = parcelRequire("1ArWc");

var $i7mYY = parcelRequire("i7mYY");

var $d1G6W = parcelRequire("d1G6W");

var $2whNH = parcelRequire("2whNH");

var $gTtop = parcelRequire("gTtop");

var $kiuDo = parcelRequire("kiuDo");

var $79vie = parcelRequire("79vie");

var $jVmMx = parcelRequire("jVmMx");
function $8b6d395814534b36$export$f36491c978b47831(v) {
    return $d3YYW.fromArray([
        [
            "facet",
            $3zjNo.stringToJson(v.facet)
        ],
        [
            "index",
            $3zjNo.intToJson(v.index)
        ]
    ]);
}
function $8b6d395814534b36$export$4537221bf74c4819(v) {
    var dict = $1ArWc.classify(v);
    if (typeof dict === "number") return $3zjNo.error(undefined, "Not an object", v);
    if (dict.TAG !== /* JSONObject */ 2) return $3zjNo.error(undefined, "Not an object", v);
    var dict$1 = dict._0;
    var facet = $3zjNo.stringFromJson($2whNH.getWithDefault($d3YYW.get(dict$1, "facet"), null));
    if (facet.TAG === /* Ok */ 0) {
        var index = $3zjNo.intFromJson($2whNH.getWithDefault($d3YYW.get(dict$1, "index"), null));
        if (index.TAG === /* Ok */ 0) return {
            TAG: /* Ok */ 0,
            _0: {
                facet: facet._0,
                index: index._0
            }
        };
        var e = index._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".index" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = facet._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".facet" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
var $8b6d395814534b36$export$6f3f41cc52acf41c = $iv6Yc._3($jVmMx.Decode.map2, $iv6Yc._2($jVmMx.Decode.field, "facet", $jVmMx.Decode.string), $iv6Yc._2($jVmMx.Decode.field, "index", $jVmMx.Decode.$$int), function(facet, index) {
    return {
        facet: facet,
        index: index
    };
});
function $8b6d395814534b36$export$50fd5e4354593993(param) {
    return $iv6Yc._1($jVmMx.Encode.object, [
        [
            "facet",
            $iv6Yc._1($jVmMx.Encode.string, param.facet)
        ],
        [
            "index",
            $iv6Yc._1($jVmMx.Encode.$$int, param.index)
        ]
    ]);
}
function $8b6d395814534b36$export$cc42ff7b6c615091(v) {
    return $d3YYW.fromArray([
        [
            "entries",
            $3zjNo.arrayToJson($8b6d395814534b36$export$f36491c978b47831, v.entries)
        ],
        [
            "minPrice",
            $3zjNo.optionToJson($3zjNo.floatToJson, v.minPrice)
        ],
        [
            "maxPrice",
            $3zjNo.optionToJson($3zjNo.floatToJson, v.maxPrice)
        ]
    ]);
}
function $8b6d395814534b36$export$bb5e712207166a02(v) {
    var dict = $1ArWc.classify(v);
    if (typeof dict === "number") return $3zjNo.error(undefined, "Not an object", v);
    if (dict.TAG !== /* JSONObject */ 2) return $3zjNo.error(undefined, "Not an object", v);
    var dict$1 = dict._0;
    var entries = $3zjNo.arrayFromJson($8b6d395814534b36$export$4537221bf74c4819, $2whNH.getWithDefault($d3YYW.get(dict$1, "entries"), null));
    if (entries.TAG === /* Ok */ 0) {
        var minPrice = $3zjNo.optionFromJson($3zjNo.floatFromJson, $2whNH.getWithDefault($d3YYW.get(dict$1, "minPrice"), null));
        if (minPrice.TAG === /* Ok */ 0) {
            var maxPrice = $3zjNo.optionFromJson($3zjNo.floatFromJson, $2whNH.getWithDefault($d3YYW.get(dict$1, "maxPrice"), null));
            if (maxPrice.TAG === /* Ok */ 0) return {
                TAG: /* Ok */ 0,
                _0: {
                    entries: entries._0,
                    minPrice: minPrice._0,
                    maxPrice: maxPrice._0
                }
            };
            var e = maxPrice._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".maxPrice" + e.path,
                    message: e.message,
                    value: e.value
                }
            };
        }
        var e$1 = minPrice._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".minPrice" + e$1.path,
                message: e$1.message,
                value: e$1.value
            }
        };
    }
    var e$2 = entries._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".entries" + e$2.path,
            message: e$2.message,
            value: e$2.value
        }
    };
}
function $8b6d395814534b36$export$dd44f18ab656f3bb(minPrice, maxPrice, entries) {
    return {
        entries: entries,
        minPrice: minPrice,
        maxPrice: maxPrice
    };
}
var $8b6d395814534b36$export$7ae2d2a8b28a8cb8 = $79vie.map3($79vie.field("entries", $79vie.array($8b6d395814534b36$export$6f3f41cc52acf41c)), $79vie.field("minPrice", $79vie.option($79vie.$$float)), $79vie.field("maxPrice", $79vie.option($79vie.$$float)), function(entries, minPrice, maxPrice) {
    return {
        entries: entries,
        minPrice: minPrice,
        maxPrice: maxPrice
    };
});
function $8b6d395814534b36$export$d5b7a8bf56ee1fe2(param) {
    return $iv6Yc._1($jVmMx.Encode.object, [
        [
            "entries",
            $iv6Yc._2($jVmMx.Encode.array, param.entries, $8b6d395814534b36$export$50fd5e4354593993)
        ],
        [
            "minPrice",
            $jVmMx.Encode.nullable(param.minPrice, $jVmMx.Encode.$$float)
        ],
        [
            "maxPrice",
            $jVmMx.Encode.nullable(param.maxPrice, $jVmMx.Encode.$$float)
        ]
    ]);
}
var $8b6d395814534b36$export$e5172b961a11c52e = $3zjNo.stringToJson;
var $8b6d395814534b36$export$bdddd0cc5d922103 = $3zjNo.stringFromJson;
function $8b6d395814534b36$var$t_decode$1(json) {
    return $gTtop.flatMap($3zjNo.stringFromJson(json), function(string) {
        var entries = $i7mYY.keepMap(string.split(","), function(each) {
            var match = each.split(";");
            if (match.length !== 2) return {
                facet: decodeURIComponent(each),
                index: -1
            };
            var key = match[0];
            var index = match[1];
            return {
                facet: decodeURIComponent(key),
                index: $kiuDo.int_of_string(index)
            };
        });
        var extractedMinPrice = $i7mYY.reduce(entries, undefined, function(acc, entry) {
            var match = entry.facet.split("=");
            if (match.length !== 2) return acc;
            var match$1 = match[0];
            if (match$1 === "minprice") return $d1G6W.fromString(match[1]);
            else return acc;
        });
        var extractedMaxPrice = $i7mYY.reduce(entries, undefined, function(acc, entry) {
            var match = entry.facet.split("=");
            if (match.length !== 2) return acc;
            var match$1 = match[0];
            if (match$1 === "maxprice") return $d1G6W.fromString(match[1]);
            else return acc;
        });
        var entries$1 = $i7mYY.keepMap(entries, function(entry) {
            var match = entry.index;
            if (match !== -1) return entry;
        });
        return {
            TAG: /* Ok */ 0,
            _0: {
                entries: entries$1,
                minPrice: extractedMinPrice,
                maxPrice: extractedMaxPrice
            }
        };
    });
}
function $8b6d395814534b36$var$encode(a) {
    return JSON.stringify($3zjNo.stringToJson(a.join(","))).replace(/^\"(.*)\"$/, "$1");
}
function $8b6d395814534b36$var$t_encode$1(a) {
    return $8b6d395814534b36$var$encode($i7mYY.concat($i7mYY.map(a.entries, function(param) {
        return encodeURIComponent(param.facet) + ";" + String(param.index);
    }), $i7mYY.keepMap([
        $2whNH.map(a.minPrice, function(minPrice) {
            return encodeURIComponent("minprice") + "=" + String(minPrice);
        }),
        $2whNH.map(a.maxPrice, function(maxPrice) {
            return encodeURIComponent("maxprice") + "=" + String(maxPrice);
        })
    ], function(a) {
        return a;
    })));
}
function $8b6d395814534b36$export$e3ea025983b032e1(a) {
    return $8b6d395814534b36$var$encode($i7mYY.map(a.entries, function(param) {
        return String(param.index);
    }));
}
var $8b6d395814534b36$export$1c37c01eba8ed446 = [
    $8b6d395814534b36$var$t_decode$1,
    $8b6d395814534b36$var$t_encode$1
];
function $8b6d395814534b36$export$7a47376c130cfeac(filters) {
    try {
        var result = $8b6d395814534b36$var$t_decode$1(filters);
        if (result.TAG === /* Ok */ 0) return result._0;
        else return;
    } catch (exn) {
        return;
    }
}
var $8b6d395814534b36$export$3004f64547af360e = $8b6d395814534b36$var$t_decode$1;
var $8b6d395814534b36$export$f84e8e69fd4488a5 = $8b6d395814534b36$var$t_encode$1;
 /* entry_fromJson Not a pure module */ 
});
parcelRegister("3zjNo", function(module, exports) {

$parcel$export(module.exports, "error", function () { return $2993fefbdf26d22c$export$a3bc9b8ed74fc; });
$parcel$export(module.exports, "stringToJson", function () { return $2993fefbdf26d22c$export$cb73ac3d868ef79b; });
$parcel$export(module.exports, "stringFromJson", function () { return $2993fefbdf26d22c$export$a8bc34bb3318cfda; });
$parcel$export(module.exports, "intToJson", function () { return $2993fefbdf26d22c$export$dce6a9069b80cba6; });
$parcel$export(module.exports, "intFromJson", function () { return $2993fefbdf26d22c$export$40281f6dcbcf0ee4; });
$parcel$export(module.exports, "floatToJson", function () { return $2993fefbdf26d22c$export$ad575e1229096d23; });
$parcel$export(module.exports, "floatFromJson", function () { return $2993fefbdf26d22c$export$a7e4c9de6f0be695; });
$parcel$export(module.exports, "boolToJson", function () { return $2993fefbdf26d22c$export$1345bb952a2766a4; });
$parcel$export(module.exports, "boolFromJson", function () { return $2993fefbdf26d22c$export$2cacc15469418278; });
$parcel$export(module.exports, "arrayToJson", function () { return $2993fefbdf26d22c$export$fc848dd87fcd545f; });
$parcel$export(module.exports, "arrayFromJson", function () { return $2993fefbdf26d22c$export$5491596feec56301; });
$parcel$export(module.exports, "optionToJson", function () { return $2993fefbdf26d22c$export$ee26ff36a9af215a; });
$parcel$export(module.exports, "optionFromJson", function () { return $2993fefbdf26d22c$export$c52a79ebe572c75; });
$parcel$export(module.exports, "dictToJson", function () { return $2993fefbdf26d22c$export$1875196e68ae0bdf; });
$parcel$export(module.exports, "dictFromJson", function () { return $2993fefbdf26d22c$export$51f094e6554ee1ed; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iAJWt = parcelRequire("iAJWt");

var $iv6Yc = parcelRequire("iv6Yc");

var $d3YYW = parcelRequire("d3YYW");

var $1ArWc = parcelRequire("1ArWc");

var $5alaa = parcelRequire("5alaa");

var $69lAE = parcelRequire("69lAE");

var $i7mYY = parcelRequire("i7mYY");

var $dD1bi = parcelRequire("dD1bi");

var $gTtop = parcelRequire("gTtop");

var $loT9g = parcelRequire("loT9g");

var $19caA = parcelRequire("19caA");
function $2993fefbdf26d22c$export$a3bc9b8ed74fc(path, message, value) {
    var path$1 = path !== undefined ? path : "";
    return {
        TAG: /* Error */ 1,
        _0: {
            path: path$1,
            message: message,
            value: value
        }
    };
}
function $2993fefbdf26d22c$export$cb73ac3d868ef79b(s) {
    return s;
}
function $2993fefbdf26d22c$export$a8bc34bb3318cfda(j) {
    var s = $1ArWc.decodeString(j);
    if (s !== undefined) return {
        TAG: /* Ok */ 0,
        _0: s
    };
    else return {
        TAG: /* Error */ 1,
        _0: {
            path: "",
            message: "Not a string",
            value: j
        }
    };
}
function $2993fefbdf26d22c$export$dce6a9069b80cba6(i) {
    return i;
}
function $2993fefbdf26d22c$export$40281f6dcbcf0ee4(j) {
    var f = $1ArWc.decodeNumber(j);
    if (f !== undefined) {
        if ($5alaa.floor(f) === f) return {
            TAG: /* Ok */ 0,
            _0: $5alaa.floor(f)
        };
        else return {
            TAG: /* Error */ 1,
            _0: {
                path: "",
                message: "Not an integer",
                value: j
            }
        };
    } else return {
        TAG: /* Error */ 1,
        _0: {
            path: "",
            message: "Not a number",
            value: j
        }
    };
}
var $2993fefbdf26d22c$export$e69bf62e5233e775 = $dD1bi.float_of_bits;
function $2993fefbdf26d22c$export$e6b69943c89ad4c4(j) {
    var n = $1ArWc.decodeNumber(j);
    if (n !== undefined) return {
        TAG: /* Ok */ 0,
        _0: $dD1bi.bits_of_float(n)
    };
    else return $2993fefbdf26d22c$export$a3bc9b8ed74fc(undefined, "Not a number", j);
}
var $2993fefbdf26d22c$export$6678a7fcc55aad68 = $dD1bi.to_float;
function $2993fefbdf26d22c$export$42c109f7941462bb(j) {
    var n = $1ArWc.decodeNumber(j);
    if (n !== undefined) return {
        TAG: /* Ok */ 0,
        _0: $dD1bi.of_float(n)
    };
    else return $2993fefbdf26d22c$export$a3bc9b8ed74fc(undefined, "Not a number", j);
}
function $2993fefbdf26d22c$export$ad575e1229096d23(v) {
    return v;
}
function $2993fefbdf26d22c$export$a7e4c9de6f0be695(j) {
    var f = $1ArWc.decodeNumber(j);
    if (f !== undefined) return {
        TAG: /* Ok */ 0,
        _0: f
    };
    else return {
        TAG: /* Error */ 1,
        _0: {
            path: "",
            message: "Not a number",
            value: j
        }
    };
}
function $2993fefbdf26d22c$export$1345bb952a2766a4(v) {
    return v;
}
function $2993fefbdf26d22c$export$2cacc15469418278(j) {
    var b = $1ArWc.decodeBoolean(j);
    if (b !== undefined) return {
        TAG: /* Ok */ 0,
        _0: b
    };
    else return {
        TAG: /* Error */ 1,
        _0: {
            path: "",
            message: "Not a boolean",
            value: j
        }
    };
}
function $2993fefbdf26d22c$export$3565179eec7bd73e(param) {
    return 0.0;
}
function $2993fefbdf26d22c$export$e90afe2f09fcf9b5(param) {
    return {
        TAG: /* Ok */ 0,
        _0: undefined
    };
}
var $2993fefbdf26d22c$export$fc848dd87fcd545f = $69lAE.map;
function $2993fefbdf26d22c$export$5491596feec56301(decoder, json) {
    var arr = $1ArWc.decodeArray(json);
    if (arr !== undefined) return $69lAE.reducei(function(acc, jsonI, i) {
        var match = $iv6Yc._1(decoder, jsonI);
        if (acc.TAG !== /* Ok */ 0) return acc;
        if (match.TAG === /* Ok */ 0) return {
            TAG: /* Ok */ 0,
            _0: $69lAE.concat([
                match._0
            ], acc._0)
        };
        var error = match._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: "[" + (String(i) + ("]" + error.path)),
                message: error.message,
                value: error.value
            }
        };
    }, {
        TAG: /* Ok */ 0,
        _0: []
    }, arr);
    else return {
        TAG: /* Error */ 1,
        _0: {
            path: "",
            message: "Not an array",
            value: json
        }
    };
}
function $2993fefbdf26d22c$export$248031d748512657(encoder, list) {
    var arr = $iAJWt.of_list(list);
    return $69lAE.map(encoder, arr);
}
function $2993fefbdf26d22c$export$81588e2d52d5154e(decoder, json) {
    var __x = $2993fefbdf26d22c$export$5491596feec56301(decoder, json);
    return $gTtop.map(__x, $iAJWt.to_list);
}
function $2993fefbdf26d22c$export$ee26ff36a9af215a(encoder, opt) {
    if (opt !== undefined) return $iv6Yc._1(encoder, $loT9g.valFromOption(opt));
    else return null;
}
function $2993fefbdf26d22c$export$c52a79ebe572c75(decoder, json) {
    var match = $1ArWc.decodeNull(json);
    if (match !== undefined) return {
        TAG: /* Ok */ 0,
        _0: undefined
    };
    var __x = $iv6Yc._1(decoder, json);
    return $gTtop.map(__x, function(v) {
        return $loT9g.some(v);
    });
}
function $2993fefbdf26d22c$export$1bfa197d6673cc35(okEncoder, errorEncoder, result) {
    if (result.TAG === /* Ok */ 0) return [
        "Ok",
        $iv6Yc._1(okEncoder, result._0)
    ];
    else return [
        "Error",
        $iv6Yc._1(errorEncoder, result._0)
    ];
}
function $2993fefbdf26d22c$export$e1d2d69b868b65c2(okDecoder, errorDecoder, json) {
    var match = $1ArWc.decodeArray(json);
    if (match === undefined) return $2993fefbdf26d22c$export$a3bc9b8ed74fc(undefined, "Not an array", json);
    if (match.length !== 2) return $2993fefbdf26d22c$export$a3bc9b8ed74fc(undefined, "Expected exactly 2 values in array", json);
    var variantConstructorId = match[0];
    var payload = match[1];
    var match$1 = $1ArWc.decodeString(variantConstructorId);
    if (match$1 === undefined) return $2993fefbdf26d22c$export$a3bc9b8ed74fc(undefined, "Not a string", variantConstructorId);
    switch(match$1){
        case "Error":
            var v = $iv6Yc._1(errorDecoder, payload);
            if (v.TAG === /* Ok */ 0) return {
                TAG: /* Ok */ 0,
                _0: {
                    TAG: /* Error */ 1,
                    _0: v._0
                }
            };
            else return {
                TAG: /* Error */ 1,
                _0: v._0
            };
        case "Ok":
            return $gTtop.map($iv6Yc._1(okDecoder, payload), function(v) {
                return {
                    TAG: /* Ok */ 0,
                    _0: v
                };
            });
        default:
            return $2993fefbdf26d22c$export$a3bc9b8ed74fc(undefined, 'Expected either "Ok" or "Error"', variantConstructorId);
    }
}
function $2993fefbdf26d22c$export$1875196e68ae0bdf(encoder, dict) {
    return $d3YYW.map($iv6Yc.__1(encoder), dict);
}
function $2993fefbdf26d22c$export$51f094e6554ee1ed(decoder, json) {
    var dict = $1ArWc.decodeObject(json);
    if (dict !== undefined) return $i7mYY.reduce($d3YYW.entries($loT9g.valFromOption(dict)), {
        TAG: /* Ok */ 0,
        _0: {}
    }, function(acc, param) {
        var key = param[0];
        var match = $iv6Yc._1(decoder, param[1]);
        if (acc.TAG !== /* Ok */ 0) return acc;
        var prev = acc._0;
        if (match.TAG === /* Ok */ 0) {
            prev[key] = match._0;
            return {
                TAG: /* Ok */ 0,
                _0: prev
            };
        }
        var error = match._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: "." + (key + error.path),
                message: error.message,
                value: error.value
            }
        };
    });
    else return {
        TAG: /* Error */ 1,
        _0: {
            path: "",
            message: "Not a dict",
            value: json
        }
    };
}
var $2993fefbdf26d22c$var$string = [
    $2993fefbdf26d22c$export$cb73ac3d868ef79b,
    $2993fefbdf26d22c$export$a8bc34bb3318cfda
];
var $2993fefbdf26d22c$var$$$int = [
    $2993fefbdf26d22c$export$dce6a9069b80cba6,
    $2993fefbdf26d22c$export$40281f6dcbcf0ee4
];
var $2993fefbdf26d22c$var$int64Unsafe = [
    $2993fefbdf26d22c$export$6678a7fcc55aad68,
    $2993fefbdf26d22c$export$42c109f7941462bb
];
var $2993fefbdf26d22c$var$$$float = [
    $2993fefbdf26d22c$export$ad575e1229096d23,
    $2993fefbdf26d22c$export$a7e4c9de6f0be695
];
var $2993fefbdf26d22c$var$bool = [
    $2993fefbdf26d22c$export$1345bb952a2766a4,
    $2993fefbdf26d22c$export$2cacc15469418278
];
var $2993fefbdf26d22c$var$array = [
    $2993fefbdf26d22c$export$fc848dd87fcd545f,
    $2993fefbdf26d22c$export$5491596feec56301
];
var $2993fefbdf26d22c$var$list = [
    $2993fefbdf26d22c$export$248031d748512657,
    $2993fefbdf26d22c$export$81588e2d52d5154e
];
var $2993fefbdf26d22c$var$option = [
    $2993fefbdf26d22c$export$ee26ff36a9af215a,
    $2993fefbdf26d22c$export$c52a79ebe572c75
];
var $2993fefbdf26d22c$var$unit = [
    $2993fefbdf26d22c$export$3565179eec7bd73e,
    $2993fefbdf26d22c$export$e90afe2f09fcf9b5
];
var $2993fefbdf26d22c$export$1c4d583cbe1d2b10 = {
    falseableEncode: $19caA.falseableEncode,
    falseableDecode: $19caA.falseableDecode,
    falseable: $19caA.falseable,
    magicDecode: $19caA.magicDecode,
    magic: $19caA.magic,
    string: $2993fefbdf26d22c$var$string,
    $$int: $2993fefbdf26d22c$var$$$int,
    int64Unsafe: $2993fefbdf26d22c$var$int64Unsafe,
    $$float: $2993fefbdf26d22c$var$$$float,
    bool: $2993fefbdf26d22c$var$bool,
    array: $2993fefbdf26d22c$var$array,
    list: $2993fefbdf26d22c$var$list,
    option: $2993fefbdf26d22c$var$option,
    unit: $2993fefbdf26d22c$var$unit
};
 /* No side effect */ 
});
parcelRegister("iAJWt", function(module, exports) {

$parcel$export(module.exports, "to_list", function () { return $d88f39f10b164530$export$8e209af3baf60707; });
$parcel$export(module.exports, "of_list", function () { return $d88f39f10b164530$export$b71d4560b1745112; });

var $iv6Yc = parcelRequire("iv6Yc");

var $7bjme = parcelRequire("7bjme");

var $1PGgk = parcelRequire("1PGgk");

var $1xvYg = parcelRequire("1xvYg");

var $bBMv4 = parcelRequire("bBMv4");
var $d88f39f10b164530$export$d79c6918e0a9d9af = $1PGgk.make_float;
var $d88f39f10b164530$export$cebbcf13f19bf144 = {};
function $d88f39f10b164530$export$2cd8252107eb640b(l, f) {
    if (l === 0) return [];
    if (l < 0) throw {
        RE_EXN_ID: "Invalid_argument",
        _1: "Array.init",
        Error: new Error()
    };
    var res = $1PGgk.make(l, $iv6Yc._1(f, 0));
    for(var i = 1; i < l; ++i)res[i] = $iv6Yc._1(f, i);
    return res;
}
function $d88f39f10b164530$export$4ebb4186b84fa2f7(sx, sy, init) {
    var res = $1PGgk.make(sx, []);
    for(var x = 0; x < sx; ++x)res[x] = $1PGgk.make(sy, init);
    return res;
}
function $d88f39f10b164530$export$784d13d8ee351f07(a) {
    var l = a.length;
    if (l === 0) return [];
    else return $1PGgk.sub(a, 0, l);
}
function $d88f39f10b164530$export$10d8903dec122b9d(a1, a2) {
    var l1 = a1.length;
    if (l1 === 0) return $d88f39f10b164530$export$784d13d8ee351f07(a2);
    else if (a2.length === 0) return $1PGgk.sub(a1, 0, l1);
    else return a1.concat(a2);
}
function $d88f39f10b164530$export$f93b5905241a7cca(a, ofs, len) {
    if (ofs < 0 || len < 0 || ofs > (a.length - len | 0)) throw {
        RE_EXN_ID: "Invalid_argument",
        _1: "Array.sub",
        Error: new Error()
    };
    return $1PGgk.sub(a, ofs, len);
}
function $d88f39f10b164530$export$9563e054e6f787fb(a, ofs, len, v) {
    if (ofs < 0 || len < 0 || ofs > (a.length - len | 0)) throw {
        RE_EXN_ID: "Invalid_argument",
        _1: "Array.fill",
        Error: new Error()
    };
    for(var i = ofs, i_finish = ofs + len | 0; i < i_finish; ++i)a[i] = v;
}
function $d88f39f10b164530$export$1b8713e12f56ba52(a1, ofs1, a2, ofs2, len) {
    if (len < 0 || ofs1 < 0 || ofs1 > (a1.length - len | 0) || ofs2 < 0 || ofs2 > (a2.length - len | 0)) throw {
        RE_EXN_ID: "Invalid_argument",
        _1: "Array.blit",
        Error: new Error()
    };
    $1PGgk.blit(a1, ofs1, a2, ofs2, len);
}
function $d88f39f10b164530$export$c0bf298a2e425654(f, a) {
    for(var i = 0, i_finish = a.length; i < i_finish; ++i)$iv6Yc._1(f, a[i]);
}
function $d88f39f10b164530$export$21f0e7f97cbd7529(f, a, b) {
    if (a.length !== b.length) throw {
        RE_EXN_ID: "Invalid_argument",
        _1: "Array.iter2: arrays must have the same length",
        Error: new Error()
    };
    for(var i = 0, i_finish = a.length; i < i_finish; ++i)$iv6Yc._2(f, a[i], b[i]);
}
function $d88f39f10b164530$export$871de8747c9eaa88(f, a) {
    var l = a.length;
    if (l === 0) return [];
    var r = $1PGgk.make(l, $iv6Yc._1(f, a[0]));
    for(var i = 1; i < l; ++i)r[i] = $iv6Yc._1(f, a[i]);
    return r;
}
function $d88f39f10b164530$export$5be556bf484c4f10(f, a, b) {
    var la = a.length;
    var lb = b.length;
    if (la !== lb) throw {
        RE_EXN_ID: "Invalid_argument",
        _1: "Array.map2: arrays must have the same length",
        Error: new Error()
    };
    if (la === 0) return [];
    var r = $1PGgk.make(la, $iv6Yc._2(f, a[0], b[0]));
    for(var i = 1; i < la; ++i)r[i] = $iv6Yc._2(f, a[i], b[i]);
    return r;
}
function $d88f39f10b164530$export$2827e1b448e826c6(f, a) {
    for(var i = 0, i_finish = a.length; i < i_finish; ++i)$iv6Yc._2(f, i, a[i]);
}
function $d88f39f10b164530$export$8ef92191dafa99ba(f, a) {
    var l = a.length;
    if (l === 0) return [];
    var r = $1PGgk.make(l, $iv6Yc._2(f, 0, a[0]));
    for(var i = 1; i < l; ++i)r[i] = $iv6Yc._2(f, i, a[i]);
    return r;
}
function $d88f39f10b164530$export$8e209af3baf60707(a) {
    var _i = a.length - 1 | 0;
    var _res = /* [] */ 0;
    while(true){
        var res = _res;
        var i = _i;
        if (i < 0) return res;
        _res = {
            hd: a[i],
            tl: res
        };
        _i = i - 1 | 0;
        continue;
    }
}
function $d88f39f10b164530$var$list_length(_accu, _param) {
    while(true){
        var param = _param;
        var accu = _accu;
        if (!param) return accu;
        _param = param.tl;
        _accu = accu + 1 | 0;
        continue;
    }
}
function $d88f39f10b164530$export$b71d4560b1745112(l) {
    if (!l) return [];
    var a = $1PGgk.make($d88f39f10b164530$var$list_length(0, l), l.hd);
    var _i = 1;
    var _param = l.tl;
    while(true){
        var param = _param;
        var i = _i;
        if (!param) return a;
        a[i] = param.hd;
        _param = param.tl;
        _i = i + 1 | 0;
        continue;
    }
}
function $d88f39f10b164530$export$887fcf96d740879c(f, x, a) {
    var r = x;
    for(var i = 0, i_finish = a.length; i < i_finish; ++i)r = $iv6Yc._2(f, r, a[i]);
    return r;
}
function $d88f39f10b164530$export$d98553ecae3b472f(f, a, x) {
    var r = x;
    for(var i = a.length - 1 | 0; i >= 0; --i)r = $iv6Yc._2(f, a[i], r);
    return r;
}
function $d88f39f10b164530$export$f7e9f41ea797a17(p, a) {
    var n = a.length;
    var _i = 0;
    while(true){
        var i = _i;
        if (i === n) return false;
        if ($iv6Yc._1(p, a[i])) return true;
        _i = i + 1 | 0;
        continue;
    }
}
function $d88f39f10b164530$export$b276b5448e887371(p, a) {
    var n = a.length;
    var _i = 0;
    while(true){
        var i = _i;
        if (i === n) return true;
        if (!$iv6Yc._1(p, a[i])) return false;
        _i = i + 1 | 0;
        continue;
    }
}
function $d88f39f10b164530$export$e8308fa57e490f0c(x, a) {
    var n = a.length;
    var _i = 0;
    while(true){
        var i = _i;
        if (i === n) return false;
        if ($7bjme.equal(a[i], x)) return true;
        _i = i + 1 | 0;
        continue;
    }
}
function $d88f39f10b164530$export$922408a699a56fa1(x, a) {
    var n = a.length;
    var _i = 0;
    while(true){
        var i = _i;
        if (i === n) return false;
        if (x === a[i]) return true;
        _i = i + 1 | 0;
        continue;
    }
}
var $d88f39f10b164530$var$Bottom = /* @__PURE__ */ $1xvYg.create("Array.Bottom");
function $d88f39f10b164530$export$97db5808d8f88186(cmp, a) {
    var maxson = function maxson(l, i) {
        var i31 = ((i + i | 0) + i | 0) + 1 | 0;
        var x = i31;
        if ((i31 + 2 | 0) < l) {
            if ($iv6Yc._2(cmp, $1PGgk.get(a, i31), $1PGgk.get(a, i31 + 1 | 0)) < 0) x = i31 + 1 | 0;
            if ($iv6Yc._2(cmp, $1PGgk.get(a, x), $1PGgk.get(a, i31 + 2 | 0)) < 0) x = i31 + 2 | 0;
            return x;
        }
        if ((i31 + 1 | 0) < l && $iv6Yc._2(cmp, $1PGgk.get(a, i31), $1PGgk.get(a, i31 + 1 | 0)) < 0) return i31 + 1 | 0;
        if (i31 < l) return i31;
        throw {
            RE_EXN_ID: $d88f39f10b164530$var$Bottom,
            _1: i,
            Error: new Error()
        };
    };
    var trickle = function trickle(l, i, e) {
        try {
            var _i = i;
            while(true){
                var i$1 = _i;
                var j = maxson(l, i$1);
                if ($iv6Yc._2(cmp, $1PGgk.get(a, j), e) <= 0) return $1PGgk.set(a, i$1, e);
                $1PGgk.set(a, i$1, $1PGgk.get(a, j));
                _i = j;
                continue;
            }
        } catch (raw_i) {
            var i$2 = $bBMv4.internalToOCamlException(raw_i);
            if (i$2.RE_EXN_ID === $d88f39f10b164530$var$Bottom) return $1PGgk.set(a, i$2._1, e);
            throw i$2;
        }
    };
    var bubble = function bubble(l, i) {
        try {
            var _i = i;
            while(true){
                var i$1 = _i;
                var j = maxson(l, i$1);
                $1PGgk.set(a, i$1, $1PGgk.get(a, j));
                _i = j;
                continue;
            }
        } catch (raw_i) {
            var i$2 = $bBMv4.internalToOCamlException(raw_i);
            if (i$2.RE_EXN_ID === $d88f39f10b164530$var$Bottom) return i$2._1;
            throw i$2;
        }
    };
    var trickleup = function trickleup(_i, e) {
        while(true){
            var i = _i;
            var father = (i - 1 | 0) / 3 | 0;
            if (i === father) throw {
                RE_EXN_ID: "Assert_failure",
                _1: [
                    "array.ml",
                    236,
                    4
                ],
                Error: new Error()
            };
            if ($iv6Yc._2(cmp, $1PGgk.get(a, father), e) >= 0) return $1PGgk.set(a, i, e);
            $1PGgk.set(a, i, $1PGgk.get(a, father));
            if (father <= 0) return $1PGgk.set(a, 0, e);
            _i = father;
            continue;
        }
    };
    var l = a.length;
    for(var i = ((l + 1 | 0) / 3 | 0) - 1 | 0; i >= 0; --i)trickle(l, i, $1PGgk.get(a, i));
    for(var i$1 = l - 1 | 0; i$1 >= 2; --i$1){
        var e = $1PGgk.get(a, i$1);
        $1PGgk.set(a, i$1, $1PGgk.get(a, 0));
        trickleup(bubble(i$1, 0), e);
    }
    if (l <= 1) return;
    var e$1 = $1PGgk.get(a, 1);
    $1PGgk.set(a, 1, $1PGgk.get(a, 0));
    $1PGgk.set(a, 0, e$1);
}
function $d88f39f10b164530$export$a1529f83f7b416e0(cmp, a) {
    var merge = function merge(src1ofs, src1len, src2, src2ofs, src2len, dst, dstofs) {
        var src1r = src1ofs + src1len | 0;
        var src2r = src2ofs + src2len | 0;
        var _i1 = src1ofs;
        var _s1 = $1PGgk.get(a, src1ofs);
        var _i2 = src2ofs;
        var _s2 = $1PGgk.get(src2, src2ofs);
        var _d = dstofs;
        while(true){
            var d = _d;
            var s2 = _s2;
            var i2 = _i2;
            var s1 = _s1;
            var i1 = _i1;
            if ($iv6Yc._2(cmp, s1, s2) <= 0) {
                $1PGgk.set(dst, d, s1);
                var i1$1 = i1 + 1 | 0;
                if (i1$1 >= src1r) return $d88f39f10b164530$export$1b8713e12f56ba52(src2, i2, dst, d + 1 | 0, src2r - i2 | 0);
                _d = d + 1 | 0;
                _s1 = $1PGgk.get(a, i1$1);
                _i1 = i1$1;
                continue;
            }
            $1PGgk.set(dst, d, s2);
            var i2$1 = i2 + 1 | 0;
            if (i2$1 >= src2r) return $d88f39f10b164530$export$1b8713e12f56ba52(a, i1, dst, d + 1 | 0, src1r - i1 | 0);
            _d = d + 1 | 0;
            _s2 = $1PGgk.get(src2, i2$1);
            _i2 = i2$1;
            continue;
        }
    };
    var isortto = function isortto(srcofs, dst, dstofs, len) {
        for(var i = 0; i < len; ++i){
            var e = $1PGgk.get(a, srcofs + i | 0);
            var j = (dstofs + i | 0) - 1 | 0;
            while(j >= dstofs && $iv6Yc._2(cmp, $1PGgk.get(dst, j), e) > 0){
                $1PGgk.set(dst, j + 1 | 0, $1PGgk.get(dst, j));
                j = j - 1 | 0;
            }
            $1PGgk.set(dst, j + 1 | 0, e);
        }
    };
    var sortto = function sortto1(srcofs, dst, dstofs, len) {
        if (len <= 5) return isortto(srcofs, dst, dstofs, len);
        var l1 = len / 2 | 0;
        var l2 = len - l1 | 0;
        sortto(srcofs + l1 | 0, dst, dstofs + l1 | 0, l2);
        sortto(srcofs, a, srcofs + l2 | 0, l1);
        merge(srcofs + l2 | 0, l1, dst, dstofs + l1 | 0, l2, dst, dstofs);
    };
    var l = a.length;
    if (l <= 5) return isortto(0, a, 0, l);
    var l1 = l / 2 | 0;
    var l2 = l - l1 | 0;
    var t = $1PGgk.make(l2, $1PGgk.get(a, 0));
    sortto(l1, t, 0, l2);
    sortto(0, a, l2, l1);
    merge(l2, l1, t, 0, l2, a, 0);
}
var $d88f39f10b164530$export$fbdae951ea4eb733 = $d88f39f10b164530$export$4ebb4186b84fa2f7;
var $d88f39f10b164530$export$ee1b3e54f0441b22 = $1PGgk.concat;
var $d88f39f10b164530$export$9e7eab3675a60000 = $d88f39f10b164530$export$a1529f83f7b416e0;
 /* No side effect */ 
});

parcelRegister("19caA", function(module, exports) {

$parcel$export(module.exports, "falseableEncode", function () { return $0d601263f4f6eea3$export$56a34f49e946fb8d; });
$parcel$export(module.exports, "falseableDecode", function () { return $0d601263f4f6eea3$export$79fc6ebce6085d4; });
$parcel$export(module.exports, "falseable", function () { return $0d601263f4f6eea3$export$7e1b4c12916ef62d; });
$parcel$export(module.exports, "magicDecode", function () { return $0d601263f4f6eea3$export$560896e1f267396b; });
$parcel$export(module.exports, "magic", function () { return $0d601263f4f6eea3$export$13db3bb8db75f394; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $1ArWc = parcelRequire("1ArWc");

var $gTtop = parcelRequire("gTtop");

var $loT9g = parcelRequire("loT9g");
function $0d601263f4f6eea3$export$56a34f49e946fb8d(encoder, opt) {
    if (opt !== undefined) return $iv6Yc._1(encoder, $loT9g.valFromOption(opt));
    else return false;
}
function $0d601263f4f6eea3$export$79fc6ebce6085d4(decoder, json) {
    var match = $1ArWc.decodeBoolean(json);
    if (match !== undefined && !match) return {
        TAG: /* Ok */ 0,
        _0: undefined
    };
    var __x = $iv6Yc._1(decoder, json);
    return $gTtop.map(__x, function(v) {
        return $loT9g.some(v);
    });
}
var $0d601263f4f6eea3$export$7e1b4c12916ef62d = [
    $0d601263f4f6eea3$export$56a34f49e946fb8d,
    $0d601263f4f6eea3$export$79fc6ebce6085d4
];
function $0d601263f4f6eea3$export$560896e1f267396b(j) {
    return {
        TAG: /* Ok */ 0,
        _0: j
    };
}
function $0d601263f4f6eea3$var$magic_0(prim) {
    return prim;
}
var $0d601263f4f6eea3$export$13db3bb8db75f394 = [
    $0d601263f4f6eea3$var$magic_0,
    $0d601263f4f6eea3$export$560896e1f267396b
];
 /* No side effect */ 
});


parcelRegister("jVmMx", function(module, exports) {

$parcel$export(module.exports, "Encode", function () { return $e81503310f020e69$export$7feeb05a8babbb15; });
$parcel$export(module.exports, "Decode", function () { return $e81503310f020e69$export$325185342b153af9; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $d3YYW = parcelRequire("d3YYW");

var $7bjme = parcelRequire("7bjme");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $79vie = parcelRequire("79vie");

var $AAkl8 = parcelRequire("AAkl8");
function $e81503310f020e69$var$nullable(value, encoder) {
    return $2whNH.mapWithDefault(value, $AAkl8.$$null, encoder);
}
function $e81503310f020e69$var$simpleVariant(values, value) {
    return $i7mYY.reduce(values, $AAkl8.string("THIS SHOULD NEVER HAPPEN!"), function(acc, param) {
        if ($7bjme.equal(value, param[1])) return $AAkl8.array([
            param[0]
        ], $AAkl8.string);
        else return acc;
    });
}
function $e81503310f020e69$var$deccoVariantWithPayload(value, name, payloadEncoder) {
    return $AAkl8.array([
        $AAkl8.string(name),
        $iv6Yc._1(payloadEncoder, value)
    ], function(x) {
        return x;
    });
}
function $e81503310f020e69$var$dictWithEncoder(d, encoder) {
    return $AAkl8.dict($d3YYW.map($iv6Yc.__1(encoder), d));
}
function $e81503310f020e69$var$addIf(notEqualTo, previous, encode, input) {
    var value = input[1];
    if ($7bjme.notequal(value, notEqualTo)) return $i7mYY.concat(previous, [
        [
            input[0],
            $iv6Yc._1(encode, value)
        ]
    ]);
    else return previous;
}
var $e81503310f020e69$export$7feeb05a8babbb15 = {
    encode: $AAkl8.encode,
    string: $AAkl8.string,
    $$int: $AAkl8.$$int,
    $$float: $AAkl8.$$float,
    bool: $AAkl8.bool,
    $$null: $AAkl8.$$null,
    array: $AAkl8.array,
    list: $AAkl8.list,
    object: $AAkl8.object,
    dict: $AAkl8.dict,
    nullable: $e81503310f020e69$var$nullable,
    simpleVariant: $e81503310f020e69$var$simpleVariant,
    deccoVariantWithPayload: $e81503310f020e69$var$deccoVariantWithPayload,
    dictWithEncoder: $e81503310f020e69$var$dictWithEncoder,
    addIf: $e81503310f020e69$var$addIf
};
function $e81503310f020e69$var$lazy_(thunk) {
    return $79vie.andThen($79vie.succeed(undefined), thunk);
}
function $e81503310f020e69$var$$$default(encoder, $$default$1) {
    return $79vie.oneOf(encoder, [
        $79vie.succeed($$default$1)
    ]);
}
function $e81503310f020e69$var$fieldWithDefault(name, decoder, defaultTo) {
    return $79vie.map($79vie.option($79vie.field(name, decoder)), function(v) {
        return $2whNH.getWithDefault(v, defaultTo);
    });
}
function $e81503310f020e69$var$exactString(exactValue) {
    return $79vie.andThen($79vie.string, function(str) {
        if (str === exactValue) return $79vie.succeed($79vie.string);
        else return $79vie.fail("String is not the expected value of: " + exactValue + "");
    });
}
function $e81503310f020e69$var$exactStringVariant(exactString, variant) {
    return $79vie.andThen($79vie.index(0, $79vie.string), function(str) {
        if (str === exactString) return $79vie.succeed(variant);
        else return $79vie.fail("Not " + exactString + "");
    });
}
function $e81503310f020e69$var$exactVariantChoice(exactValue) {
    return $79vie.andThen($79vie.index(0, $79vie.string), function(str) {
        if (str === exactValue) return $79vie.succeed(exactValue);
        else return $79vie.fail("Trying to decode " + str + " but it doesn't match value " + exactValue + "");
    });
}
function $e81503310f020e69$var$simpleVariant$1(values) {
    var acceptedValues = values.map(function(param) {
        return '"' + param[0] + '"';
    }).join(" or ");
    return $79vie.andThen($79vie.index(0, $79vie.string), function(str) {
        var match = values.find(function(param) {
            return param[0] === str;
        });
        if (match !== undefined) return $79vie.succeed(match[1]);
        else return $79vie.fail("Trying to decode but the string " + str + " is not supported! Accepted values: " + acceptedValues + "");
    });
}
function $e81503310f020e69$var$deccoVariantWithPayload$1(name, decoder, f) {
    return $79vie.map2($79vie.index(0, $e81503310f020e69$var$exactString(name)), $79vie.index(1, decoder), function(param, value) {
        return $iv6Yc._1(f, value);
    });
}
function $e81503310f020e69$var$stringifiedPayloadVariant(name, decoder, then) {
    return $79vie.map($79vie.andThen($79vie.string, function(str) {
        if (!str.includes(name)) return $79vie.fail("Not " + name + "");
        var split = str.split(name);
        var secondPart = $i7mYY.get(split, 1);
        if (secondPart === undefined) return $79vie.fail("Not " + name + "");
        var e = $79vie.decodeString(secondPart, decoder);
        if (e.TAG === /* Ok */ 0) return $79vie.succeed(e._0);
        else return $79vie.fail("Could not parse payload in " + name + "");
    }), $iv6Yc.__1(then));
}
var $e81503310f020e69$export$325185342b153af9 = {
    string: $79vie.string,
    bool: $79vie.bool,
    $$int: $79vie.$$int,
    $$float: $79vie.$$float,
    nullable: $79vie.nullable,
    array: $79vie.array,
    list: $79vie.list,
    dict: $79vie.dict,
    keyValuePairs: $79vie.keyValuePairs,
    tuple2: $79vie.tuple2,
    tuple3: $79vie.tuple3,
    tuple4: $79vie.tuple4,
    tuple5: $79vie.tuple5,
    tuple6: $79vie.tuple6,
    tuple7: $79vie.tuple7,
    tuple8: $79vie.tuple8,
    field: $79vie.field,
    at: $79vie.at,
    index: $79vie.index,
    option: $79vie.option,
    oneOf: $79vie.oneOf,
    decodeString: $79vie.decodeString,
    decodeValue: $79vie.decodeValue,
    errorToString: $79vie.errorToString,
    map: $79vie.map,
    map2: $79vie.map2,
    map3: $79vie.map3,
    map4: $79vie.map4,
    map5: $79vie.map5,
    map6: $79vie.map6,
    map7: $79vie.map7,
    map8: $79vie.map8,
    value: $79vie.value,
    $$null: $79vie.$$null,
    succeed: $79vie.succeed,
    fail: $79vie.fail,
    andMap: $79vie.andMap,
    andThen: $79vie.andThen,
    lazy_: $e81503310f020e69$var$lazy_,
    $$default: $e81503310f020e69$var$$$default,
    fieldWithDefault: $e81503310f020e69$var$fieldWithDefault,
    exactString: $e81503310f020e69$var$exactString,
    exactStringVariant: $e81503310f020e69$var$exactStringVariant,
    exactVariantChoice: $e81503310f020e69$var$exactVariantChoice,
    simpleVariant: $e81503310f020e69$var$simpleVariant$1,
    deccoVariantWithPayload: $e81503310f020e69$var$deccoVariantWithPayload$1,
    stringifiedPayloadVariant: $e81503310f020e69$var$stringifiedPayloadVariant
};
 /* Json__Decode Not a pure module */ 
});



parcelRegister("kJhYp", function(module, exports) {

$parcel$export(module.exports, "empty", function () { return $f175f3bac0cfdc8e$export$6e22c362a0406a2c; });
$parcel$export(module.exports, "getStatesByNamespace", function () { return $f175f3bac0cfdc8e$export$2d42810f93829863; });
$parcel$export(module.exports, "setLocalCallbacksByNamespace", function () { return $f175f3bac0cfdc8e$export$43b342c2469019c6; });
$parcel$export(module.exports, "fromUrl", function () { return $f175f3bac0cfdc8e$export$8344cc6f9c959d9b; });
$parcel$export(module.exports, "getCurrentPermalink", function () { return $f175f3bac0cfdc8e$export$fb4a3cb44569e9cb; });
$parcel$export(module.exports, "toBaseUrl", function () { return $f175f3bac0cfdc8e$export$b9eeeb253b0e913a; });
$parcel$export(module.exports, "decodePostMessageData", function () { return $f175f3bac0cfdc8e$export$6db0585e40b24b51; });
$parcel$export(module.exports, "toQueryString", function () { return $f175f3bac0cfdc8e$export$249cc09c933c4d7a; });
$parcel$export(module.exports, "sanitizeLocation", function () { return $f175f3bac0cfdc8e$export$6283f5953ff9dfce; });
$parcel$export(module.exports, "goTo", function () { return $f175f3bac0cfdc8e$export$95e8d77caafa3e06; });
$parcel$export(module.exports, "use", function () { return $f175f3bac0cfdc8e$export$1f96ae73734a86cc; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $d3YYW = parcelRequire("d3YYW");

var $7bjme = parcelRequire("7bjme");

var $oO3sB = parcelRequire("oO3sB");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $79vie = parcelRequire("79vie");

var $2U6UT = parcelRequire("2U6UT");

var $bygWp = parcelRequire("bygWp");

var $h6rW7 = parcelRequire("h6rW7");

var $gO2mJ = parcelRequire("gO2mJ");

var $hylFb = parcelRequire("hylFb");

var $efwy1 = parcelRequire("efwy1");

var $9hB74 = parcelRequire("9hB74");
function $f175f3bac0cfdc8e$export$dd44f18ab656f3bb(quickViewOpt, quickNav, param) {
    var quickView = quickViewOpt !== undefined ? quickViewOpt : $9hB74.empty;
    return {
        quickView: quickView,
        quickNav: quickNav
    };
}
var $f175f3bac0cfdc8e$var$quickView = $9hB74.empty;
var $f175f3bac0cfdc8e$export$6e22c362a0406a2c = {
    quickView: $f175f3bac0cfdc8e$var$quickView,
    quickNav: undefined
};
var $f175f3bac0cfdc8e$var$emptyStates_localCallbacks = [];
var $f175f3bac0cfdc8e$export$e42d6bead5896355 = {
    current: $f175f3bac0cfdc8e$export$6e22c362a0406a2c,
    previous: undefined,
    localCallbacks: $f175f3bac0cfdc8e$var$emptyStates_localCallbacks,
    historyBackExecuted: false,
    initialUrl: undefined,
    urlTransformer: undefined,
    popstateHandled: false,
    didPushState: false
};
var $f175f3bac0cfdc8e$export$56ebd555c379811b = {
    contents: []
};
var $f175f3bac0cfdc8e$export$941cc14f96bce2f9 = $2whNH.getWithDefault(window.makerLocationGlobalState, {});
window.makerLocationGlobalState = $loT9g.some($f175f3bac0cfdc8e$export$941cc14f96bce2f9);
function $f175f3bac0cfdc8e$export$2d42810f93829863(namespace) {
    return $2whNH.getWithDefault($h6rW7.map(namespace, function(ns) {
        return $d3YYW.get($f175f3bac0cfdc8e$export$941cc14f96bce2f9, ns);
    }), $f175f3bac0cfdc8e$export$e42d6bead5896355);
}
function $f175f3bac0cfdc8e$export$80897a7cab7c2b74(namespace, updatedState) {
    $h6rW7.forEach(namespace, function(ns) {
        $f175f3bac0cfdc8e$export$941cc14f96bce2f9[ns] = updatedState;
    });
}
function $f175f3bac0cfdc8e$export$23b995f3cdc4794a(namespace, updatedCurrent) {
    var init = $f175f3bac0cfdc8e$export$2d42810f93829863(namespace);
    $f175f3bac0cfdc8e$export$80897a7cab7c2b74(namespace, {
        current: updatedCurrent,
        previous: init.previous,
        localCallbacks: init.localCallbacks,
        historyBackExecuted: init.historyBackExecuted,
        initialUrl: init.initialUrl,
        urlTransformer: init.urlTransformer,
        popstateHandled: init.popstateHandled,
        didPushState: init.didPushState
    });
}
function $f175f3bac0cfdc8e$export$2153f4652e4b7d9d(namespace, updatedPrevious) {
    var init = $f175f3bac0cfdc8e$export$2d42810f93829863(namespace);
    $f175f3bac0cfdc8e$export$80897a7cab7c2b74(namespace, {
        current: init.current,
        previous: updatedPrevious,
        localCallbacks: init.localCallbacks,
        historyBackExecuted: init.historyBackExecuted,
        initialUrl: init.initialUrl,
        urlTransformer: init.urlTransformer,
        popstateHandled: init.popstateHandled,
        didPushState: init.didPushState
    });
}
function $f175f3bac0cfdc8e$export$8851740e53f84569(namespace, updatedHistoryBackExecuted) {
    var init = $f175f3bac0cfdc8e$export$2d42810f93829863(namespace);
    $f175f3bac0cfdc8e$export$80897a7cab7c2b74(namespace, {
        current: init.current,
        previous: init.previous,
        localCallbacks: init.localCallbacks,
        historyBackExecuted: updatedHistoryBackExecuted,
        initialUrl: init.initialUrl,
        urlTransformer: init.urlTransformer,
        popstateHandled: init.popstateHandled,
        didPushState: init.didPushState
    });
}
function $f175f3bac0cfdc8e$export$43b342c2469019c6(namespace, updatedCallbacks) {
    var init = $f175f3bac0cfdc8e$export$2d42810f93829863(namespace);
    $f175f3bac0cfdc8e$export$80897a7cab7c2b74(namespace, {
        current: init.current,
        previous: init.previous,
        localCallbacks: updatedCallbacks,
        historyBackExecuted: init.historyBackExecuted,
        initialUrl: init.initialUrl,
        urlTransformer: init.urlTransformer,
        popstateHandled: init.popstateHandled,
        didPushState: init.didPushState
    });
}
function $f175f3bac0cfdc8e$export$4e3ee7a4ada28f37(namespace, updatedInitialUrl) {
    var init = $f175f3bac0cfdc8e$export$2d42810f93829863(namespace);
    $f175f3bac0cfdc8e$export$80897a7cab7c2b74(namespace, {
        current: init.current,
        previous: init.previous,
        localCallbacks: init.localCallbacks,
        historyBackExecuted: init.historyBackExecuted,
        initialUrl: updatedInitialUrl,
        urlTransformer: init.urlTransformer,
        popstateHandled: init.popstateHandled,
        didPushState: init.didPushState
    });
}
function $f175f3bac0cfdc8e$export$b83916b9e08e5bda(namespace, updatedDidPushState) {
    var init = $f175f3bac0cfdc8e$export$2d42810f93829863(namespace);
    $f175f3bac0cfdc8e$export$80897a7cab7c2b74(namespace, {
        current: init.current,
        previous: init.previous,
        localCallbacks: init.localCallbacks,
        historyBackExecuted: init.historyBackExecuted,
        initialUrl: init.initialUrl,
        urlTransformer: init.urlTransformer,
        popstateHandled: init.popstateHandled,
        didPushState: updatedDidPushState
    });
}
function $f175f3bac0cfdc8e$export$19e846b3002e97fc(namespace, updatedUrlTransformer) {
    var init = $f175f3bac0cfdc8e$export$2d42810f93829863(namespace);
    $f175f3bac0cfdc8e$export$80897a7cab7c2b74(namespace, {
        current: init.current,
        previous: init.previous,
        localCallbacks: init.localCallbacks,
        historyBackExecuted: init.historyBackExecuted,
        initialUrl: init.initialUrl,
        urlTransformer: updatedUrlTransformer,
        popstateHandled: init.popstateHandled,
        didPushState: init.didPushState
    });
}
function $f175f3bac0cfdc8e$export$8e77936ce3a6428d(namespace, updatedPopstateHandled) {
    var init = $f175f3bac0cfdc8e$export$2d42810f93829863(namespace);
    $f175f3bac0cfdc8e$export$80897a7cab7c2b74(namespace, {
        current: init.current,
        previous: init.previous,
        localCallbacks: init.localCallbacks,
        historyBackExecuted: init.historyBackExecuted,
        initialUrl: init.initialUrl,
        urlTransformer: init.urlTransformer,
        popstateHandled: updatedPopstateHandled,
        didPushState: init.didPushState
    });
}
function $f175f3bac0cfdc8e$export$27ed1c0a853be7b5($$location) {
    var merge = [
        $d3YYW.entries($9hB74.toDict($$location.quickView)),
        $2whNH.mapWithDefault($2whNH.map($$location.quickNav, $hylFb.toDict), [], $d3YYW.entries)
    ];
    return $d3YYW.fromArray($i7mYY.concatMany(merge));
}
function $f175f3bac0cfdc8e$export$697d07bbc1cd003b(dict) {
    return {
        quickView: $9hB74.fromDict(dict),
        quickNav: $hylFb.fromDict(dict)
    };
}
function $f175f3bac0cfdc8e$export$8344cc6f9c959d9b(namespace, url) {
    return $f175f3bac0cfdc8e$export$697d07bbc1cd003b($h6rW7.getDictByNamespace($d3YYW.fromArray(Array.from(new URL(url).searchParams.entries())), namespace));
}
function $f175f3bac0cfdc8e$export$cc35ddcd67deb479(namespace, $$location) {
    var originalBaseUrl = $2whNH.getWithDefault($f175f3bac0cfdc8e$export$2d42810f93829863(namespace).initialUrl, new URL($2U6UT.getUrl(undefined)));
    var urlTransformer = $f175f3bac0cfdc8e$export$2d42810f93829863(namespace).urlTransformer;
    var url = $2whNH.getWithDefault($2whNH.flatMap(urlTransformer, function(fn) {
        return $iv6Yc._2(fn, $$location, originalBaseUrl);
    }), originalBaseUrl);
    var params = url.searchParams;
    $i7mYY.forEach($d3YYW.entries($f175f3bac0cfdc8e$export$27ed1c0a853be7b5($$location)), function(param) {
        var value = param[1];
        var key = $h6rW7.toNamespacedKey(param[0], namespace);
        if (value === "") params.delete(key);
        else params.set(key, value);
    });
    var str = params.toString();
    url.search = str;
    return url.toString();
}
var $f175f3bac0cfdc8e$export$40cb1fa3871d285b = $f175f3bac0cfdc8e$export$cc35ddcd67deb479;
function $f175f3bac0cfdc8e$export$fb4a3cb44569e9cb(namespace, param) {
    return $f175f3bac0cfdc8e$export$cc35ddcd67deb479(namespace, $f175f3bac0cfdc8e$export$2d42810f93829863(namespace).current);
}
function $f175f3bac0cfdc8e$export$b9eeeb253b0e913a(namespace, url) {
    var str = $i7mYY.map(Object.keys($f175f3bac0cfdc8e$export$27ed1c0a853be7b5($f175f3bac0cfdc8e$export$dd44f18ab656f3bb($9hB74.empty, $hylFb.empty, undefined))), function(key) {
        return $2whNH.mapWithDefault(namespace, key, function(namespace) {
            return $h6rW7.toNamespacedKey(key, $loT9g.some(namespace));
        });
    }).join("|");
    var paramsToDelete = new RegExp("^(" + str + ")");
    return $bygWp.deleteParamWithRegex(url, paramsToDelete);
}
function $f175f3bac0cfdc8e$export$19bcc900ba6cb7ac(namespace, param) {
    return $f175f3bac0cfdc8e$export$b9eeeb253b0e913a(namespace, $2whNH.mapWithDefault($f175f3bac0cfdc8e$export$2d42810f93829863(namespace).initialUrl, window.location.href, function(prim) {
        return prim.href;
    }));
}
var $f175f3bac0cfdc8e$export$882d6efd8e16e97a = function eventData(event) {
    var data = event.data;
    if (typeof data === "string") return data;
    return undefined;
};
var $f175f3bac0cfdc8e$export$a9b0330d1baa427 = function encode(input) {
    return btoa(unescape(encodeURIComponent(input)));
};
var $f175f3bac0cfdc8e$export$6db0585e40b24b51 = function decode(input) {
    return decodeURIComponent(escape(atob(input)));
};
function $f175f3bac0cfdc8e$export$249cc09c933c4d7a(namespace, $$location) {
    return $oO3sB.substr(1, $i7mYY.reduce($d3YYW.entries($f175f3bac0cfdc8e$export$27ed1c0a853be7b5($$location)), "", function(acc, param) {
        return acc + "&" + $h6rW7.toNamespacedKey(param[0], namespace) + "=" + param[1];
    }));
}
function $f175f3bac0cfdc8e$export$6283f5953ff9dfce($$location) {
    return {
        quickView: $9hB74.sanitize($$location.quickView),
        quickNav: $2whNH.mapWithDefault($$location.quickNav, $hylFb.empty, $hylFb.sanitize)
    };
}
function $f175f3bac0cfdc8e$export$41997a5f251f8aca(historyEnabledOpt, namespace, param) {
    var historyEnabled = historyEnabledOpt !== undefined ? historyEnabledOpt : true;
    var match = $2U6UT.isEmbed(undefined);
    if (match) {
        var data = JSON.stringify($d3YYW.fromArray([
            [
                "historyBack",
                true
            ]
        ]));
        var encoded = $f175f3bac0cfdc8e$export$a9b0330d1baa427(data);
        console.log([
            "Location: driveLocationPop",
            "data=",
            data,
            "encoded=",
            encoded
        ]);
        return Promise.resolve($2U6UT.postMessage("pushState", encoded));
    }
    if (historyEnabled) return $gO2mJ.back($gO2mJ.history);
    var state = $gO2mJ.state($gO2mJ.history);
    var url = $f175f3bac0cfdc8e$export$19bcc900ba6cb7ac(namespace, undefined);
    return $gO2mJ.replaceState($gO2mJ.history, state, "", url);
}
function $f175f3bac0cfdc8e$export$81b3971520bf97dc(historyEnabledOpt, namespace, $$location, replaceState) {
    var historyEnabled = historyEnabledOpt !== undefined ? historyEnabledOpt : true;
    var match = $2U6UT.isEmbed(undefined);
    if (match) {
        var url = $f175f3bac0cfdc8e$export$249cc09c933c4d7a(namespace, $$location);
        var data = $f175f3bac0cfdc8e$export$a9b0330d1baa427(JSON.stringify($d3YYW.fromArray([
            [
                "url",
                url
            ],
            [
                "replaceState",
                replaceState
            ]
        ])));
        console.log("Location: driveLocationChange");
        return Promise.resolve($2U6UT.postMessage("pushState", data));
    }
    if (historyEnabled) {
        var url$1 = $f175f3bac0cfdc8e$export$cc35ddcd67deb479(namespace, $$location);
        var state = $gO2mJ.state($gO2mJ.history);
        $f175f3bac0cfdc8e$export$b83916b9e08e5bda(namespace, true);
        if (replaceState) return $gO2mJ.replaceState($gO2mJ.history, state, "", url$1);
        else return $gO2mJ.pushState($gO2mJ.history, state, "", url$1);
    }
    var state$1 = $gO2mJ.state($gO2mJ.history);
    var url$2 = $f175f3bac0cfdc8e$export$19bcc900ba6cb7ac(namespace, undefined);
    return $gO2mJ.replaceState($gO2mJ.history, state$1, "", url$2);
}
function $f175f3bac0cfdc8e$export$30cac7b92c174c77(namespace, param) {
    $i7mYY.forEach($f175f3bac0cfdc8e$export$2d42810f93829863(namespace).localCallbacks, function(fn) {
        $iv6Yc._1(fn, undefined);
    });
}
function $f175f3bac0cfdc8e$export$77cefc892ead858e(namespace, param) {
    $i7mYY.forEach($f175f3bac0cfdc8e$export$56ebd555c379811b.contents, function(fn) {
        $iv6Yc._1(fn, namespace);
    });
}
function $f175f3bac0cfdc8e$export$1146ef0fd2030a0b(namespace, param) {
    $f175f3bac0cfdc8e$export$30cac7b92c174c77(namespace, undefined);
    $f175f3bac0cfdc8e$export$77cefc892ead858e(namespace, undefined);
}
function $f175f3bac0cfdc8e$export$aad8462122ac592b(namespace, configId) {
    var next = $f175f3bac0cfdc8e$export$8344cc6f9c959d9b(namespace, $2U6UT.getUrl(undefined));
    var isToCur = $7bjme.equal($f175f3bac0cfdc8e$export$2d42810f93829863(namespace).current, next);
    var nextConfigId = $2whNH.map(next.quickNav, function(q) {
        return q.configId;
    });
    var isSameConfigId = $7bjme.equal(configId, nextConfigId);
    if (isToCur) return;
    else if (isSameConfigId) {
        if (nextConfigId !== undefined) {
            $f175f3bac0cfdc8e$export$23b995f3cdc4794a(namespace, next);
            return $f175f3bac0cfdc8e$export$1146ef0fd2030a0b(namespace, undefined);
        } else return;
    } else if (nextConfigId !== undefined) return;
    else {
        $f175f3bac0cfdc8e$export$23b995f3cdc4794a(namespace, next);
        return $f175f3bac0cfdc8e$export$1146ef0fd2030a0b(namespace, undefined);
    }
}
function $f175f3bac0cfdc8e$export$ac34ae621e70e60c(namespace, historyEnabledOpt, replaceStateOpt, isPopStateOpt, preserveScroll, next) {
    var historyEnabled = historyEnabledOpt !== undefined ? historyEnabledOpt : true;
    var replaceState = replaceStateOpt !== undefined ? replaceStateOpt : false;
    var isPopState = isPopStateOpt !== undefined ? isPopStateOpt : false;
    var states = $f175f3bac0cfdc8e$export$2d42810f93829863(namespace);
    var current = states.current;
    var previous = states.previous;
    var didPushState = states.didPushState;
    var historyBackExecuted = states.historyBackExecuted;
    var isToCur = $7bjme.equal(next, current);
    var isToPrev = $7bjme.equal(next, previous) && didPushState;
    var replaceState$1 = historyBackExecuted ? false : replaceState;
    if (isPopState && !isToCur) $f175f3bac0cfdc8e$export$2153f4652e4b7d9d(namespace, undefined);
    else if (isToCur) ;
    else if (isToPrev && $2U6UT.supportsHistoryBack(undefined)) {
        $f175f3bac0cfdc8e$export$41997a5f251f8aca(historyEnabled, namespace, undefined);
        $f175f3bac0cfdc8e$export$8851740e53f84569(namespace, true);
    } else {
        $f175f3bac0cfdc8e$export$81b3971520bf97dc(historyEnabled, namespace, next, replaceState$1);
        $f175f3bac0cfdc8e$export$8851740e53f84569(namespace, false);
        if (!replaceState$1) $f175f3bac0cfdc8e$export$2153f4652e4b7d9d(namespace, $f175f3bac0cfdc8e$export$2d42810f93829863(namespace).current);
    }
    if (!isToCur) {
        $f175f3bac0cfdc8e$export$23b995f3cdc4794a(namespace, next);
        return $f175f3bac0cfdc8e$export$1146ef0fd2030a0b(namespace, undefined);
    }
}
function $f175f3bac0cfdc8e$export$95e8d77caafa3e06(namespace, historyEnabledOpt, quickView, quickNav, replaceStateOpt, preserveScroll, param) {
    var historyEnabled = historyEnabledOpt !== undefined ? historyEnabledOpt : true;
    var replaceState = replaceStateOpt !== undefined ? replaceStateOpt : false;
    var quickNav$1 = quickNav !== undefined || quickView === undefined ? quickNav : $f175f3bac0cfdc8e$export$8344cc6f9c959d9b(namespace, window.location.href).quickNav;
    var quickView$1 = $2whNH.getWithDefault(quickView, $9hB74.empty);
    var next = {
        quickView: quickView$1,
        quickNav: quickNav$1
    };
    $f175f3bac0cfdc8e$export$ac34ae621e70e60c(namespace, historyEnabled, replaceState, undefined, undefined, next);
}
function $f175f3bac0cfdc8e$export$6069752846db2f99(namespace, param) {
    var $$location = $f175f3bac0cfdc8e$export$8344cc6f9c959d9b(namespace, $2U6UT.getUrl(undefined));
    $f175f3bac0cfdc8e$export$ac34ae621e70e60c(namespace, undefined, undefined, true, undefined, $$location);
}
function $f175f3bac0cfdc8e$export$39ef3b304b681432(namespace, data) {
    var decoded = $2whNH.getWithDefault($2whNH.flatMap($2whNH.map($2whNH.map(data, $f175f3bac0cfdc8e$export$6db0585e40b24b51), function(__x) {
        return $79vie.decodeString(__x, $79vie.dict($79vie.string));
    }), function(result) {
        if (result.TAG === /* Ok */ 0) return $loT9g.some(result._0);
    }), {});
    var url = $d3YYW.get(decoded, "url");
    var $$location = $2whNH.getWithDefault($2whNH.map(url, function(param) {
        return $f175f3bac0cfdc8e$export$8344cc6f9c959d9b(namespace, param);
    }), $f175f3bac0cfdc8e$export$6e22c362a0406a2c);
    $f175f3bac0cfdc8e$export$ac34ae621e70e60c(namespace, undefined, undefined, true, undefined, $$location);
}
function $f175f3bac0cfdc8e$export$ca65614d7992560c(namespace, $$event) {
    var parts = $2whNH.map($f175f3bac0cfdc8e$export$882d6efd8e16e97a($$event), function(param) {
        return $oO3sB.split("-", param);
    });
    var action = $2whNH.flatMap(parts, function(parts) {
        return $i7mYY.get(parts, 0);
    });
    var data = $2whNH.flatMap(parts, function(parts) {
        return $i7mYY.get(parts, 1);
    });
    var iframeid = $2whNH.flatMap($2whNH.map(parts, $i7mYY.reverse), function(parts) {
        return $i7mYY.get(parts, 0);
    });
    if (action === undefined) return;
    switch(action){
        case "popstate":
            if (iframeid !== undefined && iframeid === "iframeid=" + window.iframeid) return $f175f3bac0cfdc8e$export$39ef3b304b681432(namespace, data);
            else return;
        case "pushState":
            if (!$2U6UT.isEmbed(undefined)) {
                setTimeout(function(param) {
                    return $f175f3bac0cfdc8e$export$6069752846db2f99(namespace, param);
                }, 42);
                return;
            } else return;
        default:
            return;
    }
}
function $f175f3bac0cfdc8e$export$aadfb65bee660f96(namespace) {
    window.removeEventListener("message", function(param) {
        return $f175f3bac0cfdc8e$export$ca65614d7992560c(namespace, param);
    });
    window.addEventListener("message", function(param) {
        return $f175f3bac0cfdc8e$export$ca65614d7992560c(namespace, param);
    });
    if (!$2U6UT.isEmbed(undefined)) {
        window.removeEventListener("popstate", function(param) {
            return $f175f3bac0cfdc8e$export$6069752846db2f99(namespace, param);
        });
        window.addEventListener("popstate", function(param) {
            return $f175f3bac0cfdc8e$export$6069752846db2f99(namespace, param);
        });
        return;
    }
}
function $f175f3bac0cfdc8e$export$b1f5225dba175928(namespace) {
    $g85JO.useEffect(function() {
        if ($f175f3bac0cfdc8e$export$2d42810f93829863(namespace).initialUrl === undefined) $f175f3bac0cfdc8e$export$4e3ee7a4ada28f37(namespace, $bygWp.maybeMakeUrl($2U6UT.getUrl(undefined)));
        var updateInitialUrl = function updateInitialUrl(calledByNamespace) {
            if ($7bjme.notequal(calledByNamespace, namespace)) return $f175f3bac0cfdc8e$export$4e3ee7a4ada28f37(namespace, $bygWp.maybeMakeUrl($2U6UT.getUrl(undefined)));
        };
        $f175f3bac0cfdc8e$export$56ebd555c379811b.contents = $i7mYY.concat($f175f3bac0cfdc8e$export$56ebd555c379811b.contents, [
            updateInitialUrl
        ]);
        return function(param) {
            $f175f3bac0cfdc8e$export$56ebd555c379811b.contents = $i7mYY.keep($f175f3bac0cfdc8e$export$56ebd555c379811b.contents, function(fn) {
                return fn !== updateInitialUrl;
            });
        };
    }, [
        namespace
    ]);
}
function $f175f3bac0cfdc8e$export$1f96ae73734a86cc(param) {
    var match = $efwy1.use(undefined);
    var urlTransformer = match.urlTransformer;
    var namespace = match.namespace;
    var match$1 = $g85JO.useState(function() {
        return $f175f3bac0cfdc8e$export$2d42810f93829863(namespace).current;
    });
    var setLocation = match$1[1];
    $g85JO.useEffect(function() {
        $iv6Yc._1(setLocation, function(param) {
            return $f175f3bac0cfdc8e$export$2d42810f93829863(namespace).current;
        });
    }, [
        namespace
    ]);
    $f175f3bac0cfdc8e$export$b1f5225dba175928(namespace);
    $g85JO.useEffect(function() {
        $f175f3bac0cfdc8e$export$19e846b3002e97fc(namespace, urlTransformer);
    }, [
        namespace,
        urlTransformer
    ]);
    $g85JO.useEffect(function() {
        var update = function update(param) {
            $iv6Yc._1(setLocation, function(param) {
                return $f175f3bac0cfdc8e$export$2d42810f93829863(namespace).current;
            });
        };
        $f175f3bac0cfdc8e$export$43b342c2469019c6(namespace, $i7mYY.concat($f175f3bac0cfdc8e$export$2d42810f93829863(namespace).localCallbacks, [
            update
        ]));
        return function(param) {
            $f175f3bac0cfdc8e$export$43b342c2469019c6(namespace, $i7mYY.keep($f175f3bac0cfdc8e$export$2d42810f93829863(namespace).localCallbacks, function(fn) {
                return fn !== update;
            }));
        };
    }, [
        namespace
    ]);
    $g85JO.useEffect(function() {
        $f175f3bac0cfdc8e$export$aadfb65bee660f96(namespace);
        if ($f175f3bac0cfdc8e$export$2d42810f93829863(namespace).popstateHandled === false) {
            $f175f3bac0cfdc8e$export$6069752846db2f99(namespace, undefined);
            $f175f3bac0cfdc8e$export$8e77936ce3a6428d(namespace, true);
        }
    }, [
        namespace
    ]);
    return match$1[0];
}
$f175f3bac0cfdc8e$export$6069752846db2f99(undefined, undefined);
 /* currentGlobalState Not a pure module */ 
});
parcelRegister("2U6UT", function(module, exports) {

$parcel$export(module.exports, "postMessage", function () { return $21d62d3bd50327f6$export$6efe264be9505de7; });
$parcel$export(module.exports, "isEmbed", function () { return $21d62d3bd50327f6$export$6a4806a2b2fc6ddd; });
$parcel$export(module.exports, "getUrl", function () { return $21d62d3bd50327f6$export$94df0e59ebebf4a7; });
$parcel$export(module.exports, "supportsHistoryBack", function () { return $21d62d3bd50327f6$export$e919434736d243df; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $e8cwi = parcelRequire("e8cwi");
function $21d62d3bd50327f6$export$6efe264be9505de7(name, data) {
    window.parent.postMessage(name + ("-" + (data + ("-iframeid=" + window.iframeid))), "*");
}
function $21d62d3bd50327f6$export$6a4806a2b2fc6ddd(param) {
    return $2whNH.isSome(window.parentUrl == null ? undefined : $loT9g.some(window.parentUrl));
}
function $21d62d3bd50327f6$export$94df0e59ebebf4a7(param) {
    return $2whNH.getWithDefault(window.parentUrl == null ? undefined : $loT9g.some(window.parentUrl), window.location.href);
}
function $21d62d3bd50327f6$export$70d1bf7729efff40(param) {
    return $2whNH.getWithDefault($2whNH.map($e8cwi.asHtmlDocument(document), function(prim) {
        return prim.title;
    }), "");
}
var $21d62d3bd50327f6$export$9ad581bdbd72e3a4 = [
    "rue21.com",
    "pratapsons.com",
    "pratapsonsglobal.com",
    "culpritunderwear.com",
    "goodearth.in",
    "whisperinghomes.com"
];
function $21d62d3bd50327f6$export$e919434736d243df(param) {
    var partial_arg = $21d62d3bd50327f6$export$94df0e59ebebf4a7(undefined);
    return !$i7mYY.some($21d62d3bd50327f6$export$9ad581bdbd72e3a4, function(param) {
        return partial_arg.includes(param);
    });
}
 /* Webapi__Dom__Document Not a pure module */ 
});
parcelRegister("e8cwi", function(module, exports) {

$parcel$export(module.exports, "asHtmlDocument", function () { return $a49b863a9a7d4917$export$c4755dad0148a1d9; });

var $loT9g = parcelRequire("loT9g");

var $amOA8 = parcelRequire("amOA8");

var $cstWc = parcelRequire("cstWc");

var $5BvP6 = parcelRequire("5BvP6");

var $5OXjM = parcelRequire("5OXjM");

var $fJCbh = parcelRequire("fJCbh");
function $a49b863a9a7d4917$export$c08352ad19c25332(T) {
    var asHtmlDocument = function asHtmlDocument(document) {
        var defaultView = document.defaultView;
        if (defaultView != null) {
            var HTMLDocument = defaultView.HTMLDocument;
            if (HTMLDocument != null && document instanceof HTMLDocument) return document;
        }
    };
    var ofNode = function ofNode(node) {
        if ($amOA8.nodeType(node) === /* Document */ 8) return $loT9g.some(node);
    };
    var compatMode = function compatMode(self) {
        return $cstWc.decodeCompatMode(self.compatMode);
    };
    var visibilityState = function visibilityState(self) {
        return $cstWc.decodeVisibilityState(self.visibilityState);
    };
    return {
        asHtmlDocument: asHtmlDocument,
        ofNode: ofNode,
        compatMode: compatMode,
        visibilityState: visibilityState
    };
}
var $a49b863a9a7d4917$var$include = $amOA8.Impl({});
$5OXjM.Impl({});
$fJCbh.Impl({});
$5BvP6.Impl({});
var $a49b863a9a7d4917$export$c4755dad0148a1d9 = function asHtmlDocument(document) {
    var defaultView = document.defaultView;
    if (defaultView != null) {
        var HTMLDocument = defaultView.HTMLDocument;
        if (HTMLDocument != null && document instanceof HTMLDocument) return document;
    }
};
function $a49b863a9a7d4917$export$b09cfa9b7e510069(node) {
    if ($amOA8.nodeType(node) === /* Document */ 8) return $loT9g.some(node);
}
function $a49b863a9a7d4917$export$995723b54eb391a5(self) {
    return $cstWc.decodeCompatMode(self.compatMode);
}
function $a49b863a9a7d4917$export$3d0d3483832deb8e(self) {
    return $cstWc.decodeVisibilityState(self.visibilityState);
}
var $a49b863a9a7d4917$export$4debbe1037afe35e = $a49b863a9a7d4917$var$include.nodeType;
 /* include Not a pure module */ 
});
parcelRegister("amOA8", function(module, exports) {

$parcel$export(module.exports, "Impl", function () { return $78c331f32a57dcbf$export$c08352ad19c25332; });
$parcel$export(module.exports, "nodeType", function () { return $78c331f32a57dcbf$export$4debbe1037afe35e; });

var $cstWc = parcelRequire("cstWc");

var $5OXjM = parcelRequire("5OXjM");
function $78c331f32a57dcbf$export$c08352ad19c25332(T) {
    var nodeType = function nodeType(self) {
        return $cstWc.decodeNodeType(self.nodeType);
    };
    return {
        nodeType: nodeType
    };
}
$5OXjM.Impl({});
function $78c331f32a57dcbf$export$4debbe1037afe35e(self) {
    return $cstWc.decodeNodeType(self.nodeType);
}
 /*  Not a pure module */ 
});
parcelRegister("cstWc", function(module, exports) {

$parcel$export(module.exports, "decodeCompatMode", function () { return $911f528f090317fc$export$4aa2174b1f9b281d; });
$parcel$export(module.exports, "encodeContentEditable", function () { return $911f528f090317fc$export$11e4dded6305aac5; });
$parcel$export(module.exports, "decodeContentEditable", function () { return $911f528f090317fc$export$33ee79228d0c88e9; });
$parcel$export(module.exports, "encodeDir", function () { return $911f528f090317fc$export$60f9589b1ae70ec4; });
$parcel$export(module.exports, "decodeDir", function () { return $911f528f090317fc$export$effab2688df43525; });
$parcel$export(module.exports, "encodeInsertPosition", function () { return $911f528f090317fc$export$b7b0561a1a2440cf; });
$parcel$export(module.exports, "decodeNodeType", function () { return $911f528f090317fc$export$5c924db342d17115; });
$parcel$export(module.exports, "decodeVisibilityState", function () { return $911f528f090317fc$export$2251030e379f19a7; });
function $911f528f090317fc$export$3c3191cdd4f03507(x) {
    return x;
}
function $911f528f090317fc$export$3f3d0079954536f4(x) {
    if (x + 1 >>> 0 > 2) return /* Unknown */ 3;
    else return x + 1 | 0;
}
function $911f528f090317fc$export$4aa2174b1f9b281d(x) {
    switch(x){
        case "BackCompat":
            return /* BackCompat */ 0;
        case "CSS1Compat":
            return /* CSS1Compat */ 1;
        default:
            return /* Unknown */ 2;
    }
}
function $911f528f090317fc$export$11e4dded6305aac5(x) {
    switch(x){
        case /* True */ 0:
            return "true";
        case /* False */ 1:
            return "false";
        case /* Inherit */ 2:
            return "inherit";
        case /* Unknown */ 3:
            return "";
    }
}
function $911f528f090317fc$export$33ee79228d0c88e9(x) {
    switch(x){
        case "false":
            return /* False */ 1;
        case "inherit":
            return /* Inherit */ 2;
        case "true":
            return /* True */ 0;
        default:
            return /* Unknown */ 3;
    }
}
function $911f528f090317fc$export$e5fbea3206fe4b3c(x) {
    if (x > 2 || x < 0) throw {
        RE_EXN_ID: "Invalid_argument",
        _1: "invalid deltaMode",
        Error: new Error()
    };
    return x;
}
function $911f528f090317fc$export$3dde7b99cba1956c(x) {
    switch(x){
        case /* On */ 0:
            return "on";
        case /* Off */ 1:
            return "off";
        case /* Unknown */ 2:
            return "";
    }
}
function $911f528f090317fc$export$65c5110e76ff3dcc(x) {
    switch(x){
        case "off":
            return /* Off */ 1;
        case "on":
            return /* On */ 0;
        default:
            return /* Unknown */ 2;
    }
}
function $911f528f090317fc$export$60f9589b1ae70ec4(x) {
    switch(x){
        case /* Ltr */ 0:
            return "ltr";
        case /* Rtl */ 1:
            return "rtl";
        case /* Unknown */ 2:
            return "";
    }
}
function $911f528f090317fc$export$effab2688df43525(x) {
    switch(x){
        case "ltr":
            return /* Ltr */ 0;
        case "rtl":
            return /* Rtl */ 1;
        default:
            return /* Unknown */ 2;
    }
}
function $911f528f090317fc$var$decode(x) {
    if (x > 3 || x < 0) return /* Unknown */ 4;
    else return x;
}
var $911f528f090317fc$export$26762ca2f68a3191 = {
    decode: $911f528f090317fc$var$decode
};
function $911f528f090317fc$export$24374a5985756f50(x) {
    return x + 1 | 0;
}
function $911f528f090317fc$export$b7b0561a1a2440cf(x) {
    switch(x){
        case /* BeforeBegin */ 0:
            return "beforebegin";
        case /* AfterBegin */ 1:
            return "afterbegin";
        case /* BeforeEnd */ 2:
            return "beforeend";
        case /* AfterEnd */ 3:
            return "afterend";
    }
}
function $911f528f090317fc$export$509e0dc687c1381a(x) {
    switch(x){
        case /* Alt */ 0:
            return "Alt";
        case /* AltGraph */ 1:
            return "AltGraph";
        case /* CapsLock */ 2:
            return "CapsLock";
        case /* Control */ 3:
            return "Control";
        case /* Fn */ 4:
            return "Fn";
        case /* FnLock */ 5:
            return "FnLock";
        case /* Hyper */ 6:
            return "Hyper";
        case /* Meta */ 7:
            return "Meta";
        case /* NumLock */ 8:
            return "NumLock";
        case /* ScrollLock */ 9:
            return "ScrollLock";
        case /* Shift */ 10:
            return "Shift";
        case /* Super */ 11:
            return "Super";
        case /* Symbol */ 12:
            return "Symbol";
        case /* SymbolLock */ 13:
            return "SymbolLock";
    }
}
function $911f528f090317fc$export$5c924db342d17115(x) {
    if (x > 12 || x < 1) return /* Unknown */ 12;
    else return x - 1 | 0;
}
function $911f528f090317fc$export$64d4f5c3bdeaf4d(x) {
    switch(x){
        case "mouse":
            return /* Mouse */ 0;
        case "pen":
            return /* Pen */ 1;
        case "touch|":
            return /* Touch */ 2;
        default:
            return /* Unknown */ 3;
    }
}
function $911f528f090317fc$export$db630ac806153a82(x) {
    switch(x){
        case "complete":
            return /* Complete */ 2;
        case "interactive":
            return /* Interactive */ 1;
        case "loading":
            return /* Loading */ 0;
        default:
            return /* Unknown */ 3;
    }
}
function $911f528f090317fc$export$98c66c6ec1c08548(x) {
    switch(x){
        case "closed":
            return /* Closed */ 1;
        case "open":
            return /* Open */ 0;
        default:
            throw {
                RE_EXN_ID: "Invalid_argument",
                _1: "Unknown shadowRootMode",
                Error: new Error()
            };
    }
}
function $911f528f090317fc$export$2251030e379f19a7(x) {
    switch(x){
        case "hidden":
            return /* Hidden */ 1;
        case "prerender":
            return /* Prerender */ 2;
        case "unloaded":
            return /* Unloaded */ 3;
        case "visible":
            return /* Visible */ 0;
        default:
            return /* Unknown */ 4;
    }
}
function $911f528f090317fc$var$many(x) {
    if (x) return x.hd | $911f528f090317fc$var$many(x.tl);
    else return 0;
}
var $911f528f090317fc$export$d07c789697b72851 = {
    _All: -1,
    _Element: 1,
    _Attribute: 2,
    _Text: 4,
    _CDATASection: 8,
    _EntityReference: 16,
    _Entity: 32,
    _ProcessingInstruction: 64,
    _Comment: 128,
    _Document: 256,
    _DocumentType: 512,
    _DocumentFragment: 1024,
    _Notation: 2048,
    many: $911f528f090317fc$var$many
};
 /* No side effect */ 
});

parcelRegister("5OXjM", function(module, exports) {

$parcel$export(module.exports, "Impl", function () { return $43cfa29c5061abc3$export$c08352ad19c25332; });
function $43cfa29c5061abc3$export$c08352ad19c25332(T) {
    return {};
}
 /* No side effect */ 
});


parcelRegister("5BvP6", function(module, exports) {

$parcel$export(module.exports, "Impl", function () { return $414917e15bba6a6f$export$c08352ad19c25332; });
function $414917e15bba6a6f$export$c08352ad19c25332(T) {
    return {};
}
 /* No side effect */ 
});

parcelRegister("fJCbh", function(module, exports) {

$parcel$export(module.exports, "Impl", function () { return $b748acef06e75a8a$export$c08352ad19c25332; });
function $b748acef06e75a8a$export$c08352ad19c25332(T) {
    return {};
}
 /* No side effect */ 
});



parcelRegister("h6rW7", function(module, exports) {

$parcel$export(module.exports, "toString", function () { return $c738aacb6830be55$export$f84e8e69fd4488a5; });
$parcel$export(module.exports, "fromString", function () { return $c738aacb6830be55$export$3004f64547af360e; });
$parcel$export(module.exports, "empty", function () { return $c738aacb6830be55$export$6e22c362a0406a2c; });
$parcel$export(module.exports, "toNamespacedKey", function () { return $c738aacb6830be55$export$9886bab0176e1b3e; });
$parcel$export(module.exports, "getDictByNamespace", function () { return $c738aacb6830be55$export$2ddb74fbdf359c07; });
$parcel$export(module.exports, "map", function () { return $c738aacb6830be55$export$871de8747c9eaa88; });
$parcel$export(module.exports, "forEach", function () { return $c738aacb6830be55$export$4b80e395e36b5a56; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $d3YYW = parcelRequire("d3YYW");

var $7bjme = parcelRequire("7bjme");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");
function $c738aacb6830be55$export$327e003d2047f30a($star) {
    var _$toString = function toString(key) {
        return key;
    };
    var _$fromString = function fromString(key) {
        return key;
    };
    return {
        toString: _$toString,
        fromString: _$fromString
    };
}
function $c738aacb6830be55$export$f84e8e69fd4488a5(key) {
    return key;
}
function $c738aacb6830be55$export$3004f64547af360e(key) {
    return key;
}
var $c738aacb6830be55$export$971d5caa766a69d7 = {
    toString: $c738aacb6830be55$export$f84e8e69fd4488a5,
    fromString: $c738aacb6830be55$export$3004f64547af360e
};
var $c738aacb6830be55$export$c889f2fcc19dbf12 = "__";
var $c738aacb6830be55$export$6e22c362a0406a2c = "nonamespace";
function $c738aacb6830be55$export$9886bab0176e1b3e(nonNamespacedKey, namespace) {
    var namespace$1 = $2whNH.map(namespace, $c738aacb6830be55$export$f84e8e69fd4488a5);
    if (namespace$1 !== undefined && namespace$1 !== "") return nonNamespacedKey + $c738aacb6830be55$export$c889f2fcc19dbf12 + namespace$1;
    else return nonNamespacedKey;
}
function $c738aacb6830be55$export$ac0413943b7bd356(namespacedKey) {
    var split = namespacedKey.split($c738aacb6830be55$export$c889f2fcc19dbf12);
    var nonNamespacedKey = $2whNH.getWithDefault($i7mYY.get(split, 0), namespacedKey);
    var namespace = $2whNH.map($i7mYY.get(split, 1), $c738aacb6830be55$export$3004f64547af360e);
    return [
        nonNamespacedKey,
        namespace
    ];
}
function $c738aacb6830be55$export$2ddb74fbdf359c07(dict, namespace) {
    return $d3YYW.fromArray($i7mYY.keepMap($i7mYY.map($d3YYW.entries(dict), function(param) {
        return [
            $c738aacb6830be55$export$ac0413943b7bd356(param[0]),
            param[1]
        ];
    }), function(param) {
        var match = param[0];
        if ($7bjme.equal(match[1], namespace)) return [
            match[0],
            param[1]
        ];
    }));
}
function $c738aacb6830be55$export$871de8747c9eaa88(namespace, fn) {
    return $iv6Yc._1(fn, $2whNH.getWithDefault(namespace, $c738aacb6830be55$export$6e22c362a0406a2c));
}
function $c738aacb6830be55$export$4b80e395e36b5a56(namespace, fn) {
    $iv6Yc._1(fn, $2whNH.getWithDefault(namespace, $c738aacb6830be55$export$6e22c362a0406a2c));
}
 /* No side effect */ 
});

parcelRegister("gO2mJ", function(module, exports) {

$parcel$export(module.exports, "state", function () { return $c3c32699874043b4$export$ca000e230c0caa3e; });
$parcel$export(module.exports, "history", function () { return $c3c32699874043b4$export$55abd4691b317664; });
$parcel$export(module.exports, "pushState", function () { return $c3c32699874043b4$export$ba0fd82af7b4fe6e; });
$parcel$export(module.exports, "replaceState", function () { return $c3c32699874043b4$export$e68dd4d2e7e08394; });
$parcel$export(module.exports, "back", function () { return $c3c32699874043b4$export$7c341cb16fc91138; });
$parcel$export(module.exports, "setScrollRestoration", function () { return $c3c32699874043b4$export$b71790aeac1abc4b; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $75ZqT = parcelRequire("75ZqT");

var $i7mYY = parcelRequire("i7mYY");

var $bBMv4 = parcelRequire("bBMv4");

var $4QdUt = parcelRequire("4QdUt");
function $c3c32699874043b4$export$ca000e230c0caa3e(prim) {
    return prim.state;
}
var $c3c32699874043b4$export$55abd4691b317664 = window.history;
function $c3c32699874043b4$export$b33b857ad1d9900e(exn) {
    var messagePrefix = "Error in History API";
    var jsExn = $75ZqT.$$Error.fromRescript(exn);
    var rootCause = $75ZqT.$$Error.getRootCause(jsExn);
    var match = rootCause.message;
    var match$1 = rootCause.name;
    var rootCauseMessage = match !== undefined ? match$1 !== undefined ? "RC: " + match$1 + " " + match + "" : "RC: " + match + "" : match$1 !== undefined ? "RC: " + match$1 + "" : undefined;
    var message = $i7mYY.keepMap([
        messagePrefix,
        rootCauseMessage
    ], function(a) {
        return a;
    }).join(", ");
    console.error(messagePrefix, jsExn);
    return $4QdUt.jsError2($75ZqT.$$Error.fromStringWithCause(message, rootCause), message);
}
function $c3c32699874043b4$export$ba0fd82af7b4fe6e(history, state, unused, url) {
    try {
        return Promise.resolve((history.pushState(state, unused, url), undefined));
    } catch (raw_e) {
        return $c3c32699874043b4$export$b33b857ad1d9900e($bBMv4.internalToOCamlException(raw_e));
    }
}
function $c3c32699874043b4$export$e68dd4d2e7e08394(history, state, unused, url) {
    try {
        return Promise.resolve((history.replaceState(state, unused, url), undefined));
    } catch (raw_e) {
        return $c3c32699874043b4$export$b33b857ad1d9900e($bBMv4.internalToOCamlException(raw_e));
    }
}
function $c3c32699874043b4$export$7c341cb16fc91138(history) {
    try {
        return Promise.resolve((history.back(), undefined));
    } catch (raw_e) {
        return $c3c32699874043b4$export$b33b857ad1d9900e($bBMv4.internalToOCamlException(raw_e));
    }
}
function $c3c32699874043b4$export$b71790aeac1abc4b(next) {
    try {
        $c3c32699874043b4$export$55abd4691b317664.scrollRestoration = next;
        return;
    } catch (raw_e) {
        var e = $bBMv4.internalToOCamlException(raw_e);
        $c3c32699874043b4$export$b33b857ad1d9900e(e);
        return;
    }
}
 /* history Not a pure module */ 
});

parcelRegister("hylFb", function(module, exports) {

$parcel$export(module.exports, "empty", function () { return $cc766a7f9999f1c5$export$6e22c362a0406a2c; });
$parcel$export(module.exports, "fromDict", function () { return $cc766a7f9999f1c5$export$697d07bbc1cd003b; });
$parcel$export(module.exports, "toDict", function () { return $cc766a7f9999f1c5$export$27ed1c0a853be7b5; });
$parcel$export(module.exports, "toString", function () { return $cc766a7f9999f1c5$export$f84e8e69fd4488a5; });
$parcel$export(module.exports, "sanitize", function () { return $cc766a7f9999f1c5$export$83d2e9e3e4ee39ed; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $d3YYW = parcelRequire("d3YYW");

var $oO3sB = parcelRequire("oO3sB");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $kiuDo = parcelRequire("kiuDo");

var $hxhfd = parcelRequire("hxhfd");

var $fEMeF = parcelRequire("fEMeF");

var $04dLg = parcelRequire("04dLg");
var $cc766a7f9999f1c5$var$prefix = "category";
function $cc766a7f9999f1c5$var$toString(value) {
    return $i7mYY.keepMap([
        $cc766a7f9999f1c5$var$prefix,
        value.categoryId,
        value.sourceNodeId
    ], function(a) {
        return a;
    }).join(":");
}
function $cc766a7f9999f1c5$var$fromString(value) {
    var match = value.split(":");
    var len = match.length;
    if (len !== 2) {
        if (len !== 3) return;
        var p = match[0];
        var categoryId = match[1];
        var sourceNodeId = match[2];
        if (p === $cc766a7f9999f1c5$var$prefix) return {
            categoryId: categoryId,
            sourceNodeId: sourceNodeId
        };
        else return;
    }
    var p$1 = match[0];
    var categoryId$1 = match[1];
    if (p$1 === $cc766a7f9999f1c5$var$prefix) return {
        categoryId: categoryId$1,
        sourceNodeId: undefined
    };
}
var $cc766a7f9999f1c5$export$99a2eb47b6c875e2 = {
    prefix: $cc766a7f9999f1c5$var$prefix,
    toString: $cc766a7f9999f1c5$var$toString,
    fromString: $cc766a7f9999f1c5$var$fromString
};
function $cc766a7f9999f1c5$export$513f42987b822fd7(value) {
    switch(value){
        case "cart":
            return /* StoreCart */ 3;
        case "favorites":
            return /* Favorites */ 1;
        case "history":
            return /* History */ 2;
        case "plp":
            return /* PLP */ 0;
        default:
            if (value.startsWith($cc766a7f9999f1c5$var$prefix + ":")) return $2whNH.flatMap($cc766a7f9999f1c5$var$fromString(value), function(data) {
                return /* StoreCategory */ {
                    _0: data
                };
            });
            else return;
    }
}
function $cc766a7f9999f1c5$export$dd44f18ab656f3bb(configId, tabId, categoryId, productCategoryId, productId, relatedProductsId, variantId, photoZoom, view, filters, previewMode, devMode, sort, param) {
    return {
        configId: configId,
        tabId: tabId,
        categoryId: categoryId,
        productCategoryId: productCategoryId,
        productId: productId,
        relatedProductsId: relatedProductsId,
        variantId: variantId,
        photoZoom: photoZoom,
        previewMode: previewMode,
        devMode: devMode,
        filters: filters,
        sort: sort,
        view: view
    };
}
var $cc766a7f9999f1c5$export$6e22c362a0406a2c = $cc766a7f9999f1c5$export$dd44f18ab656f3bb("", undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
function $cc766a7f9999f1c5$export$b42e70ddca33ff5b(value) {
    return $2whNH.flatMap(value, function(value) {
        if (value === "") return;
        else return value;
    });
}
function $cc766a7f9999f1c5$export$697d07bbc1cd003b(params) {
    return $2whNH.map($d3YYW.get(params, "QNConfigId"), function(configId) {
        return {
            configId: configId,
            tabId: $cc766a7f9999f1c5$export$b42e70ddca33ff5b($d3YYW.get(params, "QNTabId")),
            categoryId: $cc766a7f9999f1c5$export$b42e70ddca33ff5b($d3YYW.get(params, "QNCategoryId")),
            productCategoryId: $cc766a7f9999f1c5$export$b42e70ddca33ff5b($d3YYW.get(params, "QNProductCategoryId")),
            productId: $cc766a7f9999f1c5$export$b42e70ddca33ff5b($d3YYW.get(params, "QNProductId")),
            relatedProductsId: $cc766a7f9999f1c5$export$b42e70ddca33ff5b($d3YYW.get(params, "QNRelatedProductsId")),
            variantId: $cc766a7f9999f1c5$export$b42e70ddca33ff5b($d3YYW.get(params, "QNVariantId")),
            photoZoom: $2whNH.flatMap($d3YYW.get(params, "QNPhotoZoom"), function(value) {
                var isInt = $2whNH.isSome($oO3sB.match_(/^([0-9]+)$/i, value));
                if (isInt) return $kiuDo.int_of_string(value);
            }),
            previewMode: $2whNH.flatMap($d3YYW.get(params, "QNPreviewMode"), function(value) {
                switch(value){
                    case "HEAD":
                        return /* PreviewHead */ 0;
                    case "LIVE":
                        return /* PreviewLive */ 1;
                    default:
                        var match = value.match(/^T([0-9]+)$/);
                        if (match === null) return;
                        if (match.length !== 2) return;
                        var timestamp = match[1];
                        if (timestamp !== undefined) return /* PreviewBackup */ {
                            _0: Number(timestamp)
                        };
                        else return;
                }
            }),
            devMode: $2whNH.map($d3YYW.get(params, "QNDevMode"), $hxhfd.getApiEnv),
            filters: $2whNH.flatMap($d3YYW.get(params, "QNFilters"), $fEMeF.safeDecode),
            sort: $2whNH.map($cc766a7f9999f1c5$export$b42e70ddca33ff5b($d3YYW.get(params, "QNSort")), function(value) {
                return $iv6Yc._1($04dLg.ProductSortOrder.fromString, value);
            }),
            view: $2whNH.flatMap($d3YYW.get(params, "QNView"), $cc766a7f9999f1c5$export$513f42987b822fd7)
        };
    });
}
function $cc766a7f9999f1c5$export$27ed1c0a853be7b5(state) {
    var match = state.previewMode;
    var match$1 = state.devMode;
    var tmp;
    if (match$1 !== undefined) {
        if (typeof match$1 === "number") switch(match$1){
            case /* Staging */ 0:
                tmp = "staging";
                break;
            case /* Production */ 1:
                tmp = "prod";
                break;
            case /* Local */ 2:
                tmp = "local";
                break;
        }
        else tmp = match$1._0;
    } else tmp = "";
    var match$2 = state.view;
    var tmp$1;
    if (match$2 !== undefined) {
        if (typeof match$2 === "number") switch(match$2){
            case /* PLP */ 0:
                tmp$1 = "plp";
                break;
            case /* Favorites */ 1:
                tmp$1 = "favorites";
                break;
            case /* History */ 2:
                tmp$1 = "history";
                break;
            case /* StoreCart */ 3:
                tmp$1 = "cart";
                break;
        }
        else tmp$1 = $cc766a7f9999f1c5$var$toString(match$2._0);
    } else tmp$1 = "";
    return $d3YYW.fromArray([
        [
            "QNConfigId",
            state.configId
        ],
        [
            "QNTabId",
            $2whNH.getWithDefault(state.tabId, "")
        ],
        [
            "QNCategoryId",
            $2whNH.getWithDefault(state.categoryId, "")
        ],
        [
            "QNProductCategoryId",
            $2whNH.getWithDefault(state.productCategoryId, "")
        ],
        [
            "QNProductId",
            $2whNH.getWithDefault(state.productId, "")
        ],
        [
            "QNVariantId",
            $2whNH.getWithDefault(state.variantId, "")
        ],
        [
            "QNRelatedProductsId",
            $2whNH.getWithDefault(state.relatedProductsId, "")
        ],
        [
            "QNPhotoZoom",
            $2whNH.mapWithDefault(state.photoZoom, "", function(prim) {
                return String(prim);
            })
        ],
        [
            "QNPreviewMode",
            match !== undefined ? typeof match === "number" ? match !== 0 ? "LIVE" : "HEAD" : "T" + match._0.toString() : ""
        ],
        [
            "QNDevMode",
            tmp
        ],
        [
            "QNView",
            tmp$1
        ],
        [
            "QNFilters",
            $2whNH.getWithDefault($2whNH.map(state.filters, $fEMeF.toString), "")
        ],
        [
            "QNSort",
            $2whNH.getWithDefault($2whNH.map(state.sort, function(value) {
                return $04dLg.ProductSortOrder.toString(value);
            }), "")
        ]
    ]);
}
function $cc766a7f9999f1c5$export$f84e8e69fd4488a5(state) {
    var match = state.previewMode;
    var match$1 = state.devMode;
    var tmp;
    if (match$1 !== undefined) {
        if (typeof match$1 === "number") switch(match$1){
            case /* Staging */ 0:
                tmp = "staging";
                break;
            case /* Production */ 1:
                tmp = "prod";
                break;
            case /* Local */ 2:
                tmp = "local";
                break;
        }
        else tmp = match$1._0;
    } else tmp = "";
    var match$2 = state.view;
    var tmp$1;
    if (match$2 !== undefined) {
        if (typeof match$2 === "number") switch(match$2){
            case /* PLP */ 0:
                tmp$1 = "plp";
                break;
            case /* Favorites */ 1:
                tmp$1 = "favorites";
                break;
            case /* History */ 2:
                tmp$1 = "history";
                break;
            case /* StoreCart */ 3:
                tmp$1 = "cart";
                break;
        }
        else tmp$1 = $cc766a7f9999f1c5$var$toString(match$2._0);
    } else tmp$1 = "";
    return [
        "QNConfigId" + state.configId,
        "QNTabId" + $2whNH.getWithDefault(state.tabId, ""),
        "QNCategoryId" + $2whNH.getWithDefault(state.categoryId, ""),
        "QNProductCategoryId" + $2whNH.getWithDefault(state.productCategoryId, ""),
        "QNProductId" + $2whNH.getWithDefault(state.productId, ""),
        "QNVariantId" + $2whNH.getWithDefault(state.variantId, ""),
        "QNRelatedProductsId" + $2whNH.getWithDefault(state.relatedProductsId, ""),
        "QNPhotoZoom" + $2whNH.mapWithDefault(state.photoZoom, "", function(prim) {
            return String(prim);
        }),
        "QNPreviewMode" + (match !== undefined ? typeof match === "number" ? match !== 0 ? "LIVE" : "HEAD" : "T" + match._0.toString() : ""),
        "QNDevMode" + tmp,
        "QNView" + tmp$1,
        "QNFilters" + $2whNH.getWithDefault($2whNH.map(state.filters, $fEMeF.toString), ""),
        "QNSort" + $2whNH.getWithDefault($2whNH.map(state.sort, function(value) {
            return $04dLg.ProductSortOrder.toString(value);
        }), "")
    ].join("|");
}
function $cc766a7f9999f1c5$export$83d2e9e3e4ee39ed($$location) {
    return {
        configId: "",
        tabId: undefined,
        categoryId: $$location.categoryId,
        productCategoryId: $$location.productCategoryId,
        productId: $$location.productId,
        relatedProductsId: $$location.relatedProductsId,
        variantId: $$location.variantId,
        photoZoom: undefined,
        previewMode: $$location.previewMode,
        devMode: $$location.devMode,
        filters: $$location.filters,
        sort: $$location.sort,
        view: $$location.view
    };
}
 /* empty Not a pure module */ 
});
parcelRegister("04dLg", function(module, exports) {

$parcel$export(module.exports, "ProductSortOrder", function () { return $00cb0c920b5246fc$export$1fffe7771e220b3d; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $AAkl8 = parcelRequire("AAkl8");

var $kM5sF = parcelRequire("kM5sF");
function $00cb0c920b5246fc$var$toJson(sortOrder) {
    switch(sortOrder){
        case /* Default */ 0:
            return $AAkl8.array([
                "Default"
            ], $AAkl8.string);
        case /* Featured */ 1:
            return $AAkl8.array([
                "Featured"
            ], $AAkl8.string);
        case /* BestSellers */ 2:
            return $AAkl8.array([
                "BestSellers"
            ], $AAkl8.string);
        case /* Newest */ 3:
            return $AAkl8.array([
                "Newest"
            ], $AAkl8.string);
        case /* HighestPrice */ 4:
            return $AAkl8.array([
                "HighestPrice"
            ], $AAkl8.string);
        case /* LowestPrice */ 5:
            return $AAkl8.array([
                "LowestPrice"
            ], $AAkl8.string);
        case /* HighestDiscount */ 6:
            return $AAkl8.array([
                "HighestDiscount"
            ], $AAkl8.string);
    }
}
var $00cb0c920b5246fc$var$fromJson = $kM5sF.ProductSortOrder.fromJson;
var $00cb0c920b5246fc$var$all = $kM5sF.ProductSortOrder.all;
var $00cb0c920b5246fc$var$fromString = $kM5sF.ProductSortOrder.fromString;
function $00cb0c920b5246fc$var$toString(sort) {
    switch(sort){
        case /* Default */ 0:
            return "default";
        case /* Featured */ 1:
            return "featured";
        case /* BestSellers */ 2:
            return "best_sellers";
        case /* Newest */ 3:
            return "newest";
        case /* HighestPrice */ 4:
            return "highest_price";
        case /* LowestPrice */ 5:
            return "lowest_price";
        case /* HighestDiscount */ 6:
            return "highest_discount";
    }
}
var $00cb0c920b5246fc$export$1fffe7771e220b3d = {
    toJson: $00cb0c920b5246fc$var$toJson,
    fromJson: $00cb0c920b5246fc$var$fromJson,
    all: $00cb0c920b5246fc$var$all,
    fromString: $00cb0c920b5246fc$var$fromString,
    toString: $00cb0c920b5246fc$var$toString
};
 /* Json__Encode Not a pure module */ 
});
parcelRegister("kM5sF", function(module, exports) {

$parcel$export(module.exports, "ProductSortOrder", function () { return $f1fc86dab33de118$export$1fffe7771e220b3d; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $jVmMx = parcelRequire("jVmMx");
var $f1fc86dab33de118$var$fromJson = $jVmMx.Decode.simpleVariant([
    [
        "Default",
        /* Default */ 0
    ],
    [
        "Featured",
        /* Featured */ 1
    ],
    [
        "BestSellers",
        /* BestSellers */ 2
    ],
    [
        "Newest",
        /* Newest */ 3
    ],
    [
        "HighestPrice",
        /* HighestPrice */ 4
    ],
    [
        "LowestPrice",
        /* LowestPrice */ 5
    ],
    [
        "HighestDiscount",
        /* HighestDiscount */ 6
    ]
]);
var $f1fc86dab33de118$var$all = [
    /* Default */ 0,
    /* Featured */ 1,
    /* BestSellers */ 2,
    /* Newest */ 3,
    /* HighestPrice */ 4,
    /* LowestPrice */ 5
];
function $f1fc86dab33de118$var$fromString(str) {
    switch(str){
        case "best_sellers":
            return /* BestSellers */ 2;
        case "default":
            return /* Default */ 0;
        case "featured":
            return /* Featured */ 1;
        case "highest_discount":
            return /* HighestDiscount */ 6;
        case "highest_price":
            return /* HighestPrice */ 4;
        case "lowest_price":
            return /* LowestPrice */ 5;
        case "newest":
            return /* Newest */ 3;
        default:
            return /* Default */ 0;
    }
}
var $f1fc86dab33de118$export$1fffe7771e220b3d = {
    fromJson: $f1fc86dab33de118$var$fromJson,
    all: $f1fc86dab33de118$var$all,
    fromString: $f1fc86dab33de118$var$fromString
};
 /* fromJson Not a pure module */ 
});



parcelRegister("efwy1", function(module, exports) {

$parcel$export(module.exports, "Provider", function () { return $a5fbb6b1f63e3f3e$export$2881499e37b75b9a; });
$parcel$export(module.exports, "use", function () { return $a5fbb6b1f63e3f3e$export$1f96ae73734a86cc; });
$parcel$export(module.exports, "useNamespaceAsString", function () { return $a5fbb6b1f63e3f3e$export$b3b7bea75702f8f; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $g85JO = parcelRequire("g85JO");

var $2whNH = parcelRequire("2whNH");

var $h6rW7 = parcelRequire("h6rW7");
function $a5fbb6b1f63e3f3e$export$fa84e94ceb8582bf(param, param$1) {}
var $a5fbb6b1f63e3f3e$export$a078c61943f9dbbe = /*#__PURE__*/ $g85JO.createContext({
    namespace: undefined,
    urlTransformer: undefined,
    setUrlTransformer: function setUrlTransformer(param) {}
});
var $a5fbb6b1f63e3f3e$export$ca328f169d304df4 = $a5fbb6b1f63e3f3e$export$a078c61943f9dbbe.Provider;
var $a5fbb6b1f63e3f3e$var$provider$1 = $a5fbb6b1f63e3f3e$export$a078c61943f9dbbe.Provider;
function $a5fbb6b1f63e3f3e$var$LocationConfig$Provider(Props) {
    var namespace = Props.namespace;
    var children = Props.children;
    var match = $g85JO.useState(function() {});
    return /*#__PURE__*/ $g85JO.createElement($a5fbb6b1f63e3f3e$var$provider$1, {
        value: {
            namespace: namespace,
            urlTransformer: match[0],
            setUrlTransformer: match[1]
        },
        children: children
    });
}
$a5fbb6b1f63e3f3e$var$LocationConfig$Provider.displayName = "LocationConfig.Provider";
var $a5fbb6b1f63e3f3e$export$2881499e37b75b9a = {
    provider: $a5fbb6b1f63e3f3e$var$provider$1,
    make: $a5fbb6b1f63e3f3e$var$LocationConfig$Provider
};
function $a5fbb6b1f63e3f3e$export$1f96ae73734a86cc(param) {
    return $g85JO.useContext($a5fbb6b1f63e3f3e$export$a078c61943f9dbbe);
}
function $a5fbb6b1f63e3f3e$export$b3b7bea75702f8f(param) {
    return $h6rW7.toString($2whNH.getWithDefault($g85JO.useContext($a5fbb6b1f63e3f3e$export$a078c61943f9dbbe).namespace, $h6rW7.empty));
}
 /* context Not a pure module */ 
});

parcelRegister("9hB74", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $6c227d72a731a538$export$dd44f18ab656f3bb; });
$parcel$export(module.exports, "empty", function () { return $6c227d72a731a538$export$6e22c362a0406a2c; });
$parcel$export(module.exports, "fromDict", function () { return $6c227d72a731a538$export$697d07bbc1cd003b; });
$parcel$export(module.exports, "toDict", function () { return $6c227d72a731a538$export$27ed1c0a853be7b5; });
$parcel$export(module.exports, "toString", function () { return $6c227d72a731a538$export$f84e8e69fd4488a5; });
$parcel$export(module.exports, "sanitize", function () { return $6c227d72a731a538$export$83d2e9e3e4ee39ed; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $d3YYW = parcelRequire("d3YYW");

var $oO3sB = parcelRequire("oO3sB");

var $d1G6W = parcelRequire("d1G6W");

var $2Ng4w = parcelRequire("2Ng4w");

var $2whNH = parcelRequire("2whNH");

var $kiuDo = parcelRequire("kiuDo");

var $loT9g = parcelRequire("loT9g");
function $6c227d72a731a538$export$dd44f18ab656f3bb(mediaId, mediaParentId, albumId, panelClosed, whichList, productId, relatedMediaProductIds, relatedMediaCategoryId, variantId, photoZoom, time, param) {
    return {
        mediaId: mediaId,
        mediaParentId: mediaParentId,
        albumId: albumId,
        panelClosed: panelClosed,
        whichList: whichList,
        productId: productId,
        relatedMediaProductIds: relatedMediaProductIds,
        relatedMediaCategoryId: relatedMediaCategoryId,
        variantId: variantId,
        photoZoom: photoZoom,
        time: time
    };
}
var $6c227d72a731a538$export$6e22c362a0406a2c = $6c227d72a731a538$export$dd44f18ab656f3bb(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
function $6c227d72a731a538$export$b42e70ddca33ff5b(value) {
    return $2whNH.flatMap(value, function(value) {
        if (value === "") return;
        else return value;
    });
}
function $6c227d72a731a538$export$697d07bbc1cd003b(params) {
    var mediaId = $6c227d72a731a538$export$b42e70ddca33ff5b($d3YYW.get(params, "QVMediaId"));
    var mediaParentId = $6c227d72a731a538$export$b42e70ddca33ff5b($d3YYW.get(params, "QVMediaParentId"));
    var albumId = $6c227d72a731a538$export$b42e70ddca33ff5b($d3YYW.get(params, "QVAlbumId"));
    var panelClosed = $2whNH.map($d3YYW.get(params, "QVPanelClosed"), function(value) {
        return $2whNH.isSome($oO3sB.match_(/true|t|1|ok|yes|y/i, value));
    });
    var whichList = $6c227d72a731a538$export$b42e70ddca33ff5b($d3YYW.get(params, "QVWhichList"));
    var productId = $6c227d72a731a538$export$b42e70ddca33ff5b($d3YYW.get(params, "QVProductId"));
    var relatedMediaProductIds = $2whNH.map($d3YYW.get(params, "QVRelatedMediaProductIds"), function(ids) {
        return ids.split(",");
    });
    var relatedMediaCategoryId = $6c227d72a731a538$export$b42e70ddca33ff5b($d3YYW.get(params, "QVRelatedMediaCategoryId"));
    var variantId = $6c227d72a731a538$export$b42e70ddca33ff5b($d3YYW.get(params, "QVVariantId"));
    var photoZoom = $2whNH.flatMap($d3YYW.get(params, "QVPhotoZoom"), function(value) {
        var isInt = $2whNH.isSome($oO3sB.match_(/^([0-9]+)$/i, value));
        if (isInt) return $kiuDo.int_of_string(value);
    });
    var time = $2whNH.flatMap($d3YYW.get(params, "QVTime"), function(value) {
        var isFloat = $2whNH.isSome($loT9g.null_to_opt(value.match(/^([0-9\.]+)$/i)));
        if (isFloat) return $d1G6W.fromString(value);
    });
    return {
        mediaId: mediaId,
        mediaParentId: mediaParentId,
        albumId: albumId,
        panelClosed: panelClosed,
        whichList: whichList,
        productId: productId,
        relatedMediaProductIds: relatedMediaProductIds,
        relatedMediaCategoryId: relatedMediaCategoryId,
        variantId: variantId,
        photoZoom: photoZoom,
        time: time
    };
}
function $6c227d72a731a538$export$27ed1c0a853be7b5(state) {
    return $d3YYW.fromArray([
        [
            "QVMediaId",
            $2whNH.getWithDefault(state.mediaId, "")
        ],
        [
            "QVMediaParentId",
            $2whNH.getWithDefault(state.mediaParentId, "")
        ],
        [
            "QVAlbumId",
            $2whNH.getWithDefault(state.albumId, "")
        ],
        [
            "QVPanelClosed",
            $2whNH.mapWithDefault(state.panelClosed, "", $2Ng4w.string_of_bool)
        ],
        [
            "QVWhichList",
            $2whNH.getWithDefault(state.whichList, "")
        ],
        [
            "QVProductId",
            $2whNH.getWithDefault(state.productId, "")
        ],
        [
            "QVRelatedMediaProductIds",
            $2whNH.getWithDefault(state.relatedMediaProductIds, []).join(",")
        ],
        [
            "QVRelatedMediaCategoryId",
            $2whNH.getWithDefault(state.relatedMediaCategoryId, "")
        ],
        [
            "QVVariantId",
            $2whNH.getWithDefault(state.variantId, "")
        ],
        [
            "QVPhotoZoom",
            $2whNH.mapWithDefault(state.photoZoom, "", function(prim) {
                return String(prim);
            })
        ],
        [
            "QVTime",
            $2whNH.mapWithDefault(state.time, "", function(prim) {
                return String(prim);
            })
        ]
    ]);
}
function $6c227d72a731a538$export$f84e8e69fd4488a5(state) {
    return [
        "QVMediaId" + $2whNH.getWithDefault(state.mediaId, ""),
        "QVMediaParentId" + $2whNH.getWithDefault(state.mediaParentId, ""),
        "QVAlbumId" + $2whNH.getWithDefault(state.albumId, ""),
        "QVPanelClosed" + $2whNH.mapWithDefault(state.panelClosed, "", $2Ng4w.string_of_bool),
        "QVWhichList" + $2whNH.getWithDefault(state.whichList, ""),
        "QVProductId" + $2whNH.getWithDefault(state.productId, ""),
        "QVRelatedMediaProductIds" + $2whNH.getWithDefault(state.relatedMediaProductIds, []).join(","),
        "QVRelatedMediaCategoryId" + $2whNH.getWithDefault(state.relatedMediaCategoryId, ""),
        "QVVariantId" + $2whNH.getWithDefault(state.variantId, ""),
        "QVPhotoZoom" + $2whNH.mapWithDefault(state.photoZoom, "", function(prim) {
            return String(prim);
        }),
        "QVTime" + $2whNH.mapWithDefault(state.time, "", function(prim) {
            return String(prim);
        })
    ].join("|");
}
function $6c227d72a731a538$export$83d2e9e3e4ee39ed($$location) {
    return {
        mediaId: $$location.mediaId,
        mediaParentId: $$location.mediaParentId,
        albumId: $$location.albumId,
        panelClosed: undefined,
        whichList: $$location.whichList,
        productId: $$location.productId,
        relatedMediaProductIds: $$location.relatedMediaProductIds,
        relatedMediaCategoryId: $$location.relatedMediaCategoryId,
        variantId: $$location.variantId,
        photoZoom: undefined,
        time: $$location.time
    };
}
 /* empty Not a pure module */ 
});


parcelRegister("cq0ZS", function(module, exports) {

$parcel$export(module.exports, "index", function () { return $90a8afb5337f6822$export$b610b8812bbcded9; });
$parcel$export(module.exports, "findCategoriesBy", function () { return $90a8afb5337f6822$export$5540aab9d168e062; });
$parcel$export(module.exports, "findCategoryBy", function () { return $90a8afb5337f6822$export$eae62d8adba53de9; });
$parcel$export(module.exports, "keepMapCategories", function () { return $90a8afb5337f6822$export$f5acacd1d0aa2099; });
$parcel$export(module.exports, "getCategoryPathById", function () { return $90a8afb5337f6822$export$59bf8d5782d9c7a0; });
$parcel$export(module.exports, "getCategoryById", function () { return $90a8afb5337f6822$export$302a712dad05c91f; });
$parcel$export(module.exports, "getCategoryParentById", function () { return $90a8afb5337f6822$export$dd6d8d0aa3d7b08e; });
$parcel$export(module.exports, "getChildren", function () { return $90a8afb5337f6822$export$f8cf48ee793b41be; });
$parcel$export(module.exports, "getCategorySiblings", function () { return $90a8afb5337f6822$export$c7417bdb55b01d6d; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $d3YYW = parcelRequire("d3YYW");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $3tOK1 = parcelRequire("3tOK1");
var $90a8afb5337f6822$export$b610b8812bbcded9 = $3tOK1.mem(function(categories) {
    var generate = function generate1(categories, path) {
        return $i7mYY.reduce(categories, [], function(result, category) {
            var key = category.id;
            var subpath = $i7mYY.concat(path, [
                category
            ]);
            var match = category.categoryType;
            var children;
            if (typeof match === "number") children = [];
            else switch(match.TAG | 0){
                case /* Standard */ 1:
                    children = match._0.children;
                    break;
                case /* QuickView */ 2:
                    children = match._0.children;
                    break;
                default:
                    children = [];
            }
            return $i7mYY.concat($i7mYY.concat(result, [
                [
                    key,
                    subpath
                ]
            ]), generate(children, subpath));
        });
    };
    return $d3YYW.fromArray(generate(categories, []));
});
function $90a8afb5337f6822$export$5540aab9d168e062(categories, fn) {
    return $i7mYY.keepMap($d3YYW.values($iv6Yc._1($90a8afb5337f6822$export$b610b8812bbcded9, categories)), function(path) {
        var firstInPath = $i7mYY.get($i7mYY.reverse(path), 0);
        if (firstInPath !== undefined && $iv6Yc._1(fn, firstInPath)) return firstInPath;
    });
}
function $90a8afb5337f6822$export$eae62d8adba53de9(categories, fn) {
    return $i7mYY.get($90a8afb5337f6822$export$5540aab9d168e062(categories, fn), 0);
}
function $90a8afb5337f6822$export$f5acacd1d0aa2099(categories, fn) {
    return $i7mYY.keepMap($d3YYW.values($iv6Yc._1($90a8afb5337f6822$export$b610b8812bbcded9, categories)), function(path) {
        var category = $i7mYY.get($i7mYY.reverse(path), 0);
        if (category !== undefined) return $iv6Yc._1(fn, category);
    });
}
function $90a8afb5337f6822$export$59bf8d5782d9c7a0(categories, id) {
    return $2whNH.getWithDefault($d3YYW.get($iv6Yc._1($90a8afb5337f6822$export$b610b8812bbcded9, categories), id), []);
}
function $90a8afb5337f6822$export$302a712dad05c91f(categories, id) {
    return $i7mYY.get($i7mYY.reverse($90a8afb5337f6822$export$59bf8d5782d9c7a0(categories, id)), 0);
}
function $90a8afb5337f6822$export$dd6d8d0aa3d7b08e(categories, id) {
    return $i7mYY.get($i7mYY.reverse($90a8afb5337f6822$export$59bf8d5782d9c7a0(categories, id)), 1);
}
function $90a8afb5337f6822$export$f8cf48ee793b41be(category) {
    var match = category.categoryType;
    if (typeof match === "number") return [];
    switch(match.TAG | 0){
        case /* QuickView */ 2:
            return match._0.children;
        case /* Standard */ 1:
        case /* ConfigEmbed */ 4:
            return match._0.children;
        default:
            return [];
    }
}
function $90a8afb5337f6822$export$c7417bdb55b01d6d(categories, id) {
    return $2whNH.map($90a8afb5337f6822$export$dd6d8d0aa3d7b08e(categories, id), $90a8afb5337f6822$export$f8cf48ee793b41be);
}
 /* index Not a pure module */ 
});



parcelRegister("9bmXk", function(module, exports) {

$parcel$export(module.exports, "fromOption", function () { return $6af6f2b7793ec660$export$172ec0a6ebfeb6fa; });

var $loT9g = parcelRequire("loT9g");
function $6af6f2b7793ec660$export$2385a24977818dd0(x, f) {
    if (x == null) return x;
    else return f(x);
}
function $6af6f2b7793ec660$export$c0bf298a2e425654(x, f) {
    if (!(x == null)) return f(x);
}
function $6af6f2b7793ec660$export$172ec0a6ebfeb6fa(x) {
    if (x !== undefined) return $loT9g.valFromOption(x);
}
var $6af6f2b7793ec660$export$9d85d2d85cb82adf = $6af6f2b7793ec660$export$172ec0a6ebfeb6fa;
 /* No side effect */ 
});

parcelRegister("h7kEx", function(module, exports) {

$parcel$export(module.exports, "Server", function () { return $c7631c58fbf98032$export$d59771a2e9612de9; });
$parcel$export(module.exports, "Decoding", function () { return $c7631c58fbf98032$export$34a9c8428d70b516; });
$parcel$export(module.exports, "$$fetch", function () { return $c7631c58fbf98032$export$eb3fff827c83c3a1; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $5YOUh = parcelRequire("5YOUh");

var $j4B9x = parcelRequire("j4B9x");

var $iv6Yc = parcelRequire("iv6Yc");

var $gOCfv = parcelRequire("gOCfv");

var $d3YYW = parcelRequire("d3YYW");

var $1ArWc = parcelRequire("1ArWc");

var $eklj4 = parcelRequire("eklj4");

var $75ZqT = parcelRequire("75ZqT");

var $7bjme = parcelRequire("7bjme");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $hxhfd = parcelRequire("hxhfd");

var $1xvYg = parcelRequire("1xvYg");

var $4RPwt = parcelRequire("4RPwt");

var $bsv7W = parcelRequire("bsv7W");

var $bygWp = parcelRequire("bygWp");

var $bBMv4 = parcelRequire("bBMv4");

var $ehnwQ = parcelRequire("ehnwQ");

var $4QdUt = parcelRequire("4QdUt");
var $c7631c58fbf98032$export$ea52035eac03daf0 = /* @__PURE__ */ $1xvYg.create("FetchUtils-Showside.ServerError");
var $c7631c58fbf98032$export$ef3eed12d06c0285 = /* @__PURE__ */ $1xvYg.create("FetchUtils-Showside.DecodeError");
var $c7631c58fbf98032$export$bae979e68e4dc802 = /* @__PURE__ */ $1xvYg.create("FetchUtils-Showside.NetworkError");
function $c7631c58fbf98032$export$f53235827bfffde0(url, requestInit) {
    var $$fetch$1 = window.makerFetch;
    if ($$fetch$1 !== undefined) return $$fetch$1(url, requestInit);
    else return fetch(url, requestInit);
}
function $c7631c58fbf98032$var$entries(headers) {
    return Object.fromEntries(headers.entries());
}
var $c7631c58fbf98032$export$953df90d5d5fed48 = {
    entries: $c7631c58fbf98032$var$entries
};
function $c7631c58fbf98032$var$toString(method_) {
    if (typeof method_ !== "number") return method_._0.toUpperCase();
    switch(method_){
        case /* Get */ 0:
            return "GET";
        case /* Head */ 1:
            return "HEAD";
        case /* Post */ 2:
            return "POST";
        case /* Put */ 3:
            return "PUT";
        case /* Delete */ 4:
            return "DELETE";
        case /* Connect */ 5:
            return "CONNECT";
        case /* Options */ 6:
            return "OPTIONS";
        case /* Trace */ 7:
            return "TRACE";
        case /* Patch */ 8:
            return "PATCH";
    }
}
var $c7631c58fbf98032$export$31bb55db0b3e4187 = {
    toString: $c7631c58fbf98032$var$toString
};
function $c7631c58fbf98032$var$toObject(req) {
    return $c7631c58fbf98032$var$_toObject.apply(this, arguments);
}
function $c7631c58fbf98032$var$_toObject() {
    $c7631c58fbf98032$var$_toObject = (0, $5YOUh._)(function(req) {
        var req$1, text, headers;
        return (0, $j4B9x.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    try {
                        req$1 = req.clone();
                    } catch (exn) {
                        req$1 = req;
                    }
                    return [
                        4,
                        $eklj4.$$catch($gOCfv.$$Request.text(req$1), function(param) {
                            return Promise.resolve("");
                        })
                    ];
                case 1:
                    text = _state.sent();
                    headers = req$1.headers;
                    return [
                        2,
                        {
                            url: req$1.url,
                            headers: Object.fromEntries(headers.entries()),
                            method: $c7631c58fbf98032$var$toString($gOCfv.$$Request.method_(req$1)),
                            text: text
                        }
                    ];
            }
        });
    });
    return $c7631c58fbf98032$var$_toObject.apply(this, arguments);
}
var $c7631c58fbf98032$export$53d047610dcbd7d1 = {
    toObject: $c7631c58fbf98032$var$toObject
};
function $c7631c58fbf98032$var$toObject$1(res) {
    return $c7631c58fbf98032$var$_toObject$1.apply(this, arguments);
}
function $c7631c58fbf98032$var$_toObject$1() {
    $c7631c58fbf98032$var$_toObject$1 = (0, $5YOUh._)(function(res) {
        var res$1, text, headers;
        return (0, $j4B9x.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    try {
                        res$1 = res.clone();
                    } catch (exn) {
                        res$1 = res;
                    }
                    return [
                        4,
                        $eklj4.$$catch($gOCfv.$$Response.text(res$1), function(param) {
                            return Promise.resolve("");
                        })
                    ];
                case 1:
                    text = _state.sent();
                    headers = res$1.headers;
                    return [
                        2,
                        {
                            url: res$1.url,
                            headers: Object.fromEntries(headers.entries()),
                            status: res$1.status,
                            statusText: res$1.statusText,
                            text: text
                        }
                    ];
            }
        });
    });
    return $c7631c58fbf98032$var$_toObject$1.apply(this, arguments);
}
var $c7631c58fbf98032$export$ccdc019228fc9db2 = {
    toObject: $c7631c58fbf98032$var$toObject$1
};
var $c7631c58fbf98032$export$cea17b2eb787e8f6 = {};
var $c7631c58fbf98032$export$852e4a2c9592440a = "Unknown error occurred";
function $c7631c58fbf98032$export$bf7e10db8fb87848(error, statusCode, requestUrl) {
    var nonCriticalErrorSubstrings = [
        "Focal product not found in result set"
    ];
    var isNonCriticalMessage = function isNonCriticalMessage(msg) {
        return $i7mYY.some(nonCriticalErrorSubstrings, function(sub) {
            return msg.includes(sub);
        });
    };
    var errorMessage = error.RE_EXN_ID === $c7631c58fbf98032$export$bae979e68e4dc802 || error.RE_EXN_ID === $c7631c58fbf98032$export$ea52035eac03daf0 || error.RE_EXN_ID === $c7631c58fbf98032$export$ef3eed12d06c0285 ? error._1 : "";
    var isProduction = requestUrl.startsWith($hxhfd.apiHostnameProduction);
    var isForbidden = $7bjme.equal(statusCode, 403);
    var isNonCritical = isNonCriticalMessage(errorMessage);
    if (isProduction && !isForbidden) return !isNonCritical;
    else return false;
}
function $c7631c58fbf98032$export$42595fc4624ec725(urlStr) {
    var url = $bygWp.maybeMakeUrl($bygWp.resolveRelativePath(urlStr));
    if (url === undefined) return urlStr;
    var url$1 = $loT9g.valFromOption(url);
    var pathname = url$1.pathname;
    var host = url$1.host;
    return host + pathname;
}
function $c7631c58fbf98032$var$makeError(req, res, message, param) {
    var statusCode = res.status;
    var url = res.url;
    var displayUrl = $c7631c58fbf98032$export$42595fc4624ec725(url);
    return {
        exn: {
            RE_EXN_ID: $c7631c58fbf98032$export$ea52035eac03daf0,
            _1: "Error " + statusCode.toString() + " in API " + displayUrl + ": " + message + ""
        },
        request: req,
        response: res
    };
}
function $c7631c58fbf98032$var$truncateTo100Characters(str) {
    if (str.length > 100) return str.slice(0, 100) + "...";
    else return str;
}
function $c7631c58fbf98032$var$extractUsefulErrorMessageFromResponse(req, res) {
    return $gOCfv.$$Response.text(res.clone()).then(function(text) {
        var json;
        try {
            json = $loT9g.some(JSON.parse(text));
        } catch (e) {
            json = undefined;
        }
        var message = $c7631c58fbf98032$var$truncateTo100Characters(text);
        var message$1 = message.trim() === "" ? $c7631c58fbf98032$export$852e4a2c9592440a : message;
        var obj = $2whNH.flatMap(json, $1ArWc.decodeObject);
        if (obj === undefined) return Promise.resolve($c7631c58fbf98032$var$makeError(req, res, message$1, undefined));
        var displayError = $2whNH.flatMap($d3YYW.get($loT9g.valFromOption(obj), "error"), $1ArWc.decodeString);
        if (displayError !== undefined) return Promise.resolve($c7631c58fbf98032$var$makeError(req, res, displayError, undefined));
        else return Promise.resolve($c7631c58fbf98032$var$makeError(req, res, message$1, undefined));
    });
}
function $c7631c58fbf98032$var$handleServerResponse(req, res) {
    var statusCode = res.status;
    if (statusCode >= 200 && statusCode < 300) return Promise.resolve({
        TAG: /* Ok */ 0,
        _0: res
    });
    else return $c7631c58fbf98032$var$extractUsefulErrorMessageFromResponse(req, res).then(function(error) {
        return {
            TAG: /* Error */ 1,
            _0: error
        };
    });
}
function $c7631c58fbf98032$var$reportToRollbar(error) {
    return $c7631c58fbf98032$var$_reportToRollbar.apply(this, arguments);
}
function $c7631c58fbf98032$var$_reportToRollbar() {
    $c7631c58fbf98032$var$_reportToRollbar = (0, $5YOUh._)(function(error) {
        var isCriticalError$1, request, response;
        return (0, $j4B9x.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    isCriticalError$1 = $c7631c58fbf98032$export$bf7e10db8fb87848(error.exn, error.response.status, error.request.url);
                    return [
                        4,
                        $c7631c58fbf98032$var$toObject(error.request)
                    ];
                case 1:
                    request = _state.sent();
                    return [
                        4,
                        $c7631c58fbf98032$var$toObject$1(error.response)
                    ];
                case 2:
                    response = _state.sent();
                    if (isCriticalError$1) return [
                        2,
                        $4QdUt.critical2($75ZqT.$$Error.fromRescript(error.exn), {
                            request: request,
                            response: response
                        })
                    ];
                    else return [
                        2,
                        $4QdUt.error2(error.exn, {
                            request: request,
                            response: response
                        })
                    ];
                    return [
                        2
                    ];
            }
        });
    });
    return $c7631c58fbf98032$var$_reportToRollbar.apply(this, arguments);
}
function $c7631c58fbf98032$var$reportAllServerErrors(res, req) {
    return res.then(function(param) {
        return $c7631c58fbf98032$var$handleServerResponse(req, param);
    }).then(function(result) {
        if (result.TAG === /* Ok */ 0) return Promise.resolve(result._0);
        var error = result._0;
        return $c7631c58fbf98032$var$reportToRollbar(error).then(function(param) {
            return Promise.reject(error.exn);
        });
    });
}
function $c7631c58fbf98032$var$ignoreNotFoundError(res, req) {
    return res.then(function(param) {
        return $c7631c58fbf98032$var$handleServerResponse(req, param);
    }).then(function(result) {
        if (result.TAG === /* Ok */ 0) return Promise.resolve(result._0);
        var error = result._0;
        if (error.response.status === 404) return Promise.reject({
            RE_EXN_ID: $c7631c58fbf98032$export$ea52035eac03daf0,
            _1: "Not found"
        });
        else return $c7631c58fbf98032$var$reportToRollbar(error).then(function(param) {
            return Promise.reject(error.exn);
        });
    });
}
var $c7631c58fbf98032$export$d59771a2e9612de9 = {
    makeError: $c7631c58fbf98032$var$makeError,
    truncateTo100Characters: $c7631c58fbf98032$var$truncateTo100Characters,
    extractUsefulErrorMessageFromResponse: $c7631c58fbf98032$var$extractUsefulErrorMessageFromResponse,
    handleServerResponse: $c7631c58fbf98032$var$handleServerResponse,
    reportToRollbar: $c7631c58fbf98032$var$reportToRollbar,
    reportAllServerErrors: $c7631c58fbf98032$var$reportAllServerErrors,
    ignoreNotFoundError: $c7631c58fbf98032$var$ignoreNotFoundError
};
function $c7631c58fbf98032$var$ignoreDecode(json) {
    return Promise.resolve({
        TAG: /* Ok */ 0,
        _0: json
    });
}
function $c7631c58fbf98032$var$raiseExnIfFound(json, decoder) {
    var decodedObject = $1ArWc.decodeObject(json);
    var error = $2whNH.flatMap($2whNH.flatMap(decodedObject, function(dict) {
        return $d3YYW.get(dict, "error");
    }), $1ArWc.decodeString);
    var numberOfFields = $2whNH.getWithDefault($2whNH.map(decodedObject, function(object) {
        return Object.keys(object).length;
    }), 0);
    if (error !== undefined && error.trim() !== "" && numberOfFields === 1) return Promise.resolve({
        TAG: /* Error */ 1,
        _0: error
    });
    else return $iv6Yc._1(decoder, json);
}
var $c7631c58fbf98032$var$SuccessfulResponseErrorBody = {
    raiseExnIfFound: $c7631c58fbf98032$var$raiseExnIfFound
};
function $c7631c58fbf98032$var$reportAllDecodingErrors(res, decoder) {
    return res.then(function(res) {
        return $gOCfv.$$Response.json(res).then(function(json) {
            var decoded = $c7631c58fbf98032$var$raiseExnIfFound(json, decoder);
            var url = res.url;
            var displayUrl = $c7631c58fbf98032$export$42595fc4624ec725(url);
            return $ehnwQ.$$catch(decoded, function(e) {
                var rootCause = $75ZqT.$$Error.fromRescript(e);
                var name = $2whNH.getWithDefault(rootCause.name, "Error");
                var message = $2whNH.getWithDefault(rootCause.message, $c7631c58fbf98032$export$852e4a2c9592440a);
                var errorMessage = "Error raised when decoding " + displayUrl + ": " + name + " " + message + "";
                var error = {
                    RE_EXN_ID: $c7631c58fbf98032$export$ef3eed12d06c0285,
                    _1: errorMessage
                };
                if (message.includes("Failed to fetch dynamically imported module:") || message.includes("Cannot find module") || message.includes("Could not resolve bundle with id")) return Promise.reject(error);
                else return $c7631c58fbf98032$var$toObject$1(res).then(function(response) {
                    var isCriticalError$1 = $c7631c58fbf98032$export$bf7e10db8fb87848(error, res.status, res.url);
                    if (isCriticalError$1) return $4QdUt.critical2($75ZqT.$$Error.fromRescript(error), {
                        apiUrl: url,
                        response: response
                    }).then(function(param) {
                        return Promise.reject(error);
                    });
                    else return $4QdUt.error2(error, {
                        apiUrl: url,
                        response: response
                    }).then(function(param) {
                        return Promise.reject(error);
                    });
                });
            }).then(function(decoded) {
                if (decoded.TAG === /* Ok */ 0) return Promise.resolve(decoded._0);
                var errorMessage = "Failed to decode response of API " + displayUrl + ": " + decoded._0 + "";
                var error = {
                    RE_EXN_ID: $c7631c58fbf98032$export$ef3eed12d06c0285,
                    _1: errorMessage
                };
                return $c7631c58fbf98032$var$toObject$1(res).then(function(response) {
                    var isCriticalError$1 = $c7631c58fbf98032$export$bf7e10db8fb87848(error, res.status, res.url);
                    if (isCriticalError$1) return $4QdUt.critical2($75ZqT.$$Error.fromRescript(error), {
                        apiUrl: url,
                        response: response
                    }).then(function(param) {
                        return Promise.reject(error);
                    });
                    else return $4QdUt.error2(error, {
                        apiUrl: url,
                        response: response
                    }).then(function(param) {
                        return Promise.reject(error);
                    });
                });
            });
        });
    });
}
var $c7631c58fbf98032$export$34a9c8428d70b516 = {
    ignoreDecode: $c7631c58fbf98032$var$ignoreDecode,
    SuccessfulResponseErrorBody: $c7631c58fbf98032$var$SuccessfulResponseErrorBody,
    reportAllDecodingErrors: $c7631c58fbf98032$var$reportAllDecodingErrors
};
function $c7631c58fbf98032$export$d5856779b17605db(e, req) {
    var url = req.url;
    var displayUrl = $c7631c58fbf98032$export$42595fc4624ec725(url);
    var err = $75ZqT.$$Error.fromRescript(e);
    var name = $2whNH.getWithDefault(err.name, "Error");
    var message = $2whNH.getWithDefault(err.message, $c7631c58fbf98032$export$852e4a2c9592440a);
    var errorMessage = "Error raised when fetching " + displayUrl + ": " + name + " " + message + "";
    var error = $75ZqT.$$Error.fromRescriptWithNewMessage(e, errorMessage);
    var isNetworkError = (0, $bsv7W.default)(e);
    if (isNetworkError) return Promise.reject({
        RE_EXN_ID: $c7631c58fbf98032$export$bae979e68e4dc802,
        _1: $2whNH.getWithDefault(err.message, "Network error")
    });
    else return $c7631c58fbf98032$var$toObject(req).then(function(request) {
        var isCriticalError$1 = $c7631c58fbf98032$export$bf7e10db8fb87848(e, undefined, req.url);
        if (isCriticalError$1) return $4QdUt.critical2(error, {
            apiUrl: url,
            request: request
        }).then(function(param) {
            return Promise.reject(e);
        });
        else return $4QdUt.jsError2(error, {
            apiUrl: url,
            request: request
        }).then(function(param) {
            return Promise.reject(e);
        });
    });
}
function $c7631c58fbf98032$export$eb3fff827c83c3a1(method_Opt, body, headers, reportDecodingError, reportServerError, decoder, url) {
    var method_ = method_Opt !== undefined ? method_Opt : /* Get */ 0;
    var reportServerError$1 = $2whNH.getWithDefault(reportServerError, $c7631c58fbf98032$var$reportAllServerErrors);
    var reportDecodingError$1 = $2whNH.getWithDefault(reportDecodingError, $c7631c58fbf98032$var$reportAllDecodingErrors);
    var requestInit = $gOCfv.RequestInit.make(method_, headers, body, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined)(undefined);
    var request = new Request(url, requestInit);
    try {
        return $iv6Yc._2(reportDecodingError$1, $iv6Yc._2(reportServerError$1, $ehnwQ.$$catch($c7631c58fbf98032$export$f53235827bfffde0(url, requestInit), function(exn) {
            return $c7631c58fbf98032$export$d5856779b17605db(exn, request);
        }), request), decoder);
    } catch (raw_e) {
        var e = $bBMv4.internalToOCamlException(raw_e);
        return $c7631c58fbf98032$export$d5856779b17605db($4RPwt.Exn.unwrapJsError(e), request);
    }
}
 /* Rollbar Not a pure module */ 
});
parcelRegister("bsv7W", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $857a746c851076f0$export$2e2bcd8739ae039; });
var $857a746c851076f0$var$objectToString = Object.prototype.toString;
var $857a746c851076f0$var$isError = function(value) {
    return $857a746c851076f0$var$objectToString.call(value) === "[object Error]";
};
var $857a746c851076f0$var$errorMessages = new Set([
    "network error",
    "Failed to fetch",
    "NetworkError when attempting to fetch resource.",
    "The Internet connection appears to be offline.",
    "Load failed",
    "Network request failed",
    "fetch failed",
    "terminated"
]);
function $857a746c851076f0$export$2e2bcd8739ae039(error) {
    var isValid = error && $857a746c851076f0$var$isError(error) && error.name === "TypeError" && typeof error.message === "string";
    if (!isValid) return false;
    // We do an extra check for Safari 17+ as it has a very generic error message.
    // Network errors in Safari have no stack.
    if (error.message === "Load failed") return error.stack === undefined;
    return $857a746c851076f0$var$errorMessages.has(error.message);
}

});


parcelRegister("9MZLD", function(module, exports) {

$parcel$export(module.exports, "calc", function () { return $72088279e53ed889$export$42bfa9b2d4dad91a; });
$parcel$export(module.exports, "toString", function () { return $72088279e53ed889$export$f84e8e69fd4488a5; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $aaMxi = parcelRequire("aaMxi");
function $72088279e53ed889$export$42bfa9b2d4dad91a(vw) {
    if (vw <= 360) return /* Xs */ 0;
    else if (vw <= 600) return /* Sm */ 1;
    else if (vw < 1024) return /* Md */ 2;
    else if (vw < 1366) return /* Lg */ 3;
    else return /* Xl */ 4;
}
function $72088279e53ed889$export$f84e8e69fd4488a5(breakpoint) {
    switch(breakpoint){
        case /* Xs */ 0:
            return "xs";
        case /* Sm */ 1:
            return "sm";
        case /* Md */ 2:
            return "md";
        case /* Lg */ 3:
            return "lg";
        case /* Xl */ 4:
            return "xl";
    }
}
var $72088279e53ed889$export$3004f64547af360e = $aaMxi.fromString;
 /* No side effect */ 
});
parcelRegister("aaMxi", function(module, exports) {

$parcel$export(module.exports, "toString", function () { return $76807cd06135ae8a$export$f84e8e69fd4488a5; });
$parcel$export(module.exports, "fromString", function () { return $76807cd06135ae8a$export$3004f64547af360e; });
// Generated by ReScript, PLEASE EDIT WITH CARE
function $76807cd06135ae8a$export$f84e8e69fd4488a5(breakpoint) {
    switch(breakpoint){
        case /* Xs */ 0:
            return "xs";
        case /* Sm */ 1:
            return "sm";
        case /* Md */ 2:
            return "md";
        case /* Lg */ 3:
            return "lg";
        case /* Xl */ 4:
            return "xl";
    }
}
function $76807cd06135ae8a$export$3004f64547af360e(breakpoint) {
    switch(breakpoint){
        case "lg":
            return /* Lg */ 3;
        case "md":
            return /* Md */ 2;
        case "sm":
            return /* Sm */ 1;
        case "xl":
            return /* Xl */ 4;
        case "xs":
            return /* Xs */ 0;
        default:
            return;
    }
}
 /* No side effect */ 
});


parcelRegister("ivJr2", function(module, exports) {

$parcel$export(module.exports, "useWithDefault", function () { return $d79e5db4efca08e9$export$805fc67cbeef14a6; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $g85JO = parcelRequire("g85JO");

var $loT9g = parcelRequire("loT9g");
function $d79e5db4efca08e9$export$805fc67cbeef14a6(hookNameOpt, providerNameOpt, ctx, $$default) {
    var hookName = hookNameOpt !== undefined ? hookNameOpt : "React.useContext";
    var providerName = providerNameOpt !== undefined ? providerNameOpt : "React.Context.provider";
    var ctx$1 = $g85JO.useContext(ctx);
    if (ctx$1 !== undefined) return $loT9g.valFromOption(ctx$1);
    else {
        console.warn("" + hookName + " was called without initializing the provider. Ensure the component is wrapped in <" + providerName + ">.");
        return $$default;
    }
}
 /* react Not a pure module */ 
});

parcelRegister("kMqPq", function(module, exports) {

$parcel$export(module.exports, "makeApiUrl", function () { return $f20d19efe359e012$export$122a632893579567; });
$parcel$export(module.exports, "preloadConfig", function () { return $f20d19efe359e012$export$4113fd76ece5c26f; });
$parcel$export(module.exports, "nodeLimit", function () { return $f20d19efe359e012$export$3e97b5ef32dc0192; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $hxhfd = parcelRequire("hxhfd");

var $bBMv4 = parcelRequire("bBMv4");

var $jEVpK = parcelRequire("jEVpK");

var $9MZLD = parcelRequire("9MZLD");
function $f20d19efe359e012$export$122a632893579567(apiHostname, live, backup, configId, breakpoint, trimTreeByReferrer, noTreeOpt, param) {
    var noTree = noTreeOpt !== undefined ? noTreeOpt : false;
    return apiHostname + "/api/get_config?config_id=" + configId + (live ? "&live=true" : "") + $2whNH.mapWithDefault(backup, "", function(backup) {
        return "&backup=" + backup;
    }) + $2whNH.mapWithDefault(trimTreeByReferrer, "", function(trimTreeByReferrer) {
        return "&trim_tree_by_referrer=" + trimTreeByReferrer;
    }) + "&showside_format=true&breakpoint=" + breakpoint + ("&node_limit=" + String(30)) + "&paginate=true" + (noTree ? "&no_tree=true" : "");
}
function $f20d19efe359e012$export$4113fd76ece5c26f(enableTrimmingTreeByReferrerOpt, breakpointOverride, embedType, configId) {
    var enableTrimmingTreeByReferrer = enableTrimmingTreeByReferrerOpt !== undefined ? enableTrimmingTreeByReferrerOpt : false;
    var $$location = window.location;
    var trimTreeByReferrer = enableTrimmingTreeByReferrer ? encodeURIComponent($$location.origin + $$location.pathname) : undefined;
    var match;
    try {
        var url = new URL(window.location.href);
        var navParams = url.searchParams;
        var devMode = $2whNH.mapWithDefault($loT9g.nullable_to_opt(navParams.get("QNDevMode")), /* Production */ 1, $hxhfd.getApiEnv);
        var previewMode = navParams.get("QNPreviewMode");
        var backup;
        if (previewMode == null) backup = undefined;
        else {
            var match$1 = previewMode.match(/^T([0-9]+)$/);
            if (match$1 !== null && match$1.length === 2) {
                var timestamp = match$1[1];
                backup = timestamp !== undefined ? timestamp : undefined;
            } else backup = undefined;
        }
        var live = previewMode == null || previewMode !== "HEAD" ? true : false;
        match = [
            $hxhfd.getApiHostname(devMode),
            live,
            backup
        ];
    } catch (raw_e) {
        var e = $bBMv4.internalToOCamlException(raw_e);
        console.error("Failed to get referrer, apiHostname, live, backup for preloading:", e);
        match = [
            $hxhfd.apiHostnameProduction,
            true,
            undefined
        ];
    }
    var apiHostname = match[0];
    var breakpoint = $9MZLD.toString($2whNH.getWithDefault(breakpointOverride, $9MZLD.calc($jEVpK.getWidth(undefined))));
    var fragment = document.createDocumentFragment();
    var preconnect = document.createElement("link");
    preconnect.setAttribute("rel", "preconnect");
    preconnect.setAttribute("href", apiHostname);
    preconnect.setAttribute("crossorigin", "anonymous");
    fragment.appendChild(preconnect);
    var dnsPrefetch = document.createElement("link");
    dnsPrefetch.setAttribute("rel", "dns-prefetch");
    dnsPrefetch.setAttribute("href", apiHostname);
    fragment.appendChild(dnsPrefetch);
    var preload = document.createElement("link");
    preload.setAttribute("rel", "preload");
    preload.setAttribute("as", "fetch");
    preload.setAttribute("fetchpriority", "high");
    preload.setAttribute("href", $f20d19efe359e012$export$122a632893579567(apiHostname, match[1], match[2], configId, breakpoint, trimTreeByReferrer, embedType === /* ProductDetailsPage */ 5, undefined));
    preload.setAttribute("crossorigin", "anonymous");
    fragment.appendChild(preload);
    $2whNH.forEach($loT9g.nullable_to_opt(document.querySelector("head")), function(__x) {
        __x.appendChild(fragment);
    });
}
var $f20d19efe359e012$export$3e97b5ef32dc0192 = 30;
 /* Env-Showside Not a pure module */ 
});
parcelRegister("jEVpK", function(module, exports) {

$parcel$export(module.exports, "getWidth", function () { return $e4fe4a070745e220$export$3c49c185de0c2bfc; });
$parcel$export(module.exports, "getHeight", function () { return $e4fe4a070745e220$export$c08559766941f856; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $2whNH = parcelRequire("2whNH");
function $e4fe4a070745e220$export$3c49c185de0c2bfc(param) {
    var clientWidth = document.documentElement.clientWidth;
    var innerWidth = window.innerWidth;
    var tmp;
    var exit = 0;
    if (innerWidth !== 0 || clientWidth <= 0) exit = 1;
    else tmp = clientWidth;
    if (exit === 1) tmp = clientWidth !== 0 ? clientWidth < innerWidth ? clientWidth : innerWidth : innerWidth > 0 || clientWidth >= innerWidth ? innerWidth : clientWidth;
    return $2whNH.getWithDefault($2whNH.flatMap($2whNH.flatMap(window.parentScrollPosition, function(position) {
        return position.window;
    }), function($$window) {
        return $$window.windowWidth;
    }), tmp);
}
function $e4fe4a070745e220$export$c08559766941f856(param) {
    var clientHeight = document.documentElement.clientHeight;
    var innerHeight = window.innerHeight;
    var tmp;
    var exit = 0;
    if (innerHeight !== 0 || clientHeight <= 0) exit = 1;
    else tmp = clientHeight;
    if (exit === 1) tmp = clientHeight !== 0 ? clientHeight > innerHeight ? clientHeight : innerHeight : innerHeight > 0 || clientHeight <= innerHeight ? innerHeight : clientHeight;
    return $2whNH.getWithDefault($2whNH.flatMap($2whNH.flatMap(window.parentScrollPosition, function(position) {
        return position.window;
    }), function($$window) {
        return $$window.windowHeight;
    }), tmp);
}
 /* No side effect */ 
});


parcelRegister("aSJcu", function(module, exports) {

$parcel$export(module.exports, "Provider", function () { return $7ec2026abd080d82$export$2881499e37b75b9a; });
$parcel$export(module.exports, "use", function () { return $7ec2026abd080d82$export$1f96ae73734a86cc; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $81N94 = parcelRequire("81N94");

var $g85JO = parcelRequire("g85JO");

var $2whNH = parcelRequire("2whNH");

var $aANnx = parcelRequire("aANnx");

var $biidj = parcelRequire("biidj");
var $7ec2026abd080d82$export$f36c9b20522c59e3 = {
    isMobile: true,
    breakpoint: /* Sm */ 1,
    windowSize: {
        width: 1,
        height: 1
    }
};
var $7ec2026abd080d82$export$a078c61943f9dbbe = /*#__PURE__*/ $g85JO.createContext($7ec2026abd080d82$export$f36c9b20522c59e3);
var $7ec2026abd080d82$var$provider = $7ec2026abd080d82$export$a078c61943f9dbbe.Provider;
function $7ec2026abd080d82$var$ViewportContext$Provider(Props) {
    var value = Props.value;
    var children = Props.children;
    var match = $biidj.useWindowSize(true, 100, undefined);
    var width = $81N94.int_max(match[0], 1);
    var height = $81N94.int_max(match[1], 1);
    var match$1 = $aANnx.use(width);
    var breakpoint = match$1.breakpoint;
    var isMobile = match$1.isMobile;
    var value$1 = $g85JO.useMemo(function() {
        return $2whNH.getWithDefault(value, {
            isMobile: isMobile,
            breakpoint: breakpoint,
            windowSize: {
                width: width,
                height: height
            }
        });
    }, [
        breakpoint,
        isMobile,
        value,
        width,
        height
    ]);
    return /*#__PURE__*/ $g85JO.createElement($7ec2026abd080d82$var$provider, {
        value: value$1,
        children: children
    });
}
$7ec2026abd080d82$var$ViewportContext$Provider.displayName = "ViewportContext.Provider";
var $7ec2026abd080d82$export$2881499e37b75b9a = {
    provider: $7ec2026abd080d82$var$provider,
    make: $7ec2026abd080d82$var$ViewportContext$Provider
};
function $7ec2026abd080d82$export$1f96ae73734a86cc(param) {
    return $g85JO.useContext($7ec2026abd080d82$export$a078c61943f9dbbe);
}
 /* context Not a pure module */ 
});
parcelRegister("aANnx", function(module, exports) {

$parcel$export(module.exports, "use", function () { return $7b6391c33f978986$export$1f96ae73734a86cc; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $g85JO = parcelRequire("g85JO");

var $9MZLD = parcelRequire("9MZLD");

var $aaMxi = parcelRequire("aaMxi");
function $7b6391c33f978986$export$1f96ae73734a86cc(windowWidth) {
    return $g85JO.useMemo(function() {
        var breakpoint = $9MZLD.calc(windowWidth);
        return {
            isMobile: breakpoint <= /* Sm */ 1,
            breakpoint: breakpoint
        };
    }, [
        windowWidth
    ]);
}
var $7b6391c33f978986$export$f84e8e69fd4488a5 = $aaMxi.toString;
var $7b6391c33f978986$export$3004f64547af360e = $aaMxi.fromString;
 /* react Not a pure module */ 
});

parcelRegister("biidj", function(module, exports) {

$parcel$export(module.exports, "useWindowResize", function () { return $838f8109c90a0736$export$2754b3c6fa113f36; });
$parcel$export(module.exports, "useWindowSize", function () { return $838f8109c90a0736$export$42c02f33970a2afa; });
$parcel$export(module.exports, "useWindowWidth", function () { return $838f8109c90a0736$export$52797c36be27ec5f; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $2whNH = parcelRequire("2whNH");

var $l1q57 = parcelRequire("l1q57");

var $jEVpK = parcelRequire("jEVpK");
function $838f8109c90a0736$export$2754b3c6fa113f36(callback) {
    $g85JO.useEffect(function() {
        window.addEventListener("resize", callback, {
            capture: false,
            passive: true,
            once: false
        });
        return function(param) {
            window.removeEventListener("resize", callback, {
                capture: false,
                passive: true
            });
        };
    }, [
        callback
    ]);
}
function $838f8109c90a0736$export$42c02f33970a2afa(leading, wait, param) {
    var getSize = function getSize(param) {
        return [
            $jEVpK.getWidth(undefined),
            $jEVpK.getHeight(undefined)
        ];
    };
    var match = $l1q57.useDebounce(leading, wait, function(param) {
        return getSize(undefined);
    });
    var setResult = match[1];
    var handleResize = $g85JO.useCallback(function(param) {
        $iv6Yc._1(setResult, function(param) {
            return getSize(undefined);
        });
    }, []);
    $838f8109c90a0736$export$2754b3c6fa113f36(handleResize);
    return match[0];
}
function $838f8109c90a0736$export$52797c36be27ec5f(leading, wait, disabled, param) {
    var match = $l1q57.useDebounce(leading, wait, function(param) {
        return $jEVpK.getWidth(undefined);
    });
    var setResult = match[1];
    var handleResize = $g85JO.useCallback(function(param) {
        $iv6Yc._1(setResult, function(param) {
            return $jEVpK.getWidth(undefined);
        });
    }, []);
    $838f8109c90a0736$export$2754b3c6fa113f36(handleResize);
    var disabled$1 = $2whNH.mapWithDefault(disabled, false, function(ref) {
        return ref.current;
    });
    $g85JO.useEffect(function() {
        $iv6Yc._1(handleResize, new Event("resize"));
    }, [
        disabled$1
    ]);
    return match[0];
}
function $838f8109c90a0736$export$7c4ec72a573072ce(leading, wait, disabled, param) {
    var match = $l1q57.useDebounce(leading, wait, function(param) {
        return $jEVpK.getHeight(undefined);
    });
    var setResult = match[1];
    var handleResize = $g85JO.useCallback(function(param) {
        var disabled$1 = $2whNH.mapWithDefault(disabled, false, function(ref) {
            return ref.current;
        });
        if (disabled$1) return;
        else return $iv6Yc._1(setResult, function(param) {
            return $jEVpK.getHeight(undefined);
        });
    }, []);
    $838f8109c90a0736$export$2754b3c6fa113f36(handleResize);
    var disabled$1 = $2whNH.mapWithDefault(disabled, false, function(ref) {
        return ref.current;
    });
    $g85JO.useEffect(function() {
        $iv6Yc._1(handleResize, new Event("resize"));
    }, [
        disabled$1
    ]);
    return match[0];
}
 /* react Not a pure module */ 
});
parcelRegister("l1q57", function(module, exports) {

$parcel$export(module.exports, "useDebounce", function () { return $f4ddec392c242104$export$21805fee57372823; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $hr0dx = parcelRequire("hr0dx");
function $f4ddec392c242104$export$21805fee57372823(leadingOpt, waitOpt, init) {
    var leading = leadingOpt !== undefined ? leadingOpt : false;
    var wait = waitOpt !== undefined ? waitOpt : 100;
    return $hr0dx.useDebounce(init, leading, wait);
}
 /* @react-hook/debounce Not a pure module */ 
});
parcelRegister("hr0dx", function(module, exports) {

$parcel$export(module.exports, "useDebounce", function () { return $cb15206feb2761c7$export$21805fee57372823; });

var $g85JO = parcelRequire("g85JO");

var $gleUZ = parcelRequire("gleUZ");
var $cb15206feb2761c7$export$40ae01be0011c1e6 = function(callback) {
    var wait = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 100, leading = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var storedCallback = (0, $gleUZ.default)(callback);
    var timeout = $g85JO.useRef();
    var deps = [
        wait,
        leading,
        storedCallback
    ]; // Cleans up pending timeouts when the deps change
    function _ref() {
        timeout.current && clearTimeout(timeout.current);
        timeout.current = void 0;
    }
    $g85JO.useEffect(function() {
        return _ref;
    }, deps);
    function _ref2() {
        timeout.current = void 0;
    }
    return $g85JO.useCallback(function() {
        // eslint-disable-next-line prefer-rest-params
        var args = arguments;
        var current = timeout.current; // Calls on leading edge
        if (current === void 0 && leading) {
            timeout.current = setTimeout(_ref2, wait); // eslint-disable-next-line prefer-spread
            return storedCallback.current.apply(null, args);
        } // Clear the timeout every call and start waiting again
        current && clearTimeout(current); // Waits for `wait` before invoking the callback
        timeout.current = setTimeout(function() {
            timeout.current = void 0;
            storedCallback.current.apply(null, args);
        }, wait);
    }, deps);
};
var $cb15206feb2761c7$export$21805fee57372823 = function(initialState, wait, leading) {
    var state = $g85JO.useState(initialState);
    return [
        state[0],
        $cb15206feb2761c7$export$40ae01be0011c1e6(state[1], wait, leading),
        state[1]
    ];
};

});
parcelRegister("gleUZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $be5a2def63f7d654$export$2e2bcd8739ae039; });

var $g85JO = parcelRequire("g85JO");
var $be5a2def63f7d654$var$useLatest = function(current) {
    var storedValue = $g85JO.useRef(current);
    $g85JO.useEffect(function() {
        storedValue.current = current;
    });
    return storedValue;
};
var $be5a2def63f7d654$export$2e2bcd8739ae039 = $be5a2def63f7d654$var$useLatest;

});





parcelRegister("dcR0L", function(module, exports) {

$parcel$export(module.exports, "empty", function () { return $99d5844fb97da95b$export$6e22c362a0406a2c; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $kNO66 = parcelRequire("kNO66");
var $99d5844fb97da95b$var$empty_categories = [];
var $99d5844fb97da95b$export$6e22c362a0406a2c = {
    id: "",
    categories: $99d5844fb97da95b$var$empty_categories,
    settings: $kNO66.empty,
    transitiveStoreId: undefined,
    transitiveAccount: undefined,
    transitiveStore: undefined,
    accountId: undefined,
    lastModifiedAt: 0.0
};
var $99d5844fb97da95b$export$ce5bcb86ca2bfc97;
 /* LegacyShowside_SettingsDecoders-ApiTypes Not a pure module */ 
});
parcelRegister("kNO66", function(module, exports) {

$parcel$export(module.exports, "PanelSize", function () { return $f24f3e94dd9d9c04$export$69e2902d2a3921ff; });
$parcel$export(module.exports, "PanelPosition", function () { return $f24f3e94dd9d9c04$export$a048ae1f0ae09c2c; });
$parcel$export(module.exports, "DesktopPDPLayout", function () { return $f24f3e94dd9d9c04$export$631e3c3b01fb1045; });
$parcel$export(module.exports, "TitleDescriptionPosition", function () { return $f24f3e94dd9d9c04$export$9a41294384f62a08; });
$parcel$export(module.exports, "GaVersion", function () { return $f24f3e94dd9d9c04$export$a65f4ba0b4d85314; });
$parcel$export(module.exports, "PDPCTAConfig", function () { return $f24f3e94dd9d9c04$export$d8c400e89f051a97; });
$parcel$export(module.exports, "fromJson", function () { return $f24f3e94dd9d9c04$export$7ae2d2a8b28a8cb8; });
$parcel$export(module.exports, "empty", function () { return $f24f3e94dd9d9c04$export$6e22c362a0406a2c; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $79vie = parcelRequire("79vie");

var $jVmMx = parcelRequire("jVmMx");

var $3Wlzc = parcelRequire("3Wlzc");

var $atDFT = parcelRequire("atDFT");

var $1Gpco = parcelRequire("1Gpco");

var $dRfYk = parcelRequire("dRfYk");

var $f1TVX = parcelRequire("f1TVX");

var $dT0m1 = parcelRequire("dT0m1");

var $crJlr = parcelRequire("crJlr");

var $7lqRw = parcelRequire("7lqRw");

var $eaePg = parcelRequire("eaePg");

var $ij6do = parcelRequire("ij6do");

var $5kJL4 = parcelRequire("5kJL4");
var $f24f3e94dd9d9c04$var$fromJson = $jVmMx.Decode.simpleVariant([
    [
        "Large",
        /* Large */ 0
    ],
    [
        "Medium",
        /* Medium */ 1
    ],
    [
        "Small",
        /* Small */ 2
    ],
    [
        "FullWidth",
        /* FullWidth */ 3
    ]
]);
var $f24f3e94dd9d9c04$export$69e2902d2a3921ff = {
    fromJson: $f24f3e94dd9d9c04$var$fromJson
};
var $f24f3e94dd9d9c04$var$fromJson$1 = $jVmMx.Decode.simpleVariant([
    [
        "Left",
        /* Left */ 0
    ],
    [
        "Right",
        /* Right */ 1
    ]
]);
var $f24f3e94dd9d9c04$export$a048ae1f0ae09c2c = {
    fromJson: $f24f3e94dd9d9c04$var$fromJson$1
};
var $f24f3e94dd9d9c04$var$fromJson$2 = $jVmMx.Decode.simpleVariant([
    [
        "Old",
        /* Old */ 0
    ],
    [
        "Horizontal",
        /* Horizontal */ 1
    ],
    [
        "Vertical",
        /* Vertical */ 2
    ]
]);
var $f24f3e94dd9d9c04$export$631e3c3b01fb1045 = {
    fromJson: $f24f3e94dd9d9c04$var$fromJson$2
};
var $f24f3e94dd9d9c04$var$fromJson$3 = $jVmMx.Decode.simpleVariant([
    [
        "Left",
        /* Left */ 0
    ],
    [
        "Center",
        /* Center */ 1
    ]
]);
var $f24f3e94dd9d9c04$export$9a41294384f62a08 = {
    fromJson: $f24f3e94dd9d9c04$var$fromJson$3
};
var $f24f3e94dd9d9c04$var$fromJson$4 = $jVmMx.Decode.simpleVariant([
    [
        "Ua",
        /* Ua */ 0
    ],
    [
        "Gtag",
        /* Gtag */ 1
    ]
]);
var $f24f3e94dd9d9c04$export$a65f4ba0b4d85314 = {
    fromJson: $f24f3e94dd9d9c04$var$fromJson$4
};
var $f24f3e94dd9d9c04$var$addToCartProps_fromJson = $79vie.map4($79vie.field("textColor", $79vie.string), $79vie.field("bgColor", $79vie.string), $79vie.field("label", $79vie.string), $79vie.field("confirmationMessage", $79vie.string), function(textColor, bgColor, label, confirmationMessage) {
    return {
        textColor: textColor,
        bgColor: bgColor,
        label: label,
        confirmationMessage: confirmationMessage
    };
});
var $f24f3e94dd9d9c04$var$customActionProps_fromJson = $iv6Yc._8($jVmMx.Decode.map7, $iv6Yc._2($jVmMx.Decode.field, "id", $jVmMx.Decode.string), $iv6Yc._2($jVmMx.Decode.field, "textColor", $jVmMx.Decode.string), $iv6Yc._2($jVmMx.Decode.field, "bgColor", $jVmMx.Decode.string), $iv6Yc._2($jVmMx.Decode.field, "label", $jVmMx.Decode.string), $iv6Yc._2($jVmMx.Decode.field, "confirmationMessage", $jVmMx.Decode.string), $iv6Yc._2($jVmMx.Decode.field, "onClickFn", $jVmMx.Decode.string), $iv6Yc._2($jVmMx.Decode.field, "renderFn", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string)), function(id, textColor, bgColor, label, confirmationMessage, onClickFn, renderFn) {
    return {
        id: id,
        textColor: textColor,
        bgColor: bgColor,
        label: label,
        confirmationMessage: confirmationMessage,
        onClickFn: onClickFn,
        renderFn: renderFn
    };
});
var $f24f3e94dd9d9c04$var$pdpCTAAction_fromJson = $iv6Yc._2($jVmMx.Decode.oneOf, $jVmMx.Decode.deccoVariantWithPayload("CustomAction", $f24f3e94dd9d9c04$var$customActionProps_fromJson, function(payload) {
    return {
        TAG: /* CustomAction */ 2,
        _0: payload
    };
}), [
    $jVmMx.Decode.deccoVariantWithPayload("AddToCart", $f24f3e94dd9d9c04$var$addToCartProps_fromJson, function(payload) {
        return {
            TAG: /* AddToCart */ 0,
            _0: payload
        };
    }),
    $jVmMx.Decode.deccoVariantWithPayload("OpenLink", $jVmMx.Decode.string, function(payload) {
        return {
            TAG: /* OpenLink */ 1,
            _0: payload
        };
    })
]);
var $f24f3e94dd9d9c04$var$fromJson$5 = $iv6Yc._4($jVmMx.Decode.map3, $iv6Yc._2($jVmMx.Decode.field, "primary", $f24f3e94dd9d9c04$var$pdpCTAAction_fromJson), $iv6Yc._2($jVmMx.Decode.field, "secondary", $iv6Yc._1($jVmMx.Decode.option, $f24f3e94dd9d9c04$var$pdpCTAAction_fromJson)), $jVmMx.Decode.fieldWithDefault("tertiary", $iv6Yc._1($jVmMx.Decode.option, $f24f3e94dd9d9c04$var$pdpCTAAction_fromJson), undefined), function(primary, secondary, tertiary) {
    return {
        primary: primary,
        secondary: secondary,
        tertiary: tertiary
    };
});
var $f24f3e94dd9d9c04$export$d8c400e89f051a97 = {
    addToCartProps_fromJson: $f24f3e94dd9d9c04$var$addToCartProps_fromJson,
    customActionProps_fromJson: $f24f3e94dd9d9c04$var$customActionProps_fromJson,
    pdpCTAAction_fromJson: $f24f3e94dd9d9c04$var$pdpCTAAction_fromJson,
    fromJson: $f24f3e94dd9d9c04$var$fromJson$5
};
var $f24f3e94dd9d9c04$export$7ae2d2a8b28a8cb8 = $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._1($jVmMx.Decode.succeed, function(panelSize, panelPosition, backdrop, backdropBlur, backdropColor, categoryLayout, categorySize, nestedCategoryLayout, nestedCategorySize, checkoutLink, checkoutCustomAction, currencyPickerEnabled, gridDensityZoomEnabled, filtersEnabled, filtersLabelOrder, linksAsSidebar, sidebarDesktopDefault, sidebarMobileDefault, backButton, smartbarEnabled, zIndexInt, zIndex, categoryCardShape, categoryCardFitToContainer, categoryCardTitleLineTruncate, productCardTitleLineTruncate, productCardFitToContainer, productCardShape, productCardSize, productCardAddToCart, pdpCTAConfig, pdpAddToCartLabel, pdpAddToCartConfirmation, pdpPrimaryCustomAction, pdpSecondaryCustomAction, pdpTertiaryCustomAction, pdpGalleryCustomAction, pdpSizeGuide, pdpCTAButtons, pdpOpenLinkLabel, pdpCTAButtonBgColor, pdpCTAButtonTextColor, pdpGalleryBGBlur, pdpGalleryBGColor, pdpPricePrefixText, pdpPriceSuffixText, pdpPromoText, shipping, shippingShort, arrival, hideOutOfStock, videoLoop, videoAutoPlay, videoMute, videoControls, openLinkLabel, openLinkInNewTab, openProductLink, outOfStockLabel, indexNode, quickviewCarousel, quickviewAutoplay, quickviewPictureInPicture, siteHeaderCSSSelector, siteHeaderRespect, displayVariantBy, newMobilePDP, desktopPDPLayout, newMobilePDPCube, newMobilePDPCover, newMobilePDPCtaLabel, quantityPicker, mkrBio, cart, gaTrackingId, gaVersion, contextualL1s, contextualInline, contextualMenuDesktop, contextualMenuMobile, autoHideBottombar, expandVariantsInProductsListing, favoritesEnabled, historyEnabled, plpHistorySliderEnabled, plpTitleDescriptionEnabled, plpTitleDescriptionPosition, seoDynamicLinks, theme, pdpTheme, plpTheme, productCardComponent, pdpComponent) {
    return {
        panelSize: panelSize,
        panelPosition: panelPosition,
        backdrop: backdrop,
        backdropBlur: backdropBlur,
        backdropColor: backdropColor,
        categoryLayout: categoryLayout,
        categorySize: categorySize,
        nestedCategoryLayout: nestedCategoryLayout,
        nestedCategorySize: nestedCategorySize,
        checkoutLink: checkoutLink,
        checkoutCustomAction: checkoutCustomAction,
        currencyPickerEnabled: currencyPickerEnabled,
        gridDensityZoomEnabled: gridDensityZoomEnabled,
        filtersEnabled: filtersEnabled,
        filtersLabelOrder: filtersLabelOrder,
        linksAsSidebar: linksAsSidebar,
        sidebarDesktopDefault: sidebarDesktopDefault,
        sidebarMobileDefault: sidebarMobileDefault,
        backButton: backButton,
        smartbarEnabled: smartbarEnabled,
        zIndexInt: zIndexInt,
        zIndex: zIndex,
        categoryCardShape: categoryCardShape,
        categoryCardFitToContainer: categoryCardFitToContainer,
        categoryCardTitleLineTruncate: categoryCardTitleLineTruncate,
        productCardTitleLineTruncate: productCardTitleLineTruncate,
        productCardFitToContainer: productCardFitToContainer,
        productCardShape: productCardShape,
        productCardSize: productCardSize,
        productCardAddToCart: productCardAddToCart,
        pdpCTAConfig: pdpCTAConfig,
        pdpAddToCartLabel: pdpAddToCartLabel,
        pdpAddToCartConfirmation: pdpAddToCartConfirmation,
        pdpPrimaryCustomAction: pdpPrimaryCustomAction,
        pdpSecondaryCustomAction: pdpSecondaryCustomAction,
        pdpTertiaryCustomAction: pdpTertiaryCustomAction,
        pdpGalleryCustomAction: pdpGalleryCustomAction,
        pdpSizeGuide: pdpSizeGuide,
        pdpCTAButtons: pdpCTAButtons,
        pdpOpenLinkLabel: pdpOpenLinkLabel,
        pdpCTAButtonBgColor: pdpCTAButtonBgColor,
        pdpCTAButtonTextColor: pdpCTAButtonTextColor,
        pdpGalleryBGBlur: pdpGalleryBGBlur,
        pdpGalleryBGColor: pdpGalleryBGColor,
        pdpPricePrefixText: pdpPricePrefixText,
        pdpPriceSuffixText: pdpPriceSuffixText,
        pdpPromoText: pdpPromoText,
        shipping: shipping,
        shippingShort: shippingShort,
        arrival: arrival,
        hideOutOfStock: hideOutOfStock,
        videoLoop: videoLoop,
        videoAutoPlay: videoAutoPlay,
        videoMute: videoMute,
        videoControls: videoControls,
        openLinkLabel: openLinkLabel,
        openLinkInNewTab: openLinkInNewTab,
        openProductLink: openProductLink,
        outOfStockLabel: outOfStockLabel,
        indexNode: indexNode,
        quickviewCarousel: quickviewCarousel,
        quickviewAutoplay: quickviewAutoplay,
        quickviewPictureInPicture: quickviewPictureInPicture,
        siteHeaderCSSSelector: siteHeaderCSSSelector,
        siteHeaderRespect: siteHeaderRespect,
        displayVariantBy: displayVariantBy,
        newMobilePDP: newMobilePDP,
        desktopPDPLayout: desktopPDPLayout,
        newMobilePDPCube: newMobilePDPCube,
        newMobilePDPCover: newMobilePDPCover,
        newMobilePDPCtaLabel: newMobilePDPCtaLabel,
        quantityPicker: quantityPicker,
        mkrBio: mkrBio,
        cart: cart,
        gaTrackingId: gaTrackingId,
        gaVersion: gaVersion,
        contextualL1s: contextualL1s,
        contextualInline: contextualInline,
        contextualMenuDesktop: contextualMenuDesktop,
        contextualMenuMobile: contextualMenuMobile,
        autoHideBottombar: autoHideBottombar,
        expandVariantsInProductsListing: expandVariantsInProductsListing,
        favoritesEnabled: favoritesEnabled,
        historyEnabled: historyEnabled,
        plpHistorySliderEnabled: plpHistorySliderEnabled,
        plpTitleDescriptionEnabled: plpTitleDescriptionEnabled,
        plpTitleDescriptionPosition: plpTitleDescriptionPosition,
        seoDynamicLinks: seoDynamicLinks,
        theme: theme,
        plpTheme: plpTheme,
        pdpTheme: pdpTheme,
        productCardComponent: productCardComponent,
        pdpComponent: pdpComponent
    };
}), $iv6Yc._2($jVmMx.Decode.field, "panelSize", $f24f3e94dd9d9c04$var$fromJson)), $iv6Yc._2($jVmMx.Decode.field, "panelPosition", $f24f3e94dd9d9c04$var$fromJson$1)), $iv6Yc._2($jVmMx.Decode.field, "backdrop", $jVmMx.Decode.bool)), $iv6Yc._2($jVmMx.Decode.field, "backdropBlur", $jVmMx.Decode.bool)), $iv6Yc._2($jVmMx.Decode.field, "backdropColor", $jVmMx.Decode.string)), $iv6Yc._2($jVmMx.Decode.field, "categoryLayout", $5kJL4.smartbarCategoryLayout_fromJson)), $iv6Yc._2($jVmMx.Decode.field, "categorySize", $5kJL4.smartbarCategorySize_fromJson)), $iv6Yc._2($jVmMx.Decode.field, "nestedCategoryLayout", $5kJL4.smartbarCategoryLayout_fromJson)), $iv6Yc._2($jVmMx.Decode.field, "nestedCategorySize", $5kJL4.smartbarCategorySize_fromJson)), $iv6Yc._2($jVmMx.Decode.field, "checkoutLink", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string))), $jVmMx.Decode.fieldWithDefault("checkoutCustomAction", $iv6Yc._1($jVmMx.Decode.option, $dRfYk.fromJson), undefined)), $jVmMx.Decode.fieldWithDefault("currencyPickerEnabled", $jVmMx.Decode.bool, true)), $jVmMx.Decode.fieldWithDefault("gridDensityZoomEnabled", $jVmMx.Decode.bool, false)), $iv6Yc._2($jVmMx.Decode.field, "filtersEnabled", $jVmMx.Decode.bool)), $iv6Yc._2($jVmMx.Decode.field, "filtersLabelOrder", $iv6Yc._1($jVmMx.Decode.array, $jVmMx.Decode.string))), $iv6Yc._2($jVmMx.Decode.field, "linksAsSidebar", $jVmMx.Decode.bool)), $iv6Yc._2($jVmMx.Decode.field, "sidebarDesktopDefault", $jVmMx.Decode.bool)), $iv6Yc._2($jVmMx.Decode.field, "sidebarMobileDefault", $jVmMx.Decode.bool)), $iv6Yc._2($jVmMx.Decode.field, "backButton", $jVmMx.Decode.bool)), $iv6Yc._2($jVmMx.Decode.field, "smartbarEnabled", $jVmMx.Decode.bool)), $iv6Yc._2($jVmMx.Decode.field, "zIndexInt", $jVmMx.Decode.$$int)), $iv6Yc._2($jVmMx.Decode.field, "zIndex", $jVmMx.Decode.string)), $iv6Yc._2($jVmMx.Decode.field, "categoryCardShape", $5kJL4.cardShape_fromJson)), $iv6Yc._2($jVmMx.Decode.field, "categoryCardFitToContainer", $jVmMx.Decode.bool)), $iv6Yc._2($jVmMx.Decode.field, "categoryCardTitleLineTruncate", $jVmMx.Decode.$$int)), $iv6Yc._2($jVmMx.Decode.field, "productCardTitleLineTruncate", $jVmMx.Decode.$$int)), $iv6Yc._2($jVmMx.Decode.field, "productCardFitToContainer", $jVmMx.Decode.bool)), $iv6Yc._2($jVmMx.Decode.field, "productCardShape", $5kJL4.cardShape_fromJson)), $iv6Yc._2($jVmMx.Decode.field, "productCardSize", $ij6do.CardSize.fromJson)), $iv6Yc._2($jVmMx.Decode.field, "productCardAddToCart", $jVmMx.Decode.bool)), $iv6Yc._2($jVmMx.Decode.field, "pdpCTAConfig", $f24f3e94dd9d9c04$var$fromJson$5)), $iv6Yc._2($jVmMx.Decode.field, "pdpAddToCartLabel", $jVmMx.Decode.string)), $iv6Yc._2($jVmMx.Decode.field, "pdpAddToCartConfirmation", $jVmMx.Decode.string)), $jVmMx.Decode.fieldWithDefault("pdpPrimaryCustomAction", $iv6Yc._1($jVmMx.Decode.option, $crJlr.Button.fromJson), undefined)), $jVmMx.Decode.fieldWithDefault("pdpSecondaryCustomAction", $iv6Yc._1($jVmMx.Decode.option, $crJlr.Button.fromJson), undefined)), $jVmMx.Decode.fieldWithDefault("pdpTertiaryCustomAction", $iv6Yc._1($jVmMx.Decode.option, $crJlr.Button.fromJson), undefined)), $jVmMx.Decode.fieldWithDefault("pdpGalleryCustomAction", $iv6Yc._1($jVmMx.Decode.option, $crJlr.Button.fromJson), undefined)), $iv6Yc._2($jVmMx.Decode.field, "pdpSizeGuide", $iv6Yc._1($jVmMx.Decode.option, $f1TVX.fromJson))), $iv6Yc._2($jVmMx.Decode.field, "pdpCTAButtons", $dT0m1.fromJson)), $iv6Yc._2($jVmMx.Decode.field, "pdpOpenLinkLabel", $jVmMx.Decode.string)), $iv6Yc._2($jVmMx.Decode.field, "pdpCTAButtonBgColor", $jVmMx.Decode.string)), $iv6Yc._2($jVmMx.Decode.field, "pdpCTAButtonTextColor", $jVmMx.Decode.string)), $iv6Yc._2($jVmMx.Decode.field, "pdpGalleryBGBlur", $jVmMx.Decode.bool)), $iv6Yc._2($jVmMx.Decode.field, "pdpGalleryBGColor", $jVmMx.Decode.string)), $iv6Yc._2($jVmMx.Decode.field, "pdpPricePrefixText", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string))), $iv6Yc._2($jVmMx.Decode.field, "pdpPriceSuffixText", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string))), $iv6Yc._2($jVmMx.Decode.field, "pdpPromoText", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string))), $iv6Yc._2($jVmMx.Decode.field, "shipping", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string))), $iv6Yc._2($jVmMx.Decode.field, "shippingShort", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string))), $iv6Yc._2($jVmMx.Decode.field, "arrival", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string))), $iv6Yc._2($jVmMx.Decode.field, "hideOutOfStock", $jVmMx.Decode.bool)), $iv6Yc._2($jVmMx.Decode.field, "videoLoop", $jVmMx.Decode.bool)), $iv6Yc._2($jVmMx.Decode.field, "videoAutoPlay", $jVmMx.Decode.bool)), $iv6Yc._2($jVmMx.Decode.field, "videoMute", $jVmMx.Decode.bool)), $iv6Yc._2($jVmMx.Decode.field, "videoControls", $jVmMx.Decode.bool)), $iv6Yc._2($jVmMx.Decode.field, "openLinkLabel", $jVmMx.Decode.string)), $iv6Yc._2($jVmMx.Decode.field, "openLinkInNewTab", $jVmMx.Decode.bool)), $iv6Yc._2($jVmMx.Decode.field, "openProductLink", $jVmMx.Decode.bool)), $iv6Yc._2($jVmMx.Decode.field, "outOfStockLabel", $jVmMx.Decode.string)), $iv6Yc._2($jVmMx.Decode.field, "indexNode", $iv6Yc._1($jVmMx.Decode.option, $ij6do.fromJson))), $iv6Yc._2($jVmMx.Decode.field, "quickviewCarousel", $jVmMx.Decode.bool)), $iv6Yc._2($jVmMx.Decode.field, "quickviewAutoplay", $jVmMx.Decode.bool)), $iv6Yc._2($jVmMx.Decode.field, "quickviewPictureInPicture", $jVmMx.Decode.bool)), $iv6Yc._2($jVmMx.Decode.field, "siteHeaderCSSSelector", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string))), $iv6Yc._2($jVmMx.Decode.field, "siteHeaderRespect", $jVmMx.Decode.bool)), $iv6Yc._2($jVmMx.Decode.field, "displayVariantBy", $eaePg.fromJson)), $iv6Yc._2($jVmMx.Decode.field, "newMobilePDP", $jVmMx.Decode.bool)), $iv6Yc._2($jVmMx.Decode.field, "desktopPDPLayout", $f24f3e94dd9d9c04$var$fromJson$2)), $iv6Yc._2($jVmMx.Decode.field, "newMobilePDPCube", $jVmMx.Decode.bool)), $iv6Yc._2($jVmMx.Decode.field, "newMobilePDPCover", $jVmMx.Decode.bool)), $jVmMx.Decode.fieldWithDefault("newMobilePDPCtaLabel", $jVmMx.Decode.string, "Buy Now")), $iv6Yc._2($jVmMx.Decode.field, "quantityPicker", $jVmMx.Decode.bool)), $iv6Yc._2($jVmMx.Decode.field, "mkrBio", $iv6Yc._1($jVmMx.Decode.option, $atDFT.fromJson))), $iv6Yc._2($jVmMx.Decode.field, "cart", $jVmMx.Decode.bool)), $iv6Yc._2($jVmMx.Decode.field, "gaTrackingId", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string))), $iv6Yc._2($jVmMx.Decode.field, "gaVersion", $f24f3e94dd9d9c04$var$fromJson$4)), $iv6Yc._2($jVmMx.Decode.field, "contextualL1s", $jVmMx.Decode.bool)), $iv6Yc._2($jVmMx.Decode.field, "contextualInline", $jVmMx.Decode.bool)), $jVmMx.Decode.fieldWithDefault("contextualMenuDesktop", $jVmMx.Decode.bool, false)), $jVmMx.Decode.fieldWithDefault("contextualMenuMobile", $jVmMx.Decode.bool, false)), $iv6Yc._2($jVmMx.Decode.field, "autoHideBottombar", $jVmMx.Decode.bool)), $iv6Yc._2($jVmMx.Decode.field, "expandVariantsInProductsListing", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.bool))), $jVmMx.Decode.fieldWithDefault("favoritesEnabled", $jVmMx.Decode.bool, false)), $jVmMx.Decode.fieldWithDefault("historyEnabled", $jVmMx.Decode.bool, false)), $jVmMx.Decode.fieldWithDefault("plpHistorySliderEnabled", $jVmMx.Decode.bool, false)), $jVmMx.Decode.fieldWithDefault("plpTitleDescriptionEnabled", $jVmMx.Decode.bool, false)), $jVmMx.Decode.fieldWithDefault("plpTitleDescriptionPosition", $f24f3e94dd9d9c04$var$fromJson$3, /* Left */ 0)), $jVmMx.Decode.fieldWithDefault("seoDynamicLinks", $jVmMx.Decode.bool, false)), $jVmMx.Decode.fieldWithDefault("theme", $1Gpco.fromJson, $1Gpco.empty)), $jVmMx.Decode.fieldWithDefault("pdpTheme", $iv6Yc._1($jVmMx.Decode.option, $1Gpco.fromJson), undefined)), $jVmMx.Decode.fieldWithDefault("plpTheme", $iv6Yc._1($jVmMx.Decode.option, $1Gpco.fromJson), undefined)), $jVmMx.Decode.fieldWithDefault("productCardComponent", $iv6Yc._1($jVmMx.Decode.option, $7lqRw.reference_fromJson), undefined)), $jVmMx.Decode.fieldWithDefault("pdpComponent", $iv6Yc._1($jVmMx.Decode.option, $7lqRw.reference_fromJson), undefined));
var $f24f3e94dd9d9c04$var$empty_filtersLabelOrder = [];
var $f24f3e94dd9d9c04$var$empty_pdpCTAConfig = {
    primary: {
        TAG: /* OpenLink */ 1,
        _0: "test"
    },
    secondary: undefined,
    tertiary: undefined
};
var $f24f3e94dd9d9c04$var$empty_pdpCTAButtons = [
    "open_link",
    undefined,
    undefined
];
var $f24f3e94dd9d9c04$var$empty_theme = {
    themeId: $iv6Yc._1($3Wlzc.fromString, "empty"),
    themeName: "",
    themeCreatedAt: 0,
    themeUpdatedAt: 0,
    primaryColor: "#111827",
    secondaryColor: "#374151",
    tertiaryColor: "#6B7280",
    accentColor: "#000000",
    backgroundColor: "#ffffff",
    backgroundArt: /* NoArt */ 0,
    placeholderColor: "#F3F4F6",
    productPromoBackgroundColor: "#F3F4F6",
    productPromoLabelColor: "#111827",
    productPriceDiscountBackgroundColor: "#dc2626",
    productPriceDiscountLabelColor: "#ffffff",
    drawerBackgroundColor: "#ffffff",
    drawerLabelColor: "#111827",
    headingFont: {
        fontFamily: undefined,
        fontSizeScale: 1.0,
        fontWeight: /* WeightAuto */ 0
    },
    bodyFont: {
        fontFamily: undefined,
        fontSizeScale: 1.0,
        fontWeight: /* WeightAuto */ 0
    },
    buttonFont: {
        fontFamily: undefined,
        fontSizeScale: 1.0,
        fontWeight: /* WeightAuto */ 0
    },
    roundedEdges: "4px",
    rowGutter: "45px",
    columnGutter: "12px",
    sectionVerticalPadding: "0px",
    sectionPaddingTop: undefined,
    sectionPaddingBottom: undefined
};
var $f24f3e94dd9d9c04$export$6e22c362a0406a2c = {
    panelSize: /* Small */ 2,
    panelPosition: /* Right */ 1,
    backdrop: true,
    backdropBlur: true,
    backdropColor: "",
    categoryLayout: /* Labels */ 0,
    categorySize: /* Small */ 0,
    nestedCategoryLayout: /* Labels */ 0,
    nestedCategorySize: /* Small */ 0,
    checkoutLink: undefined,
    checkoutCustomAction: undefined,
    currencyPickerEnabled: true,
    gridDensityZoomEnabled: true,
    filtersEnabled: true,
    filtersLabelOrder: $f24f3e94dd9d9c04$var$empty_filtersLabelOrder,
    linksAsSidebar: true,
    sidebarDesktopDefault: true,
    sidebarMobileDefault: true,
    backButton: true,
    smartbarEnabled: true,
    zIndexInt: 0,
    zIndex: "",
    categoryCardShape: /* Square */ 1,
    categoryCardFitToContainer: true,
    categoryCardTitleLineTruncate: 0,
    productCardTitleLineTruncate: 0,
    productCardFitToContainer: true,
    productCardShape: /* Square */ 1,
    productCardSize: /* Md */ 4,
    productCardAddToCart: true,
    pdpCTAConfig: $f24f3e94dd9d9c04$var$empty_pdpCTAConfig,
    pdpAddToCartLabel: "Add to cart",
    pdpAddToCartConfirmation: "",
    pdpPrimaryCustomAction: undefined,
    pdpSecondaryCustomAction: undefined,
    pdpTertiaryCustomAction: undefined,
    pdpGalleryCustomAction: undefined,
    pdpSizeGuide: undefined,
    pdpCTAButtons: $f24f3e94dd9d9c04$var$empty_pdpCTAButtons,
    pdpOpenLinkLabel: "",
    pdpCTAButtonBgColor: "",
    pdpCTAButtonTextColor: "",
    pdpGalleryBGBlur: true,
    pdpGalleryBGColor: "",
    pdpPricePrefixText: undefined,
    pdpPriceSuffixText: undefined,
    pdpPromoText: undefined,
    shipping: undefined,
    shippingShort: undefined,
    arrival: undefined,
    hideOutOfStock: true,
    videoLoop: true,
    videoAutoPlay: true,
    videoMute: true,
    videoControls: true,
    openLinkLabel: "",
    openLinkInNewTab: true,
    openProductLink: true,
    outOfStockLabel: "",
    indexNode: undefined,
    quickviewCarousel: true,
    quickviewAutoplay: true,
    quickviewPictureInPicture: true,
    siteHeaderCSSSelector: undefined,
    siteHeaderRespect: false,
    displayVariantBy: /* FirstVariant */ 0,
    newMobilePDP: false,
    desktopPDPLayout: /* Old */ 0,
    newMobilePDPCube: false,
    newMobilePDPCover: false,
    newMobilePDPCtaLabel: "Buy Now",
    quantityPicker: false,
    mkrBio: undefined,
    cart: false,
    gaTrackingId: undefined,
    gaVersion: /* Gtag */ 1,
    contextualL1s: false,
    contextualInline: false,
    contextualMenuDesktop: false,
    contextualMenuMobile: false,
    autoHideBottombar: false,
    expandVariantsInProductsListing: undefined,
    favoritesEnabled: false,
    historyEnabled: false,
    plpHistorySliderEnabled: false,
    plpTitleDescriptionEnabled: false,
    plpTitleDescriptionPosition: /* Left */ 0,
    seoDynamicLinks: false,
    theme: $f24f3e94dd9d9c04$var$empty_theme,
    plpTheme: undefined,
    pdpTheme: undefined,
    productCardComponent: undefined,
    pdpComponent: undefined
};
var $f24f3e94dd9d9c04$export$ce5bcb86ca2bfc97;
 /* fromJson Not a pure module */ 
});
parcelRegister("3Wlzc", function(module, exports) {

$parcel$export(module.exports, "fromString", function () { return $2de784942e0235f6$export$3004f64547af360e; });
$parcel$export(module.exports, "toString", function () { return $2de784942e0235f6$export$f84e8e69fd4488a5; });
$parcel$export(module.exports, "fromJson", function () { return $2de784942e0235f6$export$7ae2d2a8b28a8cb8; });
$parcel$export(module.exports, "toJson", function () { return $2de784942e0235f6$export$d5b7a8bf56ee1fe2; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $ki9MN = parcelRequire("ki9MN");
var $2de784942e0235f6$export$fcf199705d83ca19 = $ki9MN.Make({});
var $2de784942e0235f6$export$bb5e712207166a02 = $2de784942e0235f6$export$fcf199705d83ca19.t_decode;
var $2de784942e0235f6$export$cc42ff7b6c615091 = $2de784942e0235f6$export$fcf199705d83ca19.t_encode;
var $2de784942e0235f6$export$3004f64547af360e = $2de784942e0235f6$export$fcf199705d83ca19.fromString;
var $2de784942e0235f6$export$f84e8e69fd4488a5 = $2de784942e0235f6$export$fcf199705d83ca19.toString;
var $2de784942e0235f6$export$7ae2d2a8b28a8cb8 = $2de784942e0235f6$export$fcf199705d83ca19.fromJson;
var $2de784942e0235f6$export$d5b7a8bf56ee1fe2 = $2de784942e0235f6$export$fcf199705d83ca19.toJson;
 /* ThemeId Not a pure module */ 
});

parcelRegister("atDFT", function(module, exports) {

$parcel$export(module.exports, "toJson", function () { return $7a0b63647ce1033d$export$d5b7a8bf56ee1fe2; });
$parcel$export(module.exports, "fromJson", function () { return $7a0b63647ce1033d$export$7ae2d2a8b28a8cb8; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $jVmMx = parcelRequire("jVmMx");

var $doJJK = parcelRequire("doJJK");

var $1cVsx = parcelRequire("1cVsx");

var $1Efib = parcelRequire("1Efib");

var $iIV46 = parcelRequire("iIV46");

var $4WJAy = parcelRequire("4WJAy");
function $7a0b63647ce1033d$export$d5b7a8bf56ee1fe2(param) {
    return $iv6Yc._1($jVmMx.Encode.object, [
        [
            "logoUrl",
            $iv6Yc._1($jVmMx.Encode.string, param.logoUrl)
        ],
        [
            "name",
            $jVmMx.Encode.nullable(param.name, $jVmMx.Encode.string)
        ],
        [
            "description",
            $jVmMx.Encode.nullable(param.description, $jVmMx.Encode.string)
        ],
        [
            "callToAction",
            $jVmMx.Encode.nullable(param.callToAction, $1cVsx.CallToAction.toJson)
        ],
        [
            "socialNetworksLinks",
            $iv6Yc._2($jVmMx.Encode.array, param.socialNetworksLinks, $iIV46.SocialNetworkLink.toJson)
        ],
        [
            "socialNetworkConnections",
            $iv6Yc._2($jVmMx.Encode.array, param.socialNetworkConnections, $4WJAy.SocialNetworkConnection.toJson)
        ]
    ]);
}
var $7a0b63647ce1033d$export$7ae2d2a8b28a8cb8 = $iv6Yc._7($jVmMx.Decode.map6, $iv6Yc._2($jVmMx.Decode.field, "logoUrl", $jVmMx.Decode.string), $iv6Yc._2($jVmMx.Decode.field, "name", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string)), $iv6Yc._2($jVmMx.Decode.field, "description", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string)), $iv6Yc._2($jVmMx.Decode.field, "callToAction", $iv6Yc._1($jVmMx.Decode.option, $1cVsx.CallToAction.fromJson)), $jVmMx.Decode.fieldWithDefault("socialNetworksLinks", $iv6Yc._1($jVmMx.Decode.array, $iIV46.SocialNetworkLink.fromJson), []), $jVmMx.Decode.fieldWithDefault("socialNetworkConnections", $iv6Yc._1($jVmMx.Decode.array, $4WJAy.SocialNetworkConnection.fromJson), []), function(logoUrl, name, description, callToAction, socialNetworksLinks, socialNetworkConnections) {
    return {
        logoUrl: logoUrl,
        name: name,
        description: description,
        callToAction: callToAction,
        socialNetworksLinks: socialNetworksLinks,
        socialNetworkConnections: socialNetworkConnections
    };
});
var $7a0b63647ce1033d$var$include = $doJJK.Make({
    toJson: $7a0b63647ce1033d$export$d5b7a8bf56ee1fe2,
    fromJson: $7a0b63647ce1033d$export$7ae2d2a8b28a8cb8
});
var $7a0b63647ce1033d$export$9ac734aae7a92a2f = $1Efib.SocialNetwork;
var $7a0b63647ce1033d$export$e484e22f04591e42 = $1Efib.socialNetwork_encode;
var $7a0b63647ce1033d$export$f4ccf1f914f20b8b = $1Efib.socialNetwork_decode;
var $7a0b63647ce1033d$export$f623d33378fe95d9 = $4WJAy.SocialNetworkConnection;
var $7a0b63647ce1033d$export$476f111d50424bc5 = $4WJAy.socialNetworkConnection_encode;
var $7a0b63647ce1033d$export$3077b58d91da28a8 = $4WJAy.socialNetworkConnection_decode;
var $7a0b63647ce1033d$export$a264728fb17e7f22 = $iIV46.SocialNetworkLink;
var $7a0b63647ce1033d$export$9d7f48f48c6f19fc = $iIV46.socialNetworkLink_encode;
var $7a0b63647ce1033d$export$8f0f8cac64b2ba68 = $iIV46.socialNetworkLink_decode;
var $7a0b63647ce1033d$export$9438b36140854db6 = $1cVsx.CallToAction;
var $7a0b63647ce1033d$export$c95d60fac5ec910f = $1cVsx.callToAction_encode;
var $7a0b63647ce1033d$export$2c8cd572e69a9d0a = $1cVsx.callToAction_decode;
var $7a0b63647ce1033d$export$cc42ff7b6c615091 = $7a0b63647ce1033d$var$include.t_encode;
var $7a0b63647ce1033d$export$bb5e712207166a02 = $7a0b63647ce1033d$var$include.t_decode;
var $7a0b63647ce1033d$export$1c37c01eba8ed446 = $7a0b63647ce1033d$var$include.codec;
 /* fromJson Not a pure module */ 
});
parcelRegister("1cVsx", function(module, exports) {

$parcel$export(module.exports, "CallToAction", function () { return $0e137ba89e6c71c5$export$9438b36140854db6; });
$parcel$export(module.exports, "callToAction_encode", function () { return $0e137ba89e6c71c5$export$c95d60fac5ec910f; });
$parcel$export(module.exports, "callToAction_decode", function () { return $0e137ba89e6c71c5$export$2c8cd572e69a9d0a; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $79vie = parcelRequire("79vie");

var $AAkl8 = parcelRequire("AAkl8");

var $doJJK = parcelRequire("doJJK");
function $0e137ba89e6c71c5$var$toJson(param) {
    return $AAkl8.object([
        [
            "label",
            $AAkl8.string(param.label)
        ],
        [
            "url",
            $AAkl8.string(param.url)
        ]
    ]);
}
var $0e137ba89e6c71c5$var$fromJson = $79vie.map2($79vie.field("label", $79vie.string), $79vie.field("url", $79vie.string), function(label, url) {
    return {
        label: label,
        url: url
    };
});
var $0e137ba89e6c71c5$var$include = $doJJK.Make({
    toJson: $0e137ba89e6c71c5$var$toJson,
    fromJson: $0e137ba89e6c71c5$var$fromJson
});
var $0e137ba89e6c71c5$var$t_encode = $0e137ba89e6c71c5$var$include.t_encode;
var $0e137ba89e6c71c5$var$t_decode = $0e137ba89e6c71c5$var$include.t_decode;
var $0e137ba89e6c71c5$var$CallToAction_codec = $0e137ba89e6c71c5$var$include.codec;
var $0e137ba89e6c71c5$export$9438b36140854db6 = {
    toJson: $0e137ba89e6c71c5$var$toJson,
    fromJson: $0e137ba89e6c71c5$var$fromJson,
    t_encode: $0e137ba89e6c71c5$var$t_encode,
    t_decode: $0e137ba89e6c71c5$var$t_decode,
    codec: $0e137ba89e6c71c5$var$CallToAction_codec
};
var $0e137ba89e6c71c5$export$c95d60fac5ec910f = $0e137ba89e6c71c5$var$t_encode;
var $0e137ba89e6c71c5$export$2c8cd572e69a9d0a = $0e137ba89e6c71c5$var$t_decode;
 /* fromJson Not a pure module */ 
});

parcelRegister("1Efib", function(module, exports) {

$parcel$export(module.exports, "SocialNetwork", function () { return $1335639e2d357902$export$9ac734aae7a92a2f; });
$parcel$export(module.exports, "socialNetwork_encode", function () { return $1335639e2d357902$export$e484e22f04591e42; });
$parcel$export(module.exports, "socialNetwork_decode", function () { return $1335639e2d357902$export$f4ccf1f914f20b8b; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $jVmMx = parcelRequire("jVmMx");

var $doJJK = parcelRequire("doJJK");
var $1335639e2d357902$var$partial_arg = [
    [
        "Instagram",
        /* Instagram */ 0
    ],
    [
        "Tiktok",
        /* Tiktok */ 1
    ],
    [
        "Twitter",
        /* Twitter */ 2
    ],
    [
        "Facebook",
        /* Facebook */ 3
    ],
    [
        "Youtube",
        /* Youtube */ 4
    ]
];
function $1335639e2d357902$var$toJson(param) {
    return $jVmMx.Encode.simpleVariant($1335639e2d357902$var$partial_arg, param);
}
var $1335639e2d357902$var$fromJson = $jVmMx.Decode.simpleVariant([
    [
        "Instagram",
        /* Instagram */ 0
    ],
    [
        "Tiktok",
        /* Tiktok */ 1
    ],
    [
        "Twitter",
        /* Twitter */ 2
    ],
    [
        "Facebook",
        /* Facebook */ 3
    ],
    [
        "Youtube",
        /* Youtube */ 4
    ]
]);
var $1335639e2d357902$var$include = $doJJK.Make({
    toJson: $1335639e2d357902$var$toJson,
    fromJson: $1335639e2d357902$var$fromJson
});
var $1335639e2d357902$var$t_encode = $1335639e2d357902$var$include.t_encode;
var $1335639e2d357902$var$t_decode = $1335639e2d357902$var$include.t_decode;
var $1335639e2d357902$var$SocialNetwork_codec = $1335639e2d357902$var$include.codec;
var $1335639e2d357902$export$9ac734aae7a92a2f = {
    toJson: $1335639e2d357902$var$toJson,
    fromJson: $1335639e2d357902$var$fromJson,
    t_encode: $1335639e2d357902$var$t_encode,
    t_decode: $1335639e2d357902$var$t_decode,
    codec: $1335639e2d357902$var$SocialNetwork_codec
};
var $1335639e2d357902$export$e484e22f04591e42 = $1335639e2d357902$var$t_encode;
var $1335639e2d357902$export$f4ccf1f914f20b8b = $1335639e2d357902$var$t_decode;
 /* fromJson Not a pure module */ 
});

parcelRegister("iIV46", function(module, exports) {

$parcel$export(module.exports, "SocialNetworkLink", function () { return $da189a01c4e0e366$export$a264728fb17e7f22; });
$parcel$export(module.exports, "socialNetworkLink_encode", function () { return $da189a01c4e0e366$export$9d7f48f48c6f19fc; });
$parcel$export(module.exports, "socialNetworkLink_decode", function () { return $da189a01c4e0e366$export$8f0f8cac64b2ba68; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $jVmMx = parcelRequire("jVmMx");

var $doJJK = parcelRequire("doJJK");
function $da189a01c4e0e366$var$toJson(v) {
    switch(v.TAG | 0){
        case /* Instagram */ 0:
            return $jVmMx.Encode.deccoVariantWithPayload(v._0, "Instagram", $jVmMx.Encode.string);
        case /* Tiktok */ 1:
            return $jVmMx.Encode.deccoVariantWithPayload(v._0, "Tiktok", $jVmMx.Encode.string);
        case /* Twitter */ 2:
            return $jVmMx.Encode.deccoVariantWithPayload(v._0, "Twitter", $jVmMx.Encode.string);
        case /* Facebook */ 3:
            return $jVmMx.Encode.deccoVariantWithPayload(v._0, "Facebook", $jVmMx.Encode.string);
        case /* Youtube */ 4:
            return $jVmMx.Encode.deccoVariantWithPayload(v._0, "Youtube", $jVmMx.Encode.string);
    }
}
var $da189a01c4e0e366$var$fromJson = $iv6Yc._2($jVmMx.Decode.oneOf, $jVmMx.Decode.deccoVariantWithPayload("Instagram", $jVmMx.Decode.string, function(value) {
    return {
        TAG: /* Instagram */ 0,
        _0: value
    };
}), [
    $jVmMx.Decode.deccoVariantWithPayload("Tiktok", $jVmMx.Decode.string, function(value) {
        return {
            TAG: /* Tiktok */ 1,
            _0: value
        };
    }),
    $jVmMx.Decode.deccoVariantWithPayload("Twitter", $jVmMx.Decode.string, function(value) {
        return {
            TAG: /* Twitter */ 2,
            _0: value
        };
    }),
    $jVmMx.Decode.deccoVariantWithPayload("Facebook", $jVmMx.Decode.string, function(value) {
        return {
            TAG: /* Facebook */ 3,
            _0: value
        };
    }),
    $jVmMx.Decode.deccoVariantWithPayload("Youtube", $jVmMx.Decode.string, function(value) {
        return {
            TAG: /* Youtube */ 4,
            _0: value
        };
    })
]);
var $da189a01c4e0e366$var$include = $doJJK.Make({
    toJson: $da189a01c4e0e366$var$toJson,
    fromJson: $da189a01c4e0e366$var$fromJson
});
var $da189a01c4e0e366$var$t_encode = $da189a01c4e0e366$var$include.t_encode;
var $da189a01c4e0e366$var$t_decode = $da189a01c4e0e366$var$include.t_decode;
var $da189a01c4e0e366$var$SocialNetworkLink_codec = $da189a01c4e0e366$var$include.codec;
var $da189a01c4e0e366$export$a264728fb17e7f22 = {
    toJson: $da189a01c4e0e366$var$toJson,
    fromJson: $da189a01c4e0e366$var$fromJson,
    t_encode: $da189a01c4e0e366$var$t_encode,
    t_decode: $da189a01c4e0e366$var$t_decode,
    codec: $da189a01c4e0e366$var$SocialNetworkLink_codec
};
var $da189a01c4e0e366$export$9d7f48f48c6f19fc = $da189a01c4e0e366$var$t_encode;
var $da189a01c4e0e366$export$8f0f8cac64b2ba68 = $da189a01c4e0e366$var$t_decode;
 /* fromJson Not a pure module */ 
});

parcelRegister("4WJAy", function(module, exports) {

$parcel$export(module.exports, "SocialNetworkConnection", function () { return $399ff121f23a86ed$export$f623d33378fe95d9; });
$parcel$export(module.exports, "socialNetworkConnection_encode", function () { return $399ff121f23a86ed$export$476f111d50424bc5; });
$parcel$export(module.exports, "socialNetworkConnection_decode", function () { return $399ff121f23a86ed$export$3077b58d91da28a8; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $79vie = parcelRequire("79vie");

var $AAkl8 = parcelRequire("AAkl8");

var $doJJK = parcelRequire("doJJK");

var $1Efib = parcelRequire("1Efib");
function $399ff121f23a86ed$var$toJson(param) {
    return $AAkl8.object([
        [
            "handle",
            $AAkl8.string(param.handle)
        ],
        [
            "showPostDescription",
            $AAkl8.bool(param.showPostDescription)
        ],
        [
            "showLikes",
            $AAkl8.bool(param.showLikes)
        ],
        [
            "showViews",
            $AAkl8.bool(param.showViews)
        ],
        [
            "numOfPosts",
            $AAkl8.$$int(param.numOfPosts)
        ],
        [
            "socialNetwork",
            $iv6Yc._1($1Efib.SocialNetwork.toJson, param.socialNetwork)
        ]
    ]);
}
var $399ff121f23a86ed$var$fromJson = $79vie.map6($79vie.field("handle", $79vie.string), $79vie.field("showPostDescription", $79vie.bool), $79vie.field("showLikes", $79vie.bool), $79vie.field("showViews", $79vie.bool), $79vie.field("numOfPosts", $79vie.$$int), $79vie.field("socialNetwork", $1Efib.SocialNetwork.fromJson), function(handle, showPostDescription, showLikes, showViews, numOfPosts, socialNetwork) {
    return {
        handle: handle,
        showPostDescription: showPostDescription,
        showLikes: showLikes,
        showViews: showViews,
        numOfPosts: numOfPosts,
        socialNetwork: socialNetwork
    };
});
var $399ff121f23a86ed$var$include = $doJJK.Make({
    toJson: $399ff121f23a86ed$var$toJson,
    fromJson: $399ff121f23a86ed$var$fromJson
});
var $399ff121f23a86ed$var$t_encode = $399ff121f23a86ed$var$include.t_encode;
var $399ff121f23a86ed$var$t_decode = $399ff121f23a86ed$var$include.t_decode;
var $399ff121f23a86ed$var$SocialNetworkConnection_codec = $399ff121f23a86ed$var$include.codec;
var $399ff121f23a86ed$export$f623d33378fe95d9 = {
    toJson: $399ff121f23a86ed$var$toJson,
    fromJson: $399ff121f23a86ed$var$fromJson,
    t_encode: $399ff121f23a86ed$var$t_encode,
    t_decode: $399ff121f23a86ed$var$t_decode,
    codec: $399ff121f23a86ed$var$SocialNetworkConnection_codec
};
var $399ff121f23a86ed$export$476f111d50424bc5 = $399ff121f23a86ed$var$t_encode;
var $399ff121f23a86ed$export$3077b58d91da28a8 = $399ff121f23a86ed$var$t_decode;
 /* fromJson Not a pure module */ 
});


parcelRegister("1Gpco", function(module, exports) {

$parcel$export(module.exports, "Color", function () { return $139d42aaf4e6920e$export$892596cec99bc70e; });
$parcel$export(module.exports, "Px", function () { return $139d42aaf4e6920e$export$f1c8ff7305c3a8b7; });
$parcel$export(module.exports, "Font", function () { return $139d42aaf4e6920e$export$89abf52a030e56ee; });
$parcel$export(module.exports, "Art", function () { return $139d42aaf4e6920e$export$3be6e5a8e8158e24; });
$parcel$export(module.exports, "fromJson", function () { return $139d42aaf4e6920e$export$7ae2d2a8b28a8cb8; });
$parcel$export(module.exports, "reference_fromJson", function () { return $139d42aaf4e6920e$export$c09225d5aa9e9604; });
$parcel$export(module.exports, "empty", function () { return $139d42aaf4e6920e$export$6e22c362a0406a2c; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $jVmMx = parcelRequire("jVmMx");

var $3Wlzc = parcelRequire("3Wlzc");
var $139d42aaf4e6920e$var$fromJson = $jVmMx.Decode.string;
var $139d42aaf4e6920e$export$892596cec99bc70e = {
    fromJson: $139d42aaf4e6920e$var$fromJson
};
var $139d42aaf4e6920e$var$fromJson$1 = $jVmMx.Decode.string;
var $139d42aaf4e6920e$export$f1c8ff7305c3a8b7 = {
    fromJson: $139d42aaf4e6920e$var$fromJson$1
};
var $139d42aaf4e6920e$var$fromJson$2 = $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string);
var $139d42aaf4e6920e$var$FontFamily = {
    fromJson: $139d42aaf4e6920e$var$fromJson$2
};
var $139d42aaf4e6920e$var$fromJson$3 = $jVmMx.Decode.simpleVariant([
    [
        "WeightAuto",
        /* WeightAuto */ 0
    ],
    [
        "WeightThin",
        /* WeightThin */ 1
    ],
    [
        "WeightLight",
        /* WeightLight */ 2
    ],
    [
        "WeightNormal",
        /* WeightNormal */ 3
    ],
    [
        "WeightMedium",
        /* WeightMedium */ 4
    ],
    [
        "WeightSemiBold",
        /* WeightSemiBold */ 5
    ],
    [
        "WeightBold",
        /* WeightBold */ 6
    ]
]);
var $139d42aaf4e6920e$var$FontWeight = {
    fromJson: $139d42aaf4e6920e$var$fromJson$3
};
var $139d42aaf4e6920e$var$empty = {
    fontFamily: undefined,
    fontSizeScale: 1.0,
    fontWeight: /* WeightAuto */ 0
};
var $139d42aaf4e6920e$var$fromJson$4 = $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._1($jVmMx.Decode.succeed, function(fontFamily, fontSizeScale, fontWeight) {
    return {
        fontFamily: fontFamily,
        fontSizeScale: fontSizeScale,
        fontWeight: fontWeight
    };
}), $iv6Yc._2($jVmMx.Decode.field, "fontFamily", $139d42aaf4e6920e$var$fromJson$2)), $jVmMx.Decode.fieldWithDefault("fontSizeScale", $jVmMx.Decode.$$float, 1.0)), $jVmMx.Decode.fieldWithDefault("fontWeight", $139d42aaf4e6920e$var$fromJson$3, /* WeightAuto */ 0));
var $139d42aaf4e6920e$export$89abf52a030e56ee = {
    FontFamily: $139d42aaf4e6920e$var$FontFamily,
    FontWeight: $139d42aaf4e6920e$var$FontWeight,
    empty: $139d42aaf4e6920e$var$empty,
    fromJson: $139d42aaf4e6920e$var$fromJson$4
};
var $139d42aaf4e6920e$var$fromJson$5 = $iv6Yc._2($jVmMx.Decode.oneOf, $jVmMx.Decode.simpleVariant([
    [
        "NoArt",
        /* NoArt */ 0
    ]
]), [
    $jVmMx.Decode.deccoVariantWithPayload("GradientArt", $jVmMx.Decode.string, function(c) {
        return {
            TAG: /* GradientArt */ 0,
            _0: c
        };
    }),
    $jVmMx.Decode.deccoVariantWithPayload("ImageArt", $jVmMx.Decode.string, function(c) {
        return {
            TAG: /* ImageArt */ 1,
            _0: c
        };
    })
]);
var $139d42aaf4e6920e$export$3be6e5a8e8158e24 = {
    fromJson: $139d42aaf4e6920e$var$fromJson$5
};
var $139d42aaf4e6920e$export$7ae2d2a8b28a8cb8 = $iv6Yc._2($jVmMx.Decode.andThen, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._1($jVmMx.Decode.succeed, function(themeId, themeName, themeCreatedAt, themeUpdatedAt, primaryColor, secondaryColor, tertiaryColor, accentColor, backgroundColor, backgroundArt, placeholderColor, productPromoBackgroundColor, productPromoLabelColor, productPriceDiscountBackgroundColor, productPriceDiscountLabelColor, drawerLabelColor, drawerBackgroundColor, headingFont, bodyFont, buttonFont, roundedEdges, rowGutter, columnGutter, sectionVerticalPadding, sectionPaddingTop, sectionPaddingBottom) {
    return {
        themeId: themeId,
        themeName: themeName,
        themeCreatedAt: themeCreatedAt,
        themeUpdatedAt: themeUpdatedAt,
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        tertiaryColor: tertiaryColor,
        accentColor: accentColor,
        backgroundColor: backgroundColor,
        backgroundArt: backgroundArt,
        placeholderColor: placeholderColor,
        productPromoBackgroundColor: productPromoBackgroundColor,
        productPromoLabelColor: productPromoLabelColor,
        productPriceDiscountBackgroundColor: productPriceDiscountBackgroundColor,
        productPriceDiscountLabelColor: productPriceDiscountLabelColor,
        drawerBackgroundColor: drawerBackgroundColor,
        drawerLabelColor: drawerLabelColor,
        headingFont: headingFont,
        bodyFont: bodyFont,
        buttonFont: buttonFont,
        roundedEdges: roundedEdges,
        rowGutter: rowGutter,
        columnGutter: columnGutter,
        sectionVerticalPadding: sectionVerticalPadding,
        sectionPaddingTop: sectionPaddingTop,
        sectionPaddingBottom: sectionPaddingBottom
    };
}), $iv6Yc._2($jVmMx.Decode.field, "themeId", $3Wlzc.fromJson)), $jVmMx.Decode.fieldWithDefault("themeName", $jVmMx.Decode.string, "")), $jVmMx.Decode.fieldWithDefault("themeCreatedAt", $jVmMx.Decode.$$float, 0)), $jVmMx.Decode.fieldWithDefault("themeUpdatedAt", $jVmMx.Decode.$$float, 0)), $jVmMx.Decode.fieldWithDefault("primaryColor", $139d42aaf4e6920e$var$fromJson, "")), $jVmMx.Decode.fieldWithDefault("secondaryColor", $139d42aaf4e6920e$var$fromJson, "")), $jVmMx.Decode.fieldWithDefault("tertiaryColor", $139d42aaf4e6920e$var$fromJson, "")), $jVmMx.Decode.fieldWithDefault("accentColor", $139d42aaf4e6920e$var$fromJson, "")), $jVmMx.Decode.fieldWithDefault("backgroundColor", $139d42aaf4e6920e$var$fromJson, "")), $jVmMx.Decode.fieldWithDefault("backgroundArt", $139d42aaf4e6920e$var$fromJson$5, /* NoArt */ 0)), $jVmMx.Decode.fieldWithDefault("placeholderColor", $139d42aaf4e6920e$var$fromJson, "")), $jVmMx.Decode.fieldWithDefault("productPromoBackgroundColor", $139d42aaf4e6920e$var$fromJson, "")), $jVmMx.Decode.fieldWithDefault("productPromoLabelColor", $139d42aaf4e6920e$var$fromJson, "")), $jVmMx.Decode.fieldWithDefault("productPriceDiscountBackgroundColor", $139d42aaf4e6920e$var$fromJson, "")), $jVmMx.Decode.fieldWithDefault("productPriceDiscountLabelColor", $139d42aaf4e6920e$var$fromJson, "")), $jVmMx.Decode.fieldWithDefault("drawerLabelColor", $139d42aaf4e6920e$var$fromJson, "")), $jVmMx.Decode.fieldWithDefault("drawerBackgroundColor", $139d42aaf4e6920e$var$fromJson, "")), $jVmMx.Decode.fieldWithDefault("headingFont", $139d42aaf4e6920e$var$fromJson$4, $139d42aaf4e6920e$var$empty)), $jVmMx.Decode.fieldWithDefault("bodyFont", $139d42aaf4e6920e$var$fromJson$4, $139d42aaf4e6920e$var$empty)), $jVmMx.Decode.fieldWithDefault("buttonFont", $139d42aaf4e6920e$var$fromJson$4, $139d42aaf4e6920e$var$empty)), $jVmMx.Decode.fieldWithDefault("roundedEdges", $139d42aaf4e6920e$var$fromJson$1, "0px")), $jVmMx.Decode.fieldWithDefault("rowGutter", $139d42aaf4e6920e$var$fromJson$1, "45px")), $jVmMx.Decode.fieldWithDefault("columnGutter", $139d42aaf4e6920e$var$fromJson$1, "12px")), $jVmMx.Decode.fieldWithDefault("sectionVerticalPadding", $139d42aaf4e6920e$var$fromJson$1, "0px")), $jVmMx.Decode.fieldWithDefault("sectionPaddingTop", $iv6Yc._1($jVmMx.Decode.nullable, $139d42aaf4e6920e$var$fromJson$1), undefined)), $jVmMx.Decode.fieldWithDefault("sectionPaddingBottom", $iv6Yc._1($jVmMx.Decode.nullable, $139d42aaf4e6920e$var$fromJson$1), undefined)), function(result) {
    return $iv6Yc._1($jVmMx.Decode.succeed, result);
});
var $139d42aaf4e6920e$export$c09225d5aa9e9604 = $iv6Yc._2($jVmMx.Decode.oneOf, $jVmMx.Decode.simpleVariant([
    [
        "LegacyTheme",
        /* LegacyTheme */ 0
    ]
]), [
    $jVmMx.Decode.deccoVariantWithPayload("LinkedTheme", $3Wlzc.fromJson, function(c) {
        return /* LinkedTheme */ {
            _0: c
        };
    })
]);
var $139d42aaf4e6920e$var$empty_themeId = $iv6Yc._1($3Wlzc.fromString, "empty");
var $139d42aaf4e6920e$var$empty_headingFont = {
    fontFamily: undefined,
    fontSizeScale: 1.0,
    fontWeight: /* WeightAuto */ 0
};
var $139d42aaf4e6920e$var$empty_bodyFont = {
    fontFamily: undefined,
    fontSizeScale: 1.0,
    fontWeight: /* WeightAuto */ 0
};
var $139d42aaf4e6920e$var$empty_buttonFont = {
    fontFamily: undefined,
    fontSizeScale: 1.0,
    fontWeight: /* WeightAuto */ 0
};
var $139d42aaf4e6920e$export$6e22c362a0406a2c = {
    themeId: $139d42aaf4e6920e$var$empty_themeId,
    themeName: "",
    themeCreatedAt: 0,
    themeUpdatedAt: 0,
    primaryColor: "#111827",
    secondaryColor: "#374151",
    tertiaryColor: "#6B7280",
    accentColor: "#000000",
    backgroundColor: "#ffffff",
    backgroundArt: /* NoArt */ 0,
    placeholderColor: "#F3F4F6",
    productPromoBackgroundColor: "#F3F4F6",
    productPromoLabelColor: "#111827",
    productPriceDiscountBackgroundColor: "#dc2626",
    productPriceDiscountLabelColor: "#ffffff",
    drawerBackgroundColor: "#ffffff",
    drawerLabelColor: "#111827",
    headingFont: $139d42aaf4e6920e$var$empty_headingFont,
    bodyFont: $139d42aaf4e6920e$var$empty_bodyFont,
    buttonFont: $139d42aaf4e6920e$var$empty_buttonFont,
    roundedEdges: "4px",
    rowGutter: "45px",
    columnGutter: "12px",
    sectionVerticalPadding: "0px",
    sectionPaddingTop: undefined,
    sectionPaddingBottom: undefined
};
 /* fromJson Not a pure module */ 
});

parcelRegister("dRfYk", function(module, exports) {

$parcel$export(module.exports, "toJson", function () { return $a16c9d4c2cb6102f$export$d5b7a8bf56ee1fe2; });
$parcel$export(module.exports, "fromJson", function () { return $a16c9d4c2cb6102f$export$7ae2d2a8b28a8cb8; });
$parcel$export(module.exports, "toString", function () { return $a16c9d4c2cb6102f$export$f84e8e69fd4488a5; });
$parcel$export(module.exports, "fromString", function () { return $a16c9d4c2cb6102f$export$3004f64547af360e; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $ki9MN = parcelRequire("ki9MN");
var $a16c9d4c2cb6102f$export$46b83a6aabf254e3 = $ki9MN.Make({});
var $a16c9d4c2cb6102f$export$bb5e712207166a02 = $a16c9d4c2cb6102f$export$46b83a6aabf254e3.t_decode;
var $a16c9d4c2cb6102f$export$cc42ff7b6c615091 = $a16c9d4c2cb6102f$export$46b83a6aabf254e3.t_encode;
var $a16c9d4c2cb6102f$export$d5b7a8bf56ee1fe2 = $a16c9d4c2cb6102f$export$46b83a6aabf254e3.toJson;
var $a16c9d4c2cb6102f$export$7ae2d2a8b28a8cb8 = $a16c9d4c2cb6102f$export$46b83a6aabf254e3.fromJson;
var $a16c9d4c2cb6102f$export$f84e8e69fd4488a5 = $a16c9d4c2cb6102f$export$46b83a6aabf254e3.toString;
var $a16c9d4c2cb6102f$export$3004f64547af360e = $a16c9d4c2cb6102f$export$46b83a6aabf254e3.fromString;
 /* Id Not a pure module */ 
});

parcelRegister("f1TVX", function(module, exports) {

$parcel$export(module.exports, "toJson", function () { return $af12564938624f73$export$d5b7a8bf56ee1fe2; });
$parcel$export(module.exports, "fromJson", function () { return $af12564938624f73$export$7ae2d2a8b28a8cb8; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $2whNH = parcelRequire("2whNH");

var $jVmMx = parcelRequire("jVmMx");

var $doJJK = parcelRequire("doJJK");

var $dRfYk = parcelRequire("dRfYk");
function $af12564938624f73$export$3e4db5ef97444133(param) {
    return $iv6Yc._1($jVmMx.Encode.object, [
        [
            "disable",
            $iv6Yc._1($jVmMx.Encode.bool, param.disable)
        ],
        [
            "image",
            $jVmMx.Encode.nullable(param.image, $jVmMx.Encode.string)
        ],
        [
            "smallImage",
            $jVmMx.Encode.nullable(param.smallImage, $jVmMx.Encode.string)
        ],
        [
            "link",
            $jVmMx.Encode.nullable(param.link, $jVmMx.Encode.string)
        ],
        [
            "customScript",
            $jVmMx.Encode.nullable(param.customScript, $jVmMx.Encode.string)
        ],
        [
            "customAction",
            $jVmMx.Encode.nullable(param.customAction, $dRfYk.toJson)
        ]
    ]);
}
var $af12564938624f73$export$236903ff01f632a8 = $iv6Yc._7($jVmMx.Decode.map6, $jVmMx.Decode.fieldWithDefault("disable", $jVmMx.Decode.bool, false), $iv6Yc._2($jVmMx.Decode.field, "image", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string)), $iv6Yc._2($jVmMx.Decode.field, "smallImage", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string)), $iv6Yc._2($jVmMx.Decode.field, "link", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string)), $iv6Yc._2($jVmMx.Decode.field, "customScript", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string)), $iv6Yc._2($jVmMx.Decode.field, "customAction", $iv6Yc._1($jVmMx.Decode.option, $dRfYk.fromJson)), function(disable, image, smallImage, link, customScript, customAction) {
    return {
        disable: disable,
        image: image,
        smallImage: smallImage,
        link: link,
        customScript: customScript,
        customAction: customAction
    };
});
function $af12564938624f73$export$d5b7a8bf56ee1fe2(param) {
    return $iv6Yc._1($jVmMx.Encode.object, [
        [
            "label",
            $iv6Yc._1($jVmMx.Encode.string, param.label)
        ],
        [
            "image",
            $jVmMx.Encode.nullable(param.image, $jVmMx.Encode.string)
        ],
        [
            "smallImage",
            $jVmMx.Encode.nullable(param.smallImage, $jVmMx.Encode.string)
        ],
        [
            "link",
            $jVmMx.Encode.nullable(param.link, $jVmMx.Encode.string)
        ],
        [
            "overrides",
            $jVmMx.Encode.nullable(param.overrides, function(__x) {
                return $jVmMx.Encode.dictWithEncoder(__x, $af12564938624f73$export$3e4db5ef97444133);
            })
        ],
        [
            "excludeCategoryIds",
            $iv6Yc._2($jVmMx.Encode.array, param.excludeCategoryIds, $jVmMx.Encode.string)
        ],
        [
            "customScript",
            $jVmMx.Encode.nullable(param.customScript, $jVmMx.Encode.string)
        ],
        [
            "customAction",
            $jVmMx.Encode.nullable(param.customAction, $dRfYk.toJson)
        ]
    ]);
}
var $af12564938624f73$export$7ae2d2a8b28a8cb8 = $iv6Yc.app($jVmMx.Decode.map8, [
    $jVmMx.Decode.fieldWithDefault("label", $jVmMx.Decode.string, "Size Guide"),
    $iv6Yc._2($jVmMx.Decode.field, "image", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string)),
    $iv6Yc._2($jVmMx.Decode.field, "smallImage", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string)),
    $iv6Yc._2($jVmMx.Decode.field, "link", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string)),
    $iv6Yc._2($jVmMx.Decode.field, "overrides", $iv6Yc._1($jVmMx.Decode.option, $iv6Yc._1($jVmMx.Decode.dict, $af12564938624f73$export$236903ff01f632a8))),
    $jVmMx.Decode.fieldWithDefault("excludeCategoryIds", $iv6Yc._1($jVmMx.Decode.array, $jVmMx.Decode.string), []),
    $iv6Yc._2($jVmMx.Decode.field, "customScript", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string)),
    $iv6Yc._2($jVmMx.Decode.field, "customAction", $iv6Yc._1($jVmMx.Decode.option, $dRfYk.fromJson)),
    function(label, image, smallImage, link, overrides, excludeCategoryIds, customScript, customAction) {
        return {
            label: label,
            image: image,
            smallImage: smallImage,
            link: link,
            overrides: overrides,
            excludeCategoryIds: excludeCategoryIds,
            customScript: customScript,
            customAction: customAction
        };
    }
]);
var $af12564938624f73$var$empty_excludeCategoryIds = [];
var $af12564938624f73$export$6e22c362a0406a2c = {
    label: "Size Guide",
    image: undefined,
    smallImage: undefined,
    link: undefined,
    overrides: undefined,
    excludeCategoryIds: $af12564938624f73$var$empty_excludeCategoryIds,
    customScript: undefined,
    customAction: undefined
};
function $af12564938624f73$export$8dcf39a7a23517d9(t) {
    var disable = $2whNH.isNone(t.image) && $2whNH.isNone(t.smallImage) && $2whNH.isNone(t.link);
    return {
        disable: disable,
        image: t.image,
        smallImage: t.smallImage,
        link: t.link,
        customScript: t.customScript,
        customAction: t.customAction
    };
}
function $af12564938624f73$export$a07654da0f40bacb(templateOpt, subset) {
    var template = templateOpt !== undefined ? templateOpt : $af12564938624f73$export$6e22c362a0406a2c;
    return {
        label: template.label,
        image: subset.image,
        smallImage: subset.smallImage,
        link: subset.link,
        overrides: template.overrides,
        excludeCategoryIds: template.excludeCategoryIds,
        customScript: subset.customScript,
        customAction: subset.customAction
    };
}
var $af12564938624f73$var$include = $doJJK.Make({
    toJson: $af12564938624f73$export$d5b7a8bf56ee1fe2,
    fromJson: $af12564938624f73$export$7ae2d2a8b28a8cb8
});
var $af12564938624f73$export$668a436e0b5aab94 = {
    disable: false,
    image: undefined,
    smallImage: undefined,
    link: undefined,
    customScript: undefined,
    customAction: undefined
};
var $af12564938624f73$export$cc42ff7b6c615091 = $af12564938624f73$var$include.t_encode;
var $af12564938624f73$export$bb5e712207166a02 = $af12564938624f73$var$include.t_decode;
var $af12564938624f73$export$1c37c01eba8ed446 = $af12564938624f73$var$include.codec;
 /* subset_decode Not a pure module */ 
});

parcelRegister("dT0m1", function(module, exports) {

$parcel$export(module.exports, "fromJson", function () { return $a1c0afc6a41cf2ea$export$7ae2d2a8b28a8cb8; });
$parcel$export(module.exports, "toJson", function () { return $a1c0afc6a41cf2ea$export$d5b7a8bf56ee1fe2; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $i7mYY = parcelRequire("i7mYY");

var $79vie = parcelRequire("79vie");

var $5oEIZ = parcelRequire("5oEIZ");

var $doJJK = parcelRequire("doJJK");
var $a1c0afc6a41cf2ea$export$7ae2d2a8b28a8cb8 = $79vie.andThen($79vie.string, function(str) {
    var parts = $i7mYY.keepMap(str.split($5oEIZ.separator), function(part) {
        switch(part){
            case "add_to_cart":
                return "add_to_cart";
            case "custom_action":
                return "custom_action";
            case "open_link":
                return "open_link";
            default:
                return;
        }
    });
    var match = $i7mYY.get(parts, 0);
    var match$1 = $i7mYY.get(parts, 1);
    var match$2 = $i7mYY.get(parts, 2);
    if (match !== undefined) {
        if (match$1 !== undefined) return $79vie.succeed([
            match$1,
            match,
            match$2
        ]);
        else if (match$2 !== undefined) return $79vie.fail("CTAButtons '" + str + "' is not supported.");
        else return $79vie.succeed([
            match,
            undefined,
            undefined
        ]);
    } else return $79vie.fail("CTAButtons '" + str + "' is not supported.");
});
var $a1c0afc6a41cf2ea$var$include = $doJJK.Make({
    toJson: $5oEIZ.t_encode,
    fromJson: $a1c0afc6a41cf2ea$export$7ae2d2a8b28a8cb8
});
var $a1c0afc6a41cf2ea$export$d5b7a8bf56ee1fe2 = $5oEIZ.t_encode;
var $a1c0afc6a41cf2ea$export$cc42ff7b6c615091 = $a1c0afc6a41cf2ea$var$include.t_encode;
var $a1c0afc6a41cf2ea$export$bb5e712207166a02 = $a1c0afc6a41cf2ea$var$include.t_decode;
var $a1c0afc6a41cf2ea$export$1c37c01eba8ed446 = $a1c0afc6a41cf2ea$var$include.codec;
 /* fromJson Not a pure module */ 
});
parcelRegister("5oEIZ", function(module, exports) {

$parcel$export(module.exports, "separator", function () { return $3edec8b28ff099de$export$3e523c77c1f23f8c; });
$parcel$export(module.exports, "t_encode", function () { return $3edec8b28ff099de$export$cc42ff7b6c615091; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $3zjNo = parcelRequire("3zjNo");

var $1ArWc = parcelRequire("1ArWc");

var $i7mYY = parcelRequire("i7mYY");
var $3edec8b28ff099de$export$3e523c77c1f23f8c = " + ";
function $3edec8b28ff099de$export$cc42ff7b6c615091(input) {
    var secondary = input[1];
    var primary = input[0];
    if (secondary !== undefined) {
        var tertiary = input[2];
        if (tertiary !== undefined) return secondary + $3edec8b28ff099de$export$3e523c77c1f23f8c + primary + $3edec8b28ff099de$export$3e523c77c1f23f8c + tertiary;
        else return secondary + $3edec8b28ff099de$export$3e523c77c1f23f8c + primary;
    }
    var secondary$1 = input[2];
    if (secondary$1 !== undefined) return secondary$1 + $3edec8b28ff099de$export$3e523c77c1f23f8c + primary;
    else return primary;
}
function $3edec8b28ff099de$export$bb5e712207166a02(json) {
    var str = $1ArWc.classify(json);
    if (typeof str === "number") return $3zjNo.error(undefined, "Trying to decode a field that is not a string to CTAButtons", json);
    if (str.TAG !== /* JSONString */ 0) return $3zjNo.error(undefined, "Trying to decode a field that is not a string to CTAButtons", json);
    var str$1 = str._0;
    var parts = $i7mYY.keepMap(str$1.split($3edec8b28ff099de$export$3e523c77c1f23f8c), function(part) {
        switch(part){
            case "add_to_cart":
                return "add_to_cart";
            case "custom_action":
                return "custom_action";
            case "open_link":
                return "open_link";
            default:
                return;
        }
    });
    var match = $i7mYY.get(parts, 0);
    var match$1 = $i7mYY.get(parts, 1);
    var match$2 = $i7mYY.get(parts, 2);
    if (match !== undefined) {
        if (match$1 !== undefined) return {
            TAG: /* Ok */ 0,
            _0: [
                match$1,
                match,
                match$2
            ]
        };
        if (match$2 === undefined) return {
            TAG: /* Ok */ 0,
            _0: [
                match,
                undefined,
                undefined
            ]
        };
    }
    return $3zjNo.error(undefined, "CTAButtons '" + str$1 + "' is not supported.", json);
}
 /* No side effect */ 
});


parcelRegister("crJlr", function(module, exports) {

$parcel$export(module.exports, "fromJson", function () { return $90fb2e32b228b062$export$7ae2d2a8b28a8cb8; });
$parcel$export(module.exports, "Button", function () { return $90fb2e32b228b062$export$353f5b6fc5456de1; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $jVmMx = parcelRequire("jVmMx");

var $doJJK = parcelRequire("doJJK");

var $dRfYk = parcelRequire("dRfYk");
function $90fb2e32b228b062$export$d5b7a8bf56ee1fe2(param) {
    return $iv6Yc._1($jVmMx.Encode.object, [
        [
            "id",
            $iv6Yc._1($dRfYk.toJson, param.id)
        ],
        [
            "name",
            $iv6Yc._1($jVmMx.Encode.string, param.name)
        ],
        [
            "onClickFn",
            $jVmMx.Encode.nullable(param.onClickFn, $jVmMx.Encode.string)
        ],
        [
            "renderFn",
            $jVmMx.Encode.nullable(param.renderFn, $jVmMx.Encode.string)
        ],
        [
            "addToCart",
            $iv6Yc._1($jVmMx.Encode.bool, param.addToCart)
        ]
    ]);
}
var $90fb2e32b228b062$export$7ae2d2a8b28a8cb8 = $iv6Yc._6($jVmMx.Decode.map5, $iv6Yc._2($jVmMx.Decode.field, "id", $dRfYk.fromJson), $iv6Yc._2($jVmMx.Decode.field, "name", $jVmMx.Decode.string), $iv6Yc._2($jVmMx.Decode.field, "onClickFn", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string)), $iv6Yc._2($jVmMx.Decode.field, "renderFn", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string)), $iv6Yc._2($jVmMx.Decode.field, "addToCart", $jVmMx.Decode.bool), function(id, name, onClickFn, renderFn, addToCart) {
    return {
        id: id,
        name: name,
        onClickFn: onClickFn,
        renderFn: renderFn,
        addToCart: addToCart
    };
});
var $90fb2e32b228b062$var$include = $doJJK.Make({
    toJson: $90fb2e32b228b062$export$d5b7a8bf56ee1fe2,
    fromJson: $90fb2e32b228b062$export$7ae2d2a8b28a8cb8
});
function $90fb2e32b228b062$var$toJson$1(param) {
    return $iv6Yc._1($jVmMx.Encode.object, [
        [
            "id",
            $jVmMx.Encode.nullable(param.id, $dRfYk.toJson)
        ],
        [
            "textColor",
            $jVmMx.Encode.nullable(param.textColor, $jVmMx.Encode.string)
        ],
        [
            "bgColor",
            $jVmMx.Encode.nullable(param.bgColor, $jVmMx.Encode.string)
        ],
        [
            "label",
            $jVmMx.Encode.nullable(param.label, $jVmMx.Encode.string)
        ],
        [
            "confirmation",
            $jVmMx.Encode.nullable(param.confirmation, $jVmMx.Encode.string)
        ]
    ]);
}
var $90fb2e32b228b062$var$fromJson$1 = $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._1($jVmMx.Decode.succeed, function(id, textColor, bgColor, label, confirmation) {
    return {
        id: id,
        textColor: textColor,
        bgColor: bgColor,
        label: label,
        confirmation: confirmation
    };
}), $iv6Yc._2($jVmMx.Decode.field, "id", $iv6Yc._1($jVmMx.Decode.option, $dRfYk.fromJson))), $jVmMx.Decode.fieldWithDefault("textColor", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string), undefined)), $jVmMx.Decode.fieldWithDefault("bgColor", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string), undefined)), $jVmMx.Decode.fieldWithDefault("label", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string), undefined)), $jVmMx.Decode.fieldWithDefault("confirmation", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string), undefined));
var $90fb2e32b228b062$var$include$1 = $doJJK.Make({
    toJson: $90fb2e32b228b062$var$toJson$1,
    fromJson: $90fb2e32b228b062$var$fromJson$1
});
var $90fb2e32b228b062$var$Button_defaults = {
    id: undefined,
    textColor: "#ffffff",
    bgColor: "#000000",
    label: "Add to Cart",
    confirmation: "Added to cart!"
};
var $90fb2e32b228b062$var$Button_t_encode = $90fb2e32b228b062$var$include$1.t_encode;
var $90fb2e32b228b062$var$Button_t_decode = $90fb2e32b228b062$var$include$1.t_decode;
var $90fb2e32b228b062$var$Button_codec = $90fb2e32b228b062$var$include$1.codec;
var $90fb2e32b228b062$export$353f5b6fc5456de1 = {
    toJson: $90fb2e32b228b062$var$toJson$1,
    fromJson: $90fb2e32b228b062$var$fromJson$1,
    defaults: $90fb2e32b228b062$var$Button_defaults,
    t_encode: $90fb2e32b228b062$var$Button_t_encode,
    t_decode: $90fb2e32b228b062$var$Button_t_decode,
    codec: $90fb2e32b228b062$var$Button_codec
};
var $90fb2e32b228b062$export$cc42ff7b6c615091 = $90fb2e32b228b062$var$include.t_encode;
var $90fb2e32b228b062$export$bb5e712207166a02 = $90fb2e32b228b062$var$include.t_decode;
var $90fb2e32b228b062$export$1c37c01eba8ed446 = $90fb2e32b228b062$var$include.codec;
 /* fromJson Not a pure module */ 
});

parcelRegister("7lqRw", function(module, exports) {

$parcel$export(module.exports, "reference_toJson", function () { return $558f54d51306072b$export$b959f71adeda4ed6; });
$parcel$export(module.exports, "reference_fromJson", function () { return $558f54d51306072b$export$c09225d5aa9e9604; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $jVmMx = parcelRequire("jVmMx");

var $iCR57 = parcelRequire("iCR57");
function $558f54d51306072b$export$3da5ea18781e244d(t) {
    if (typeof t === "number") return $jVmMx.Encode.simpleVariant([
        [
            "Unknown",
            /* Unknown */ 0
        ]
    ], /* Unknown */ 0);
    switch(t.TAG | 0){
        case /* String */ 0:
            return $jVmMx.Encode.deccoVariantWithPayload(t._0, "String", $jVmMx.Encode.string);
        case /* Number */ 1:
            return $jVmMx.Encode.deccoVariantWithPayload(t._0, "Number", $jVmMx.Encode.$$float);
        case /* Boolean */ 2:
            return $jVmMx.Encode.deccoVariantWithPayload(t._0, "Boolean", $jVmMx.Encode.bool);
    }
}
var $558f54d51306072b$export$673e52a1ed88e3a6 = $iv6Yc._2($jVmMx.Decode.oneOf, $jVmMx.Decode.deccoVariantWithPayload("String", $jVmMx.Decode.string, function(s) {
    return {
        TAG: /* String */ 0,
        _0: s
    };
}), [
    $jVmMx.Decode.deccoVariantWithPayload("Number", $jVmMx.Decode.$$float, function(f) {
        return {
            TAG: /* Number */ 1,
            _0: f
        };
    }),
    $jVmMx.Decode.deccoVariantWithPayload("Boolean", $jVmMx.Decode.bool, function(b) {
        return {
            TAG: /* Boolean */ 2,
            _0: b
        };
    }),
    $jVmMx.Decode.simpleVariant([
        [
            "Unknown",
            /* Unknown */ 0
        ]
    ])
]);
function $558f54d51306072b$export$b959f71adeda4ed6(t) {
    return $iv6Yc._1($jVmMx.Encode.object, [
        [
            "id",
            $iv6Yc._1($iCR57.toJson, t.id)
        ],
        [
            "name",
            $iv6Yc._1($jVmMx.Encode.string, t.name)
        ],
        [
            "version",
            $iv6Yc._1($jVmMx.Encode.string, t.version)
        ],
        [
            "componentUrl",
            $iv6Yc._1($jVmMx.Encode.string, t.componentUrl)
        ],
        [
            "props",
            $jVmMx.Encode.dictWithEncoder(t.props, $558f54d51306072b$export$3da5ea18781e244d)
        ]
    ]);
}
var $558f54d51306072b$export$c09225d5aa9e9604 = $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._1($jVmMx.Decode.succeed, function(id, name, version, componentUrl, props) {
    return {
        id: id,
        name: name,
        version: version,
        componentUrl: componentUrl,
        props: props
    };
}), $iv6Yc._2($jVmMx.Decode.field, "id", $iCR57.fromJson)), $iv6Yc._2($jVmMx.Decode.field, "name", $jVmMx.Decode.string)), $iv6Yc._2($jVmMx.Decode.field, "version", $jVmMx.Decode.string)), $iv6Yc._2($jVmMx.Decode.field, "componentUrl", $jVmMx.Decode.string)), $jVmMx.Decode.fieldWithDefault("props", $iv6Yc._1($jVmMx.Decode.dict, $558f54d51306072b$export$673e52a1ed88e3a6), {}));
 /* propValue_fromJson Not a pure module */ 
});
parcelRegister("iCR57", function(module, exports) {

$parcel$export(module.exports, "toString", function () { return $d8f4f37f97a840d0$export$f84e8e69fd4488a5; });
$parcel$export(module.exports, "fromJson", function () { return $d8f4f37f97a840d0$export$7ae2d2a8b28a8cb8; });
$parcel$export(module.exports, "toJson", function () { return $d8f4f37f97a840d0$export$d5b7a8bf56ee1fe2; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $ki9MN = parcelRequire("ki9MN");
var $d8f4f37f97a840d0$export$391a5bbc85d0d67d = $ki9MN.Make({});
var $d8f4f37f97a840d0$export$bb5e712207166a02 = $d8f4f37f97a840d0$export$391a5bbc85d0d67d.t_decode;
var $d8f4f37f97a840d0$export$cc42ff7b6c615091 = $d8f4f37f97a840d0$export$391a5bbc85d0d67d.t_encode;
var $d8f4f37f97a840d0$export$3004f64547af360e = $d8f4f37f97a840d0$export$391a5bbc85d0d67d.fromString;
var $d8f4f37f97a840d0$export$f84e8e69fd4488a5 = $d8f4f37f97a840d0$export$391a5bbc85d0d67d.toString;
var $d8f4f37f97a840d0$export$7ae2d2a8b28a8cb8 = $d8f4f37f97a840d0$export$391a5bbc85d0d67d.fromJson;
var $d8f4f37f97a840d0$export$d5b7a8bf56ee1fe2 = $d8f4f37f97a840d0$export$391a5bbc85d0d67d.toJson;
 /* CustomComponentId Not a pure module */ 
});


parcelRegister("eaePg", function(module, exports) {

$parcel$export(module.exports, "toJson", function () { return $a4fd7ff2ead7aa09$export$d5b7a8bf56ee1fe2; });
$parcel$export(module.exports, "fromJson", function () { return $a4fd7ff2ead7aa09$export$7ae2d2a8b28a8cb8; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $jVmMx = parcelRequire("jVmMx");

var $doJJK = parcelRequire("doJJK");
var $a4fd7ff2ead7aa09$var$partial_arg = [
    [
        "FirstVariant",
        /* FirstVariant */ 0
    ],
    [
        "HighestPriceVariant",
        /* HighestPriceVariant */ 1
    ],
    [
        "LowestPriceVariant",
        /* LowestPriceVariant */ 2
    ],
    [
        "HighestDiscountVariant",
        /* HighestDiscountVariant */ 3
    ]
];
function $a4fd7ff2ead7aa09$export$d5b7a8bf56ee1fe2(param) {
    return $jVmMx.Encode.simpleVariant($a4fd7ff2ead7aa09$var$partial_arg, param);
}
var $a4fd7ff2ead7aa09$export$7ae2d2a8b28a8cb8 = $jVmMx.Decode.simpleVariant([
    [
        "FirstVariant",
        /* FirstVariant */ 0
    ],
    [
        "HighestPriceVariant",
        /* HighestPriceVariant */ 1
    ],
    [
        "LowestPriceVariant",
        /* LowestPriceVariant */ 2
    ],
    [
        "HighestDiscountVariant",
        /* HighestDiscountVariant */ 3
    ]
]);
var $a4fd7ff2ead7aa09$var$include = $doJJK.Make({
    toJson: $a4fd7ff2ead7aa09$export$d5b7a8bf56ee1fe2,
    fromJson: $a4fd7ff2ead7aa09$export$7ae2d2a8b28a8cb8
});
var $a4fd7ff2ead7aa09$export$cc42ff7b6c615091 = $a4fd7ff2ead7aa09$var$include.t_encode;
var $a4fd7ff2ead7aa09$export$bb5e712207166a02 = $a4fd7ff2ead7aa09$var$include.t_decode;
var $a4fd7ff2ead7aa09$export$1c37c01eba8ed446 = $a4fd7ff2ead7aa09$var$include.codec;
 /* fromJson Not a pure module */ 
});

parcelRegister("ij6do", function(module, exports) {

$parcel$export(module.exports, "CardSize", function () { return $d53ed27e8c71ce82$export$93c0382b74e40ff9; });
$parcel$export(module.exports, "Link", function () { return $d53ed27e8c71ce82$export$a6c7ac8248d6e38a; });
$parcel$export(module.exports, "CategoryCard", function () { return $d53ed27e8c71ce82$export$5fbe069c73ec3073; });
$parcel$export(module.exports, "ExternalConnection", function () { return $d53ed27e8c71ce82$export$9b7d2686799c37a; });
$parcel$export(module.exports, "layout_fromJson", function () { return $d53ed27e8c71ce82$export$4e73ccac02f50c1c; });
$parcel$export(module.exports, "linkCategory_fromJson", function () { return $d53ed27e8c71ce82$export$4447e9406ed8729a; });
$parcel$export(module.exports, "categoryType_fromJson", function () { return $d53ed27e8c71ce82$export$9ebb77ea9091af9c; });
$parcel$export(module.exports, "category_fromJson", function () { return $d53ed27e8c71ce82$export$66ee41028aa2b6df; });
$parcel$export(module.exports, "taggedMedia_fromJson", function () { return $d53ed27e8c71ce82$export$c9a9d5efc52cc0e9; });
$parcel$export(module.exports, "taggedMediaSource_fromJson", function () { return $d53ed27e8c71ce82$export$b6ac0a9f368576b6; });
$parcel$export(module.exports, "quickviewCategory_fromJson", function () { return $d53ed27e8c71ce82$export$5855298e525169e0; });
$parcel$export(module.exports, "indexCategory_fromJson", function () { return $d53ed27e8c71ce82$export$b1fdf50be3d3b56a; });
$parcel$export(module.exports, "customComponentCategory_fromJson", function () { return $d53ed27e8c71ce82$export$ec0974398445544b; });
$parcel$export(module.exports, "configEmbedCategory_fromJson", function () { return $d53ed27e8c71ce82$export$34cabec5ccdcad25; });
$parcel$export(module.exports, "fromJson", function () { return $d53ed27e8c71ce82$export$7ae2d2a8b28a8cb8; });
$parcel$export(module.exports, "Page", function () { return $d53ed27e8c71ce82$export$6955bcca4cd3539f; });
$parcel$export(module.exports, "empty", function () { return $d53ed27e8c71ce82$export$6e22c362a0406a2c; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $79vie = parcelRequire("79vie");

var $bYadz = parcelRequire("bYadz");

var $jVmMx = parcelRequire("jVmMx");

var $1Gpco = parcelRequire("1Gpco");

var $dRfYk = parcelRequire("dRfYk");

var $aNn17 = parcelRequire("aNn17");

var $cXBWA = parcelRequire("cXBWA");

var $7lqRw = parcelRequire("7lqRw");

var $ZzK4r = parcelRequire("ZzK4r");

var $7Qe3X = parcelRequire("7Qe3X");

var $5lwUf = parcelRequire("5lwUf");

var $04dLg = parcelRequire("04dLg");

var $kM5sF = parcelRequire("kM5sF");

var $fnO65 = parcelRequire("fnO65");

var $cvFfT = parcelRequire("cvFfT");

var $5kJL4 = parcelRequire("5kJL4");
var $d53ed27e8c71ce82$var$fromJson = $jVmMx.Decode.simpleVariant([
    [
        "Xxxs",
        /* Xxxs */ 0
    ],
    [
        "Xxs",
        /* Xxs */ 1
    ],
    [
        "Xs",
        /* Xs */ 2
    ],
    [
        "Sm",
        /* Sm */ 3
    ],
    [
        "Md",
        /* Md */ 4
    ],
    [
        "Lg",
        /* Lg */ 5
    ],
    [
        "Xl",
        /* Xl */ 6
    ],
    [
        "Xxl",
        /* Xxl */ 7
    ],
    [
        "Xxxl",
        /* Xxxl */ 8
    ],
    [
        "Xxxxl",
        /* Xxxxl */ 9
    ],
    [
        "Xxxxxl",
        /* Xxxxxl */ 10
    ]
]);
var $d53ed27e8c71ce82$export$93c0382b74e40ff9 = {
    fromJson: $d53ed27e8c71ce82$var$fromJson
};
var $d53ed27e8c71ce82$var$categoryLink_fromJson = $iv6Yc._3($jVmMx.Decode.map2, $iv6Yc._2($jVmMx.Decode.field, "categoryId", $jVmMx.Decode.string), $jVmMx.Decode.fieldWithDefault("filters", $iv6Yc._1($jVmMx.Decode.option, $bYadz.fromJson), undefined), function(categoryId, filters) {
    return {
        categoryId: categoryId,
        filters: filters
    };
});
var $d53ed27e8c71ce82$var$productLink_fromJson = $iv6Yc._4($jVmMx.Decode.map3, $iv6Yc._2($jVmMx.Decode.field, "productId", $jVmMx.Decode.string), $jVmMx.Decode.fieldWithDefault("variantId", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string), undefined), $jVmMx.Decode.fieldWithDefault("productCategoryId", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string), undefined), function(productId, variantId, productCategoryId) {
    return {
        productId: productId,
        variantId: variantId,
        productCategoryId: productCategoryId
    };
});
var $d53ed27e8c71ce82$var$storeCategoryLink_fromJson = $iv6Yc._5($jVmMx.Decode.map4, $iv6Yc._2($jVmMx.Decode.field, "categoryId", $jVmMx.Decode.string), $jVmMx.Decode.fieldWithDefault("sortBy", $04dLg.ProductSortOrder.fromJson, /* Default */ 0), $iv6Yc._2($jVmMx.Decode.field, "count", $jVmMx.Decode.$$int), $jVmMx.Decode.fieldWithDefault("relatedMediaCount", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.$$int), undefined), function(categoryId, sortBy, count, relatedMediaCount) {
    return {
        categoryId: categoryId,
        sortBy: sortBy,
        count: count,
        relatedMediaCount: relatedMediaCount
    };
});
var $d53ed27e8c71ce82$var$customActionLink_fromJson = $iv6Yc._4($jVmMx.Decode.map3, $iv6Yc._2($jVmMx.Decode.field, "customActionId", $dRfYk.fromJson), $iv6Yc._2($jVmMx.Decode.field, "code", $jVmMx.Decode.string), $iv6Yc._2($jVmMx.Decode.field, "name", $jVmMx.Decode.string), function(customActionId, code, name) {
    return {
        customActionId: customActionId,
        code: code,
        name: name
    };
});
var $d53ed27e8c71ce82$var$fromJson$1 = $iv6Yc._2($jVmMx.Decode.oneOf, $jVmMx.Decode.deccoVariantWithPayload("URL", $jVmMx.Decode.string, function(str) {
    return {
        TAG: /* URL */ 0,
        _0: str
    };
}), [
    $jVmMx.Decode.deccoVariantWithPayload("Category", $d53ed27e8c71ce82$var$categoryLink_fromJson, function(str) {
        return {
            TAG: /* Category */ 1,
            _0: str
        };
    }),
    $jVmMx.Decode.deccoVariantWithPayload("Product", $d53ed27e8c71ce82$var$productLink_fromJson, function(str) {
        return {
            TAG: /* Product */ 2,
            _0: str
        };
    }),
    $jVmMx.Decode.deccoVariantWithPayload("StoreCategory", $d53ed27e8c71ce82$var$storeCategoryLink_fromJson, function(str) {
        return {
            TAG: /* StoreCategory */ 3,
            _0: str
        };
    }),
    $jVmMx.Decode.deccoVariantWithPayload("CustomAction", $d53ed27e8c71ce82$var$customActionLink_fromJson, function(str) {
        return {
            TAG: /* CustomAction */ 4,
            _0: str
        };
    })
]);
var $d53ed27e8c71ce82$export$a6c7ac8248d6e38a = {
    fromJson: $d53ed27e8c71ce82$var$fromJson$1
};
var $d53ed27e8c71ce82$var$videoCard_fromJson = $iv6Yc._8($jVmMx.Decode.map7, $jVmMx.Decode.fieldWithDefault("link", $iv6Yc._1($jVmMx.Decode.option, $d53ed27e8c71ce82$var$fromJson$1), undefined), $jVmMx.Decode.fieldWithDefault("size", $d53ed27e8c71ce82$var$fromJson, /* Lg */ 5), $jVmMx.Decode.fieldWithDefault("shape", $5kJL4.cardShape_fromJson, /* Square */ 1), $iv6Yc._2($jVmMx.Decode.field, "videoUrl", $jVmMx.Decode.string), $jVmMx.Decode.fieldWithDefault("width", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.$$int), undefined), $jVmMx.Decode.fieldWithDefault("height", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.$$int), undefined), $jVmMx.Decode.fieldWithDefault("fallbackImageUrl", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string), undefined), function(link, size, shape, videoUrl, width, height, fallbackImageUrl) {
    return {
        link: link,
        size: size,
        shape: shape,
        videoUrl: videoUrl,
        width: width,
        height: height,
        fallbackImageUrl: fallbackImageUrl
    };
});
var $d53ed27e8c71ce82$var$imageCard_fromJson = $iv6Yc._7($jVmMx.Decode.map6, $jVmMx.Decode.fieldWithDefault("link", $iv6Yc._1($jVmMx.Decode.option, $d53ed27e8c71ce82$var$fromJson$1), undefined), $jVmMx.Decode.fieldWithDefault("size", $d53ed27e8c71ce82$var$fromJson, /* Lg */ 5), $jVmMx.Decode.fieldWithDefault("shape", $5kJL4.cardShape_fromJson, /* Square */ 1), $iv6Yc._2($jVmMx.Decode.field, "imageUrl", $jVmMx.Decode.string), $jVmMx.Decode.fieldWithDefault("width", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.$$int), undefined), $jVmMx.Decode.fieldWithDefault("height", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.$$int), undefined), function(link, size, shape, imageUrl, width, height) {
    return {
        link: link,
        size: size,
        shape: shape,
        imageUrl: imageUrl,
        width: width,
        height: height
    };
});
var $d53ed27e8c71ce82$var$imageLinkCard_fromJson = $iv6Yc._5($jVmMx.Decode.map4, $iv6Yc._2($jVmMx.Decode.field, "link", $d53ed27e8c71ce82$var$fromJson$1), $iv6Yc._2($jVmMx.Decode.field, "imageUrl", $jVmMx.Decode.string), $jVmMx.Decode.fieldWithDefault("size", $d53ed27e8c71ce82$var$fromJson, /* Lg */ 5), $jVmMx.Decode.fieldWithDefault("shape", $5kJL4.cardShape_fromJson, /* Square */ 1), function(link, imageUrl, size, shape) {
    return {
        link: link,
        imageUrl: imageUrl,
        size: size,
        shape: shape
    };
});
var $d53ed27e8c71ce82$var$videoLinkCard_fromJson = $iv6Yc._6($jVmMx.Decode.map5, $iv6Yc._2($jVmMx.Decode.field, "link", $d53ed27e8c71ce82$var$fromJson$1), $iv6Yc._2($jVmMx.Decode.field, "videoUrl", $jVmMx.Decode.string), $jVmMx.Decode.fieldWithDefault("size", $d53ed27e8c71ce82$var$fromJson, /* Lg */ 5), $jVmMx.Decode.fieldWithDefault("shape", $5kJL4.cardShape_fromJson, /* Square */ 1), $jVmMx.Decode.fieldWithDefault("fallbackImageUrl", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string), undefined), function(link, videoUrl, size, shape, fallbackImageUrl) {
    return {
        link: link,
        videoUrl: videoUrl,
        size: size,
        shape: shape,
        fallbackImageUrl: fallbackImageUrl
    };
});
var $d53ed27e8c71ce82$var$medialessCard_fromJson = $iv6Yc._4($jVmMx.Decode.map3, $iv6Yc._2($jVmMx.Decode.field, "link", $iv6Yc._1($jVmMx.Decode.option, $d53ed27e8c71ce82$var$fromJson$1)), $jVmMx.Decode.fieldWithDefault("size", $d53ed27e8c71ce82$var$fromJson, /* Lg */ 5), $jVmMx.Decode.fieldWithDefault("shape", $5kJL4.cardShape_fromJson, /* Square */ 1), function(link, size, shape) {
    return {
        link: link,
        size: size,
        shape: shape
    };
});
var $d53ed27e8c71ce82$var$medialessLinkCard_fromJson = $iv6Yc._4($jVmMx.Decode.map3, $iv6Yc._2($jVmMx.Decode.field, "link", $d53ed27e8c71ce82$var$fromJson$1), $jVmMx.Decode.fieldWithDefault("size", $d53ed27e8c71ce82$var$fromJson, /* Lg */ 5), $jVmMx.Decode.fieldWithDefault("shape", $5kJL4.cardShape_fromJson, /* Square */ 1), function(link, size, shape) {
    return {
        link: link,
        size: size,
        shape: shape
    };
});
var $d53ed27e8c71ce82$var$imageDisplayCard_fromJson = $iv6Yc._4($jVmMx.Decode.map3, $iv6Yc._2($jVmMx.Decode.field, "imageUrl", $jVmMx.Decode.string), $jVmMx.Decode.fieldWithDefault("size", $d53ed27e8c71ce82$var$fromJson, /* Lg */ 5), $jVmMx.Decode.fieldWithDefault("shape", $5kJL4.cardShape_fromJson, /* Square */ 1), function(imageUrl, size, shape) {
    return {
        imageUrl: imageUrl,
        size: size,
        shape: shape
    };
});
var $d53ed27e8c71ce82$var$videoDisplayCard_fromJson = $iv6Yc._5($jVmMx.Decode.map4, $iv6Yc._2($jVmMx.Decode.field, "videoUrl", $jVmMx.Decode.string), $jVmMx.Decode.fieldWithDefault("size", $d53ed27e8c71ce82$var$fromJson, /* Lg */ 5), $jVmMx.Decode.fieldWithDefault("shape", $5kJL4.cardShape_fromJson, /* Square */ 1), $iv6Yc._2($jVmMx.Decode.field, "fallbackImageUrl", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string)), function(videoUrl, size, shape, fallbackImageUrl) {
    return {
        videoUrl: videoUrl,
        size: size,
        shape: shape,
        fallbackImageUrl: fallbackImageUrl
    };
});
var $d53ed27e8c71ce82$var$fromJson$2 = $iv6Yc._2($jVmMx.Decode.oneOf, $jVmMx.Decode.deccoVariantWithPayload("ImageLinkCard", $d53ed27e8c71ce82$var$imageLinkCard_fromJson, function(payload) {
    return {
        TAG: /* ImageLinkCard */ 0,
        _0: payload
    };
}), [
    $jVmMx.Decode.deccoVariantWithPayload("VideoLinkCard", $d53ed27e8c71ce82$var$videoLinkCard_fromJson, function(payload) {
        return {
            TAG: /* VideoLinkCard */ 1,
            _0: payload
        };
    }),
    $jVmMx.Decode.deccoVariantWithPayload("ImageCard", $d53ed27e8c71ce82$var$imageCard_fromJson, function(payload) {
        return {
            TAG: /* ImageCard */ 2,
            _0: payload
        };
    }),
    $jVmMx.Decode.deccoVariantWithPayload("VideoCard", $d53ed27e8c71ce82$var$videoCard_fromJson, function(payload) {
        return {
            TAG: /* VideoCard */ 3,
            _0: payload
        };
    }),
    $jVmMx.Decode.deccoVariantWithPayload("MedialessCard", $d53ed27e8c71ce82$var$medialessCard_fromJson, function(payload) {
        return {
            TAG: /* MedialessCard */ 4,
            _0: payload
        };
    }),
    $jVmMx.Decode.deccoVariantWithPayload("MedialessLinkCard", $d53ed27e8c71ce82$var$medialessLinkCard_fromJson, function(payload) {
        return {
            TAG: /* MedialessLinkCard */ 5,
            _0: payload
        };
    }),
    $jVmMx.Decode.deccoVariantWithPayload("ImageDisplayCard", $d53ed27e8c71ce82$var$imageDisplayCard_fromJson, function(payload) {
        return {
            TAG: /* ImageDisplayCard */ 6,
            _0: payload
        };
    }),
    $jVmMx.Decode.deccoVariantWithPayload("VideoDisplayCard", $d53ed27e8c71ce82$var$videoDisplayCard_fromJson, function(payload) {
        return {
            TAG: /* VideoDisplayCard */ 7,
            _0: payload
        };
    })
]);
var $d53ed27e8c71ce82$export$5fbe069c73ec3073 = {
    videoCard_fromJson: $d53ed27e8c71ce82$var$videoCard_fromJson,
    imageCard_fromJson: $d53ed27e8c71ce82$var$imageCard_fromJson,
    imageLinkCard_fromJson: $d53ed27e8c71ce82$var$imageLinkCard_fromJson,
    videoLinkCard_fromJson: $d53ed27e8c71ce82$var$videoLinkCard_fromJson,
    medialessCard_fromJson: $d53ed27e8c71ce82$var$medialessCard_fromJson,
    medialessLinkCard_fromJson: $d53ed27e8c71ce82$var$medialessLinkCard_fromJson,
    imageDisplayCard_fromJson: $d53ed27e8c71ce82$var$imageDisplayCard_fromJson,
    videoDisplayCard_fromJson: $d53ed27e8c71ce82$var$videoDisplayCard_fromJson,
    fromJson: $d53ed27e8c71ce82$var$fromJson$2
};
var $d53ed27e8c71ce82$var$storeCategoryConnection_fromJson = $iv6Yc._6($jVmMx.Decode.map5, $iv6Yc._2($jVmMx.Decode.field, "categoryId", $jVmMx.Decode.string), $iv6Yc._2($jVmMx.Decode.field, "sortBy", $kM5sF.ProductSortOrder.fromJson), $jVmMx.Decode.fieldWithDefault("filterBy", $iv6Yc._1($jVmMx.Decode.option, $iv6Yc._1($jVmMx.Decode.array, $jVmMx.Decode.string)), undefined), $iv6Yc._2($jVmMx.Decode.field, "count", $jVmMx.Decode.$$int), $jVmMx.Decode.fieldWithDefault("relatedMediaCount", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.$$int), undefined), function(categoryId, sortBy, filterBy, count, relatedMediaCount) {
    return {
        categoryId: categoryId,
        sortBy: sortBy,
        filterBy: filterBy,
        count: count,
        relatedMediaCount: relatedMediaCount
    };
});
var $d53ed27e8c71ce82$var$configEmbedConnection_fromJson = $iv6Yc._2($jVmMx.Decode.map, $iv6Yc._2($jVmMx.Decode.field, "configId", $jVmMx.Decode.string), function(configId) {
    return {
        configId: configId
    };
});
var $d53ed27e8c71ce82$var$fromJson$3 = $iv6Yc._2($jVmMx.Decode.oneOf, $jVmMx.Decode.deccoVariantWithPayload("StoreCategory", $d53ed27e8c71ce82$var$storeCategoryConnection_fromJson, function(payload) {
    return {
        TAG: /* StoreCategory */ 0,
        _0: payload
    };
}), [
    $jVmMx.Decode.deccoVariantWithPayload("ConfigEmbed", $d53ed27e8c71ce82$var$configEmbedConnection_fromJson, function(payload) {
        return {
            TAG: /* ConfigEmbed */ 1,
            _0: payload
        };
    }),
    $jVmMx.Decode.simpleVariant([
        [
            "History",
            /* History */ 0
        ]
    ]),
    $jVmMx.Decode.simpleVariant([
        [
            "Favorites",
            /* Favorites */ 1
        ]
    ]),
    $jVmMx.Decode.simpleVariant([
        [
            "StoreCart",
            /* StoreCart */ 2
        ]
    ])
]);
var $d53ed27e8c71ce82$var$t_v1_fromJson = $iv6Yc._2($jVmMx.Decode.andThen, $d53ed27e8c71ce82$var$storeCategoryConnection_fromJson, function(connection) {
    return $iv6Yc._1($jVmMx.Decode.succeed, {
        TAG: /* StoreCategory */ 0,
        _0: connection
    });
});
var $d53ed27e8c71ce82$var$fromJson$4 = $79vie.oneOf($d53ed27e8c71ce82$var$fromJson$3, [
    $d53ed27e8c71ce82$var$t_v1_fromJson
]);
var $d53ed27e8c71ce82$export$9b7d2686799c37a = {
    storeCategoryConnection_fromJson: $d53ed27e8c71ce82$var$storeCategoryConnection_fromJson,
    configEmbedConnection_fromJson: $d53ed27e8c71ce82$var$configEmbedConnection_fromJson,
    t_v1_fromJson: $d53ed27e8c71ce82$var$t_v1_fromJson,
    fromJson: $d53ed27e8c71ce82$var$fromJson$4
};
var $d53ed27e8c71ce82$export$4e73ccac02f50c1c = $iv6Yc._2($jVmMx.Decode.oneOf, $jVmMx.Decode.deccoVariantWithPayload("SubCategoriesSlider", $5kJL4.sliderPayload_fromJson, function(payload) {
    return {
        TAG: /* SubCategoriesSlider */ 0,
        _0: payload
    };
}), [
    $jVmMx.Decode.deccoVariantWithPayload("SubCategoriesSliderWithHeader", $5kJL4.sliderPayload_fromJson, function(payload) {
        return {
            TAG: /* SubCategoriesSliderWithHeader */ 1,
            _0: payload
        };
    }),
    $jVmMx.Decode.deccoVariantWithPayload("SubCategoriesGrid", $5kJL4.gridPayload_fromJson, function(payload) {
        return {
            TAG: /* SubCategoriesGrid */ 2,
            _0: payload
        };
    }),
    $jVmMx.Decode.deccoVariantWithPayload("ProductGrid", $5kJL4.gridPayload_fromJson, function(payload) {
        return {
            TAG: /* ProductGrid */ 3,
            _0: payload
        };
    }),
    $jVmMx.Decode.deccoVariantWithPayload("ProductSlider", $5kJL4.sliderPayload_fromJson, function(payload) {
        return {
            TAG: /* ProductSlider */ 4,
            _0: payload
        };
    }),
    $jVmMx.Decode.simpleVariant([
        [
            "NoLayout",
            /* NoLayout */ 0
        ]
    ])
]);
var $d53ed27e8c71ce82$export$4447e9406ed8729a = $iv6Yc._4($jVmMx.Decode.map3, $iv6Yc._2($jVmMx.Decode.field, "link", $jVmMx.Decode.string), $jVmMx.Decode.fieldWithDefault("imageWidth", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.$$int), undefined), $jVmMx.Decode.fieldWithDefault("imageHeight", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.$$int), undefined), function(link, imageWidth, imageHeight) {
    return {
        link: link,
        imageWidth: imageWidth,
        imageHeight: imageHeight
    };
});
function $d53ed27e8c71ce82$var$fromJson$5(param) {
    return $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._1($jVmMx.Decode.succeed, function(id, title, description, showTitle, showDescription, visible, visibleInMenuBar, visibleInSectionList, visibleInParent, visibleInHeaderSlider, listPageActiveLayout, userSelectedLayout, forcedPLPLayout, tabbedSubCategories, card, categoryType, socialNetworkSource, displayPriority, expandVariantsInProductsListing, lastModifiedAt, sectionTheme, pageTheme, stickySection) {
        return {
            id: id,
            title: title,
            description: description,
            showTitle: showTitle,
            showDescription: showDescription,
            visible: visible,
            visibleInMenuBar: visibleInMenuBar,
            visibleInSectionList: visibleInSectionList,
            visibleInParent: visibleInParent,
            visibleInHeaderSlider: visibleInHeaderSlider,
            listPageActiveLayout: listPageActiveLayout,
            userSelectedLayout: userSelectedLayout,
            forcedPLPLayout: forcedPLPLayout,
            tabbedSubCategories: tabbedSubCategories,
            card: card,
            categoryType: categoryType,
            socialNetworkSource: socialNetworkSource,
            displayPriority: displayPriority,
            expandVariantsInProductsListing: expandVariantsInProductsListing,
            lastModifiedAt: lastModifiedAt,
            sectionTheme: sectionTheme,
            pageTheme: pageTheme,
            stickySection: stickySection
        };
    }), $iv6Yc._2($jVmMx.Decode.field, "id", $jVmMx.Decode.string)), $jVmMx.Decode.fieldWithDefault("title", $jVmMx.Decode.string, "")), $jVmMx.Decode.fieldWithDefault("description", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string), undefined)), $jVmMx.Decode.fieldWithDefault("showTitle", $jVmMx.Decode.bool, true)), $jVmMx.Decode.fieldWithDefault("showDescription", $jVmMx.Decode.bool, true)), $jVmMx.Decode.fieldWithDefault("visible", $jVmMx.Decode.bool, true)), $jVmMx.Decode.fieldWithDefault("visibleInMenuBar", $jVmMx.Decode.bool, true)), $jVmMx.Decode.fieldWithDefault("visibleInSectionList", $jVmMx.Decode.bool, true)), $jVmMx.Decode.fieldWithDefault("visibleInParent", $jVmMx.Decode.bool, true)), $jVmMx.Decode.fieldWithDefault("visibleInHeaderSlider", $jVmMx.Decode.bool, true)), $jVmMx.Decode.fieldWithDefault("listPageActiveLayout", $d53ed27e8c71ce82$export$4e73ccac02f50c1c, /* NoLayout */ 0)), $jVmMx.Decode.fieldWithDefault("userSelectedLayout", $d53ed27e8c71ce82$export$4e73ccac02f50c1c, /* NoLayout */ 0)), $jVmMx.Decode.fieldWithDefault("forcedPLPLayout", $d53ed27e8c71ce82$export$4e73ccac02f50c1c, /* NoLayout */ 0)), $jVmMx.Decode.fieldWithDefault("tabbedSubCategories", $iv6Yc._1($jVmMx.Decode.option, $fnO65.CategoryTabSettings.fromJson), undefined)), $iv6Yc._2($jVmMx.Decode.field, "card", $d53ed27e8c71ce82$var$fromJson$2)), $iv6Yc._2($jVmMx.Decode.field, "categoryType", $d53ed27e8c71ce82$export$9ebb77ea9091af9c(undefined))), $jVmMx.Decode.fieldWithDefault("socialNetworkSource", $iv6Yc._1($jVmMx.Decode.option, $cvFfT.SocialNetworkSource.fromJson), undefined)), $jVmMx.Decode.fieldWithDefault("displayPriority", $5lwUf.DisplayPriority.fromJson, /* ChildrenFirst */ 0)), $jVmMx.Decode.fieldWithDefault("expandVariantsInProductsListing", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.bool), undefined)), $jVmMx.Decode.fieldWithDefault("lastModifiedAt", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.$$float), undefined)), $jVmMx.Decode.fieldWithDefault("sectionTheme", $1Gpco.reference_fromJson, /* LegacyTheme */ 0)), $jVmMx.Decode.fieldWithDefault("pageTheme", $1Gpco.reference_fromJson, /* LegacyTheme */ 0)), $jVmMx.Decode.fieldWithDefault("stickySection", $jVmMx.Decode.bool, false));
}
function $d53ed27e8c71ce82$export$66ee41028aa2b6df(param) {
    return $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._1($jVmMx.Decode.succeed, function(firstCard, externalConnection, children, loadMoreChildren, totalChildren, link, products, taggedMedia, imageHotspots, imageWidth, imageHeight) {
        return {
            firstCard: firstCard,
            externalConnection: externalConnection,
            children: children,
            loadMoreChildren: loadMoreChildren,
            totalChildren: totalChildren,
            link: link,
            products: products,
            taggedMedia: taggedMedia,
            imageHotspots: imageHotspots,
            imageWidth: imageWidth,
            imageHeight: imageHeight
        };
    }), $jVmMx.Decode.fieldWithDefault("firstCard", $iv6Yc._1($jVmMx.Decode.option, $d53ed27e8c71ce82$var$fromJson$2), undefined)), $jVmMx.Decode.fieldWithDefault("externalConnection", $iv6Yc._1($jVmMx.Decode.option, $d53ed27e8c71ce82$var$fromJson$4), undefined)), $iv6Yc._2($jVmMx.Decode.field, "children", $iv6Yc._1($jVmMx.Decode.array, $jVmMx.Decode.lazy_(function(param) {
        return $d53ed27e8c71ce82$var$fromJson$5(undefined);
    })))), $jVmMx.Decode.fieldWithDefault("loadMoreChildren", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string), undefined)), $jVmMx.Decode.fieldWithDefault("totalChildren", $jVmMx.Decode.$$int, 0)), $jVmMx.Decode.fieldWithDefault("link", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string), undefined)), $jVmMx.Decode.fieldWithDefault("products", $7Qe3X.TaggedProducts.fromJson, [])), $jVmMx.Decode.fieldWithDefault("taggedMedia", $iv6Yc._1($jVmMx.Decode.option, $d53ed27e8c71ce82$export$c9a9d5efc52cc0e9(undefined)), undefined)), $jVmMx.Decode.fieldWithDefault("imageHotspots", $iv6Yc._1($jVmMx.Decode.option, $iv6Yc._1($jVmMx.Decode.array, $cXBWA.fromJson)), undefined)), $jVmMx.Decode.fieldWithDefault("imageWidth", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.$$int), undefined)), $jVmMx.Decode.fieldWithDefault("imageHeight", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.$$int), undefined));
}
function $d53ed27e8c71ce82$export$b6ac0a9f368576b6(param) {
    return $79vie.oneOf($jVmMx.Decode.deccoVariantWithPayload("Manual", $79vie.array($jVmMx.Decode.lazy_(function(param) {
        return $d53ed27e8c71ce82$var$fromJson$5(undefined);
    })), function(payload) {
        return /* Manual */ {
            _0: payload
        };
    }), []);
}
function $d53ed27e8c71ce82$export$c9a9d5efc52cc0e9(param) {
    return $iv6Yc._8($jVmMx.Decode.map7, $iv6Yc._2($jVmMx.Decode.field, "source", $d53ed27e8c71ce82$export$b6ac0a9f368576b6(undefined)), $jVmMx.Decode.fieldWithDefault("displayType", $ZzK4r.TaggedMedia.displayType_fromJson, /* InlineDisplay */ 0), $jVmMx.Decode.fieldWithDefault("cardWidth", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.$$int), undefined), $jVmMx.Decode.fieldWithDefault("cardHeight", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.$$int), undefined), $jVmMx.Decode.fieldWithDefault("startRowOffset", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.$$int), undefined), $jVmMx.Decode.fieldWithDefault("slidesPerView", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.$$float), undefined), $jVmMx.Decode.fieldWithDefault("imageFit", $ZzK4r.TaggedMedia.imageFit_fromJson, /* FitCover */ 0), function(source, displayType, cardWidth, cardHeight, startRowOffset, slidesPerView, imageFit) {
        return {
            source: source,
            displayType: displayType,
            cardWidth: cardWidth,
            cardHeight: cardHeight,
            startRowOffset: startRowOffset,
            slidesPerView: slidesPerView,
            imageFit: imageFit
        };
    });
}
function $d53ed27e8c71ce82$export$5855298e525169e0(param) {
    return $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._1($jVmMx.Decode.succeed, function(isStories, isPinned, firstCard, externalConnection, children, loadMoreChildren, totalChildren, link, products, imageHotspots, imageWidth, imageHeight) {
        return {
            isStories: isStories,
            isPinned: isPinned,
            firstCard: firstCard,
            externalConnection: externalConnection,
            children: children,
            loadMoreChildren: loadMoreChildren,
            totalChildren: totalChildren,
            link: link,
            products: products,
            imageHotspots: imageHotspots,
            imageWidth: imageWidth,
            imageHeight: imageHeight
        };
    }), $jVmMx.Decode.fieldWithDefault("isStories", $jVmMx.Decode.bool, false)), $jVmMx.Decode.fieldWithDefault("isPinned", $jVmMx.Decode.bool, false)), $jVmMx.Decode.fieldWithDefault("firstCard", $iv6Yc._1($jVmMx.Decode.option, $d53ed27e8c71ce82$var$fromJson$2), undefined)), $jVmMx.Decode.fieldWithDefault("externalConnection", $iv6Yc._1($jVmMx.Decode.option, $d53ed27e8c71ce82$var$fromJson$4), undefined)), $iv6Yc._2($jVmMx.Decode.field, "children", $iv6Yc._1($jVmMx.Decode.array, $jVmMx.Decode.lazy_(function(param) {
        return $d53ed27e8c71ce82$var$fromJson$5(undefined);
    })))), $jVmMx.Decode.fieldWithDefault("loadMoreChildren", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string), undefined)), $jVmMx.Decode.fieldWithDefault("totalChildren", $jVmMx.Decode.$$int, 0)), $jVmMx.Decode.fieldWithDefault("link", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string), undefined)), $jVmMx.Decode.fieldWithDefault("products", $7Qe3X.TaggedProducts.fromJson, [])), $jVmMx.Decode.fieldWithDefault("imageHotspots", $iv6Yc._1($jVmMx.Decode.option, $iv6Yc._1($jVmMx.Decode.array, $cXBWA.fromJson)), undefined)), $jVmMx.Decode.fieldWithDefault("imageWidth", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.$$int), undefined)), $jVmMx.Decode.fieldWithDefault("imageHeight", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.$$int), undefined));
}
function $d53ed27e8c71ce82$export$b1fdf50be3d3b56a(param) {
    return $iv6Yc._4($jVmMx.Decode.map3, $jVmMx.Decode.fieldWithDefault("externalConnection", $iv6Yc._1($jVmMx.Decode.option, $d53ed27e8c71ce82$var$fromJson$4), undefined), $jVmMx.Decode.fieldWithDefault("taggedMedia", $iv6Yc._1($jVmMx.Decode.option, $d53ed27e8c71ce82$export$c9a9d5efc52cc0e9(undefined)), undefined), $jVmMx.Decode.fieldWithDefault("products", $7Qe3X.TaggedProducts.fromJson, []), function(externalConnection, taggedMedia, products) {
        return {
            externalConnection: externalConnection,
            taggedMedia: taggedMedia,
            products: products
        };
    });
}
function $d53ed27e8c71ce82$export$ec0974398445544b(param) {
    return $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._1($jVmMx.Decode.succeed, function(component) {
        return {
            component: component
        };
    }), $iv6Yc._2($jVmMx.Decode.field, "component", $7lqRw.reference_fromJson));
}
function $d53ed27e8c71ce82$export$34cabec5ccdcad25(param) {
    return $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._1($jVmMx.Decode.succeed, function(firstCard, configId, children, loadMoreChildren, totalChildren, link, products, taggedMedia, imageHotspots, imageWidth, imageHeight) {
        return {
            firstCard: firstCard,
            configId: configId,
            children: children,
            loadMoreChildren: loadMoreChildren,
            totalChildren: totalChildren,
            link: link,
            products: products,
            taggedMedia: taggedMedia,
            imageHotspots: imageHotspots,
            imageWidth: imageWidth,
            imageHeight: imageHeight
        };
    }), $jVmMx.Decode.fieldWithDefault("firstCard", $iv6Yc._1($jVmMx.Decode.option, $d53ed27e8c71ce82$var$fromJson$2), undefined)), $iv6Yc._2($jVmMx.Decode.field, "configId", $jVmMx.Decode.string)), $iv6Yc._2($jVmMx.Decode.field, "children", $iv6Yc._1($jVmMx.Decode.array, $jVmMx.Decode.lazy_(function(param) {
        return $d53ed27e8c71ce82$var$fromJson$5(undefined);
    })))), $jVmMx.Decode.fieldWithDefault("loadMoreChildren", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string), undefined)), $jVmMx.Decode.fieldWithDefault("totalChildren", $jVmMx.Decode.$$int, 0)), $jVmMx.Decode.fieldWithDefault("link", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string), undefined)), $jVmMx.Decode.fieldWithDefault("products", $7Qe3X.TaggedProducts.fromJson, [])), $jVmMx.Decode.fieldWithDefault("taggedMedia", $iv6Yc._1($jVmMx.Decode.option, $d53ed27e8c71ce82$export$c9a9d5efc52cc0e9(undefined)), undefined)), $jVmMx.Decode.fieldWithDefault("imageHotspots", $iv6Yc._1($jVmMx.Decode.option, $iv6Yc._1($jVmMx.Decode.array, $cXBWA.fromJson)), undefined)), $jVmMx.Decode.fieldWithDefault("imageWidth", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.$$int), undefined)), $jVmMx.Decode.fieldWithDefault("imageHeight", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.$$int), undefined));
}
function $d53ed27e8c71ce82$export$9ebb77ea9091af9c(param) {
    return $iv6Yc._2($jVmMx.Decode.oneOf, $jVmMx.Decode.deccoVariantWithPayload("Link", $d53ed27e8c71ce82$export$4447e9406ed8729a, function(payload) {
        return {
            TAG: /* Link */ 0,
            _0: payload
        };
    }), [
        $jVmMx.Decode.deccoVariantWithPayload("Standard", $d53ed27e8c71ce82$export$66ee41028aa2b6df(undefined), function(payload) {
            return {
                TAG: /* Standard */ 1,
                _0: payload
            };
        }),
        $jVmMx.Decode.deccoVariantWithPayload("QuickView", $d53ed27e8c71ce82$export$5855298e525169e0(undefined), function(payload) {
            return {
                TAG: /* QuickView */ 2,
                _0: payload
            };
        }),
        $jVmMx.Decode.deccoVariantWithPayload("Index", $d53ed27e8c71ce82$export$b1fdf50be3d3b56a(undefined), function(payload) {
            return {
                TAG: /* Index */ 3,
                _0: payload
            };
        }),
        $jVmMx.Decode.deccoVariantWithPayload("ConfigEmbed", $d53ed27e8c71ce82$export$34cabec5ccdcad25(undefined), function(payload) {
            return {
                TAG: /* ConfigEmbed */ 4,
                _0: payload
            };
        }),
        $jVmMx.Decode.simpleVariant([
            [
                "Page",
                /* Page */ 0
            ]
        ]),
        $jVmMx.Decode.deccoVariantWithPayload("CustomComponentSection", $d53ed27e8c71ce82$export$ec0974398445544b(undefined), function(payload) {
            return {
                TAG: /* CustomComponentSection */ 5,
                _0: payload
            };
        }),
        $jVmMx.Decode.deccoVariantWithPayload("EmbedCodeSection", $aNn17.t_decode, function(payload) {
            return {
                TAG: /* EmbedCodeSection */ 6,
                _0: payload
            };
        })
    ]);
}
var $d53ed27e8c71ce82$export$7ae2d2a8b28a8cb8 = $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._1($jVmMx.Decode.succeed, function(id, title, description, showTitle, showDescription, visible, visibleInMenuBar, visibleInSectionList, visibleInParent, visibleInHeaderSlider, listPageActiveLayout, userSelectedLayout, forcedPLPLayout, tabbedSubCategories, card, categoryType, socialNetworkSource, displayPriority, expandVariantsInProductsListing, lastModifiedAt, sectionTheme, pageTheme, stickySection) {
    return {
        id: id,
        title: title,
        description: description,
        showTitle: showTitle,
        showDescription: showDescription,
        visible: visible,
        visibleInMenuBar: visibleInMenuBar,
        visibleInSectionList: visibleInSectionList,
        visibleInParent: visibleInParent,
        visibleInHeaderSlider: visibleInHeaderSlider,
        listPageActiveLayout: listPageActiveLayout,
        userSelectedLayout: userSelectedLayout,
        forcedPLPLayout: forcedPLPLayout,
        tabbedSubCategories: tabbedSubCategories,
        card: card,
        categoryType: categoryType,
        socialNetworkSource: socialNetworkSource,
        displayPriority: displayPriority,
        expandVariantsInProductsListing: expandVariantsInProductsListing,
        lastModifiedAt: lastModifiedAt,
        sectionTheme: sectionTheme,
        pageTheme: pageTheme,
        stickySection: stickySection
    };
}), $iv6Yc._2($jVmMx.Decode.field, "id", $jVmMx.Decode.string)), $jVmMx.Decode.fieldWithDefault("title", $jVmMx.Decode.string, "")), $jVmMx.Decode.fieldWithDefault("description", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string), undefined)), $jVmMx.Decode.fieldWithDefault("showTitle", $jVmMx.Decode.bool, true)), $jVmMx.Decode.fieldWithDefault("showDescription", $jVmMx.Decode.bool, true)), $jVmMx.Decode.fieldWithDefault("visible", $jVmMx.Decode.bool, true)), $jVmMx.Decode.fieldWithDefault("visibleInMenuBar", $jVmMx.Decode.bool, true)), $jVmMx.Decode.fieldWithDefault("visibleInSectionList", $jVmMx.Decode.bool, true)), $jVmMx.Decode.fieldWithDefault("visibleInParent", $jVmMx.Decode.bool, true)), $jVmMx.Decode.fieldWithDefault("visibleInHeaderSlider", $jVmMx.Decode.bool, true)), $jVmMx.Decode.fieldWithDefault("listPageActiveLayout", $d53ed27e8c71ce82$export$4e73ccac02f50c1c, /* NoLayout */ 0)), $jVmMx.Decode.fieldWithDefault("userSelectedLayout", $d53ed27e8c71ce82$export$4e73ccac02f50c1c, /* NoLayout */ 0)), $jVmMx.Decode.fieldWithDefault("forcedPLPLayout", $d53ed27e8c71ce82$export$4e73ccac02f50c1c, /* NoLayout */ 0)), $jVmMx.Decode.fieldWithDefault("tabbedSubCategories", $iv6Yc._1($jVmMx.Decode.option, $fnO65.CategoryTabSettings.fromJson), undefined)), $iv6Yc._2($jVmMx.Decode.field, "card", $d53ed27e8c71ce82$var$fromJson$2)), $iv6Yc._2($jVmMx.Decode.field, "categoryType", $d53ed27e8c71ce82$export$9ebb77ea9091af9c(undefined))), $jVmMx.Decode.fieldWithDefault("socialNetworkSource", $iv6Yc._1($jVmMx.Decode.option, $cvFfT.SocialNetworkSource.fromJson), undefined)), $jVmMx.Decode.fieldWithDefault("displayPriority", $5lwUf.DisplayPriority.fromJson, /* ChildrenFirst */ 0)), $jVmMx.Decode.fieldWithDefault("expandVariantsInProductsListing", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.bool), undefined)), $jVmMx.Decode.fieldWithDefault("lastModifiedAt", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.$$float), undefined)), $jVmMx.Decode.fieldWithDefault("sectionTheme", $1Gpco.reference_fromJson, /* LegacyTheme */ 0)), $jVmMx.Decode.fieldWithDefault("pageTheme", $1Gpco.reference_fromJson, /* LegacyTheme */ 0)), $jVmMx.Decode.fieldWithDefault("stickySection", $jVmMx.Decode.bool, false));
var $d53ed27e8c71ce82$var$fromJson$7 = $iv6Yc._6($jVmMx.Decode.map5, $iv6Yc._2($jVmMx.Decode.field, "categories", $iv6Yc._1($jVmMx.Decode.array, $d53ed27e8c71ce82$export$7ae2d2a8b28a8cb8)), $iv6Yc._2($jVmMx.Decode.field, "previous", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string)), $iv6Yc._2($jVmMx.Decode.field, "next", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string)), $jVmMx.Decode.fieldWithDefault("offset", $jVmMx.Decode.$$int, 0), $jVmMx.Decode.fieldWithDefault("total", $jVmMx.Decode.$$int, 0), function(categories, previous, next, offset, total) {
    return {
        categories: categories,
        previous: previous,
        next: next,
        offset: offset,
        total: total
    };
});
var $d53ed27e8c71ce82$export$6955bcca4cd3539f = {
    fromJson: $d53ed27e8c71ce82$var$fromJson$7
};
var $d53ed27e8c71ce82$export$6e22c362a0406a2c = {
    id: "",
    title: "",
    description: undefined,
    showTitle: true,
    showDescription: true,
    visible: true,
    visibleInMenuBar: true,
    visibleInSectionList: true,
    visibleInParent: true,
    visibleInHeaderSlider: true,
    listPageActiveLayout: {
        TAG: /* SubCategoriesGrid */ 2,
        _0: {
            columns: /* FourColumnGrid */ 3,
            gap: /* Equal */ 0,
            maxRows: undefined,
            maxWidth: undefined,
            padding: undefined,
            pattern: undefined
        }
    },
    userSelectedLayout: {
        TAG: /* SubCategoriesGrid */ 2,
        _0: {
            columns: /* FourColumnGrid */ 3,
            gap: /* Equal */ 0,
            maxRows: undefined,
            maxWidth: undefined,
            padding: undefined,
            pattern: undefined
        }
    },
    forcedPLPLayout: {
        TAG: /* ProductGrid */ 3,
        _0: {
            columns: /* FourColumnGrid */ 3,
            gap: /* Equal */ 0,
            maxRows: undefined,
            maxWidth: undefined,
            padding: undefined,
            pattern: undefined
        }
    },
    tabbedSubCategories: undefined,
    card: {
        TAG: /* ImageLinkCard */ 0,
        _0: {
            link: {
                TAG: /* URL */ 0,
                _0: ""
            },
            imageUrl: "",
            size: /* Md */ 4,
            shape: /* Square */ 1
        }
    },
    categoryType: {
        TAG: /* Link */ 0,
        _0: {
            link: "",
            imageWidth: undefined,
            imageHeight: undefined
        }
    },
    socialNetworkSource: undefined,
    displayPriority: /* ChildrenFirst */ 0,
    expandVariantsInProductsListing: undefined,
    lastModifiedAt: undefined,
    sectionTheme: /* LegacyTheme */ 0,
    pageTheme: /* LegacyTheme */ 0,
    stickySection: false
};
 /* fromJson Not a pure module */ 
});
parcelRegister("aNn17", function(module, exports) {

$parcel$export(module.exports, "t_encode", function () { return $7dc055ac0cae2e63$export$cc42ff7b6c615091; });
$parcel$export(module.exports, "t_decode", function () { return $7dc055ac0cae2e63$export$bb5e712207166a02; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $jVmMx = parcelRequire("jVmMx");
function $7dc055ac0cae2e63$export$356ef11d02801a41(t) {
    if (t) return $jVmMx.Encode.deccoVariantWithPayload(t._0, "Int", $jVmMx.Encode.$$int);
    else return $jVmMx.Encode.simpleVariant([
        [
            "Auto",
            /* Auto */ 0
        ]
    ], t);
}
var $7dc055ac0cae2e63$export$f614c35f717085b7 = $iv6Yc._2($jVmMx.Decode.oneOf, $jVmMx.Decode.deccoVariantWithPayload("Int", $jVmMx.Decode.$$int, function(i) {
    return /* Int */ {
        _0: i
    };
}), [
    $jVmMx.Decode.simpleVariant([
        [
            "Auto",
            /* Auto */ 0
        ]
    ])
]);
function $7dc055ac0cae2e63$export$cc42ff7b6c615091(t) {
    return $iv6Yc._1($jVmMx.Encode.object, [
        [
            "code",
            $iv6Yc._1($jVmMx.Encode.string, t.code)
        ],
        [
            "size",
            $iv6Yc._2($jVmMx.Encode.array, [
                t.size[0],
                t.size[1]
            ], $7dc055ac0cae2e63$export$356ef11d02801a41)
        ]
    ]);
}
var $7dc055ac0cae2e63$export$bb5e712207166a02 = $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._1($jVmMx.Decode.succeed, function(code, size) {
    return {
        code: code,
        size: size
    };
}), $iv6Yc._2($jVmMx.Decode.field, "code", $jVmMx.Decode.string)), $iv6Yc._2($jVmMx.Decode.field, "size", $iv6Yc._2($jVmMx.Decode.tuple2, $7dc055ac0cae2e63$export$f614c35f717085b7, $7dc055ac0cae2e63$export$f614c35f717085b7)));
 /* size_decode Not a pure module */ 
});

parcelRegister("cXBWA", function(module, exports) {

$parcel$export(module.exports, "toJson", function () { return $96f86d9b84470f00$export$d5b7a8bf56ee1fe2; });
$parcel$export(module.exports, "fromJson", function () { return $96f86d9b84470f00$export$7ae2d2a8b28a8cb8; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $79vie = parcelRequire("79vie");

var $jVmMx = parcelRequire("jVmMx");

var $doJJK = parcelRequire("doJJK");
function $96f86d9b84470f00$export$d5b7a8bf56ee1fe2(param) {
    return $iv6Yc._1($jVmMx.Encode.object, [
        [
            "id",
            $iv6Yc._1($jVmMx.Encode.string, param.id)
        ],
        [
            "x",
            $iv6Yc._1($jVmMx.Encode.$$int, param.x)
        ],
        [
            "y",
            $iv6Yc._1($jVmMx.Encode.$$int, param.y)
        ],
        [
            "google_feed_id",
            $iv6Yc._1($jVmMx.Encode.string, param.productId)
        ],
        [
            "variantId",
            $jVmMx.Encode.nullable(param.variantId, $jVmMx.Encode.string)
        ],
        [
            "visible",
            $jVmMx.Encode.nullable(param.visible, $jVmMx.Encode.bool)
        ]
    ]);
}
var $96f86d9b84470f00$export$7ae2d2a8b28a8cb8 = $79vie.map6($79vie.field("id", $79vie.string), $79vie.field("x", $79vie.$$int), $79vie.field("y", $79vie.$$int), $79vie.field("google_feed_id", $79vie.string), $79vie.field("variantId", $79vie.nullable($79vie.string)), $79vie.field("visible", $79vie.nullable($79vie.bool)), function(id, x, y, productId, variantId, visible) {
    return {
        id: id,
        x: x,
        y: y,
        productId: productId,
        variantId: variantId,
        visible: visible
    };
});
var $96f86d9b84470f00$var$include = $doJJK.Make({
    toJson: $96f86d9b84470f00$export$d5b7a8bf56ee1fe2,
    fromJson: $96f86d9b84470f00$export$7ae2d2a8b28a8cb8
});
var $96f86d9b84470f00$export$cc42ff7b6c615091 = $96f86d9b84470f00$var$include.t_encode;
var $96f86d9b84470f00$export$bb5e712207166a02 = $96f86d9b84470f00$var$include.t_decode;
var $96f86d9b84470f00$export$1c37c01eba8ed446 = $96f86d9b84470f00$var$include.codec;
 /* fromJson Not a pure module */ 
});

parcelRegister("ZzK4r", function(module, exports) {

$parcel$export(module.exports, "TaggedMedia", function () { return $0b916c4066f75179$export$5600df035d4a4579; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $jVmMx = parcelRequire("jVmMx");

var $doJJK = parcelRequire("doJJK");

var $gZgAC = parcelRequire("gZgAC");
function $0b916c4066f75179$var$source_toJson(source) {
    return $jVmMx.Encode.deccoVariantWithPayload(source._0, "Manual", function(__x) {
        return $iv6Yc._2($jVmMx.Encode.array, __x, $gZgAC.NodeBreakpoint.node_encode);
    });
}
var $0b916c4066f75179$var$source_fromJson = $iv6Yc._2($jVmMx.Decode.oneOf, $jVmMx.Decode.deccoVariantWithPayload("Manual", $iv6Yc._1($jVmMx.Decode.array, $gZgAC.NodeBreakpoint.node_decode), function(payload) {
    return /* Manual */ {
        _0: payload
    };
}), []);
function $0b916c4066f75179$var$displayType_toJson(displayType) {
    return $jVmMx.Encode.simpleVariant([
        [
            "InlineDisplay",
            /* InlineDisplay */ 0
        ],
        [
            "SliderDisplay",
            /* SliderDisplay */ 1
        ]
    ], displayType);
}
var $0b916c4066f75179$var$displayType_fromJson = $iv6Yc._2($jVmMx.Decode.oneOf, $jVmMx.Decode.simpleVariant([
    [
        "InlineDisplay",
        /* InlineDisplay */ 0
    ]
]), [
    $jVmMx.Decode.simpleVariant([
        [
            "SliderDisplay",
            /* SliderDisplay */ 1
        ]
    ])
]);
function $0b916c4066f75179$var$imageFit_toJson(imageFit) {
    return $jVmMx.Encode.simpleVariant([
        [
            "FitCover",
            /* FitCover */ 0
        ],
        [
            "FitContain",
            /* FitContain */ 1
        ]
    ], imageFit);
}
var $0b916c4066f75179$var$imageFit_fromJson = $iv6Yc._2($jVmMx.Decode.oneOf, $jVmMx.Decode.simpleVariant([
    [
        "FitCover",
        /* FitCover */ 0
    ]
]), [
    $jVmMx.Decode.simpleVariant([
        [
            "FitContain",
            /* FitContain */ 1
        ]
    ])
]);
function $0b916c4066f75179$var$toJson(param) {
    return $iv6Yc._1($jVmMx.Encode.object, [
        [
            "source",
            $0b916c4066f75179$var$source_toJson(param.source)
        ],
        [
            "displayType",
            $0b916c4066f75179$var$displayType_toJson(param.displayType)
        ],
        [
            "cardWidth",
            $jVmMx.Encode.nullable(param.cardWidth, $jVmMx.Encode.$$int)
        ],
        [
            "cardHeight",
            $jVmMx.Encode.nullable(param.cardHeight, $jVmMx.Encode.$$int)
        ],
        [
            "startRowOffset",
            $jVmMx.Encode.nullable(param.startRowOffset, $jVmMx.Encode.$$int)
        ],
        [
            "imageFit",
            $0b916c4066f75179$var$imageFit_toJson(param.imageFit)
        ]
    ]);
}
var $0b916c4066f75179$var$fromJson = $iv6Yc._7($jVmMx.Decode.map6, $iv6Yc._2($jVmMx.Decode.field, "source", $0b916c4066f75179$var$source_fromJson), $jVmMx.Decode.fieldWithDefault("displayType", $0b916c4066f75179$var$displayType_fromJson, /* InlineDisplay */ 0), $jVmMx.Decode.fieldWithDefault("cardWidth", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.$$int), undefined), $jVmMx.Decode.fieldWithDefault("cardHeight", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.$$int), undefined), $jVmMx.Decode.fieldWithDefault("startRowOffset", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.$$int), undefined), $jVmMx.Decode.fieldWithDefault("imageFit", $0b916c4066f75179$var$imageFit_fromJson, /* FitCover */ 0), function(source, displayType, cardWidth, cardHeight, startRowOffset, imageFit) {
    return {
        source: source,
        displayType: displayType,
        cardWidth: cardWidth,
        cardHeight: cardHeight,
        startRowOffset: startRowOffset,
        imageFit: imageFit
    };
});
var $0b916c4066f75179$var$include = $doJJK.Make({
    toJson: $0b916c4066f75179$var$toJson,
    fromJson: $0b916c4066f75179$var$fromJson
});
var $0b916c4066f75179$var$TaggedMedia_t_encode = $0b916c4066f75179$var$include.t_encode;
var $0b916c4066f75179$var$TaggedMedia_t_decode = $0b916c4066f75179$var$include.t_decode;
var $0b916c4066f75179$var$TaggedMedia_codec = $0b916c4066f75179$var$include.codec;
var $0b916c4066f75179$export$5600df035d4a4579 = {
    source_toJson: $0b916c4066f75179$var$source_toJson,
    source_fromJson: $0b916c4066f75179$var$source_fromJson,
    displayType_toJson: $0b916c4066f75179$var$displayType_toJson,
    displayType_fromJson: $0b916c4066f75179$var$displayType_fromJson,
    imageFit_toJson: $0b916c4066f75179$var$imageFit_toJson,
    imageFit_fromJson: $0b916c4066f75179$var$imageFit_fromJson,
    toJson: $0b916c4066f75179$var$toJson,
    fromJson: $0b916c4066f75179$var$fromJson,
    t_encode: $0b916c4066f75179$var$TaggedMedia_t_encode,
    t_decode: $0b916c4066f75179$var$TaggedMedia_t_decode,
    codec: $0b916c4066f75179$var$TaggedMedia_codec
};
 /* source_fromJson Not a pure module */ 
});
parcelRegister("gZgAC", function(module, exports) {

$parcel$export(module.exports, "NodeBreakpoint", function () { return $c5df36311db42caa$export$72fda6e2106c3aee; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $79vie = parcelRequire("79vie");

var $AAkl8 = parcelRequire("AAkl8");

var $jVmMx = parcelRequire("jVmMx");

var $fFzkv = parcelRequire("fFzkv");

var $doJJK = parcelRequire("doJJK");

var $fgjJY = parcelRequire("fgjJY");

var $bkHbG = parcelRequire("bkHbG");

var $cXBWA = parcelRequire("cXBWA");

var $3BXFF = parcelRequire("3BXFF");

var $7Qe3X = parcelRequire("7Qe3X");
function $c5df36311db42caa$var$node_encode(param) {
    return $iv6Yc._1($jVmMx.Encode.object, [
        [
            "id",
            $iv6Yc._1($jVmMx.Encode.string, param.id)
        ],
        [
            "image",
            $jVmMx.Encode.nullable(param.image, $jVmMx.Encode.string)
        ],
        [
            "imageWidth",
            $jVmMx.Encode.nullable(param.imageWidth, $jVmMx.Encode.$$int)
        ],
        [
            "imageHeight",
            $jVmMx.Encode.nullable(param.imageHeight, $jVmMx.Encode.$$int)
        ],
        [
            "imageHotspots",
            $jVmMx.Encode.nullable(param.imageHotspots, function(__x) {
                return $iv6Yc._2($jVmMx.Encode.array, __x, $cXBWA.toJson);
            })
        ],
        [
            "video",
            $jVmMx.Encode.nullable(param.video, $jVmMx.Encode.string)
        ],
        [
            "layout",
            $jVmMx.Encode.nullable(param.layout, $bkHbG.Layout.toJson)
        ],
        [
            "cardShape",
            $jVmMx.Encode.nullable(param.cardShape, $3BXFF.CardShape.toJson)
        ],
        [
            "cardSize",
            $jVmMx.Encode.nullable(param.cardSize, $jVmMx.Encode.string)
        ],
        [
            "link",
            $jVmMx.Encode.nullable(param.link, $fgjJY.Link.toJson)
        ],
        [
            "sliderRows",
            $jVmMx.Encode.nullable(param.sliderRows, $jVmMx.Encode.$$int)
        ],
        [
            "gridMaxRows",
            $jVmMx.Encode.nullable(param.gridMaxRows, $jVmMx.Encode.$$int)
        ],
        [
            "googleFeedIds",
            $jVmMx.Encode.nullable(param.googleFeedIds, $7Qe3X.TaggedProducts.toJson)
        ],
        [
            "sectionTheme",
            $jVmMx.Encode.nullable(param.sectionTheme, $fFzkv.reference_toJson)
        ],
        [
            "pageTheme",
            $jVmMx.Encode.nullable(param.pageTheme, $fFzkv.reference_toJson)
        ]
    ]);
}
var $c5df36311db42caa$var$node_decode = $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._1($jVmMx.Decode.succeed, function(id, image, imageWidth, imageHeight, imageHotspots, video, layout, cardShape, cardSize, link, sliderRows, gridMaxRows, googleFeedIds, sectionTheme, pageTheme) {
    return {
        id: id,
        image: image,
        imageWidth: imageWidth,
        imageHeight: imageHeight,
        imageHotspots: imageHotspots,
        video: video,
        layout: layout,
        cardShape: cardShape,
        cardSize: cardSize,
        link: link,
        sliderRows: sliderRows,
        gridMaxRows: gridMaxRows,
        googleFeedIds: googleFeedIds,
        sectionTheme: sectionTheme,
        pageTheme: pageTheme
    };
}), $jVmMx.Decode.fieldWithDefault("id", $jVmMx.Decode.string, "")), $iv6Yc._2($jVmMx.Decode.field, "image", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string))), $iv6Yc._2($jVmMx.Decode.field, "imageWidth", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.$$int))), $iv6Yc._2($jVmMx.Decode.field, "imageHeight", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.$$int))), $iv6Yc._2($jVmMx.Decode.field, "imageHotspots", $iv6Yc._1($jVmMx.Decode.option, $iv6Yc._1($jVmMx.Decode.array, $cXBWA.fromJson)))), $iv6Yc._2($jVmMx.Decode.field, "video", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string))), $iv6Yc._2($jVmMx.Decode.field, "layout", $iv6Yc._1($jVmMx.Decode.option, $bkHbG.Layout.fromJson))), $iv6Yc._2($jVmMx.Decode.field, "cardShape", $iv6Yc._1($jVmMx.Decode.option, $3BXFF.CardShape.fromJson))), $iv6Yc._2($jVmMx.Decode.field, "cardSize", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string))), $jVmMx.Decode.fieldWithDefault("link", $iv6Yc._1($jVmMx.Decode.option, $fgjJY.Link.fromJson), undefined)), $jVmMx.Decode.fieldWithDefault("sliderRows", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.$$int), undefined)), $jVmMx.Decode.fieldWithDefault("gridMaxRows", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.$$int), undefined)), $jVmMx.Decode.fieldWithDefault("googleFeedIds", $iv6Yc._1($jVmMx.Decode.option, $7Qe3X.TaggedProducts.fromJson), undefined)), $jVmMx.Decode.fieldWithDefault("sectionTheme", $iv6Yc._1($jVmMx.Decode.option, $fFzkv.reference_fromJson), undefined)), $jVmMx.Decode.fieldWithDefault("pageTheme", $iv6Yc._1($jVmMx.Decode.option, $fFzkv.reference_fromJson), undefined));
var $c5df36311db42caa$var$fromJson = $79vie.map($79vie.field("mobile", $c5df36311db42caa$var$node_decode), function(mobile) {
    return {
        mobile: mobile
    };
});
function $c5df36311db42caa$var$toJson(param) {
    return $AAkl8.object([
        [
            "mobile",
            $c5df36311db42caa$var$node_encode(param.mobile)
        ]
    ]);
}
var $c5df36311db42caa$var$include = $doJJK.Make({
    toJson: $c5df36311db42caa$var$toJson,
    fromJson: $c5df36311db42caa$var$fromJson
});
var $c5df36311db42caa$var$NodeBreakpoint_empty = {
    mobile: {
        id: "",
        image: undefined,
        imageWidth: undefined,
        imageHeight: undefined,
        imageHotspots: undefined,
        video: undefined,
        layout: undefined,
        cardShape: undefined,
        cardSize: undefined,
        link: undefined,
        sliderRows: undefined,
        gridMaxRows: undefined,
        googleFeedIds: undefined,
        sectionTheme: undefined,
        pageTheme: undefined
    }
};
var $c5df36311db42caa$var$NodeBreakpoint_t_encode = $c5df36311db42caa$var$include.t_encode;
var $c5df36311db42caa$var$NodeBreakpoint_t_decode = $c5df36311db42caa$var$include.t_decode;
var $c5df36311db42caa$var$NodeBreakpoint_codec = $c5df36311db42caa$var$include.codec;
var $c5df36311db42caa$export$72fda6e2106c3aee = {
    node_encode: $c5df36311db42caa$var$node_encode,
    node_decode: $c5df36311db42caa$var$node_decode,
    fromJson: $c5df36311db42caa$var$fromJson,
    toJson: $c5df36311db42caa$var$toJson,
    empty: $c5df36311db42caa$var$NodeBreakpoint_empty,
    t_encode: $c5df36311db42caa$var$NodeBreakpoint_t_encode,
    t_decode: $c5df36311db42caa$var$NodeBreakpoint_t_decode,
    codec: $c5df36311db42caa$var$NodeBreakpoint_codec
};
 /* node_decode Not a pure module */ 
});
parcelRegister("fFzkv", function(module, exports) {

$parcel$export(module.exports, "toJson", function () { return $b6861714979486b0$export$d5b7a8bf56ee1fe2; });
$parcel$export(module.exports, "reference_toJson", function () { return $b6861714979486b0$export$b959f71adeda4ed6; });
$parcel$export(module.exports, "fromJson", function () { return $b6861714979486b0$export$7ae2d2a8b28a8cb8; });
$parcel$export(module.exports, "reference_fromJson", function () { return $b6861714979486b0$export$c09225d5aa9e9604; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $jVmMx = parcelRequire("jVmMx");

var $3Wlzc = parcelRequire("3Wlzc");

var $1Gpco = parcelRequire("1Gpco");
function $b6861714979486b0$var$toJson(c) {
    return $iv6Yc._1($jVmMx.Encode.string, c);
}
var $b6861714979486b0$var$fromJson = $1Gpco.Color.fromJson;
var $b6861714979486b0$export$892596cec99bc70e = {
    toJson: $b6861714979486b0$var$toJson,
    fromJson: $b6861714979486b0$var$fromJson
};
function $b6861714979486b0$var$toJson$1(px) {
    return $iv6Yc._1($jVmMx.Encode.string, px);
}
var $b6861714979486b0$var$fromJson$1 = $1Gpco.Px.fromJson;
var $b6861714979486b0$export$f1c8ff7305c3a8b7 = {
    toJson: $b6861714979486b0$var$toJson$1,
    fromJson: $b6861714979486b0$var$fromJson$1
};
function $b6861714979486b0$var$toJson$2(fontFamily) {
    return $jVmMx.Encode.nullable(fontFamily, $jVmMx.Encode.string);
}
var $b6861714979486b0$var$fromJson$2 = $1Gpco.Font.FontFamily.fromJson;
var $b6861714979486b0$var$FontFamily = {
    toJson: $b6861714979486b0$var$toJson$2,
    fromJson: $b6861714979486b0$var$fromJson$2
};
function $b6861714979486b0$var$toJson$3(fontWeight) {
    return $jVmMx.Encode.simpleVariant([
        [
            "WeightAuto",
            /* WeightAuto */ 0
        ],
        [
            "WeightThin",
            /* WeightThin */ 1
        ],
        [
            "WeightLight",
            /* WeightLight */ 2
        ],
        [
            "WeightNormal",
            /* WeightNormal */ 3
        ],
        [
            "WeightMedium",
            /* WeightMedium */ 4
        ],
        [
            "WeightSemiBold",
            /* WeightSemiBold */ 5
        ],
        [
            "WeightBold",
            /* WeightBold */ 6
        ]
    ], fontWeight);
}
var $b6861714979486b0$var$fromJson$3 = $1Gpco.Font.FontWeight.fromJson;
var $b6861714979486b0$var$FontWeight = {
    toJson: $b6861714979486b0$var$toJson$3,
    fromJson: $b6861714979486b0$var$fromJson$3
};
function $b6861714979486b0$var$toJson$4(font) {
    return $iv6Yc._1($jVmMx.Encode.object, [
        [
            "fontFamily",
            $b6861714979486b0$var$toJson$2(font.fontFamily)
        ],
        [
            "fontSizeScale",
            $iv6Yc._1($jVmMx.Encode.$$float, font.fontSizeScale)
        ],
        [
            "fontWeight",
            $b6861714979486b0$var$toJson$3(font.fontWeight)
        ]
    ]);
}
var $b6861714979486b0$var$fromJson$4 = $1Gpco.Font.fromJson;
var $b6861714979486b0$export$89abf52a030e56ee = {
    FontFamily: $b6861714979486b0$var$FontFamily,
    FontWeight: $b6861714979486b0$var$FontWeight,
    toJson: $b6861714979486b0$var$toJson$4,
    fromJson: $b6861714979486b0$var$fromJson$4
};
function $b6861714979486b0$var$toJson$5(art) {
    if (typeof art === "number") return $jVmMx.Encode.simpleVariant([
        [
            "NoArt",
            /* NoArt */ 0
        ]
    ], /* NoArt */ 0);
    else if (art.TAG === /* GradientArt */ 0) return $jVmMx.Encode.deccoVariantWithPayload(art._0, "GradientArt", $jVmMx.Encode.string);
    else return $jVmMx.Encode.deccoVariantWithPayload(art._0, "ImageArt", $jVmMx.Encode.string);
}
var $b6861714979486b0$var$fromJson$5 = $1Gpco.Art.fromJson;
var $b6861714979486b0$export$3be6e5a8e8158e24 = {
    toJson: $b6861714979486b0$var$toJson$5,
    fromJson: $b6861714979486b0$var$fromJson$5
};
function $b6861714979486b0$export$d5b7a8bf56ee1fe2(param) {
    return $iv6Yc._1($jVmMx.Encode.object, [
        [
            "themeId",
            $iv6Yc._1($3Wlzc.toJson, param.themeId)
        ],
        [
            "themeName",
            $iv6Yc._1($jVmMx.Encode.string, param.themeName)
        ],
        [
            "themeCreatedAt",
            $iv6Yc._1($jVmMx.Encode.$$float, param.themeCreatedAt)
        ],
        [
            "themeUpdatedAt",
            $iv6Yc._1($jVmMx.Encode.$$float, param.themeUpdatedAt)
        ],
        [
            "primaryColor",
            $iv6Yc._1($jVmMx.Encode.string, param.primaryColor)
        ],
        [
            "secondaryColor",
            $iv6Yc._1($jVmMx.Encode.string, param.secondaryColor)
        ],
        [
            "tertiaryColor",
            $iv6Yc._1($jVmMx.Encode.string, param.tertiaryColor)
        ],
        [
            "accentColor",
            $iv6Yc._1($jVmMx.Encode.string, param.accentColor)
        ],
        [
            "backgroundColor",
            $iv6Yc._1($jVmMx.Encode.string, param.backgroundColor)
        ],
        [
            "backgroundArt",
            $b6861714979486b0$var$toJson$5(param.backgroundArt)
        ],
        [
            "placeholderColor",
            $iv6Yc._1($jVmMx.Encode.string, param.placeholderColor)
        ],
        [
            "productPromoBackgroundColor",
            $iv6Yc._1($jVmMx.Encode.string, param.productPromoBackgroundColor)
        ],
        [
            "productPromoLabelColor",
            $iv6Yc._1($jVmMx.Encode.string, param.productPromoLabelColor)
        ],
        [
            "productPriceDiscountBackgroundColor",
            $iv6Yc._1($jVmMx.Encode.string, param.productPriceDiscountBackgroundColor)
        ],
        [
            "productPriceDiscountLabelColor",
            $iv6Yc._1($jVmMx.Encode.string, param.productPriceDiscountLabelColor)
        ],
        [
            "drawerLabelColor",
            $iv6Yc._1($jVmMx.Encode.string, param.drawerLabelColor)
        ],
        [
            "drawerBackgroundColor",
            $iv6Yc._1($jVmMx.Encode.string, param.drawerBackgroundColor)
        ],
        [
            "headingFont",
            $b6861714979486b0$var$toJson$4(param.headingFont)
        ],
        [
            "bodyFont",
            $b6861714979486b0$var$toJson$4(param.bodyFont)
        ],
        [
            "buttonFont",
            $b6861714979486b0$var$toJson$4(param.buttonFont)
        ],
        [
            "roundedEdges",
            $iv6Yc._1($jVmMx.Encode.string, param.roundedEdges)
        ],
        [
            "rowGutter",
            $iv6Yc._1($jVmMx.Encode.string, param.rowGutter)
        ],
        [
            "columnGutter",
            $iv6Yc._1($jVmMx.Encode.string, param.columnGutter)
        ],
        [
            "sectionVerticalPadding",
            $iv6Yc._1($jVmMx.Encode.string, param.sectionVerticalPadding)
        ],
        [
            "sectionPaddingTop",
            $jVmMx.Encode.nullable(param.sectionPaddingTop, $b6861714979486b0$var$toJson$1)
        ],
        [
            "sectionPaddingBottom",
            $jVmMx.Encode.nullable(param.sectionPaddingBottom, $b6861714979486b0$var$toJson$1)
        ]
    ]);
}
function $b6861714979486b0$export$b959f71adeda4ed6(v) {
    if (v) return $jVmMx.Encode.deccoVariantWithPayload(v._0, "LinkedTheme", $3Wlzc.toJson);
    else return $jVmMx.Encode.simpleVariant([
        [
            "LegacyTheme",
            /* LegacyTheme */ 0
        ]
    ], /* LegacyTheme */ 0);
}
var $b6861714979486b0$export$7ae2d2a8b28a8cb8 = $1Gpco.fromJson;
var $b6861714979486b0$export$c09225d5aa9e9604 = $1Gpco.reference_fromJson;
 /* Generic-ApiTypes Not a pure module */ 
});

parcelRegister("fgjJY", function(module, exports) {

$parcel$export(module.exports, "Link", function () { return $b1c7a9b01cb1c470$export$a6c7ac8248d6e38a; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $79vie = parcelRequire("79vie");

var $jVmMx = parcelRequire("jVmMx");

var $doJJK = parcelRequire("doJJK");

var $dRfYk = parcelRequire("dRfYk");

var $04dLg = parcelRequire("04dLg");
function $b1c7a9b01cb1c470$var$t_encode(v) {
    var categoryLink_toJson = function categoryLink_toJson(param) {
        return $iv6Yc._1($jVmMx.Encode.object, [
            [
                "value",
                $jVmMx.Encode.nullable(param.value, $jVmMx.Encode.string)
            ],
            [
                "categoryId",
                $iv6Yc._1($jVmMx.Encode.string, param.categoryId)
            ]
        ]);
    };
    var productLink_toJson = function productLink_toJson(param) {
        return $iv6Yc._1($jVmMx.Encode.object, [
            [
                "value",
                $jVmMx.Encode.nullable(param.value, $jVmMx.Encode.string)
            ],
            [
                "productId",
                $iv6Yc._1($jVmMx.Encode.string, param.productId)
            ],
            [
                "variantId",
                $jVmMx.Encode.nullable(param.variantId, $jVmMx.Encode.string)
            ]
        ]);
    };
    var storeCollectionLink_toJson = function storeCollectionLink_toJson(param) {
        return $iv6Yc._1($jVmMx.Encode.object, [
            [
                "value",
                $jVmMx.Encode.nullable(param.value, $jVmMx.Encode.string)
            ],
            [
                "categoryId",
                $iv6Yc._1($jVmMx.Encode.string, param.categoryId)
            ],
            [
                "sortBy",
                $04dLg.ProductSortOrder.toJson(param.sortBy)
            ]
        ]);
    };
    var customActionLink_toJson = function customActionLink_toJson(param) {
        return $iv6Yc._1($jVmMx.Encode.object, [
            [
                "customActionId",
                $iv6Yc._1($dRfYk.toJson, param.customActionId)
            ]
        ]);
    };
    if (typeof v === "number") return $jVmMx.Encode.simpleVariant([
        [
            "NotLinked",
            /* NotLinked */ 0
        ]
    ], /* NotLinked */ 0);
    switch(v.TAG | 0){
        case /* UrlLink */ 0:
            return $jVmMx.Encode.deccoVariantWithPayload(v._0, "UrlLink", $jVmMx.Encode.string);
        case /* CategoryLink */ 1:
            return $jVmMx.Encode.deccoVariantWithPayload(v._0, "CategoryLink", categoryLink_toJson);
        case /* ProductLink */ 2:
            return $jVmMx.Encode.deccoVariantWithPayload(v._0, "ProductLink", productLink_toJson);
        case /* StoreCategoryLink */ 3:
            return $jVmMx.Encode.deccoVariantWithPayload(v._0, "StoreCategoryLink", storeCollectionLink_toJson);
        case /* CustomActionLink */ 4:
            return $jVmMx.Encode.deccoVariantWithPayload(v._0, "CustomActionLink", customActionLink_toJson);
        case /* UnknownLink */ 5:
            return $jVmMx.Encode.deccoVariantWithPayload(v._0, "UnknownLink", $jVmMx.Encode.string);
    }
}
var $b1c7a9b01cb1c470$var$categoryLink_fromJson = $iv6Yc._3($jVmMx.Decode.map2, $iv6Yc._2($jVmMx.Decode.field, "value", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string)), $iv6Yc._2($jVmMx.Decode.field, "categoryId", $jVmMx.Decode.string), function(value, categoryId) {
    return {
        value: value,
        categoryId: categoryId
    };
});
var $b1c7a9b01cb1c470$var$productLink_fromJson = $iv6Yc._4($jVmMx.Decode.map3, $iv6Yc._2($jVmMx.Decode.field, "value", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string)), $iv6Yc._2($jVmMx.Decode.field, "productId", $jVmMx.Decode.string), $iv6Yc._2($jVmMx.Decode.field, "variantId", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string)), function(value, productId, variantId) {
    return {
        value: value,
        productId: productId,
        variantId: variantId
    };
});
var $b1c7a9b01cb1c470$var$storeCategoryLink_fromJson = $iv6Yc._4($jVmMx.Decode.map3, $iv6Yc._2($jVmMx.Decode.field, "value", $iv6Yc._1($jVmMx.Decode.nullable, $jVmMx.Decode.string)), $iv6Yc._2($jVmMx.Decode.field, "categoryId", $jVmMx.Decode.string), $jVmMx.Decode.fieldWithDefault("sortBy", $04dLg.ProductSortOrder.fromJson, /* Default */ 0), function(value, categoryId, sortBy) {
    return {
        value: value,
        categoryId: categoryId,
        sortBy: sortBy
    };
});
var $b1c7a9b01cb1c470$var$customActionLink_fromJson = $iv6Yc._2($jVmMx.Decode.map, $iv6Yc._2($jVmMx.Decode.field, "customActionId", $dRfYk.fromJson), function(customActionId) {
    return {
        customActionId: customActionId
    };
});
var $b1c7a9b01cb1c470$var$t_decode = $iv6Yc._2($jVmMx.Decode.oneOf, $jVmMx.Decode.deccoVariantWithPayload("UnknownLink", $jVmMx.Decode.string, function(str) {
    return {
        TAG: /* UnknownLink */ 5,
        _0: str
    };
}), [
    $jVmMx.Decode.deccoVariantWithPayload("UrlLink", $jVmMx.Decode.string, function(str) {
        return {
            TAG: /* UrlLink */ 0,
            _0: str
        };
    }),
    $jVmMx.Decode.deccoVariantWithPayload("CategoryLink", $b1c7a9b01cb1c470$var$categoryLink_fromJson, function(str) {
        return {
            TAG: /* CategoryLink */ 1,
            _0: str
        };
    }),
    $jVmMx.Decode.deccoVariantWithPayload("ProductLink", $b1c7a9b01cb1c470$var$productLink_fromJson, function(str) {
        return {
            TAG: /* ProductLink */ 2,
            _0: str
        };
    }),
    $jVmMx.Decode.deccoVariantWithPayload("StoreCategoryLink", $b1c7a9b01cb1c470$var$storeCategoryLink_fromJson, function(str) {
        return {
            TAG: /* StoreCategoryLink */ 3,
            _0: str
        };
    }),
    $jVmMx.Decode.deccoVariantWithPayload("CustomActionLink", $b1c7a9b01cb1c470$var$customActionLink_fromJson, function(str) {
        return {
            TAG: /* CustomActionLink */ 4,
            _0: str
        };
    }),
    $jVmMx.Decode.simpleVariant([
        [
            "NotLinked",
            /* NotLinked */ 0
        ]
    ])
]);
var $b1c7a9b01cb1c470$var$t_v1_decode = $iv6Yc._2($jVmMx.Decode.andThen, $jVmMx.Decode.$$default($jVmMx.Decode.string, ""), function(link) {
    return $iv6Yc._1($jVmMx.Decode.succeed, {
        TAG: /* UnknownLink */ 5,
        _0: link
    });
});
var $b1c7a9b01cb1c470$var$t_decode$1 = $79vie.oneOf($b1c7a9b01cb1c470$var$t_decode, [
    $b1c7a9b01cb1c470$var$t_v1_decode
]);
var $b1c7a9b01cb1c470$var$include = $doJJK.Make({
    toJson: $b1c7a9b01cb1c470$var$t_encode,
    fromJson: $b1c7a9b01cb1c470$var$t_decode$1
});
var $b1c7a9b01cb1c470$var$Link_t_encode = $b1c7a9b01cb1c470$var$include.t_encode;
var $b1c7a9b01cb1c470$var$Link_t_decode = $b1c7a9b01cb1c470$var$include.t_decode;
var $b1c7a9b01cb1c470$var$Link_codec = $b1c7a9b01cb1c470$var$include.codec;
var $b1c7a9b01cb1c470$export$a6c7ac8248d6e38a = {
    t_v1_decode: $b1c7a9b01cb1c470$var$t_v1_decode,
    toJson: $b1c7a9b01cb1c470$var$t_encode,
    fromJson: $b1c7a9b01cb1c470$var$t_decode$1,
    t_encode: $b1c7a9b01cb1c470$var$Link_t_encode,
    t_decode: $b1c7a9b01cb1c470$var$Link_t_decode,
    codec: $b1c7a9b01cb1c470$var$Link_codec
};
 /* categoryLink_fromJson Not a pure module */ 
});

parcelRegister("bkHbG", function(module, exports) {

$parcel$export(module.exports, "Layout", function () { return $8403101541d24caa$export$c84671f46d6a1ca; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $79vie = parcelRequire("79vie");

var $AAkl8 = parcelRequire("AAkl8");

var $jVmMx = parcelRequire("jVmMx");

var $doJJK = parcelRequire("doJJK");
var $8403101541d24caa$var$partial_arg = [
    [
        "Default",
        /* Default */ 0
    ],
    [
        "Slider",
        /* Slider */ 1
    ],
    [
        "Grid",
        /* Grid */ 2
    ],
    [
        "AdvancedGrid",
        /* AdvancedGrid */ 3
    ],
    [
        "AdvancedSlider",
        /* AdvancedSlider */ 4
    ]
];
function $8403101541d24caa$var$labels_encode(param) {
    return $jVmMx.Encode.simpleVariant($8403101541d24caa$var$partial_arg, param);
}
var $8403101541d24caa$var$labels_decode = $jVmMx.Decode.simpleVariant([
    [
        "Default",
        /* Default */ 0
    ],
    [
        "Slider",
        /* Slider */ 1
    ],
    [
        "Grid",
        /* Grid */ 2
    ],
    [
        "AdvancedGrid",
        /* AdvancedGrid */ 3
    ],
    [
        "AdvancedSlider",
        /* AdvancedSlider */ 4
    ]
]);
var $8403101541d24caa$var$cellContent_fromJson = $jVmMx.Decode.simpleVariant([
    [
        "Slot",
        /* Slot */ 0
    ],
    [
        "Whitespace",
        /* Whitespace */ 1
    ]
]);
var $8403101541d24caa$var$partial_arg$1 = [
    [
        "Slot",
        /* Slot */ 0
    ],
    [
        "Whitespace",
        /* Whitespace */ 1
    ]
];
function $8403101541d24caa$var$cellContent_toJson(param) {
    return $jVmMx.Encode.simpleVariant($8403101541d24caa$var$partial_arg$1, param);
}
function $8403101541d24caa$var$cell_toJson(param) {
    return $iv6Yc._1($jVmMx.Encode.object, [
        [
            "colSpan",
            $iv6Yc._1($jVmMx.Encode.$$int, param.colSpan)
        ],
        [
            "rowSpan",
            $iv6Yc._1($jVmMx.Encode.$$int, param.rowSpan)
        ],
        [
            "content",
            $iv6Yc._1($8403101541d24caa$var$cellContent_toJson, param.content)
        ]
    ]);
}
var $8403101541d24caa$var$cell_fromJson = $iv6Yc._4($jVmMx.Decode.map3, $iv6Yc._2($jVmMx.Decode.field, "colSpan", $jVmMx.Decode.$$int), $iv6Yc._2($jVmMx.Decode.field, "rowSpan", $jVmMx.Decode.$$int), $iv6Yc._2($jVmMx.Decode.field, "content", $8403101541d24caa$var$cellContent_fromJson), function(colSpan, rowSpan, content) {
    return {
        colSpan: colSpan,
        rowSpan: rowSpan,
        content: content
    };
});
function $8403101541d24caa$var$toJson(__x) {
    return $iv6Yc._2($jVmMx.Encode.array, __x, function(__x) {
        return $iv6Yc._2($jVmMx.Encode.array, __x, $8403101541d24caa$var$cell_toJson);
    });
}
var $8403101541d24caa$var$fromJson = $iv6Yc._1($jVmMx.Decode.array, $iv6Yc._1($jVmMx.Decode.array, $8403101541d24caa$var$cell_fromJson));
var $8403101541d24caa$var$GridPattern = {
    cellContent_fromJson: $8403101541d24caa$var$cellContent_fromJson,
    cellContent_toJson: $8403101541d24caa$var$cellContent_toJson,
    cell_toJson: $8403101541d24caa$var$cell_toJson,
    cell_fromJson: $8403101541d24caa$var$cell_fromJson,
    toJson: $8403101541d24caa$var$toJson,
    fromJson: $8403101541d24caa$var$fromJson
};
function $8403101541d24caa$var$gridOptions_encode(param) {
    return $iv6Yc._1($jVmMx.Encode.object, [
        [
            "columns",
            $jVmMx.Encode.nullable(param.columns, $jVmMx.Encode.$$int)
        ],
        [
            "gap",
            $jVmMx.Encode.nullable(param.gap, $jVmMx.Encode.$$int)
        ],
        [
            "maxWidth",
            $jVmMx.Encode.nullable(param.maxWidth, $jVmMx.Encode.$$int)
        ],
        [
            "padding",
            $jVmMx.Encode.nullable(param.padding, $jVmMx.Encode.$$int)
        ]
    ]);
}
var $8403101541d24caa$var$gridOptions_decode = $iv6Yc._5($jVmMx.Decode.map4, $iv6Yc._2($jVmMx.Decode.field, "columns", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.$$int)), $iv6Yc._2($jVmMx.Decode.field, "gap", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.$$int)), $iv6Yc._2($jVmMx.Decode.field, "maxWidth", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.$$int)), $iv6Yc._2($jVmMx.Decode.field, "padding", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.$$int)), function(cols, gap, maxWidth, padding) {
    return {
        columns: cols,
        gap: gap,
        maxWidth: maxWidth,
        padding: padding
    };
});
var $8403101541d24caa$var$partial_arg$2 = [
    [
        "EffectSlide",
        /* EffectSlide */ 0
    ],
    [
        "EffectFade",
        /* EffectFade */ 1
    ]
];
function $8403101541d24caa$var$sliderEffect_encode(param) {
    return $jVmMx.Encode.simpleVariant($8403101541d24caa$var$partial_arg$2, param);
}
var $8403101541d24caa$var$sliderEffect_decode = $jVmMx.Decode.simpleVariant([
    [
        "EffectSlide",
        /* EffectSlide */ 0
    ],
    [
        "EffectFade",
        /* EffectFade */ 1
    ]
]);
var $8403101541d24caa$var$partial_arg$3 = [
    [
        "NavAuto",
        /* NavAuto */ 0
    ],
    [
        "NavScrollbar",
        /* NavScrollbar */ 2
    ],
    [
        "NavArrows",
        /* NavArrows */ 1
    ],
    [
        "NavDots",
        /* NavDots */ 3
    ],
    [
        "NavNone",
        /* NavNone */ 4
    ]
];
function $8403101541d24caa$var$sliderNav_encode(param) {
    return $jVmMx.Encode.simpleVariant($8403101541d24caa$var$partial_arg$3, param);
}
var $8403101541d24caa$var$sliderNav_decode = $jVmMx.Decode.simpleVariant([
    [
        "NavAuto",
        /* NavAuto */ 0
    ],
    [
        "NavScrollbar",
        /* NavScrollbar */ 2
    ],
    [
        "NavArrows",
        /* NavArrows */ 1
    ],
    [
        "NavDots",
        /* NavDots */ 3
    ],
    [
        "NavNone",
        /* NavNone */ 4
    ]
]);
var $8403101541d24caa$var$partial_arg$4 = [
    [
        "TransitionEase",
        /* TransitionEase */ 0
    ],
    [
        "TransitionLinear",
        /* TransitionLinear */ 1
    ],
    [
        "TransitionEaseIn",
        /* TransitionEaseIn */ 2
    ],
    [
        "TransitionEaseOut",
        /* TransitionEaseOut */ 3
    ],
    [
        "TransitionEaseInOut",
        /* TransitionEaseInOut */ 4
    ]
];
function $8403101541d24caa$var$transition_encode(param) {
    return $jVmMx.Encode.simpleVariant($8403101541d24caa$var$partial_arg$4, param);
}
var $8403101541d24caa$var$transition_decode = $jVmMx.Decode.simpleVariant([
    [
        "TransitionEase",
        /* TransitionEase */ 0
    ],
    [
        "TransitionLinear",
        /* TransitionLinear */ 1
    ],
    [
        "TransitionEaseIn",
        /* TransitionEaseIn */ 2
    ],
    [
        "TransitionEaseOut",
        /* TransitionEaseOut */ 3
    ],
    [
        "TransitionEaseInOut",
        /* TransitionEaseInOut */ 4
    ]
]);
function $8403101541d24caa$var$sliderOptions_encode(param) {
    return $iv6Yc._1($jVmMx.Encode.object, [
        [
            "columns",
            $jVmMx.Encode.nullable(param.columns, $jVmMx.Encode.$$float)
        ],
        [
            "gap",
            $jVmMx.Encode.nullable(param.gap, $jVmMx.Encode.$$int)
        ],
        [
            "maxWidth",
            $jVmMx.Encode.nullable(param.maxWidth, $jVmMx.Encode.$$int)
        ],
        [
            "padding",
            $jVmMx.Encode.nullable(param.padding, $jVmMx.Encode.$$int)
        ],
        [
            "effect",
            $iv6Yc._1($8403101541d24caa$var$sliderEffect_encode, param.effect)
        ],
        [
            "nav",
            $iv6Yc._1($8403101541d24caa$var$sliderNav_encode, param.nav)
        ],
        [
            "autoplay",
            $iv6Yc._1($jVmMx.Encode.bool, param.autoplay)
        ],
        [
            "transition",
            $iv6Yc._1($8403101541d24caa$var$transition_encode, param.transition)
        ],
        [
            "transitionSpeed",
            $iv6Yc._1($jVmMx.Encode.$$int, param.transitionSpeed)
        ],
        [
            "autoplayDelay",
            $iv6Yc._1($jVmMx.Encode.$$int, param.autoplayDelay)
        ]
    ]);
}
var $8403101541d24caa$var$sliderOptions_decode = $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._1($jVmMx.Decode.succeed, function(columns, gap, maxWidth, padding, effect, nav, transition, transitionSpeed, autoplay, autoplayDelay, loop) {
    return {
        columns: columns,
        gap: gap,
        maxWidth: maxWidth,
        padding: padding,
        effect: effect,
        nav: nav,
        loop: loop,
        autoplay: autoplay,
        transition: transition,
        transitionSpeed: transitionSpeed,
        autoplayDelay: autoplayDelay
    };
}), $iv6Yc._2($jVmMx.Decode.field, "columns", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.$$float))), $iv6Yc._2($jVmMx.Decode.field, "gap", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.$$int))), $iv6Yc._2($jVmMx.Decode.field, "maxWidth", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.$$int))), $iv6Yc._2($jVmMx.Decode.field, "padding", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.$$int))), $iv6Yc._2($jVmMx.Decode.field, "effect", $8403101541d24caa$var$sliderEffect_decode)), $jVmMx.Decode.fieldWithDefault("nav", $8403101541d24caa$var$sliderNav_decode, /* NavAuto */ 0)), $jVmMx.Decode.fieldWithDefault("transition", $8403101541d24caa$var$transition_decode, /* TransitionEaseOut */ 3)), $jVmMx.Decode.fieldWithDefault("transitionSpeed", $jVmMx.Decode.$$int, 300)), $jVmMx.Decode.fieldWithDefault("autoplay", $jVmMx.Decode.bool, false)), $jVmMx.Decode.fieldWithDefault("autoplayDelay", $jVmMx.Decode.$$int, 3000)), $jVmMx.Decode.fieldWithDefault("loop", $jVmMx.Decode.bool, false));
function $8403101541d24caa$var$toJson$1(layout) {
    if (typeof layout !== "number") {
        if (layout.TAG === /* AdvancedGrid */ 0) return $AAkl8.string("AdvancedGrid" + $AAkl8.encode($8403101541d24caa$var$gridOptions_encode(layout._0), 0));
        else return $AAkl8.string("AdvancedSlider" + $AAkl8.encode($8403101541d24caa$var$sliderOptions_encode(layout._0), 0));
    }
    switch(layout){
        case /* Default */ 0:
            return $AAkl8.string("default");
        case /* Slider */ 1:
            return $AAkl8.string("slider");
        case /* Grid */ 2:
            return $AAkl8.string("grid");
    }
}
var $8403101541d24caa$var$advancedGrid_decode = $jVmMx.Decode.stringifiedPayloadVariant("AdvancedGrid", $8403101541d24caa$var$gridOptions_decode, function(payload) {
    return {
        TAG: /* AdvancedGrid */ 0,
        _0: payload
    };
});
var $8403101541d24caa$var$advancedSlider_decode = $jVmMx.Decode.stringifiedPayloadVariant("AdvancedSlider", $8403101541d24caa$var$sliderOptions_decode, function(payload) {
    return {
        TAG: /* AdvancedSlider */ 1,
        _0: payload
    };
});
var $8403101541d24caa$var$fromJson$1 = $iv6Yc._2($jVmMx.Decode.oneOf, $8403101541d24caa$var$advancedGrid_decode, [
    $8403101541d24caa$var$advancedSlider_decode,
    $iv6Yc._2($jVmMx.Decode.map, $jVmMx.Decode.exactString("grid"), function(param) {
        return /* Grid */ 2;
    }),
    $iv6Yc._2($jVmMx.Decode.map, $jVmMx.Decode.exactString("slider"), function(param) {
        return /* Slider */ 1;
    }),
    $iv6Yc._2($jVmMx.Decode.map, $jVmMx.Decode.exactString("default"), function(param) {
        return /* Default */ 0;
    })
]);
var $8403101541d24caa$var$include = $doJJK.Make({
    toJson: $8403101541d24caa$var$toJson$1,
    fromJson: $8403101541d24caa$var$fromJson$1
});
var $8403101541d24caa$var$Layout_t_encode = $8403101541d24caa$var$include.t_encode;
var $8403101541d24caa$var$Layout_t_decode = $8403101541d24caa$var$include.t_decode;
var $8403101541d24caa$var$Layout_codec = $8403101541d24caa$var$include.codec;
var $8403101541d24caa$export$c84671f46d6a1ca = {
    labels_encode: $8403101541d24caa$var$labels_encode,
    labels_decode: $8403101541d24caa$var$labels_decode,
    abstract_encode: $AAkl8.string,
    abstract_decode: $79vie.string,
    GridPattern: $8403101541d24caa$var$GridPattern,
    gridOptions_encode: $8403101541d24caa$var$gridOptions_encode,
    gridOptions_decode: $8403101541d24caa$var$gridOptions_decode,
    sliderEffect_encode: $8403101541d24caa$var$sliderEffect_encode,
    sliderEffect_decode: $8403101541d24caa$var$sliderEffect_decode,
    sliderNav_encode: $8403101541d24caa$var$sliderNav_encode,
    sliderNav_decode: $8403101541d24caa$var$sliderNav_decode,
    transition_encode: $8403101541d24caa$var$transition_encode,
    transition_decode: $8403101541d24caa$var$transition_decode,
    sliderOptions_encode: $8403101541d24caa$var$sliderOptions_encode,
    sliderOptions_decode: $8403101541d24caa$var$sliderOptions_decode,
    toJson: $8403101541d24caa$var$toJson$1,
    advancedGrid_decode: $8403101541d24caa$var$advancedGrid_decode,
    advancedSlider_decode: $8403101541d24caa$var$advancedSlider_decode,
    fromJson: $8403101541d24caa$var$fromJson$1,
    t_encode: $8403101541d24caa$var$Layout_t_encode,
    t_decode: $8403101541d24caa$var$Layout_t_decode,
    codec: $8403101541d24caa$var$Layout_codec
};
 /* labels_decode Not a pure module */ 
});

parcelRegister("3BXFF", function(module, exports) {

$parcel$export(module.exports, "CardShape", function () { return $2a131d3950bcab33$export$4932b1a0b24cac6d; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $79vie = parcelRequire("79vie");

var $AAkl8 = parcelRequire("AAkl8");

var $jVmMx = parcelRequire("jVmMx");

var $doJJK = parcelRequire("doJJK");
var $2a131d3950bcab33$var$partial_arg = [
    [
        "Default",
        /* Default */ 0
    ],
    [
        "Landscape",
        /* Landscape */ 1
    ],
    [
        "Portrait",
        /* Portrait */ 2
    ],
    [
        "Panorama",
        /* Panorama */ 3
    ],
    [
        "Wide",
        /* Wide */ 4
    ],
    [
        "Tall",
        /* Tall */ 5
    ],
    [
        "Square",
        /* Square */ 6
    ],
    [
        "Circle",
        /* Circle */ 7
    ],
    [
        "Custom",
        /* Custom */ 8
    ]
];
function $2a131d3950bcab33$var$labels_encode(param) {
    return $jVmMx.Encode.simpleVariant($2a131d3950bcab33$var$partial_arg, param);
}
var $2a131d3950bcab33$var$labels_decode = $jVmMx.Decode.simpleVariant([
    [
        "Default",
        /* Default */ 0
    ],
    [
        "Landscape",
        /* Landscape */ 1
    ],
    [
        "Portrait",
        /* Portrait */ 2
    ],
    [
        "Panorama",
        /* Panorama */ 3
    ],
    [
        "Wide",
        /* Wide */ 4
    ],
    [
        "Tall",
        /* Tall */ 5
    ],
    [
        "Square",
        /* Square */ 6
    ],
    [
        "Circle",
        /* Circle */ 7
    ],
    [
        "Custom",
        /* Custom */ 8
    ]
]);
function $2a131d3950bcab33$var$custom_encode(c) {
    return $AAkl8.object([
        [
            "width",
            $AAkl8.$$int(c.width)
        ],
        [
            "height",
            $AAkl8.$$int(c.height)
        ]
    ]);
}
var $2a131d3950bcab33$var$custom_decode = $79vie.map2($79vie.field("width", $79vie.$$int), $79vie.field("height", $79vie.$$int), function(width, height) {
    return {
        width: width,
        height: height
    };
});
function $2a131d3950bcab33$var$toJson(cardShape) {
    if (typeof cardShape !== "number") return $iv6Yc._1($jVmMx.Encode.string, "Custom" + $iv6Yc._2($jVmMx.Encode.encode, $2a131d3950bcab33$var$custom_encode(cardShape._0), 0));
    switch(cardShape){
        case /* Default */ 0:
            return $iv6Yc._1($jVmMx.Encode.string, "default");
        case /* Landscape */ 1:
            return $iv6Yc._1($jVmMx.Encode.string, "landscape");
        case /* Portrait */ 2:
            return $iv6Yc._1($jVmMx.Encode.string, "portrait");
        case /* Panorama */ 3:
            return $iv6Yc._1($jVmMx.Encode.string, "panorama");
        case /* Wide */ 4:
            return $iv6Yc._1($jVmMx.Encode.string, "wide");
        case /* Tall */ 5:
            return $iv6Yc._1($jVmMx.Encode.string, "tall");
        case /* Square */ 6:
            return $iv6Yc._1($jVmMx.Encode.string, "square");
        case /* Circle */ 7:
            return $iv6Yc._1($jVmMx.Encode.string, "circle");
    }
}
var $2a131d3950bcab33$var$customDecode = $jVmMx.Decode.stringifiedPayloadVariant("Custom", $2a131d3950bcab33$var$custom_decode, function(payload) {
    return /* Custom */ {
        _0: payload
    };
});
var $2a131d3950bcab33$var$fromJson = $iv6Yc._2($jVmMx.Decode.oneOf, $2a131d3950bcab33$var$customDecode, [
    $iv6Yc._2($jVmMx.Decode.map, $jVmMx.Decode.exactString("default"), function(param) {
        return /* Default */ 0;
    }),
    $iv6Yc._2($jVmMx.Decode.map, $jVmMx.Decode.exactString("landscape"), function(param) {
        return /* Landscape */ 1;
    }),
    $iv6Yc._2($jVmMx.Decode.map, $jVmMx.Decode.exactString("portrait"), function(param) {
        return /* Portrait */ 2;
    }),
    $iv6Yc._2($jVmMx.Decode.map, $jVmMx.Decode.exactString("panorama"), function(param) {
        return /* Panorama */ 3;
    }),
    $iv6Yc._2($jVmMx.Decode.map, $jVmMx.Decode.exactString("wide"), function(param) {
        return /* Wide */ 4;
    }),
    $iv6Yc._2($jVmMx.Decode.map, $jVmMx.Decode.exactString("tall"), function(param) {
        return /* Tall */ 5;
    }),
    $iv6Yc._2($jVmMx.Decode.map, $jVmMx.Decode.exactString("square"), function(param) {
        return /* Square */ 6;
    }),
    $iv6Yc._2($jVmMx.Decode.map, $jVmMx.Decode.exactString("circle"), function(param) {
        return /* Circle */ 7;
    })
]);
var $2a131d3950bcab33$var$include = $doJJK.Make({
    toJson: $2a131d3950bcab33$var$toJson,
    fromJson: $2a131d3950bcab33$var$fromJson
});
var $2a131d3950bcab33$var$CardShape_t_encode = $2a131d3950bcab33$var$include.t_encode;
var $2a131d3950bcab33$var$CardShape_t_decode = $2a131d3950bcab33$var$include.t_decode;
var $2a131d3950bcab33$var$CardShape_codec = $2a131d3950bcab33$var$include.codec;
var $2a131d3950bcab33$export$4932b1a0b24cac6d = {
    labels_encode: $2a131d3950bcab33$var$labels_encode,
    labels_decode: $2a131d3950bcab33$var$labels_decode,
    abstract_encode: $AAkl8.string,
    abstract_decode: $79vie.string,
    custom_encode: $2a131d3950bcab33$var$custom_encode,
    custom_decode: $2a131d3950bcab33$var$custom_decode,
    toJson: $2a131d3950bcab33$var$toJson,
    fromJson: $2a131d3950bcab33$var$fromJson,
    t_encode: $2a131d3950bcab33$var$CardShape_t_encode,
    t_decode: $2a131d3950bcab33$var$CardShape_t_decode,
    codec: $2a131d3950bcab33$var$CardShape_codec
};
 /* labels_decode Not a pure module */ 
});

parcelRegister("7Qe3X", function(module, exports) {

$parcel$export(module.exports, "TaggedProducts", function () { return $5b584c4b6d1bb7db$export$830cc7a486eaf924; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $79vie = parcelRequire("79vie");

var $AAkl8 = parcelRequire("AAkl8");

var $jVmMx = parcelRequire("jVmMx");

var $doJJK = parcelRequire("doJJK");
function $5b584c4b6d1bb7db$var$entry_encode(param) {
    return $iv6Yc._1($jVmMx.Encode.object, [
        [
            "id",
            $iv6Yc._1($jVmMx.Encode.string, param.id)
        ],
        [
            "productId",
            $iv6Yc._1($jVmMx.Encode.string, param.productId)
        ],
        [
            "variantId",
            $jVmMx.Encode.nullable(param.variantId, $jVmMx.Encode.string)
        ]
    ]);
}
var $5b584c4b6d1bb7db$var$entry_v1_decode = $iv6Yc._2($jVmMx.Decode.andThen, $jVmMx.Decode.$$default($jVmMx.Decode.string, ""), function(entry) {
    return $iv6Yc._1($jVmMx.Decode.succeed, {
        id: entry,
        productId: entry,
        variantId: undefined
    });
});
var $5b584c4b6d1bb7db$var$entry_decode = $79vie.map3($79vie.field("id", $79vie.string), $79vie.field("productId", $79vie.string), $79vie.field("variantId", $79vie.option($79vie.string)), function(id, productId, variantId) {
    return {
        id: id,
        productId: productId,
        variantId: variantId
    };
});
var $5b584c4b6d1bb7db$var$entry_decode$1 = $79vie.oneOf($5b584c4b6d1bb7db$var$entry_decode, [
    $5b584c4b6d1bb7db$var$entry_v1_decode
]);
function $5b584c4b6d1bb7db$var$toJson(arr) {
    return $AAkl8.array(arr, $5b584c4b6d1bb7db$var$entry_encode);
}
var $5b584c4b6d1bb7db$var$fromJson = $79vie.array($79vie.oneOf($5b584c4b6d1bb7db$var$entry_decode$1, [
    $5b584c4b6d1bb7db$var$entry_v1_decode
]));
var $5b584c4b6d1bb7db$var$include = $doJJK.Make({
    toJson: $5b584c4b6d1bb7db$var$toJson,
    fromJson: $5b584c4b6d1bb7db$var$fromJson
});
var $5b584c4b6d1bb7db$var$TaggedProducts_t_encode = $5b584c4b6d1bb7db$var$include.t_encode;
var $5b584c4b6d1bb7db$var$TaggedProducts_t_decode = $5b584c4b6d1bb7db$var$include.t_decode;
var $5b584c4b6d1bb7db$var$TaggedProducts_codec = $5b584c4b6d1bb7db$var$include.codec;
var $5b584c4b6d1bb7db$export$830cc7a486eaf924 = {
    entry_encode: $5b584c4b6d1bb7db$var$entry_encode,
    entry_v1_decode: $5b584c4b6d1bb7db$var$entry_v1_decode,
    entry_decode: $5b584c4b6d1bb7db$var$entry_decode$1,
    toJson: $5b584c4b6d1bb7db$var$toJson,
    fromJson: $5b584c4b6d1bb7db$var$fromJson,
    t_encode: $5b584c4b6d1bb7db$var$TaggedProducts_t_encode,
    t_decode: $5b584c4b6d1bb7db$var$TaggedProducts_t_decode,
    codec: $5b584c4b6d1bb7db$var$TaggedProducts_codec
};
 /* entry_v1_decode Not a pure module */ 
});



parcelRegister("5lwUf", function(module, exports) {

$parcel$export(module.exports, "DisplayPriority", function () { return $3e487064e461ee0c$export$685054b2bd85bd7a; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $jVmMx = parcelRequire("jVmMx");

var $doJJK = parcelRequire("doJJK");
var $3e487064e461ee0c$var$fromJson = $jVmMx.Decode.simpleVariant([
    [
        "ChildrenFirst",
        /* ChildrenFirst */ 0
    ],
    [
        "ProductsFirst",
        /* ProductsFirst */ 1
    ]
]);
function $3e487064e461ee0c$var$toJson(v) {
    if (v) return $iv6Yc._2($jVmMx.Encode.array, [
        "ProductsFirst"
    ], $jVmMx.Encode.string);
    else return $iv6Yc._2($jVmMx.Encode.array, [
        "ChildrenFirst"
    ], $jVmMx.Encode.string);
}
var $3e487064e461ee0c$var$include = $doJJK.Make({
    toJson: $3e487064e461ee0c$var$toJson,
    fromJson: $3e487064e461ee0c$var$fromJson
});
var $3e487064e461ee0c$var$DisplayPriority_t_encode = $3e487064e461ee0c$var$include.t_encode;
var $3e487064e461ee0c$var$DisplayPriority_t_decode = $3e487064e461ee0c$var$include.t_decode;
var $3e487064e461ee0c$var$DisplayPriority_codec = $3e487064e461ee0c$var$include.codec;
var $3e487064e461ee0c$export$685054b2bd85bd7a = {
    fromJson: $3e487064e461ee0c$var$fromJson,
    toJson: $3e487064e461ee0c$var$toJson,
    t_encode: $3e487064e461ee0c$var$DisplayPriority_t_encode,
    t_decode: $3e487064e461ee0c$var$DisplayPriority_t_decode,
    codec: $3e487064e461ee0c$var$DisplayPriority_codec
};
 /* fromJson Not a pure module */ 
});

parcelRegister("fnO65", function(module, exports) {

$parcel$export(module.exports, "CategoryTabSettings", function () { return $b32fdd3eabce53a3$export$96682b7d1b581f55; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $2whNH = parcelRequire("2whNH");

var $AAkl8 = parcelRequire("AAkl8");

var $jVmMx = parcelRequire("jVmMx");

var $doJJK = parcelRequire("doJJK");
var $b32fdd3eabce53a3$var$partial_arg = [
    [
        "Labels",
        /* Labels */ 0
    ],
    [
        "PillsWithLabel",
        /* PillsWithLabel */ 1
    ],
    [
        "PillsWithIcon",
        /* PillsWithIcon */ 2
    ],
    [
        "PillsWithRoundedIcon",
        /* PillsWithRoundedIcon */ 3
    ]
];
function $b32fdd3eabce53a3$var$layout_encode(param) {
    return $jVmMx.Encode.simpleVariant($b32fdd3eabce53a3$var$partial_arg, param);
}
var $b32fdd3eabce53a3$var$layout_decode = $jVmMx.Decode.simpleVariant([
    [
        "Labels",
        /* Labels */ 0
    ],
    [
        "PillsWithLabel",
        /* PillsWithLabel */ 1
    ],
    [
        "PillsWithIcon",
        /* PillsWithIcon */ 2
    ],
    [
        "PillsWithRoundedIcon",
        /* PillsWithRoundedIcon */ 3
    ]
]);
var $b32fdd3eabce53a3$var$partial_arg$1 = [
    [
        "Small",
        /* Small */ 0
    ],
    [
        "Medium",
        /* Medium */ 1
    ],
    [
        "Large",
        /* Large */ 2
    ]
];
function $b32fdd3eabce53a3$var$size_encode(param) {
    return $jVmMx.Encode.simpleVariant($b32fdd3eabce53a3$var$partial_arg$1, param);
}
var $b32fdd3eabce53a3$var$size_decode = $jVmMx.Decode.simpleVariant([
    [
        "Small",
        /* Small */ 0
    ],
    [
        "Medium",
        /* Medium */ 1
    ],
    [
        "Large",
        /* Large */ 2
    ]
]);
var $b32fdd3eabce53a3$var$partial_arg$2 = [
    [
        "Top",
        /* Top */ 0
    ],
    [
        "Bottom",
        /* Bottom */ 1
    ]
];
function $b32fdd3eabce53a3$var$position_encode(param) {
    return $jVmMx.Encode.simpleVariant($b32fdd3eabce53a3$var$partial_arg$2, param);
}
var $b32fdd3eabce53a3$var$position_decode = $jVmMx.Decode.simpleVariant([
    [
        "Top",
        /* Top */ 0
    ],
    [
        "Bottom",
        /* Bottom */ 1
    ]
]);
var $b32fdd3eabce53a3$var$partial_arg$3 = [
    [
        "Left",
        /* Left */ 0
    ],
    [
        "Center",
        /* Center */ 1
    ],
    [
        "Right",
        /* Right */ 2
    ]
];
function $b32fdd3eabce53a3$var$align_encode(param) {
    return $jVmMx.Encode.simpleVariant($b32fdd3eabce53a3$var$partial_arg$3, param);
}
var $b32fdd3eabce53a3$var$align_decode = $jVmMx.Decode.simpleVariant([
    [
        "Left",
        /* Left */ 0
    ],
    [
        "Center",
        /* Center */ 1
    ],
    [
        "Right",
        /* Right */ 2
    ]
]);
function $b32fdd3eabce53a3$var$toJson(param) {
    return $AAkl8.object([
        [
            "layout",
            $iv6Yc._1($b32fdd3eabce53a3$var$layout_encode, param.layout)
        ],
        [
            "size",
            $iv6Yc._1($b32fdd3eabce53a3$var$size_encode, param.size)
        ],
        [
            "position",
            $iv6Yc._1($b32fdd3eabce53a3$var$position_encode, param.position)
        ],
        [
            "align",
            $iv6Yc._1($b32fdd3eabce53a3$var$align_encode, param.align)
        ]
    ]);
}
var $b32fdd3eabce53a3$var$fromJson = $iv6Yc._5($jVmMx.Decode.map4, $iv6Yc._2($jVmMx.Decode.field, "layout", $iv6Yc._1($jVmMx.Decode.option, $b32fdd3eabce53a3$var$layout_decode)), $iv6Yc._2($jVmMx.Decode.field, "size", $iv6Yc._1($jVmMx.Decode.option, $b32fdd3eabce53a3$var$size_decode)), $iv6Yc._2($jVmMx.Decode.field, "position", $iv6Yc._1($jVmMx.Decode.option, $b32fdd3eabce53a3$var$position_decode)), $iv6Yc._2($jVmMx.Decode.field, "align", $iv6Yc._1($jVmMx.Decode.option, $b32fdd3eabce53a3$var$align_decode)), function(layout, size, position, align) {
    return {
        layout: $2whNH.getWithDefault(layout, /* Labels */ 0),
        size: $2whNH.getWithDefault(size, /* Medium */ 1),
        position: $2whNH.getWithDefault(position, /* Top */ 0),
        align: $2whNH.getWithDefault(align, /* Left */ 0)
    };
});
var $b32fdd3eabce53a3$var$include = $doJJK.Make({
    toJson: $b32fdd3eabce53a3$var$toJson,
    fromJson: $b32fdd3eabce53a3$var$fromJson
});
var $b32fdd3eabce53a3$var$CategoryTabSettings_t_encode = $b32fdd3eabce53a3$var$include.t_encode;
var $b32fdd3eabce53a3$var$CategoryTabSettings_t_decode = $b32fdd3eabce53a3$var$include.t_decode;
var $b32fdd3eabce53a3$var$CategoryTabSettings_codec = $b32fdd3eabce53a3$var$include.codec;
var $b32fdd3eabce53a3$export$96682b7d1b581f55 = {
    layout_encode: $b32fdd3eabce53a3$var$layout_encode,
    layout_decode: $b32fdd3eabce53a3$var$layout_decode,
    size_encode: $b32fdd3eabce53a3$var$size_encode,
    size_decode: $b32fdd3eabce53a3$var$size_decode,
    position_encode: $b32fdd3eabce53a3$var$position_encode,
    position_decode: $b32fdd3eabce53a3$var$position_decode,
    align_encode: $b32fdd3eabce53a3$var$align_encode,
    align_decode: $b32fdd3eabce53a3$var$align_decode,
    toJson: $b32fdd3eabce53a3$var$toJson,
    fromJson: $b32fdd3eabce53a3$var$fromJson,
    t_encode: $b32fdd3eabce53a3$var$CategoryTabSettings_t_encode,
    t_decode: $b32fdd3eabce53a3$var$CategoryTabSettings_t_decode,
    codec: $b32fdd3eabce53a3$var$CategoryTabSettings_codec
};
 /* layout_decode Not a pure module */ 
});

parcelRegister("cvFfT", function(module, exports) {

$parcel$export(module.exports, "SocialNetworkSource", function () { return $91b861c0b6c61b13$export$1daf4b0130eb169c; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $jVmMx = parcelRequire("jVmMx");

var $doJJK = parcelRequire("doJJK");

var $j1laG = parcelRequire("j1laG");

var $eIysb = parcelRequire("eIysb");
var $91b861c0b6c61b13$var$fromJson = $iv6Yc._2($jVmMx.Decode.oneOf, $jVmMx.Decode.deccoVariantWithPayload("Instagram", $eIysb.ContentType.fromJson, function(payload) {
    return {
        TAG: /* Instagram */ 0,
        _0: payload
    };
}), [
    $jVmMx.Decode.deccoVariantWithPayload("Tiktok", $j1laG.ContentType.fromJson, function(payload) {
        return {
            TAG: /* Tiktok */ 1,
            _0: payload
        };
    })
]);
function $91b861c0b6c61b13$var$toJson(source) {
    if (source.TAG === /* Instagram */ 0) return $jVmMx.Encode.deccoVariantWithPayload(source._0, "Instagram", $eIysb.ContentType.toJson);
    else return $jVmMx.Encode.deccoVariantWithPayload(source._0, "Tiktok", $j1laG.ContentType.toJson);
}
var $91b861c0b6c61b13$var$include = $doJJK.Make({
    toJson: $91b861c0b6c61b13$var$toJson,
    fromJson: $91b861c0b6c61b13$var$fromJson
});
var $91b861c0b6c61b13$var$t_encode = $91b861c0b6c61b13$var$include.t_encode;
var $91b861c0b6c61b13$var$t_decode = $91b861c0b6c61b13$var$include.t_decode;
var $91b861c0b6c61b13$var$SocialNetworkSource_codec = $91b861c0b6c61b13$var$include.codec;
var $91b861c0b6c61b13$export$1daf4b0130eb169c = {
    fromJson: $91b861c0b6c61b13$var$fromJson,
    toJson: $91b861c0b6c61b13$var$toJson,
    t_encode: $91b861c0b6c61b13$var$t_encode,
    t_decode: $91b861c0b6c61b13$var$t_decode,
    codec: $91b861c0b6c61b13$var$SocialNetworkSource_codec
};
var $91b861c0b6c61b13$export$dff3ee56860fc5b9 = $91b861c0b6c61b13$var$t_encode;
var $91b861c0b6c61b13$export$9aaed70cd0774be8 = $91b861c0b6c61b13$var$t_decode;
 /* fromJson Not a pure module */ 
});
parcelRegister("j1laG", function(module, exports) {

$parcel$export(module.exports, "ContentType", function () { return $dd8e887b65296ed8$export$e2e108cbe2e4f865; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $2whNH = parcelRequire("2whNH");

var $AAkl8 = parcelRequire("AAkl8");

var $jVmMx = parcelRequire("jVmMx");

var $doJJK = parcelRequire("doJJK");
var $dd8e887b65296ed8$var$videosPayload_decode = $iv6Yc._3($jVmMx.Decode.map2, $iv6Yc._2($jVmMx.Decode.field, "id", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string)), $iv6Yc._2($jVmMx.Decode.field, "isPinned", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.bool)), function(id, isPinned) {
    return {
        id: $2whNH.getWithDefault(id, ""),
        isPinned: $2whNH.getWithDefault(isPinned, false)
    };
});
function $dd8e887b65296ed8$var$videosPayload_encode(payload) {
    return $AAkl8.object([
        [
            "id",
            $AAkl8.string(payload.id)
        ],
        [
            "isPinned",
            $AAkl8.bool(payload.isPinned)
        ]
    ]);
}
var $dd8e887b65296ed8$var$videosWithPayload_decode = $iv6Yc._3($jVmMx.Decode.map2, $jVmMx.Decode.exactVariantChoice("Videos"), $iv6Yc._2($jVmMx.Decode.index, 1, $dd8e887b65296ed8$var$videosPayload_decode), function(param, payload) {
    return /* Videos */ {
        _0: payload
    };
});
function $dd8e887b65296ed8$var$toJson(contentType) {
    return $jVmMx.Encode.deccoVariantWithPayload(contentType._0, "Videos", $dd8e887b65296ed8$var$videosPayload_encode);
}
var $dd8e887b65296ed8$var$include = $doJJK.Make({
    toJson: $dd8e887b65296ed8$var$toJson,
    fromJson: $dd8e887b65296ed8$var$videosWithPayload_decode
});
var $dd8e887b65296ed8$var$ContentType_t_encode = $dd8e887b65296ed8$var$include.t_encode;
var $dd8e887b65296ed8$var$ContentType_t_decode = $dd8e887b65296ed8$var$include.t_decode;
var $dd8e887b65296ed8$var$ContentType_codec = $dd8e887b65296ed8$var$include.codec;
var $dd8e887b65296ed8$export$e2e108cbe2e4f865 = {
    videosPayload_decode: $dd8e887b65296ed8$var$videosPayload_decode,
    videosPayload_encode: $dd8e887b65296ed8$var$videosPayload_encode,
    videosWithPayload_decode: $dd8e887b65296ed8$var$videosWithPayload_decode,
    fromJson: $dd8e887b65296ed8$var$videosWithPayload_decode,
    toJson: $dd8e887b65296ed8$var$toJson,
    t_encode: $dd8e887b65296ed8$var$ContentType_t_encode,
    t_decode: $dd8e887b65296ed8$var$ContentType_t_decode,
    codec: $dd8e887b65296ed8$var$ContentType_codec
};
 /* videosPayload_decode Not a pure module */ 
});

parcelRegister("eIysb", function(module, exports) {

$parcel$export(module.exports, "ContentType", function () { return $ab6fe6861e105328$export$e2e108cbe2e4f865; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $2whNH = parcelRequire("2whNH");

var $AAkl8 = parcelRequire("AAkl8");

var $jVmMx = parcelRequire("jVmMx");

var $doJJK = parcelRequire("doJJK");
var $ab6fe6861e105328$var$reelsPayload_decode = $iv6Yc._6($jVmMx.Decode.map5, $iv6Yc._2($jVmMx.Decode.field, "id", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string)), $iv6Yc._2($jVmMx.Decode.field, "isPinned", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.bool)), $iv6Yc._2($jVmMx.Decode.field, "isSharedToFeed", $jVmMx.Decode.bool), $iv6Yc._2($jVmMx.Decode.field, "isScraped", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.bool)), $iv6Yc._2($jVmMx.Decode.field, "isCollaborated", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.bool)), function(id, isPinned, isSharedToFeed, isScraped, isCollaborated) {
    return {
        id: $2whNH.getWithDefault(id, ""),
        isPinned: $2whNH.getWithDefault(isPinned, false),
        isSharedToFeed: isSharedToFeed,
        isScraped: $2whNH.getWithDefault(isScraped, false),
        isCollaborated: $2whNH.getWithDefault(isCollaborated, false)
    };
});
function $ab6fe6861e105328$var$reelsPayload_encode(payload) {
    return $AAkl8.object([
        [
            "id",
            $AAkl8.string(payload.id)
        ],
        [
            "isPinned",
            $AAkl8.bool(payload.isPinned)
        ],
        [
            "isSharedToFeed",
            $AAkl8.bool(payload.isSharedToFeed)
        ],
        [
            "isScraped",
            $AAkl8.bool(payload.isScraped)
        ],
        [
            "isCollaborated",
            $AAkl8.bool(payload.isCollaborated)
        ]
    ]);
}
var $ab6fe6861e105328$var$postsPayload_decode = $iv6Yc._5($jVmMx.Decode.map4, $iv6Yc._2($jVmMx.Decode.field, "id", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string)), $iv6Yc._2($jVmMx.Decode.field, "isPinned", $jVmMx.Decode.bool), $iv6Yc._2($jVmMx.Decode.field, "isScraped", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.bool)), $iv6Yc._2($jVmMx.Decode.field, "isCollaborated", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.bool)), function(id, isPinned, isScraped, isCollaborated) {
    return {
        id: $2whNH.getWithDefault(id, ""),
        isPinned: isPinned,
        isScraped: $2whNH.getWithDefault(isScraped, false),
        isCollaborated: $2whNH.getWithDefault(isCollaborated, false)
    };
});
function $ab6fe6861e105328$var$postsPayload_encode(payload) {
    return $AAkl8.object([
        [
            "id",
            $AAkl8.string(payload.id)
        ],
        [
            "isPinned",
            $AAkl8.bool(payload.isPinned)
        ],
        [
            "isScraped",
            $AAkl8.bool(payload.isScraped)
        ],
        [
            "isCollaborated",
            $AAkl8.bool(payload.isCollaborated)
        ]
    ]);
}
var $ab6fe6861e105328$var$reelsWithPayload_decode = $iv6Yc._3($jVmMx.Decode.map2, $jVmMx.Decode.exactVariantChoice("Reels"), $iv6Yc._2($jVmMx.Decode.index, 1, $ab6fe6861e105328$var$reelsPayload_decode), function(param, payload) {
    return {
        TAG: /* Reels */ 1,
        _0: payload
    };
});
var $ab6fe6861e105328$var$instagramContentType_v2_decode = $iv6Yc._2($jVmMx.Decode.oneOf, $iv6Yc._2($jVmMx.Decode.andThen, $jVmMx.Decode.exactVariantChoice("Posts"), function(param) {
    return $iv6Yc._1($jVmMx.Decode.succeed, {
        TAG: /* Posts */ 0,
        _0: {
            id: "",
            isPinned: false,
            isScraped: false,
            isCollaborated: false
        }
    });
}), [
    $ab6fe6861e105328$var$reelsWithPayload_decode
]);
var $ab6fe6861e105328$var$postsWithPayload_decode = $iv6Yc._3($jVmMx.Decode.map2, $jVmMx.Decode.exactVariantChoice("Posts"), $iv6Yc._2($jVmMx.Decode.index, 1, $ab6fe6861e105328$var$postsPayload_decode), function(param, payload) {
    return {
        TAG: /* Posts */ 0,
        _0: payload
    };
});
var $ab6fe6861e105328$var$instagramContentType_v1_decode = $iv6Yc._2($jVmMx.Decode.oneOf, $iv6Yc._2($jVmMx.Decode.andThen, $jVmMx.Decode.exactVariantChoice("Posts"), function(param) {
    return $iv6Yc._1($jVmMx.Decode.succeed, {
        TAG: /* Posts */ 0,
        _0: {
            id: "",
            isPinned: false,
            isScraped: false,
            isCollaborated: false
        }
    });
}), [
    $iv6Yc._2($jVmMx.Decode.andThen, $jVmMx.Decode.exactVariantChoice("Reels"), function(param) {
        return $iv6Yc._1($jVmMx.Decode.succeed, {
            TAG: /* Reels */ 1,
            _0: {
                id: "",
                isPinned: false,
                isSharedToFeed: true,
                isScraped: false,
                isCollaborated: false
            }
        });
    })
]);
var $ab6fe6861e105328$var$fromJson = $iv6Yc._2($jVmMx.Decode.oneOf, $ab6fe6861e105328$var$postsWithPayload_decode, [
    $ab6fe6861e105328$var$reelsWithPayload_decode
]);
var $ab6fe6861e105328$var$fromJson$1 = $iv6Yc._2($jVmMx.Decode.oneOf, $ab6fe6861e105328$var$fromJson, [
    $ab6fe6861e105328$var$instagramContentType_v2_decode,
    $ab6fe6861e105328$var$instagramContentType_v1_decode
]);
function $ab6fe6861e105328$var$toJson(contentType) {
    if (contentType.TAG === /* Posts */ 0) return $jVmMx.Encode.deccoVariantWithPayload(contentType._0, "Posts", $ab6fe6861e105328$var$postsPayload_encode);
    else return $jVmMx.Encode.deccoVariantWithPayload(contentType._0, "Reels", $ab6fe6861e105328$var$reelsPayload_encode);
}
var $ab6fe6861e105328$var$include = $doJJK.Make({
    toJson: $ab6fe6861e105328$var$toJson,
    fromJson: $ab6fe6861e105328$var$fromJson$1
});
var $ab6fe6861e105328$var$ContentType_t_encode = $ab6fe6861e105328$var$include.t_encode;
var $ab6fe6861e105328$var$ContentType_t_decode = $ab6fe6861e105328$var$include.t_decode;
var $ab6fe6861e105328$var$ContentType_codec = $ab6fe6861e105328$var$include.codec;
var $ab6fe6861e105328$export$e2e108cbe2e4f865 = {
    reelsPayload_decode: $ab6fe6861e105328$var$reelsPayload_decode,
    reelsPayload_encode: $ab6fe6861e105328$var$reelsPayload_encode,
    postsPayload_decode: $ab6fe6861e105328$var$postsPayload_decode,
    postsPayload_encode: $ab6fe6861e105328$var$postsPayload_encode,
    reelsWithPayload_decode: $ab6fe6861e105328$var$reelsWithPayload_decode,
    instagramContentType_v2_decode: $ab6fe6861e105328$var$instagramContentType_v2_decode,
    postsWithPayload_decode: $ab6fe6861e105328$var$postsWithPayload_decode,
    instagramContentType_v1_decode: $ab6fe6861e105328$var$instagramContentType_v1_decode,
    fromJson: $ab6fe6861e105328$var$fromJson$1,
    toJson: $ab6fe6861e105328$var$toJson,
    t_encode: $ab6fe6861e105328$var$ContentType_t_encode,
    t_decode: $ab6fe6861e105328$var$ContentType_t_decode,
    codec: $ab6fe6861e105328$var$ContentType_codec
};
 /* reelsPayload_decode Not a pure module */ 
});


parcelRegister("5kJL4", function(module, exports) {

$parcel$export(module.exports, "gridColumns_fromJson", function () { return $3e2250a5077b1b2b$export$8c25ab61e3ebfea6; });
$parcel$export(module.exports, "layoutGap_fromJson", function () { return $3e2250a5077b1b2b$export$d1231c8849dff43d; });
$parcel$export(module.exports, "sliderEffect_fromJson", function () { return $3e2250a5077b1b2b$export$7b8c2d503c3f2b85; });
$parcel$export(module.exports, "sliderNav_fromJson", function () { return $3e2250a5077b1b2b$export$a97538abbb745701; });
$parcel$export(module.exports, "transition_fromJson", function () { return $3e2250a5077b1b2b$export$e325d0430234ce09; });
$parcel$export(module.exports, "smartbarCategoryLayout_fromJson", function () { return $3e2250a5077b1b2b$export$caa8cc636f063fc5; });
$parcel$export(module.exports, "smartbarCategorySize_fromJson", function () { return $3e2250a5077b1b2b$export$4b356bb189ad847c; });
$parcel$export(module.exports, "cardShape_fromJson", function () { return $3e2250a5077b1b2b$export$62374691ae503c00; });
$parcel$export(module.exports, "gridPayload_fromJson", function () { return $3e2250a5077b1b2b$export$f881733ee4dc8a30; });
$parcel$export(module.exports, "sliderPayload_fromJson", function () { return $3e2250a5077b1b2b$export$e419410b2a3ba3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $jVmMx = parcelRequire("jVmMx");

var $bkHbG = parcelRequire("bkHbG");
var $3e2250a5077b1b2b$export$8c25ab61e3ebfea6 = $jVmMx.Decode.simpleVariant([
    [
        "OneColumnGrid",
        /* OneColumnGrid */ 0
    ],
    [
        "TwoColumnGrid",
        /* TwoColumnGrid */ 1
    ],
    [
        "ThreeColumnGrid",
        /* ThreeColumnGrid */ 2
    ],
    [
        "FourColumnGrid",
        /* FourColumnGrid */ 3
    ],
    [
        "FiveColumnGrid",
        /* FiveColumnGrid */ 4
    ],
    [
        "SixColumnGrid",
        /* SixColumnGrid */ 5
    ],
    [
        "SevenColumnGrid",
        /* SevenColumnGrid */ 6
    ],
    [
        "EightColumnGrid",
        /* EightColumnGrid */ 7
    ],
    [
        "TwelveColumnGrid",
        /* TwelveColumnGrid */ 8
    ]
]);
var $3e2250a5077b1b2b$var$pixelDecoder = $jVmMx.Decode.deccoVariantWithPayload("Pixels", $jVmMx.Decode.$$int, function(i) {
    return /* Pixels */ {
        _0: i
    };
});
var $3e2250a5077b1b2b$export$d1231c8849dff43d = $iv6Yc._2($jVmMx.Decode.oneOf, $3e2250a5077b1b2b$var$pixelDecoder, [
    $jVmMx.Decode.simpleVariant([
        [
            "Equal",
            /* Equal */ 0
        ],
        [
            "Half",
            /* Half */ 1
        ],
        [
            "Double",
            /* Double */ 2
        ]
    ])
]);
var $3e2250a5077b1b2b$export$7b8c2d503c3f2b85 = $jVmMx.Decode.simpleVariant([
    [
        "EffectSlide",
        /* EffectSlide */ 0
    ],
    [
        "EffectFade",
        /* EffectFade */ 1
    ]
]);
var $3e2250a5077b1b2b$export$a97538abbb745701 = $jVmMx.Decode.simpleVariant([
    [
        "NavAuto",
        /* NavAuto */ 0
    ],
    [
        "NavArrows",
        /* NavArrows */ 1
    ],
    [
        "NavScrollbar",
        /* NavScrollbar */ 2
    ],
    [
        "NavDots",
        /* NavDots */ 3
    ],
    [
        "NavNone",
        /* NavNone */ 4
    ]
]);
var $3e2250a5077b1b2b$export$e325d0430234ce09 = $jVmMx.Decode.simpleVariant([
    [
        "TransitionEase",
        /* TransitionEase */ 0
    ],
    [
        "TransitionLinear",
        /* TransitionLinear */ 1
    ],
    [
        "TransitionEaseIn",
        /* TransitionEaseIn */ 2
    ],
    [
        "TransitionEaseOut",
        /* TransitionEaseOut */ 3
    ],
    [
        "TransitionEaseInOut",
        /* TransitionEaseInOut */ 4
    ]
]);
var $3e2250a5077b1b2b$var$iconsWithLabelDecoder = $jVmMx.Decode.deccoVariantWithPayload("IconsWithLabel", $iv6Yc._2($jVmMx.Decode.map, $iv6Yc._2($jVmMx.Decode.field, "lineClamp", $jVmMx.Decode.$$int), function(lineClamp) {
    return /* IconsWithLabel */ {
        lineClamp: lineClamp
    };
}), function(v) {
    return v;
});
var $3e2250a5077b1b2b$export$caa8cc636f063fc5 = $iv6Yc._2($jVmMx.Decode.oneOf, $3e2250a5077b1b2b$var$iconsWithLabelDecoder, [
    $jVmMx.Decode.simpleVariant([
        [
            "Labels",
            /* Labels */ 0
        ],
        [
            "IconsOnly",
            /* IconsOnly */ 1
        ],
        [
            "PillsWithLabel",
            /* PillsWithLabel */ 2
        ],
        [
            "PillsWithIcon",
            /* PillsWithIcon */ 3
        ],
        [
            "PillsWithRoundedIcon",
            /* PillsWithRoundedIcon */ 4
        ]
    ])
]);
var $3e2250a5077b1b2b$export$4b356bb189ad847c = $jVmMx.Decode.simpleVariant([
    [
        "Small",
        /* Small */ 0
    ],
    [
        "Medium",
        /* Medium */ 1
    ],
    [
        "Large",
        /* Large */ 2
    ]
]);
var $3e2250a5077b1b2b$var$customDecoder = $jVmMx.Decode.deccoVariantWithPayload("Custom", $iv6Yc._2($jVmMx.Decode.tuple2, $jVmMx.Decode.$$int, $jVmMx.Decode.$$int), function(param) {
    return /* Custom */ {
        _0: param[0],
        _1: param[1]
    };
});
var $3e2250a5077b1b2b$export$62374691ae503c00 = $iv6Yc._2($jVmMx.Decode.oneOf, $3e2250a5077b1b2b$var$customDecoder, [
    $jVmMx.Decode.simpleVariant([
        [
            "Circle",
            /* Circle */ 0
        ],
        [
            "Square",
            /* Square */ 1
        ],
        [
            "Landscape",
            /* Landscape */ 2
        ],
        [
            "Portrait",
            /* Portrait */ 3
        ],
        [
            "Panorama",
            /* Panorama */ 4
        ],
        [
            "Wide",
            /* Wide */ 5
        ],
        [
            "Tall",
            /* Tall */ 6
        ]
    ])
]);
var $3e2250a5077b1b2b$export$f881733ee4dc8a30 = $iv6Yc._7($jVmMx.Decode.map6, $iv6Yc._2($jVmMx.Decode.field, "columns", $3e2250a5077b1b2b$export$8c25ab61e3ebfea6), $jVmMx.Decode.fieldWithDefault("gap", $3e2250a5077b1b2b$export$d1231c8849dff43d, /* Equal */ 0), $jVmMx.Decode.fieldWithDefault("maxRows", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.$$int), undefined), $jVmMx.Decode.fieldWithDefault("maxWidth", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.$$int), undefined), $jVmMx.Decode.fieldWithDefault("padding", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.$$int), undefined), $jVmMx.Decode.fieldWithDefault("pattern", $iv6Yc._1($jVmMx.Decode.option, $bkHbG.Layout.GridPattern.fromJson), undefined), function(columns, gap, maxRows, maxWidth, padding, pattern) {
    return {
        columns: columns,
        gap: gap,
        maxRows: maxRows,
        maxWidth: maxWidth,
        padding: padding,
        pattern: pattern
    };
});
var $3e2250a5077b1b2b$export$e419410b2a3ba3bb = $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._1($jVmMx.Decode.succeed, function(slidesPerView, gap, maxWidth, padding, rows, effect, nav, transition, transitionSpeed, autoplay, autoplayDelay, loop) {
    return {
        slidesPerView: slidesPerView,
        gap: gap,
        maxWidth: maxWidth,
        padding: padding,
        rows: rows,
        effect: effect,
        nav: nav,
        transition: transition,
        transitionSpeed: transitionSpeed,
        autoplay: autoplay,
        autoplayDelay: autoplayDelay,
        loop: loop
    };
}), $iv6Yc._2($jVmMx.Decode.field, "slidesPerView", $jVmMx.Decode.$$float)), $jVmMx.Decode.fieldWithDefault("gap", $3e2250a5077b1b2b$export$d1231c8849dff43d, /* Equal */ 0)), $jVmMx.Decode.fieldWithDefault("maxWidth", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.$$int), undefined)), $jVmMx.Decode.fieldWithDefault("padding", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.$$int), undefined)), $jVmMx.Decode.fieldWithDefault("rows", $jVmMx.Decode.$$int, 1)), $jVmMx.Decode.fieldWithDefault("effect", $3e2250a5077b1b2b$export$7b8c2d503c3f2b85, /* EffectSlide */ 0)), $jVmMx.Decode.fieldWithDefault("nav", $3e2250a5077b1b2b$export$a97538abbb745701, /* NavAuto */ 0)), $jVmMx.Decode.fieldWithDefault("transition", $3e2250a5077b1b2b$export$e325d0430234ce09, /* TransitionEaseOut */ 3)), $jVmMx.Decode.fieldWithDefault("transitionSpeed", $jVmMx.Decode.$$int, 300)), $jVmMx.Decode.fieldWithDefault("autoplay", $jVmMx.Decode.bool, false)), $jVmMx.Decode.fieldWithDefault("autoplayDelay", $jVmMx.Decode.$$int, 3000)), $jVmMx.Decode.fieldWithDefault("loop", $jVmMx.Decode.bool, false));
 /* gridColumns_fromJson Not a pure module */ 
});




parcelRegister("6Cykr", function(module, exports) {

$parcel$export(module.exports, "toJson", function () { return $4d20eba1bc1620bd$export$d5b7a8bf56ee1fe2; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $AAkl8 = parcelRequire("AAkl8");

var $jVmMx = parcelRequire("jVmMx");

var $fFzkv = parcelRequire("fFzkv");

var $atDFT = parcelRequire("atDFT");

var $dRfYk = parcelRequire("dRfYk");

var $f1TVX = parcelRequire("f1TVX");

var $dT0m1 = parcelRequire("dT0m1");

var $crJlr = parcelRequire("crJlr");

var $7lqRw = parcelRequire("7lqRw");

var $eaePg = parcelRequire("eaePg");

var $cUpzT = parcelRequire("cUpzT");

var $fin9m = parcelRequire("fin9m");

var $kNO66 = parcelRequire("kNO66");
var $4d20eba1bc1620bd$var$partial_arg = [
    [
        "Large",
        /* Large */ 0
    ],
    [
        "Medium",
        /* Medium */ 1
    ],
    [
        "Small",
        /* Small */ 2
    ],
    [
        "FullWidth",
        /* FullWidth */ 3
    ]
];
function $4d20eba1bc1620bd$var$toJson(param) {
    return $jVmMx.Encode.simpleVariant($4d20eba1bc1620bd$var$partial_arg, param);
}
var $4d20eba1bc1620bd$var$fromJson = $kNO66.PanelSize.fromJson;
var $4d20eba1bc1620bd$export$69e2902d2a3921ff = {
    toJson: $4d20eba1bc1620bd$var$toJson,
    fromJson: $4d20eba1bc1620bd$var$fromJson
};
var $4d20eba1bc1620bd$var$partial_arg$1 = [
    [
        "Left",
        /* Left */ 0
    ],
    [
        "Right",
        /* Right */ 1
    ]
];
function $4d20eba1bc1620bd$var$toJson$1(param) {
    return $jVmMx.Encode.simpleVariant($4d20eba1bc1620bd$var$partial_arg$1, param);
}
var $4d20eba1bc1620bd$var$fromJson$1 = $kNO66.PanelPosition.fromJson;
var $4d20eba1bc1620bd$export$a048ae1f0ae09c2c = {
    toJson: $4d20eba1bc1620bd$var$toJson$1,
    fromJson: $4d20eba1bc1620bd$var$fromJson$1
};
var $4d20eba1bc1620bd$var$partial_arg$2 = [
    [
        "Old",
        /* Old */ 0
    ],
    [
        "Horizontal",
        /* Horizontal */ 1
    ],
    [
        "Vertical",
        /* Vertical */ 2
    ]
];
function $4d20eba1bc1620bd$var$toJson$2(param) {
    return $jVmMx.Encode.simpleVariant($4d20eba1bc1620bd$var$partial_arg$2, param);
}
var $4d20eba1bc1620bd$var$fromJson$2 = $kNO66.DesktopPDPLayout.fromJson;
var $4d20eba1bc1620bd$export$631e3c3b01fb1045 = {
    toJson: $4d20eba1bc1620bd$var$toJson$2,
    fromJson: $4d20eba1bc1620bd$var$fromJson$2
};
var $4d20eba1bc1620bd$var$partial_arg$3 = [
    [
        "Left",
        /* Left */ 0
    ],
    [
        "Center",
        /* Center */ 1
    ]
];
function $4d20eba1bc1620bd$var$toJson$3(param) {
    return $jVmMx.Encode.simpleVariant($4d20eba1bc1620bd$var$partial_arg$3, param);
}
var $4d20eba1bc1620bd$var$fromJson$3 = $kNO66.TitleDescriptionPosition.fromJson;
var $4d20eba1bc1620bd$export$9a41294384f62a08 = {
    toJson: $4d20eba1bc1620bd$var$toJson$3,
    fromJson: $4d20eba1bc1620bd$var$fromJson$3
};
var $4d20eba1bc1620bd$var$partial_arg$4 = [
    [
        "Ua",
        /* Ua */ 0
    ],
    [
        "Gtag",
        /* Gtag */ 1
    ]
];
function $4d20eba1bc1620bd$var$toJson$4(param) {
    return $jVmMx.Encode.simpleVariant($4d20eba1bc1620bd$var$partial_arg$4, param);
}
var $4d20eba1bc1620bd$var$fromJson$4 = $kNO66.GaVersion.fromJson;
var $4d20eba1bc1620bd$export$a65f4ba0b4d85314 = {
    toJson: $4d20eba1bc1620bd$var$toJson$4,
    fromJson: $4d20eba1bc1620bd$var$fromJson$4
};
function $4d20eba1bc1620bd$var$addToCartProps_toJson(param) {
    return $AAkl8.object([
        [
            "textColor",
            $AAkl8.string(param.textColor)
        ],
        [
            "bgColor",
            $AAkl8.string(param.bgColor)
        ],
        [
            "label",
            $AAkl8.string(param.label)
        ],
        [
            "confirmationMessage",
            $AAkl8.string(param.confirmationMessage)
        ]
    ]);
}
var $4d20eba1bc1620bd$var$addToCartProps_fromJson = $kNO66.PDPCTAConfig.addToCartProps_fromJson;
function $4d20eba1bc1620bd$var$customActionProps_toJson(param) {
    return $iv6Yc._1($jVmMx.Encode.object, [
        [
            "id",
            $iv6Yc._1($jVmMx.Encode.string, param.id)
        ],
        [
            "textColor",
            $iv6Yc._1($jVmMx.Encode.string, param.textColor)
        ],
        [
            "bgColor",
            $iv6Yc._1($jVmMx.Encode.string, param.bgColor)
        ],
        [
            "label",
            $iv6Yc._1($jVmMx.Encode.string, param.label)
        ],
        [
            "confirmationMessage",
            $iv6Yc._1($jVmMx.Encode.string, param.confirmationMessage)
        ],
        [
            "onClickFn",
            $iv6Yc._1($jVmMx.Encode.string, param.onClickFn)
        ],
        [
            "renderFn",
            $jVmMx.Encode.nullable(param.renderFn, $jVmMx.Encode.string)
        ]
    ]);
}
var $4d20eba1bc1620bd$var$customActionProps_fromJson = $kNO66.PDPCTAConfig.customActionProps_fromJson;
function $4d20eba1bc1620bd$var$pdpCTAAction_toJson(v) {
    switch(v.TAG | 0){
        case /* AddToCart */ 0:
            return $jVmMx.Encode.deccoVariantWithPayload(v._0, "AddToCart", $4d20eba1bc1620bd$var$addToCartProps_toJson);
        case /* OpenLink */ 1:
            return $jVmMx.Encode.deccoVariantWithPayload(v._0, "OpenLink", $jVmMx.Encode.string);
        case /* CustomAction */ 2:
            return $jVmMx.Encode.deccoVariantWithPayload(v._0, "CustomAction", $4d20eba1bc1620bd$var$customActionProps_toJson);
    }
}
var $4d20eba1bc1620bd$var$pdpCTAAction_fromJson = $kNO66.PDPCTAConfig.pdpCTAAction_fromJson;
function $4d20eba1bc1620bd$var$toJson$5(param) {
    return $iv6Yc._1($jVmMx.Encode.object, [
        [
            "primary",
            $4d20eba1bc1620bd$var$pdpCTAAction_toJson(param.primary)
        ],
        [
            "secondary",
            $jVmMx.Encode.nullable(param.secondary, $4d20eba1bc1620bd$var$pdpCTAAction_toJson)
        ],
        [
            "tertiary",
            $jVmMx.Encode.nullable(param.tertiary, $4d20eba1bc1620bd$var$pdpCTAAction_toJson)
        ]
    ]);
}
var $4d20eba1bc1620bd$var$fromJson$5 = $kNO66.PDPCTAConfig.fromJson;
var $4d20eba1bc1620bd$export$d8c400e89f051a97 = {
    addToCartProps_toJson: $4d20eba1bc1620bd$var$addToCartProps_toJson,
    addToCartProps_fromJson: $4d20eba1bc1620bd$var$addToCartProps_fromJson,
    customActionProps_toJson: $4d20eba1bc1620bd$var$customActionProps_toJson,
    customActionProps_fromJson: $4d20eba1bc1620bd$var$customActionProps_fromJson,
    pdpCTAAction_toJson: $4d20eba1bc1620bd$var$pdpCTAAction_toJson,
    pdpCTAAction_fromJson: $4d20eba1bc1620bd$var$pdpCTAAction_fromJson,
    toJson: $4d20eba1bc1620bd$var$toJson$5,
    fromJson: $4d20eba1bc1620bd$var$fromJson$5
};
function $4d20eba1bc1620bd$export$d5b7a8bf56ee1fe2(param) {
    return $iv6Yc._1($jVmMx.Encode.object, [
        [
            "panelSize",
            $iv6Yc._1($4d20eba1bc1620bd$var$toJson, param.panelSize)
        ],
        [
            "panelPosition",
            $iv6Yc._1($4d20eba1bc1620bd$var$toJson$1, param.panelPosition)
        ],
        [
            "backdrop",
            $iv6Yc._1($jVmMx.Encode.bool, param.backdrop)
        ],
        [
            "backdropBlur",
            $iv6Yc._1($jVmMx.Encode.bool, param.backdropBlur)
        ],
        [
            "backdropColor",
            $iv6Yc._1($jVmMx.Encode.string, param.backdropColor)
        ],
        [
            "categoryLayout",
            $fin9m.smartbarCategoryLayout_toJson(param.categoryLayout)
        ],
        [
            "categorySize",
            $fin9m.smartbarCategorySize_toJson(param.categorySize)
        ],
        [
            "nestedCategoryLayout",
            $fin9m.smartbarCategoryLayout_toJson(param.nestedCategoryLayout)
        ],
        [
            "nestedCategorySize",
            $fin9m.smartbarCategorySize_toJson(param.nestedCategorySize)
        ],
        [
            "checkoutLink",
            $jVmMx.Encode.nullable(param.checkoutLink, $jVmMx.Encode.string)
        ],
        [
            "checkoutCustomAction",
            $jVmMx.Encode.nullable(param.checkoutCustomAction, $dRfYk.toJson)
        ],
        [
            "currencyPickerEnabled",
            $iv6Yc._1($jVmMx.Encode.bool, param.currencyPickerEnabled)
        ],
        [
            "gridDensityZoomEnabled",
            $iv6Yc._1($jVmMx.Encode.bool, param.gridDensityZoomEnabled)
        ],
        [
            "filtersEnabled",
            $iv6Yc._1($jVmMx.Encode.bool, param.filtersEnabled)
        ],
        [
            "filtersLabelOrder",
            $iv6Yc._2($jVmMx.Encode.array, param.filtersLabelOrder, $jVmMx.Encode.string)
        ],
        [
            "linksAsSidebar",
            $iv6Yc._1($jVmMx.Encode.bool, param.linksAsSidebar)
        ],
        [
            "sidebarDesktopDefault",
            $iv6Yc._1($jVmMx.Encode.bool, param.sidebarDesktopDefault)
        ],
        [
            "sidebarMobileDefault",
            $iv6Yc._1($jVmMx.Encode.bool, param.sidebarMobileDefault)
        ],
        [
            "backButton",
            $iv6Yc._1($jVmMx.Encode.bool, param.backButton)
        ],
        [
            "smartbarEnabled",
            $iv6Yc._1($jVmMx.Encode.bool, param.smartbarEnabled)
        ],
        [
            "zIndexInt",
            $iv6Yc._1($jVmMx.Encode.$$int, param.zIndexInt)
        ],
        [
            "zIndex",
            $iv6Yc._1($jVmMx.Encode.string, param.zIndex)
        ],
        [
            "categoryCardShape",
            $fin9m.cardShape_toJson(param.categoryCardShape)
        ],
        [
            "categoryCardFitToContainer",
            $iv6Yc._1($jVmMx.Encode.bool, param.categoryCardFitToContainer)
        ],
        [
            "categoryCardTitleLineTruncate",
            $iv6Yc._1($jVmMx.Encode.$$int, param.categoryCardTitleLineTruncate)
        ],
        [
            "productCardTitleLineTruncate",
            $iv6Yc._1($jVmMx.Encode.$$int, param.productCardTitleLineTruncate)
        ],
        [
            "productCardFitToContainer",
            $iv6Yc._1($jVmMx.Encode.bool, param.productCardFitToContainer)
        ],
        [
            "productCardShape",
            $fin9m.cardShape_toJson(param.productCardShape)
        ],
        [
            "productCardSize",
            $iv6Yc._1($cUpzT.CardSize.toJson, param.productCardSize)
        ],
        [
            "productCardAddToCart",
            $iv6Yc._1($jVmMx.Encode.bool, param.productCardAddToCart)
        ],
        [
            "pdpCTAConfig",
            $4d20eba1bc1620bd$var$toJson$5(param.pdpCTAConfig)
        ],
        [
            "pdpAddToCartLabel",
            $iv6Yc._1($jVmMx.Encode.string, param.pdpAddToCartLabel)
        ],
        [
            "pdpAddToCartConfirmation",
            $iv6Yc._1($jVmMx.Encode.string, param.pdpAddToCartConfirmation)
        ],
        [
            "pdpPrimaryCustomAction",
            $jVmMx.Encode.nullable(param.pdpPrimaryCustomAction, $crJlr.Button.toJson)
        ],
        [
            "pdpSecondaryCustomAction",
            $jVmMx.Encode.nullable(param.pdpSecondaryCustomAction, $crJlr.Button.toJson)
        ],
        [
            "pdpTertiaryCustomAction",
            $jVmMx.Encode.nullable(param.pdpTertiaryCustomAction, $crJlr.Button.toJson)
        ],
        [
            "pdpGalleryCustomAction",
            $jVmMx.Encode.nullable(param.pdpGalleryCustomAction, $crJlr.Button.toJson)
        ],
        [
            "pdpSizeGuide",
            $jVmMx.Encode.nullable(param.pdpSizeGuide, $f1TVX.toJson)
        ],
        [
            "pdpCTAButtons",
            $dT0m1.toJson(param.pdpCTAButtons)
        ],
        [
            "pdpOpenLinkLabel",
            $iv6Yc._1($jVmMx.Encode.string, param.pdpOpenLinkLabel)
        ],
        [
            "pdpCTAButtonBgColor",
            $iv6Yc._1($jVmMx.Encode.string, param.pdpCTAButtonBgColor)
        ],
        [
            "pdpCTAButtonTextColor",
            $iv6Yc._1($jVmMx.Encode.string, param.pdpCTAButtonTextColor)
        ],
        [
            "pdpGalleryBGBlur",
            $iv6Yc._1($jVmMx.Encode.bool, param.pdpGalleryBGBlur)
        ],
        [
            "pdpGalleryBGColor",
            $iv6Yc._1($jVmMx.Encode.string, param.pdpGalleryBGColor)
        ],
        [
            "pdpPricePrefixText",
            $jVmMx.Encode.nullable(param.pdpPricePrefixText, $jVmMx.Encode.string)
        ],
        [
            "pdpPriceSuffixText",
            $jVmMx.Encode.nullable(param.pdpPriceSuffixText, $jVmMx.Encode.string)
        ],
        [
            "pdpPromoText",
            $jVmMx.Encode.nullable(param.pdpPromoText, $jVmMx.Encode.string)
        ],
        [
            "shipping",
            $jVmMx.Encode.nullable(param.shipping, $jVmMx.Encode.string)
        ],
        [
            "shippingShort",
            $jVmMx.Encode.nullable(param.shippingShort, $jVmMx.Encode.string)
        ],
        [
            "arrival",
            $jVmMx.Encode.nullable(param.arrival, $jVmMx.Encode.string)
        ],
        [
            "hideOutOfStock",
            $iv6Yc._1($jVmMx.Encode.bool, param.hideOutOfStock)
        ],
        [
            "videoLoop",
            $iv6Yc._1($jVmMx.Encode.bool, param.videoLoop)
        ],
        [
            "videoAutoPlay",
            $iv6Yc._1($jVmMx.Encode.bool, param.videoAutoPlay)
        ],
        [
            "videoMute",
            $iv6Yc._1($jVmMx.Encode.bool, param.videoMute)
        ],
        [
            "videoControls",
            $iv6Yc._1($jVmMx.Encode.bool, param.videoControls)
        ],
        [
            "openLinkLabel",
            $iv6Yc._1($jVmMx.Encode.string, param.openLinkLabel)
        ],
        [
            "openLinkInNewTab",
            $iv6Yc._1($jVmMx.Encode.bool, param.openLinkInNewTab)
        ],
        [
            "openProductLink",
            $iv6Yc._1($jVmMx.Encode.bool, param.openProductLink)
        ],
        [
            "outOfStockLabel",
            $iv6Yc._1($jVmMx.Encode.string, param.outOfStockLabel)
        ],
        [
            "indexNode",
            $jVmMx.Encode.nullable(param.indexNode, $cUpzT.toJson)
        ],
        [
            "quickviewCarousel",
            $iv6Yc._1($jVmMx.Encode.bool, param.quickviewCarousel)
        ],
        [
            "quickviewAutoplay",
            $iv6Yc._1($jVmMx.Encode.bool, param.quickviewAutoplay)
        ],
        [
            "quickviewPictureInPicture",
            $iv6Yc._1($jVmMx.Encode.bool, param.quickviewPictureInPicture)
        ],
        [
            "siteHeaderCSSSelector",
            $jVmMx.Encode.nullable(param.siteHeaderCSSSelector, $jVmMx.Encode.string)
        ],
        [
            "siteHeaderRespect",
            $iv6Yc._1($jVmMx.Encode.bool, param.siteHeaderRespect)
        ],
        [
            "displayVariantBy",
            $eaePg.toJson(param.displayVariantBy)
        ],
        [
            "newMobilePDP",
            $iv6Yc._1($jVmMx.Encode.bool, param.newMobilePDP)
        ],
        [
            "desktopPDPLayout",
            $iv6Yc._1($4d20eba1bc1620bd$var$toJson$2, param.desktopPDPLayout)
        ],
        [
            "newMobilePDPCube",
            $iv6Yc._1($jVmMx.Encode.bool, param.newMobilePDPCube)
        ],
        [
            "newMobilePDPCover",
            $iv6Yc._1($jVmMx.Encode.bool, param.newMobilePDPCover)
        ],
        [
            "newMobilePDPCtaLabel",
            $iv6Yc._1($jVmMx.Encode.string, param.newMobilePDPCtaLabel)
        ],
        [
            "quantityPicker",
            $iv6Yc._1($jVmMx.Encode.bool, param.quantityPicker)
        ],
        [
            "mkrBio",
            $jVmMx.Encode.nullable(param.mkrBio, $atDFT.toJson)
        ],
        [
            "cart",
            $iv6Yc._1($jVmMx.Encode.bool, param.cart)
        ],
        [
            "gaTrackingId",
            $jVmMx.Encode.nullable(param.gaTrackingId, $jVmMx.Encode.string)
        ],
        [
            "gaVersion",
            $iv6Yc._1($4d20eba1bc1620bd$var$toJson$4, param.gaVersion)
        ],
        [
            "contextualL1s",
            $iv6Yc._1($jVmMx.Encode.bool, param.contextualL1s)
        ],
        [
            "contextualInline",
            $iv6Yc._1($jVmMx.Encode.bool, param.contextualInline)
        ],
        [
            "contextualMenuDesktop",
            $iv6Yc._1($jVmMx.Encode.bool, param.contextualMenuDesktop)
        ],
        [
            "contextualMenuMobile",
            $iv6Yc._1($jVmMx.Encode.bool, param.contextualMenuMobile)
        ],
        [
            "autoHideBottombar",
            $iv6Yc._1($jVmMx.Encode.bool, param.autoHideBottombar)
        ],
        [
            "expandVariantsInProductsListing",
            $jVmMx.Encode.nullable(param.expandVariantsInProductsListing, $jVmMx.Encode.bool)
        ],
        [
            "favoritesEnabled",
            $iv6Yc._1($jVmMx.Encode.bool, param.favoritesEnabled)
        ],
        [
            "historyEnabled",
            $iv6Yc._1($jVmMx.Encode.bool, param.historyEnabled)
        ],
        [
            "plpHistorySliderEnabled",
            $iv6Yc._1($jVmMx.Encode.bool, param.plpHistorySliderEnabled)
        ],
        [
            "plpTitleDescriptionEnabled",
            $iv6Yc._1($jVmMx.Encode.bool, param.plpTitleDescriptionEnabled)
        ],
        [
            "plpTitleDescriptionPosition",
            $iv6Yc._1($4d20eba1bc1620bd$var$toJson$3, param.plpTitleDescriptionPosition)
        ],
        [
            "seoDynamicLinks",
            $iv6Yc._1($jVmMx.Encode.bool, param.seoDynamicLinks)
        ],
        [
            "theme",
            $fFzkv.toJson(param.theme)
        ],
        [
            "pdpTheme",
            $jVmMx.Encode.nullable(param.pdpTheme, $fFzkv.toJson)
        ],
        [
            "plpTheme",
            $jVmMx.Encode.nullable(param.plpTheme, $fFzkv.toJson)
        ],
        [
            "productCardComponent",
            $jVmMx.Encode.nullable(param.productCardComponent, $7lqRw.reference_toJson)
        ],
        [
            "pdpComponent",
            $jVmMx.Encode.nullable(param.pdpComponent, $7lqRw.reference_toJson)
        ]
    ]);
}
var $4d20eba1bc1620bd$export$ce5bcb86ca2bfc97;
var $4d20eba1bc1620bd$export$7ae2d2a8b28a8cb8 = $kNO66.fromJson;
 /* Json__Encode Not a pure module */ 
});
parcelRegister("cUpzT", function(module, exports) {

$parcel$export(module.exports, "CardSize", function () { return $965e8e3de14ed127$export$93c0382b74e40ff9; });
$parcel$export(module.exports, "toJson", function () { return $965e8e3de14ed127$export$d5b7a8bf56ee1fe2; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $79vie = parcelRequire("79vie");

var $bYadz = parcelRequire("bYadz");

var $jVmMx = parcelRequire("jVmMx");

var $fFzkv = parcelRequire("fFzkv");

var $dRfYk = parcelRequire("dRfYk");

var $aNn17 = parcelRequire("aNn17");

var $cXBWA = parcelRequire("cXBWA");

var $7lqRw = parcelRequire("7lqRw");

var $ZzK4r = parcelRequire("ZzK4r");

var $7Qe3X = parcelRequire("7Qe3X");

var $5lwUf = parcelRequire("5lwUf");

var $04dLg = parcelRequire("04dLg");

var $fnO65 = parcelRequire("fnO65");

var $cvFfT = parcelRequire("cvFfT");

var $fin9m = parcelRequire("fin9m");

var $ij6do = parcelRequire("ij6do");
var $965e8e3de14ed127$var$partial_arg = [
    [
        "Xxxs",
        /* Xxxs */ 0
    ],
    [
        "Xxs",
        /* Xxs */ 1
    ],
    [
        "Xs",
        /* Xs */ 2
    ],
    [
        "Sm",
        /* Sm */ 3
    ],
    [
        "Md",
        /* Md */ 4
    ],
    [
        "Lg",
        /* Lg */ 5
    ],
    [
        "Xl",
        /* Xl */ 6
    ],
    [
        "Xxl",
        /* Xxl */ 7
    ],
    [
        "Xxxl",
        /* Xxxl */ 8
    ],
    [
        "Xxxxl",
        /* Xxxxl */ 9
    ],
    [
        "Xxxxxl",
        /* Xxxxxl */ 10
    ]
];
function $965e8e3de14ed127$var$toJson(param) {
    return $jVmMx.Encode.simpleVariant($965e8e3de14ed127$var$partial_arg, param);
}
var $965e8e3de14ed127$var$fromJson = $ij6do.CardSize.fromJson;
var $965e8e3de14ed127$export$93c0382b74e40ff9 = {
    toJson: $965e8e3de14ed127$var$toJson,
    fromJson: $965e8e3de14ed127$var$fromJson
};
function $965e8e3de14ed127$var$toJson$1(v) {
    var categoryLink_toJson = function categoryLink_toJson(param) {
        return $iv6Yc._1($jVmMx.Encode.object, $jVmMx.Encode.addIf(undefined, [
            [
                "categoryId",
                $iv6Yc._1($jVmMx.Encode.string, param.categoryId)
            ]
        ], function(__x) {
            return $jVmMx.Encode.nullable(__x, $bYadz.t_encode);
        }, [
            "filters",
            param.filters
        ]));
    };
    var productLink_toJson = function productLink_toJson(param) {
        return $iv6Yc._1($jVmMx.Encode.object, $jVmMx.Encode.addIf(undefined, $jVmMx.Encode.addIf(undefined, [
            [
                "productId",
                $iv6Yc._1($jVmMx.Encode.string, param.productId)
            ]
        ], function(__x) {
            return $jVmMx.Encode.nullable(__x, $jVmMx.Encode.string);
        }, [
            "variantId",
            param.variantId
        ]), function(__x) {
            return $jVmMx.Encode.nullable(__x, $jVmMx.Encode.string);
        }, [
            "productCategoryId",
            param.productCategoryId
        ]));
    };
    var storeCategoryLink_toJson = function storeCategoryLink_toJson(param) {
        return $iv6Yc._1($jVmMx.Encode.object, [
            [
                "categoryId",
                $iv6Yc._1($jVmMx.Encode.string, param.categoryId)
            ],
            [
                "sortBy",
                $04dLg.ProductSortOrder.toJson(param.sortBy)
            ],
            [
                "count",
                $iv6Yc._1($jVmMx.Encode.$$int, param.count)
            ],
            [
                "relatedMediaCount",
                $jVmMx.Encode.nullable(param.relatedMediaCount, $jVmMx.Encode.$$int)
            ]
        ]);
    };
    var customActionLink_toJson = function customActionLink_toJson(param) {
        return $iv6Yc._1($jVmMx.Encode.object, [
            [
                "customActionId",
                $iv6Yc._1($dRfYk.toJson, param.customActionId)
            ],
            [
                "code",
                $iv6Yc._1($jVmMx.Encode.string, param.code)
            ],
            [
                "name",
                $iv6Yc._1($jVmMx.Encode.string, param.name)
            ]
        ]);
    };
    switch(v.TAG | 0){
        case /* URL */ 0:
            return $jVmMx.Encode.deccoVariantWithPayload(v._0, "URL", $jVmMx.Encode.string);
        case /* Category */ 1:
            return $jVmMx.Encode.deccoVariantWithPayload(v._0, "Category", categoryLink_toJson);
        case /* Product */ 2:
            return $jVmMx.Encode.deccoVariantWithPayload(v._0, "Product", productLink_toJson);
        case /* StoreCategory */ 3:
            return $jVmMx.Encode.deccoVariantWithPayload(v._0, "StoreCategory", storeCategoryLink_toJson);
        case /* CustomAction */ 4:
            return $jVmMx.Encode.deccoVariantWithPayload(v._0, "CustomAction", customActionLink_toJson);
    }
}
var $965e8e3de14ed127$var$fromJson$1 = $ij6do.Link.fromJson;
var $965e8e3de14ed127$export$a6c7ac8248d6e38a = {
    toJson: $965e8e3de14ed127$var$toJson$1,
    fromJson: $965e8e3de14ed127$var$fromJson$1
};
function $965e8e3de14ed127$var$videoCard_toJson(param) {
    return $iv6Yc._1($jVmMx.Encode.object, $jVmMx.Encode.addIf(undefined, $jVmMx.Encode.addIf(undefined, $jVmMx.Encode.addIf(undefined, $jVmMx.Encode.addIf(undefined, $jVmMx.Encode.addIf(/* Square */ 1, $jVmMx.Encode.addIf(/* Lg */ 5, [
        [
            "videoUrl",
            $iv6Yc._1($jVmMx.Encode.string, param.videoUrl)
        ]
    ], $965e8e3de14ed127$var$toJson, [
        "size",
        param.size
    ]), $fin9m.cardShape_toJson, [
        "shape",
        param.shape
    ]), function(__x) {
        return $jVmMx.Encode.nullable(__x, $965e8e3de14ed127$var$toJson$1);
    }, [
        "link",
        param.link
    ]), function(__x) {
        return $jVmMx.Encode.nullable(__x, $jVmMx.Encode.$$int);
    }, [
        "width",
        param.width
    ]), function(__x) {
        return $jVmMx.Encode.nullable(__x, $jVmMx.Encode.$$int);
    }, [
        "height",
        param.height
    ]), function(__x) {
        return $jVmMx.Encode.nullable(__x, $jVmMx.Encode.string);
    }, [
        "fallbackImageUrl",
        param.fallbackImageUrl
    ]));
}
var $965e8e3de14ed127$var$videoCard_fromJson = $ij6do.CategoryCard.videoCard_fromJson;
function $965e8e3de14ed127$var$imageCard_toJson(param) {
    return $iv6Yc._1($jVmMx.Encode.object, $jVmMx.Encode.addIf(undefined, $jVmMx.Encode.addIf(undefined, $jVmMx.Encode.addIf(undefined, $jVmMx.Encode.addIf(/* Square */ 1, $jVmMx.Encode.addIf(/* Lg */ 5, [
        [
            "imageUrl",
            $iv6Yc._1($jVmMx.Encode.string, param.imageUrl)
        ]
    ], $965e8e3de14ed127$var$toJson, [
        "size",
        param.size
    ]), $fin9m.cardShape_toJson, [
        "shape",
        param.shape
    ]), function(__x) {
        return $jVmMx.Encode.nullable(__x, $965e8e3de14ed127$var$toJson$1);
    }, [
        "link",
        param.link
    ]), function(__x) {
        return $jVmMx.Encode.nullable(__x, $jVmMx.Encode.$$int);
    }, [
        "width",
        param.width
    ]), function(__x) {
        return $jVmMx.Encode.nullable(__x, $jVmMx.Encode.$$int);
    }, [
        "height",
        param.height
    ]));
}
var $965e8e3de14ed127$var$imageCard_fromJson = $ij6do.CategoryCard.imageCard_fromJson;
function $965e8e3de14ed127$var$imageLinkCard_toJson(param) {
    return $iv6Yc._1($jVmMx.Encode.object, $jVmMx.Encode.addIf(/* Square */ 1, $jVmMx.Encode.addIf(/* Lg */ 5, [
        [
            "link",
            $965e8e3de14ed127$var$toJson$1(param.link)
        ],
        [
            "imageUrl",
            $iv6Yc._1($jVmMx.Encode.string, param.imageUrl)
        ]
    ], $965e8e3de14ed127$var$toJson, [
        "size",
        param.size
    ]), $fin9m.cardShape_toJson, [
        "shape",
        param.shape
    ]));
}
var $965e8e3de14ed127$var$imageLinkCard_fromJson = $ij6do.CategoryCard.imageLinkCard_fromJson;
function $965e8e3de14ed127$var$videoLinkCard_toJson(param) {
    return $iv6Yc._1($jVmMx.Encode.object, $jVmMx.Encode.addIf(undefined, $jVmMx.Encode.addIf(/* Square */ 1, $jVmMx.Encode.addIf(/* Lg */ 5, [
        [
            "link",
            $965e8e3de14ed127$var$toJson$1(param.link)
        ],
        [
            "videoUrl",
            $iv6Yc._1($jVmMx.Encode.string, param.videoUrl)
        ]
    ], $965e8e3de14ed127$var$toJson, [
        "size",
        param.size
    ]), $fin9m.cardShape_toJson, [
        "shape",
        param.shape
    ]), function(__x) {
        return $jVmMx.Encode.nullable(__x, $jVmMx.Encode.string);
    }, [
        "fallbackImageUrl",
        param.fallbackImageUrl
    ]));
}
var $965e8e3de14ed127$var$videoLinkCard_fromJson = $ij6do.CategoryCard.videoLinkCard_fromJson;
function $965e8e3de14ed127$var$medialessCard_toJson(param) {
    return $iv6Yc._1($jVmMx.Encode.object, $jVmMx.Encode.addIf(/* Square */ 1, $jVmMx.Encode.addIf(/* Lg */ 5, [
        [
            "link",
            $jVmMx.Encode.nullable(param.link, $965e8e3de14ed127$var$toJson$1)
        ]
    ], $965e8e3de14ed127$var$toJson, [
        "size",
        param.size
    ]), $fin9m.cardShape_toJson, [
        "shape",
        param.shape
    ]));
}
var $965e8e3de14ed127$var$medialessCard_fromJson = $ij6do.CategoryCard.medialessCard_fromJson;
function $965e8e3de14ed127$var$medialessLinkCard_toJson(param) {
    return $iv6Yc._1($jVmMx.Encode.object, $jVmMx.Encode.addIf(/* Square */ 1, $jVmMx.Encode.addIf(/* Lg */ 5, [
        [
            "link",
            $965e8e3de14ed127$var$toJson$1(param.link)
        ]
    ], $965e8e3de14ed127$var$toJson, [
        "size",
        param.size
    ]), $fin9m.cardShape_toJson, [
        "shape",
        param.shape
    ]));
}
var $965e8e3de14ed127$var$medialessLinkCard_fromJson = $ij6do.CategoryCard.medialessLinkCard_fromJson;
function $965e8e3de14ed127$var$imageDisplayCard_toJson(param) {
    return $iv6Yc._1($jVmMx.Encode.object, $jVmMx.Encode.addIf(/* Square */ 1, $jVmMx.Encode.addIf(/* Lg */ 5, [
        [
            "imageUrl",
            $iv6Yc._1($jVmMx.Encode.string, param.imageUrl)
        ]
    ], $965e8e3de14ed127$var$toJson, [
        "size",
        param.size
    ]), $fin9m.cardShape_toJson, [
        "shape",
        param.shape
    ]));
}
var $965e8e3de14ed127$var$imageDisplayCard_fromJson = $ij6do.CategoryCard.imageDisplayCard_fromJson;
function $965e8e3de14ed127$var$videoDisplayCard_toJson(param) {
    return $iv6Yc._1($jVmMx.Encode.object, $jVmMx.Encode.addIf(/* Square */ 1, $jVmMx.Encode.addIf(/* Lg */ 5, [
        [
            "videoUrl",
            $iv6Yc._1($jVmMx.Encode.string, param.videoUrl)
        ],
        [
            "fallbackImageUrl",
            $jVmMx.Encode.nullable(param.fallbackImageUrl, $jVmMx.Encode.string)
        ]
    ], $965e8e3de14ed127$var$toJson, [
        "size",
        param.size
    ]), $fin9m.cardShape_toJson, [
        "shape",
        param.shape
    ]));
}
var $965e8e3de14ed127$var$videoDisplayCard_fromJson = $ij6do.CategoryCard.videoDisplayCard_fromJson;
function $965e8e3de14ed127$var$toJson$2(v) {
    switch(v.TAG | 0){
        case /* ImageLinkCard */ 0:
            return $jVmMx.Encode.deccoVariantWithPayload(v._0, "ImageLinkCard", $965e8e3de14ed127$var$imageLinkCard_toJson);
        case /* VideoLinkCard */ 1:
            return $jVmMx.Encode.deccoVariantWithPayload(v._0, "VideoLinkCard", $965e8e3de14ed127$var$videoLinkCard_toJson);
        case /* ImageCard */ 2:
            return $jVmMx.Encode.deccoVariantWithPayload(v._0, "ImageCard", $965e8e3de14ed127$var$imageCard_toJson);
        case /* VideoCard */ 3:
            return $jVmMx.Encode.deccoVariantWithPayload(v._0, "VideoCard", $965e8e3de14ed127$var$videoCard_toJson);
        case /* MedialessCard */ 4:
            return $jVmMx.Encode.deccoVariantWithPayload(v._0, "MedialessCard", $965e8e3de14ed127$var$medialessCard_toJson);
        case /* MedialessLinkCard */ 5:
            return $jVmMx.Encode.deccoVariantWithPayload(v._0, "MedialessLinkCard", $965e8e3de14ed127$var$medialessLinkCard_toJson);
        case /* ImageDisplayCard */ 6:
            return $jVmMx.Encode.deccoVariantWithPayload(v._0, "ImageDisplayCard", $965e8e3de14ed127$var$imageDisplayCard_toJson);
        case /* VideoDisplayCard */ 7:
            return $jVmMx.Encode.deccoVariantWithPayload(v._0, "VideoDisplayCard", $965e8e3de14ed127$var$videoDisplayCard_toJson);
    }
}
var $965e8e3de14ed127$var$fromJson$2 = $ij6do.CategoryCard.fromJson;
var $965e8e3de14ed127$export$5fbe069c73ec3073 = {
    videoCard_toJson: $965e8e3de14ed127$var$videoCard_toJson,
    videoCard_fromJson: $965e8e3de14ed127$var$videoCard_fromJson,
    imageCard_toJson: $965e8e3de14ed127$var$imageCard_toJson,
    imageCard_fromJson: $965e8e3de14ed127$var$imageCard_fromJson,
    imageLinkCard_toJson: $965e8e3de14ed127$var$imageLinkCard_toJson,
    imageLinkCard_fromJson: $965e8e3de14ed127$var$imageLinkCard_fromJson,
    videoLinkCard_toJson: $965e8e3de14ed127$var$videoLinkCard_toJson,
    videoLinkCard_fromJson: $965e8e3de14ed127$var$videoLinkCard_fromJson,
    medialessCard_toJson: $965e8e3de14ed127$var$medialessCard_toJson,
    medialessCard_fromJson: $965e8e3de14ed127$var$medialessCard_fromJson,
    medialessLinkCard_toJson: $965e8e3de14ed127$var$medialessLinkCard_toJson,
    medialessLinkCard_fromJson: $965e8e3de14ed127$var$medialessLinkCard_fromJson,
    imageDisplayCard_toJson: $965e8e3de14ed127$var$imageDisplayCard_toJson,
    imageDisplayCard_fromJson: $965e8e3de14ed127$var$imageDisplayCard_fromJson,
    videoDisplayCard_toJson: $965e8e3de14ed127$var$videoDisplayCard_toJson,
    videoDisplayCard_fromJson: $965e8e3de14ed127$var$videoDisplayCard_fromJson,
    toJson: $965e8e3de14ed127$var$toJson$2,
    fromJson: $965e8e3de14ed127$var$fromJson$2
};
function $965e8e3de14ed127$var$storeCategoryConnection_toJson(param) {
    return $iv6Yc._1($jVmMx.Encode.object, [
        [
            "categoryId",
            $iv6Yc._1($jVmMx.Encode.string, param.categoryId)
        ],
        [
            "sortBy",
            $04dLg.ProductSortOrder.toJson(param.sortBy)
        ],
        [
            "filterBy",
            $jVmMx.Encode.nullable(param.filterBy, function(__x) {
                return $iv6Yc._2($jVmMx.Encode.array, __x, $jVmMx.Encode.string);
            })
        ],
        [
            "count",
            $iv6Yc._1($jVmMx.Encode.$$int, param.count)
        ],
        [
            "relatedMediaCount",
            $jVmMx.Encode.nullable(param.relatedMediaCount, $jVmMx.Encode.$$int)
        ]
    ]);
}
var $965e8e3de14ed127$var$storeCategoryConnection_fromJson = $ij6do.ExternalConnection.storeCategoryConnection_fromJson;
function $965e8e3de14ed127$var$configEmbedConnection_toJson(param) {
    return $iv6Yc._1($jVmMx.Encode.object, [
        [
            "configId",
            $iv6Yc._1($jVmMx.Encode.string, param.configId)
        ]
    ]);
}
var $965e8e3de14ed127$var$configEmbedConnection_fromJson = $ij6do.ExternalConnection.configEmbedConnection_fromJson;
function $965e8e3de14ed127$var$toJson$3(source) {
    if (typeof source !== "number") {
        if (source.TAG === /* StoreCategory */ 0) return $jVmMx.Encode.deccoVariantWithPayload(source._0, "StoreCategory", $965e8e3de14ed127$var$storeCategoryConnection_toJson);
        else return $jVmMx.Encode.deccoVariantWithPayload(source._0, "ConfigEmbed", $965e8e3de14ed127$var$configEmbedConnection_toJson);
    }
    switch(source){
        case /* History */ 0:
            return $jVmMx.Encode.simpleVariant([
                [
                    "History",
                    /* History */ 0
                ]
            ], /* History */ 0);
        case /* Favorites */ 1:
            return $jVmMx.Encode.simpleVariant([
                [
                    "Favorites",
                    /* Favorites */ 1
                ]
            ], /* Favorites */ 1);
        case /* StoreCart */ 2:
            return $jVmMx.Encode.simpleVariant([
                [
                    "StoreCart",
                    /* StoreCart */ 2
                ]
            ], /* StoreCart */ 2);
    }
}
var $965e8e3de14ed127$var$fromJson$3 = $ij6do.ExternalConnection.fromJson;
var $965e8e3de14ed127$var$t_v1_fromJson = $ij6do.ExternalConnection.t_v1_fromJson;
var $965e8e3de14ed127$var$fromJson$4 = $79vie.oneOf($965e8e3de14ed127$var$fromJson$3, [
    $965e8e3de14ed127$var$t_v1_fromJson
]);
var $965e8e3de14ed127$export$9b7d2686799c37a = {
    storeCategoryConnection_toJson: $965e8e3de14ed127$var$storeCategoryConnection_toJson,
    storeCategoryConnection_fromJson: $965e8e3de14ed127$var$storeCategoryConnection_fromJson,
    configEmbedConnection_toJson: $965e8e3de14ed127$var$configEmbedConnection_toJson,
    configEmbedConnection_fromJson: $965e8e3de14ed127$var$configEmbedConnection_fromJson,
    toJson: $965e8e3de14ed127$var$toJson$3,
    t_v1_fromJson: $965e8e3de14ed127$var$t_v1_fromJson,
    fromJson: $965e8e3de14ed127$var$fromJson$4
};
function $965e8e3de14ed127$export$b1e2a34e4e928b82(v) {
    if (typeof v === "number") return $jVmMx.Encode.simpleVariant([
        [
            "NoLayout",
            /* NoLayout */ 0
        ]
    ], /* NoLayout */ 0);
    switch(v.TAG | 0){
        case /* SubCategoriesSlider */ 0:
            return $jVmMx.Encode.deccoVariantWithPayload(v._0, "SubCategoriesSlider", $fin9m.sliderPayload_toJson);
        case /* SubCategoriesSliderWithHeader */ 1:
            return $jVmMx.Encode.deccoVariantWithPayload(v._0, "SubCategoriesSliderWithHeader", $fin9m.sliderPayload_toJson);
        case /* SubCategoriesGrid */ 2:
            return $jVmMx.Encode.deccoVariantWithPayload(v._0, "SubCategoriesGrid", $fin9m.gridPayload_toJson);
        case /* ProductGrid */ 3:
            return $jVmMx.Encode.deccoVariantWithPayload(v._0, "ProductGrid", $fin9m.gridPayload_toJson);
        case /* ProductSlider */ 4:
            return $jVmMx.Encode.deccoVariantWithPayload(v._0, "ProductSlider", $fin9m.sliderPayload_toJson);
    }
}
function $965e8e3de14ed127$export$af661a7cdd7ac535(param) {
    return $iv6Yc._1($jVmMx.Encode.object, $jVmMx.Encode.addIf(undefined, $jVmMx.Encode.addIf(undefined, [
        [
            "link",
            $iv6Yc._1($jVmMx.Encode.string, param.link)
        ]
    ], function(__x) {
        return $jVmMx.Encode.nullable(__x, $jVmMx.Encode.$$int);
    }, [
        "imageWidth",
        param.imageWidth
    ]), function(__x) {
        return $jVmMx.Encode.nullable(__x, $jVmMx.Encode.$$int);
    }, [
        "imageHeight",
        param.imageHeight
    ]));
}
function $965e8e3de14ed127$export$d5b7a8bf56ee1fe2(param) {
    return $iv6Yc._1($jVmMx.Encode.object, $jVmMx.Encode.addIf(false, $jVmMx.Encode.addIf(/* LegacyTheme */ 0, $jVmMx.Encode.addIf(/* LegacyTheme */ 0, $jVmMx.Encode.addIf(undefined, $jVmMx.Encode.addIf(undefined, $jVmMx.Encode.addIf(/* ChildrenFirst */ 0, $jVmMx.Encode.addIf(undefined, $jVmMx.Encode.addIf(undefined, $jVmMx.Encode.addIf(/* NoLayout */ 0, $jVmMx.Encode.addIf(/* NoLayout */ 0, $jVmMx.Encode.addIf(/* NoLayout */ 0, $jVmMx.Encode.addIf(true, $jVmMx.Encode.addIf(true, $jVmMx.Encode.addIf(true, $jVmMx.Encode.addIf(true, $jVmMx.Encode.addIf(true, $jVmMx.Encode.addIf(true, $jVmMx.Encode.addIf(true, $jVmMx.Encode.addIf(undefined, $jVmMx.Encode.addIf("", [
        [
            "id",
            $iv6Yc._1($jVmMx.Encode.string, param.id)
        ],
        [
            "card",
            $965e8e3de14ed127$var$toJson$2(param.card)
        ],
        [
            "categoryType",
            $965e8e3de14ed127$export$d194f3d683133ffb(param.categoryType)
        ]
    ], $jVmMx.Encode.string, [
        "title",
        param.title
    ]), function(__x) {
        return $jVmMx.Encode.nullable(__x, $jVmMx.Encode.string);
    }, [
        "description",
        param.description
    ]), $jVmMx.Encode.bool, [
        "showTitle",
        param.showTitle
    ]), $jVmMx.Encode.bool, [
        "showDescription",
        param.showDescription
    ]), $jVmMx.Encode.bool, [
        "visible",
        param.visible
    ]), $jVmMx.Encode.bool, [
        "visibleInMenuBar",
        param.visibleInMenuBar
    ]), $jVmMx.Encode.bool, [
        "visibleInSectionList",
        param.visibleInSectionList
    ]), $jVmMx.Encode.bool, [
        "visibleInParent",
        param.visibleInParent
    ]), $jVmMx.Encode.bool, [
        "visibleInHeaderSlider",
        param.visibleInHeaderSlider
    ]), $965e8e3de14ed127$export$b1e2a34e4e928b82, [
        "listPageActiveLayout",
        param.listPageActiveLayout
    ]), $965e8e3de14ed127$export$b1e2a34e4e928b82, [
        "userSelectedLayout",
        param.userSelectedLayout
    ]), $965e8e3de14ed127$export$b1e2a34e4e928b82, [
        "forcedPLPLayout",
        param.forcedPLPLayout
    ]), function(__x) {
        return $jVmMx.Encode.nullable(__x, $fnO65.CategoryTabSettings.toJson);
    }, [
        "tabbedSubCategories",
        param.tabbedSubCategories
    ]), function(__x) {
        return $jVmMx.Encode.nullable(__x, $cvFfT.SocialNetworkSource.toJson);
    }, [
        "socialNetworkSource",
        param.socialNetworkSource
    ]), $5lwUf.DisplayPriority.toJson, [
        "displayPriority",
        param.displayPriority
    ]), function(__x) {
        return $jVmMx.Encode.nullable(__x, $jVmMx.Encode.bool);
    }, [
        "expandVariantsInProductsListing",
        param.expandVariantsInProductsListing
    ]), function(__x) {
        return $jVmMx.Encode.nullable(__x, $jVmMx.Encode.$$float);
    }, [
        "lastModifiedAt",
        param.lastModifiedAt
    ]), $fFzkv.reference_toJson, [
        "sectionTheme",
        param.sectionTheme
    ]), $fFzkv.reference_toJson, [
        "pageTheme",
        param.pageTheme
    ]), $jVmMx.Encode.bool, [
        "stickySection",
        param.stickySection
    ]));
}
function $965e8e3de14ed127$export$41945fcab21e0ca0(param) {
    return $iv6Yc._1($jVmMx.Encode.object, $jVmMx.Encode.addIf(undefined, $jVmMx.Encode.addIf(undefined, $jVmMx.Encode.addIf(undefined, $jVmMx.Encode.addIf(undefined, $jVmMx.Encode.addIf([], $jVmMx.Encode.addIf(undefined, $jVmMx.Encode.addIf(undefined, $jVmMx.Encode.addIf(0, $jVmMx.Encode.addIf(undefined, [
        [
            "configId",
            $iv6Yc._1($jVmMx.Encode.string, param.configId)
        ],
        [
            "children",
            $iv6Yc._2($jVmMx.Encode.array, param.children, $965e8e3de14ed127$export$d5b7a8bf56ee1fe2)
        ]
    ], function(__x) {
        return $jVmMx.Encode.nullable(__x, $jVmMx.Encode.string);
    }, [
        "loadMoreChildren",
        param.loadMoreChildren
    ]), $jVmMx.Encode.$$int, [
        "totalChildren",
        param.totalChildren
    ]), function(__x) {
        return $jVmMx.Encode.nullable(__x, $965e8e3de14ed127$var$toJson$2);
    }, [
        "firstCard",
        param.firstCard
    ]), function(__x) {
        return $jVmMx.Encode.nullable(__x, $jVmMx.Encode.string);
    }, [
        "link",
        param.link
    ]), $7Qe3X.TaggedProducts.toJson, [
        "products",
        param.products
    ]), function(__x) {
        return $jVmMx.Encode.nullable(__x, $965e8e3de14ed127$export$c74db3ae56d7358);
    }, [
        "taggedMedia",
        param.taggedMedia
    ]), function(__x) {
        return $jVmMx.Encode.nullable(__x, function(__x) {
            return $iv6Yc._2($jVmMx.Encode.array, __x, $cXBWA.toJson);
        });
    }, [
        "imageHotspots",
        param.imageHotspots
    ]), function(__x) {
        return $jVmMx.Encode.nullable(__x, $jVmMx.Encode.$$int);
    }, [
        "imageWidth",
        param.imageWidth
    ]), function(__x) {
        return $jVmMx.Encode.nullable(__x, $jVmMx.Encode.$$int);
    }, [
        "imageHeight",
        param.imageHeight
    ]));
}
function $965e8e3de14ed127$export$68b78bf03d398edc(param) {
    return $iv6Yc._1($jVmMx.Encode.object, $jVmMx.Encode.addIf(undefined, $jVmMx.Encode.addIf(undefined, $jVmMx.Encode.addIf(undefined, $jVmMx.Encode.addIf([], $jVmMx.Encode.addIf(undefined, $jVmMx.Encode.addIf(undefined, $jVmMx.Encode.addIf(undefined, $jVmMx.Encode.addIf(0, $jVmMx.Encode.addIf(undefined, [
        [
            "children",
            $iv6Yc._2($jVmMx.Encode.array, param.children, $965e8e3de14ed127$export$d5b7a8bf56ee1fe2)
        ]
    ], function(__x) {
        return $jVmMx.Encode.nullable(__x, $jVmMx.Encode.string);
    }, [
        "loadMoreChildren",
        param.loadMoreChildren
    ]), $jVmMx.Encode.$$int, [
        "totalChildren",
        param.totalChildren
    ]), function(__x) {
        return $jVmMx.Encode.nullable(__x, $965e8e3de14ed127$var$toJson$2);
    }, [
        "firstCard",
        param.firstCard
    ]), function(__x) {
        return $jVmMx.Encode.nullable(__x, $965e8e3de14ed127$var$toJson$3);
    }, [
        "externalConnection",
        param.externalConnection
    ]), function(__x) {
        return $jVmMx.Encode.nullable(__x, $jVmMx.Encode.string);
    }, [
        "link",
        param.link
    ]), $7Qe3X.TaggedProducts.toJson, [
        "products",
        param.products
    ]), function(__x) {
        return $jVmMx.Encode.nullable(__x, $965e8e3de14ed127$export$c74db3ae56d7358);
    }, [
        "taggedMedia",
        param.taggedMedia
    ]), function(__x) {
        return $jVmMx.Encode.nullable(__x, $jVmMx.Encode.$$int);
    }, [
        "imageHeight",
        param.imageHeight
    ]), function(__x) {
        return $jVmMx.Encode.nullable(__x, $jVmMx.Encode.$$int);
    }, [
        "imageWidth",
        param.imageWidth
    ]));
}
function $965e8e3de14ed127$export$abf03b6af9b8b685(param) {
    return $iv6Yc._1($jVmMx.Encode.object, $jVmMx.Encode.addIf([], $jVmMx.Encode.addIf(undefined, $jVmMx.Encode.addIf(undefined, [], function(__x) {
        return $jVmMx.Encode.nullable(__x, $965e8e3de14ed127$var$toJson$3);
    }, [
        "externalConnection",
        param.externalConnection
    ]), function(__x) {
        return $jVmMx.Encode.nullable(__x, $965e8e3de14ed127$export$c74db3ae56d7358);
    }, [
        "taggedMedia",
        param.taggedMedia
    ]), $7Qe3X.TaggedProducts.toJson, [
        "products",
        param.products
    ]));
}
function $965e8e3de14ed127$export$b3e6093e3620ebdb(param) {
    var products = param.products;
    return $iv6Yc._1($jVmMx.Encode.object, $jVmMx.Encode.addIf(undefined, $jVmMx.Encode.addIf(undefined, $jVmMx.Encode.addIf(undefined, $jVmMx.Encode.addIf([], $jVmMx.Encode.addIf([], $jVmMx.Encode.addIf(undefined, $jVmMx.Encode.addIf(undefined, $jVmMx.Encode.addIf(undefined, $jVmMx.Encode.addIf(false, $jVmMx.Encode.addIf(false, $jVmMx.Encode.addIf(0, $jVmMx.Encode.addIf(undefined, [
        [
            "children",
            $iv6Yc._2($jVmMx.Encode.array, param.children, $965e8e3de14ed127$export$d5b7a8bf56ee1fe2)
        ]
    ], function(__x) {
        return $jVmMx.Encode.nullable(__x, $jVmMx.Encode.string);
    }, [
        "loadMoreChildren",
        param.loadMoreChildren
    ]), $jVmMx.Encode.$$int, [
        "totalChildren",
        param.totalChildren
    ]), $jVmMx.Encode.bool, [
        "isStories",
        param.isStories
    ]), $jVmMx.Encode.bool, [
        "isPinned",
        param.isPinned
    ]), function(__x) {
        return $jVmMx.Encode.nullable(__x, $965e8e3de14ed127$var$toJson$2);
    }, [
        "firstCard",
        param.firstCard
    ]), function(__x) {
        return $jVmMx.Encode.nullable(__x, $965e8e3de14ed127$var$toJson$3);
    }, [
        "externalConnection",
        param.externalConnection
    ]), function(__x) {
        return $jVmMx.Encode.nullable(__x, $jVmMx.Encode.string);
    }, [
        "link",
        param.link
    ]), $7Qe3X.TaggedProducts.toJson, [
        "products",
        products
    ]), $7Qe3X.TaggedProducts.toJson, [
        "products",
        products
    ]), function(value) {
        return $jVmMx.Encode.nullable(value, function(__x) {
            return $iv6Yc._2($jVmMx.Encode.array, __x, $cXBWA.toJson);
        });
    }, [
        "imageHotspots",
        param.imageHotspots
    ]), function(__x) {
        return $jVmMx.Encode.nullable(__x, $jVmMx.Encode.$$int);
    }, [
        "imageWidth",
        param.imageWidth
    ]), function(__x) {
        return $jVmMx.Encode.nullable(__x, $jVmMx.Encode.$$int);
    }, [
        "imageHeight",
        param.imageHeight
    ]));
}
function $965e8e3de14ed127$export$fe39dcb116b81ff(param) {
    return $iv6Yc._1($jVmMx.Encode.object, [
        [
            "component",
            $7lqRw.reference_toJson(param.component)
        ]
    ]);
}
function $965e8e3de14ed127$export$c74db3ae56d7358(param) {
    return $iv6Yc._1($jVmMx.Encode.object, $jVmMx.Encode.addIf(/* FitCover */ 0, $jVmMx.Encode.addIf(undefined, $jVmMx.Encode.addIf(undefined, $jVmMx.Encode.addIf(undefined, $jVmMx.Encode.addIf(undefined, $jVmMx.Encode.addIf(/* InlineDisplay */ 0, [
        [
            "source",
            $965e8e3de14ed127$export$59412ed590e45b2a(param.source)
        ]
    ], $ZzK4r.TaggedMedia.displayType_toJson, [
        "displayType",
        param.displayType
    ]), function(__x) {
        return $jVmMx.Encode.nullable(__x, $jVmMx.Encode.$$int);
    }, [
        "cardWidth",
        param.cardWidth
    ]), function(__x) {
        return $jVmMx.Encode.nullable(__x, $jVmMx.Encode.$$int);
    }, [
        "cardHeight",
        param.cardHeight
    ]), function(__x) {
        return $jVmMx.Encode.nullable(__x, $jVmMx.Encode.$$int);
    }, [
        "startRowOffset",
        param.startRowOffset
    ]), function(__x) {
        return $jVmMx.Encode.nullable(__x, $jVmMx.Encode.$$float);
    }, [
        "slidesPerView",
        param.slidesPerView
    ]), $ZzK4r.TaggedMedia.imageFit_toJson, [
        "imageFit",
        param.imageFit
    ]));
}
function $965e8e3de14ed127$export$d194f3d683133ffb(v) {
    if (typeof v === "number") return $jVmMx.Encode.simpleVariant([
        [
            "Page",
            /* Page */ 0
        ]
    ], v);
    switch(v.TAG | 0){
        case /* Link */ 0:
            return $jVmMx.Encode.deccoVariantWithPayload(v._0, "Link", $965e8e3de14ed127$export$af661a7cdd7ac535);
        case /* Standard */ 1:
            return $jVmMx.Encode.deccoVariantWithPayload(v._0, "Standard", $965e8e3de14ed127$export$68b78bf03d398edc);
        case /* QuickView */ 2:
            return $jVmMx.Encode.deccoVariantWithPayload(v._0, "QuickView", $965e8e3de14ed127$export$b3e6093e3620ebdb);
        case /* Index */ 3:
            return $jVmMx.Encode.deccoVariantWithPayload(v._0, "Index", $965e8e3de14ed127$export$abf03b6af9b8b685);
        case /* ConfigEmbed */ 4:
            return $jVmMx.Encode.deccoVariantWithPayload(v._0, "ConfigEmbed", $965e8e3de14ed127$export$41945fcab21e0ca0);
        case /* CustomComponentSection */ 5:
            return $jVmMx.Encode.deccoVariantWithPayload(v._0, "CustomComponentSection", $965e8e3de14ed127$export$fe39dcb116b81ff);
        case /* EmbedCodeSection */ 6:
            return $jVmMx.Encode.deccoVariantWithPayload(v._0, "EmbedCodeSection", $aNn17.t_encode);
    }
}
function $965e8e3de14ed127$export$59412ed590e45b2a(source) {
    return $jVmMx.Encode.deccoVariantWithPayload(source._0, "Manual", function(__x) {
        return $iv6Yc._2($jVmMx.Encode.array, __x, $965e8e3de14ed127$export$d5b7a8bf56ee1fe2);
    });
}
function $965e8e3de14ed127$var$toJson$5(v) {
    return $iv6Yc._1($jVmMx.Encode.object, [
        [
            "categories",
            $iv6Yc._2($jVmMx.Encode.array, v.categories, $965e8e3de14ed127$export$d5b7a8bf56ee1fe2)
        ],
        [
            "previous",
            $jVmMx.Encode.nullable(v.previous, $jVmMx.Encode.string)
        ],
        [
            "next",
            $jVmMx.Encode.nullable(v.next, $jVmMx.Encode.string)
        ],
        [
            "offset",
            $iv6Yc._1($jVmMx.Encode.$$int, v.offset)
        ],
        [
            "total",
            $iv6Yc._1($jVmMx.Encode.$$int, v.total)
        ]
    ]);
}
var $965e8e3de14ed127$var$fromJson$5 = $ij6do.Page.fromJson;
var $965e8e3de14ed127$export$6955bcca4cd3539f = {
    toJson: $965e8e3de14ed127$var$toJson$5,
    fromJson: $965e8e3de14ed127$var$fromJson$5
};
var $965e8e3de14ed127$export$4e73ccac02f50c1c = $ij6do.layout_fromJson;
var $965e8e3de14ed127$export$4447e9406ed8729a = $ij6do.linkCategory_fromJson;
var $965e8e3de14ed127$export$7ae2d2a8b28a8cb8 = $ij6do.fromJson;
var $965e8e3de14ed127$export$66ee41028aa2b6df = $ij6do.category_fromJson;
var $965e8e3de14ed127$export$b6ac0a9f368576b6 = $ij6do.taggedMediaSource_fromJson;
var $965e8e3de14ed127$export$c9a9d5efc52cc0e9 = $ij6do.taggedMedia_fromJson;
var $965e8e3de14ed127$export$5855298e525169e0 = $ij6do.quickviewCategory_fromJson;
var $965e8e3de14ed127$export$b1fdf50be3d3b56a = $ij6do.indexCategory_fromJson;
var $965e8e3de14ed127$export$34cabec5ccdcad25 = $ij6do.configEmbedCategory_fromJson;
var $965e8e3de14ed127$export$ec0974398445544b = $ij6do.customComponentCategory_fromJson;
var $965e8e3de14ed127$export$9ebb77ea9091af9c = $ij6do.categoryType_fromJson;
 /* fromJson Not a pure module */ 
});
parcelRegister("fin9m", function(module, exports) {

$parcel$export(module.exports, "smartbarCategoryLayout_toJson", function () { return $b22a7e9364837e04$export$691c196d3f7dc224; });
$parcel$export(module.exports, "smartbarCategorySize_toJson", function () { return $b22a7e9364837e04$export$32c83531346916c; });
$parcel$export(module.exports, "cardShape_toJson", function () { return $b22a7e9364837e04$export$1e863f3dbfe761fd; });
$parcel$export(module.exports, "gridPayload_toJson", function () { return $b22a7e9364837e04$export$e3e306bb99732ba5; });
$parcel$export(module.exports, "sliderPayload_toJson", function () { return $b22a7e9364837e04$export$2c2cf81ad1b771ea; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $jVmMx = parcelRequire("jVmMx");

var $bkHbG = parcelRequire("bkHbG");

var $5kJL4 = parcelRequire("5kJL4");
var $b22a7e9364837e04$var$partial_arg = [
    [
        "OneColumnGrid",
        /* OneColumnGrid */ 0
    ],
    [
        "TwoColumnGrid",
        /* TwoColumnGrid */ 1
    ],
    [
        "ThreeColumnGrid",
        /* ThreeColumnGrid */ 2
    ],
    [
        "FourColumnGrid",
        /* FourColumnGrid */ 3
    ],
    [
        "FiveColumnGrid",
        /* FiveColumnGrid */ 4
    ],
    [
        "SixColumnGrid",
        /* SixColumnGrid */ 5
    ],
    [
        "SevenColumnGrid",
        /* SevenColumnGrid */ 6
    ],
    [
        "EightColumnGrid",
        /* EightColumnGrid */ 7
    ],
    [
        "TwelveColumnGrid",
        /* TwelveColumnGrid */ 8
    ]
];
function $b22a7e9364837e04$export$f37b5a4ead4e4f53(param) {
    return $jVmMx.Encode.simpleVariant($b22a7e9364837e04$var$partial_arg, param);
}
function $b22a7e9364837e04$export$cf1da31c1d8e49bd(v) {
    if (typeof v !== "number") return $jVmMx.Encode.deccoVariantWithPayload(v._0, "Pixels", $jVmMx.Encode.$$int);
    switch(v){
        case /* Equal */ 0:
            return $iv6Yc._2($jVmMx.Encode.array, [
                "Equal"
            ], $jVmMx.Encode.string);
        case /* Half */ 1:
            return $iv6Yc._2($jVmMx.Encode.array, [
                "Half"
            ], $jVmMx.Encode.string);
        case /* Double */ 2:
            return $iv6Yc._2($jVmMx.Encode.array, [
                "Double"
            ], $jVmMx.Encode.string);
    }
}
var $b22a7e9364837e04$var$partial_arg$1 = [
    [
        "EffectSlide",
        /* EffectSlide */ 0
    ],
    [
        "EffectFade",
        /* EffectFade */ 1
    ]
];
function $b22a7e9364837e04$export$c897463d3ff3d06b(param) {
    return $jVmMx.Encode.simpleVariant($b22a7e9364837e04$var$partial_arg$1, param);
}
var $b22a7e9364837e04$var$partial_arg$2 = [
    [
        "NavAuto",
        /* NavAuto */ 0
    ],
    [
        "NavScrollbar",
        /* NavScrollbar */ 2
    ],
    [
        "NavArrows",
        /* NavArrows */ 1
    ],
    [
        "NavDots",
        /* NavDots */ 3
    ],
    [
        "NavNone",
        /* NavNone */ 4
    ]
];
function $b22a7e9364837e04$export$5c2587a0612fd33e(param) {
    return $jVmMx.Encode.simpleVariant($b22a7e9364837e04$var$partial_arg$2, param);
}
var $b22a7e9364837e04$var$partial_arg$3 = [
    [
        "TransitionEase",
        /* TransitionEase */ 0
    ],
    [
        "TransitionLinear",
        /* TransitionLinear */ 1
    ],
    [
        "TransitionEaseIn",
        /* TransitionEaseIn */ 2
    ],
    [
        "TransitionEaseOut",
        /* TransitionEaseOut */ 3
    ],
    [
        "TransitionEaseInOut",
        /* TransitionEaseInOut */ 4
    ]
];
function $b22a7e9364837e04$export$5c74d797915c703f(param) {
    return $jVmMx.Encode.simpleVariant($b22a7e9364837e04$var$partial_arg$3, param);
}
function $b22a7e9364837e04$export$691c196d3f7dc224(v) {
    if (typeof v !== "number") return $jVmMx.Encode.deccoVariantWithPayload({
        lineClamp: v.lineClamp
    }, "IconsWithLabel", function(payload) {
        return $iv6Yc._1($jVmMx.Encode.object, [
            [
                "lineClamp",
                $iv6Yc._1($jVmMx.Encode.$$int, payload.lineClamp)
            ]
        ]);
    });
    switch(v){
        case /* Labels */ 0:
            return $iv6Yc._2($jVmMx.Encode.array, [
                "Labels"
            ], $jVmMx.Encode.string);
        case /* IconsOnly */ 1:
            return $iv6Yc._2($jVmMx.Encode.array, [
                "IconsOnly"
            ], $jVmMx.Encode.string);
        case /* PillsWithLabel */ 2:
            return $iv6Yc._2($jVmMx.Encode.array, [
                "PillsWithLabel"
            ], $jVmMx.Encode.string);
        case /* PillsWithIcon */ 3:
            return $iv6Yc._2($jVmMx.Encode.array, [
                "PillsWithIcon"
            ], $jVmMx.Encode.string);
        case /* PillsWithRoundedIcon */ 4:
            return $iv6Yc._2($jVmMx.Encode.array, [
                "PillsWithRoundedIcon"
            ], $jVmMx.Encode.string);
    }
}
var $b22a7e9364837e04$var$partial_arg$4 = [
    [
        "Small",
        /* Small */ 0
    ],
    [
        "Medium",
        /* Medium */ 1
    ],
    [
        "Large",
        /* Large */ 2
    ]
];
function $b22a7e9364837e04$export$32c83531346916c(param) {
    return $jVmMx.Encode.simpleVariant($b22a7e9364837e04$var$partial_arg$4, param);
}
function $b22a7e9364837e04$export$1e863f3dbfe761fd(v) {
    if (typeof v !== "number") return $jVmMx.Encode.deccoVariantWithPayload([
        v._0,
        v._1
    ], "Custom", function(__x) {
        return $iv6Yc._2($jVmMx.Encode.array, __x, $jVmMx.Encode.$$int);
    });
    switch(v){
        case /* Circle */ 0:
            return $iv6Yc._2($jVmMx.Encode.array, [
                "Circle"
            ], $jVmMx.Encode.string);
        case /* Square */ 1:
            return $iv6Yc._2($jVmMx.Encode.array, [
                "Square"
            ], $jVmMx.Encode.string);
        case /* Landscape */ 2:
            return $iv6Yc._2($jVmMx.Encode.array, [
                "Landscape"
            ], $jVmMx.Encode.string);
        case /* Portrait */ 3:
            return $iv6Yc._2($jVmMx.Encode.array, [
                "Portrait"
            ], $jVmMx.Encode.string);
        case /* Panorama */ 4:
            return $iv6Yc._2($jVmMx.Encode.array, [
                "Panorama"
            ], $jVmMx.Encode.string);
        case /* Wide */ 5:
            return $iv6Yc._2($jVmMx.Encode.array, [
                "Wide"
            ], $jVmMx.Encode.string);
        case /* Tall */ 6:
            return $iv6Yc._2($jVmMx.Encode.array, [
                "Tall"
            ], $jVmMx.Encode.string);
    }
}
function $b22a7e9364837e04$export$e3e306bb99732ba5(param) {
    return $iv6Yc._1($jVmMx.Encode.object, $jVmMx.Encode.addIf(undefined, $jVmMx.Encode.addIf(undefined, $jVmMx.Encode.addIf(undefined, $jVmMx.Encode.addIf(undefined, $jVmMx.Encode.addIf(/* Equal */ 0, [
        [
            "columns",
            $b22a7e9364837e04$export$f37b5a4ead4e4f53(param.columns)
        ]
    ], $b22a7e9364837e04$export$cf1da31c1d8e49bd, [
        "gap",
        param.gap
    ]), function(__x) {
        return $jVmMx.Encode.nullable(__x, $jVmMx.Encode.$$int);
    }, [
        "maxRows",
        param.maxRows
    ]), function(__x) {
        return $jVmMx.Encode.nullable(__x, $jVmMx.Encode.$$int);
    }, [
        "maxWidth",
        param.maxWidth
    ]), function(__x) {
        return $jVmMx.Encode.nullable(__x, $jVmMx.Encode.$$int);
    }, [
        "padding",
        param.padding
    ]), function(__x) {
        return $jVmMx.Encode.nullable(__x, $bkHbG.Layout.GridPattern.toJson);
    }, [
        "pattern",
        param.pattern
    ]));
}
function $b22a7e9364837e04$export$2c2cf81ad1b771ea(param) {
    return $iv6Yc._1($jVmMx.Encode.object, $jVmMx.Encode.addIf(false, $jVmMx.Encode.addIf(false, $jVmMx.Encode.addIf(3000, $jVmMx.Encode.addIf(300, $jVmMx.Encode.addIf(/* TransitionEaseOut */ 3, $jVmMx.Encode.addIf(/* NavAuto */ 0, $jVmMx.Encode.addIf(/* EffectSlide */ 0, $jVmMx.Encode.addIf(1, $jVmMx.Encode.addIf(undefined, $jVmMx.Encode.addIf(undefined, $jVmMx.Encode.addIf(/* Equal */ 0, [
        [
            "slidesPerView",
            $iv6Yc._1($jVmMx.Encode.$$float, param.slidesPerView)
        ]
    ], $b22a7e9364837e04$export$cf1da31c1d8e49bd, [
        "gap",
        param.gap
    ]), function(__x) {
        return $jVmMx.Encode.nullable(__x, $jVmMx.Encode.$$int);
    }, [
        "maxWidth",
        param.maxWidth
    ]), function(__x) {
        return $jVmMx.Encode.nullable(__x, $jVmMx.Encode.$$int);
    }, [
        "padding",
        param.padding
    ]), $jVmMx.Encode.$$int, [
        "rows",
        param.rows
    ]), $b22a7e9364837e04$export$c897463d3ff3d06b, [
        "effect",
        param.effect
    ]), $b22a7e9364837e04$export$5c2587a0612fd33e, [
        "nav",
        param.nav
    ]), $b22a7e9364837e04$export$5c74d797915c703f, [
        "transition",
        param.transition
    ]), $jVmMx.Encode.$$int, [
        "transitionSpeed",
        param.transitionSpeed
    ]), $jVmMx.Encode.$$int, [
        "autoplayDelay",
        param.autoplayDelay
    ]), $jVmMx.Encode.bool, [
        "autoplay",
        param.autoplay
    ]), $jVmMx.Encode.bool, [
        "loop",
        param.loop
    ]));
}
var $b22a7e9364837e04$export$8c25ab61e3ebfea6 = $5kJL4.gridColumns_fromJson;
var $b22a7e9364837e04$export$7b8c2d503c3f2b85 = $5kJL4.sliderEffect_fromJson;
var $b22a7e9364837e04$export$a97538abbb745701 = $5kJL4.sliderNav_fromJson;
var $b22a7e9364837e04$export$e325d0430234ce09 = $5kJL4.transition_fromJson;
var $b22a7e9364837e04$export$d1231c8849dff43d = $5kJL4.layoutGap_fromJson;
var $b22a7e9364837e04$export$caa8cc636f063fc5 = $5kJL4.smartbarCategoryLayout_fromJson;
var $b22a7e9364837e04$export$4b356bb189ad847c = $5kJL4.smartbarCategorySize_fromJson;
var $b22a7e9364837e04$export$62374691ae503c00 = $5kJL4.cardShape_fromJson;
var $b22a7e9364837e04$export$f881733ee4dc8a30 = $5kJL4.gridPayload_fromJson;
var $b22a7e9364837e04$export$e419410b2a3ba3bb = $5kJL4.sliderPayload_fromJson;
 /* Generic-ApiTypes Not a pure module */ 
});



parcelRegister("7pMKc", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("aVOcH")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("hI3Yy")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("bYlNO"))
]).then(function() {
    return parcelRequire("SXVLB");
});

});




parcelRegister("gfHt9", function(module, exports) {

$parcel$export(module.exports, "toString", function () { return $bd4fc41ad063639a$export$f84e8e69fd4488a5; });
$parcel$export(module.exports, "isNonInteractive", function () { return $bd4fc41ad063639a$export$d81e15431dcd4820; });
// Generated by ReScript, PLEASE EDIT WITH CARE
function $bd4fc41ad063639a$export$f84e8e69fd4488a5($$event) {
    if (typeof $$event !== "object") {
        if ($$event === "open") return "open";
        else if ($$event === "slider:category") return "slider:category";
        else if ($$event === "Clicked Secondary Button") return "Clicked Secondary Button";
        else if ($$event === "Clicked Hide Products Button") return "Clicked Hide Products Button";
        else if ($$event === "page view") return "page_view";
        else if ($$event === "mkrbio:link_clicked") return "mkrbio:link_clicked";
        else if ($$event === "Clicked PDP Carousel Close Button") return "Clicked PDP Carousel Close Button";
        else if ($$event === "Opened") return "Opened";
        else if ($$event === "mobile pdp:swiped next product") return "mobile pdp:swiped next product";
        else if ($$event === "loaded") return "loadaed";
        else if ($$event === "quickview:open") return "quickview:open";
        else if ($$event === "Clicked Media Carousel Close Button") return "Clicked Media Carousel Close Button";
        else if ($$event === "product details:image select") return "product details:image select";
        else if ($$event === "swipe down drawer") return "swipe down drawer";
        else if ($$event === "product details:description") return "product details:description";
        else if ($$event === "Clicked CTA Button") return "Clicked CTA Button";
        else if ($$event === "slider:promo title") return "slider:promo title";
        else if ($$event === "mkrbio:cta_clicked") return "mkrbio:cta_clicked";
        else if ($$event === "product details:add to cart") return "product details:add to cart";
        else if ($$event === "product details:other products") return "product details:other products";
        else if ($$event === "Clicked PDP Photo") return "Clicked PDP Photo";
        else if ($$event === "open top category") return "open top category";
        else if ($$event === "mobile pdp:swiped previous product") return "mobile pdp:swiped previous product";
        else if ($$event === "product details:open") return "product details:open";
        else if ($$event === "slider:title") return "slider:title";
        else if ($$event === "Swiped Products Drawer Down To Bottom") return "Swiped Products Drawer Down To Bottom";
        else if ($$event === "Clicked Product Pins Tips On") return "Clicked Product Pins Tips On";
        else if ($$event === "mobile pdp:tapped previous image") return "mobile pdp:tapped previous image";
        else if ($$event === "slider:item") return "slider:item";
        else if ($$event === "Clicked Product Stack Thumbnail") return "Clicked Product Stack Thumbnail";
        else if ($$event === "Clicked Product Pin") return "Clicked Product Pin";
        else if ($$event === "slider:see all link") return "slider:see all link";
        else if ($$event === "Clicked Product Pins Tips Off") return "Clicked Product Pins Tips Off";
        else if ($$event === "mobile pdp:clicked main cta btn") return "mobile pdp:clicked main cta btn";
        else if ($$event === "open link") return "open link";
        else if ($$event === "Clicked Related Product Card") return "Clicked Related Product Card";
        else if ($$event === "Clicked Product Variant") return "Clicked Product Variant";
        else if ($$event === "Clicked In-Media Product Card") return "Clicked In-Media Product Card";
        else if ($$event === "Swiped Products Drawer Up To Top") return "Swiped Products Drawer Up To Top";
        else if ($$event === "exit click") return "exit click";
        else if ($$event === "open index") return "open index";
        else if ($$event === "timespent") return "time spent";
        else if ($$event === "menu:link clicked") return "menu:link clicked";
        else if ($$event === "mobile pdp:tapped next image") return "mobile pdp:tapped next image";
        else if ($$event === "Clicked View Products Button") return "Clicked View Products Button";
        else if ($$event === "checkout") return "checkout";
        else if ($$event === "swipe up drawer") return "swipe up drawer";
        else if ($$event === "mobile pdp:clicked view details btn") return "mobile pdp:clicked view details btn";
        else if ($$event === "sort expanded") return "sort expanded";
        else if ($$event === "product details:swatch") return "product details:swatch";
        else if ($$event === "menu:open") return "menu:open";
        else if ($$event === "product details:image scroll") return "product details:image scroll";
        else if ($$event === "back button") return "back button";
        else if ($$event === "slider:promo") return "slider:promo";
        else if ($$event === "top category nav") return "top category nav";
        else if ($$event === "filter expanded") return "filter expanded";
        else if ($$event === "mkrbio:made_with_maker") return "mkrbio:made_with_maker";
        else if ($$event === "mobile pdp:clicked see more color options") return "mobile pdp:clicked see more color options";
        else return "Closed";
    }
    var variant = $$event.NAME;
    if (variant === "Clicked Product Card") return "Clicked " + $$event.VAL + " Product Card";
    else if (variant === "Clicked PDP Section Closed") return "Clicked PDP " + $$event.VAL + " Section Closed";
    else if (variant === "sec") return "" + $$event.VAL + " sec";
    else if (variant === "filter applied") return "filter applied";
    else if (variant === "sort applied") return "sort applied";
    else if (variant === "clicked action") return "clicked action " + $$event.VAL + "";
    else return "Clicked PDP " + $$event.VAL + " Section Open";
}
function $bd4fc41ad063639a$export$d81e15431dcd4820($$event) {
    if (typeof $$event === "object") return $$event.NAME === "sec";
    else if ($$event === "product details:image scroll" || $$event === "menu:open" || $$event === "timespent" || $$event === "loaded" || $$event === "Opened" || $$event === "page view") return true;
    else return $$event === "open";
}
 /* No side effect */ 
});


parcelRegister("kK0OQ", function(module, exports) {

$parcel$export(module.exports, "load", function () { return $f198bd26d7ab9fbe$export$11e63f7b0f3d9900; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $5YOUh = parcelRequire("5YOUh");

var $j4B9x = parcelRequire("j4B9x");

var $iv6Yc = parcelRequire("iv6Yc");

var $GuWH3 = parcelRequire("GuWH3");

var $79vie = parcelRequire("79vie");

var $jVmMx = parcelRequire("jVmMx");

var $2gwg0 = parcelRequire("2gwg0");

var $h7kEx = parcelRequire("h7kEx");

var $bjgUL = parcelRequire("bjgUL");

var $fcz2a = parcelRequire("fcz2a");
var $f198bd26d7ab9fbe$var$t_decode = $iv6Yc._5($jVmMx.Decode.map4, $iv6Yc._2($jVmMx.Decode.field, "gaTrackingId", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string)), $jVmMx.Decode.fieldWithDefault("gaVersion", $fcz2a.GaVersion.fromJson, /* Gtag */ 1), $iv6Yc._2($jVmMx.Decode.field, "checkoutLink", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string)), $iv6Yc._2($jVmMx.Decode.field, "historyEnabled", $jVmMx.Decode.bool), function(gaTrackingId, gaVersion, checkoutLink, historyEnabled) {
    return {
        gaTrackingId: gaTrackingId,
        gaVersion: gaVersion,
        checkoutLink: checkoutLink,
        historyEnabled: historyEnabled
    };
});
var $f198bd26d7ab9fbe$export$c72f6eaae7b9adff = {
    t_decode: $f198bd26d7ab9fbe$var$t_decode
};
var $f198bd26d7ab9fbe$export$bb5e712207166a02 = $79vie.map3($79vie.field("id", $79vie.string), $79vie.field("accountId", $79vie.option($79vie.string)), $79vie.field("settings", $f198bd26d7ab9fbe$var$t_decode), function(id, accountId, settings) {
    return {
        id: id,
        accountId: accountId,
        settings: settings
    };
});
function $f198bd26d7ab9fbe$export$11e63f7b0f3d9900(smartnavApiHost) {
    var shop = $2gwg0.getShop(undefined);
    if (shop === undefined) return Promise.reject($GuWH3.raiseError("Shopify store not found"));
    if (shop === "") return Promise.reject($GuWH3.raiseError("Shopify store not found"));
    var url = smartnavApiHost + "/api/get_shopify_url_config?url=" + encodeURIComponent("https://" + shop);
    return $h7kEx.$$fetch(undefined, undefined, undefined, undefined, $h7kEx.Server.ignoreNotFoundError, function() {
        var _ref = (0, $5YOUh._)(function(json) {
            return (0, $j4B9x.__generator)(this, function(_state) {
                return [
                    2,
                    $bjgUL.decode(json, $f198bd26d7ab9fbe$export$bb5e712207166a02)
                ];
            });
        });
        return function(json) {
            return _ref.apply(this, arguments);
        };
    }(), url);
}
var $f198bd26d7ab9fbe$export$7ae2d2a8b28a8cb8 = $f198bd26d7ab9fbe$export$bb5e712207166a02;
 /* t_decode Not a pure module */ 
});
parcelRegister("bjgUL", function(module, exports) {

$parcel$export(module.exports, "decode", function () { return $83be96e9a9e1b412$export$2f872c0f2117be69; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $79vie = parcelRequire("79vie");
function $83be96e9a9e1b412$export$2f872c0f2117be69(j, decoder) {
    var errorToString = function errorToString(_error) {
        while(true){
            var error = _error;
            switch(error.TAG | 0){
                case /* Failure */ 0:
                    return error._0;
                case /* Index */ 1:
                case /* Field */ 2:
                    _error = error._1;
                    continue;
                case /* OneOf */ 3:
                    _error = error._0;
                    continue;
            }
        }
    };
    var result = $79vie.decodeValue(j, decoder);
    if (result.TAG === /* Ok */ 0) return {
        TAG: /* Ok */ 0,
        _0: result._0
    };
    else return {
        TAG: /* Error */ 1,
        _0: errorToString(result._0)
    };
}
 /* Json__Decode Not a pure module */ 
});

parcelRegister("fcz2a", function(module, exports) {

$parcel$export(module.exports, "GaVersion", function () { return $b1132707dbc023c6$export$a65f4ba0b4d85314; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $jVmMx = parcelRequire("jVmMx");

var $doJJK = parcelRequire("doJJK");
var $b1132707dbc023c6$var$partial_arg = [
    [
        "Ua",
        /* Ua */ 0
    ],
    [
        "Gtag",
        /* Gtag */ 1
    ]
];
function $b1132707dbc023c6$var$toJson(param) {
    return $jVmMx.Encode.simpleVariant($b1132707dbc023c6$var$partial_arg, param);
}
var $b1132707dbc023c6$var$fromJson = $jVmMx.Decode.simpleVariant([
    [
        "Ua",
        /* Ua */ 0
    ],
    [
        "Gtag",
        /* Gtag */ 1
    ]
]);
var $b1132707dbc023c6$var$include = $doJJK.Make({
    toJson: $b1132707dbc023c6$var$toJson,
    fromJson: $b1132707dbc023c6$var$fromJson
});
var $b1132707dbc023c6$var$t_encode = $b1132707dbc023c6$var$include.t_encode;
var $b1132707dbc023c6$var$t_decode = $b1132707dbc023c6$var$include.t_decode;
var $b1132707dbc023c6$var$GaVersion_codec = $b1132707dbc023c6$var$include.codec;
var $b1132707dbc023c6$export$a65f4ba0b4d85314 = {
    toJson: $b1132707dbc023c6$var$toJson,
    fromJson: $b1132707dbc023c6$var$fromJson,
    t_encode: $b1132707dbc023c6$var$t_encode,
    t_decode: $b1132707dbc023c6$var$t_decode,
    codec: $b1132707dbc023c6$var$GaVersion_codec
};
var $b1132707dbc023c6$export$88678e9619c1f002 = $b1132707dbc023c6$var$t_encode;
var $b1132707dbc023c6$export$52971681fb885ae3 = $b1132707dbc023c6$var$t_decode;
 /* fromJson Not a pure module */ 
});


parcelRegister("8Eq46", function(module, exports) {

$parcel$export(module.exports, "Gtag", function () { return $64c647238f3fb248$export$9b3bbaa5b7814624; });
$parcel$export(module.exports, "getLinkerParam", function () { return $64c647238f3fb248$export$466b56998c0a4c1c; });
$parcel$export(module.exports, "track", function () { return $64c647238f3fb248$export$6b2a7d5132615086; });
$parcel$export(module.exports, "init", function () { return $64c647238f3fb248$export$2cd8252107eb640b; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $d3YYW = parcelRequire("d3YYW");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $bygWp = parcelRequire("bygWp");

var $aYvyX = parcelRequire("aYvyX");

var $gfHt9 = parcelRequire("gfHt9");

var $jQWDR = parcelRequire("jQWDR");
var $64c647238f3fb248$var$jsonStringifyExn = function jsonStringify(input) {
    return JSON.stringify(input);
};
var $64c647238f3fb248$var$initScript = function initScript() {
    window.dataLayer = window.dataLayer || [];
    window.gtag = function() {
        dataLayer.push(arguments);
    };
};
function $64c647238f3fb248$var$sendEvent(account, callback, $$event, properties, param) {
    var match = window.gtag;
    if (match !== undefined) ;
    else $iv6Yc._1($64c647238f3fb248$var$initScript, undefined);
    var match$1 = $2whNH.mapWithDefault(account, false, function(a) {
        return a.eventsPostmessage;
    });
    var match$2 = window.gtag;
    var match$3 = window.gtag;
    if (!match$1) {
        if (callback !== undefined) {
            if (match$2 !== undefined) return match$2("event", $$event, properties, $loT9g.valFromOption(callback));
            else return;
        } else if (match$3 !== undefined) return match$3("event", $$event, properties);
        else return;
    }
    try {
        var data = $64c647238f3fb248$var$jsonStringifyExn({
            smartnav: true,
            event: $$event,
            ecommerce: properties
        });
        window.postMessage(data, "*");
        return;
    } catch (exn) {
        return;
    }
}
function $64c647238f3fb248$var$track(account, gaTrackingId, $$event, category, action, label, value, param) {
    $64c647238f3fb248$var$sendEvent(account, undefined, action, {
        event_category: category,
        event_label: label,
        value: value,
        non_interaction: $gfHt9.isNonInteractive($$event),
        send_to: gaTrackingId
    }, undefined);
}
function $64c647238f3fb248$var$insertScript(id) {
    $iv6Yc._1($64c647238f3fb248$var$initScript, undefined);
    var script = document.createElement("script");
    script.setAttribute("src", "https://www.googletagmanager.com/gtag/js?id=" + id);
    script.setAttribute("async", "true");
    $2whNH.forEach($loT9g.nullable_to_opt(document.querySelector("head")), function(param) {
        param.appendChild(script);
    });
}
function $64c647238f3fb248$var$init(gaTrackingId, checkoutLink, sendPageViewOpt, account) {
    var sendPageView = sendPageViewOpt !== undefined ? sendPageViewOpt : false;
    var domain = $2whNH.mapWithDefault($2whNH.map($2whNH.flatMap(checkoutLink, $bygWp.maybeMakeUrl), function(prim) {
        return prim.hostname;
    }), [], function(domain) {
        return [
            domain
        ];
    });
    var match = window.gtag;
    if (match !== undefined || gaTrackingId === undefined) ;
    else $64c647238f3fb248$var$insertScript(gaTrackingId);
    var match$1 = window.gtag;
    if (match$1 !== undefined && gaTrackingId !== undefined) return match$1("config", gaTrackingId, {
        send_page_view: sendPageView,
        linker: checkoutLink !== undefined ? {
            domains: $i7mYY.concat([
                "mkr.bio"
            ], domain)
        } : undefined
    });
}
var $64c647238f3fb248$var$clientIdRef = {
    contents: undefined
};
function $64c647238f3fb248$var$getGtagProperty(gaTrackingId, name) {
    return new Promise(function(resolve, reject) {
        var match = window.smartnavOriginalGtag;
        var match$1 = window.gtag;
        var gtag;
        if (match !== undefined) gtag = match;
        else {
            if (match$1 === undefined) return reject(null);
            gtag = match$1;
        }
        gtag("get", $2whNH.getWithDefault(gaTrackingId, $jQWDR.config.measurementId), name, function(result) {
            resolve(result == null ? undefined : $loT9g.some(result));
        });
    });
}
function $64c647238f3fb248$var$getClientId(gaTrackingId, gaVersion, checkoutLink, account) {
    var match = $aYvyX.isEnabled(undefined);
    var match$1 = $64c647238f3fb248$var$clientIdRef.contents;
    if (match) {
        if (match$1 !== undefined) return Promise.resolve(match$1);
        else {
            $64c647238f3fb248$var$init(gaTrackingId, checkoutLink, undefined, account);
            return Promise.all([
                $64c647238f3fb248$var$getGtagProperty(gaTrackingId, "client_id"),
                $64c647238f3fb248$var$getGtagProperty(gaTrackingId, "session_id")
            ]).then(function(param) {
                var sessionId = param[1];
                var clientId = param[0];
                $64c647238f3fb248$var$clientIdRef.contents = clientId !== undefined && sessionId !== undefined ? [
                    clientId,
                    sessionId
                ] : undefined;
                return $64c647238f3fb248$var$clientIdRef.contents;
            });
        }
    } else return Promise.resolve(undefined);
}
var $64c647238f3fb248$var$initAnalyticsJs = function initAnalyticsJs() {
    (function(i, s, o, g, r, a, m) {
        i["GoogleAnalyticsObject"] = r;
        i[r] = i[r] || function() {
            (i[r].q = i[r].q || []).push(arguments);
        }, i[r].l = 1 * new Date();
        a = s.createElement(o), m = s.getElementsByTagName(o)[0];
        a.async = 1;
        a.src = g;
        m.parentNode.insertBefore(a, m);
    })(window, document, "script", "https://www.google-analytics.com/analytics.js", "ga");
};
function $64c647238f3fb248$var$getLinkerParam(gaTrackingId, gaVersion, checkoutLink, account, param) {
    var glBridge = $2whNH.flatMap($2whNH.map(window.google_tag_data == null ? undefined : $loT9g.some(window.google_tag_data), function(prim) {
        return prim.glBridge;
    }), function(prim) {
        if (prim == null) return;
        else return $loT9g.some(prim);
    });
    var retry = function retry(param) {
        return new Promise(function(resolve, reject) {
            setTimeout(function(param) {
                $64c647238f3fb248$var$getLinkerParam(gaTrackingId, gaVersion, checkoutLink, account, undefined).then(function(result) {
                    resolve(result);
                });
            }, 42);
        });
    };
    var match = window.GoogleAnalyticsObject;
    if (account === undefined) return Promise.resolve(undefined);
    if (glBridge === undefined) {
        if (match !== undefined) return retry(undefined);
        else {
            $iv6Yc._1($64c647238f3fb248$var$initAnalyticsJs, undefined);
            return retry(undefined);
        }
    }
    var glBridge$1 = $loT9g.valFromOption(glBridge);
    return $64c647238f3fb248$var$getClientId(gaTrackingId, $loT9g.some(gaVersion), checkoutLink, account).then(function(result) {
        if (result === undefined) return;
        var sessionId = result[1];
        var clientId = result[0];
        var value = $2whNH.flatMap($i7mYY.get($i7mYY.keepMap($i7mYY.map($2whNH.getWithDefault($loT9g.nullable_to_opt(document.cookie), "").split(";"), function(prim) {
            return prim.trim();
        }), function(value) {
            var regex = new RegExp("_ga_(.*)=GS1.1.(" + sessionId + "(.*))");
            var matches = $2whNH.getWithDefault($loT9g.null_to_opt(value.match(regex)), []);
            var key = $i7mYY.get(matches, 1);
            var value$1 = $i7mYY.get(matches, 2);
            if (key === undefined) return;
            var key$1 = $loT9g.valFromOption(key);
            if (key$1 === undefined) return;
            if (value$1 === undefined) return;
            var value$2 = $loT9g.valFromOption(value$1);
            if (value$2 !== undefined) return [
                key$1,
                value$2
            ];
        }), 0), function(param) {
            return $loT9g.nullable_to_opt(glBridge$1.generate($d3YYW.fromArray([
                [
                    "_ga",
                    clientId
                ],
                [
                    "_ga_" + param[0],
                    param[1]
                ]
            ])));
        });
        if (value !== undefined) return [
            "_gl",
            value
        ];
    });
}
var $64c647238f3fb248$var$Linker = {
    clientIdRef: $64c647238f3fb248$var$clientIdRef,
    getGtagProperty: $64c647238f3fb248$var$getGtagProperty,
    getClientId: $64c647238f3fb248$var$getClientId,
    initAnalyticsJs: $64c647238f3fb248$var$initAnalyticsJs,
    getLinkerParam: $64c647238f3fb248$var$getLinkerParam
};
var $64c647238f3fb248$export$9b3bbaa5b7814624 = {
    jsonStringifyExn: $64c647238f3fb248$var$jsonStringifyExn,
    initScript: $64c647238f3fb248$var$initScript,
    sendEvent: $64c647238f3fb248$var$sendEvent,
    track: $64c647238f3fb248$var$track,
    insertScript: $64c647238f3fb248$var$insertScript,
    init: $64c647238f3fb248$var$init,
    Linker: $64c647238f3fb248$var$Linker
};
function $64c647238f3fb248$export$466b56998c0a4c1c(gaTrackingId, gaVersion, checkoutLink, account, param) {
    if (gaTrackingId !== undefined) return $64c647238f3fb248$var$getLinkerParam(gaTrackingId, gaVersion, checkoutLink, account, undefined);
    else return Promise.resolve(undefined);
}
function $64c647238f3fb248$export$6b2a7d5132615086(account, gaTrackingId, $$event, category, action, label, value, param) {
    $64c647238f3fb248$var$track(account, gaTrackingId, $$event, category, action, label, value, undefined);
}
function $64c647238f3fb248$export$2cd8252107eb640b(gaTrackingId, gaVersion, checkoutLink, sendPageView, account) {
    var match = $aYvyX.isEnabled(undefined);
    if (match && gaTrackingId !== undefined) {
        $64c647238f3fb248$var$init(gaTrackingId, checkoutLink, sendPageView, account);
        return;
    }
}
 /* Analytics-Showside Not a pure module */ 
});
parcelRegister("jQWDR", function(module, exports) {

$parcel$export(module.exports, "config", function () { return $e7405cb5cc5fc6b8$export$e506a1d27d1eaa20; });
// Generated by ReScript, PLEASE EDIT WITH CARE
var $e7405cb5cc5fc6b8$export$e506a1d27d1eaa20 = {
    apiKey: "AIzaSyBeEYbHQ1kD7JW3eXTj7z_Ko-ilIDfotmw",
    authDomain: "smart-nav-analytics.firebaseapp.com",
    projectId: "smart-nav-analytics",
    storageBucket: "smart-nav-analytics.appspot.com",
    messagingSenderId: "340297097320",
    appId: "1:340297097320:web:6979368a4b6cd0e86b1bdd",
    measurementId: "G-PXQYP4VJE2"
};
 /* No side effect */ 
});


parcelRegister("5p4vV", function(module, exports) {

$parcel$export(module.exports, "makeItemViewed", function () { return $3ef2c9ef489da144$export$72928bb0043236c0; });
$parcel$export(module.exports, "init", function () { return $3ef2c9ef489da144$export$2cd8252107eb640b; });
$parcel$export(module.exports, "logEvent", function () { return $3ef2c9ef489da144$export$5e9eec8001665ac5; });
$parcel$export(module.exports, "maybeLogEvent", function () { return $3ef2c9ef489da144$export$be53a2ec43e04fff; });
$parcel$export(module.exports, "logValueEvent", function () { return $3ef2c9ef489da144$export$6a69902e2a25f124; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $5YOUh = parcelRequire("5YOUh");

var $j4B9x = parcelRequire("j4B9x");

var $oO3sB = parcelRequire("oO3sB");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $7KlbQ = parcelRequire("7KlbQ");

var $gfHt9 = parcelRequire("gfHt9");

var $jQWDR = parcelRequire("jQWDR");

var $8Eq46 = parcelRequire("8Eq46");

var $cdK26 = parcelRequire("cdK26");
function $3ef2c9ef489da144$export$72928bb0043236c0(product, variant, affiliation, configId, link, isInline, isNavMenu, $$event) {
    var match = $7KlbQ.Variant.getVariantPrices(variant);
    var price = match[0];
    return {
        isInline: isInline,
        isNavMenu: isNavMenu,
        navVersion: "v2",
        affiliation: affiliation,
        parentUrl: link,
        sheetId: configId,
        currency: product.currency,
        value: price,
        non_interaction: $gfHt9.isNonInteractive($$event),
        items: [
            {
                affiliation: affiliation,
                id: product.id,
                name: product.name,
                price: price,
                quantity: 1,
                variant: product.id
            }
        ]
    };
}


var $3ef2c9ef489da144$export$c55cfd413944906d = function init(options) {
    return (parcelRequire("j606b")).then(function(param) {
        var initializeApp = param.initializeApp;
        return initializeApp(options);
    }).then(function(app) {
        return (parcelRequire("jzxac")).then(function(functions) {
            return [
                app,
                functions
            ];
        });
    });
};
function $3ef2c9ef489da144$export$766a064793e9be30(param) {
    var cookie = $cdK26.initialDocumentCookie(undefined);
    var partial_arg = /_shopify_sa_p=(.*)ref%3Dmkr%257C([a-z0-9.]+)%257C([a-z0-9.]+)/;
    var matches = $2whNH.getWithDefault($2whNH.flatMap(cookie, function(param) {
        return $oO3sB.match_(partial_arg, param);
    }), []);
    var clientId = $i7mYY.get(matches, 2);
    var sessionId = $i7mYY.get(matches, 3);
    if (clientId === undefined) return;
    var clientId$1 = $loT9g.valFromOption(clientId);
    if (clientId$1 === undefined) return;
    if (sessionId === undefined) return;
    var sessionId$1 = $loT9g.valFromOption(sessionId);
    if (sessionId$1 !== undefined) return {
        config: {
            client_id: clientId$1,
            session_id: sessionId$1
        }
    };
}
function $3ef2c9ef489da144$export$2cd8252107eb640b(param) {
    return $3ef2c9ef489da144$var$_init.apply(this, arguments);
}
function $3ef2c9ef489da144$var$_init() {
    $3ef2c9ef489da144$var$_init = (0, $5YOUh._)(function(param) {
        var match, match$1, functions, instance;
        return (0, $j4B9x.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    match = window.gtag;
                    if (match !== undefined) ;
                    else $8Eq46.Gtag.insertScript($jQWDR.config.measurementId);
                    window.smartnavOriginalGtag = window.gtag;
                    return [
                        4,
                        $3ef2c9ef489da144$export$c55cfd413944906d($jQWDR.config)
                    ];
                case 1:
                    match$1 = _state.sent();
                    functions = match$1[1];
                    instance = functions.initializeAnalytics(match$1[0], $3ef2c9ef489da144$export$766a064793e9be30(undefined));
                    return [
                        2,
                        [
                            functions,
                            instance
                        ]
                    ];
            }
        });
    });
    return $3ef2c9ef489da144$var$_init.apply(this, arguments);
}
function $3ef2c9ef489da144$export$5e9eec8001665ac5(param, $$event, options) {
    param[0].logEvent(param[1], $$event, options);
}
function $3ef2c9ef489da144$export$be53a2ec43e04fff(firebase, $$event, options) {
    if (firebase !== undefined) return $3ef2c9ef489da144$export$5e9eec8001665ac5(firebase, $$event, options);
    else {
        console.log("log event", $$event, options);
        return;
    }
}
function $3ef2c9ef489da144$export$6a69902e2a25f124(param, $$event, options, value) {
    param[0].logEvent(param[1], $$event, options, value);
}
function $3ef2c9ef489da144$export$30b6b276519d35d9(firebase, $$event, options, value) {
    if (firebase !== undefined) return $3ef2c9ef489da144$export$6a69902e2a25f124(firebase, $$event, options, value);
    else {
        console.log("log event", $$event, options, value);
        return;
    }
}
 /* Product-Showside Not a pure module */ 
});
parcelRegister("cdK26", function(module, exports) {

$parcel$export(module.exports, "initialDocumentCookie", function () { return $8e5a681fe8edbb44$export$6d8a53c95d62f16a; });
$parcel$export(module.exports, "waitForShopifyAnalytics", function () { return $8e5a681fe8edbb44$export$f84603f07eeb1d63; });
$parcel$export(module.exports, "getProductPageProductId", function () { return $8e5a681fe8edbb44$export$655ef3e62ebfeb40; });
$parcel$export(module.exports, "getCollectionPageCollectionId", function () { return $8e5a681fe8edbb44$export$1ccfc961cba0f1c6; });
$parcel$export(module.exports, "getProductPageVariantId", function () { return $8e5a681fe8edbb44$export$cc267c015bc8901b; });
$parcel$export(module.exports, "isProductPage", function () { return $8e5a681fe8edbb44$export$a6ee0f0139d9689a; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $7bjme = parcelRequire("7bjme");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $bygWp = parcelRequire("bygWp");
function $8e5a681fe8edbb44$var$fromMeta(meta) {
    var page = meta.page;
    var page$1 = page == null ? undefined : $loT9g.some(page);
    var product = meta.product;
    var resourceId = $2whNH.flatMap($2whNH.map(page$1, function(prim) {
        return prim.resourceId;
    }), function(prim) {
        if (prim == null) return;
        else return $loT9g.some(prim);
    });
    var resourceType = $2whNH.flatMap($2whNH.map(page$1, function(prim) {
        return prim.resourceType;
    }), function(prim) {
        if (prim == null) return;
        else return $loT9g.some(prim);
    });
    if (resourceType === undefined) return;
    switch(resourceType){
        case "collection":
            if (resourceId !== undefined) return {
                TAG: /* CollectionPage */ 0,
                collectionId: resourceId.toString()
            };
            else return;
        case "product":
            if (resourceId !== undefined) return {
                TAG: /* ProductPage */ 1,
                productId: resourceId.toString(),
                variants: $2whNH.getWithDefault($2whNH.flatMap($2whNH.map(product == null ? undefined : $loT9g.some(product), function(prim) {
                    return prim.variants;
                }), function(prim) {
                    if (prim == null) return;
                    else return $loT9g.some(prim);
                }), [])
            };
            else return;
        default:
            return;
    }
}
var $8e5a681fe8edbb44$export$6955bcca4cd3539f = {
    fromMeta: $8e5a681fe8edbb44$var$fromMeta
};
function $8e5a681fe8edbb44$export$6d8a53c95d62f16a(param) {
    return $2whNH.flatMap($2whNH.map($2whNH.flatMap($2whNH.map($2whNH.flatMap($2whNH.map(window.ShopifyAnalytics == null ? undefined : $loT9g.some(window.ShopifyAnalytics), function(prim) {
        return prim.lib;
    }), function(prim) {
        if (prim == null) return;
        else return $loT9g.some(prim);
    }), function(prim) {
        return prim.config;
    }), function(prim) {
        if (prim == null) return;
        else return $loT9g.some(prim);
    }), function(prim) {
        return prim.initialDocumentCookie;
    }), function(prim) {
        if (prim == null) return;
        else return $loT9g.some(prim);
    });
}
function $8e5a681fe8edbb44$export$f84603f07eeb1d63(retryCountOpt, param) {
    var retryCount = retryCountOpt !== undefined ? retryCountOpt : 0;
    var match = window.ShopifyAnalytics;
    var match$1 = retryCount > 25;
    if (!(match == null) || match$1) return Promise.resolve(undefined);
    else return new Promise(function(resolve, reject) {
        setTimeout(function(param) {
            $8e5a681fe8edbb44$export$f84603f07eeb1d63(retryCount + 1 | 0, undefined).then(function(result) {
                resolve(result);
            });
        }, 42);
    });
}
function $8e5a681fe8edbb44$export$c2a6433281518c91(param) {
    return $2whNH.flatMap($2whNH.flatMap($2whNH.map(window.ShopifyAnalytics == null ? undefined : $loT9g.some(window.ShopifyAnalytics), function(prim) {
        return prim.meta;
    }), function(prim) {
        if (prim == null) return;
        else return $loT9g.some(prim);
    }), $8e5a681fe8edbb44$var$fromMeta);
}
function $8e5a681fe8edbb44$export$655ef3e62ebfeb40(param) {
    return $2whNH.flatMap($8e5a681fe8edbb44$export$c2a6433281518c91(undefined), function(page) {
        if (page.TAG === /* CollectionPage */ 0) return;
        else return page.productId;
    });
}
function $8e5a681fe8edbb44$export$1ccfc961cba0f1c6(param) {
    return $2whNH.flatMap($8e5a681fe8edbb44$export$c2a6433281518c91(undefined), function(page) {
        if (page.TAG === /* CollectionPage */ 0) return page.collectionId;
    });
}
function $8e5a681fe8edbb44$export$cc267c015bc8901b(param) {
    var variants = $2whNH.mapWithDefault($8e5a681fe8edbb44$export$c2a6433281518c91(undefined), [], function(page) {
        if (page.TAG === /* CollectionPage */ 0) return [];
        else return page.variants;
    });
    var idToFind = $bygWp.getParam(window.location.href, "variant");
    var foundVariant = idToFind !== undefined ? $i7mYY.getBy(variants, function(v) {
        var currentId = $2whNH.map($loT9g.nullable_to_opt(v.id), function(prim) {
            return prim.toString();
        });
        return $7bjme.equal(currentId, idToFind);
    }) : undefined;
    var firstVariant = $i7mYY.get(variants, 0);
    return $2whNH.map($2whNH.flatMap($2whNH.map($2whNH.orElse(foundVariant, firstVariant), function(prim) {
        return prim.id;
    }), function(prim) {
        if (prim == null) return;
        else return $loT9g.some(prim);
    }), function(prim) {
        return prim.toString();
    });
}
function $8e5a681fe8edbb44$export$a6ee0f0139d9689a(param) {
    return $2whNH.isSome($8e5a681fe8edbb44$export$655ef3e62ebfeb40(undefined));
}
 /* No side effect */ 
});

parcelRegister("j606b", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("7sEFF")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("1EEJk"))
]).then(function() {
    return parcelRequire("gOTk6");
});

});

parcelRegister("jzxac", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("7sEFF")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("jAZo8"))
]).then(function() {
    return parcelRequire("iPXNi");
});

});


parcelRegister("79G3i", function(module, exports) {

$parcel$export(module.exports, "Public", function () { return $5359fe5ba89848c8$export$68b4491d6924a6d1; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $7bjme = parcelRequire("7bjme");

var $i7mYY = parcelRequire("i7mYY");

var $jVmMx = parcelRequire("jVmMx");

var $fFzkv = parcelRequire("fFzkv");

var $dRfYk = parcelRequire("dRfYk");

var $crJlr = parcelRequire("crJlr");

var $fOw8Z = parcelRequire("fOw8Z");

var $5td17 = parcelRequire("5td17");

var $gkW0h = parcelRequire("gkW0h");

var $hmUAM = parcelRequire("hmUAM");

var $3u0dF = parcelRequire("3u0dF");

var $jLiCS = parcelRequire("jLiCS");

var $1FxyN = parcelRequire("1FxyN");

var $5NmPk = parcelRequire("5NmPk");

var $doWsD = parcelRequire("doWsD");

var $dKt0X = parcelRequire("dKt0X");

var $2KZ1D = parcelRequire("2KZ1D");

var $519Gg = parcelRequire("519Gg");

var $3DzsH = parcelRequire("3DzsH");

var $9BF9g = parcelRequire("9BF9g");

var $f4o9q = parcelRequire("f4o9q");

var $2d3Mr = parcelRequire("2d3Mr");

var $cAXsd = parcelRequire("cAXsd");

var $aHg7U = parcelRequire("aHg7U");
var $5359fe5ba89848c8$var$fromJson = $iv6Yc._2($jVmMx.Decode.andThen, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._1($jVmMx.Decode.succeed, function(id, pdpStackEnabled, pdpStackPosition, pdpStackOffset, pdpStackSize, pdpConfig, pdpHideMediaFromOtherVariants, pdpShowRelatedMedia, pdpRelatedMediaStyle, plpShowRelatedMedia, plpRelatedMediaStyle, filtersConfig, filtersConfig2, lastModifiedAt, facebookPixelId, facebookPixelPageViewEnabled, facebookPixelViewItemEnabled, facebookPixelAddToCartEnabled, facebookPixelAddToWishlistEnabled, connectedInstagramAccount, connectedTiktokAccount, showPoweredByMaker, slug, pinterestTagId, makerPagesSlug, googleAds, connectedGAProperty, deprecated_addToCart, customActions, bioConfigId, customBioScript, isAnalyticsEmailAllowed, analyticsEmailFrequency, overrides, useCustomDimensionForFingerprinting, expandVariantsInProductsListing, eventsPostmessage, eventsWhitelist, productRules, productPriceStyle, productCardStyle, showProductReviews, showProductReviewsCountInPLP, showProductReviewsCountInPDP, cartCountCSSSelector, audienceCreatedOn, optimize, gaMeasurementId, navMenuConfig, allowMultipleEmbedsOnSamePage, siteHeaderCSSSelector, themes) {
    return {
        id: id,
        pdpStackEnabled: pdpStackEnabled,
        pdpStackPosition: pdpStackPosition,
        pdpStackOffset: pdpStackOffset,
        pdpStackSize: pdpStackSize,
        pdpConfig: pdpConfig,
        pdpHideMediaFromOtherVariants: pdpHideMediaFromOtherVariants,
        pdpShowRelatedMedia: pdpShowRelatedMedia,
        pdpRelatedMediaStyle: pdpRelatedMediaStyle,
        plpShowRelatedMedia: plpShowRelatedMedia,
        plpRelatedMediaStyle: plpRelatedMediaStyle,
        filtersConfig: filtersConfig,
        filtersConfig2: filtersConfig2,
        lastModifiedAt: lastModifiedAt,
        facebookPixelId: facebookPixelId,
        facebookPixelPageViewEnabled: facebookPixelPageViewEnabled,
        facebookPixelViewItemEnabled: facebookPixelViewItemEnabled,
        facebookPixelAddToCartEnabled: facebookPixelAddToCartEnabled,
        facebookPixelAddToWishlistEnabled: facebookPixelAddToWishlistEnabled,
        connectedInstagramAccount: connectedInstagramAccount,
        connectedTiktokAccount: connectedTiktokAccount,
        optimize: optimize,
        showPoweredByMaker: showPoweredByMaker,
        slug: slug,
        pinterestTagId: pinterestTagId,
        makerPagesSlug: makerPagesSlug,
        googleAds: googleAds,
        connectedGAProperty: connectedGAProperty,
        deprecated_addToCart: deprecated_addToCart,
        customActions: customActions,
        bioConfigId: bioConfigId,
        customBioScript: customBioScript,
        isAnalyticsEmailAllowed: isAnalyticsEmailAllowed,
        analyticsEmailFrequency: analyticsEmailFrequency,
        overrides: overrides,
        useCustomDimensionForFingerprinting: useCustomDimensionForFingerprinting,
        expandVariantsInProductsListing: expandVariantsInProductsListing,
        eventsPostmessage: eventsPostmessage,
        eventsWhitelist: eventsWhitelist,
        productRules: productRules,
        productPriceStyle: productPriceStyle,
        productCardStyle: productCardStyle,
        showProductReviews: showProductReviews,
        showProductReviewsCountInPLP: showProductReviewsCountInPLP,
        showProductReviewsCountInPDP: showProductReviewsCountInPDP,
        cartCountCSSSelector: cartCountCSSSelector,
        audienceCreatedOn: audienceCreatedOn,
        gaMeasurementId: gaMeasurementId,
        navMenuConfig: navMenuConfig,
        allowMultipleEmbedsOnSamePage: allowMultipleEmbedsOnSamePage,
        siteHeaderCSSSelector: siteHeaderCSSSelector,
        themes: themes
    };
}), $iv6Yc._2($jVmMx.Decode.field, "id", $jVmMx.Decode.string)), $jVmMx.Decode.fieldWithDefault("pdpStackEnabled", $jVmMx.Decode.bool, false)), $jVmMx.Decode.fieldWithDefault("pdpStackPosition", $3DzsH.PDPStackPosition.fromJson, "left")), $jVmMx.Decode.fieldWithDefault("pdpStackOffset", $2KZ1D.PDPStackOffset.fromJson, {
    left: 0,
    right: 0,
    bottom: 0
})), $jVmMx.Decode.fieldWithDefault("pdpStackSize", $jLiCS.PDPStackSize.fromJson, "sm")), $iv6Yc._2($jVmMx.Decode.field, "pdpConfig", $iv6Yc._1($jVmMx.Decode.option, $519Gg.fromJson))), $jVmMx.Decode.fieldWithDefault("pdpHideMediaFromOtherVariants", $jVmMx.Decode.bool, true)), $jVmMx.Decode.fieldWithDefault("pdpShowRelatedMedia", $jVmMx.Decode.bool, true)), $jVmMx.Decode.fieldWithDefault("pdpRelatedMediaStyle", $iv6Yc._1($jVmMx.Decode.option, $5NmPk.RelatedMedia.sliderStyles_fromJson), undefined)), $jVmMx.Decode.fieldWithDefault("plpShowRelatedMedia", $jVmMx.Decode.bool, false)), $jVmMx.Decode.fieldWithDefault("plpRelatedMediaStyle", $iv6Yc._1($jVmMx.Decode.option, $5NmPk.RelatedMedia.fromJson), undefined)), $iv6Yc._2($jVmMx.Decode.field, "filtersConfig", $iv6Yc._1($jVmMx.Decode.option, $fOw8Z.fromJson))), $iv6Yc._2($jVmMx.Decode.field, "filtersConfig2", $iv6Yc._1($jVmMx.Decode.option, $5td17.fromJson))), $iv6Yc._2($jVmMx.Decode.field, "lastModifiedAt", $jVmMx.Decode.$$float)), $iv6Yc._2($jVmMx.Decode.field, "facebookPixelId", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string))), $jVmMx.Decode.fieldWithDefault("facebookPixelPageViewEnabled", $jVmMx.Decode.bool, false)), $jVmMx.Decode.fieldWithDefault("facebookPixelViewItemEnabled", $jVmMx.Decode.bool, true)), $jVmMx.Decode.fieldWithDefault("facebookPixelAddToCartEnabled", $jVmMx.Decode.bool, true)), $jVmMx.Decode.fieldWithDefault("facebookPixelAddToWishlistEnabled", $jVmMx.Decode.bool, true)), $jVmMx.Decode.fieldWithDefault("connectedInstagramAccount", $iv6Yc._1($jVmMx.Decode.option, $aHg7U.ConnectedInstagramAccount.fromJson), undefined)), $jVmMx.Decode.fieldWithDefault("connectedTiktokAccount", $iv6Yc._1($jVmMx.Decode.option, $cAXsd.ConnectedTiktokAccount.fromJson), undefined)), $jVmMx.Decode.fieldWithDefault("showPoweredByMaker", $jVmMx.Decode.bool, false)), $iv6Yc._2($jVmMx.Decode.field, "slug", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string))), $iv6Yc._2($jVmMx.Decode.field, "pinterestTagId", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string))), $jVmMx.Decode.fieldWithDefault("makerPagesSlug", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string), undefined)), $iv6Yc._2($jVmMx.Decode.field, "googleAds", $iv6Yc._1($jVmMx.Decode.option, $hmUAM.GoogleAdsCodecs.fromJson))), $jVmMx.Decode.fieldWithDefault("connectedGAProperty", $iv6Yc._1($jVmMx.Decode.option, $2d3Mr.ConnectedGAPropertyCodecs.fromJson), undefined)), $iv6Yc._2($jVmMx.Decode.field, "addToCart", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string))), $jVmMx.Decode.fieldWithDefault("customActions", $iv6Yc._1($jVmMx.Decode.array, $crJlr.fromJson), [])), $jVmMx.Decode.fieldWithDefault("bioConfigId", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string), undefined)), $jVmMx.Decode.fieldWithDefault("customBioScript", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string), undefined)), $jVmMx.Decode.fieldWithDefault("isAnalyticsEmailAllowed", $jVmMx.Decode.bool, true)), $jVmMx.Decode.fieldWithDefault("analyticsEmailFrequency", $dKt0X.EmailFrequency.fromJson, {
    weekly: true,
    monthly: true,
    yearly: true,
    daily: false
})), $jVmMx.Decode.fieldWithDefault("overrides", $iv6Yc._1($jVmMx.Decode.option, $3u0dF.Overrides.fromJson), undefined)), $jVmMx.Decode.fieldWithDefault("useCustomDimensionForFingerprinting", $jVmMx.Decode.bool, false)), $jVmMx.Decode.fieldWithDefault("expandVariantsInProductsListing", $jVmMx.Decode.bool, false)), $jVmMx.Decode.fieldWithDefault("eventsPostmessage", $jVmMx.Decode.bool, false)), $jVmMx.Decode.fieldWithDefault("eventsWhitelist", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string), undefined)), $jVmMx.Decode.fieldWithDefault("productRules", $1FxyN.ProductRules.fromJson, $1FxyN.ProductRules.empty)), $jVmMx.Decode.fieldWithDefault("productPriceStyle", $f4o9q.ProductPriceStyle.fromJson, /* Default */ 0)), $jVmMx.Decode.fieldWithDefault("productCardStyle", $iv6Yc._1($jVmMx.Decode.option, $9BF9g.ProductCardStyle.fromJson), undefined)), $jVmMx.Decode.fieldWithDefault("showProductReviews", $jVmMx.Decode.bool, true)), $jVmMx.Decode.fieldWithDefault("showProductReviewsCountInPLP", $jVmMx.Decode.bool, true)), $jVmMx.Decode.fieldWithDefault("showProductReviewsCountInPDP", $jVmMx.Decode.bool, true)), $jVmMx.Decode.fieldWithDefault("cartCountCSSSelector", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string), undefined)), $jVmMx.Decode.fieldWithDefault("audienceCreatedOn", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.$$float), undefined)), $jVmMx.Decode.fieldWithDefault("optimize", $iv6Yc._1($jVmMx.Decode.option, $gkW0h.Optimize.fromJson), undefined)), $jVmMx.Decode.fieldWithDefault("gaMeasurementId", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string), undefined)), $jVmMx.Decode.fieldWithDefault("navMenuConfig", $iv6Yc._1($jVmMx.Decode.option, $doWsD.NavMenu.fromJson), undefined)), $jVmMx.Decode.fieldWithDefault("allowMultipleEmbedsOnSamePage", $jVmMx.Decode.bool, false)), $jVmMx.Decode.fieldWithDefault("siteHeaderCSSSelector", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string), undefined)), $jVmMx.Decode.fieldWithDefault("themes", $iv6Yc._1($jVmMx.Decode.array, $fFzkv.fromJson), [])), function(result) {
    var deprecated_addToCart = result.deprecated_addToCart;
    var tmp;
    if (deprecated_addToCart !== undefined) {
        var customActions = $i7mYY.concat([
            {
                id: $iv6Yc._1($dRfYk.fromString, "add-to-cart"),
                name: "Add to cart",
                onClickFn: deprecated_addToCart,
                renderFn: undefined,
                addToCart: true
            }
        ], result.customActions);
        var newrecord = $7bjme.obj_dup(result);
        newrecord.customActions = customActions;
        newrecord.deprecated_addToCart = undefined;
        tmp = newrecord;
    } else tmp = result;
    return $iv6Yc._1($jVmMx.Decode.succeed, tmp);
});
var $5359fe5ba89848c8$export$68b4491d6924a6d1 = {
    fromJson: $5359fe5ba89848c8$var$fromJson
};
 /* fromJson Not a pure module */ 
});
parcelRegister("fOw8Z", function(module, exports) {

$parcel$export(module.exports, "fromJson", function () { return $b83475a4cfd08827$export$7ae2d2a8b28a8cb8; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $79vie = parcelRequire("79vie");

var $AAkl8 = parcelRequire("AAkl8");

var $jVmMx = parcelRequire("jVmMx");

var $doJJK = parcelRequire("doJJK");
function $b83475a4cfd08827$var$color_encode(param) {
    return $AAkl8.object([
        [
            "id",
            $AAkl8.string(param.id)
        ],
        [
            "label",
            $AAkl8.string(param.label)
        ],
        [
            "tag",
            $AAkl8.string(param.tag)
        ],
        [
            "colorValue",
            $AAkl8.string(param.colorValue)
        ]
    ]);
}
var $b83475a4cfd08827$var$color_decode = $79vie.map4($79vie.field("id", $79vie.string), $79vie.field("label", $79vie.string), $79vie.field("tag", $79vie.string), $79vie.field("colorValue", $79vie.string), function(id, label, tag, colorValue) {
    return {
        id: id,
        label: label,
        tag: tag,
        colorValue: colorValue
    };
});
function $b83475a4cfd08827$var$image_encode(param) {
    return $AAkl8.object([
        [
            "id",
            $AAkl8.string(param.id)
        ],
        [
            "label",
            $AAkl8.string(param.label)
        ],
        [
            "tag",
            $AAkl8.string(param.tag)
        ],
        [
            "imageUrl",
            $AAkl8.string(param.imageUrl)
        ]
    ]);
}
var $b83475a4cfd08827$var$image_decode = $79vie.map4($79vie.field("id", $79vie.string), $79vie.field("label", $79vie.string), $79vie.field("tag", $79vie.string), $79vie.field("imageUrl", $79vie.string), function(id, label, tag, imageUrl) {
    return {
        id: id,
        label: label,
        tag: tag,
        imageUrl: imageUrl
    };
});
function $b83475a4cfd08827$var$checkbox_encode(param) {
    return $AAkl8.object([
        [
            "id",
            $AAkl8.string(param.id)
        ],
        [
            "label",
            $AAkl8.string(param.label)
        ],
        [
            "tag",
            $AAkl8.string(param.tag)
        ]
    ]);
}
var $b83475a4cfd08827$var$checkbox_decode = $79vie.map3($79vie.field("id", $79vie.string), $79vie.field("label", $79vie.string), $79vie.field("tag", $79vie.string), function(id, label, tag) {
    return {
        id: id,
        label: label,
        tag: tag
    };
});
var $b83475a4cfd08827$var$intermediate_decode = $79vie.map4($79vie.field("id", $79vie.string), $79vie.field("label", $79vie.string), $79vie.field("tag", $79vie.string), $79vie.field("value", $79vie.option($79vie.string)), function(id, label, tag, value) {
    return {
        id: id,
        label: label,
        tag: tag,
        value: value
    };
});
var $b83475a4cfd08827$export$6d08773d2e66f8f2 = {
    color_encode: $b83475a4cfd08827$var$color_encode,
    color_decode: $b83475a4cfd08827$var$color_decode,
    image_encode: $b83475a4cfd08827$var$image_encode,
    image_decode: $b83475a4cfd08827$var$image_decode,
    checkbox_encode: $b83475a4cfd08827$var$checkbox_encode,
    checkbox_decode: $b83475a4cfd08827$var$checkbox_decode,
    intermediate_decode: $b83475a4cfd08827$var$intermediate_decode
};
var $b83475a4cfd08827$var$partial_arg = [
    [
        "Tag",
        /* Tag */ 0
    ],
    [
        "Color",
        /* Color */ 1
    ],
    [
        "Size",
        /* Size */ 2
    ],
    [
        "Material",
        /* Material */ 3
    ],
    [
        "Pattern",
        /* Pattern */ 4
    ]
];
function $b83475a4cfd08827$export$5d9e9b4d40c39504(param) {
    return $jVmMx.Encode.simpleVariant($b83475a4cfd08827$var$partial_arg, param);
}
var $b83475a4cfd08827$export$6ac17622fef3953b = $jVmMx.Decode.simpleVariant([
    [
        "Tag",
        /* Tag */ 0
    ],
    [
        "Color",
        /* Color */ 1
    ],
    [
        "Size",
        /* Size */ 2
    ],
    [
        "Material",
        /* Material */ 3
    ],
    [
        "Pattern",
        /* Pattern */ 4
    ]
]);
function $b83475a4cfd08827$export$f663501057cbec00(param) {
    return $AAkl8.object([
        [
            "sectionExtractor",
            $AAkl8.string(param.sectionExtractor)
        ],
        [
            "labelExtractor",
            $AAkl8.string(param.labelExtractor)
        ]
    ]);
}
var $b83475a4cfd08827$export$ba7a19adcaca8bfa = $iv6Yc._3($jVmMx.Decode.map2, $iv6Yc._2($jVmMx.Decode.field, "sectionExtractor", $jVmMx.Decode.string), $iv6Yc._2($jVmMx.Decode.field, "labelExtractor", $jVmMx.Decode.string), function(sectionExtractor, labelExtractor) {
    return {
        sectionExtractor: sectionExtractor,
        labelExtractor: labelExtractor
    };
});
function $b83475a4cfd08827$var$data_encode(param, optionsEncoder) {
    return $iv6Yc._1($jVmMx.Encode.object, [
        [
            "_type",
            $b83475a4cfd08827$export$5d9e9b4d40c39504(param._type)
        ],
        [
            "id",
            $iv6Yc._1($jVmMx.Encode.string, param.id)
        ],
        [
            "label",
            $iv6Yc._1($jVmMx.Encode.string, param.label)
        ],
        [
            "options",
            $iv6Yc._2($jVmMx.Encode.array, param.options, optionsEncoder)
        ],
        [
            "importInfo",
            $jVmMx.Encode.nullable(param.importInfo, $b83475a4cfd08827$export$f663501057cbec00)
        ]
    ]);
}
function $b83475a4cfd08827$var$data_decode(decoder) {
    return $79vie.map5($79vie.field("_type", $b83475a4cfd08827$export$6ac17622fef3953b), $79vie.field("id", $79vie.string), $79vie.field("label", $79vie.string), $79vie.field("options", $79vie.array(decoder)), $79vie.field("importInfo", $79vie.option($b83475a4cfd08827$export$ba7a19adcaca8bfa)), function(_type, id, label, options, importInfo) {
        return {
            _type: _type,
            id: id,
            label: label,
            options: options,
            importInfo: importInfo
        };
    });
}
function $b83475a4cfd08827$var$toJson(v) {
    switch(v.TAG | 0){
        case /* ColorCheckbox */ 0:
            return $jVmMx.Encode.deccoVariantWithPayload(v._0, "ColorCheckbox", function(__x) {
                return $b83475a4cfd08827$var$data_encode(__x, $b83475a4cfd08827$var$color_encode);
            });
        case /* ImageCheckbox */ 1:
            return $jVmMx.Encode.deccoVariantWithPayload(v._0, "ImageCheckbox", function(__x) {
                return $b83475a4cfd08827$var$data_encode(__x, $b83475a4cfd08827$var$image_encode);
            });
        case /* Checkbox */ 2:
            return $jVmMx.Encode.deccoVariantWithPayload(v._0, "Checkbox", function(__x) {
                return $b83475a4cfd08827$var$data_encode(__x, $b83475a4cfd08827$var$checkbox_encode);
            });
    }
}
var $b83475a4cfd08827$var$fromJson = $iv6Yc._2($jVmMx.Decode.oneOf, $jVmMx.Decode.deccoVariantWithPayload("ColorCheckbox", $b83475a4cfd08827$var$data_decode($b83475a4cfd08827$var$color_decode), function(c) {
    return {
        TAG: /* ColorCheckbox */ 0,
        _0: c
    };
}), [
    $jVmMx.Decode.deccoVariantWithPayload("ImageCheckbox", $b83475a4cfd08827$var$data_decode($b83475a4cfd08827$var$image_decode), function(i) {
        return {
            TAG: /* ImageCheckbox */ 1,
            _0: i
        };
    }),
    $jVmMx.Decode.deccoVariantWithPayload("Checkbox", $b83475a4cfd08827$var$data_decode($b83475a4cfd08827$var$checkbox_decode), function(c) {
        return {
            TAG: /* Checkbox */ 2,
            _0: c
        };
    })
]);
var $b83475a4cfd08827$export$6e2c8f0811a474ce = {
    data_encode: $b83475a4cfd08827$var$data_encode,
    data_decode: $b83475a4cfd08827$var$data_decode,
    toJson: $b83475a4cfd08827$var$toJson,
    fromJson: $b83475a4cfd08827$var$fromJson
};
function $b83475a4cfd08827$export$d5b7a8bf56ee1fe2(__x) {
    return $AAkl8.array(__x, $b83475a4cfd08827$var$toJson);
}
var $b83475a4cfd08827$export$7ae2d2a8b28a8cb8 = $79vie.array($b83475a4cfd08827$var$fromJson);
var $b83475a4cfd08827$var$include = $doJJK.Make({
    toJson: $b83475a4cfd08827$export$d5b7a8bf56ee1fe2,
    fromJson: $b83475a4cfd08827$export$7ae2d2a8b28a8cb8
});
var $b83475a4cfd08827$export$cc42ff7b6c615091 = $b83475a4cfd08827$var$include.t_encode;
var $b83475a4cfd08827$export$bb5e712207166a02 = $b83475a4cfd08827$var$include.t_decode;
var $b83475a4cfd08827$export$1c37c01eba8ed446 = $b83475a4cfd08827$var$include.codec;
 /* color_decode Not a pure module */ 
});

parcelRegister("5td17", function(module, exports) {

$parcel$export(module.exports, "fromJson", function () { return $3fb9c214fab54956$export$7ae2d2a8b28a8cb8; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $79vie = parcelRequire("79vie");

var $AAkl8 = parcelRequire("AAkl8");

var $jVmMx = parcelRequire("jVmMx");

var $doJJK = parcelRequire("doJJK");
function $3fb9c214fab54956$var$color_encode(param) {
    return $AAkl8.object([
        [
            "id",
            $AAkl8.string(param.id)
        ],
        [
            "label",
            $AAkl8.string(param.label)
        ],
        [
            "facet",
            $AAkl8.string(param.facet)
        ],
        [
            "colorValue",
            $AAkl8.string(param.colorValue)
        ]
    ]);
}
var $3fb9c214fab54956$var$color_decode = $79vie.map4($79vie.field("id", $79vie.string), $79vie.field("label", $79vie.string), $79vie.field("facet", $79vie.string), $79vie.field("colorValue", $79vie.string), function(id, label, facet, colorValue) {
    return {
        id: id,
        label: label,
        facet: facet,
        colorValue: colorValue
    };
});
function $3fb9c214fab54956$var$image_encode(param) {
    return $AAkl8.object([
        [
            "id",
            $AAkl8.string(param.id)
        ],
        [
            "label",
            $AAkl8.string(param.label)
        ],
        [
            "facet",
            $AAkl8.string(param.facet)
        ],
        [
            "imageUrl",
            $AAkl8.string(param.imageUrl)
        ]
    ]);
}
var $3fb9c214fab54956$var$image_decode = $79vie.map4($79vie.field("id", $79vie.string), $79vie.field("label", $79vie.string), $79vie.field("facet", $79vie.string), $79vie.field("imageUrl", $79vie.string), function(id, label, facet, imageUrl) {
    return {
        id: id,
        label: label,
        facet: facet,
        imageUrl: imageUrl
    };
});
function $3fb9c214fab54956$var$checkbox_encode(param) {
    return $AAkl8.object([
        [
            "id",
            $AAkl8.string(param.id)
        ],
        [
            "label",
            $AAkl8.string(param.label)
        ],
        [
            "facet",
            $AAkl8.string(param.facet)
        ]
    ]);
}
var $3fb9c214fab54956$var$checkbox_decode = $79vie.map3($79vie.field("id", $79vie.string), $79vie.field("label", $79vie.string), $79vie.field("facet", $79vie.string), function(id, label, facet) {
    return {
        id: id,
        label: label,
        facet: facet
    };
});
var $3fb9c214fab54956$var$intermediate_decode = $79vie.map4($79vie.field("id", $79vie.string), $79vie.field("label", $79vie.string), $79vie.field("facet", $79vie.string), $79vie.field("value", $79vie.option($79vie.string)), function(id, label, facet, value) {
    return {
        id: id,
        label: label,
        facet: facet,
        value: value
    };
});
var $3fb9c214fab54956$export$6d08773d2e66f8f2 = {
    color_encode: $3fb9c214fab54956$var$color_encode,
    color_decode: $3fb9c214fab54956$var$color_decode,
    image_encode: $3fb9c214fab54956$var$image_encode,
    image_decode: $3fb9c214fab54956$var$image_decode,
    checkbox_encode: $3fb9c214fab54956$var$checkbox_encode,
    checkbox_decode: $3fb9c214fab54956$var$checkbox_decode,
    intermediate_decode: $3fb9c214fab54956$var$intermediate_decode
};
function $3fb9c214fab54956$var$data_encode(param, optionsEncoder) {
    return $iv6Yc._1($jVmMx.Encode.object, [
        [
            "id",
            $iv6Yc._1($jVmMx.Encode.string, param.id)
        ],
        [
            "label",
            $iv6Yc._1($jVmMx.Encode.string, param.label)
        ],
        [
            "options",
            $iv6Yc._2($jVmMx.Encode.array, param.options, optionsEncoder)
        ],
        [
            "visible",
            $iv6Yc._1($jVmMx.Encode.bool, param.visible)
        ]
    ]);
}
function $3fb9c214fab54956$var$data_decode(decoder) {
    return $iv6Yc._5($jVmMx.Decode.map4, $iv6Yc._2($jVmMx.Decode.field, "id", $jVmMx.Decode.string), $iv6Yc._2($jVmMx.Decode.field, "label", $jVmMx.Decode.string), $iv6Yc._2($jVmMx.Decode.field, "options", $iv6Yc._1($jVmMx.Decode.array, decoder)), $jVmMx.Decode.fieldWithDefault("visible", $jVmMx.Decode.bool, true), function(id, label, options, visible) {
        return {
            id: id,
            label: label,
            options: options,
            visible: visible
        };
    });
}
function $3fb9c214fab54956$var$toJson(v) {
    switch(v.TAG | 0){
        case /* ColorCheckbox */ 0:
            return $jVmMx.Encode.deccoVariantWithPayload(v._0, "ColorCheckbox", function(__x) {
                return $3fb9c214fab54956$var$data_encode(__x, $3fb9c214fab54956$var$color_encode);
            });
        case /* ImageCheckbox */ 1:
            return $jVmMx.Encode.deccoVariantWithPayload(v._0, "ImageCheckbox", function(__x) {
                return $3fb9c214fab54956$var$data_encode(__x, $3fb9c214fab54956$var$image_encode);
            });
        case /* Checkbox */ 2:
            return $jVmMx.Encode.deccoVariantWithPayload(v._0, "Checkbox", function(__x) {
                return $3fb9c214fab54956$var$data_encode(__x, $3fb9c214fab54956$var$checkbox_encode);
            });
    }
}
var $3fb9c214fab54956$var$fromJson = $iv6Yc._2($jVmMx.Decode.oneOf, $jVmMx.Decode.deccoVariantWithPayload("ColorCheckbox", $3fb9c214fab54956$var$data_decode($3fb9c214fab54956$var$color_decode), function(c) {
    return {
        TAG: /* ColorCheckbox */ 0,
        _0: c
    };
}), [
    $jVmMx.Decode.deccoVariantWithPayload("ImageCheckbox", $3fb9c214fab54956$var$data_decode($3fb9c214fab54956$var$image_decode), function(i) {
        return {
            TAG: /* ImageCheckbox */ 1,
            _0: i
        };
    }),
    $jVmMx.Decode.deccoVariantWithPayload("Checkbox", $3fb9c214fab54956$var$data_decode($3fb9c214fab54956$var$checkbox_decode), function(c) {
        return {
            TAG: /* Checkbox */ 2,
            _0: c
        };
    })
]);
var $3fb9c214fab54956$export$6e2c8f0811a474ce = {
    data_encode: $3fb9c214fab54956$var$data_encode,
    data_decode: $3fb9c214fab54956$var$data_decode,
    toJson: $3fb9c214fab54956$var$toJson,
    fromJson: $3fb9c214fab54956$var$fromJson
};
function $3fb9c214fab54956$export$d5b7a8bf56ee1fe2(__x) {
    return $AAkl8.array(__x, $3fb9c214fab54956$var$toJson);
}
var $3fb9c214fab54956$export$7ae2d2a8b28a8cb8 = $79vie.array($3fb9c214fab54956$var$fromJson);
var $3fb9c214fab54956$var$include = $doJJK.Make({
    toJson: $3fb9c214fab54956$export$d5b7a8bf56ee1fe2,
    fromJson: $3fb9c214fab54956$export$7ae2d2a8b28a8cb8
});
var $3fb9c214fab54956$export$cc42ff7b6c615091 = $3fb9c214fab54956$var$include.t_encode;
var $3fb9c214fab54956$export$bb5e712207166a02 = $3fb9c214fab54956$var$include.t_decode;
var $3fb9c214fab54956$export$1c37c01eba8ed446 = $3fb9c214fab54956$var$include.codec;
 /* color_decode Not a pure module */ 
});

parcelRegister("gkW0h", function(module, exports) {

$parcel$export(module.exports, "Optimize", function () { return $be4b81dd94def38e$export$b8e51e84bc71aff9; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $jVmMx = parcelRequire("jVmMx");

var $doJJK = parcelRequire("doJJK");
function $be4b81dd94def38e$var$toJson(param) {
    return $iv6Yc._1($jVmMx.Encode.object, [
        [
            "isActive",
            $iv6Yc._1($jVmMx.Encode.bool, param.isActive)
        ]
    ]);
}
var $be4b81dd94def38e$var$fromJson = $iv6Yc._2($jVmMx.Decode.map, $jVmMx.Decode.fieldWithDefault("isActive", $jVmMx.Decode.bool, true), function(isActive) {
    return {
        isActive: isActive
    };
});
var $be4b81dd94def38e$var$include = $doJJK.Make({
    toJson: $be4b81dd94def38e$var$toJson,
    fromJson: $be4b81dd94def38e$var$fromJson
});
var $be4b81dd94def38e$var$Optimize_t_encode = $be4b81dd94def38e$var$include.t_encode;
var $be4b81dd94def38e$var$Optimize_t_decode = $be4b81dd94def38e$var$include.t_decode;
var $be4b81dd94def38e$var$Optimize_codec = $be4b81dd94def38e$var$include.codec;
var $be4b81dd94def38e$export$b8e51e84bc71aff9 = {
    toJson: $be4b81dd94def38e$var$toJson,
    fromJson: $be4b81dd94def38e$var$fromJson,
    t_encode: $be4b81dd94def38e$var$Optimize_t_encode,
    t_decode: $be4b81dd94def38e$var$Optimize_t_decode,
    codec: $be4b81dd94def38e$var$Optimize_codec
};
 /* fromJson Not a pure module */ 
});

parcelRegister("hmUAM", function(module, exports) {

$parcel$export(module.exports, "GoogleAdsCodecs", function () { return $ca5063cca2496149$export$2d5d03092842fd5f; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $jVmMx = parcelRequire("jVmMx");

var $doJJK = parcelRequire("doJJK");
function $ca5063cca2496149$var$toJson(param) {
    return $iv6Yc._1($jVmMx.Encode.object, [
        [
            "tagId",
            $jVmMx.Encode.nullable(param.tagId, $jVmMx.Encode.string)
        ],
        [
            "pageViewEnabled",
            $iv6Yc._1($jVmMx.Encode.bool, param.pageViewEnabled)
        ],
        [
            "pageViewConversionLabel",
            $jVmMx.Encode.nullable(param.pageViewConversionLabel, $jVmMx.Encode.string)
        ],
        [
            "viewItemEnabled",
            $iv6Yc._1($jVmMx.Encode.bool, param.viewItemEnabled)
        ],
        [
            "viewItemConversionLabel",
            $jVmMx.Encode.nullable(param.viewItemConversionLabel, $jVmMx.Encode.string)
        ],
        [
            "addToCartEnabled",
            $iv6Yc._1($jVmMx.Encode.bool, param.addToCartEnabled)
        ],
        [
            "addToCartConversionLabel",
            $jVmMx.Encode.nullable(param.addToCartConversionLabel, $jVmMx.Encode.string)
        ]
    ]);
}
var $ca5063cca2496149$var$fromJson = $iv6Yc._8($jVmMx.Decode.map7, $iv6Yc._2($jVmMx.Decode.field, "tagId", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string)), $jVmMx.Decode.fieldWithDefault("pageViewEnabled", $jVmMx.Decode.bool, false), $iv6Yc._2($jVmMx.Decode.field, "pageViewConversionLabel", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string)), $jVmMx.Decode.fieldWithDefault("viewItemEnabled", $jVmMx.Decode.bool, true), $iv6Yc._2($jVmMx.Decode.field, "viewItemConversionLabel", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string)), $jVmMx.Decode.fieldWithDefault("addToCartEnabled", $jVmMx.Decode.bool, true), $iv6Yc._2($jVmMx.Decode.field, "addToCartConversionLabel", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string)), function(tagId, pageViewEnabled, pageViewConversionLabel, viewItemEnabled, viewItemConversionLabel, addToCartEnabled, addToCartConversionLabel) {
    return {
        tagId: tagId,
        pageViewEnabled: pageViewEnabled,
        pageViewConversionLabel: pageViewConversionLabel,
        viewItemEnabled: viewItemEnabled,
        viewItemConversionLabel: viewItemConversionLabel,
        addToCartEnabled: addToCartEnabled,
        addToCartConversionLabel: addToCartConversionLabel
    };
});
var $ca5063cca2496149$var$include = $doJJK.Make({
    toJson: $ca5063cca2496149$var$toJson,
    fromJson: $ca5063cca2496149$var$fromJson
});
var $ca5063cca2496149$var$GoogleAdsCodecs_empty = {
    tagId: undefined,
    pageViewEnabled: false,
    pageViewConversionLabel: undefined,
    viewItemEnabled: true,
    viewItemConversionLabel: undefined,
    addToCartEnabled: true,
    addToCartConversionLabel: undefined
};
var $ca5063cca2496149$var$GoogleAdsCodecs_t_encode = $ca5063cca2496149$var$include.t_encode;
var $ca5063cca2496149$var$GoogleAdsCodecs_t_decode = $ca5063cca2496149$var$include.t_decode;
var $ca5063cca2496149$var$GoogleAdsCodecs_codec = $ca5063cca2496149$var$include.codec;
var $ca5063cca2496149$export$2d5d03092842fd5f = {
    toJson: $ca5063cca2496149$var$toJson,
    fromJson: $ca5063cca2496149$var$fromJson,
    empty: $ca5063cca2496149$var$GoogleAdsCodecs_empty,
    t_encode: $ca5063cca2496149$var$GoogleAdsCodecs_t_encode,
    t_decode: $ca5063cca2496149$var$GoogleAdsCodecs_t_decode,
    codec: $ca5063cca2496149$var$GoogleAdsCodecs_codec
};
 /* fromJson Not a pure module */ 
});

parcelRegister("3u0dF", function(module, exports) {

$parcel$export(module.exports, "Overrides", function () { return $2894580601046fed$export$23b9aa6bc8814b5; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $jVmMx = parcelRequire("jVmMx");

var $doJJK = parcelRequire("doJJK");
function $2894580601046fed$var$propertyToJson(param) {
    return $iv6Yc._1($jVmMx.Encode.object, [
        [
            "property",
            $iv6Yc._1($jVmMx.Encode.string, param.property)
        ],
        [
            "value",
            param.value
        ]
    ]);
}
function $2894580601046fed$var$overrideToJson(param) {
    return $iv6Yc._1($jVmMx.Encode.object, [
        [
            "configId",
            $iv6Yc._1($jVmMx.Encode.string, param.configId)
        ],
        [
            "properties",
            $iv6Yc._2($jVmMx.Encode.array, param.properties, $2894580601046fed$var$propertyToJson)
        ]
    ]);
}
function $2894580601046fed$var$toJson(__x) {
    return $iv6Yc._2($jVmMx.Encode.array, __x, $2894580601046fed$var$overrideToJson);
}
var $2894580601046fed$var$Encode = {
    propertyToJson: $2894580601046fed$var$propertyToJson,
    overrideToJson: $2894580601046fed$var$overrideToJson,
    toJson: $2894580601046fed$var$toJson
};
var $2894580601046fed$var$propertyFromJson = $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._1($jVmMx.Decode.succeed, function(property, value) {
    return {
        property: property,
        value: value
    };
}), $iv6Yc._2($jVmMx.Decode.field, "property", $jVmMx.Decode.string)), $iv6Yc._2($jVmMx.Decode.field, "value", $jVmMx.Decode.value));
var $2894580601046fed$var$overrideFromJson = $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._1($jVmMx.Decode.succeed, function(configId, properties) {
    return {
        configId: configId,
        properties: properties
    };
}), $iv6Yc._2($jVmMx.Decode.field, "configId", $jVmMx.Decode.string)), $iv6Yc._2($jVmMx.Decode.field, "properties", $iv6Yc._1($jVmMx.Decode.array, $2894580601046fed$var$propertyFromJson)));
var $2894580601046fed$var$fromJson = $iv6Yc._1($jVmMx.Decode.array, $2894580601046fed$var$overrideFromJson);
var $2894580601046fed$var$Decode = {
    propertyFromJson: $2894580601046fed$var$propertyFromJson,
    overrideFromJson: $2894580601046fed$var$overrideFromJson,
    fromJson: $2894580601046fed$var$fromJson
};
var $2894580601046fed$var$include = $doJJK.Make({
    toJson: $2894580601046fed$var$toJson,
    fromJson: $2894580601046fed$var$fromJson
});
function $2894580601046fed$var$getByConfigId(overrides, configId) {
    return $i7mYY.getBy(overrides, function(override) {
        return override.configId === configId;
    });
}
function $2894580601046fed$var$getByConfigIdAndProperty(overrides, configId, property) {
    return $i7mYY.getBy($2whNH.mapWithDefault($2894580601046fed$var$getByConfigId(overrides, configId), [], function(override) {
        return override.properties;
    }), function(item) {
        return item.property === property;
    });
}
var $2894580601046fed$var$Overrides_t_encode = $2894580601046fed$var$include.t_encode;
var $2894580601046fed$var$Overrides_t_decode = $2894580601046fed$var$include.t_decode;
var $2894580601046fed$var$Overrides_codec = $2894580601046fed$var$include.codec;
var $2894580601046fed$export$23b9aa6bc8814b5 = {
    Encode: $2894580601046fed$var$Encode,
    Decode: $2894580601046fed$var$Decode,
    toJson: $2894580601046fed$var$toJson,
    fromJson: $2894580601046fed$var$fromJson,
    t_encode: $2894580601046fed$var$Overrides_t_encode,
    t_decode: $2894580601046fed$var$Overrides_t_decode,
    codec: $2894580601046fed$var$Overrides_codec,
    getByConfigId: $2894580601046fed$var$getByConfigId,
    getByConfigIdAndProperty: $2894580601046fed$var$getByConfigIdAndProperty
};
 /* propertyFromJson Not a pure module */ 
});

parcelRegister("jLiCS", function(module, exports) {

$parcel$export(module.exports, "PDPStackSize", function () { return $e630dad53c02320a$export$f2f78bc64bec03df; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $jVmMx = parcelRequire("jVmMx");

var $doJJK = parcelRequire("doJJK");
var $e630dad53c02320a$var$partial_arg = [
    [
        "sm",
        "sm"
    ],
    [
        "lg",
        "lg"
    ]
];
function $e630dad53c02320a$var$toJson(param) {
    return $jVmMx.Encode.simpleVariant($e630dad53c02320a$var$partial_arg, param);
}
var $e630dad53c02320a$var$fromJson = $jVmMx.Decode.simpleVariant([
    [
        "sm",
        "sm"
    ],
    [
        "lg",
        "lg"
    ]
]);
var $e630dad53c02320a$var$include = $doJJK.Make({
    toJson: $e630dad53c02320a$var$toJson,
    fromJson: $e630dad53c02320a$var$fromJson
});
var $e630dad53c02320a$var$t_encode = $e630dad53c02320a$var$include.t_encode;
var $e630dad53c02320a$var$t_decode = $e630dad53c02320a$var$include.t_decode;
var $e630dad53c02320a$var$PDPStackSize_codec = $e630dad53c02320a$var$include.codec;
var $e630dad53c02320a$export$f2f78bc64bec03df = {
    toJson: $e630dad53c02320a$var$toJson,
    fromJson: $e630dad53c02320a$var$fromJson,
    t_encode: $e630dad53c02320a$var$t_encode,
    t_decode: $e630dad53c02320a$var$t_decode,
    codec: $e630dad53c02320a$var$PDPStackSize_codec
};
var $e630dad53c02320a$export$ccd9022e0f959c9e = $e630dad53c02320a$var$t_encode;
var $e630dad53c02320a$export$b3b3171d8f08f6d6 = $e630dad53c02320a$var$t_decode;
 /* fromJson Not a pure module */ 
});

parcelRegister("1FxyN", function(module, exports) {

$parcel$export(module.exports, "ProductRules", function () { return $1373a71edb2a434a$export$1fa40822353c573d; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $jVmMx = parcelRequire("jVmMx");

var $doJJK = parcelRequire("doJJK");

var $5Ax4c = parcelRequire("5Ax4c");
function $1373a71edb2a434a$var$customAddToCartText_toJson(param) {
    return $iv6Yc._1($jVmMx.Encode.object, [
        [
            "rule",
            $5Ax4c.toJson(param.rule)
        ],
        [
            "text",
            $iv6Yc._1($jVmMx.Encode.string, param.text)
        ],
        [
            "overrideOutOfStock",
            $iv6Yc._1($jVmMx.Encode.bool, param.overrideOutOfStock)
        ]
    ]);
}
var $1373a71edb2a434a$var$customAddToCartText_fromJson = $iv6Yc._4($jVmMx.Decode.map3, $iv6Yc._2($jVmMx.Decode.field, "rule", $5Ax4c.fromJson(undefined)), $iv6Yc._2($jVmMx.Decode.field, "text", $jVmMx.Decode.string), $jVmMx.Decode.fieldWithDefault("overrideOutOfStock", $jVmMx.Decode.bool, false), function(rule, text, overrideOutOfStock) {
    return {
        rule: rule,
        text: text,
        overrideOutOfStock: overrideOutOfStock
    };
});
function $1373a71edb2a434a$var$toJson(param) {
    return $iv6Yc._1($jVmMx.Encode.object, [
        [
            "hideAddToCartButton",
            $jVmMx.Encode.nullable(param.hideAddToCartButton, $5Ax4c.toJson)
        ],
        [
            "customAddToCartText",
            $jVmMx.Encode.nullable(param.customAddToCartText, $1373a71edb2a434a$var$customAddToCartText_toJson)
        ],
        [
            "hideOpenLinkButton",
            $jVmMx.Encode.nullable(param.hideOpenLinkButton, $5Ax4c.toJson)
        ]
    ]);
}
var $1373a71edb2a434a$var$fromJson = $iv6Yc._4($jVmMx.Decode.map3, $jVmMx.Decode.fieldWithDefault("hideAddToCartButton", $iv6Yc._1($jVmMx.Decode.option, $5Ax4c.fromJson(undefined)), undefined), $jVmMx.Decode.fieldWithDefault("customAddToCartText", $iv6Yc._1($jVmMx.Decode.option, $1373a71edb2a434a$var$customAddToCartText_fromJson), undefined), $jVmMx.Decode.fieldWithDefault("hideOpenLinkButton", $iv6Yc._1($jVmMx.Decode.option, $5Ax4c.fromJson(undefined)), undefined), function(hideAddToCartButton, customAddToCartText, hideOpenLinkButton) {
    return {
        hideAddToCartButton: hideAddToCartButton,
        customAddToCartText: customAddToCartText,
        hideOpenLinkButton: hideOpenLinkButton
    };
});
var $1373a71edb2a434a$var$include = $doJJK.Make({
    toJson: $1373a71edb2a434a$var$toJson,
    fromJson: $1373a71edb2a434a$var$fromJson
});
var $1373a71edb2a434a$var$t_encode = $1373a71edb2a434a$var$include.t_encode;
var $1373a71edb2a434a$var$t_decode = $1373a71edb2a434a$var$include.t_decode;
var $1373a71edb2a434a$var$ProductRules_empty = {
    hideAddToCartButton: undefined,
    customAddToCartText: undefined,
    hideOpenLinkButton: undefined
};
var $1373a71edb2a434a$var$ProductRules_codec = $1373a71edb2a434a$var$include.codec;
var $1373a71edb2a434a$export$1fa40822353c573d = {
    customAddToCartText_toJson: $1373a71edb2a434a$var$customAddToCartText_toJson,
    customAddToCartText_fromJson: $1373a71edb2a434a$var$customAddToCartText_fromJson,
    toJson: $1373a71edb2a434a$var$toJson,
    fromJson: $1373a71edb2a434a$var$fromJson,
    empty: $1373a71edb2a434a$var$ProductRules_empty,
    t_encode: $1373a71edb2a434a$var$t_encode,
    t_decode: $1373a71edb2a434a$var$t_decode,
    codec: $1373a71edb2a434a$var$ProductRules_codec
};
var $1373a71edb2a434a$export$7705977b4a99ae42 = $1373a71edb2a434a$var$t_encode;
var $1373a71edb2a434a$export$b072445cfa6f9311 = $1373a71edb2a434a$var$t_decode;
 /* customAddToCartText_fromJson Not a pure module */ 
});
parcelRegister("5Ax4c", function(module, exports) {

$parcel$export(module.exports, "toJson", function () { return $4119f6e7443e0fed$export$d5b7a8bf56ee1fe2; });
$parcel$export(module.exports, "fromJson", function () { return $4119f6e7443e0fed$export$7ae2d2a8b28a8cb8; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $79vie = parcelRequire("79vie");

var $AAkl8 = parcelRequire("AAkl8");

var $jVmMx = parcelRequire("jVmMx");

var $jkQEU = parcelRequire("jkQEU");
function $4119f6e7443e0fed$var$toJson(stringCondition) {
    switch(stringCondition.TAG | 0){
        case /* EqualsTo */ 0:
            return $jVmMx.Encode.deccoVariantWithPayload(stringCondition._0, "EqualsTo", $jVmMx.Encode.string);
        case /* Contains */ 1:
            return $jVmMx.Encode.deccoVariantWithPayload(stringCondition._0, "Contains", $jVmMx.Encode.string);
        case /* NotEqualsTo */ 2:
            return $jVmMx.Encode.deccoVariantWithPayload(stringCondition._0, "NotEqualsTo", $jVmMx.Encode.string);
    }
}
var $4119f6e7443e0fed$var$fromJson = $iv6Yc._2($jVmMx.Decode.oneOf, $jVmMx.Decode.deccoVariantWithPayload("EqualsTo", $jVmMx.Decode.string, function(payload) {
    return {
        TAG: /* EqualsTo */ 0,
        _0: payload
    };
}), [
    $jVmMx.Decode.deccoVariantWithPayload("Contains", $jVmMx.Decode.string, function(payload) {
        return {
            TAG: /* Contains */ 1,
            _0: payload
        };
    }),
    $jVmMx.Decode.deccoVariantWithPayload("NotEqualsTo", $jVmMx.Decode.string, function(payload) {
        return {
            TAG: /* NotEqualsTo */ 2,
            _0: payload
        };
    })
]);
var $4119f6e7443e0fed$export$ef4a1c06c1da1817 = {
    toJson: $4119f6e7443e0fed$var$toJson,
    fromJson: $4119f6e7443e0fed$var$fromJson
};
function $4119f6e7443e0fed$var$toJson$1(t) {
    switch(t.TAG | 0){
        case /* EqualsTo */ 0:
            return $jVmMx.Encode.deccoVariantWithPayload(t._0, "EqualsTo", $jVmMx.Encode.$$float);
        case /* NotEqualsTo */ 1:
            return $jVmMx.Encode.deccoVariantWithPayload(t._0, "NotEqualsTo", $jVmMx.Encode.$$float);
        case /* GreaterThan */ 2:
            return $jVmMx.Encode.deccoVariantWithPayload(t._0, "GreaterThan", $jVmMx.Encode.$$float);
        case /* GreaterThanOrEqualsTo */ 3:
            return $jVmMx.Encode.deccoVariantWithPayload(t._0, "GreaterThanOrEqualsTo", $jVmMx.Encode.$$float);
        case /* LessThan */ 4:
            return $jVmMx.Encode.deccoVariantWithPayload(t._0, "LessThan", $jVmMx.Encode.$$float);
        case /* LessThanOrEqualsTo */ 5:
            return $jVmMx.Encode.deccoVariantWithPayload(t._0, "LessThanOrEqualsTo", $jVmMx.Encode.$$float);
    }
}
var $4119f6e7443e0fed$var$fromJson$1 = $iv6Yc._2($jVmMx.Decode.oneOf, $jVmMx.Decode.deccoVariantWithPayload("EqualsTo", $jVmMx.Decode.$$float, function(payload) {
    return {
        TAG: /* EqualsTo */ 0,
        _0: payload
    };
}), [
    $jVmMx.Decode.deccoVariantWithPayload("NotEqualsTo", $jVmMx.Decode.$$float, function(payload) {
        return {
            TAG: /* NotEqualsTo */ 1,
            _0: payload
        };
    }),
    $jVmMx.Decode.deccoVariantWithPayload("GreaterThan", $jVmMx.Decode.$$float, function(payload) {
        return {
            TAG: /* GreaterThan */ 2,
            _0: payload
        };
    }),
    $jVmMx.Decode.deccoVariantWithPayload("GreaterThanOrEqualsTo", $jVmMx.Decode.$$float, function(payload) {
        return {
            TAG: /* GreaterThanOrEqualsTo */ 3,
            _0: payload
        };
    }),
    $jVmMx.Decode.deccoVariantWithPayload("LessThan", $jVmMx.Decode.$$float, function(payload) {
        return {
            TAG: /* LessThan */ 4,
            _0: payload
        };
    }),
    $jVmMx.Decode.deccoVariantWithPayload("LessThanOrEqualsTo", $jVmMx.Decode.$$float, function(payload) {
        return {
            TAG: /* LessThanOrEqualsTo */ 5,
            _0: payload
        };
    })
]);
var $4119f6e7443e0fed$export$2cbe3d8ade9bdc14 = {
    toJson: $4119f6e7443e0fed$var$toJson$1,
    fromJson: $4119f6e7443e0fed$var$fromJson$1
};
function $4119f6e7443e0fed$var$toJson$2(t) {
    switch(t.TAG | 0){
        case /* EqualsTo */ 0:
            return $jVmMx.Encode.deccoVariantWithPayload(t._0, "EqualsTo", $jVmMx.Encode.$$int);
        case /* NotEqualsTo */ 1:
            return $jVmMx.Encode.deccoVariantWithPayload(t._0, "NotEqualsTo", $jVmMx.Encode.$$int);
        case /* GreaterThan */ 2:
            return $jVmMx.Encode.deccoVariantWithPayload(t._0, "GreaterThan", $jVmMx.Encode.$$int);
        case /* GreaterThanOrEqualsTo */ 3:
            return $jVmMx.Encode.deccoVariantWithPayload(t._0, "GreaterThanOrEqualsTo", $jVmMx.Encode.$$int);
        case /* LessThan */ 4:
            return $jVmMx.Encode.deccoVariantWithPayload(t._0, "LessThan", $jVmMx.Encode.$$int);
        case /* LessThanOrEqualsTo */ 5:
            return $jVmMx.Encode.deccoVariantWithPayload(t._0, "LessThanOrEqualsTo", $jVmMx.Encode.$$int);
    }
}
var $4119f6e7443e0fed$var$fromJson$2 = $iv6Yc._2($jVmMx.Decode.oneOf, $jVmMx.Decode.deccoVariantWithPayload("EqualsTo", $jVmMx.Decode.$$int, function(payload) {
    return {
        TAG: /* EqualsTo */ 0,
        _0: payload
    };
}), [
    $jVmMx.Decode.deccoVariantWithPayload("NotEqualsTo", $jVmMx.Decode.$$int, function(payload) {
        return {
            TAG: /* NotEqualsTo */ 1,
            _0: payload
        };
    }),
    $jVmMx.Decode.deccoVariantWithPayload("GreaterThan", $jVmMx.Decode.$$int, function(payload) {
        return {
            TAG: /* GreaterThan */ 2,
            _0: payload
        };
    }),
    $jVmMx.Decode.deccoVariantWithPayload("GreaterThanOrEqualsTo", $jVmMx.Decode.$$int, function(payload) {
        return {
            TAG: /* GreaterThanOrEqualsTo */ 3,
            _0: payload
        };
    }),
    $jVmMx.Decode.deccoVariantWithPayload("LessThan", $jVmMx.Decode.$$int, function(payload) {
        return {
            TAG: /* LessThan */ 4,
            _0: payload
        };
    }),
    $jVmMx.Decode.deccoVariantWithPayload("LessThanOrEqualsTo", $jVmMx.Decode.$$int, function(payload) {
        return {
            TAG: /* LessThanOrEqualsTo */ 5,
            _0: payload
        };
    })
]);
var $4119f6e7443e0fed$export$da3abb9be5cc0ffa = {
    toJson: $4119f6e7443e0fed$var$toJson$2,
    fromJson: $4119f6e7443e0fed$var$fromJson$2
};
function $4119f6e7443e0fed$var$toJson$3(arrayCondition, payloadEncoder) {
    if (arrayCondition.TAG === /* Any */ 0) return $jVmMx.Encode.deccoVariantWithPayload(arrayCondition._0, "Any", payloadEncoder);
    else return $jVmMx.Encode.deccoVariantWithPayload(arrayCondition._0, "NotAny", payloadEncoder);
}
function $4119f6e7443e0fed$var$fromJson$3(payloadDecoder) {
    return $iv6Yc._2($jVmMx.Decode.oneOf, $jVmMx.Decode.deccoVariantWithPayload("Any", payloadDecoder, function(payload) {
        return {
            TAG: /* Any */ 0,
            _0: payload
        };
    }), [
        $jVmMx.Decode.deccoVariantWithPayload("NotAny", payloadDecoder, function(payload) {
            return {
                TAG: /* NotAny */ 1,
                _0: payload
            };
        })
    ]);
}
var $4119f6e7443e0fed$export$9867bc6065674be0 = {
    toJson: $4119f6e7443e0fed$var$toJson$3,
    fromJson: $4119f6e7443e0fed$var$fromJson$3
};
function $4119f6e7443e0fed$var$toJson$4(param) {
    return $AAkl8.object([
        [
            "id",
            $iv6Yc._1($jkQEU.toJson, param.id)
        ],
        [
            "condition",
            $4119f6e7443e0fed$var$toJson$3(param.condition, $4119f6e7443e0fed$var$toJson)
        ]
    ]);
}
var $4119f6e7443e0fed$var$fromJson$4 = $79vie.map2($79vie.field("id", $jkQEU.fromJson), $79vie.field("condition", $4119f6e7443e0fed$var$fromJson$3($4119f6e7443e0fed$var$fromJson)), function(id, condition) {
    return {
        id: id,
        condition: condition
    };
});
var $4119f6e7443e0fed$export$f8f1308682b8f2d2 = {
    toJson: $4119f6e7443e0fed$var$toJson$4,
    fromJson: $4119f6e7443e0fed$var$fromJson$4
};
function $4119f6e7443e0fed$var$toJson$5(param) {
    return $AAkl8.object([
        [
            "id",
            $iv6Yc._1($jkQEU.toJson, param.id)
        ],
        [
            "condition",
            $4119f6e7443e0fed$var$toJson(param.condition)
        ]
    ]);
}
var $4119f6e7443e0fed$var$fromJson$5 = $79vie.map2($79vie.field("id", $jkQEU.fromJson), $79vie.field("condition", $4119f6e7443e0fed$var$fromJson), function(id, condition) {
    return {
        id: id,
        condition: condition
    };
});
var $4119f6e7443e0fed$export$11b099a658b17995 = {
    toJson: $4119f6e7443e0fed$var$toJson$5,
    fromJson: $4119f6e7443e0fed$var$fromJson$5
};
function $4119f6e7443e0fed$var$toJson$6(param) {
    return $AAkl8.object([
        [
            "id",
            $iv6Yc._1($jkQEU.toJson, param.id)
        ],
        [
            "condition",
            $4119f6e7443e0fed$var$toJson$3(param.condition, $4119f6e7443e0fed$var$toJson)
        ]
    ]);
}
var $4119f6e7443e0fed$var$fromJson$6 = $79vie.map2($79vie.field("id", $jkQEU.fromJson), $79vie.field("condition", $4119f6e7443e0fed$var$fromJson$3($4119f6e7443e0fed$var$fromJson)), function(id, condition) {
    return {
        id: id,
        condition: condition
    };
});
var $4119f6e7443e0fed$export$877f3fa7327cd466 = {
    toJson: $4119f6e7443e0fed$var$toJson$6,
    fromJson: $4119f6e7443e0fed$var$fromJson$6
};
function $4119f6e7443e0fed$var$toJson$7(param) {
    return $AAkl8.object([
        [
            "id",
            $iv6Yc._1($jkQEU.toJson, param.id)
        ],
        [
            "metadataKey",
            $AAkl8.string(param.metadataKey)
        ],
        [
            "condition",
            $4119f6e7443e0fed$var$toJson(param.condition)
        ]
    ]);
}
var $4119f6e7443e0fed$var$fromJson$7 = $79vie.map3($79vie.field("id", $jkQEU.fromJson), $79vie.field("metadataKey", $79vie.string), $79vie.field("condition", $4119f6e7443e0fed$var$fromJson), function(id, metadataKey, condition) {
    return {
        id: id,
        metadataKey: metadataKey,
        condition: condition
    };
});
var $4119f6e7443e0fed$export$fec6d490dd749df0 = {
    toJson: $4119f6e7443e0fed$var$toJson$7,
    fromJson: $4119f6e7443e0fed$var$fromJson$7
};
function $4119f6e7443e0fed$var$toJson$8(param) {
    return $AAkl8.object([
        [
            "id",
            $iv6Yc._1($jkQEU.toJson, param.id)
        ],
        [
            "condition",
            $4119f6e7443e0fed$var$toJson$1(param.condition)
        ]
    ]);
}
var $4119f6e7443e0fed$var$fromJson$8 = $79vie.map2($79vie.field("id", $jkQEU.fromJson), $79vie.field("condition", $4119f6e7443e0fed$var$fromJson$1), function(id, condition) {
    return {
        id: id,
        condition: condition
    };
});
var $4119f6e7443e0fed$export$2ce953db205a18d3 = {
    toJson: $4119f6e7443e0fed$var$toJson$8,
    fromJson: $4119f6e7443e0fed$var$fromJson$8
};
function $4119f6e7443e0fed$var$toJson$9(param) {
    return $AAkl8.object([
        [
            "id",
            $iv6Yc._1($jkQEU.toJson, param.id)
        ],
        [
            "condition",
            $4119f6e7443e0fed$var$toJson$2(param.condition)
        ]
    ]);
}
var $4119f6e7443e0fed$var$fromJson$9 = $79vie.map2($79vie.field("id", $jkQEU.fromJson), $79vie.field("condition", $4119f6e7443e0fed$var$fromJson$2), function(id, condition) {
    return {
        id: id,
        condition: condition
    };
});
var $4119f6e7443e0fed$export$2e4246fb755f537f = {
    toJson: $4119f6e7443e0fed$var$toJson$9,
    fromJson: $4119f6e7443e0fed$var$fromJson$9
};
function $4119f6e7443e0fed$var$toJson$10(op) {
    return $jVmMx.Encode.simpleVariant([
        [
            "And",
            /* And */ 0
        ],
        [
            "Or",
            /* Or */ 1
        ]
    ], op);
}
var $4119f6e7443e0fed$var$fromJson$10 = $jVmMx.Decode.simpleVariant([
    [
        "And",
        /* And */ 0
    ],
    [
        "Or",
        /* Or */ 1
    ]
]);
var $4119f6e7443e0fed$export$fc1f61f0deaddd66 = {
    toJson: $4119f6e7443e0fed$var$toJson$10,
    fromJson: $4119f6e7443e0fed$var$fromJson$10
};
function $4119f6e7443e0fed$var$toJson$11(encoder, param) {
    return $iv6Yc._1($jVmMx.Encode.object, [
        [
            "id",
            $iv6Yc._1($jkQEU.toJson, param.id)
        ],
        [
            "rules",
            $iv6Yc._2($jVmMx.Encode.array, param.rules, encoder)
        ],
        [
            "op",
            $4119f6e7443e0fed$var$toJson$10(param.op)
        ]
    ]);
}
function $4119f6e7443e0fed$var$fromJson$11(decoder) {
    return $iv6Yc._4($jVmMx.Decode.map3, $iv6Yc._2($jVmMx.Decode.field, "id", $jkQEU.fromJson), $iv6Yc._2($jVmMx.Decode.field, "rules", $iv6Yc._1($jVmMx.Decode.array, $jVmMx.Decode.lazy_(decoder))), $iv6Yc._2($jVmMx.Decode.field, "op", $4119f6e7443e0fed$var$fromJson$10), function(id, rules, op) {
        return {
            id: id,
            op: op,
            rules: rules
        };
    });
}
var $4119f6e7443e0fed$export$7f941bf77681be15 = {
    toJson: $4119f6e7443e0fed$var$toJson$11,
    fromJson: $4119f6e7443e0fed$var$fromJson$11
};
function $4119f6e7443e0fed$export$d5b7a8bf56ee1fe2(t) {
    switch(t.TAG | 0){
        case /* ProductTags */ 0:
            return $jVmMx.Encode.deccoVariantWithPayload(t._0, "ProductTags", $4119f6e7443e0fed$var$toJson$4);
        case /* ProductType */ 1:
            return $jVmMx.Encode.deccoVariantWithPayload(t._0, "ProductType", $4119f6e7443e0fed$var$toJson$5);
        case /* CustomLabels */ 2:
            return $jVmMx.Encode.deccoVariantWithPayload(t._0, "CustomLabels", $4119f6e7443e0fed$var$toJson$6);
        case /* ProductMetaData */ 3:
            return $jVmMx.Encode.deccoVariantWithPayload(t._0, "ProductMetaData", $4119f6e7443e0fed$var$toJson$7);
        case /* ProductPrice */ 4:
            return $jVmMx.Encode.deccoVariantWithPayload(t._0, "ProductPrice", $4119f6e7443e0fed$var$toJson$8);
        case /* ProductQuantity */ 5:
            return $jVmMx.Encode.deccoVariantWithPayload(t._0, "ProductQuantity", $4119f6e7443e0fed$var$toJson$9);
        case /* CompoundRule */ 6:
            return $jVmMx.Encode.deccoVariantWithPayload(t._0, "CompoundRule", function(param) {
                return $4119f6e7443e0fed$var$toJson$11($4119f6e7443e0fed$export$d5b7a8bf56ee1fe2, param);
            });
    }
}
function $4119f6e7443e0fed$export$7ae2d2a8b28a8cb8(param) {
    return $iv6Yc._2($jVmMx.Decode.oneOf, $jVmMx.Decode.deccoVariantWithPayload("ProductTags", $4119f6e7443e0fed$var$fromJson$4, function(payload) {
        return {
            TAG: /* ProductTags */ 0,
            _0: payload
        };
    }), [
        $jVmMx.Decode.deccoVariantWithPayload("ProductType", $4119f6e7443e0fed$var$fromJson$5, function(payload) {
            return {
                TAG: /* ProductType */ 1,
                _0: payload
            };
        }),
        $jVmMx.Decode.deccoVariantWithPayload("CustomLabels", $4119f6e7443e0fed$var$fromJson$6, function(payload) {
            return {
                TAG: /* CustomLabels */ 2,
                _0: payload
            };
        }),
        $jVmMx.Decode.deccoVariantWithPayload("ProductMetaData", $4119f6e7443e0fed$var$fromJson$7, function(payload) {
            return {
                TAG: /* ProductMetaData */ 3,
                _0: payload
            };
        }),
        $jVmMx.Decode.deccoVariantWithPayload("ProductPrice", $4119f6e7443e0fed$var$fromJson$8, function(payload) {
            return {
                TAG: /* ProductPrice */ 4,
                _0: payload
            };
        }),
        $jVmMx.Decode.deccoVariantWithPayload("ProductQuantity", $4119f6e7443e0fed$var$fromJson$9, function(payload) {
            return {
                TAG: /* ProductQuantity */ 5,
                _0: payload
            };
        }),
        $jVmMx.Decode.deccoVariantWithPayload("CompoundRule", $4119f6e7443e0fed$var$fromJson$11($4119f6e7443e0fed$export$7ae2d2a8b28a8cb8), function(payload) {
            return {
                TAG: /* CompoundRule */ 6,
                _0: payload
            };
        })
    ]);
}
 /* fromJson Not a pure module */ 
});
parcelRegister("jkQEU", function(module, exports) {

$parcel$export(module.exports, "toJson", function () { return $e138bb890c1a8733$export$d5b7a8bf56ee1fe2; });
$parcel$export(module.exports, "fromJson", function () { return $e138bb890c1a8733$export$7ae2d2a8b28a8cb8; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $ki9MN = parcelRequire("ki9MN");
var $e138bb890c1a8733$export$46b83a6aabf254e3 = $ki9MN.Make({});
var $e138bb890c1a8733$export$bb5e712207166a02 = $e138bb890c1a8733$export$46b83a6aabf254e3.t_decode;
var $e138bb890c1a8733$export$cc42ff7b6c615091 = $e138bb890c1a8733$export$46b83a6aabf254e3.t_encode;
var $e138bb890c1a8733$export$3004f64547af360e = $e138bb890c1a8733$export$46b83a6aabf254e3.fromString;
var $e138bb890c1a8733$export$f84e8e69fd4488a5 = $e138bb890c1a8733$export$46b83a6aabf254e3.toString;
var $e138bb890c1a8733$export$d5b7a8bf56ee1fe2 = $e138bb890c1a8733$export$46b83a6aabf254e3.toJson;
var $e138bb890c1a8733$export$7ae2d2a8b28a8cb8 = $e138bb890c1a8733$export$46b83a6aabf254e3.fromJson;
 /* Id Not a pure module */ 
});



parcelRegister("5NmPk", function(module, exports) {

$parcel$export(module.exports, "RelatedMedia", function () { return $43833c51e9860c01$export$b603cdf0301ce8bf; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $jVmMx = parcelRequire("jVmMx");

var $doJJK = parcelRequire("doJJK");
function $43833c51e9860c01$var$customShape_toJson(param) {
    return $iv6Yc._1($jVmMx.Encode.object, [
        [
            "width",
            $iv6Yc._1($jVmMx.Encode.$$int, param.width)
        ],
        [
            "height",
            $iv6Yc._1($jVmMx.Encode.$$int, param.height)
        ]
    ]);
}
var $43833c51e9860c01$var$customShape_fromJson = $iv6Yc._3($jVmMx.Decode.map2, $iv6Yc._2($jVmMx.Decode.field, "width", $jVmMx.Decode.$$int), $iv6Yc._2($jVmMx.Decode.field, "height", $jVmMx.Decode.$$int), function(width, height) {
    return {
        width: width,
        height: height
    };
});
function $43833c51e9860c01$var$shape_toJson(v) {
    if (typeof v !== "number") return $jVmMx.Encode.deccoVariantWithPayload(v._0, "Custom", $43833c51e9860c01$var$customShape_toJson);
    switch(v){
        case /* Tall */ 0:
            return $iv6Yc._2($jVmMx.Encode.array, [
                "Tall"
            ], $jVmMx.Encode.string);
        case /* Square */ 1:
            return $iv6Yc._2($jVmMx.Encode.array, [
                "Square"
            ], $jVmMx.Encode.string);
        case /* Circle */ 2:
            return $iv6Yc._2($jVmMx.Encode.array, [
                "Circle"
            ], $jVmMx.Encode.string);
    }
}
var $43833c51e9860c01$var$customDecoder = $jVmMx.Decode.deccoVariantWithPayload("Custom", $43833c51e9860c01$var$customShape_fromJson, function(param) {
    return /* Custom */ {
        _0: {
            width: param.width,
            height: param.height
        }
    };
});
var $43833c51e9860c01$var$shape_fromJson = $iv6Yc._2($jVmMx.Decode.oneOf, $43833c51e9860c01$var$customDecoder, [
    $jVmMx.Decode.simpleVariant([
        [
            "Circle",
            /* Circle */ 2
        ],
        [
            "Square",
            /* Square */ 1
        ],
        [
            "Tall",
            /* Tall */ 0
        ]
    ])
]);
function $43833c51e9860c01$var$size_toJson(v) {
    switch(v){
        case /* Small */ 0:
            return $iv6Yc._2($jVmMx.Encode.array, [
                "Small"
            ], $jVmMx.Encode.string);
        case /* Medium */ 1:
            return $iv6Yc._2($jVmMx.Encode.array, [
                "Medium"
            ], $jVmMx.Encode.string);
        case /* Large */ 2:
            return $iv6Yc._2($jVmMx.Encode.array, [
                "Large"
            ], $jVmMx.Encode.string);
    }
}
var $43833c51e9860c01$var$size_fromJson = $jVmMx.Decode.simpleVariant([
    [
        "Small",
        /* Small */ 0
    ],
    [
        "Medium",
        /* Medium */ 1
    ],
    [
        "Large",
        /* Large */ 2
    ]
]);
function $43833c51e9860c01$var$sliderStyles_toJson(param) {
    return $iv6Yc._1($jVmMx.Encode.object, [
        [
            "shape",
            $43833c51e9860c01$var$shape_toJson(param.shape)
        ],
        [
            "size",
            $43833c51e9860c01$var$size_toJson(param.size)
        ]
    ]);
}
var $43833c51e9860c01$var$sliderStyles_fromJson = $iv6Yc._3($jVmMx.Decode.map2, $iv6Yc._2($jVmMx.Decode.field, "shape", $43833c51e9860c01$var$shape_fromJson), $iv6Yc._2($jVmMx.Decode.field, "size", $43833c51e9860c01$var$size_fromJson), function(shape, size) {
    return {
        shape: shape,
        size: size
    };
});
function $43833c51e9860c01$var$inlineStyles_toJson(param) {
    return $iv6Yc._1($jVmMx.Encode.object, [
        [
            "span",
            $43833c51e9860c01$var$customShape_toJson(param.span)
        ],
        [
            "startRowOffset",
            $iv6Yc._1($jVmMx.Encode.$$int, param.startRowOffset)
        ]
    ]);
}
var $43833c51e9860c01$var$inlineStyles_fromJson = $iv6Yc._3($jVmMx.Decode.map2, $iv6Yc._2($jVmMx.Decode.field, "span", $43833c51e9860c01$var$customShape_fromJson), $iv6Yc._2($jVmMx.Decode.field, "startRowOffset", $jVmMx.Decode.$$int), function(span, startRowOffset) {
    return {
        span: span,
        startRowOffset: startRowOffset
    };
});
function $43833c51e9860c01$var$toJson(v) {
    if (v.TAG === /* SliderLayout */ 0) return $jVmMx.Encode.deccoVariantWithPayload(v._0, "SliderLayout", $43833c51e9860c01$var$sliderStyles_toJson);
    else return $jVmMx.Encode.deccoVariantWithPayload(v._0, "InlineLayout", $43833c51e9860c01$var$inlineStyles_toJson);
}
var $43833c51e9860c01$var$fromJson = $iv6Yc._2($jVmMx.Decode.oneOf, $jVmMx.Decode.deccoVariantWithPayload("SliderLayout", $43833c51e9860c01$var$sliderStyles_fromJson, function(styles) {
    return {
        TAG: /* SliderLayout */ 0,
        _0: styles
    };
}), [
    $jVmMx.Decode.deccoVariantWithPayload("InlineLayout", $43833c51e9860c01$var$inlineStyles_fromJson, function(styles) {
        return {
            TAG: /* InlineLayout */ 1,
            _0: styles
        };
    })
]);
var $43833c51e9860c01$var$include = $doJJK.Make({
    toJson: $43833c51e9860c01$var$toJson,
    fromJson: $43833c51e9860c01$var$fromJson
});
var $43833c51e9860c01$var$RelatedMedia_t_encode = $43833c51e9860c01$var$include.t_encode;
var $43833c51e9860c01$var$RelatedMedia_t_decode = $43833c51e9860c01$var$include.t_decode;
var $43833c51e9860c01$var$RelatedMedia_codec = $43833c51e9860c01$var$include.codec;
var $43833c51e9860c01$export$b603cdf0301ce8bf = {
    customShape_toJson: $43833c51e9860c01$var$customShape_toJson,
    customShape_fromJson: $43833c51e9860c01$var$customShape_fromJson,
    shape_toJson: $43833c51e9860c01$var$shape_toJson,
    shape_fromJson: $43833c51e9860c01$var$shape_fromJson,
    size_toJson: $43833c51e9860c01$var$size_toJson,
    size_fromJson: $43833c51e9860c01$var$size_fromJson,
    sliderStyles_toJson: $43833c51e9860c01$var$sliderStyles_toJson,
    sliderStyles_fromJson: $43833c51e9860c01$var$sliderStyles_fromJson,
    inlineStyles_toJson: $43833c51e9860c01$var$inlineStyles_toJson,
    inlineStyles_fromJson: $43833c51e9860c01$var$inlineStyles_fromJson,
    toJson: $43833c51e9860c01$var$toJson,
    fromJson: $43833c51e9860c01$var$fromJson,
    t_encode: $43833c51e9860c01$var$RelatedMedia_t_encode,
    t_decode: $43833c51e9860c01$var$RelatedMedia_t_decode,
    codec: $43833c51e9860c01$var$RelatedMedia_codec
};
 /* customShape_fromJson Not a pure module */ 
});

parcelRegister("doWsD", function(module, exports) {

$parcel$export(module.exports, "NavMenu", function () { return $9c1add5e29ec5c23$export$a6edb1992047cc25; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $jVmMx = parcelRequire("jVmMx");
var $9c1add5e29ec5c23$var$partial_arg = [
    [
        "InsertModeReplace",
        /* InsertModeReplace */ 0
    ],
    [
        "InsertModeAppend",
        /* InsertModeAppend */ 1
    ]
];
function $9c1add5e29ec5c23$var$insertMode_toJson(param) {
    return $jVmMx.Encode.simpleVariant($9c1add5e29ec5c23$var$partial_arg, param);
}
var $9c1add5e29ec5c23$var$insertMode_fromJson = $jVmMx.Decode.simpleVariant([
    [
        "InsertModeReplace",
        /* InsertModeReplace */ 0
    ],
    [
        "InsertModeAppend",
        /* InsertModeAppend */ 1
    ]
]);
function $9c1add5e29ec5c23$var$toJson(param) {
    return $iv6Yc._1($jVmMx.Encode.object, [
        [
            "topbarTarget",
            $jVmMx.Encode.nullable(param.topbarTarget, $jVmMx.Encode.string)
        ],
        [
            "topbarTargetStyle",
            $jVmMx.Encode.nullable(param.topbarTargetStyle, $jVmMx.Encode.string)
        ],
        [
            "topbarZIndex",
            $jVmMx.Encode.nullable(param.topbarZIndex, $jVmMx.Encode.$$int)
        ],
        [
            "topbarContainerTarget",
            $jVmMx.Encode.nullable(param.topbarContainerTarget, $jVmMx.Encode.string)
        ],
        [
            "topbarThreeColumnLayout",
            $jVmMx.Encode.nullable(param.topbarThreeColumnLayout, $jVmMx.Encode.bool)
        ],
        [
            "topbarHomeEnabled",
            $iv6Yc._1($jVmMx.Encode.bool, param.topbarHomeEnabled)
        ],
        [
            "topbarInsertMode",
            $iv6Yc._1($9c1add5e29ec5c23$var$insertMode_toJson, param.topbarInsertMode)
        ],
        [
            "topbarEnabled",
            $iv6Yc._1($jVmMx.Encode.bool, param.topbarEnabled)
        ],
        [
            "hamburgerTarget",
            $jVmMx.Encode.nullable(param.hamburgerTarget, $jVmMx.Encode.string)
        ],
        [
            "hamburgerTargetStyle",
            $jVmMx.Encode.nullable(param.hamburgerTargetStyle, $jVmMx.Encode.string)
        ],
        [
            "hamburgerZIndex",
            $jVmMx.Encode.nullable(param.hamburgerZIndex, $jVmMx.Encode.$$int)
        ],
        [
            "hamburgerContainerTarget",
            $jVmMx.Encode.nullable(param.hamburgerContainerTarget, $jVmMx.Encode.string)
        ],
        [
            "hamburgerTriggerButtonTarget",
            $jVmMx.Encode.nullable(param.hamburgerTriggerButtonTarget, $jVmMx.Encode.string)
        ],
        [
            "hamburgerHomeEnabled",
            $iv6Yc._1($jVmMx.Encode.bool, param.hamburgerHomeEnabled)
        ],
        [
            "injectCSS",
            $jVmMx.Encode.nullable(param.injectCSS, $jVmMx.Encode.string)
        ],
        [
            "injectJS",
            $jVmMx.Encode.nullable(param.injectJS, $jVmMx.Encode.string)
        ],
        [
            "breakpointMaxWidth",
            $jVmMx.Encode.nullable(param.breakpointMaxWidth, $jVmMx.Encode.$$int)
        ]
    ]);
}
var $9c1add5e29ec5c23$var$fromJson = $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._1($jVmMx.Decode.succeed, function(topbarTarget, topbarTargetStyle, topbarZIndex, topbarContainerTarget, topbarThreeColumnLayout, topbarHomeEnabled, topbarInsertMode, topbarEnabled, hamburgerTarget, hamburgerTargetStyle, hamburgerZIndex, hamburgerContainerTarget, hamburgerTriggerButtonTarget, hamburgerHomeEnabled, injectCSS, injectJS, breakpointMaxWidth) {
    return {
        topbarTarget: topbarTarget,
        topbarTargetStyle: topbarTargetStyle,
        topbarZIndex: topbarZIndex,
        topbarContainerTarget: topbarContainerTarget,
        topbarThreeColumnLayout: topbarThreeColumnLayout,
        topbarInsertMode: topbarInsertMode,
        topbarEnabled: topbarEnabled,
        topbarHomeEnabled: topbarHomeEnabled,
        hamburgerTarget: hamburgerTarget,
        hamburgerTargetStyle: hamburgerTargetStyle,
        hamburgerContainerTarget: hamburgerContainerTarget,
        hamburgerTriggerButtonTarget: hamburgerTriggerButtonTarget,
        hamburgerZIndex: hamburgerZIndex,
        hamburgerHomeEnabled: hamburgerHomeEnabled,
        injectCSS: injectCSS,
        injectJS: injectJS,
        breakpointMaxWidth: breakpointMaxWidth
    };
}), $iv6Yc._2($jVmMx.Decode.field, "topbarTarget", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string))), $iv6Yc._2($jVmMx.Decode.field, "topbarTargetStyle", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string))), $iv6Yc._2($jVmMx.Decode.field, "topbarZIndex", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.$$int))), $jVmMx.Decode.fieldWithDefault("topbarContainerTarget", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string), undefined)), $jVmMx.Decode.fieldWithDefault("topbarThreeColumnLayout", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.bool), undefined)), $jVmMx.Decode.fieldWithDefault("topbarHomeEnabled", $jVmMx.Decode.bool, false)), $jVmMx.Decode.fieldWithDefault("topbarInsertMode", $9c1add5e29ec5c23$var$insertMode_fromJson, /* InsertModeReplace */ 0)), $jVmMx.Decode.fieldWithDefault("topbarEnabled", $jVmMx.Decode.bool, true)), $iv6Yc._2($jVmMx.Decode.field, "hamburgerTarget", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string))), $iv6Yc._2($jVmMx.Decode.field, "hamburgerTargetStyle", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string))), $iv6Yc._2($jVmMx.Decode.field, "hamburgerZIndex", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.$$int))), $jVmMx.Decode.fieldWithDefault("hamburgerContainerTarget", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string), undefined)), $jVmMx.Decode.fieldWithDefault("hamburgerTriggerButtonTarget", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string), undefined)), $jVmMx.Decode.fieldWithDefault("hamburgerHomeEnabled", $jVmMx.Decode.bool, false)), $iv6Yc._2($jVmMx.Decode.field, "injectCSS", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string))), $iv6Yc._2($jVmMx.Decode.field, "injectJS", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string))), $iv6Yc._2($jVmMx.Decode.field, "breakpointMaxWidth", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.$$int)));
var $9c1add5e29ec5c23$export$a6edb1992047cc25 = {
    insertMode_toJson: $9c1add5e29ec5c23$var$insertMode_toJson,
    insertMode_fromJson: $9c1add5e29ec5c23$var$insertMode_fromJson,
    toJson: $9c1add5e29ec5c23$var$toJson,
    fromJson: $9c1add5e29ec5c23$var$fromJson
};
 /* insertMode_fromJson Not a pure module */ 
});

parcelRegister("dKt0X", function(module, exports) {

$parcel$export(module.exports, "EmailFrequency", function () { return $a02613e7e5630e09$export$ebc71933b3b0487e; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $jVmMx = parcelRequire("jVmMx");
var $a02613e7e5630e09$var$fromJson = $iv6Yc._5($jVmMx.Decode.map4, $jVmMx.Decode.fieldWithDefault("weekly", $jVmMx.Decode.bool, true), $jVmMx.Decode.fieldWithDefault("monthly", $jVmMx.Decode.bool, true), $jVmMx.Decode.fieldWithDefault("yearly", $jVmMx.Decode.bool, true), $jVmMx.Decode.fieldWithDefault("daily", $jVmMx.Decode.bool, false), function(weekly, monthly, yearly, daily) {
    return {
        weekly: weekly,
        monthly: monthly,
        yearly: yearly,
        daily: daily
    };
});
function $a02613e7e5630e09$var$toJson(param) {
    return $iv6Yc._1($jVmMx.Encode.object, [
        [
            "weekly",
            $iv6Yc._1($jVmMx.Encode.bool, param.weekly)
        ],
        [
            "monthly",
            $iv6Yc._1($jVmMx.Encode.bool, param.monthly)
        ],
        [
            "yearly",
            $iv6Yc._1($jVmMx.Encode.bool, param.yearly)
        ],
        [
            "daily",
            $iv6Yc._1($jVmMx.Encode.bool, param.daily)
        ]
    ]);
}
var $a02613e7e5630e09$export$ebc71933b3b0487e = {
    fromJson: $a02613e7e5630e09$var$fromJson,
    toJson: $a02613e7e5630e09$var$toJson
};
 /* fromJson Not a pure module */ 
});

parcelRegister("2KZ1D", function(module, exports) {

$parcel$export(module.exports, "PDPStackOffset", function () { return $201f3707a1a17599$export$3b8b4593d16b0fbe; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $79vie = parcelRequire("79vie");

var $AAkl8 = parcelRequire("AAkl8");

var $doJJK = parcelRequire("doJJK");
function $201f3707a1a17599$var$toJson(param) {
    return $AAkl8.object([
        [
            "left",
            $AAkl8.$$int(param.left)
        ],
        [
            "right",
            $AAkl8.$$int(param.right)
        ],
        [
            "bottom",
            $AAkl8.$$int(param.bottom)
        ]
    ]);
}
var $201f3707a1a17599$var$fromJson = $79vie.map3($79vie.field("left", $79vie.$$int), $79vie.field("right", $79vie.$$int), $79vie.field("bottom", $79vie.$$int), function(left, right, bottom) {
    return {
        left: left,
        right: right,
        bottom: bottom
    };
});
var $201f3707a1a17599$var$include = $doJJK.Make({
    toJson: $201f3707a1a17599$var$toJson,
    fromJson: $201f3707a1a17599$var$fromJson
});
var $201f3707a1a17599$var$t_encode = $201f3707a1a17599$var$include.t_encode;
var $201f3707a1a17599$var$t_decode = $201f3707a1a17599$var$include.t_decode;
var $201f3707a1a17599$var$PDPStackOffset_codec = $201f3707a1a17599$var$include.codec;
var $201f3707a1a17599$export$3b8b4593d16b0fbe = {
    toJson: $201f3707a1a17599$var$toJson,
    fromJson: $201f3707a1a17599$var$fromJson,
    t_encode: $201f3707a1a17599$var$t_encode,
    t_decode: $201f3707a1a17599$var$t_decode,
    codec: $201f3707a1a17599$var$PDPStackOffset_codec
};
var $201f3707a1a17599$export$3858a88f1f95fb98 = $201f3707a1a17599$var$t_encode;
var $201f3707a1a17599$export$d595943614c3dff4 = $201f3707a1a17599$var$t_decode;
 /* fromJson Not a pure module */ 
});

parcelRegister("519Gg", function(module, exports) {

$parcel$export(module.exports, "fromJson", function () { return $3a748e24381dd5b9$export$7ae2d2a8b28a8cb8; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $79vie = parcelRequire("79vie");

var $jVmMx = parcelRequire("jVmMx");

var $hQWQG = parcelRequire("hQWQG");

var $5Ax4c = parcelRequire("5Ax4c");
var $3a748e24381dd5b9$var$productData_fromJson = $jVmMx.Decode.simpleVariant([
    [
        "ProductTitle",
        /* ProductTitle */ 0
    ],
    [
        "ProductDescription",
        /* ProductDescription */ 1
    ],
    [
        "ProductPrice",
        /* ProductPrice */ 2
    ],
    [
        "ProductSalePrice",
        /* ProductSalePrice */ 3
    ],
    [
        "ProductSKU",
        /* ProductSKU */ 4
    ],
    [
        "ProductId",
        /* ProductId */ 5
    ],
    [
        "VariantId",
        /* VariantId */ 6
    ]
]);
var $3a748e24381dd5b9$var$availability_fromJson = $79vie.map2($79vie.field("inStockText", $79vie.string), $79vie.field("outOfStockText", $79vie.string), function(inStockText, outOfStockText) {
    return {
        inStockText: inStockText,
        outOfStockText: outOfStockText
    };
});
var $3a748e24381dd5b9$var$source_fromJson = $iv6Yc._2($jVmMx.Decode.oneOf, $jVmMx.Decode.deccoVariantWithPayload("ProductData", $3a748e24381dd5b9$var$productData_fromJson, function(value) {
    return {
        TAG: /* ProductData */ 0,
        _0: value
    };
}), [
    $jVmMx.Decode.deccoVariantWithPayload("MetaData", $79vie.string, function(value) {
        return {
            TAG: /* MetaData */ 1,
            _0: value
        };
    }),
    $jVmMx.Decode.deccoVariantWithPayload("CustomLabel", $79vie.$$int, function(value) {
        return {
            TAG: /* CustomLabel */ 2,
            _0: value
        };
    }),
    $jVmMx.Decode.deccoVariantWithPayload("Availability", $3a748e24381dd5b9$var$availability_fromJson, function(value) {
        return {
            TAG: /* Availability */ 3,
            _0: value
        };
    })
]);
var $3a748e24381dd5b9$var$fromJson = $iv6Yc._5($jVmMx.Decode.map4, $iv6Yc._2($jVmMx.Decode.field, "id", $hQWQG.ContentId.fromJson), $iv6Yc._2($jVmMx.Decode.field, "source", $3a748e24381dd5b9$var$source_fromJson), $iv6Yc._2($jVmMx.Decode.field, "isRichText", $jVmMx.Decode.bool), $jVmMx.Decode.fieldWithDefault("isPreWrapped", $jVmMx.Decode.bool, false), function(id, source, isRichText, isPreWrapped) {
    return {
        id: id,
        source: source,
        isRichText: isRichText,
        isPreWrapped: isPreWrapped
    };
});
var $3a748e24381dd5b9$var$DynamicSource = {
    productData_fromJson: $3a748e24381dd5b9$var$productData_fromJson,
    metaData_fromJson: $79vie.string,
    customLabel_fromJson: $79vie.$$int,
    availability_fromJson: $3a748e24381dd5b9$var$availability_fromJson,
    source_fromJson: $3a748e24381dd5b9$var$source_fromJson,
    fromJson: $3a748e24381dd5b9$var$fromJson
};
var $3a748e24381dd5b9$var$source_fromJson$1 = $iv6Yc._2($jVmMx.Decode.oneOf, $jVmMx.Decode.deccoVariantWithPayload("URL", $jVmMx.Decode.string, function(url) {
    return {
        TAG: /* URL */ 0,
        _0: url
    };
}), [
    $jVmMx.Decode.deccoVariantWithPayload("MetaData", $jVmMx.Decode.string, function(m) {
        return {
            TAG: /* MetaData */ 1,
            _0: m
        };
    }),
    $jVmMx.Decode.deccoVariantWithPayload("CustomLabel", $jVmMx.Decode.$$int, function(c) {
        return {
            TAG: /* CustomLabel */ 2,
            _0: c
        };
    })
]);
var $3a748e24381dd5b9$var$altTextSource_fromJson = $iv6Yc._2($jVmMx.Decode.oneOf, $jVmMx.Decode.deccoVariantWithPayload("Text", $jVmMx.Decode.string, function(u) {
    return {
        TAG: /* Text */ 0,
        _0: u
    };
}), [
    $jVmMx.Decode.deccoVariantWithPayload("MetaData", $jVmMx.Decode.string, function(m) {
        return {
            TAG: /* MetaData */ 1,
            _0: m
        };
    }),
    $jVmMx.Decode.deccoVariantWithPayload("CustomLabel", $jVmMx.Decode.$$int, function(c) {
        return {
            TAG: /* CustomLabel */ 2,
            _0: c
        };
    })
]);
var $3a748e24381dd5b9$var$fromJson$1 = $79vie.map3($79vie.field("id", $hQWQG.ContentId.fromJson), $79vie.field("source", $3a748e24381dd5b9$var$source_fromJson$1), $79vie.field("altText", $79vie.option($3a748e24381dd5b9$var$altTextSource_fromJson)), function(id, source, altText) {
    return {
        id: id,
        source: source,
        altText: altText
    };
});
var $3a748e24381dd5b9$var$$$Image = {
    source_fromJson: $3a748e24381dd5b9$var$source_fromJson$1,
    altTextSource_fromJson: $3a748e24381dd5b9$var$altTextSource_fromJson,
    fromJson: $3a748e24381dd5b9$var$fromJson$1
};
var $3a748e24381dd5b9$var$fromJson$2 = $iv6Yc._5($jVmMx.Decode.map4, $iv6Yc._2($jVmMx.Decode.field, "id", $hQWQG.ContentId.fromJson), $iv6Yc._2($jVmMx.Decode.field, "text", $jVmMx.Decode.string), $iv6Yc._2($jVmMx.Decode.field, "isRichText", $jVmMx.Decode.bool), $jVmMx.Decode.fieldWithDefault("isPreWrapped", $jVmMx.Decode.bool, false), function(id, text, isRichText, isPreWrapped) {
    return {
        id: id,
        text: text,
        isRichText: isRichText,
        isPreWrapped: isPreWrapped
    };
});
var $3a748e24381dd5b9$var$$$Text = {
    fromJson: $3a748e24381dd5b9$var$fromJson$2
};
var $3a748e24381dd5b9$var$fromJson$3 = $79vie.map($79vie.field("id", $hQWQG.ContentId.fromJson), function(id) {
    return {
        id: id
    };
});
var $3a748e24381dd5b9$var$Enhance = {
    fromJson: $3a748e24381dd5b9$var$fromJson$3
};
var $3a748e24381dd5b9$var$cellContent_fromJson = $iv6Yc._2($jVmMx.Decode.oneOf, $jVmMx.Decode.deccoVariantWithPayload("DynamicSource", $3a748e24381dd5b9$var$fromJson, function(u) {
    return {
        TAG: /* DynamicSource */ 0,
        _0: u
    };
}), [
    $jVmMx.Decode.deccoVariantWithPayload("Text", $3a748e24381dd5b9$var$fromJson$2, function(m) {
        return {
            TAG: /* Text */ 1,
            _0: m
        };
    })
]);
var $3a748e24381dd5b9$var$style_fromJson = $jVmMx.Decode.simpleVariant([
    [
        "BasicTable",
        /* BasicTable */ 0
    ],
    [
        "HorizontallyScrollableTable",
        /* HorizontallyScrollableTable */ 1
    ],
    [
        "NoBordersTable",
        /* NoBordersTable */ 2
    ]
]);
var $3a748e24381dd5b9$var$fromJson$4 = $iv6Yc._4($jVmMx.Decode.map3, $iv6Yc._2($jVmMx.Decode.field, "id", $hQWQG.ContentId.fromJson), $iv6Yc._2($jVmMx.Decode.field, "cells", $iv6Yc._1($jVmMx.Decode.array, $iv6Yc._1($jVmMx.Decode.array, $3a748e24381dd5b9$var$cellContent_fromJson))), $jVmMx.Decode.fieldWithDefault("style", $3a748e24381dd5b9$var$style_fromJson, /* BasicTable */ 0), function(id, cells, style) {
    return {
        id: id,
        cells: cells,
        style: style
    };
});
var $3a748e24381dd5b9$var$Table = {
    cellContent_fromJson: $3a748e24381dd5b9$var$cellContent_fromJson,
    style_fromJson: $3a748e24381dd5b9$var$style_fromJson,
    fromJson: $3a748e24381dd5b9$var$fromJson$4
};
var $3a748e24381dd5b9$var$fromJson$5 = $iv6Yc._3($jVmMx.Decode.map2, $iv6Yc._2($jVmMx.Decode.field, "id", $hQWQG.ContentId.fromJson), $iv6Yc._2($jVmMx.Decode.field, "code", $jVmMx.Decode.string), function(id, code) {
    return {
        id: id,
        code: code
    };
});
var $3a748e24381dd5b9$var$Code = {
    fromJson: $3a748e24381dd5b9$var$fromJson$5
};
var $3a748e24381dd5b9$var$fromJson$6 = $iv6Yc._2($jVmMx.Decode.oneOf, $jVmMx.Decode.deccoVariantWithPayload("DynamicSource", $3a748e24381dd5b9$var$fromJson, function(u) {
    return {
        TAG: /* DynamicSource */ 0,
        _0: u
    };
}), [
    $jVmMx.Decode.deccoVariantWithPayload("Text", $3a748e24381dd5b9$var$fromJson$2, function(m) {
        return {
            TAG: /* Text */ 1,
            _0: m
        };
    }),
    $jVmMx.Decode.deccoVariantWithPayload("Image", $3a748e24381dd5b9$var$fromJson$1, function(c) {
        return {
            TAG: /* Image */ 2,
            _0: c
        };
    }),
    $jVmMx.Decode.deccoVariantWithPayload("Enhance", $3a748e24381dd5b9$var$fromJson$3, function(c) {
        return {
            TAG: /* Enhance */ 3,
            _0: c
        };
    }),
    $jVmMx.Decode.deccoVariantWithPayload("Table", $3a748e24381dd5b9$var$fromJson$4, function(c) {
        return {
            TAG: /* Table */ 4,
            _0: c
        };
    }),
    $jVmMx.Decode.deccoVariantWithPayload("JavaScript", $3a748e24381dd5b9$var$fromJson$5, function(c) {
        return {
            TAG: /* JavaScript */ 5,
            _0: c
        };
    })
]);
var $3a748e24381dd5b9$export$7c6e2c02157bb7d2 = {
    DynamicSource: $3a748e24381dd5b9$var$DynamicSource,
    $$Image: $3a748e24381dd5b9$var$$$Image,
    $$Text: $3a748e24381dd5b9$var$$$Text,
    Enhance: $3a748e24381dd5b9$var$Enhance,
    Table: $3a748e24381dd5b9$var$Table,
    Code: $3a748e24381dd5b9$var$Code,
    fromJson: $3a748e24381dd5b9$var$fromJson$6
};
var $3a748e24381dd5b9$var$t_v2_decode = $iv6Yc._2($jVmMx.Decode.oneOf, $jVmMx.Decode.simpleVariant([
    [
        "Visible",
        /* Visible */ 0
    ]
]), [
    $jVmMx.Decode.simpleVariant([
        [
            "Hidden",
            /* Hidden */ 1
        ]
    ]),
    $jVmMx.Decode.deccoVariantWithPayload("RuleBased", $5Ax4c.fromJson(undefined), function(rule) {
        return /* RuleBased */ {
            _0: rule
        };
    })
]);
var $3a748e24381dd5b9$var$t_v1_decode = $iv6Yc._2($jVmMx.Decode.andThen, $jVmMx.Decode.$$default($jVmMx.Decode.bool, true), function(visible) {
    return $iv6Yc._1($jVmMx.Decode.succeed, visible ? /* Visible */ 0 : /* Hidden */ 1);
});
var $3a748e24381dd5b9$var$t_decode = $79vie.oneOf($3a748e24381dd5b9$var$t_v2_decode, [
    $3a748e24381dd5b9$var$t_v1_decode
]);
var $3a748e24381dd5b9$export$3824c08153b44726 = {
    t_v2_decode: $3a748e24381dd5b9$var$t_v2_decode,
    t_v1_decode: $3a748e24381dd5b9$var$t_v1_decode,
    t_decode: $3a748e24381dd5b9$var$t_decode,
    fromJson: $3a748e24381dd5b9$var$t_decode
};
var $3a748e24381dd5b9$var$fromJson$7 = $iv6Yc._6($jVmMx.Decode.map5, $iv6Yc._2($jVmMx.Decode.field, "id", $hQWQG.SectionId.fromJson), $iv6Yc._2($jVmMx.Decode.field, "content", $3a748e24381dd5b9$var$fromJson$6), $iv6Yc._2($jVmMx.Decode.field, "title", $jVmMx.Decode.string), $iv6Yc._2($jVmMx.Decode.field, "iconUrl", $jVmMx.Decode.string), $iv6Yc._2($jVmMx.Decode.field, "visible", $3a748e24381dd5b9$var$t_decode), function(id, content, title, iconUrl, visible) {
    return {
        id: id,
        content: content,
        title: title,
        iconUrl: iconUrl,
        visible: visible
    };
});
var $3a748e24381dd5b9$export$77fc3e7c6375c538 = {
    fromJson: $3a748e24381dd5b9$var$fromJson$7
};
var $3a748e24381dd5b9$var$accordionState_fromJson = $jVmMx.Decode.simpleVariant([
    [
        "DefaultState",
        /* DefaultState */ 0
    ],
    [
        "AlwaysExpandedState",
        /* AlwaysExpandedState */ 1
    ]
]);
var $3a748e24381dd5b9$var$fromJson$8 = $iv6Yc._7($jVmMx.Decode.map6, $iv6Yc._2($jVmMx.Decode.field, "id", $hQWQG.SectionId.fromJson), $iv6Yc._2($jVmMx.Decode.field, "contents", $iv6Yc._1($jVmMx.Decode.array, $3a748e24381dd5b9$var$fromJson$6)), $jVmMx.Decode.fieldWithDefault("accordionState", $3a748e24381dd5b9$var$accordionState_fromJson, /* DefaultState */ 0), $iv6Yc._2($jVmMx.Decode.field, "title", $jVmMx.Decode.string), $iv6Yc._2($jVmMx.Decode.field, "iconUrl", $jVmMx.Decode.string), $iv6Yc._2($jVmMx.Decode.field, "visible", $3a748e24381dd5b9$var$t_decode), function(id, contents, accordionState, title, iconUrl, visible) {
    return {
        id: id,
        contents: contents,
        accordionState: accordionState,
        title: title,
        iconUrl: iconUrl,
        visible: visible
    };
});
var $3a748e24381dd5b9$export$a66c12e18fc190b1 = {
    accordionState_fromJson: $3a748e24381dd5b9$var$accordionState_fromJson,
    fromJson: $3a748e24381dd5b9$var$fromJson$8
};
var $3a748e24381dd5b9$var$fromJson$9 = $iv6Yc._5($jVmMx.Decode.map4, $iv6Yc._2($jVmMx.Decode.field, "id", $hQWQG.SectionId.fromJson), $iv6Yc._2($jVmMx.Decode.field, "contents", $iv6Yc._1($jVmMx.Decode.array, $3a748e24381dd5b9$var$fromJson$6)), $iv6Yc._2($jVmMx.Decode.field, "title", $jVmMx.Decode.string), $iv6Yc._2($jVmMx.Decode.field, "visible", $3a748e24381dd5b9$var$t_decode), function(id, contents, title, visible) {
    return {
        id: id,
        contents: contents,
        title: title,
        visible: visible
    };
});
var $3a748e24381dd5b9$export$9586e2f332c8a6f5 = {
    fromJson: $3a748e24381dd5b9$var$fromJson$9
};
var $3a748e24381dd5b9$var$fromJson$10 = $iv6Yc._7($jVmMx.Decode.map6, $iv6Yc._2($jVmMx.Decode.field, "id", $hQWQG.SectionId.fromJson), $iv6Yc._2($jVmMx.Decode.field, "content", $3a748e24381dd5b9$var$fromJson$6), $iv6Yc._2($jVmMx.Decode.field, "mobileContent", $iv6Yc._1($jVmMx.Decode.option, $3a748e24381dd5b9$var$fromJson$6)), $iv6Yc._2($jVmMx.Decode.field, "title", $jVmMx.Decode.string), $iv6Yc._2($jVmMx.Decode.field, "visible", $3a748e24381dd5b9$var$t_decode), $jVmMx.Decode.fieldWithDefault("showTitle", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.bool), undefined), function(id, content, mobileContent, title, visible, showTitle) {
    return {
        id: id,
        content: content,
        mobileContent: mobileContent,
        title: title,
        visible: visible,
        showTitle: showTitle
    };
});
var $3a748e24381dd5b9$export$c2963165bf8a9cc9 = {
    fromJson: $3a748e24381dd5b9$var$fromJson$10
};
var $3a748e24381dd5b9$var$fromJson$11 = $iv6Yc._7($jVmMx.Decode.map6, $iv6Yc._2($jVmMx.Decode.field, "id", $hQWQG.SectionId.fromJson), $iv6Yc._2($jVmMx.Decode.field, "content", $3a748e24381dd5b9$var$fromJson$6), $iv6Yc._2($jVmMx.Decode.field, "visible", $3a748e24381dd5b9$var$t_decode), $iv6Yc._2($jVmMx.Decode.field, "title", $jVmMx.Decode.string), $iv6Yc._2($jVmMx.Decode.field, "backgroundColor", $jVmMx.Decode.string), $iv6Yc._2($jVmMx.Decode.field, "textColor", $jVmMx.Decode.string), function(id, content, visible, title, backgroundColor, textColor) {
    return {
        id: id,
        content: content,
        title: title,
        visible: visible,
        backgroundColor: backgroundColor,
        textColor: textColor
    };
});
var $3a748e24381dd5b9$export$37acb3580601e69a = {
    fromJson: $3a748e24381dd5b9$var$fromJson$11
};
var $3a748e24381dd5b9$var$fromJson$12 = $iv6Yc._5($jVmMx.Decode.map4, $iv6Yc._2($jVmMx.Decode.field, "id", $hQWQG.SectionId.fromJson), $iv6Yc._2($jVmMx.Decode.field, "title", $jVmMx.Decode.string), $iv6Yc._2($jVmMx.Decode.field, "visible", $3a748e24381dd5b9$var$t_decode), $iv6Yc._2($jVmMx.Decode.field, "content", $3a748e24381dd5b9$var$fromJson$6), function(id, title, visible, content) {
    return {
        id: id,
        title: title,
        visible: visible,
        content: content
    };
});
var $3a748e24381dd5b9$export$4d3bb46e028afc86 = {
    fromJson: $3a748e24381dd5b9$var$fromJson$12
};
function $3a748e24381dd5b9$var$showAs_toJson(showAs) {
    if (showAs) return $jVmMx.Encode.simpleVariant([
        [
            "Suffix",
            /* Suffix */ 1
        ]
    ], /* Suffix */ 1);
    else return $jVmMx.Encode.simpleVariant([
        [
            "Prefix",
            /* Prefix */ 0
        ]
    ], /* Prefix */ 0);
}
var $3a748e24381dd5b9$var$showAs_fromJson = $jVmMx.Decode.simpleVariant([
    [
        "Prefix",
        /* Prefix */ 0
    ],
    [
        "Suffix",
        /* Suffix */ 1
    ]
]);
var $3a748e24381dd5b9$var$fromJson$13 = $iv6Yc._7($jVmMx.Decode.map6, $iv6Yc._2($jVmMx.Decode.field, "id", $hQWQG.SectionId.fromJson), $iv6Yc._2($jVmMx.Decode.field, "title", $jVmMx.Decode.string), $iv6Yc._2($jVmMx.Decode.field, "visible", $3a748e24381dd5b9$var$t_decode), $iv6Yc._2($jVmMx.Decode.field, "visibleInProductCard", $jVmMx.Decode.bool), $iv6Yc._2($jVmMx.Decode.field, "content", $3a748e24381dd5b9$var$fromJson$6), $iv6Yc._2($jVmMx.Decode.field, "showAs", $3a748e24381dd5b9$var$showAs_fromJson), function(id, title, visible, visibleInProductCard, content, showAs) {
    return {
        id: id,
        title: title,
        visible: visible,
        visibleInProductCard: visibleInProductCard,
        showAs: showAs,
        content: content
    };
});
var $3a748e24381dd5b9$export$4ba25fc295a936e5 = {
    showAs_toJson: $3a748e24381dd5b9$var$showAs_toJson,
    showAs_fromJson: $3a748e24381dd5b9$var$showAs_fromJson,
    fromJson: $3a748e24381dd5b9$var$fromJson$13
};
var $3a748e24381dd5b9$export$7ae2d2a8b28a8cb8 = $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._1($jVmMx.Decode.succeed, function(summarySections, detailedSections, promoSection, promoSections, enhanceSection, enhanceSections, badges, reviews, priceLabels) {
    return {
        summarySections: summarySections,
        detailedSections: detailedSections,
        promoSection: promoSection,
        promoSections: promoSections,
        enhanceSection: enhanceSection,
        enhanceSections: enhanceSections,
        badges: badges,
        reviews: reviews,
        priceLabels: priceLabels
    };
}), $iv6Yc._2($jVmMx.Decode.field, "summarySections", $iv6Yc._1($jVmMx.Decode.array, $3a748e24381dd5b9$var$fromJson$7))), $iv6Yc._2($jVmMx.Decode.field, "detailedSections", $iv6Yc._1($jVmMx.Decode.array, $3a748e24381dd5b9$var$fromJson$8))), $iv6Yc._2($jVmMx.Decode.field, "promoSection", $3a748e24381dd5b9$var$fromJson$9)), $iv6Yc._2($jVmMx.Decode.field, "promoSections", $iv6Yc._1($jVmMx.Decode.array, $3a748e24381dd5b9$var$fromJson$9))), $iv6Yc._2($jVmMx.Decode.field, "enhanceSection", $iv6Yc._1($jVmMx.Decode.option, $3a748e24381dd5b9$var$fromJson$10))), $iv6Yc._2($jVmMx.Decode.field, "enhanceSections", $iv6Yc._1($jVmMx.Decode.array, $3a748e24381dd5b9$var$fromJson$10))), $iv6Yc._2($jVmMx.Decode.field, "badges", $iv6Yc._1($jVmMx.Decode.array, $3a748e24381dd5b9$var$fromJson$11))), $iv6Yc._2($jVmMx.Decode.field, "reviews", $iv6Yc._1($jVmMx.Decode.array, $3a748e24381dd5b9$var$fromJson$12))), $iv6Yc._2($jVmMx.Decode.field, "priceLabels", $iv6Yc._1($jVmMx.Decode.array, $3a748e24381dd5b9$var$fromJson$13)));
 /* productData_fromJson Not a pure module */ 
});
parcelRegister("hQWQG", function(module, exports) {

$parcel$export(module.exports, "ContentId", function () { return $cff4f11bdb1bf2d0$export$bb6896aa5755c251; });
$parcel$export(module.exports, "SectionId", function () { return $cff4f11bdb1bf2d0$export$9bbe9bfd3294dd44; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $ki9MN = parcelRequire("ki9MN");
var $cff4f11bdb1bf2d0$export$bb6896aa5755c251 = $ki9MN.Make({});
var $cff4f11bdb1bf2d0$export$9bbe9bfd3294dd44 = $ki9MN.Make({});
 /* ContentId Not a pure module */ 
});


parcelRegister("3DzsH", function(module, exports) {

$parcel$export(module.exports, "PDPStackPosition", function () { return $2a6085a10ae0f556$export$415b50f68bbf06b9; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $jVmMx = parcelRequire("jVmMx");

var $doJJK = parcelRequire("doJJK");
var $2a6085a10ae0f556$var$partial_arg = [
    [
        "left",
        "left"
    ],
    [
        "right",
        "right"
    ]
];
function $2a6085a10ae0f556$var$toJson(param) {
    return $jVmMx.Encode.simpleVariant($2a6085a10ae0f556$var$partial_arg, param);
}
var $2a6085a10ae0f556$var$fromJson = $jVmMx.Decode.simpleVariant([
    [
        "left",
        "left"
    ],
    [
        "right",
        "right"
    ]
]);
var $2a6085a10ae0f556$var$include = $doJJK.Make({
    toJson: $2a6085a10ae0f556$var$toJson,
    fromJson: $2a6085a10ae0f556$var$fromJson
});
var $2a6085a10ae0f556$var$t_encode = $2a6085a10ae0f556$var$include.t_encode;
var $2a6085a10ae0f556$var$t_decode = $2a6085a10ae0f556$var$include.t_decode;
var $2a6085a10ae0f556$var$PDPStackPosition_codec = $2a6085a10ae0f556$var$include.codec;
var $2a6085a10ae0f556$export$415b50f68bbf06b9 = {
    toJson: $2a6085a10ae0f556$var$toJson,
    fromJson: $2a6085a10ae0f556$var$fromJson,
    t_encode: $2a6085a10ae0f556$var$t_encode,
    t_decode: $2a6085a10ae0f556$var$t_decode,
    codec: $2a6085a10ae0f556$var$PDPStackPosition_codec
};
var $2a6085a10ae0f556$export$ba0687c1b64f2741 = $2a6085a10ae0f556$var$t_encode;
var $2a6085a10ae0f556$export$4f5b40d481e36a38 = $2a6085a10ae0f556$var$t_decode;
 /* fromJson Not a pure module */ 
});

parcelRegister("9BF9g", function(module, exports) {

$parcel$export(module.exports, "ProductCardStyle", function () { return $6fe77cf38fcab3ee$export$43cb186979960ddc; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $jVmMx = parcelRequire("jVmMx");

var $doJJK = parcelRequire("doJJK");
function $6fe77cf38fcab3ee$var$containerStyle_toJson(param) {
    return $iv6Yc._1($jVmMx.Encode.object, [
        [
            "borderColor",
            $iv6Yc._1($jVmMx.Encode.string, param.borderColor)
        ],
        [
            "borderWidth",
            $iv6Yc._1($jVmMx.Encode.string, param.borderWidth)
        ],
        [
            "borderRadius",
            $iv6Yc._1($jVmMx.Encode.string, param.borderRadius)
        ],
        [
            "padding",
            $iv6Yc._1($jVmMx.Encode.string, param.padding)
        ],
        [
            "backgroundColor",
            $iv6Yc._1($jVmMx.Encode.string, param.backgroundColor)
        ],
        [
            "overflow",
            $iv6Yc._1($jVmMx.Encode.string, param.overflow)
        ],
        [
            "cssCode",
            $jVmMx.Encode.nullable(param.cssCode, $jVmMx.Encode.string)
        ]
    ]);
}
var $6fe77cf38fcab3ee$var$containerStyle_fromJson = $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._1($jVmMx.Decode.succeed, function(borderColor, borderWidth, borderRadius, padding, backgroundColor, overflow, cssCode) {
    return {
        borderColor: borderColor,
        borderWidth: borderWidth,
        borderRadius: borderRadius,
        padding: padding,
        backgroundColor: backgroundColor,
        overflow: overflow,
        cssCode: cssCode
    };
}), $iv6Yc._2($jVmMx.Decode.field, "borderColor", $jVmMx.Decode.string)), $iv6Yc._2($jVmMx.Decode.field, "borderWidth", $jVmMx.Decode.string)), $iv6Yc._2($jVmMx.Decode.field, "borderRadius", $jVmMx.Decode.string)), $iv6Yc._2($jVmMx.Decode.field, "padding", $jVmMx.Decode.string)), $iv6Yc._2($jVmMx.Decode.field, "backgroundColor", $jVmMx.Decode.string)), $iv6Yc._2($jVmMx.Decode.field, "overflow", $jVmMx.Decode.string)), $jVmMx.Decode.fieldWithDefault("cssCode", $iv6Yc._1($jVmMx.Decode.nullable, $jVmMx.Decode.string), undefined));
function $6fe77cf38fcab3ee$var$genericStyle_toJson(param) {
    return $iv6Yc._1($jVmMx.Encode.object, [
        [
            "cssCode",
            $jVmMx.Encode.nullable(param.cssCode, $jVmMx.Encode.string)
        ]
    ]);
}
var $6fe77cf38fcab3ee$var$genericStyle_fromJson = $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._1($jVmMx.Decode.succeed, function(cssCode) {
    return {
        cssCode: cssCode
    };
}), $jVmMx.Decode.fieldWithDefault("cssCode", $iv6Yc._1($jVmMx.Decode.nullable, $jVmMx.Decode.string), undefined));
function $6fe77cf38fcab3ee$var$toJson(param) {
    return $iv6Yc._1($jVmMx.Encode.object, [
        [
            "container",
            $6fe77cf38fcab3ee$var$containerStyle_toJson(param.container)
        ],
        [
            "badge",
            $6fe77cf38fcab3ee$var$genericStyle_toJson(param.badge)
        ]
    ]);
}
var $6fe77cf38fcab3ee$var$fromJson = $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._1($jVmMx.Decode.succeed, function(container, badge) {
    return {
        container: container,
        badge: badge
    };
}), $iv6Yc._2($jVmMx.Decode.field, "container", $6fe77cf38fcab3ee$var$containerStyle_fromJson)), $jVmMx.Decode.fieldWithDefault("badge", $6fe77cf38fcab3ee$var$genericStyle_fromJson, {
    cssCode: undefined
}));
var $6fe77cf38fcab3ee$var$include = $doJJK.Make({
    toJson: $6fe77cf38fcab3ee$var$toJson,
    fromJson: $6fe77cf38fcab3ee$var$fromJson
});
var $6fe77cf38fcab3ee$var$ProductCardStyle_t_encode = $6fe77cf38fcab3ee$var$include.t_encode;
var $6fe77cf38fcab3ee$var$ProductCardStyle_t_decode = $6fe77cf38fcab3ee$var$include.t_decode;
var $6fe77cf38fcab3ee$var$ProductCardStyle_codec = $6fe77cf38fcab3ee$var$include.codec;
var $6fe77cf38fcab3ee$export$43cb186979960ddc = {
    containerStyle_toJson: $6fe77cf38fcab3ee$var$containerStyle_toJson,
    containerStyle_fromJson: $6fe77cf38fcab3ee$var$containerStyle_fromJson,
    genericStyle_toJson: $6fe77cf38fcab3ee$var$genericStyle_toJson,
    genericStyle_fromJson: $6fe77cf38fcab3ee$var$genericStyle_fromJson,
    toJson: $6fe77cf38fcab3ee$var$toJson,
    fromJson: $6fe77cf38fcab3ee$var$fromJson,
    t_encode: $6fe77cf38fcab3ee$var$ProductCardStyle_t_encode,
    t_decode: $6fe77cf38fcab3ee$var$ProductCardStyle_t_decode,
    codec: $6fe77cf38fcab3ee$var$ProductCardStyle_codec
};
 /* containerStyle_fromJson Not a pure module */ 
});

parcelRegister("f4o9q", function(module, exports) {

$parcel$export(module.exports, "ProductPriceStyle", function () { return $af89f6a10d4b21e1$export$d0b060296d2f03da; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $jVmMx = parcelRequire("jVmMx");

var $doJJK = parcelRequire("doJJK");
var $af89f6a10d4b21e1$var$partial_arg = [
    [
        "Default",
        /* Default */ 0
    ],
    [
        "VariantPricesRange",
        /* VariantPricesRange */ 1
    ]
];
function $af89f6a10d4b21e1$var$toJson(param) {
    return $jVmMx.Encode.simpleVariant($af89f6a10d4b21e1$var$partial_arg, param);
}
var $af89f6a10d4b21e1$var$fromJson = $jVmMx.Decode.simpleVariant([
    [
        "Default",
        /* Default */ 0
    ],
    [
        "VariantPricesRange",
        /* VariantPricesRange */ 1
    ]
]);
var $af89f6a10d4b21e1$var$include = $doJJK.Make({
    toJson: $af89f6a10d4b21e1$var$toJson,
    fromJson: $af89f6a10d4b21e1$var$fromJson
});
var $af89f6a10d4b21e1$var$t_encode = $af89f6a10d4b21e1$var$include.t_encode;
var $af89f6a10d4b21e1$var$t_decode = $af89f6a10d4b21e1$var$include.t_decode;
var $af89f6a10d4b21e1$var$ProductPriceStyle_codec = $af89f6a10d4b21e1$var$include.codec;
var $af89f6a10d4b21e1$export$d0b060296d2f03da = {
    toJson: $af89f6a10d4b21e1$var$toJson,
    fromJson: $af89f6a10d4b21e1$var$fromJson,
    t_encode: $af89f6a10d4b21e1$var$t_encode,
    t_decode: $af89f6a10d4b21e1$var$t_decode,
    codec: $af89f6a10d4b21e1$var$ProductPriceStyle_codec
};
var $af89f6a10d4b21e1$export$23c44dec1d1b5f74 = $af89f6a10d4b21e1$var$t_encode;
var $af89f6a10d4b21e1$export$9374040f1a164e16 = $af89f6a10d4b21e1$var$t_decode;
 /* fromJson Not a pure module */ 
});

parcelRegister("2d3Mr", function(module, exports) {

$parcel$export(module.exports, "ConnectedGAPropertyCodecs", function () { return $19bfba5bbfaeb90e$export$6d673ceccd4eb2bc; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $jVmMx = parcelRequire("jVmMx");

var $doJJK = parcelRequire("doJJK");
function $19bfba5bbfaeb90e$var$toJson(param) {
    return $iv6Yc._1($jVmMx.Encode.object, [
        [
            "id",
            $iv6Yc._1($jVmMx.Encode.string, param.id)
        ],
        [
            "displayName",
            $iv6Yc._1($jVmMx.Encode.string, param.displayName)
        ],
        [
            "timeZone",
            $jVmMx.Encode.nullable(param.timeZone, $jVmMx.Encode.string)
        ],
        [
            "adminClerkId",
            $iv6Yc._1($jVmMx.Encode.string, param.adminClerkId)
        ]
    ]);
}
var $19bfba5bbfaeb90e$var$fromJson = $iv6Yc._5($jVmMx.Decode.map4, $iv6Yc._2($jVmMx.Decode.field, "id", $jVmMx.Decode.string), $iv6Yc._2($jVmMx.Decode.field, "displayName", $jVmMx.Decode.string), $iv6Yc._2($jVmMx.Decode.field, "timeZone", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string)), $iv6Yc._2($jVmMx.Decode.field, "adminClerkId", $jVmMx.Decode.string), function(id, displayName, timeZone, adminClerkId) {
    return {
        id: id,
        displayName: displayName,
        timeZone: timeZone,
        adminClerkId: adminClerkId
    };
});
var $19bfba5bbfaeb90e$var$include = $doJJK.Make({
    toJson: $19bfba5bbfaeb90e$var$toJson,
    fromJson: $19bfba5bbfaeb90e$var$fromJson
});
var $19bfba5bbfaeb90e$var$ConnectedGAPropertyCodecs_t_encode = $19bfba5bbfaeb90e$var$include.t_encode;
var $19bfba5bbfaeb90e$var$ConnectedGAPropertyCodecs_t_decode = $19bfba5bbfaeb90e$var$include.t_decode;
var $19bfba5bbfaeb90e$var$ConnectedGAPropertyCodecs_codec = $19bfba5bbfaeb90e$var$include.codec;
var $19bfba5bbfaeb90e$export$6d673ceccd4eb2bc = {
    toJson: $19bfba5bbfaeb90e$var$toJson,
    fromJson: $19bfba5bbfaeb90e$var$fromJson,
    t_encode: $19bfba5bbfaeb90e$var$ConnectedGAPropertyCodecs_t_encode,
    t_decode: $19bfba5bbfaeb90e$var$ConnectedGAPropertyCodecs_t_decode,
    codec: $19bfba5bbfaeb90e$var$ConnectedGAPropertyCodecs_codec
};
 /* fromJson Not a pure module */ 
});

parcelRegister("cAXsd", function(module, exports) {

$parcel$export(module.exports, "ConnectedTiktokAccount", function () { return $92b6f72a16144da9$export$8ef4f26b0eec859c; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $jVmMx = parcelRequire("jVmMx");

var $doJJK = parcelRequire("doJJK");
function $92b6f72a16144da9$var$toJson(param) {
    return $iv6Yc._1($jVmMx.Encode.object, [
        [
            "id",
            $iv6Yc._1($jVmMx.Encode.string, param.id)
        ],
        [
            "handle",
            $iv6Yc._1($jVmMx.Encode.string, param.handle)
        ],
        [
            "biography",
            $jVmMx.Encode.nullable(param.biography, $jVmMx.Encode.string)
        ],
        [
            "profilePictureUrl",
            $iv6Yc._1($jVmMx.Encode.string, param.profilePictureUrl)
        ],
        [
            "autoSync",
            $iv6Yc._1($jVmMx.Encode.bool, param.autoSync)
        ],
        [
            "adminClerkId",
            $iv6Yc._1($jVmMx.Encode.string, param.adminClerkId)
        ]
    ]);
}
var $92b6f72a16144da9$var$fromJson = $iv6Yc._7($jVmMx.Decode.map6, $iv6Yc._2($jVmMx.Decode.field, "id", $jVmMx.Decode.string), $iv6Yc._2($jVmMx.Decode.field, "handle", $jVmMx.Decode.string), $iv6Yc._2($jVmMx.Decode.field, "biography", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string)), $jVmMx.Decode.fieldWithDefault("profilePictureUrl", $jVmMx.Decode.string, ""), $jVmMx.Decode.fieldWithDefault("autoSync", $jVmMx.Decode.bool, true), $iv6Yc._2($jVmMx.Decode.field, "adminClerkId", $jVmMx.Decode.string), function(id, handle, biography, profilePictureUrl, autoSync, adminClerkId) {
    return {
        id: id,
        handle: handle,
        biography: biography,
        profilePictureUrl: profilePictureUrl,
        autoSync: autoSync,
        adminClerkId: adminClerkId
    };
});
var $92b6f72a16144da9$var$include = $doJJK.Make({
    toJson: $92b6f72a16144da9$var$toJson,
    fromJson: $92b6f72a16144da9$var$fromJson
});
var $92b6f72a16144da9$var$ConnectedTiktokAccount_t_encode = $92b6f72a16144da9$var$include.t_encode;
var $92b6f72a16144da9$var$ConnectedTiktokAccount_t_decode = $92b6f72a16144da9$var$include.t_decode;
var $92b6f72a16144da9$var$ConnectedTiktokAccount_codec = $92b6f72a16144da9$var$include.codec;
var $92b6f72a16144da9$export$8ef4f26b0eec859c = {
    toJson: $92b6f72a16144da9$var$toJson,
    fromJson: $92b6f72a16144da9$var$fromJson,
    t_encode: $92b6f72a16144da9$var$ConnectedTiktokAccount_t_encode,
    t_decode: $92b6f72a16144da9$var$ConnectedTiktokAccount_t_decode,
    codec: $92b6f72a16144da9$var$ConnectedTiktokAccount_codec
};
 /* fromJson Not a pure module */ 
});

parcelRegister("aHg7U", function(module, exports) {

$parcel$export(module.exports, "ConnectedInstagramAccount", function () { return $7c9a6df2611ee45f$export$dba60373f79bbb79; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $jVmMx = parcelRequire("jVmMx");

var $doJJK = parcelRequire("doJJK");
function $7c9a6df2611ee45f$var$toJson(param) {
    return $iv6Yc._1($jVmMx.Encode.object, [
        [
            "id",
            $iv6Yc._1($jVmMx.Encode.string, param.id)
        ],
        [
            "handle",
            $iv6Yc._1($jVmMx.Encode.string, param.handle)
        ],
        [
            "isPersonal",
            $iv6Yc._1($jVmMx.Encode.bool, param.isPersonal)
        ],
        [
            "biography",
            $jVmMx.Encode.nullable(param.biography, $jVmMx.Encode.string)
        ],
        [
            "profilePictureUrl",
            $iv6Yc._1($jVmMx.Encode.string, param.profilePictureUrl)
        ],
        [
            "autoSync",
            $iv6Yc._1($jVmMx.Encode.bool, param.autoSync)
        ],
        [
            "adminClerkId",
            $jVmMx.Encode.nullable(param.adminClerkId, $jVmMx.Encode.string)
        ]
    ]);
}
var $7c9a6df2611ee45f$var$fromJson = $iv6Yc._8($jVmMx.Decode.map7, $iv6Yc._2($jVmMx.Decode.field, "id", $jVmMx.Decode.string), $iv6Yc._2($jVmMx.Decode.field, "handle", $jVmMx.Decode.string), $jVmMx.Decode.fieldWithDefault("isPersonal", $jVmMx.Decode.bool, false), $iv6Yc._2($jVmMx.Decode.field, "biography", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string)), $jVmMx.Decode.fieldWithDefault("profilePictureUrl", $jVmMx.Decode.string, ""), $jVmMx.Decode.fieldWithDefault("autoSync", $jVmMx.Decode.bool, true), $jVmMx.Decode.fieldWithDefault("adminClerkId", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string), undefined), function(id, handle, isPersonal, biography, profilePictureUrl, autoSync, adminClerkId) {
    return {
        id: id,
        handle: handle,
        isPersonal: isPersonal,
        biography: biography,
        profilePictureUrl: profilePictureUrl,
        autoSync: autoSync,
        adminClerkId: adminClerkId
    };
});
var $7c9a6df2611ee45f$var$include = $doJJK.Make({
    toJson: $7c9a6df2611ee45f$var$toJson,
    fromJson: $7c9a6df2611ee45f$var$fromJson
});
var $7c9a6df2611ee45f$var$ConnectedInstagramAccount_t_encode = $7c9a6df2611ee45f$var$include.t_encode;
var $7c9a6df2611ee45f$var$ConnectedInstagramAccount_t_decode = $7c9a6df2611ee45f$var$include.t_decode;
var $7c9a6df2611ee45f$var$ConnectedInstagramAccount_codec = $7c9a6df2611ee45f$var$include.codec;
var $7c9a6df2611ee45f$export$dba60373f79bbb79 = {
    toJson: $7c9a6df2611ee45f$var$toJson,
    fromJson: $7c9a6df2611ee45f$var$fromJson,
    t_encode: $7c9a6df2611ee45f$var$ConnectedInstagramAccount_t_encode,
    t_decode: $7c9a6df2611ee45f$var$ConnectedInstagramAccount_t_decode,
    codec: $7c9a6df2611ee45f$var$ConnectedInstagramAccount_codec
};
 /* fromJson Not a pure module */ 
});


var $d616b4594b1ad2e5$exports = {};


(parcelRequire("7wgKE")).register((parcelRequire("kSeqf")).getBundleURL("f8wNk"), JSON.parse('["f8wNk","smartnav-tracker-v2.js","hOJSK","rollbar.noconflict.umd.59f66347.js","bYlNO","ConfigurationDecoder.bs.b1f81d12.js","hI3Yy","ConfigurationDecoder.bs.856444d3.js","aVOcH","ConfigurationDecoder.bs.efd81eca.js","1EEJk","index.esm.b82cf7e5.js","7sEFF","index.esm.bd52e383.js","jAZo8","index.esm.b6e87719.js"]'));

// Generated by ReScript, PLEASE EDIT WITH CARE

var $5YOUh = parcelRequire("5YOUh");

var $j4B9x = parcelRequire("j4B9x");

var $GuWH3 = parcelRequire("GuWH3");

var $eklj4 = parcelRequire("eklj4");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $kiuDo = parcelRequire("kiuDo");

var $hxhfd = parcelRequire("hxhfd");

var $2gwg0 = parcelRequire("2gwg0");

var $aYvyX = parcelRequire("aYvyX");

var $h7kEx = parcelRequire("h7kEx");

var $kK0OQ = parcelRequire("kK0OQ");

var $8Eq46 = parcelRequire("8Eq46");

var $5p4vV = parcelRequire("5p4vV");

var $bjgUL = parcelRequire("bjgUL");

var $79G3i = parcelRequire("79G3i");
function $fde1a359643f4f76$export$c0440a6856e748cf(order, shop, param) {
    var affiliation = shop !== undefined ? shop : $2whNH.getWithDefault($2gwg0.getShop(undefined), "");
    var items = $i7mYY.map(order.line_items, function(item) {
        return {
            affiliation: affiliation,
            id: String(item.product_id),
            name: item.title,
            price: item.price,
            quantity: item.quantity,
            variant: item.sku
        };
    });
    var purchase_transaction_id = order.order_id;
    var purchase_currency = order.currency;
    var purchase_value = order.total_price;
    var purchase = {
        affiliation: affiliation,
        transaction_id: purchase_transaction_id,
        currency: purchase_currency,
        value: purchase_value,
        items: items
    };
    $5p4vV.init(undefined).then(function(firebase) {
        $5p4vV.logEvent(firebase, "purchase", purchase);
        $5p4vV.logValueEvent(firebase, "smart_nav_purchase", purchase, $kiuDo.float_of_string(order.total_price));
        $i7mYY.forEach(items, function(item) {
            $5p4vV.logValueEvent(firebase, "smart_nav_purchase_product", item, $kiuDo.float_of_string(item.price) * item.quantity);
        });
    });
}
function $fde1a359643f4f76$export$7f5abdb7f5093137(param) {
    $eklj4.$$catch($kK0OQ.load($hxhfd.apiHostnameProduction).then(function(config) {
        var accountId = config.accountId;
        if (accountId !== undefined) return $h7kEx.$$fetch(undefined, undefined, undefined, undefined, undefined, function() {
            var _ref = (0, $5YOUh._)(function(json) {
                return (0, $j4B9x.__generator)(this, function(_state) {
                    return [
                        2,
                        $bjgUL.decode(json, $79G3i.Public.fromJson)
                    ];
                });
            });
            return function(json) {
                return _ref.apply(this, arguments);
            };
        }(), $hxhfd.apiHostnameProduction + "/api/get_public_account?account_id=" + accountId).then(function(account) {
            return [
                config,
                account
            ];
        });
        else return Promise.reject($GuWH3.raiseError("Config not found"));
    }).then(function(param) {
        var config = param[0];
        $8Eq46.init(config.settings.gaTrackingId, config.settings.gaVersion, config.settings.checkoutLink, undefined, param[1]);
    }), function(param) {
        return Promise.resolve(undefined);
    });
}
function $fde1a359643f4f76$export$2cd8252107eb640b(param) {
    try {
        $fde1a359643f4f76$export$7f5abdb7f5093137(undefined);
    } catch (exn) {}
    var order = $2whNH.flatMap(window.Shopify, function(shopify) {
        return shopify.checkout;
    });
    var wasPostPurchasePageSeen = $2whNH.getWithDefault($2whNH.flatMap(window.Shopify, function(shopify) {
        return shopify.wasPostPurchasePageSeen;
    }), false);
    var match = $aYvyX.isEnabled(undefined);
    if (match && order !== undefined && !wasPostPurchasePageSeen) return $fde1a359643f4f76$export$c0440a6856e748cf(order, undefined, undefined);
}
 /* Env-Showside Not a pure module */ 

// We store a copy of the fetch function in window.makerFetch
// This is to avoid the fetch function being overwritten by other scripts
// Very common for other trackers on the page to overwrite it.
window.makerFetch = window.makerFetch || window.fetch;
(0, $fde1a359643f4f76$export$2cd8252107eb640b)();

})();
//# sourceMappingURL=smartnav-tracker-v2.js.map
